/*
MICROSOFT SOFTWARE LICENSE TERMS
MICROSOFT AZURE MAPS WEB SDK

These license terms are an agreement between you and Microsoft Corporation (or one of its affiliates). They apply to the software named above and any Microsoft services or software updates (except to the extent such services or updates are accompanied by new or additional terms, in which case those different terms apply prospectively and do not alter your or Microsoft’s rights relating to pre-updated software or services). IF YOU COMPLY WITH THESE LICENSE TERMS, YOU HAVE THE RIGHTS BELOW.  BY USING THE SOFTWARE, YOU ACCEPT THESE TERMS.

1. INSTALLATION AND USE RIGHTS.
  a) General. You may install and use any number of copies of the software to develop and test your applications.
  b) User Region Parameters. The software will allow you to select from a View list to set the map view within your application for a given customer. By default the View parameter (also referred to as “user region parameter” is set to “Unified”.  Countries/Regions that are not on the View list will default to the “Unified” View. It is your responsibility to determine the location of your users, and then set the View parameter correctly for that location. The View parameter must be used in compliance with applicable laws, including those regarding mapping, of the country where maps, images and other data and third party content that You are authorized to access via the software is made available. 
  c) Third Party Software. The software may include third party applications that Microsoft, not the third party, licenses to you under this agreement. Any included notices for third party applications are for your information only.
  d) Microsoft Online Subscription Agreement. Some features of the software provide access to, or rely on, Microsoft Azure Services. The use of those services (but not the software) is governed by the separate terms and privacy policies associated with your Microsoft Azure subscription. The services may not be available in all regions. For more information see https://go.microsoft.com/fwLink/?LinkID=522330&amp;clcid=0x9.

2. DISTRIBUTABLE CODE. The software is comprised of “Distributable Code”. “Distributable Code” is code that you are permitted to distribute in applications you develop if you comply with the terms below and otherwise set forth in these license terms. 
  a) Distribution Rights. 
    i. You may copy and distribute the object code form of the software.
    i. Third Party Distribution. You may permit distributors of your applications to copy and distribute any of this distributable code you elect to distribute with your applications.
  b) Distribution Requirements. For any code you distribute, you must:
    i. add significant primary functionality to it in your applications;
    ii. require distributors and external end users to agree to terms that protect it and Microsoft at least as much as this agreement; and
    iii. indemnify, defend, and hold harmless Microsoft from any claims, including attorneys’ fees, related to the distribution or use of your applications, except to the extent that any claim is based solely on the unmodified distributable code.
  c) Distribution Restrictions. You may not:
    i. use Microsoft’s trademarks or trade dress in your application in any way that suggests your application comes from or is endorsed by Microsoft; or
    ii. modify or distribute the source code of any distributable code so that any part of it becomes subject to any license that requires that the distributable code, any other part of the software, or any of Microsoft’s other intellectual property be disclosed or distributed in source code form, or that others have the right to modify it.

3. DATA COLLECTION. The software may collect information about you and your use of the software and send that to Microsoft. Microsoft may use this information to provide services and improve Microsoft’s products and services. Your opt-out rights, if any, are described in the product documentation. Some features in the software may enable collection of data from users of your applications that access or use the software. If you use these features to enable data collection in your applications, you must comply with applicable law, including getting any required user consent, and maintain a prominent privacy policy that accurately informs users about how you use, collect, and share their data. You can learn more about Microsoft’s data collection and use in the product documentation and the Microsoft Privacy Statement at https://go.microsoft.com/fwlink/?LinkId=512132. You agree to comply with all applicable provisions of the Microsoft Privacy Statement.

4. SCOPE OF LICENSE. The software is licensed, not sold. Microsoft reserves all other rights. Unless applicable law gives you more rights despite this limitation, you will not (and have no right to):
  a) work around any technical limitations in the software that only allow you to use it in certain ways;
  b) reverse engineer, decompile, or disassemble the software, or attempt to do so, except and only to the extent permitted by licensing terms governing the use of open-source components that may be included with the software;
  c) remove, minimize, block, or modify any notices of Microsoft or its suppliers in the software;
  d) use the software in any way that is against the law or to create or propagate malware; or
  e) share, publish, distribute, or lend the software (except for any distributable code, subject to the terms above), provide the software as a stand-alone hosted solution for others to use, or transfer the software or this agreement to any third party.

5. EXPORT RESTRICTIONS. You must comply with all domestic and international export laws and regulations that apply to the software, which include restrictions on destinations, end users, and end use. For further information on export restrictions, visit http://aka.ms/exporting.

6. SUPPORT SERVICES. Microsoft is not obligated under this agreement to provide any support services for the software. Any support provided is “as is”, “with all faults”, and without warranty of any kind.

7. UPDATES. The software may periodically check for updates, and download and install them for you. You may obtain updates only from Microsoft or authorized sources. Microsoft may need to update your system to provide you with updates. You agree to receive these automatic updates without any additional notice. Updates may not include or support all existing software features, services, or peripheral devices.

8. ENTIRE AGREEMENT. This agreement, and any other terms Microsoft may provide for supplements, updates, or third-party applications, is the entire agreement for the software.

9. APPLICABLE LAW AND PLACE TO RESOLVE DISPUTES. If you acquired the software in the United States or Canada, the laws of the state or province where you live (or, if a business, where your principal place of business is located) govern the interpretation of this agreement, claims for its breach, and all other claims (including consumer protection, unfair competition, and tort claims), regardless of conflict of laws principles. If you acquired the software in any other country, its laws apply. If U.S. federal jurisdiction exists, you and Microsoft consent to exclusive jurisdiction and venue in the federal court in King County, Washington for all disputes heard in court. If not, you and Microsoft consent to exclusive jurisdiction and venue in the Superior Court of King County, Washington for all disputes heard in court.

10. CONSUMER RIGHTS; REGIONAL VARIATIONS. This agreement describes certain legal rights. You may have other rights, including consumer rights, under the laws of your state or country. Separate and apart from your relationship with Microsoft, you may also have rights with respect to the party from which you acquired the software. This agreement does not change those other rights if the laws of your state or country do not permit it to do so. For example, if you acquired the software in one of the below regions, or mandatory country law applies, then the following provisions apply to you:
  a) Australia. You have statutory guarantees under the Australian Consumer Law and nothing in this agreement is intended to affect those rights.
  b) Canada. If you acquired this software in Canada, you may stop receiving updates by turning off the automatic update feature, disconnecting your device from the Internet (if and when you re-connect to the Internet, however, the software will resume checking for and installing updates), or uninstalling the software. The product documentation, if any, may also specify how to turn off updates for your specific device or software.
  c) Germany and Austria.
    i. Warranty. The properly licensed software will perform substantially as described in any Microsoft materials that accompany the software. However, Microsoft gives no contractual guarantee in relation to the licensed software.
    ii. Limitation of Liability. In case of intentional conduct, gross negligence, claims based on the Product Liability Act, as well as, in case of death or personal or physical injury, Microsoft is liable according to the statutory law.
  Subject to the foregoing clause ii., Microsoft will only be liable for slight negligence if Microsoft is in breach of such material contractual obligations, the fulfillment of which facilitate the due performance of this agreement, the breach of which would endanger the purpose of this agreement and the compliance with which a party may constantly trust in (so-called "cardinal obligations"). In other cases of slight negligence, Microsoft will not be liable for slight negligence.

11. DISCLAIMER OF WARRANTY. THE SOFTWARE IS LICENSED “AS IS.” YOU BEAR THE RISK OF USING IT. MICROSOFT GIVES NO EXPRESS WARRANTIES, GUARANTEES, OR CONDITIONS. TO THE EXTENT PERMITTED UNDER APPLICABLE LAWS, MICROSOFT EXCLUDES ALL IMPLIED WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.

12. LIMITATION ON AND EXCLUSION OF DAMAGES. IF YOU HAVE ANY BASIS FOR RECOVERING DAMAGES DESPITE THE PRECEDING DISCLAIMER OF WARRANTY, YOU CAN RECOVER FROM MICROSOFT AND ITS SUPPLIERS ONLY DIRECT DAMAGES UP TO U.S. $5.00. YOU CANNOT RECOVER ANY OTHER DAMAGES, INCLUDING CONSEQUENTIAL, LOST PROFITS, SPECIAL, INDIRECT, OR INCIDENTAL DAMAGES.
This limitation applies to (a) anything related to the software, services, content (including code) on third party Internet sites, or third party applications; and (b) claims for breach of contract, warranty, guarantee, or condition; strict liability, negligence, or other tort; or any other claim; in each case to the extent permitted by applicable law.
It also applies even if Microsoft knew or should have known about the possibility of the damages. The above limitation or exclusion may not apply to you because your state, province, or country may not allow the exclusion or limitation of incidental, consequential, or other damages.

Please note: As this software is distributed in Canada, some of the clauses in this agreement are provided below in French.

Remarque: Ce logiciel étant distribué au Canada, certaines des clauses dans ce contrat sont fournies ci-dessous en français.

EXONÉRATION DE GARANTIE. Le logiciel visé par une licence est offert « tel quel ». Toute utilisation de ce logiciel est à votre seule risque et péril. Microsoft n’accorde aucune autre garantie expresse. Vous pouvez bénéficier de droits additionnels en vertu du droit local sur la protection des consommateurs, que ce contrat ne peut modifier. La ou elles sont permises par le droit locale, les garanties implicites de qualité marchande, d’adéquation à un usage particulier et d’absence de contrefaçon sont exclues.

LIMITATION DES DOMMAGES-INTÉRÊTS ET EXCLUSION DE RESPONSABILITÉ POUR LES DOMMAGES. Vous pouvez obtenir de Microsoft et de ses fournisseurs une indemnisation en cas de dommages directs uniquement à hauteur de 5,00 $ US. Vous ne pouvez prétendre à aucune indemnisation pour les autres dommages, y compris les dommages spéciaux, indirects ou accessoires et pertes de bénéfices.

Cette limitation concerne:
• tout ce qui est relié au logiciel, aux services ou au contenu (y compris le code) figurant sur des sites Internet tiers ou dans des programmes tiers; et
• les réclamations au titre de violation de contrat ou de garantie, ou au titre de responsabilité stricte, de négligence ou d’une autre faute dans la limite autorisée par la loi en vigueur.

Elle s’applique également, même si Microsoft connaissait ou devrait connaître l’éventualité d’un tel dommage. Si votre pays n’autorise pas l’exclusion ou la limitation de responsabilité pour les dommages indirects, accessoires ou de quelque nature que ce soit, il se peut que la limitation ou l’exclusion ci-dessus ne s’appliquera pas à votre égard.

EFFET JURIDIQUE. Le présent contrat décrit certains droits juridiques. Vous pourriez avoir d’autres droits prévus par les lois de votre pays. Le présent contrat ne modifie pas les droits que vous confèrent les lois de votre pays si celles-ci ne le permettent pas.
---
title: THIRD PARTY NOTICES FOR Azure Maps Spatial IO Module
preamble: |
	Do Not Translate or Localize

	This file is based on or incorporates material from the projects listed below (Third Party IP).
	The original copyright notice and the license under which Microsoft received such Third Party IP,
	are set forth below. Such licenses and notices are provided for informational purposes only.
	Microsoft licenses the Third Party IP to you under the licensing terms for the Microsoft product.
	Microsoft reserves all other rights not expressly granted under this agreement, whether by implication,
	estoppel or otherwise.


registrations:
	- component:
		name: @types/jszip
		version: 3.1.7
		license: |
    MIT License

    Copyright (c) Microsoft Corporation. All rights reserved.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE


	- component:
		name: @types/node
		version: 12.12.14
		license: |
    MIT License

    Copyright (c) Microsoft Corporation. All rights reserved.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE


	- component:
		name: @types/lodash
		version: 4.14.149
		license: |
    MIT License

    Copyright (c) Microsoft Corporation. All rights reserved.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE


	- component:
		name: @types/mapbox-gl
		version: 1.5.2
		license: |
    MIT License

    Copyright (c) Microsoft Corporation. All rights reserved.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE


	- component:
		name: @types/geojson
		version: 7946.0.7
		license: |
    MIT License

    Copyright (c) Microsoft Corporation. All rights reserved.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE


	- component:
		name: azure-maps-control
		version: 2.0.22
		license: |
MICROSOFT SOFTWARE LICENSE TERMS
MICROSOFT AZURE MAPS WEB SDK
These license terms are an agreement between you and Microsoft Corporation (or one of its affiliates). They apply to the software named above and any Microsoft services or software updates (except to the extent such services or updates are accompanied by new or additional terms, in which case those different terms apply prospectively and do not alter your or Microsoft’s rights relating to pre-updated software or services). IF YOU COMPLY WITH THESE LICENSE TERMS, YOU HAVE THE RIGHTS BELOW.  BY USING THE SOFTWARE, YOU ACCEPT THESE TERMS.
1. INSTALLATION AND USE RIGHTS.
  a) General. You may install and use any number of copies of the software to develop and test your applications.
  b) User Region Parameters. The software will allow you to select from a View list to set the map view within your application for a given customer. By default the View parameter (also referred to as “user region parameter” is set to “Unified”.  Countries/Regions that are not on the View list will default to the “Unified” View. It is your responsibility to determine the location of your users, and then set the View parameter correctly for that location. The View parameter must be used in compliance with applicable laws, including those regarding mapping, of the country where maps, images and other data and third party content that You are authorized to access via the software is made available. 
  c) Third Party Software. The software may include third party applications that Microsoft, not the third party, licenses to you under this agreement. Any included notices for third party applications are for your information only.
  d) Microsoft Online Subscription Agreement. Some features of the software provide access to, or rely on, Microsoft Azure Services. The use of those services (but not the software) is governed by the separate terms and privacy policies associated with your Microsoft Azure subscription. The services may not be available in all regions. For more information see https://go.microsoft.com/fwLink/?LinkID=522330&amp;clcid=0x9.
2. DISTRIBUTABLE CODE. The software is comprised of “Distributable Code”. “Distributable Code” is code that you are permitted to distribute in applications you develop if you comply with the terms below and otherwise set forth in these license terms. 
  a) Distribution Rights. 
    i. You may copy and distribute the object code form of the software.
    i. Third Party Distribution. You may permit distributors of your applications to copy and distribute any of this distributable code you elect to distribute with your applications.
  b) Distribution Requirements. For any code you distribute, you must:
    i. add significant primary functionality to it in your applications;
    ii. require distributors and external end users to agree to terms that protect it and Microsoft at least as much as this agreement; and
    iii. indemnify, defend, and hold harmless Microsoft from any claims, including attorneys’ fees, related to the distribution or use of your applications, except to the extent that any claim is based solely on the unmodified distributable code.
  c) Distribution Restrictions. You may not:
    i. use Microsoft’s trademarks or trade dress in your application in any way that suggests your application comes from or is endorsed by Microsoft; or
    ii. modify or distribute the source code of any distributable code so that any part of it becomes subject to any license that requires that the distributable code, any other part of the software, or any of Microsoft’s other intellectual property be disclosed or distributed in source code form, or that others have the right to modify it.
3. DATA COLLECTION. The software may collect information about you and your use of the software and send that to Microsoft. Microsoft may use this information to provide services and improve Microsoft’s products and services. Your opt-out rights, if any, are described in the product documentation. Some features in the software may enable collection of data from users of your applications that access or use the software. If you use these features to enable data collection in your applications, you must comply with applicable law, including getting any required user consent, and maintain a prominent privacy policy that accurately informs users about how you use, collect, and share their data. You can learn more about Microsoft’s data collection and use in the product documentation and the Microsoft Privacy Statement at https://go.microsoft.com/fwlink/?LinkId=512132. You agree to comply with all applicable provisions of the Microsoft Privacy Statement.
4. SCOPE OF LICENSE. The software is licensed, not sold. Microsoft reserves all other rights. Unless applicable law gives you more rights despite this limitation, you will not (and have no right to):
  a) work around any technical limitations in the software that only allow you to use it in certain ways;
  b) reverse engineer, decompile, or disassemble the software, or attempt to do so, except and only to the extent permitted by licensing terms governing the use of open-source components that may be included with the software;
  c) remove, minimize, block, or modify any notices of Microsoft or its suppliers in the software;
  d) use the software in any way that is against the law or to create or propagate malware; or
  e) share, publish, distribute, or lend the software (except for any distributable code, subject to the terms above), provide the software as a stand-alone hosted solution for others to use, or transfer the software or this agreement to any third party.
5. EXPORT RESTRICTIONS. You must comply with all domestic and international export laws and regulations that apply to the software, which include restrictions on destinations, end users, and end use. For further information on export restrictions, visit http://aka.ms/exporting.
6. SUPPORT SERVICES. Microsoft is not obligated under this agreement to provide any support services for the software. Any support provided is “as is”, “with all faults”, and without warranty of any kind.
7. UPDATES. The software may periodically check for updates, and download and install them for you. You may obtain updates only from Microsoft or authorized sources. Microsoft may need to update your system to provide you with updates. You agree to receive these automatic updates without any additional notice. Updates may not include or support all existing software features, services, or peripheral devices.
8. ENTIRE AGREEMENT. This agreement, and any other terms Microsoft may provide for supplements, updates, or third-party applications, is the entire agreement for the software.
9. APPLICABLE LAW AND PLACE TO RESOLVE DISPUTES. If you acquired the software in the United States or Canada, the laws of the state or province where you live (or, if a business, where your principal place of business is located) govern the interpretation of this agreement, claims for its breach, and all other claims (including consumer protection, unfair competition, and tort claims), regardless of conflict of laws principles. If you acquired the software in any other country, its laws apply. If U.S. federal jurisdiction exists, you and Microsoft consent to exclusive jurisdiction and venue in the federal court in King County, Washington for all disputes heard in court. If not, you and Microsoft consent to exclusive jurisdiction and venue in the Superior Court of King County, Washington for all disputes heard in court.
10. CONSUMER RIGHTS; REGIONAL VARIATIONS. This agreement describes certain legal rights. You may have other rights, including consumer rights, under the laws of your state or country. Separate and apart from your relationship with Microsoft, you may also have rights with respect to the party from which you acquired the software. This agreement does not change those other rights if the laws of your state or country do not permit it to do so. For example, if you acquired the software in one of the below regions, or mandatory country law applies, then the following provisions apply to you:
  a) Australia. You have statutory guarantees under the Australian Consumer Law and nothing in this agreement is intended to affect those rights.
  b) Canada. If you acquired this software in Canada, you may stop receiving updates by turning off the automatic update feature, disconnecting your device from the Internet (if and when you re-connect to the Internet, however, the software will resume checking for and installing updates), or uninstalling the software. The product documentation, if any, may also specify how to turn off updates for your specific device or software.
  c) Germany and Austria.
    i. Warranty. The properly licensed software will perform substantially as described in any Microsoft materials that accompany the software. However, Microsoft gives no contractual guarantee in relation to the licensed software.
    ii. Limitation of Liability. In case of intentional conduct, gross negligence, claims based on the Product Liability Act, as well as, in case of death or personal or physical injury, Microsoft is liable according to the statutory law.
  Subject to the foregoing clause ii., Microsoft will only be liable for slight negligence if Microsoft is in breach of such material contractual obligations, the fulfillment of which facilitate the due performance of this agreement, the breach of which would endanger the purpose of this agreement and the compliance with which a party may constantly trust in (so-called "cardinal obligations"). In other cases of slight negligence, Microsoft will not be liable for slight negligence.
11. DISCLAIMER OF WARRANTY. THE SOFTWARE IS LICENSED “AS IS.” YOU BEAR THE RISK OF USING IT. MICROSOFT GIVES NO EXPRESS WARRANTIES, GUARANTEES, OR CONDITIONS. TO THE EXTENT PERMITTED UNDER APPLICABLE LAWS, MICROSOFT EXCLUDES ALL IMPLIED WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
12. LIMITATION ON AND EXCLUSION OF DAMAGES. IF YOU HAVE ANY BASIS FOR RECOVERING DAMAGES DESPITE THE PRECEDING DISCLAIMER OF WARRANTY, YOU CAN RECOVER FROM MICROSOFT AND ITS SUPPLIERS ONLY DIRECT DAMAGES UP TO U.S. $5.00. YOU CANNOT RECOVER ANY OTHER DAMAGES, INCLUDING CONSEQUENTIAL, LOST PROFITS, SPECIAL, INDIRECT, OR INCIDENTAL DAMAGES.
This limitation applies to (a) anything related to the software, services, content (including code) on third party Internet sites, or third party applications; and (b) claims for breach of contract, warranty, guarantee, or condition; strict liability, negligence, or other tort; or any other claim; in each case to the extent permitted by applicable law.
It also applies even if Microsoft knew or should have known about the possibility of the damages. The above limitation or exclusion may not apply to you because your state, province, or country may not allow the exclusion or limitation of incidental, consequential, or other damages.
Please note: As this software is distributed in Canada, some of the clauses in this agreement are provided below in French.
Remarque: Ce logiciel étant distribué au Canada, certaines des clauses dans ce contrat sont fournies ci-dessous en français.
EXONÉRATION DE GARANTIE. Le logiciel visé par une licence est offert « tel quel ». Toute utilisation de ce logiciel est à votre seule risque et péril. Microsoft n’accorde aucune autre garantie expresse. Vous pouvez bénéficier de droits additionnels en vertu du droit local sur la protection des consommateurs, que ce contrat ne peut modifier. La ou elles sont permises par le droit locale, les garanties implicites de qualité marchande, d’adéquation à un usage particulier et d’absence de contrefaçon sont exclues.
LIMITATION DES DOMMAGES-INTÉRÊTS ET EXCLUSION DE RESPONSABILITÉ POUR LES DOMMAGES. Vous pouvez obtenir de Microsoft et de ses fournisseurs une indemnisation en cas de dommages directs uniquement à hauteur de 5,00 $ US. Vous ne pouvez prétendre à aucune indemnisation pour les autres dommages, y compris les dommages spéciaux, indirects ou accessoires et pertes de bénéfices.
Cette limitation concerne:
• tout ce qui est relié au logiciel, aux services ou au contenu (y compris le code) figurant sur des sites Internet tiers ou dans des programmes tiers; et
• les réclamations au titre de violation de contrat ou de garantie, ou au titre de responsabilité stricte, de négligence ou d’une autre faute dans la limite autorisée par la loi en vigueur.
Elle s’applique également, même si Microsoft connaissait ou devrait connaître l’éventualité d’un tel dommage. Si votre pays n’autorise pas l’exclusion ou la limitation de responsabilité pour les dommages indirects, accessoires ou de quelque nature que ce soit, il se peut que la limitation ou l’exclusion ci-dessus ne s’appliquera pas à votre égard.
EFFET JURIDIQUE. Le présent contrat décrit certains droits juridiques. Vous pourriez avoir d’autres droits prévus par les lois de votre pays. Le présent contrat ne modifie pas les droits que vous confèrent les lois de votre pays si celles-ci ne le permettent pas.


	- component:
		name: @types/adal-angular
		version: 1.0.1
		license: |
    MIT License

    Copyright (c) Microsoft Corporation. All rights reserved.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE


	- component:
		name: jszip
		version: 3.2.2
		license: |
JSZip is dual licensed. You may use it under the MIT license *or* the GPLv3
license.

The MIT License
===============

Copyright (c) 2009-2016 Stuart Knightley, David Duponchel, Franz Buchinger, António Afonso

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.


GPL version 3
=============

                    GNU GENERAL PUBLIC LICENSE
                       Version 3, 29 June 2007

 Copyright (C) 2007 Free Software Foundation, Inc. <http://fsf.org/>
 Everyone is permitted to copy and distribute verbatim copies
 of this license document, but changing it is not allowed.

                            Preamble

  The GNU General Public License is a free, copyleft license for
software and other kinds of works.

  The licenses for most software and other practical works are designed
to take away your freedom to share and change the works.  By contrast,
the GNU General Public License is intended to guarantee your freedom to
share and change all versions of a program--to make sure it remains free
software for all its users.  We, the Free Software Foundation, use the
GNU General Public License for most of our software; it applies also to
any other work released this way by its authors.  You can apply it to
your programs, too.

  When we speak of free software, we are referring to freedom, not
price.  Our General Public Licenses are designed to make sure that you
have the freedom to distribute copies of free software (and charge for
them if you wish), that you receive source code or can get it if you
want it, that you can change the software or use pieces of it in new
free programs, and that you know you can do these things.

  To protect your rights, we need to prevent others from denying you
these rights or asking you to surrender the rights.  Therefore, you have
certain responsibilities if you distribute copies of the software, or if
you modify it: responsibilities to respect the freedom of others.

  For example, if you distribute copies of such a program, whether
gratis or for a fee, you must pass on to the recipients the same
freedoms that you received.  You must make sure that they, too, receive
or can get the source code.  And you must show them these terms so they
know their rights.

  Developers that use the GNU GPL protect your rights with two steps:
(1) assert copyright on the software, and (2) offer you this License
giving you legal permission to copy, distribute and/or modify it.

  For the developers' and authors' protection, the GPL clearly explains
that there is no warranty for this free software.  For both users' and
authors' sake, the GPL requires that modified versions be marked as
changed, so that their problems will not be attributed erroneously to
authors of previous versions.

  Some devices are designed to deny users access to install or run
modified versions of the software inside them, although the manufacturer
can do so.  This is fundamentally incompatible with the aim of
protecting users' freedom to change the software.  The systematic
pattern of such abuse occurs in the area of products for individuals to
use, which is precisely where it is most unacceptable.  Therefore, we
have designed this version of the GPL to prohibit the practice for those
products.  If such problems arise substantially in other domains, we
stand ready to extend this provision to those domains in future versions
of the GPL, as needed to protect the freedom of users.

  Finally, every program is threatened constantly by software patents.
States should not allow patents to restrict development and use of
software on general-purpose computers, but in those that do, we wish to
avoid the special danger that patents applied to a free program could
make it effectively proprietary.  To prevent this, the GPL assures that
patents cannot be used to render the program non-free.

  The precise terms and conditions for copying, distribution and
modification follow.

                       TERMS AND CONDITIONS

  0. Definitions.

  "This License" refers to version 3 of the GNU General Public License.

  "Copyright" also means copyright-like laws that apply to other kinds of
works, such as semiconductor masks.

  "The Program" refers to any copyrightable work licensed under this
License.  Each licensee is addressed as "you".  "Licensees" and
"recipients" may be individuals or organizations.

  To "modify" a work means to copy from or adapt all or part of the work
in a fashion requiring copyright permission, other than the making of an
exact copy.  The resulting work is called a "modified version" of the
earlier work or a work "based on" the earlier work.

  A "covered work" means either the unmodified Program or a work based
on the Program.

  To "propagate" a work means to do anything with it that, without
permission, would make you directly or secondarily liable for
infringement under applicable copyright law, except executing it on a
computer or modifying a private copy.  Propagation includes copying,
distribution (with or without modification), making available to the
public, and in some countries other activities as well.

  To "convey" a work means any kind of propagation that enables other
parties to make or receive copies.  Mere interaction with a user through
a computer network, with no transfer of a copy, is not conveying.

  An interactive user interface displays "Appropriate Legal Notices"
to the extent that it includes a convenient and prominently visible
feature that (1) displays an appropriate copyright notice, and (2)
tells the user that there is no warranty for the work (except to the
extent that warranties are provided), that licensees may convey the
work under this License, and how to view a copy of this License.  If
the interface presents a list of user commands or options, such as a
menu, a prominent item in the list meets this criterion.

  1. Source Code.

  The "source code" for a work means the preferred form of the work
for making modifications to it.  "Object code" means any non-source
form of a work.

  A "Standard Interface" means an interface that either is an official
standard defined by a recognized standards body, or, in the case of
interfaces specified for a particular programming language, one that
is widely used among developers working in that language.

  The "System Libraries" of an executable work include anything, other
than the work as a whole, that (a) is included in the normal form of
packaging a Major Component, but which is not part of that Major
Component, and (b) serves only to enable use of the work with that
Major Component, or to implement a Standard Interface for which an
implementation is available to the public in source code form.  A
"Major Component", in this context, means a major essential component
(kernel, window system, and so on) of the specific operating system
(if any) on which the executable work runs, or a compiler used to
produce the work, or an object code interpreter used to run it.

  The "Corresponding Source" for a work in object code form means all
the source code needed to generate, install, and (for an executable
work) run the object code and to modify the work, including scripts to
control those activities.  However, it does not include the work's
System Libraries, or general-purpose tools or generally available free
programs which are used unmodified in performing those activities but
which are not part of the work.  For example, Corresponding Source
includes interface definition files associated with source files for
the work, and the source code for shared libraries and dynamically
linked subprograms that the work is specifically designed to require,
such as by intimate data communication or control flow between those
subprograms and other parts of the work.

  The Corresponding Source need not include anything that users
can regenerate automatically from other parts of the Corresponding
Source.

  The Corresponding Source for a work in source code form is that
same work.

  2. Basic Permissions.

  All rights granted under this License are granted for the term of
copyright on the Program, and are irrevocable provided the stated
conditions are met.  This License explicitly affirms your unlimited
permission to run the unmodified Program.  The output from running a
covered work is covered by this License only if the output, given its
content, constitutes a covered work.  This License acknowledges your
rights of fair use or other equivalent, as provided by copyright law.

  You may make, run and propagate covered works that you do not
convey, without conditions so long as your license otherwise remains
in force.  You may convey covered works to others for the sole purpose
of having them make modifications exclusively for you, or provide you
with facilities for running those works, provided that you comply with
the terms of this License in conveying all material for which you do
not control copyright.  Those thus making or running the covered works
for you must do so exclusively on your behalf, under your direction
and control, on terms that prohibit them from making any copies of
your copyrighted material outside their relationship with you.

  Conveying under any other circumstances is permitted solely under
the conditions stated below.  Sublicensing is not allowed; section 10
makes it unnecessary.

  3. Protecting Users' Legal Rights From Anti-Circumvention Law.

  No covered work shall be deemed part of an effective technological
measure under any applicable law fulfilling obligations under article
11 of the WIPO copyright treaty adopted on 20 December 1996, or
similar laws prohibiting or restricting circumvention of such
measures.

  When you convey a covered work, you waive any legal power to forbid
circumvention of technological measures to the extent such circumvention
is effected by exercising rights under this License with respect to
the covered work, and you disclaim any intention to limit operation or
modification of the work as a means of enforcing, against the work's
users, your or third parties' legal rights to forbid circumvention of
technological measures.

  4. Conveying Verbatim Copies.

  You may convey verbatim copies of the Program's source code as you
receive it, in any medium, provided that you conspicuously and
appropriately publish on each copy an appropriate copyright notice;
keep intact all notices stating that this License and any
non-permissive terms added in accord with section 7 apply to the code;
keep intact all notices of the absence of any warranty; and give all
recipients a copy of this License along with the Program.

  You may charge any price or no price for each copy that you convey,
and you may offer support or warranty protection for a fee.

  5. Conveying Modified Source Versions.

  You may convey a work based on the Program, or the modifications to
produce it from the Program, in the form of source code under the
terms of section 4, provided that you also meet all of these conditions:

    a) The work must carry prominent notices stating that you modified
    it, and giving a relevant date.

    b) The work must carry prominent notices stating that it is
    released under this License and any conditions added under section
    7.  This requirement modifies the requirement in section 4 to
    "keep intact all notices".

    c) You must license the entire work, as a whole, under this
    License to anyone who comes into possession of a copy.  This
    License will therefore apply, along with any applicable section 7
    additional terms, to the whole of the work, and all its parts,
    regardless of how they are packaged.  This License gives no
    permission to license the work in any other way, but it does not
    invalidate such permission if you have separately received it.

    d) If the work has interactive user interfaces, each must display
    Appropriate Legal Notices; however, if the Program has interactive
    interfaces that do not display Appropriate Legal Notices, your
    work need not make them do so.

  A compilation of a covered work with other separate and independent
works, which are not by their nature extensions of the covered work,
and which are not combined with it such as to form a larger program,
in or on a volume of a storage or distribution medium, is called an
"aggregate" if the compilation and its resulting copyright are not
used to limit the access or legal rights of the compilation's users
beyond what the individual works permit.  Inclusion of a covered work
in an aggregate does not cause this License to apply to the other
parts of the aggregate.

  6. Conveying Non-Source Forms.

  You may convey a covered work in object code form under the terms
of sections 4 and 5, provided that you also convey the
machine-readable Corresponding Source under the terms of this License,
in one of these ways:

    a) Convey the object code in, or embodied in, a physical product
    (including a physical distribution medium), accompanied by the
    Corresponding Source fixed on a durable physical medium
    customarily used for software interchange.

    b) Convey the object code in, or embodied in, a physical product
    (including a physical distribution medium), accompanied by a
    written offer, valid for at least three years and valid for as
    long as you offer spare parts or customer support for that product
    model, to give anyone who possesses the object code either (1) a
    copy of the Corresponding Source for all the software in the
    product that is covered by this License, on a durable physical
    medium customarily used for software interchange, for a price no
    more than your reasonable cost of physically performing this
    conveying of source, or (2) access to copy the
    Corresponding Source from a network server at no charge.

    c) Convey individual copies of the object code with a copy of the
    written offer to provide the Corresponding Source.  This
    alternative is allowed only occasionally and noncommercially, and
    only if you received the object code with such an offer, in accord
    with subsection 6b.

    d) Convey the object code by offering access from a designated
    place (gratis or for a charge), and offer equivalent access to the
    Corresponding Source in the same way through the same place at no
    further charge.  You need not require recipients to copy the
    Corresponding Source along with the object code.  If the place to
    copy the object code is a network server, the Corresponding Source
    may be on a different server (operated by you or a third party)
    that supports equivalent copying facilities, provided you maintain
    clear directions next to the object code saying where to find the
    Corresponding Source.  Regardless of what server hosts the
    Corresponding Source, you remain obligated to ensure that it is
    available for as long as needed to satisfy these requirements.

    e) Convey the object code using peer-to-peer transmission, provided
    you inform other peers where the object code and Corresponding
    Source of the work are being offered to the general public at no
    charge under subsection 6d.

  A separable portion of the object code, whose source code is excluded
from the Corresponding Source as a System Library, need not be
included in conveying the object code work.

  A "User Product" is either (1) a "consumer product", which means any
tangible personal property which is normally used for personal, family,
or household purposes, or (2) anything designed or sold for incorporation
into a dwelling.  In determining whether a product is a consumer product,
doubtful cases shall be resolved in favor of coverage.  For a particular
product received by a particular user, "normally used" refers to a
typical or common use of that class of product, regardless of the status
of the particular user or of the way in which the particular user
actually uses, or expects or is expected to use, the product.  A product
is a consumer product regardless of whether the product has substantial
commercial, industrial or non-consumer uses, unless such uses represent
the only significant mode of use of the product.

  "Installation Information" for a User Product means any methods,
procedures, authorization keys, or other information required to install
and execute modified versions of a covered work in that User Product from
a modified version of its Corresponding Source.  The information must
suffice to ensure that the continued functioning of the modified object
code is in no case prevented or interfered with solely because
modification has been made.

  If you convey an object code work under this section in, or with, or
specifically for use in, a User Product, and the conveying occurs as
part of a transaction in which the right of possession and use of the
User Product is transferred to the recipient in perpetuity or for a
fixed term (regardless of how the transaction is characterized), the
Corresponding Source conveyed under this section must be accompanied
by the Installation Information.  But this requirement does not apply
if neither you nor any third party retains the ability to install
modified object code on the User Product (for example, the work has
been installed in ROM).

  The requirement to provide Installation Information does not include a
requirement to continue to provide support service, warranty, or updates
for a work that has been modified or installed by the recipient, or for
the User Product in which it has been modified or installed.  Access to a
network may be denied when the modification itself materially and
adversely affects the operation of the network or violates the rules and
protocols for communication across the network.

  Corresponding Source conveyed, and Installation Information provided,
in accord with this section must be in a format that is publicly
documented (and with an implementation available to the public in
source code form), and must require no special password or key for
unpacking, reading or copying.

  7. Additional Terms.

  "Additional permissions" are terms that supplement the terms of this
License by making exceptions from one or more of its conditions.
Additional permissions that are applicable to the entire Program shall
be treated as though they were included in this License, to the extent
that they are valid under applicable law.  If additional permissions
apply only to part of the Program, that part may be used separately
under those permissions, but the entire Program remains governed by
this License without regard to the additional permissions.

  When you convey a copy of a covered work, you may at your option
remove any additional permissions from that copy, or from any part of
it.  (Additional permissions may be written to require their own
removal in certain cases when you modify the work.)  You may place
additional permissions on material, added by you to a covered work,
for which you have or can give appropriate copyright permission.

  Notwithstanding any other provision of this License, for material you
add to a covered work, you may (if authorized by the copyright holders of
that material) supplement the terms of this License with terms:

    a) Disclaiming warranty or limiting liability differently from the
    terms of sections 15 and 16 of this License; or

    b) Requiring preservation of specified reasonable legal notices or
    author attributions in that material or in the Appropriate Legal
    Notices displayed by works containing it; or

    c) Prohibiting misrepresentation of the origin of that material, or
    requiring that modified versions of such material be marked in
    reasonable ways as different from the original version; or

    d) Limiting the use for publicity purposes of names of licensors or
    authors of the material; or

    e) Declining to grant rights under trademark law for use of some
    trade names, trademarks, or service marks; or

    f) Requiring indemnification of licensors and authors of that
    material by anyone who conveys the material (or modified versions of
    it) with contractual assumptions of liability to the recipient, for
    any liability that these contractual assumptions directly impose on
    those licensors and authors.

  All other non-permissive additional terms are considered "further
restrictions" within the meaning of section 10.  If the Program as you
received it, or any part of it, contains a notice stating that it is
governed by this License along with a term that is a further
restriction, you may remove that term.  If a license document contains
a further restriction but permits relicensing or conveying under this
License, you may add to a covered work material governed by the terms
of that license document, provided that the further restriction does
not survive such relicensing or conveying.

  If you add terms to a covered work in accord with this section, you
must place, in the relevant source files, a statement of the
additional terms that apply to those files, or a notice indicating
where to find the applicable terms.

  Additional terms, permissive or non-permissive, may be stated in the
form of a separately written license, or stated as exceptions;
the above requirements apply either way.

  8. Termination.

  You may not propagate or modify a covered work except as expressly
provided under this License.  Any attempt otherwise to propagate or
modify it is void, and will automatically terminate your rights under
this License (including any patent licenses granted under the third
paragraph of section 11).

  However, if you cease all violation of this License, then your
license from a particular copyright holder is reinstated (a)
provisionally, unless and until the copyright holder explicitly and
finally terminates your license, and (b) permanently, if the copyright
holder fails to notify you of the violation by some reasonable means
prior to 60 days after the cessation.

  Moreover, your license from a particular copyright holder is
reinstated permanently if the copyright holder notifies you of the
violation by some reasonable means, this is the first time you have
received notice of violation of this License (for any work) from that
copyright holder, and you cure the violation prior to 30 days after
your receipt of the notice.

  Termination of your rights under this section does not terminate the
licenses of parties who have received copies or rights from you under
this License.  If your rights have been terminated and not permanently
reinstated, you do not qualify to receive new licenses for the same
material under section 10.

  9. Acceptance Not Required for Having Copies.

  You are not required to accept this License in order to receive or
run a copy of the Program.  Ancillary propagation of a covered work
occurring solely as a consequence of using peer-to-peer transmission
to receive a copy likewise does not require acceptance.  However,
nothing other than this License grants you permission to propagate or
modify any covered work.  These actions infringe copyright if you do
not accept this License.  Therefore, by modifying or propagating a
covered work, you indicate your acceptance of this License to do so.

  10. Automatic Licensing of Downstream Recipients.

  Each time you convey a covered work, the recipient automatically
receives a license from the original licensors, to run, modify and
propagate that work, subject to this License.  You are not responsible
for enforcing compliance by third parties with this License.

  An "entity transaction" is a transaction transferring control of an
organization, or substantially all assets of one, or subdividing an
organization, or merging organizations.  If propagation of a covered
work results from an entity transaction, each party to that
transaction who receives a copy of the work also receives whatever
licenses to the work the party's predecessor in interest had or could
give under the previous paragraph, plus a right to possession of the
Corresponding Source of the work from the predecessor in interest, if
the predecessor has it or can get it with reasonable efforts.

  You may not impose any further restrictions on the exercise of the
rights granted or affirmed under this License.  For example, you may
not impose a license fee, royalty, or other charge for exercise of
rights granted under this License, and you may not initiate litigation
(including a cross-claim or counterclaim in a lawsuit) alleging that
any patent claim is infringed by making, using, selling, offering for
sale, or importing the Program or any portion of it.

  11. Patents.

  A "contributor" is a copyright holder who authorizes use under this
License of the Program or a work on which the Program is based.  The
work thus licensed is called the contributor's "contributor version".

  A contributor's "essential patent claims" are all patent claims
owned or controlled by the contributor, whether already acquired or
hereafter acquired, that would be infringed by some manner, permitted
by this License, of making, using, or selling its contributor version,
but do not include claims that would be infringed only as a
consequence of further modification of the contributor version.  For
purposes of this definition, "control" includes the right to grant
patent sublicenses in a manner consistent with the requirements of
this License.

  Each contributor grants you a non-exclusive, worldwide, royalty-free
patent license under the contributor's essential patent claims, to
make, use, sell, offer for sale, import and otherwise run, modify and
propagate the contents of its contributor version.

  In the following three paragraphs, a "patent license" is any express
agreement or commitment, however denominated, not to enforce a patent
(such as an express permission to practice a patent or covenant not to
sue for patent infringement).  To "grant" such a patent license to a
party means to make such an agreement or commitment not to enforce a
patent against the party.

  If you convey a covered work, knowingly relying on a patent license,
and the Corresponding Source of the work is not available for anyone
to copy, free of charge and under the terms of this License, through a
publicly available network server or other readily accessible means,
then you must either (1) cause the Corresponding Source to be so
available, or (2) arrange to deprive yourself of the benefit of the
patent license for this particular work, or (3) arrange, in a manner
consistent with the requirements of this License, to extend the patent
license to downstream recipients.  "Knowingly relying" means you have
actual knowledge that, but for the patent license, your conveying the
covered work in a country, or your recipient's use of the covered work
in a country, would infringe one or more identifiable patents in that
country that you have reason to believe are valid.

  If, pursuant to or in connection with a single transaction or
arrangement, you convey, or propagate by procuring conveyance of, a
covered work, and grant a patent license to some of the parties
receiving the covered work authorizing them to use, propagate, modify
or convey a specific copy of the covered work, then the patent license
you grant is automatically extended to all recipients of the covered
work and works based on it.

  A patent license is "discriminatory" if it does not include within
the scope of its coverage, prohibits the exercise of, or is
conditioned on the non-exercise of one or more of the rights that are
specifically granted under this License.  You may not convey a covered
work if you are a party to an arrangement with a third party that is
in the business of distributing software, under which you make payment
to the third party based on the extent of your activity of conveying
the work, and under which the third party grants, to any of the
parties who would receive the covered work from you, a discriminatory
patent license (a) in connection with copies of the covered work
conveyed by you (or copies made from those copies), or (b) primarily
for and in connection with specific products or compilations that
contain the covered work, unless you entered into that arrangement,
or that patent license was granted, prior to 28 March 2007.

  Nothing in this License shall be construed as excluding or limiting
any implied license or other defenses to infringement that may
otherwise be available to you under applicable patent law.

  12. No Surrender of Others' Freedom.

  If conditions are imposed on you (whether by court order, agreement or
otherwise) that contradict the conditions of this License, they do not
excuse you from the conditions of this License.  If you cannot convey a
covered work so as to satisfy simultaneously your obligations under this
License and any other pertinent obligations, then as a consequence you may
not convey it at all.  For example, if you agree to terms that obligate you
to collect a royalty for further conveying from those to whom you convey
the Program, the only way you could satisfy both those terms and this
License would be to refrain entirely from conveying the Program.

  13. Use with the GNU Affero General Public License.

  Notwithstanding any other provision of this License, you have
permission to link or combine any covered work with a work licensed
under version 3 of the GNU Affero General Public License into a single
combined work, and to convey the resulting work.  The terms of this
License will continue to apply to the part which is the covered work,
but the special requirements of the GNU Affero General Public License,
section 13, concerning interaction through a network will apply to the
combination as such.

  14. Revised Versions of this License.

  The Free Software Foundation may publish revised and/or new versions of
the GNU General Public License from time to time.  Such new versions will
be similar in spirit to the present version, but may differ in detail to
address new problems or concerns.

  Each version is given a distinguishing version number.  If the
Program specifies that a certain numbered version of the GNU General
Public License "or any later version" applies to it, you have the
option of following the terms and conditions either of that numbered
version or of any later version published by the Free Software
Foundation.  If the Program does not specify a version number of the
GNU General Public License, you may choose any version ever published
by the Free Software Foundation.

  If the Program specifies that a proxy can decide which future
versions of the GNU General Public License can be used, that proxy's
public statement of acceptance of a version permanently authorizes you
to choose that version for the Program.

  Later license versions may give you additional or different
permissions.  However, no additional obligations are imposed on any
author or copyright holder as a result of your choosing to follow a
later version.

  15. Disclaimer of Warranty.

  THERE IS NO WARRANTY FOR THE PROGRAM, TO THE EXTENT PERMITTED BY
APPLICABLE LAW.  EXCEPT WHEN OTHERWISE STATED IN WRITING THE COPYRIGHT
HOLDERS AND/OR OTHER PARTIES PROVIDE THE PROGRAM "AS IS" WITHOUT WARRANTY
OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
PURPOSE.  THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE PROGRAM
IS WITH YOU.  SHOULD THE PROGRAM PROVE DEFECTIVE, YOU ASSUME THE COST OF
ALL NECESSARY SERVICING, REPAIR OR CORRECTION.

  16. Limitation of Liability.

  IN NO EVENT UNLESS REQUIRED BY APPLICABLE LAW OR AGREED TO IN WRITING
WILL ANY COPYRIGHT HOLDER, OR ANY OTHER PARTY WHO MODIFIES AND/OR CONVEYS
THE PROGRAM AS PERMITTED ABOVE, BE LIABLE TO YOU FOR DAMAGES, INCLUDING ANY
GENERAL, SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE
USE OR INABILITY TO USE THE PROGRAM (INCLUDING BUT NOT LIMITED TO LOSS OF
DATA OR DATA BEING RENDERED INACCURATE OR LOSSES SUSTAINED BY YOU OR THIRD
PARTIES OR A FAILURE OF THE PROGRAM TO OPERATE WITH ANY OTHER PROGRAMS),
EVEN IF SUCH HOLDER OR OTHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF
SUCH DAMAGES.

  17. Interpretation of Sections 15 and 16.

  If the disclaimer of warranty and limitation of liability provided
above cannot be given local legal effect according to their terms,
reviewing courts shall apply local law that most closely approximates
an absolute waiver of all civil liability in connection with the
Program, unless a warranty or assumption of liability accompanies a
copy of the Program in return for a fee.

                     END OF TERMS AND CONDITIONS


	- component:
		name: lie
		version: 3.3.0
		license: |
#Copyright (c) 2014-2018 Calvin Metcalf, Jordan Harband

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

**THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.**


	- component:
		name: immediate
		version: 3.0.6
		license: |
Copyright (c) 2012 Barnesandnoble.com, llc, Donavon West, Domenic Denicola, Brian Cavalier

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


	- component:
		name: pako
		version: 1.0.10
		license: |
(The MIT License)

Copyright (C) 2014-2017 by Vitaly Puzrin and Andrei Tuputcyn

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.


	- component:
		name: readable-stream
		version: 2.3.6
		license: |
Node.js is licensed for use as follows:

"""
Copyright Node.js contributors. All rights reserved.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to
deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
IN THE SOFTWARE.
"""

This license applies to parts of Node.js originating from the
https://github.com/joyent/node repository:

"""
Copyright Joyent, Inc. and other Node contributors. All rights reserved.
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to
deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
IN THE SOFTWARE.
"""


	- component:
		name: core-util-is
		version: 1.0.2
		license: |
Copyright Node.js contributors. All rights reserved.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to
deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
IN THE SOFTWARE.


	- component:
		name: inherits
		version: 2.0.4
		license: |
The ISC License

Copyright (c) Isaac Z. Schlueter

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.



	- component:
		name: isarray
		version: 1.0.0
		license: |
(MIT)

Copyright (c) 2013 Julian Gruber <julian@juliangruber.com>

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	- component:
		name: process-nextick-args
		version: 2.0.1
		license: |
# Copyright (c) 2015 Calvin Metcalf

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

**THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.**


	- component:
		name: safe-buffer
		version: 5.1.2
		license: |
The MIT License (MIT)

Copyright (c) Feross Aboukhadijeh

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.


	- component:
		name: string_decoder
		version: 1.1.1
		license: |
Node.js is licensed for use as follows:

"""
Copyright Node.js contributors. All rights reserved.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to
deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
IN THE SOFTWARE.
"""

This license applies to parts of Node.js originating from the
https://github.com/joyent/node repository:

"""
Copyright Joyent, Inc. and other Node contributors. All rights reserved.
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to
deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
IN THE SOFTWARE.
"""



	- component:
		name: util-deprecate
		version: 1.0.2
		license: |
(The MIT License)

Copyright (c) 2014 Nathan Rajlich <nathan@tootallnate.net>

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.


	- component:
		name: set-immediate-shim
		version: 1.0.1
		license: |
MIT

	- component:
		name: lodash
		version: 4.17.15
		license: |
Copyright OpenJS Foundation and other contributors <https://openjsf.org/>

Based on Underscore.js, copyright Jeremy Ashkenas,
DocumentCloud and Investigative Reporters & Editors <http://underscorejs.org/>

This software consists of voluntary contributions made by many
individuals. For exact contribution history, see the revision history
available at https://github.com/lodash/lodash

The following license applies to all parts of this software except as
documented below:

====

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

====

Copyright and related rights for sample code are waived via CC0. Sample
code is defined as all source code displayed within the prose of the
documentation.

CC0: http://creativecommons.org/publicdomain/zero/1.0/

====

Files located in the node_modules and vendor directories are externally
maintained libraries used by this software which have their own
licenses; we recommend you read them, as their terms may differ from the
terms above.


	- component:
		name: rollup-plugin-web-worker-loader
		version: 0.8.1
		license: |
MIT License

Copyright (c) 2019 Dario Segura

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


	- component:
		name: typescript
		version: 3.7.5
		license: |
Apache License

Version 2.0, January 2004

http://www.apache.org/licenses/ 

TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

1. Definitions.

"License" shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1 through 9 of this document.

"Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is granting the License.

"Legal Entity" shall mean the union of the acting entity and all other entities that control, are controlled by, or are under common control with that entity. For the purposes of this definition, "control" means (i) the power, direct or indirect, to cause the direction or management of such entity, whether by contract or otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial ownership of such entity.

"You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this License.

"Source" form shall mean the preferred form for making modifications, including but not limited to software source code, documentation source, and configuration files.

"Object" form shall mean any form resulting from mechanical transformation or translation of a Source form, including but not limited to compiled object code, generated documentation, and conversions to other media types.

"Work" shall mean the work of authorship, whether in Source or Object form, made available under the License, as indicated by a copyright notice that is included in or attached to the work (an example is provided in the Appendix below).

"Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or derived from) the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent, as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and Derivative Works thereof.

"Contribution" shall mean any work of authorship, including the original version of the Work and any modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any form of electronic, verbal, or written communication sent to the Licensor or its representatives, including but not limited to communication on electronic mailing lists, source code control systems, and issue tracking systems that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner as "Not a Contribution."

"Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been received by Licensor and subsequently incorporated within the Work.

2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form.

3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the Work, where such license applies only to those patent claims licensable by such Contributor that are necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.

4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any medium, with or without modifications, and in Source or Object form, provided that You meet the following conditions:

You must give any other recipients of the Work or Derivative Works a copy of this License; and

You must cause any modified files to carry prominent notices stating that You changed the files; and

You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent, trademark, and attribution notices from the Source form of the Work, excluding those notices that do not pertain to any part of the Derivative Works; and

If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works that You distribute must include a readable copy of the attribution notices contained within such NOTICE file, excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source form or documentation, if provided along with the Derivative Works; or, within a display generated by the Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file are for informational purposes only and do not modify the License. You may add Your own attribution notices within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work, provided that such additional attribution notices cannot be construed as modifying the License. You may add Your own copyright statement to Your modifications and may provide additional or different license terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the conditions stated in this License.

5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede or modify the terms of any separate license agreement you may have executed with Licensor regarding such Contributions.

6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or product names of the Licensor, except as required for reasonable and customary use in describing the origin of the Work and reproducing the content of the NOTICE file.

7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License.

8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages.

9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability obligations and/or rights consistent with this License. However, in accepting such obligations, You may act only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims asserted against, such Contributor by reason of your accepting any such warranty or additional liability.

END OF TERMS AND CONDITIONS


	- component:
		name: uuid-random
		version: 1.3.0
		license: |
Copyright (c) 2016-2019 Wes Roberts

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

'use strict'
Object.defineProperty(exports, '__esModule', { value: !0 })
var t,
  e = (t = null) && 'object' == typeof t && 'default' in t ? t.default : t,
  i = require('azure-maps-control'),
  l = function (t, e) {
    return (l =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function (t, e) {
          t.__proto__ = e
        }) ||
      function (t, e) {
        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
      })(t, e)
  }
function s(t, e) {
  function i() {
    this.constructor = t
  }
  l(t, e), (t.prototype = null === e ? Object.create(e) : ((i.prototype = e.prototype), new i()))
}
var n = function () {
  return (n =
    Object.assign ||
    function (t) {
      for (var e, i = 1, l = arguments.length; i < l; i++)
        for (var s in (e = arguments[i]))
          Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s])
      return t
    }).apply(this, arguments)
}
function a(t, e, i, l) {
  return new (i || (i = Promise))(function (s, n) {
    function a(t) {
      try {
        d(l.next(t))
      } catch (t) {
        n(t)
      }
    }
    function c(t) {
      try {
        d(l.throw(t))
      } catch (t) {
        n(t)
      }
    }
    function d(t) {
      t.done
        ? s(t.value)
        : new i(function (e) {
            e(t.value)
          }).then(a, c)
    }
    d((l = l.apply(t, e || [])).next())
  })
}
function c(t, e) {
  var i,
    l,
    s,
    n,
    a = {
      label: 0,
      sent: function () {
        if (1 & s[0]) throw s[1]
        return s[1]
      },
      trys: [],
      ops: []
    }
  return (
    (n = { next: c(0), throw: c(1), return: c(2) }),
    'function' == typeof Symbol &&
      (n[Symbol.iterator] = function () {
        return this
      }),
    n
  )
  function c(n) {
    return function (c) {
      return (function (n) {
        if (i) throw new TypeError('Generator is already executing.')
        for (; a; )
          try {
            if (
              ((i = 1),
              l &&
                (s =
                  2 & n[0]
                    ? l.return
                    : n[0]
                    ? l.throw || ((s = l.return) && s.call(l), 0)
                    : l.next) &&
                !(s = s.call(l, n[1])).done)
            )
              return s
            switch (((l = 0), s && (n = [2 & n[0], s.value]), n[0])) {
              case 0:
              case 1:
                s = n
                break
              case 4:
                return a.label++, { value: n[1], done: !1 }
              case 5:
                a.label++, (l = n[1]), (n = [0])
                continue
              case 7:
                ;(n = a.ops.pop()), a.trys.pop()
                continue
              default:
                if (
                  !(s = (s = a.trys).length > 0 && s[s.length - 1]) &&
                  (6 === n[0] || 2 === n[0])
                ) {
                  a = 0
                  continue
                }
                if (3 === n[0] && (!s || (n[1] > s[0] && n[1] < s[3]))) {
                  a.label = n[1]
                  break
                }
                if (6 === n[0] && a.label < s[1]) {
                  ;(a.label = s[1]), (s = n)
                  break
                }
                if (s && a.label < s[2]) {
                  ;(a.label = s[2]), a.ops.push(n)
                  break
                }
                s[2] && a.ops.pop(), a.trys.pop()
                continue
            }
            n = e.call(t, a)
          } catch (t) {
            ;(n = [6, t]), (l = 0)
          } finally {
            i = s = 0
          }
        if (5 & n[0]) throw n[1]
        return { value: n[0] ? n[1] : void 0, done: !0 }
      })([n, c])
    }
  }
}
var d = (function () {
  function t() {}
  return (
    (t.merge = function (t, e) {
      for (var i = window || global, l = 0, s = t.split('.'); l < s.length; l++) {
        var a = s[l]
        if (!i[a]) return e
        i = i[a]
      }
      return n(n({}, i), e)
    }),
    t
  )
})()
!(function (t) {
  function e(e, i) {
    return t.call(this, e, i) || this
  }
  s(e, t),
    (e.fromData = function (t) {
      var i = NaN,
        l = NaN,
        s = new Set(['y']),
        n = new Set(['x'])
      return (
        Object.keys(t).forEach(function (e) {
          var a = e.toLowerCase()
          isNaN(i) && s.has(a) && 'number' == typeof t[e]
            ? (i = t[e])
            : isNaN(l) && n.has(a) && 'number' == typeof t[e] && (l = t[e])
        }),
        isNaN(i) || isNaN(l) ? null : new e(i, l)
      )
    }),
    (e.getX = function (t) {
      return t.length > 0 ? t[0] : NaN
    }),
    (e.getY = function (t) {
      return t.length > 1 ? t[1] : NaN
    }),
    (e.getDestination = function (t, i, l) {
      return new e(
        e.getX(t) + l * Math.cos(((i + 270) * Math.PI) / 180),
        e.getY(t) + l * Math.sin(((i + 270) * Math.PI) / 180)
      )
    }),
    (e.getDistance = function (t, i) {
      var l = e.getX(t) - e.getX(i),
        s = e.getY(t) - e.getY(i)
      return Math.sqrt(l * l + s * s)
    }),
    (e.getHeading = function (t, i) {
      var l = e.getX(i) - e.getX(t),
        s = e.getY(t) - e.getY(i)
      return ((180 * (2.5 * Math.PI - Math.atan2(s, l))) / Math.PI) % 360
    })
})(Array)
var r = function () {
  ;(this.__data__ = []), (this.size = 0)
}
var o = function (t, e) {
  return t === e || (t != t && e != e)
}
var m = function (t, e) {
    for (var i = t.length; i--; ) if (o(t[i][0], e)) return i
    return -1
  },
  u = Array.prototype.splice
var b = function (t) {
  var e = this.__data__,
    i = m(e, t)
  return !(i < 0) && (i == e.length - 1 ? e.pop() : u.call(e, i, 1), --this.size, !0)
}
var h = function (t) {
  var e = this.__data__,
    i = m(e, t)
  return i < 0 ? void 0 : e[i][1]
}
var Z = function (t) {
  return m(this.__data__, t) > -1
}
var p = function (t, e) {
  var i = this.__data__,
    l = m(i, t)
  return l < 0 ? (++this.size, i.push([t, e])) : (i[l][1] = e), this
}
function y(t) {
  var e = -1,
    i = null == t ? 0 : t.length
  for (this.clear(); ++e < i; ) {
    var l = t[e]
    this.set(l[0], l[1])
  }
}
;(y.prototype.clear = r),
  (y.prototype.delete = b),
  (y.prototype.get = h),
  (y.prototype.has = Z),
  (y.prototype.set = p)
var X = y
var G = function () {
  ;(this.__data__ = new X()), (this.size = 0)
}
var W = function (t) {
  var e = this.__data__,
    i = e.delete(t)
  return (this.size = e.size), i
}
var V = function (t) {
  return this.__data__.get(t)
}
var Y = function (t) {
    return this.__data__.has(t)
  },
  L =
    'undefined' != typeof globalThis
      ? globalThis
      : 'undefined' != typeof window
      ? window
      : 'undefined' != typeof global
      ? global
      : 'undefined' != typeof self
      ? self
      : {}
function S() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs')
}
function I(t, e) {
  return t((e = { exports: {} }), e.exports), e.exports
}
var R = 'object' == typeof L && L && L.Object === Object && L,
  f = 'object' == typeof self && self && self.Object === Object && self,
  x = R || f || Function('return this')(),
  g = x.Symbol,
  K = Object.prototype,
  J = K.hasOwnProperty,
  N = K.toString,
  z = g ? g.toStringTag : void 0
var v = function (t) {
    var e = J.call(t, z),
      i = t[z]
    try {
      t[z] = void 0
      var l = !0
    } catch (t) {}
    var s = N.call(t)
    return l && (e ? (t[z] = i) : delete t[z]), s
  },
  H = Object.prototype.toString
var w = function (t) {
    return H.call(t)
  },
  T = g ? g.toStringTag : void 0
var F = function (t) {
  return null == t
    ? void 0 === t
      ? '[object Undefined]'
      : '[object Null]'
    : T && T in Object(t)
    ? v(t)
    : w(t)
}
var M = function (t) {
  var e = typeof t
  return null != t && ('object' == e || 'function' == e)
}
var k,
  U = function (t) {
    if (!M(t)) return !1
    var e = F(t)
    return (
      '[object Function]' == e ||
      '[object GeneratorFunction]' == e ||
      '[object AsyncFunction]' == e ||
      '[object Proxy]' == e
    )
  },
  P = x['__core-js_shared__'],
  C = (k = /[^.]+$/.exec((P && P.keys && P.keys.IE_PROTO) || '')) ? 'Symbol(src)_1.' + k : ''
var j = function (t) {
    return !!C && C in t
  },
  O = Function.prototype.toString
var B = function (t) {
    if (null != t) {
      try {
        return O.call(t)
      } catch (t) {}
      try {
        return t + ''
      } catch (t) {}
    }
    return ''
  },
  E = /^\[object .+?Constructor\]$/,
  D = Function.prototype,
  Q = Object.prototype,
  _ = D.toString,
  A = Q.hasOwnProperty,
  q = RegExp(
    '^' +
      _.call(A)
        .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
      '$'
  )
var $ = function (t) {
  return !(!M(t) || j(t)) && (U(t) ? q : E).test(B(t))
}
var tt = function (t, e) {
  return null == t ? void 0 : t[e]
}
var et = function (t, e) {
    var i = tt(t, e)
    return $(i) ? i : void 0
  },
  it = et(x, 'Map'),
  lt = et(Object, 'create')
var st = function () {
  ;(this.__data__ = lt ? lt(null) : {}), (this.size = 0)
}
var nt = function (t) {
    var e = this.has(t) && delete this.__data__[t]
    return (this.size -= e ? 1 : 0), e
  },
  at = Object.prototype.hasOwnProperty
var ct = function (t) {
    var e = this.__data__
    if (lt) {
      var i = e[t]
      return '__lodash_hash_undefined__' === i ? void 0 : i
    }
    return at.call(e, t) ? e[t] : void 0
  },
  dt = Object.prototype.hasOwnProperty
var rt = function (t) {
  var e = this.__data__
  return lt ? void 0 !== e[t] : dt.call(e, t)
}
var ot = function (t, e) {
  var i = this.__data__
  return (
    (this.size += this.has(t) ? 0 : 1),
    (i[t] = lt && void 0 === e ? '__lodash_hash_undefined__' : e),
    this
  )
}
function mt(t) {
  var e = -1,
    i = null == t ? 0 : t.length
  for (this.clear(); ++e < i; ) {
    var l = t[e]
    this.set(l[0], l[1])
  }
}
;(mt.prototype.clear = st),
  (mt.prototype.delete = nt),
  (mt.prototype.get = ct),
  (mt.prototype.has = rt),
  (mt.prototype.set = ot)
var ut = mt
var bt = function () {
  ;(this.size = 0), (this.__data__ = { hash: new ut(), map: new (it || X)(), string: new ut() })
}
var ht = function (t) {
  var e = typeof t
  return 'string' == e || 'number' == e || 'symbol' == e || 'boolean' == e
    ? '__proto__' !== t
    : null === t
}
var Zt = function (t, e) {
  var i = t.__data__
  return ht(e) ? i['string' == typeof e ? 'string' : 'hash'] : i.map
}
var pt = function (t) {
  var e = Zt(this, t).delete(t)
  return (this.size -= e ? 1 : 0), e
}
var yt = function (t) {
  return Zt(this, t).get(t)
}
var Xt = function (t) {
  return Zt(this, t).has(t)
}
var Gt = function (t, e) {
  var i = Zt(this, t),
    l = i.size
  return i.set(t, e), (this.size += i.size == l ? 0 : 1), this
}
function Wt(t) {
  var e = -1,
    i = null == t ? 0 : t.length
  for (this.clear(); ++e < i; ) {
    var l = t[e]
    this.set(l[0], l[1])
  }
}
;(Wt.prototype.clear = bt),
  (Wt.prototype.delete = pt),
  (Wt.prototype.get = yt),
  (Wt.prototype.has = Xt),
  (Wt.prototype.set = Gt)
var Vt = Wt
var Yt = function (t, e) {
  var i = this.__data__
  if (i instanceof X) {
    var l = i.__data__
    if (!it || l.length < 199) return l.push([t, e]), (this.size = ++i.size), this
    i = this.__data__ = new Vt(l)
  }
  return i.set(t, e), (this.size = i.size), this
}
function Lt(t) {
  var e = (this.__data__ = new X(t))
  this.size = e.size
}
;(Lt.prototype.clear = G),
  (Lt.prototype.delete = W),
  (Lt.prototype.get = V),
  (Lt.prototype.has = Y),
  (Lt.prototype.set = Yt)
var St = Lt
var It = function (t, e) {
    for (var i = -1, l = null == t ? 0 : t.length; ++i < l && !1 !== e(t[i], i, t); );
    return t
  },
  Rt = (function () {
    try {
      var t = et(Object, 'defineProperty')
      return t({}, '', {}), t
    } catch (t) {}
  })()
var ft = function (t, e, i) {
    '__proto__' == e && Rt
      ? Rt(t, e, { configurable: !0, enumerable: !0, value: i, writable: !0 })
      : (t[e] = i)
  },
  xt = Object.prototype.hasOwnProperty
var gt = function (t, e, i) {
  var l = t[e]
  ;(xt.call(t, e) && o(l, i) && (void 0 !== i || e in t)) || ft(t, e, i)
}
var Kt = function (t, e, i, l) {
  var s = !i
  i || (i = {})
  for (var n = -1, a = e.length; ++n < a; ) {
    var c = e[n],
      d = l ? l(i[c], t[c], c, i, t) : void 0
    void 0 === d && (d = t[c]), s ? ft(i, c, d) : gt(i, c, d)
  }
  return i
}
var Jt = function (t, e) {
  for (var i = -1, l = Array(t); ++i < t; ) l[i] = e(i)
  return l
}
var Nt = function (t) {
  return null != t && 'object' == typeof t
}
var zt = function (t) {
    return Nt(t) && '[object Arguments]' == F(t)
  },
  vt = Object.prototype,
  Ht = vt.hasOwnProperty,
  wt = vt.propertyIsEnumerable,
  Tt = zt(
    (function () {
      return arguments
    })()
  )
    ? zt
    : function (t) {
        return Nt(t) && Ht.call(t, 'callee') && !wt.call(t, 'callee')
      },
  Ft = Array.isArray
var Mt = function () {
    return !1
  },
  kt = I(function (t, e) {
    var i = e && !e.nodeType && e,
      l = i && t && !t.nodeType && t,
      s = l && l.exports === i ? x.Buffer : void 0,
      n = (s ? s.isBuffer : void 0) || Mt
    t.exports = n
  }),
  Ut = /^(?:0|[1-9]\d*)$/
var Pt = function (t, e) {
  var i = typeof t
  return (
    !!(e = null == e ? 9007199254740991 : e) &&
    ('number' == i || ('symbol' != i && Ut.test(t))) &&
    t > -1 &&
    t % 1 == 0 &&
    t < e
  )
}
var Ct = function (t) {
    return 'number' == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991
  },
  jt = {}
;(jt['[object Float32Array]'] =
  jt['[object Float64Array]'] =
  jt['[object Int8Array]'] =
  jt['[object Int16Array]'] =
  jt['[object Int32Array]'] =
  jt['[object Uint8Array]'] =
  jt['[object Uint8ClampedArray]'] =
  jt['[object Uint16Array]'] =
  jt['[object Uint32Array]'] =
    !0),
  (jt['[object Arguments]'] =
    jt['[object Array]'] =
    jt['[object ArrayBuffer]'] =
    jt['[object Boolean]'] =
    jt['[object DataView]'] =
    jt['[object Date]'] =
    jt['[object Error]'] =
    jt['[object Function]'] =
    jt['[object Map]'] =
    jt['[object Number]'] =
    jt['[object Object]'] =
    jt['[object RegExp]'] =
    jt['[object Set]'] =
    jt['[object String]'] =
    jt['[object WeakMap]'] =
      !1)
var Ot = function (t) {
  return Nt(t) && Ct(t.length) && !!jt[F(t)]
}
var Bt = function (t) {
    return function (e) {
      return t(e)
    }
  },
  Et = I(function (t, e) {
    var i = e && !e.nodeType && e,
      l = i && t && !t.nodeType && t,
      s = l && l.exports === i && R.process,
      n = (function () {
        try {
          var t = l && l.require && l.require('util').types
          return t || (s && s.binding && s.binding('util'))
        } catch (t) {}
      })()
    t.exports = n
  }),
  Dt = Et && Et.isTypedArray,
  Qt = Dt ? Bt(Dt) : Ot,
  _t = Object.prototype.hasOwnProperty
var At = function (t, e) {
    var i = Ft(t),
      l = !i && Tt(t),
      s = !i && !l && kt(t),
      n = !i && !l && !s && Qt(t),
      a = i || l || s || n,
      c = a ? Jt(t.length, String) : [],
      d = c.length
    for (var r in t)
      (!e && !_t.call(t, r)) ||
        (a &&
          ('length' == r ||
            (s && ('offset' == r || 'parent' == r)) ||
            (n && ('buffer' == r || 'byteLength' == r || 'byteOffset' == r)) ||
            Pt(r, d))) ||
        c.push(r)
    return c
  },
  qt = Object.prototype
var $t = function (t) {
  var e = t && t.constructor
  return t === (('function' == typeof e && e.prototype) || qt)
}
var te = function (t, e) {
    return function (i) {
      return t(e(i))
    }
  },
  ee = te(Object.keys, Object),
  ie = Object.prototype.hasOwnProperty
var le = function (t) {
  if (!$t(t)) return ee(t)
  var e = []
  for (var i in Object(t)) ie.call(t, i) && 'constructor' != i && e.push(i)
  return e
}
var se = function (t) {
  return null != t && Ct(t.length) && !U(t)
}
var ne = function (t) {
  return se(t) ? At(t) : le(t)
}
var ae = function (t, e) {
  return t && Kt(e, ne(e), t)
}
var ce = function (t) {
    var e = []
    if (null != t) for (var i in Object(t)) e.push(i)
    return e
  },
  de = Object.prototype.hasOwnProperty
var re = function (t) {
  if (!M(t)) return ce(t)
  var e = $t(t),
    i = []
  for (var l in t) ('constructor' != l || (!e && de.call(t, l))) && i.push(l)
  return i
}
var oe = function (t) {
  return se(t) ? At(t, !0) : re(t)
}
var me = function (t, e) {
    return t && Kt(e, oe(e), t)
  },
  ue = I(function (t, e) {
    var i = e && !e.nodeType && e,
      l = i && t && !t.nodeType && t,
      s = l && l.exports === i ? x.Buffer : void 0,
      n = s ? s.allocUnsafe : void 0
    t.exports = function (t, e) {
      if (e) return t.slice()
      var i = t.length,
        l = n ? n(i) : new t.constructor(i)
      return t.copy(l), l
    }
  })
var be = function (t, e) {
  var i = -1,
    l = t.length
  for (e || (e = Array(l)); ++i < l; ) e[i] = t[i]
  return e
}
var he = function (t, e) {
  for (var i = -1, l = null == t ? 0 : t.length, s = 0, n = []; ++i < l; ) {
    var a = t[i]
    e(a, i, t) && (n[s++] = a)
  }
  return n
}
var Ze = function () {
    return []
  },
  pe = Object.prototype.propertyIsEnumerable,
  ye = Object.getOwnPropertySymbols,
  Xe = ye
    ? function (t) {
        return null == t
          ? []
          : ((t = Object(t)),
            he(ye(t), function (e) {
              return pe.call(t, e)
            }))
      }
    : Ze
var Ge = function (t, e) {
  return Kt(t, Xe(t), e)
}
var We = function (t, e) {
    for (var i = -1, l = e.length, s = t.length; ++i < l; ) t[s + i] = e[i]
    return t
  },
  Ve = te(Object.getPrototypeOf, Object),
  Ye = Object.getOwnPropertySymbols
    ? function (t) {
        for (var e = []; t; ) We(e, Xe(t)), (t = Ve(t))
        return e
      }
    : Ze
var Le = function (t, e) {
  return Kt(t, Ye(t), e)
}
var Se = function (t, e, i) {
  var l = e(t)
  return Ft(t) ? l : We(l, i(t))
}
var Ie = function (t) {
  return Se(t, ne, Xe)
}
var Re = function (t) {
    return Se(t, oe, Ye)
  },
  fe = et(x, 'DataView'),
  xe = et(x, 'Promise'),
  ge = et(x, 'Set'),
  Ke = et(x, 'WeakMap'),
  Je = B(fe),
  Ne = B(it),
  ze = B(xe),
  ve = B(ge),
  He = B(Ke),
  we = F
;((fe && '[object DataView]' != we(new fe(new ArrayBuffer(1)))) ||
  (it && '[object Map]' != we(new it())) ||
  (xe && '[object Promise]' != we(xe.resolve())) ||
  (ge && '[object Set]' != we(new ge())) ||
  (Ke && '[object WeakMap]' != we(new Ke()))) &&
  (we = function (t) {
    var e = F(t),
      i = '[object Object]' == e ? t.constructor : void 0,
      l = i ? B(i) : ''
    if (l)
      switch (l) {
        case Je:
          return '[object DataView]'
        case Ne:
          return '[object Map]'
        case ze:
          return '[object Promise]'
        case ve:
          return '[object Set]'
        case He:
          return '[object WeakMap]'
      }
    return e
  })
var Te = we,
  Fe = Object.prototype.hasOwnProperty
var Me = function (t) {
    var e = t.length,
      i = new t.constructor(e)
    return (
      e &&
        'string' == typeof t[0] &&
        Fe.call(t, 'index') &&
        ((i.index = t.index), (i.input = t.input)),
      i
    )
  },
  ke = x.Uint8Array
var Ue = function (t) {
  var e = new t.constructor(t.byteLength)
  return new ke(e).set(new ke(t)), e
}
var Pe = function (t, e) {
    var i = e ? Ue(t.buffer) : t.buffer
    return new t.constructor(i, t.byteOffset, t.byteLength)
  },
  Ce = /\w*$/
var je = function (t) {
    var e = new t.constructor(t.source, Ce.exec(t))
    return (e.lastIndex = t.lastIndex), e
  },
  Oe = g ? g.prototype : void 0,
  Be = Oe ? Oe.valueOf : void 0
var Ee = function (t) {
  return Be ? Object(Be.call(t)) : {}
}
var De = function (t, e) {
  var i = e ? Ue(t.buffer) : t.buffer
  return new t.constructor(i, t.byteOffset, t.length)
}
var Qe = function (t, e, i) {
    var l = t.constructor
    switch (e) {
      case '[object ArrayBuffer]':
        return Ue(t)
      case '[object Boolean]':
      case '[object Date]':
        return new l(+t)
      case '[object DataView]':
        return Pe(t, i)
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return De(t, i)
      case '[object Map]':
        return new l()
      case '[object Number]':
      case '[object String]':
        return new l(t)
      case '[object RegExp]':
        return je(t)
      case '[object Set]':
        return new l()
      case '[object Symbol]':
        return Ee(t)
    }
  },
  _e = Object.create,
  Ae = (function () {
    function t() {}
    return function (e) {
      if (!M(e)) return {}
      if (_e) return _e(e)
      t.prototype = e
      var i = new t()
      return (t.prototype = void 0), i
    }
  })()
var qe = function (t) {
  return 'function' != typeof t.constructor || $t(t) ? {} : Ae(Ve(t))
}
var $e = function (t) {
    return Nt(t) && '[object Map]' == Te(t)
  },
  ti = Et && Et.isMap,
  ei = ti ? Bt(ti) : $e
var ii = function (t) {
    return Nt(t) && '[object Set]' == Te(t)
  },
  li = Et && Et.isSet,
  si = li ? Bt(li) : ii,
  ni = {}
;(ni['[object Arguments]'] =
  ni['[object Array]'] =
  ni['[object ArrayBuffer]'] =
  ni['[object DataView]'] =
  ni['[object Boolean]'] =
  ni['[object Date]'] =
  ni['[object Float32Array]'] =
  ni['[object Float64Array]'] =
  ni['[object Int8Array]'] =
  ni['[object Int16Array]'] =
  ni['[object Int32Array]'] =
  ni['[object Map]'] =
  ni['[object Number]'] =
  ni['[object Object]'] =
  ni['[object RegExp]'] =
  ni['[object Set]'] =
  ni['[object String]'] =
  ni['[object Symbol]'] =
  ni['[object Uint8Array]'] =
  ni['[object Uint8ClampedArray]'] =
  ni['[object Uint16Array]'] =
  ni['[object Uint32Array]'] =
    !0),
  (ni['[object Error]'] = ni['[object Function]'] = ni['[object WeakMap]'] = !1)
var ai = function t(e, i, l, s, n, a) {
  var c,
    d = 1 & i,
    r = 2 & i,
    o = 4 & i
  if ((l && (c = n ? l(e, s, n, a) : l(e)), void 0 !== c)) return c
  if (!M(e)) return e
  var m = Ft(e)
  if (m) {
    if (((c = Me(e)), !d)) return be(e, c)
  } else {
    var u = Te(e),
      b = '[object Function]' == u || '[object GeneratorFunction]' == u
    if (kt(e)) return ue(e, d)
    if ('[object Object]' == u || '[object Arguments]' == u || (b && !n)) {
      if (((c = r || b ? {} : qe(e)), !d)) return r ? Le(e, me(c, e)) : Ge(e, ae(c, e))
    } else {
      if (!ni[u]) return n ? e : {}
      c = Qe(e, u, d)
    }
  }
  a || (a = new St())
  var h = a.get(e)
  if (h) return h
  a.set(e, c),
    si(e)
      ? e.forEach(function (s) {
          c.add(t(s, i, l, s, e, a))
        })
      : ei(e) &&
        e.forEach(function (s, n) {
          c.set(n, t(s, i, l, n, e, a))
        })
  var Z = o ? (r ? Re : Ie) : r ? keysIn : ne,
    p = m ? void 0 : Z(e)
  return (
    It(p || e, function (s, n) {
      p && (s = e[(n = s)]), gt(c, n, t(s, i, l, n, e, a))
    }),
    c
  )
}
var ci = function (t) {
  return ai(t, 5)
}
var di = function (t) {
  return this.__data__.set(t, '__lodash_hash_undefined__'), this
}
var ri = function (t) {
  return this.__data__.has(t)
}
function oi(t) {
  var e = -1,
    i = null == t ? 0 : t.length
  for (this.__data__ = new Vt(); ++e < i; ) this.add(t[e])
}
;(oi.prototype.add = oi.prototype.push = di), (oi.prototype.has = ri)
var mi = oi
var ui = function (t, e) {
  for (var i = -1, l = null == t ? 0 : t.length; ++i < l; ) if (e(t[i], i, t)) return !0
  return !1
}
var bi = function (t, e) {
  return t.has(e)
}
var hi = function (t, e, i, l, s, n) {
  var a = 1 & i,
    c = t.length,
    d = e.length
  if (c != d && !(a && d > c)) return !1
  var r = n.get(t)
  if (r && n.get(e)) return r == e
  var o = -1,
    m = !0,
    u = 2 & i ? new mi() : void 0
  for (n.set(t, e), n.set(e, t); ++o < c; ) {
    var b = t[o],
      h = e[o]
    if (l) var Z = a ? l(h, b, o, e, t, n) : l(b, h, o, t, e, n)
    if (void 0 !== Z) {
      if (Z) continue
      m = !1
      break
    }
    if (u) {
      if (
        !ui(e, function (t, e) {
          if (!bi(u, e) && (b === t || s(b, t, i, l, n))) return u.push(e)
        })
      ) {
        m = !1
        break
      }
    } else if (b !== h && !s(b, h, i, l, n)) {
      m = !1
      break
    }
  }
  return n.delete(t), n.delete(e), m
}
var Zi = function (t) {
  var e = -1,
    i = Array(t.size)
  return (
    t.forEach(function (t, l) {
      i[++e] = [l, t]
    }),
    i
  )
}
var pi = function (t) {
    var e = -1,
      i = Array(t.size)
    return (
      t.forEach(function (t) {
        i[++e] = t
      }),
      i
    )
  },
  yi = g ? g.prototype : void 0,
  Xi = yi ? yi.valueOf : void 0
var Gi = function (t, e, i, l, s, n, a) {
    switch (i) {
      case '[object DataView]':
        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1
        ;(t = t.buffer), (e = e.buffer)
      case '[object ArrayBuffer]':
        return !(t.byteLength != e.byteLength || !n(new ke(t), new ke(e)))
      case '[object Boolean]':
      case '[object Date]':
      case '[object Number]':
        return o(+t, +e)
      case '[object Error]':
        return t.name == e.name && t.message == e.message
      case '[object RegExp]':
      case '[object String]':
        return t == e + ''
      case '[object Map]':
        var c = Zi
      case '[object Set]':
        var d = 1 & l
        if ((c || (c = pi), t.size != e.size && !d)) return !1
        var r = a.get(t)
        if (r) return r == e
        ;(l |= 2), a.set(t, e)
        var m = hi(c(t), c(e), l, s, n, a)
        return a.delete(t), m
      case '[object Symbol]':
        if (Xi) return Xi.call(t) == Xi.call(e)
    }
    return !1
  },
  Wi = Object.prototype.hasOwnProperty
var Vi = function (t, e, i, l, s, n) {
    var a = 1 & i,
      c = Ie(t),
      d = c.length
    if (d != Ie(e).length && !a) return !1
    for (var r = d; r--; ) {
      var o = c[r]
      if (!(a ? o in e : Wi.call(e, o))) return !1
    }
    var m = n.get(t)
    if (m && n.get(e)) return m == e
    var u = !0
    n.set(t, e), n.set(e, t)
    for (var b = a; ++r < d; ) {
      var h = t[(o = c[r])],
        Z = e[o]
      if (l) var p = a ? l(Z, h, o, e, t, n) : l(h, Z, o, t, e, n)
      if (!(void 0 === p ? h === Z || s(h, Z, i, l, n) : p)) {
        u = !1
        break
      }
      b || (b = 'constructor' == o)
    }
    if (u && !b) {
      var y = t.constructor,
        X = e.constructor
      y != X &&
        'constructor' in t &&
        'constructor' in e &&
        !('function' == typeof y && y instanceof y && 'function' == typeof X && X instanceof X) &&
        (u = !1)
    }
    return n.delete(t), n.delete(e), u
  },
  Yi = Object.prototype.hasOwnProperty
var Li = function (t, e, i, l, s, n) {
  var a = Ft(t),
    c = Ft(e),
    d = a ? '[object Array]' : Te(t),
    r = c ? '[object Array]' : Te(e),
    o = '[object Object]' == (d = '[object Arguments]' == d ? '[object Object]' : d),
    m = '[object Object]' == (r = '[object Arguments]' == r ? '[object Object]' : r),
    u = d == r
  if (u && kt(t)) {
    if (!kt(e)) return !1
    ;(a = !0), (o = !1)
  }
  if (u && !o)
    return n || (n = new St()), a || Qt(t) ? hi(t, e, i, l, s, n) : Gi(t, e, d, i, l, s, n)
  if (!(1 & i)) {
    var b = o && Yi.call(t, '__wrapped__'),
      h = m && Yi.call(e, '__wrapped__')
    if (b || h) {
      var Z = b ? t.value() : t,
        p = h ? e.value() : e
      return n || (n = new St()), s(Z, p, i, l, n)
    }
  }
  return !!u && (n || (n = new St()), Vi(t, e, i, l, s, n))
}
var Si = function t(e, i, l, s, n) {
  return (
    e === i ||
    (null == e || null == i || (!Nt(e) && !Nt(i)) ? e != e && i != i : Li(e, i, l, s, t, n))
  )
}
var Ii,
  Ri,
  fi,
  xi,
  gi,
  Ki = function (t, e) {
    return Si(t, e)
  },
  Ji = I(function (t) {
    !(function () {
      var i,
        l,
        s,
        n = 0,
        a = []
      for (l = 0; l < 256; l++) a[l] = (l + 256).toString(16).substr(1)
      function c() {
        var t,
          e =
            ((t = 16),
            (!i || n + t > d.BUFFER_SIZE) && ((n = 0), (i = d.randomBytes(d.BUFFER_SIZE))),
            i.slice(n, (n += t)))
        return (e[6] = (15 & e[6]) | 64), (e[8] = (63 & e[8]) | 128), e
      }
      function d() {
        var t = c()
        return (
          a[t[0]] +
          a[t[1]] +
          a[t[2]] +
          a[t[3]] +
          '-' +
          a[t[4]] +
          a[t[5]] +
          '-' +
          a[t[6]] +
          a[t[7]] +
          '-' +
          a[t[8]] +
          a[t[9]] +
          '-' +
          a[t[10]] +
          a[t[11]] +
          a[t[12]] +
          a[t[13]] +
          a[t[14]] +
          a[t[15]]
        )
      }
      ;(d.BUFFER_SIZE = 4096),
        (d.bin = c),
        (d.clearBuffer = function () {
          ;(i = null), (n = 0)
        }),
        (d.test = function (t) {
          return (
            'string' == typeof t &&
            /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(t)
          )
        }),
        'undefined' != typeof crypto
          ? (s = crypto)
          : 'undefined' != typeof window && void 0 !== window.msCrypto && (s = window.msCrypto),
        (s = s || e),
        (t.exports = d),
        (d.randomBytes = (function () {
          if (s) {
            if (s.randomBytes) return s.randomBytes
            if (s.getRandomValues)
              return function (t) {
                var e = new Uint8Array(t)
                return s.getRandomValues(e), e
              }
          }
          return function (t) {
            var e,
              i = []
            for (e = 0; e < t; e++) i.push(Math.floor(256 * Math.random()))
            return i
          }
        })())
    })()
  }),
  Ni = (function (t) {
    function e(e, i, l) {
      return l ? t.call(this, e, i, l) || this : t.call(this, e, i) || this
    }
    return (
      s(e, t),
      (e.fromPosition = function (t) {
        return 2 === t.length ? new e(t[0], t[1]) : t.length > 2 ? new e(t[0], t[1], t[2]) : null
      }),
      (e.areEqual = function (t, e, i) {
        if ((void 0 === i && (i = 6), t && t.length >= 2 && e && e.length >= 2)) {
          var l = Math.pow(10, i),
            s = Ei(t[1]),
            n = Ei(e[1]),
            a = Di(t[0]),
            c = Di(e[0])
          if (0 !== Math.round((s - n) * l) / l) return !1
          var d = Math.round((a - c) * l) / l
          return 0 === d || 360 === d
        }
        return !1
      }),
      (e.fromLatLng = function (t, e, i) {
        var l = []
        if ('number' == typeof t)
          l.push(t), 'number' == typeof e && l.push(e), 'number' == typeof i && l.push(i)
        else if (Array.isArray(t))
          t.length >= 2 &&
            'number' == typeof t[0] &&
            'number' == typeof t[1] &&
            (t.length >= 3 && 'number' == typeof t[2]
              ? l.push(t[0], t[1], t[2])
              : l.push(t[0], t[1]))
        else if ('object' == typeof t) {
          var s = ['lat', 'latitude', 'y'],
            n = ['lng', 'longitude', 'lon', 'x'],
            a = ['elv', 'elevation', 'alt', 'altitude', 'z'],
            c = NaN,
            d = NaN,
            r = NaN
          Object.keys(t).forEach(function (e, i, l) {
            var o = e.toLowerCase()
            isNaN(c) && s.indexOf(o) >= 0 && 'number' == typeof t[e]
              ? (c = t[e])
              : isNaN(d) && n.indexOf(o) >= 0 && 'number' == typeof t[e]
              ? (d = t[e])
              : isNaN(r) && a.indexOf(o) >= 0 && 'number' == typeof t[e] && (r = t[e])
          }),
            isNaN(c) || isNaN(d) || (l.push(d, c), isNaN(r) || l.push(r))
        }
        return l.length >= 2 ? l : null
      }),
      (e.fromLatLngs = function (t) {
        var i = []
        if (Array.isArray(t))
          for (var l = 0, s = t.length; l < s; l++) {
            var n = e.fromLatLng(t[l])
            n && i.push(n)
          }
        return i
      }),
      (e._getDimensions = function (t) {
        for (var e = 0; Array.isArray(t); ) (t = t[0]), e++
        return 'number' == typeof t && e--, e
      }),
      e
    )
  })(Array),
  zi = (function (t) {
    function e(e, i) {
      var l = this
      if (e && i) {
        var s = e
        l =
          s[2] && i[2]
            ? t.call(this, s[0], s[1], s[2] || 0, i[0], i[1], i[2] || 0) || this
            : t.call(this, s[0], s[1], i[0], i[1]) || this
      } else if (e) {
        var n = e
        n &&
          (4 === n.length
            ? (l = t.call(this, n[0], n[1], n[2], n[3]) || this)
            : n.length >= 6 && (l = t.call(this, n[0], n[1], n[2], n[3], n[4], n[5]) || this))
      }
      return l
    }
    return (
      s(e, t),
      (e.fromBoundingBox = function (t) {
        var i = e.getWest(t),
          l = e.getSouth(t),
          s = e.getEast(t),
          n = e.getNorth(t)
        return new e([i, l, s, n])
      }),
      (e.fromDimensions = function (t, i, l) {
        var s = t[0],
          n = t[1],
          a = Math.min(Math.max(n + l / 2, -85.5), 85.5),
          c = Math.min(Math.max(n - l / 2, -85.5), 85.5),
          d = Di(s + i / 2)
        return new e([Di(s - i / 2), c, d, a])
      }),
      (e.fromEdges = function (t, i, l, s) {
        return new e([t, i, l, s])
      }),
      (e.containsPosition = function (t, i) {
        var l = e.getCenter(t),
          s = Math.abs(l[1] - i[1]),
          n = Math.abs(l[0] - i[0])
        n > 180 && (n = 360 - n)
        var a = e.getHeight(t),
          c = e.getWidth(t)
        return s <= a / 2 + 1e-8 && n <= c / 2 + 1e-8
      }),
      (e.crossesAntimeridian = function (t) {
        return Di(e.getEast(t)) - Di(e.getWest(t)) < 0
      }),
      (e.getCenter = function (t) {
        var i = Di(e.getEast(t)),
          l = Di(e.getWest(t))
        l > i && (i += 360)
        var s = Di((l + i) / 2),
          n = Ei(e.getSouth(t)),
          a = Ei(e.getNorth(t))
        return [s, Ei((n + a) / 2)]
      }),
      (e.getHeight = function (t) {
        var i = Ei(e.getNorth(t)) - Ei(e.getSouth(t))
        return isNaN(i) ? 0 : i
      }),
      (e.getWidth = function (t) {
        var i = Di(e.getEast(t)) - Di(e.getWest(t))
        return isNaN(i) ? 0 : i < 0 ? (i += 360) : i
      }),
      (e.getSouthWest = function (t) {
        var e = this.getSouth(t),
          i = this.getWest(t)
        return isNaN(e) || isNaN(i) ? null : [i, e]
      }),
      (e.getNorthEast = function (t) {
        var e = this.getNorth(t),
          i = this.getEast(t)
        return isNaN(e) || isNaN(i) ? null : [i, e]
      }),
      (e.getNorthWest = function (t) {
        var e = this.getNorth(t),
          i = this.getWest(t)
        return isNaN(e) || isNaN(i) ? null : [i, e]
      }),
      (e.getSouthEast = function (t) {
        var e = this.getSouth(t),
          i = this.getEast(t)
        return isNaN(e) || isNaN(i) ? null : [i, e]
      }),
      (e.getSouth = function (t) {
        return t && t.length >= 4 ? Number(t[1]) : NaN
      }),
      (e.getWest = function (t) {
        return t && t.length >= 4 ? Number(t[0]) : NaN
      }),
      (e.getNorth = function (t) {
        if (t) {
          if (4 === t.length) return Number(t[3])
          if (6 === t.length) return Number(t[4])
        }
        return NaN
      }),
      (e.getEast = function (t) {
        if (t) {
          if (4 === t.length) return Number(t[2])
          if (6 === t.length) return Number(t[3])
        }
        return NaN
      }),
      (e.intersect = function (t, i) {
        var l = e.getCenter(t),
          s = e.getCenter(i),
          n = Math.abs(l[1] - s[1]),
          a = Math.abs(l[0] - s[0])
        a > 180 && (a = 360 - a)
        var c = e.getHeight(t),
          d = e.getWidth(t),
          r = e.getHeight(i),
          o = e.getWidth(i)
        return n <= c / 2 + r / 2 && a <= d / 2 + o / 2
      }),
      (e.merge = function (t, i) {
        var l = t && 4 === t.length,
          s = i && 4 === i.length
        if (l && !s) return t
        if (s && !l) return i
        if (!l && !s) return null
        var n = Math.max(Ei(e.getNorth(t)), Ei(e.getNorth(i))),
          a = Math.min(Ei(e.getSouth(t)), Ei(e.getSouth(i))),
          c = [t, i],
          d = [],
          r = 0
        for (r = 0; r < c.length; r++) {
          var o = c[r],
            m = Di(e.getWest(o)),
            u = Di(e.getEast(o))
          e.crossesAntimeridian(o) ? (d.push([m, 180]), d.push([-180, u])) : d.push([m, u])
        }
        d.sort(function (t, e) {
          return t[0] === e[0] ? t[1] - e[1] : t[0] - e[0]
        })
        var b = [],
          h = d[0]
        for (r = 1; r < d.length; ) {
          var Z = d[r]
          h[1] >= Z[0] ? (h[1] = Math.max(h[1], Z[1])) : (b.push(h), (h = Z)), r++
        }
        b.push(h)
        var p = b.length,
          y = b[0][0] + 360 - b[p - 1][1],
          X = [b[p - 1][1], b[0][0]]
        for (r = 1; r < p; r++) {
          var G = b[r][0] - b[r - 1][1]
          G > y && ((y = G), (X = [b[r - 1][1], b[r][0]]))
        }
        return new e([X[1], a], [X[0], n])
      }),
      (e.fromPositions = function (t) {
        for (
          var i, l = NaN, s = NaN, n = NaN, a = NaN, c = t.length, d = new Array(c), r = 0;
          c--;

        )
          if ((i = t[c]) && i.length >= 2) {
            var o = Ei(i[1])
            ;(l = isNaN(l) ? o : Math.max(l, o)),
              (s = isNaN(s) ? o : Math.min(s, o)),
              (d[r++] = Di(i[0]))
          }
        if (r) {
          ;(d.length = r),
            d.sort(function (t, e) {
              return t - e
            })
          var m = d[0] + 360 - d[r - 1],
            u = 0
          for (c = 1; c < r; c++) {
            var b = d[c] - d[c - 1]
            b > m && ((m = b), (u = c))
          }
          ;(n = d[u]), (a = d[(u || r) - 1])
        }
        return isNaN(n) || isNaN(s) || isNaN(a) || isNaN(l) ? null : new e([n, s, a, l])
      }),
      (e.fromLatLngs = function (t) {
        return e.fromPositions(Ni.fromLatLngs(t))
      }),
      (e.fromData = function (t) {
        var i,
          l = null
        if (Array.isArray(t) && t.length > 0) {
          for (var s = 0, n = t; s < n.length; s++) {
            var a = n[s]
            null != (i = e.fromData(a)) && (l = null === l ? i : e.merge(l, i))
          }
          return l
        }
        if (t instanceof Fi) return t.getBounds()
        if (t && t.type) {
          var c = t
          if (c.bbox && 4 === c.bbox.length) return c.bbox
          switch (c.type) {
            case 'FeatureCollection':
              return e.fromData(c.features)
            case 'Feature':
              return Fi._isCircle(c)
                ? e.fromPositions(Fi._getCirclePositions(c))
                : e.fromData(c.geometry)
            case 'GeometryCollection':
              return e.fromData(c.geometries)
            case 'Point':
              var d = c.coordinates
              if (d && d.length >= 2) return [d[0], d[1], d[0], d[1]]
              break
            case 'LineString':
            case 'MultiPoint':
              return e.fromPositions(c.coordinates)
            case 'Polygon':
            case 'MultiLineString':
              var r = c.coordinates
              if (r && r.length > 0) {
                for (var o = 0, m = r.length; o < m; o++)
                  null != (i = e.fromPositions(r[o])) && (l = null === l ? i : e.merge(l, i))
                if (null != l) return l
              }
              break
            case 'MultiPolygon':
              var u = c.coordinates
              if (u && u.length > 0) {
                for (o = 0, m = u.length; o < m; o++)
                  for (var b = 0, h = u[o].length; b < h; b++)
                    null != (i = e.fromPositions(u[o][b])) && (l = null === l ? i : e.merge(l, i))
                return l
              }
          }
        }
        return null
      }),
      (e.splitOnAntimeridian = function (t) {
        var i = []
        if (e.crossesAntimeridian(t)) {
          var l = void 0,
            s = void 0,
            n = Di(e.getWest(t)),
            a = Di(e.getEast(t)),
            c = Ei(e.getNorth(t)),
            d = Ei(e.getSouth(t))
          t.length >= 6
            ? ((l = new e([n, d, t[2], 180, c, t[5]])), (s = new e([-180, d, t[2], a, c, t[5]])))
            : ((l = new e([n, d, 180, c])), (s = new e([-180, d, a, c]))),
            i.push(l, s)
        } else i.push(new e(t))
        return i
      }),
      e
    )
  })(Array),
  vi = (function () {
    function t(e, i, l, s) {
      ;(this.type = 'Feature'),
        (this.type = t.TYPE),
        (this.properties = i || {}),
        (this.id = l),
        (this.geometry = e),
        (this.bbox = s)
    }
    return (t.TYPE = 'Feature'), t
  })(),
  Hi = (function () {
    function t(e, i) {
      ;(this.type = 'Polygon'),
        (this.type = t.TYPE),
        1 === Ni._getDimensions(e) ? (this.coordinates = [e]) : (this.coordinates = e),
        (this.bbox = i)
    }
    return (t.TYPE = 'Polygon'), t
  })(),
  wi = Map,
  Ti = (function () {
    function t() {
      this.listeners = new wi()
    }
    return (
      (t.prototype._addEventListener = function (t, e, i) {
        this.listeners.has(t) || this.listeners.set(t, new wi()), this.listeners.get(t).set(e, i)
      }),
      (t.prototype._removeEventListener = function (t, e) {
        this.listeners.has(t) && this.listeners.get(t).delete(e)
      }),
      (t.prototype._invokeEvent = function (t, e) {
        var i = this
        this.listeners.has(t) &&
          this.listeners.get(t).forEach(function (l, s) {
            l && i._removeEventListener(t, s)
            try {
              s(e)
            } catch (t) {
              console.error(t)
            }
          })
      }),
      t
    )
  })(),
  Fi = (function (t) {
    function e(i, l, s) {
      var n,
        a = t.call(this) || this
      if ('Feature' === i.type) {
        var c = i
        ;(n = ci(c.geometry)),
          (s = c.properties ? ci(c.properties) : {}),
          (l = null == c.id || '' === c.id ? Ji() : c.id)
      } else (n = ci(i)), (l = null == l || '' === l ? Ji() : l), (s = s ? ci(s) : {})
      return (s[e._shapeIdPropName] = l), (a.data = new vi(n, s, l)), a._handleCircle(), a
    }
    return (
      s(e, t),
      (e.prototype.addProperty = function (t, e) {
        Ki(this.data.properties[t], e) ||
          ((this.data.properties[t] = ci(e)),
          ('subType' !== t && 'radius' !== t) || this._handleCircle(),
          this.dataSource && this.dataSource._updateSource(),
          this._invokeEvent('shapechanged', this))
      }),
      (e.prototype.getBounds = function () {
        var t,
          e = this.getCoordinates(),
          i = this.getType()
        if ('Point' === i)
          if (this.circlePolygon) {
            var l = this.circlePolygon.geometry.coordinates
            t = zi.fromPositions(l[0])
          } else {
            t = new zi((l = e), l)
          }
        else if ('MultiPoint' === i || 'LineString' === i) {
          l = e
          t = zi.fromPositions(l)
        } else if ('Polygon' === i) {
          l = e
          t = zi.fromPositions(l[0])
        } else if ('MultiLineString' === i)
          for (var s = 0, n = (l = e); s < n.length; s++) {
            var a = n[s]
            t = zi.merge(t, zi.fromPositions(a))
          }
        else if ('MultiPolygon' === i)
          for (var c = 0, d = (l = e); c < d.length; c++) {
            var r = d[c]
            t = zi.merge(t, zi.fromPositions(r[0]))
          }
        return t
      }),
      (e.prototype.getCoordinates = function () {
        return ci(this.data.geometry.coordinates)
      }),
      (e.prototype.getCircleCoordinates = function () {
        return this.circlePolygon ? ci(this.circlePolygon.geometry.coordinates[0]) : null
      }),
      (e.prototype.getId = function () {
        return this.data.id
      }),
      (e.prototype.getProperties = function () {
        return ci(this.data.properties)
      }),
      (e.prototype.getType = function () {
        return this.data.geometry.type
      }),
      (e.prototype.isCircle = function () {
        return e._isCircle(this.data)
      }),
      (e.prototype.isRectangle = function () {
        return e._isRectangle(this.data)
      }),
      (e.prototype.setCoordinates = function (t) {
        var e
        ;(e = 'Polygon' === this.getType() && 1 === Ni._getDimensions(t) ? [t] : t),
          Ki(this.data.geometry.coordinates, e) ||
            ((this.data.geometry.coordinates = ci(e)),
            this._handleCircle(),
            this.dataSource && this.dataSource._updateSource(),
            this._invokeEvent('shapechanged', this))
      }),
      (e.prototype.setProperties = function (t) {
        ;(t[e._shapeIdPropName] = this.data.id),
          Ki(this.data.properties, t) ||
            ((this.data.properties = ci(t)),
            this._handleCircle(),
            this.dataSource && this.dataSource._updateSource(),
            this._invokeEvent('shapechanged', this))
      }),
      (e.prototype.toJson = function () {
        return JSON.parse(JSON.stringify(this.data))
      }),
      (e.prototype._toJson = function () {
        return this.circlePolygon || this.data
      }),
      (e.prototype._setDataSource = function (t) {
        void 0 === t || null == t ? delete this.dataSource : (this.dataSource = t)
      }),
      (e.prototype._handleCircle = function () {
        if (this.isCircle()) {
          var t = e._getCirclePositions(this.data)
          ;(this.circlePolygon = new vi(new Hi([t]), this.data.properties, this.data.id)),
            (this.data.properties.subType = 'Circle')
        } else delete this.circlePolygon
      }),
      (e._isCircle = function (t) {
        return (
          t &&
          t.geometry &&
          'Point' === t.geometry.type &&
          t.geometry.coordinates &&
          t.properties &&
          'string' == typeof t.properties.subType &&
          'circle' === t.properties.subType.toLowerCase() &&
          'number' == typeof t.properties.radius
        )
      }),
      (e._isRectangle = function (t) {
        if (
          'Polygon' === t.geometry.type &&
          t.geometry.coordinates &&
          'string' == typeof t.properties.subType &&
          'rectangle' === t.properties.subType.toLowerCase()
        ) {
          var e = t.geometry.coordinates
          if (1 === e.length) {
            var i = e[0]
            if (5 === i.length) return i[0][0] === i[4][0] && i[0][1] === i[4][1]
            if (4 === i.length) return !0
          }
        }
        return !1
      }),
      (e._getCirclePositions = function (t) {
        return (function (t, e, i, l, s) {
          ;(l = l || 'meters'), (s = s || 0), (t = _i(t))
          for (var n = [], a = 360 / i, c = 0; c <= i; c++) n.push(Bi(t, (c * a + s) % 360, e, l))
          return n
        })(t.geometry.coordinates, t.properties.radius, 72, 'meters')
      }),
      (e._shapeIdPropName = '_azureMapsShapeId'),
      e
    )
  })(Ti),
  Mi = Math.PI / 180,
  ki = 180 / Math.PI,
  Ui = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9]
function Pi(t) {
  return t * Mi
}
function Ci(t) {
  return t * ki
}
function ji(t) {
  if (t)
    switch (t.toLowerCase()) {
      case 'feet':
      case 'foot':
      case 'ft':
        return Ri.feet
      case 'kilometers':
      case 'kilometer':
      case 'kilometres':
      case 'kilometre':
      case 'km':
      case 'kms':
        return Ri.kilometers
      case 'miles':
      case 'mile':
      case 'mi':
        return Ri.miles
      case 'nauticalmiles':
      case 'nauticalmile':
      case 'nms':
      case 'nm':
        return Ri.nauticalMiles
      case 'yards':
      case 'yard':
      case 'yds':
      case 'yrd':
      case 'yrds':
        return Ri.yards
      case 'meters':
      case 'metres':
      case 'm':
      default:
        return Ri.meters
    }
  return Ri.meters
}
function Oi(t, e) {
  if (!isNaN(t) && 'number' == typeof e && e >= 0) {
    var i = void 0
    ;(i = e < Ui.length ? Ui[e] : Math.pow(10, e)), (t = Math.round(t * i) / i)
  }
  return t
}
function Bi(t, e, i, l) {
  ;(l = l || 'meters'), (t = _i(t))
  var s,
    n,
    a,
    c = (function (t) {
      var e = ji(t)
      return (function (t, e, i, l) {
        switch (ji(e)) {
          case Ri.meters:
            t /= 1e3
            break
          case Ri.feet:
            t /= 3280.8399
            break
          case Ri.miles:
            t /= 0.62137119
            break
          case Ri.yards:
            t /= 1093.6133
            break
          case Ri.nauticalMiles:
            t /= 0.5399568
            break
          case Ri.kilometers:
        }
        switch (ji(i)) {
          case Ri.meters:
            t *= 1e3
            break
          case Ri.feet:
            t *= 3280.8399
            break
          case Ri.miles:
            t *= 0.62137119
            break
          case Ri.yards:
            t *= 1093.6133
            break
          case Ri.nauticalMiles:
            t *= 0.5399568
            break
          case Ri.kilometers:
        }
        if ('number' == typeof l && l >= 0) {
          var s = Math.pow(10, l)
          t = Math.round(t * s) / s
        }
        return t
      })(6378137, Ri.meters, e)
    })(l),
    d = Pi(t[1]),
    r = Pi(t[0]),
    o = Pi(e),
    m = i / c,
    u = Math.asin(Math.sin(d) * Math.cos(m) + Math.cos(d) * Math.sin(m) * Math.cos(o)),
    b =
      r +
      Math.atan2(Math.sin(o) * Math.sin(m) * Math.cos(d), Math.cos(m) - Math.sin(d) * Math.sin(u)),
    h = ((s = Ei(Ci(u))), (n = -85), (a = 85), Math.min(Math.max(s, n), a))
  return [Di(Ci(b)), h]
}
function Ei(t) {
  return t > 90
    ? (t = (t + 90) % 360) > 180
      ? 90 - (t - 180)
      : t - 90
    : t < -90
    ? (t = (t - 90) % 360) < -180
      ? -90 - (t + 180)
      : t + 90
    : t
}
function Di(t) {
  return t > 180 ? ((t + 180) % 360) - 180 : t < -180 ? ((t - 180) % 360) + 180 : t
}
function Qi(t) {
  if ('[object Date]' === Object.prototype.toString.call(t)) return t
  if ('string' == typeof t) {
    var e = Date.parse(t)
    if (!isNaN(e)) return new Date(e)
    if (t.indexOf('Date(') >= 0) {
      var i = 0
      return (
        (i =
          (t = t.replace('/Date(', '').replace(')/', '')).indexOf('+') > 0
            ? parseInt(t.substr(0, t.indexOf('+')), 10)
            : t.indexOf('-') > 0
            ? parseInt(t.substr(0, t.indexOf('-')), 10)
            : parseInt(t, 10)),
        new Date(i)
      )
    }
  } else if ('number' == typeof t) return new Date(t)
  return null
}
function _i(t) {
  if (Array.isArray(t) && 'number' == typeof t[0]) return t
  if (t.type) {
    if ('Point' === t.type) return t.coordinates
    if ('Feature' === t.type && 'Point' === t.geometry.type) return t.geometry.coordinates
  } else if (t instanceof Fi && 'Point' === t.getType()) return t.getCoordinates()
  return null
}
!(function (t) {
  ;(t.squareMeters = 'squareMeters'),
    (t.acres = 'acres'),
    (t.hectares = 'hectares'),
    (t.squareFeet = 'squareFeet'),
    (t.squareKilometers = 'squareKilometers'),
    (t.squareMiles = 'squareMiles'),
    (t.squareYards = 'squareYards')
})(Ii || (Ii = {})),
  (function (t) {
    ;(t.meters = 'meters'),
      (t.kilometers = 'kilometers'),
      (t.feet = 'feet'),
      (t.miles = 'miles'),
      (t.nauticalMiles = 'nauticalMiles'),
      (t.yards = 'yards')
  })(Ri || (Ri = {})),
  (function (t) {
    ;(t.seconds = 'seconds'),
      (t.hours = 'hours'),
      (t.ms = 'ms'),
      (t.minutes = 'minutes'),
      (t.days = 'days')
  })(fi || (fi = {})),
  (function (t) {
    ;(t.metersPerSecond = 'metersPerSecond'),
      (t.kilometersPerHour = 'kilometersPerHour'),
      (t.feetPerSecond = 'feetPerSecond'),
      (t.milesPerHour = 'milesPerHour'),
      (t.knots = 'knots'),
      (t.mach = 'mach')
  })(xi || (xi = {})),
  (function (t) {
    ;(t.milesPerSecondSquared = 'milesPerSecondSquared'),
      (t.kilometersPerSecondSquared = 'kilometersPerSecondSquared'),
      (t.knotsPerSecond = 'knotsPerSecond'),
      (t.standardGravity = 'standardGravity'),
      (t.feetPerSecondSquared = 'feetPerSecondSquared'),
      (t.yardsPerSecondSquared = 'yardsPerSecondSquared'),
      (t.milesPerHourSecond = 'milesPerHourSecond'),
      (t.kilometersPerHourSecond = 'kilometersPerHourSecond'),
      (t.metersPerSecondSquared = 'metersPerSecondSquared')
  })(gi || (gi = {}))
!(function () {
  function t(e, i) {
    ;(this.M = t._calculateAffineTransform(e, i)),
      (this.inverseM = t._calculateAffineTransform(i, e))
  }
  ;(t.prototype.toTarget = function (t, e) {
    if (void 0 !== typeof t) return this.transformArray(t, this.M, e)
    throw new Error('Invalid sourcePoints specified.')
  }),
    (t.prototype.toSource = function (t, e) {
      if (void 0 !== typeof t) return this.transformArray(t, this.inverseM, e)
      throw new Error('Invalid targetPoints specified.')
    }),
    (t.prototype.transformArray = function (t, e, i) {
      if (t && Array.isArray(t) && Array.isArray(t[0])) {
        for (var l = [], s = 0, n = t; s < n.length; s++) {
          var a = n[s]
          l.push(this.transform(a, e, i))
        }
        return l
      }
      return null
    }),
    (t.prototype.transform = function (t, e, i) {
      var l = t[0] * e[0][3] + t[1] * e[1][3] + e[2][3],
        s = t[0] * e[0][4] + t[1] * e[1][4] + e[2][4]
      return 'number' == typeof i && i >= 0 ? [Oi(l, i), Oi(s, i)] : [Oi(l, 6), Oi(s, 6)]
    }),
    (t._calculateAffineTransform = function (t, e) {
      if (t.length !== e.length || t.length < 1)
        throw new Error('Error: source and target arrays must have the same length.')
      var i = Math.min(t[0].length, e[0].length),
        l = i + 1
      if (t.length < i) throw new Error('Erorr: At least ' + i + ' reference points required.')
      for (var s = [], n = [], a = 0; a < l; a++) {
        n[a] = []
        for (var c = 0; c < l; c++) {
          c < i && (s[c] = 0), (n[a][c] = 0)
          for (var d = 0; d < t.length; d++)
            c < i && (s[c] += a < i ? t[d][a] * e[d][c] : e[d][c]),
              (n[a][c] +=
                a >= i && c >= i ? 1 : a >= i ? t[d][c] : c >= i ? t[d][a] : t[d][a] * t[d][c])
        }
        n[a] = n[a].concat(s)
      }
      if (!this._gaussJordanElimination(n))
        throw new Error('Error: Singular matrix. Points are likely coplanar.')
      return n
    }),
    (t._gaussJordanElimination = function (t) {
      for (var e, i, l = t.length, s = 2 * l - 1, n = 0; n < l; n++) {
        for (var a = n, c = n + 1; c < l; c++) Math.abs(t[c][n]) > Math.abs(t[a][n]) && (a = c)
        if (((i = t[a]), (t[a] = t[n]), (t[n] = i), Math.abs(t[n][n]) <= 1e-10)) return !1
        for (var d = n + 1; d < l; d++) {
          e = t[d][n] / t[n][n]
          for (var r = n; r < s; r++) t[d][r] -= t[n][r] * e
        }
      }
      for (n = l - 1; n > -1; n--) {
        e = t[n][n]
        for (c = 0; c < n; c++)
          for (var o = s - 1; o > n - 1; o--) t[c][o] -= (t[n][o] * t[c][n]) / e
        t[n][n] /= e
        for (var m = l; m < s; m++) t[n][m] /= e
      }
      return !0
    })
})()
var Ai = (function () {
    function t() {
      ;(this.type = 'FeatureCollection'),
        (this.bbox = null),
        (this.features = []),
        (this.groundOverlays = []),
        (this.properties = {}),
        (this.stats = null),
        (this.icons = {}),
        (this._groundOverlayOptions = [])
    }
    return (
      (t.enrich = function (e) {
        if (
          (e.properties &&
            !e.properties.title &&
            e.properties.name &&
            (e.properties.title = e.properties.name),
          t.getBounds(e),
          !e.stats)
        )
          try {
            t.computeStats(e)
          } catch (t) {
            e.stats = {}
          }
      }),
      (t.merge = function (e, i) {
        if (i) {
          e.properties
            ? i.properties ||
              Object.keys(i.properties).forEach(function (t) {
                e.properties[t] || 'bounds' === t || (e.properties[t] = i.properties[t])
              })
            : (e.properties = i.properties),
            i.features &&
              i.features.length > 0 &&
              (e.features && e.features.length > 0
                ? (e.features = e.features.concat(i.features))
                : (e.features = i.features)),
            i._groundOverlayOptions &&
              i._groundOverlayOptions.length > 0 &&
              (e._groundOverlayOptions && e._groundOverlayOptions.length > 0
                ? (e._groundOverlayOptions = e._groundOverlayOptions.concat(
                    i._groundOverlayOptions
                  ))
                : (e._groundOverlayOptions = i._groundOverlayOptions)),
            i.groundOverlays &&
              i.groundOverlays.length > 0 &&
              (e.groundOverlays && e.groundOverlays.length > 0
                ? (e.groundOverlays = e.groundOverlays.concat(i.groundOverlays))
                : (e.groundOverlays = i.groundOverlays)),
            i.icons && (e.icons = Object.assign(e.icons || {}, i.icons)),
            i.stats &&
              (e.stats
                ? ((e.stats.numPoints += i.stats.numPoints),
                  (e.stats.numLineStrings += i.stats.numLineStrings),
                  (e.stats.numPolygons += i.stats.numPolygons),
                  (e.stats.numGroundOverlays += i.stats.numGroundOverlays),
                  (e.stats.numNetworkLinks += i.stats.numNetworkLinks),
                  (e.stats.numPositions += i.stats.numPositions),
                  (e.stats.numCharacters += i.stats.numCharacters))
                : (e.stats = i.stats))
          var l = e.bbox,
            s = i.bbox
          l || (l = t.getBounds(e)),
            s || (s = t.getBounds(e)),
            null !== l && null !== s ? (e.bbox = zi.merge(l, s)) : null !== s && (e.bbox = s),
            e.properties && e.properties.bounds && (e.properties.bounds = void 0)
        }
      }),
      (t.computeStats = function (t) {
        if (t) {
          var e = {}
          if (
            (t.stats &&
              (e = {
                numCharacters: t.stats.numCharacters || 0,
                numNetworkLinks: t.stats.numNetworkLinks || 0,
                processingTime: 0
              }),
            (t.stats = {
              numGroundOverlays: 0,
              numLineStrings: 0,
              numPoints: 0,
              numPolygons: 0,
              numPositions: 0
            }),
            Object.assign(t.stats, e),
            t._groundOverlayOptions &&
              t._groundOverlayOptions.length > 0 &&
              ((t.stats.numGroundOverlays += t._groundOverlayOptions.length),
              (t.stats.numPositions += 4 * t._groundOverlayOptions.length)),
            t.features && t.features.length > 0)
          )
            for (var i = 0, l = t.features; i < l.length; i++) {
              var s = l[i].geometry
              if (s)
                switch (s.type) {
                  case 'Point':
                    t.stats.numPoints++, t.stats.numPositions++
                    break
                  case 'LineString':
                    t.stats.numLineStrings++, (t.stats.numPositions += s.coordinates.length)
                    break
                  case 'Polygon':
                    t.stats.numPolygons++
                    for (var n = 0, a = s.coordinates; n < a.length; n++) {
                      var c = a[n]
                      t.stats.numPositions += c.length
                    }
                    break
                  case 'MultiPoint':
                    ;(t.stats.numPoints += s.coordinates.length),
                      (t.stats.numPositions += s.coordinates.length)
                    break
                  case 'MultiLineString':
                    t.stats.numLineStrings += s.coordinates.length
                    for (var d = 0, r = s.coordinates; d < r.length; d++) {
                      var o = r[d]
                      t.stats.numPositions += o.length
                    }
                    break
                  case 'MultiPolygon':
                    t.stats.numPolygons += s.coordinates.length
                    for (var m = 0, u = s.coordinates; m < u.length; m++)
                      for (var b = 0, h = u[m]; b < h.length; b++) {
                        c = h[b]
                        t.stats.numPositions += c.length
                      }
                }
            }
        }
      }),
      (t.getBounds = function (t) {
        if (t.bbox) return t.bbox
        if (t.properties && Array.isArray(t.properties.bounds)) {
          var e = t.properties.bounds
          return (t.bbox = e), e
        }
        var i = null
        if (
          (t.features && t.features.length > 0 && (i = zi.fromData(t.features)),
          t._groundOverlayOptions && t._groundOverlayOptions.length > 0)
        )
          for (var l = 0, s = t._groundOverlayOptions; l < s.length; l++) {
            var n = s[l],
              a = n.bounds
            !a && n.coordinates && (a = zi.fromPositions(n.coordinates)),
              a && (i = i ? zi.merge(i, a) : a)
          }
        return (t.bbox = i), i
      }),
      t
    )
  })(),
  qi = (function () {
    function t() {}
    return (
      (t.prototype.merge = function () {
        for (var e, i = [], l = 0; l < arguments.length; l++) i[l] = arguments[l]
        for (var s = 0, n = i; s < n.length; s++) {
          var a = n[s]
          if (a)
            for (var c in a)
              a.hasOwnProperty(c) &&
                this.hasOwnProperty(c) &&
                (void 0 !== a[c] && null != a[c]
                  ? this[c] instanceof t
                    ? this[c].merge(a[c])
                    : (this[c] = a[c])
                  : (e || (e = new (Object.getPrototypeOf(this).constructor)()), (this[c] = e[c])))
        }
        return this
      }),
      t
    )
  })(),
  $i = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (
        (e.showPointTitles = !1),
        (e.enablePopups = !0),
        (e.allowExtrusions = !0),
        (e.visible = !0),
        (e.popupTemplate = void 0),
        e
      )
    }
    return s(e, t), e
  })(qi),
  tl = (function (t) {
    function e(e, l) {
      var s = t.call(this) || this
      return (
        (s._options = {}),
        (s._popup = new i.Popup()),
        (s._dataSourceUpdated = function () {
          s.closePopup()
        }),
        (s._mouseClick = function (t) {
          if (t && t.shapes && t.shapes.length > 0) {
            for (var e = void 0, l = 0, n = t.shapes; l < n.length; l++) {
              var a = n[l]
              if (a instanceof i.Shape) {
                var c = a.getId(),
                  d = s._datasource.getShapeById(c)
                if (d) {
                  e = d
                  break
                }
              } else if ('Feature' === a.type && a.layer && a.layer.id) {
                c = a.layer.id
                if (
                  s._layers.bubbleLayer.getId() === c ||
                  s._layers.extrudedPolygonLayer.getId() === c ||
                  s._layers.lineLayer.getId() === c ||
                  s._layers.polygonLayer.getId() === c ||
                  s._layers.symbolLayer.getId() === c
                ) {
                  e = a
                  break
                }
              }
            }
            e &&
              (e instanceof i.Shape || !e.properties || !e.properties.cluster
                ? s._options.enablePopups && s._showPopup(e, t.position)
                : s._datasource
                    .getClusterExpansionZoom(e.properties.cluster_id)
                    .then(s._getZoomClusterHandler(e)))
          }
        }),
        (s._mouseEnter = function (t) {
          var e
          t &&
            t.shapes &&
            t.shapes.length > 0 &&
            !(t.shapes[0] instanceof i.Shape) &&
            (e = t.shapes[0]),
            (s._options.enablePopups || (e && e.properties.cluster)) &&
              (s.map.getCanvas().style.cursor = 'pointer')
        }),
        (s._mouseLeave = function (t) {
          0 === t.shapes.length && (s.map.getCanvas().style.cursor = '')
        }),
        (s._datasource = e),
        (s._layers = {
          bubbleLayer: new i.layer.BubbleLayer(s._datasource, null, {
            color: [
              'case',
              ['has', 'color'],
              ['get', 'color'],
              ['has', 'marker-color'],
              ['get', 'marker-color'],
              ['has', 'point_count'],
              [
                'step',
                ['get', 'point_count'],
                'rgb(181,226,140)',
                10,
                'rgb(241,211,87)',
                100,
                'rgb(253,156,115)'
              ],
              '#1A73AA'
            ],
            filter: [
              'all',
              ['!', ['has', 'image']],
              ['any', ['==', ['geometry-type'], 'Point'], ['==', ['geometry-type'], 'MultiPoint']]
            ],
            radius: [
              'case',
              ['has', 'size'],
              ['*', ['get', 'size'], 8],
              ['has', 'marker-size'],
              ['match', ['get', 'marker-size'], 'small', 6, 'medium', 8, 'large', 12, 1],
              ['has', 'scale'],
              ['*', ['get', 'scale'], 8],
              ['has', 'point_count'],
              16,
              8
            ],
            strokeColor: [
              'case',
              ['has', 'point_count'],
              [
                'step',
                ['get', 'point_count'],
                'rgba(181,226,140,0.6)',
                10,
                'rgba(241,211,87,0.6)',
                100,
                'rgba(253,156,115,0.6)'
              ],
              'white'
            ]
          }),
          extrudedPolygonLayer: new i.layer.PolygonExtrusionLayer(s._datasource, null, {
            base: ['case', ['has', 'base'], ['get', 'base'], 0],
            fillColor: [
              'case',
              ['has', 'fillColor'],
              ['get', 'fillColor'],
              ['has', 'fill'],
              ['get', 'fill'],
              '#1e90ff'
            ],
            filter: [
              'all',
              [
                'any',
                ['==', ['geometry-type'], 'Polygon'],
                ['==', ['geometry-type'], 'MultiPolygon']
              ],
              ['all', ['has', 'height'], ['!=', ['get', 'height'], 0]]
            ],
            height: ['get', 'height']
          }),
          lineLayer: new i.layer.LineLayer(s._datasource, null, {
            filter: [
              'any',
              ['==', ['geometry-type'], 'LineString'],
              ['==', ['geometry-type'], 'MultiLineString'],
              ['==', ['geometry-type'], 'Polygon'],
              ['==', ['geometry-type'], 'MultiPolygon']
            ],
            lineCap: 'round',
            lineJoin: 'round',
            strokeColor: [
              'case',
              ['has', 'strokeColor'],
              ['get', 'strokeColor'],
              ['has', 'stroke'],
              ['get', 'stroke'],
              '#1e90ff'
            ],
            strokeOpacity: [
              'case',
              ['has', 'strokeOpacity'],
              ['get', 'strokeOpacity'],
              ['has', 'stroke-opacity'],
              ['get', 'stroke-opacity'],
              1
            ],
            strokeWidth: [
              'case',
              ['has', 'strokeWidth'],
              ['get', 'strokeWidth'],
              ['has', 'stroke-width'],
              ['get', 'stroke-width'],
              ['has', 'stroke-thickness'],
              ['get', 'stroke-thickness'],
              3
            ]
          }),
          polygonLayer: new i.layer.PolygonLayer(s._datasource, null, {
            fillColor: [
              'case',
              ['has', 'fillColor'],
              ['get', 'fillColor'],
              ['has', 'fill'],
              ['get', 'fill'],
              '#1e90ff'
            ],
            fillOpacity: [
              'case',
              ['has', 'fillOpacity'],
              ['get', 'fillOpacity'],
              ['has', 'fill-opacity'],
              ['get', 'fill-opacity'],
              0.5
            ],
            filter: [
              'all',
              [
                'any',
                ['==', ['geometry-type'], 'Polygon'],
                ['==', ['geometry-type'], 'MultiPolygon']
              ],
              ['any', ['!', ['has', 'height']], ['==', ['get', 'height'], 0]]
            ]
          }),
          symbolLayer: new i.layer.SymbolLayer(s._datasource, null, {
            filter: [
              'all',
              ['any', ['==', ['geometry-type'], 'Point'], ['==', ['geometry-type'], 'MultiPoint']]
            ],
            iconOptions: {
              allowOverlap: !0,
              anchor: [
                'case',
                ['has', 'anchor'],
                [
                  'match',
                  ['get', 'anchor'],
                  [
                    'center',
                    'left',
                    'right',
                    'top',
                    'bottom',
                    'top-left',
                    'top-right',
                    'bottom-left',
                    'bottom-right'
                  ],
                  ['get', 'anchor'],
                  'bottom'
                ],
                'bottom'
              ],
              ignorePlacement: !0,
              image: ['case', ['has', 'image'], ['get', 'image'], 'none'],
              offset: ['case', ['has', 'offset'], ['get', 'offset'], ['literal', [0, 0]]],
              rotation: ['case', ['has', 'rotation'], ['get', 'rotation'], 0],
              size: [
                'case',
                ['has', 'size'],
                ['get', 'size'],
                ['has', 'marker-size'],
                ['match', ['get', 'marker-size'], 'small', 0.5, 'medium', 1, 'large', 2, 1],
                1
              ]
            },
            textOptions: {
              offset: [
                'case',
                ['has', 'image'],
                ['literal', [0, 1.2]],
                ['has', 'point_count_abbreviated'],
                ['literal', [0, 0.4]],
                ['literal', [0, 2]]
              ],
              textField: [
                'format',
                [
                  'case',
                  ['has', 'point_count_abbreviated'],
                  ['get', 'point_count_abbreviated'],
                  ''
                ],
                {}
              ]
            }
          })
        }),
        s.setOptions(l),
        s
      )
    }
    return (
      s(e, t),
      (e.prototype.closePopup = function () {
        this._popup.setOptions({ content: '' }), this._popup.close()
      }),
      (e.prototype.dispose = function () {
        this.onRemove(), delete this._popup, delete this._options
      }),
      (e.prototype.getLayers = function () {
        return Object.assign({}, this._layers)
      }),
      (e.prototype.getOptions = function () {
        return ci(this._options)
      }),
      (e.prototype.setOptions = function (t) {
        var e = new $i().merge(this._options, ci(t))
        this._options.enablePopups && !e.enablePopups
          ? this.closePopup()
          : Ki(this._options.popupTemplate, e.popupTemplate) || this.closePopup(),
          this._options.allowExtrusions !== e.allowExtrusions &&
            (e.allowExtrusions
              ? (this._layers.extrudedPolygonLayer.setOptions({
                  filter: [
                    'all',
                    [
                      'any',
                      ['==', ['geometry-type'], 'Polygon'],
                      ['==', ['geometry-type'], 'MultiPolygon']
                    ],
                    ['all', ['has', 'height'], ['!=', ['get', 'height'], 0]]
                  ],
                  visible: this._options.visible
                }),
                this._layers.polygonLayer.setOptions({
                  filter: [
                    'all',
                    [
                      'any',
                      ['==', ['geometry-type'], 'Polygon'],
                      ['==', ['geometry-type'], 'MultiPolygon']
                    ],
                    ['any', ['!', ['has', 'height']], ['==', ['get', 'height'], 0]]
                  ]
                }))
              : (this._layers.extrudedPolygonLayer.setOptions({ visible: !1 }),
                this._layers.polygonLayer.setOptions({
                  filter: [
                    'all',
                    [
                      'any',
                      ['==', ['geometry-type'], 'Polygon'],
                      ['==', ['geometry-type'], 'MultiPolygon']
                    ]
                  ]
                }))),
          this._options.showPointTitles !== e.showPointTitles &&
            (e.showPointTitles
              ? this._layers.symbolLayer.setOptions({
                  textOptions: {
                    textField: [
                      'format',
                      [
                        'case',
                        ['has', 'title'],
                        ['get', 'title'],
                        ['has', 'name'],
                        ['get', 'name'],
                        ['has', 'point_count_abbreviated'],
                        ['get', 'point_count_abbreviated'],
                        ''
                      ],
                      {}
                    ]
                  }
                })
              : this._layers.symbolLayer.setOptions({
                  textOptions: {
                    textField: [
                      'format',
                      [
                        'case',
                        ['has', 'point_count_abbreviated'],
                        ['get', 'point_count_abbreviated'],
                        ''
                      ],
                      {}
                    ]
                  }
                })),
          this._options.visible !== e.visible &&
            (this._layers.polygonLayer.setOptions({ visible: e.visible }),
            this._layers.lineLayer.setOptions({ visible: e.visible }),
            this._layers.extrudedPolygonLayer.setOptions({
              visible: e.visible && e.allowExtrusions
            }),
            this._layers.bubbleLayer.setOptions({ visible: e.visible }),
            this._layers.symbolLayer.setOptions({ visible: e.visible })),
          (this._options = e)
      }),
      (e.prototype.onAdd = function (e) {
        t.prototype.onAdd.call(this, e),
          this.closePopup(),
          this._popup.attach(this.map),
          this.map.layers.add(
            [this._layers.polygonLayer, this._layers.lineLayer, this._layers.extrudedPolygonLayer],
            'labels'
          ),
          this.map.layers.add([this._layers.bubbleLayer, this._layers.symbolLayer]),
          this.map.events.add('mouseleave', this, this._mouseLeave),
          this.map.events.add('mouseenter', this, this._mouseEnter),
          this.map.events.add('click', this._mouseClick),
          this.map.events.add('datasourceupdated', this._datasource, this._dataSourceUpdated),
          this.map.events.add('dataremoved', this._datasource, this._dataSourceUpdated)
      }),
      (e.prototype.onRemove = function () {
        var e = this
        this._popup.remove(),
          this.map.events.remove('mouseleave', this, this._mouseLeave),
          this.map.events.remove('mouseenter', this, this._mouseEnter),
          this.map.events.remove('datasourceupdated', this._datasource, this._dataSourceUpdated),
          this.map.events.remove('dataremoved', this._datasource, this._dataSourceUpdated),
          this.map.layers.remove(
            Object.values(this._layers).filter(function (t) {
              return !!e.map.layers.getLayerById(t.getId())
            })
          ),
          t.prototype.onRemove.call(this)
      }),
      (e.prototype._buildLayers = function () {
        return []
      }),
      (e.prototype._getLayerIds = function () {
        var t
        return (t = new Array()).concat.apply(
          t,
          Object.values(this._layers).map(function (t) {
            return t._getLayerIds()
          })
        )
      }),
      (e.prototype._getSourceIds = function () {
        return new Set([this._datasource.getId()])
      }),
      (e.prototype._getZoomClusterHandler = function (t) {
        var e = this
        return function (i) {
          e.map.setCamera({ center: t.geometry.coordinates, duration: 200, type: 'ease', zoom: i })
        }
      }),
      (e.prototype._showPopup = function (t, e) {
        var l = t instanceof i.Shape ? t.getProperties() : t.properties,
          s = this._options.popupTemplate
        l.popupTemplate && (s = l.popupTemplate)
        var n = e,
          a = [0, 0],
          c = !1
        t instanceof i.Shape && 'Point' === t.getType()
          ? ((n = t.getCoordinates()), (c = !0))
          : t instanceof i.Shape || 'Point' !== t.type || ((n = t.geometry.coordinates), (c = !0)),
          c && l.image && 'center' !== l.anchor && (a = [0, -18])
        var d = i.PopupTemplate.applyTemplate(l, s)
        d &&
          (this._popup.setOptions({
            content: d,
            fillColor: s ? s.fillColor : void 0,
            pixelOffset: a,
            position: n
          }),
          this._popup.open(this.map))
      }),
      e
    )
  })(i.layer.Layer),
  el = (function () {
    function t() {}
    return (
      (t.addAttributesToObject = function (t, e) {
        if (t && t.attributes) {
          var i = t.attributes
          Object.keys(i).forEach(function (t) {
            'gml:id' === t
              ? (e.id = i[t])
              : t.startsWith('xmlns') ||
                t.startsWith('xsi') ||
                t.startsWith('_') ||
                (t.includes(':') ? (e[t.substr(t.indexOf(':') + 1)] = i[t]) : (e[t] = i[t]))
          })
        }
      }),
      (t.ajaxGetAsync = function (e, i, l, s, d) {
        return a(this, void 0, void 0, function () {
          var a, r, o, m, u, b, h, Z
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                ;(a = 'string' == typeof e ? this.parseURL(e) : e),
                  (e = a.absolutePath),
                  t.isValidString(i) && (e = i + encodeURIComponent(e)),
                  (d = d || 'SpatialIoRequest'),
                  (r = { Origin: '*' }),
                  (c.label = 1)
              case 1:
                return (
                  c.trys.push([1, 18, , 19]),
                  (o = void 0),
                  l
                    ? 'function' != typeof l
                      ? [3, 3]
                      : ((m = l(e, d) || {}),
                        [
                          4,
                          fetch(m.url || e, {
                            credentials: m.credentials,
                            headers: n(n({}, r), m.headers)
                          })
                        ])
                    : [3, 6]
                )
              case 2:
                return (o = c.sent()), [3, 5]
              case 3:
                return [4, l._sendRequest(e, d, r)]
              case 4:
                ;(o = c.sent()), (c.label = 5)
              case 5:
                return [3, 8]
              case 6:
                return [4, fetch(e, { headers: r })]
              case 7:
                ;(o = c.sent()), (c.label = 8)
              case 8:
                return o.ok
                  ? s
                    ? ((u = o.headers.get('Content-Type')),
                      this.isCompressedContentType(u) ? [4, o.arrayBuffer()] : [3, 10])
                    : [3, 13]
                  : [3, 16]
              case 9:
                return [2, c.sent()]
              case 10:
                return [4, o.arrayBuffer()]
              case 11:
                return (
                  (b = c.sent()),
                  (h = this.arrayBufferToString(b, 10)),
                  !u && /^(PK|PNG|JPEG|JPG|BMP|GIF)/.test(h)
                    ? [2, b]
                    : [2, this.arrayBufferToString(b)]
                )
              case 12:
                return [3, 15]
              case 13:
                return [4, o.text()]
              case 14:
                return [2, c.sent()]
              case 15:
                return [3, 17]
              case 16:
                throw new Error('Error downloading file. Status code: ' + o.status)
              case 17:
                return [3, 19]
              case 18:
                if ((Z = c.sent()) && 'Failed to fetch' === Z.message)
                  throw new Error(
                    'Failed to fetch. Ensure that the resource you are trying to access is on a CORs enabled endpoint.'
                  )
                throw Z
              case 19:
                return [2]
            }
          })
        })
      }),
      (t.arrayBufferToString = function (t, e) {
        var i,
          l,
          s,
          n,
          a,
          c = new Uint8Array(t),
          d = []
        for (l = e > 0 ? Math.min(e, c.length) : c.length, i = 0; i < l; )
          switch ((s = c[i++]) >> 4) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
              d.push(String.fromCharCode(s))
              break
            case 12:
            case 13:
              ;(n = c[i++]), d.push(String.fromCharCode(((31 & s) << 6) | (63 & n)))
              break
            case 14:
              ;(n = c[i++]),
                (a = c[i++]),
                d.push(String.fromCharCode(((15 & s) << 12) | ((63 & n) << 6) | ((63 & a) << 0)))
          }
        return d.join('')
      }),
      (t.closeRing = function (t) {
        t.length >= 2 && !Ni.areEqual(t[0], t[t.length - 1], 6) && t.push(t[0])
      }),
      (t.colorToHex = function (t) {
        var e
        return (
          '#' +
          ('0' + (e = Array.isArray(t) ? t : this.colorToRgbaArray(t))[0].toString(16)).slice(-2) +
          ('0' + e[1].toString(16)).slice(-2) +
          ('0' + e[2].toString(16)).slice(-2)
        )
      }),
      (t.colorToRgba = function (e) {
        var i
        if (Array.isArray(e)) i = e
        else {
          if (e.includes('rgba(') || e.includes('rgb(')) return e
          t.isValidString(e) && (i = this.colorToRgbaArray(e))
        }
        i.length >= 4 && i[3] > 1 && (i[3] /= 255), i || (i = [])
        for (var l = 0; l < 4; l++) i.length < l - 1 ? i.push(0) : i[l] < 0 && (i[l] = 0)
        return 'rgba(' + i[0] + ',' + i[1] + ',' + i[2] + ',' + i[3] + ')'
      }),
      (t.colorToRgbaArray = function (e) {
        if (t.isValidString(e)) {
          var i = void 0
          if ((e = e.toLowerCase()).includes('rgba(') || e.includes('rgb(')) {
            var l = (e = e.replace('rgba(', '').replace('rgb(', '').replace(')', '')).split(
              /\s*,\s*/
            )
            if (l.length >= 3) {
              i = []
              for (var s = 0; s < l.length; s++)
                if (l[s].includes('%')) {
                  var n = parseInt(l[s]) / 100
                  3 === s ? i.push(n) : i.push(255 * n)
                } else i.push(parseInt(l[s]))
              return (
                3 === i.length ? i.push(1) : i.length >= 4 && i[3] > 1 && (i[3] = i[3] / 255), i
              )
            }
            return [0, 0, 0, 0]
          }
          if ((i = this.cssColorNames[e])) return i
          e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, i, l) {
            return e + e + i + i + l + l
          })
          var a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e)
          return a ? [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16), 1] : [0, 0, 0, 0]
        }
      }),
      (t.createPosition = function (e, i, l, s) {
        if (t.isValidNumber(e) && t.isValidNumber(i)) {
          var n = [e, i]
          return t.isValidNumber(l) && n.push(l), s && ((n[0] = Di(n[0])), (n[1] = Ei(n[1]))), n
        }
      }),
      (t.docHasData = function (t) {
        return t && t.root && t.root.childNodes && t.root.childNodes.length > 0
      }),
      (t.doesElementContainTagName = function (t, e) {
        if (t && e && e.childNodes)
          for (var i = 0, l = e.childNodes; i < l.length; i++) {
            if (l[i].tagName === t) return !0
          }
        return !1
      }),
      (t.escapeHtml = function (t) {
        return t
          ? ((t.includes('&lt;') &&
              t.includes('&gt;') &&
              t.includes('&quot;') &&
              t.includes('&apos;') &&
              t.includes('&amp;')) ||
              (t = t.replace(/&/g, '&amp;')),
            t
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&apos;'))
          : null
      }),
      (t.getElementByTagName = function (t, e) {
        if (t && e && e.childNodes)
          for (var i = 0, l = e.childNodes; i < l.length; i++) {
            var s = l[i]
            if (s.tagName === t) return s
          }
        return null
      }),
      (t.ignoreProperty = function (t, e) {
        if (t)
          switch (t) {
            case 'title':
            case 'name':
            case 'base':
            case 'popupTemplate':
            case 'anchor':
            case 'image':
            case 'imageUrl':
            case 'rotation':
            case 'color':
            case 'size':
            case 'offset':
            case 'strokeColor':
            case 'strokeWidth':
            case 'strokeOpacity':
            case 'fillColor':
            case 'fillOpacity':
            case 'visibility':
            case 'visible':
              return !0
            default:
              if (t.startsWith('_')) return !0
          }
        return null == e || '' === e
      }),
      (t.isBinaryData = function (t) {
        return 67324752 === new Int32Array(t, 0, 1)[0]
      }),
      (t.isCompressedContentType = function (t) {
        return (
          'application/vnd.google-earth.kmz' === t ||
          'application/zip' === t ||
          'application/octet-stream' === t ||
          t.startsWith('image/')
        )
      }),
      (t.isUrl = function (e) {
        return e && 'string' == typeof e && (e.startsWith('data:image') || t.protocolRx.test(e))
      }),
      (t.isValidNumber = function (t) {
        return !isNaN(t) && null !== t && 'number' == typeof t
      }),
      (t.isValidString = function (t) {
        return t && 'string' == typeof t && '' !== t
      }),
      (t.matchFirstPreference = function (t, e) {
        for (var i = 0, l = e; i < l.length; i++) {
          var s = l[i]
          if (t.includes(s)) return s
        }
        return null
      }),
      (t.parseBoolean = function (t) {
        try {
          if ((t = t.trim()))
            switch (t.toLowerCase()) {
              case 'true':
              case 'yes':
              case '1':
                return !0
              case 'false':
              case 'no':
              case '0':
                return !1
              default:
                return Boolean(t)
            }
        } catch (t) {}
        return !1
      }),
      (t.parseQueryStringParams = function (t, e, i) {
        i && (t = t.replace(/&amp;/gi, '&'))
        var l = t.indexOf('?')
        if (l >= 0) {
          var s = t.substring(l + 1)
          if (s)
            return s
              .split('&')
              .map(function (t) {
                return t.split('=')
              })
              .reduce(function (t, i) {
                var l = i[0],
                  s = i[1]
                return (t[e ? l.toLowerCase() : l] = decodeURI(s)), t
              }, {})
        }
        return {}
      }),
      (t.parseURL = function (t, e) {
        var i = t.match(this._urlParseRx),
          l = {
            fileName: null,
            hash: i[10] || '',
            host: i[3] || '',
            hostname: i[6] || '',
            href: i[0] || '',
            origin: i[1] || '',
            password: i[5] || '',
            pathname: i[8] || (i[1] ? '/' : ''),
            port: i[7] || '',
            protocol: i[2] || '',
            search: i[9] || '',
            username: i[4] || ''
          }
        if (
          (2 === l.protocol.length &&
            ((l.protocol = 'file:///' + l.protocol.toUpperCase()),
            (l.origin = l.protocol + '//' + l.host)),
          (l.href = l.origin + l.pathname + l.search + l.hash),
          l.pathname &&
            !l.pathname.endsWith('/') &&
            (l.fileName = l.pathname.replace(/^.*[\\\/]/, '')),
          !this.protocolRx.test(t) && !t.startsWith('data:') && e && e.host && l.host !== e.host)
        ) {
          var s = e.protocol + '//' + e.host
          t.startsWith('/')
            ? (s += t)
            : ((s += '/'),
              e.fileName
                ? (s += e.pathName.substring(0, e.pathName.indexOf(e.fileName)))
                : (s += e.pathName + '/'),
              (s += t)),
            (l.href = s)
        }
        return {
          absolutePath: l.href,
          fileName: l.fileName,
          host: l.host,
          hostName: l.hostname,
          pathName: l.pathname,
          protocol: l.protocol,
          queryString: l.search
        }
      }),
      (t.replaceNewlines = function (t) {
        return t.includes('<')
          ? t.replace(/<p><\/p>/g, '').replace(/(\r\n|\n|\r){2,}/g, '\n')
          : t.replace(/(\r\n|\r|\n)/g, '<br/>')
      }),
      (t.roundBBox = function (t, e) {
        return t.length >= 6
          ? [
              this.roundToPrecision(t[0], e),
              this.roundToPrecision(t[1], e),
              t[2],
              this.roundToPrecision(t[3], e),
              this.roundToPrecision(t[4], e),
              t[5]
            ]
          : [
              this.roundToPrecision(t[0], e),
              this.roundToPrecision(t[1], e),
              this.roundToPrecision(t[2], e),
              this.roundToPrecision(t[3], e)
            ]
      }),
      (t.roundPosition = function (t, e) {
        var i = [this.roundToPrecision(t[0], e), this.roundToPrecision(t[1], e)]
        return t.length > 2 && i.push(i[2]), i
      }),
      (t.roundToPrecision = function (t, e) {
        e < 0 && (e = 0), e > 10 && (e = 10)
        var i = this._powerFactor[e]
        return Math.round(t * i + 1e-14) / i
      }),
      (t.sanitizeTypeName = function (t) {
        if (t) {
          if (t.startsWith('gml:')) return t
          var e = t.toLowerCase()
          if (e.includes(':')) {
            var i = e.split(':')
            i.length > 1 && (e = i[1])
          }
          switch (e) {
            case 'byte':
            case 'int':
            case 'uint':
            case 'usignedint':
            case 'usignedlong':
            case 'usignedshort':
            case 'usignedbyte':
            case 'integer':
            case 'negativeinteger':
            case 'positiveinteger':
            case 'nonnegativeinteger':
            case 'nonpositiveinteger':
            case 'short':
            case 'long':
            case 'decimal':
            case 'double':
            case 'float':
              return 'number'
            case 'boolean':
            case 'bool':
              return 'boolean'
            case 'date':
            case 'datetime':
              return 'date'
          }
        }
        return t
      }),
      (t.simplifyXmlNode = function (t) {
        if (t && (t.attributes || t.childNodes)) {
          var e = {}
          if ((this.addAttributesToObject(t, e), t.childNodes))
            for (var i = 0, l = t.childNodes; i < l.length; i++) {
              var s = l[i]
              s.value
                ? (e[s.tagName] = s.value)
                : s.childNodes &&
                  s.childNodes.length > 0 &&
                  (e[s.tagName] = this.simplifyXmlNode(s))
            }
          return t.value && void 0 === e.value && (e.value = t.value), e
        }
        return null
      }),
      (t.tryCastObject = function (e, i) {
        if (i)
          try {
            switch (i) {
              case 'number':
                var l = parseFloat(e)
                if (t.isValidNumber(l)) return l
                break
              case 'boolean':
                return t.parseBoolean(e)
              case 'date':
                return Qi(e)
            }
          } catch (t) {}
        return e
      }),
      (t.unescapeHTML = function (t) {
        return t
          ? t
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&quot;/g, '"')
              .replace(/&apos;/g, "'")
              .replace(/&nbsp;/g, ' ')
              .replace(/&amp;/g, '&')
          : null
      }),
      (t._powerFactor = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10]),
      (t._urlParseRx =
        /^(([^:\/?#]+:)?(?:\/\/((?:([^\/?#:]*):([^\/?#:]*)@)?([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/),
      (t.containsHtmlRx = /<\/?\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[\^'">\s]+))?)+\s*|\s*)\/?>/),
      (t.containsSpecialCharRx = /[&<>"']/),
      (t.cssColorNames = {
        aliceblue: [240, 248, 255, 1],
        antiquewhite: [250, 235, 215, 1],
        aqua: [0, 255, 255, 1],
        aquamarine: [127, 255, 212, 1],
        azure: [240, 255, 255, 1],
        beige: [245, 245, 220, 1],
        bisque: [255, 228, 196, 1],
        black: [0, 0, 0, 1],
        blanchedalmond: [255, 235, 205, 1],
        blue: [0, 0, 255, 1],
        blueviolet: [138, 43, 226, 1],
        brown: [165, 42, 42, 1],
        burlywood: [222, 184, 135, 1],
        cadetblue: [95, 158, 160, 1],
        chartreuse: [127, 255, 0, 1],
        chocolate: [210, 105, 30, 1],
        coral: [255, 127, 80, 1],
        cornflowerblue: [100, 149, 237, 1],
        cornsilk: [255, 248, 220, 1],
        crimson: [220, 20, 60, 1],
        cyan: [0, 255, 255, 1],
        darkblue: [0, 0, 139, 1],
        darkcyan: [0, 139, 139, 1],
        darkgoldenrod: [184, 134, 11, 1],
        darkgray: [169, 169, 169, 1],
        darkgreen: [0, 100, 0, 1],
        darkgrey: [169, 169, 169, 1],
        darkkhaki: [189, 183, 107, 1],
        darkmagenta: [139, 0, 139, 1],
        darkolivegreen: [85, 107, 47, 1],
        darkorange: [255, 140, 0, 1],
        darkorchid: [153, 50, 204, 1],
        darkred: [139, 0, 0, 1],
        darksalmon: [233, 150, 122, 1],
        darkseagreen: [143, 188, 143, 1],
        darkslateblue: [72, 61, 139, 1],
        darkslategray: [47, 79, 79, 1],
        darkslategrey: [47, 79, 79, 1],
        darkturquoise: [0, 206, 209, 1],
        darkviolet: [148, 0, 211, 1],
        deeppink: [255, 20, 147, 1],
        deepskyblue: [0, 191, 255, 1],
        dimgray: [105, 105, 105, 1],
        dimgrey: [105, 105, 105, 1],
        dodgerblue: [30, 144, 255, 1],
        firebrick: [178, 34, 34, 1],
        floralwhite: [255, 250, 240, 1],
        forestgreen: [34, 139, 34, 1],
        fuchsia: [255, 0, 255, 1],
        gainsboro: [220, 220, 220, 1],
        ghostwhite: [248, 248, 255, 1],
        gold: [255, 215, 0, 1],
        goldenrod: [218, 165, 32, 1],
        gray: [128, 128, 128, 1],
        green: [0, 128, 0, 1],
        greenyellow: [173, 255, 47, 1],
        grey: [128, 128, 128, 1],
        honeydew: [240, 255, 240, 1],
        hotpink: [255, 105, 180, 1],
        indianred: [205, 92, 92, 1],
        indigo: [75, 0, 130, 1],
        ivory: [255, 255, 240, 1],
        khaki: [240, 230, 140, 1],
        lavender: [230, 230, 250, 1],
        lavenderblush: [255, 240, 245, 1],
        lawngreen: [124, 252, 0, 1],
        lemonchiffon: [255, 250, 205, 1],
        lightblue: [173, 216, 230, 1],
        lightcoral: [240, 128, 128, 1],
        lightcyan: [224, 255, 255, 1],
        lightgoldenrodyellow: [250, 250, 210, 1],
        lightgray: [211, 211, 211, 1],
        lightgreen: [144, 238, 144, 1],
        lightgrey: [211, 211, 211, 1],
        lightpink: [255, 182, 193, 1],
        lightsalmon: [255, 160, 122, 1],
        lightseagreen: [32, 178, 170, 1],
        lightskyblue: [135, 206, 250, 1],
        lightslategray: [119, 136, 153, 1],
        lightslategrey: [119, 136, 153, 1],
        lightsteelblue: [176, 196, 222, 1],
        lightyellow: [255, 255, 224, 1],
        lime: [0, 255, 0, 1],
        limegreen: [50, 205, 50, 1],
        linen: [250, 240, 230, 1],
        magenta: [255, 0, 255, 1],
        maroon: [128, 0, 0, 1],
        mediumaquamarine: [102, 205, 170, 1],
        mediumblue: [0, 0, 205, 1],
        mediumorchid: [186, 85, 211, 1],
        mediumpurple: [147, 112, 219, 1],
        mediumseagreen: [60, 179, 113, 1],
        mediumslateblue: [123, 104, 238, 1],
        mediumspringgreen: [0, 250, 154, 1],
        mediumturquoise: [72, 209, 204, 1],
        mediumvioletred: [199, 21, 133, 1],
        midnightblue: [25, 25, 112, 1],
        mintcream: [245, 255, 250, 1],
        mistyrose: [255, 228, 225, 1],
        moccasin: [255, 228, 181, 1],
        navajowhite: [255, 222, 173, 1],
        navy: [0, 0, 128, 1],
        oldlace: [253, 245, 230, 1],
        olive: [128, 128, 0, 1],
        olivedrab: [107, 142, 35, 1],
        orange: [255, 165, 0, 1],
        orangered: [255, 69, 0, 1],
        orchid: [218, 112, 214, 1],
        palegoldenrod: [238, 232, 170, 1],
        palegreen: [152, 251, 152, 1],
        paleturquoise: [175, 238, 238, 1],
        palevioletred: [219, 112, 147, 1],
        papayawhip: [255, 239, 213, 1],
        peachpuff: [255, 218, 185, 1],
        peru: [205, 133, 63, 1],
        pink: [255, 192, 203, 1],
        plum: [221, 160, 221, 1],
        powderblue: [176, 224, 230, 1],
        purple: [128, 0, 128, 1],
        red: [255, 0, 0, 1],
        rosybrown: [188, 143, 143, 1],
        royalblue: [65, 105, 225, 1],
        saddlebrown: [139, 69, 19, 1],
        salmon: [250, 128, 114, 1],
        sandybrown: [244, 164, 96, 1],
        seagreen: [46, 139, 87, 1],
        seashell: [255, 245, 238, 1],
        sienna: [160, 82, 45, 1],
        silver: [192, 192, 192, 1],
        skyblue: [135, 206, 235, 1],
        slateblue: [106, 90, 205, 1],
        slategray: [112, 128, 144, 1],
        slategrey: [112, 128, 144, 1],
        snow: [255, 250, 250, 1],
        springgreen: [0, 255, 127, 1],
        steelblue: [70, 130, 180, 1],
        tan: [210, 180, 140, 1],
        teal: [0, 128, 128, 1],
        thistle: [216, 191, 216, 1],
        tomato: [255, 99, 71, 1],
        transparent: [0, 0, 0, 0],
        turquoise: [64, 224, 208, 1],
        violet: [238, 130, 238, 1],
        wheat: [245, 222, 179, 1],
        white: [255, 255, 255, 1],
        whitesmoke: [245, 245, 245, 1],
        yellow: [255, 255, 0, 1],
        yellowgreen: [154, 205, 50, 1],
        grn: [0, 128, 0, 1],
        ltblu: [173, 216, 230, 1],
        wht: [255, 255, 255, 1],
        ylw: [255, 255, 0, 1],
        modis_00_to_06hr_fire: [139, 0, 0, 1],
        modis_06_to_12hr_fire: [255, 0, 0, 1],
        modis_12_to_24hr_fire: [255, 165, 0, 1],
        modis_prev_6_days_fire: [255, 255, 0, 1]
      }),
      (t.mmPerPixelGpx = 3.7795275591),
      (t.protocolRx = /^(?:[a-zA-Z]+:)?\/\//),
      t
    )
  })(),
  il = (function () {
    function t(t) {
      ;(this._position = 0),
        (this._parseNamespaces = !0),
        (this._letterRx = /[a-zA-Z]/),
        (this._attributeStartRx = /[a-zA-Z'">]/),
        (this._nameTerminator = new Set('\r\n\t>/= ')),
        (this._namespacePrefixRx = /^xmlns(:|$)/i),
        'boolean' == typeof t && (this._parseNamespaces = t)
    }
    return (
      (t.prototype.parse = function (t) {
        ;(this._position = 0), (this._namespaces = {})
        var e = this._parseChildren(t)
        return 1 === e.length ? { namespaces: this._namespaces, root: e[0] } : null
      }),
      (t.prototype._parseChildren = function (t) {
        for (var e, i, l = []; t[this._position]; ) {
          if ('<' === t[this._position]) {
            switch (t[this._position + 1]) {
              case '/':
                return this._advancePositionToSubstring(t, '>'), l
              case '!':
              case '?':
                switch (((this._position += 2), t[this._position])) {
                  case '-':
                    this._advancePositionToSubstring(t, '--\x3e')
                    break
                  case '[':
                    ;(this._position += 7),
                      (i = this._position),
                      this._advancePositionToSubstring(t, ']]>'),
                      this._position > i &&
                        (e = t.substring(i, this._position - 2)) &&
                        e.trim().length > 0 &&
                        l.push(e)
                    break
                  default:
                    this._advancePositionToSubstring(t, '>')
                }
                this._position++
                continue
            }
            l.push(this._parseNode(t))
          } else
            (i = this._position),
              (this._position = t.indexOf('<', this._position) - 1),
              -2 === this._position && (this._position = t.length),
              (e = t.substring(i, this._position + 1)) && e.trim().length > 0 && l.push(e)
          this._position++
        }
        return l
      }),
      (t.prototype._parseNode = function (t) {
        this._position++
        var e,
          i = this._parseName(t)
        if (this._parseNamespaces && i.includes(':')) {
          var l = i.split(':')
          2 === l.length && ((e = l[0]), (i = l[1]))
        }
        var s = { attributes: this._parseAttributes(t), nsPrefix: e, tagName: i }
        if ('/' !== t[this._position - 1]) {
          this._position++
          var n = this._parseChildren(t)
          1 === n.length && 'string' == typeof n[0] ? (s.value = n[0]) : (s.childNodes = n)
        }
        return s
      }),
      (t.prototype._parseAttributes = function (t) {
        for (var e, i, l, s, n = null, a = t[this._position]; '>' !== a; ) {
          if (this._letterRx.test(a)) {
            for (
              n || (n = {}), e = this._parseName(t), a = t[this._position];
              !this._attributeStartRx.test(a);

            )
              this._position++, (a = t[this._position])
            if (
              ("'" === a || '"' === a
                ? ((s = t[this._position]),
                  (l = ++this._position),
                  (this._position = t.indexOf(s, l)),
                  (i = t.substring(l, this._position)))
                : ((i = null), this._position--),
              (n[e] = i),
              this._parseNamespaces && this._namespacePrefixRx.test(e))
            )
              if (e.includes(':')) {
                var c = e.split(':')
                2 === c.length && (this._namespaces[c[1]] = i)
              } else this._namespaces[e] = i
          }
          this._position++, (a = t[this._position])
        }
        return n
      }),
      (t.prototype._parseName = function (t) {
        for (var e = this._position; !this._nameTerminator.has(t[this._position]); )
          this._position++
        return t.substring(e, this._position)
      }),
      (t.prototype._advancePositionToSubstring = function (t, e) {
        ;(this._position = t.indexOf(e, this._position) - 1),
          -1 === this._position ? (this._position = t.length) : (this._position += e.length)
      }),
      t
    )
  })(),
  ll = I(function (t, e) {
    t.exports = (function t(e, i, l) {
      function s(a, c) {
        if (!i[a]) {
          if (!e[a]) {
            if (!c && S) return S()
            if (n) return n(a, !0)
            var d = new Error("Cannot find module '" + a + "'")
            throw ((d.code = 'MODULE_NOT_FOUND'), d)
          }
          var r = (i[a] = { exports: {} })
          e[a][0].call(
            r.exports,
            function (t) {
              return s(e[a][1][t] || t)
            },
            r,
            r.exports,
            t,
            e,
            i,
            l
          )
        }
        return i[a].exports
      }
      for (var n = S, a = 0; a < l.length; a++) s(l[a])
      return s
    })(
      {
        1: [
          function (t, e, i) {
            var l = t('./utils'),
              s = t('./support'),
              n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
            ;(i.encode = function (t) {
              for (
                var e,
                  i,
                  s,
                  a,
                  c,
                  d,
                  r,
                  o = [],
                  m = 0,
                  u = t.length,
                  b = u,
                  h = 'string' !== l.getTypeOf(t);
                m < t.length;

              )
                (b = u - m),
                  (s = h
                    ? ((e = t[m++]), (i = m < u ? t[m++] : 0), m < u ? t[m++] : 0)
                    : ((e = t.charCodeAt(m++)),
                      (i = m < u ? t.charCodeAt(m++) : 0),
                      m < u ? t.charCodeAt(m++) : 0)),
                  (a = e >> 2),
                  (c = ((3 & e) << 4) | (i >> 4)),
                  (d = 1 < b ? ((15 & i) << 2) | (s >> 6) : 64),
                  (r = 2 < b ? 63 & s : 64),
                  o.push(n.charAt(a) + n.charAt(c) + n.charAt(d) + n.charAt(r))
              return o.join('')
            }),
              (i.decode = function (t) {
                var e,
                  i,
                  l,
                  a,
                  c,
                  d,
                  r = 0,
                  o = 0,
                  m = 'data:'
                if (t.substr(0, m.length) === m)
                  throw new Error('Invalid base64 input, it looks like a data url.')
                var u,
                  b = (3 * (t = t.replace(/[^A-Za-z0-9\+\/\=]/g, '')).length) / 4
                if (
                  (t.charAt(t.length - 1) === n.charAt(64) && b--,
                  t.charAt(t.length - 2) === n.charAt(64) && b--,
                  b % 1 != 0)
                )
                  throw new Error('Invalid base64 input, bad content length.')
                for (u = s.uint8array ? new Uint8Array(0 | b) : new Array(0 | b); r < t.length; )
                  (e = (n.indexOf(t.charAt(r++)) << 2) | ((a = n.indexOf(t.charAt(r++))) >> 4)),
                    (i = ((15 & a) << 4) | ((c = n.indexOf(t.charAt(r++))) >> 2)),
                    (l = ((3 & c) << 6) | (d = n.indexOf(t.charAt(r++)))),
                    (u[o++] = e),
                    64 !== c && (u[o++] = i),
                    64 !== d && (u[o++] = l)
                return u
              })
          },
          { './support': 30, './utils': 32 }
        ],
        2: [
          function (t, e, i) {
            var l = t('./external'),
              s = t('./stream/DataWorker'),
              n = t('./stream/DataLengthProbe'),
              a = t('./stream/Crc32Probe')
            function c(t, e, i, l, s) {
              ;(this.compressedSize = t),
                (this.uncompressedSize = e),
                (this.crc32 = i),
                (this.compression = l),
                (this.compressedContent = s)
            }
            ;(n = t('./stream/DataLengthProbe')),
              (c.prototype = {
                getContentWorker: function () {
                  var t = new s(l.Promise.resolve(this.compressedContent))
                      .pipe(this.compression.uncompressWorker())
                      .pipe(new n('data_length')),
                    e = this
                  return (
                    t.on('end', function () {
                      if (this.streamInfo.data_length !== e.uncompressedSize)
                        throw new Error('Bug : uncompressed data size mismatch')
                    }),
                    t
                  )
                },
                getCompressedWorker: function () {
                  return new s(l.Promise.resolve(this.compressedContent))
                    .withStreamInfo('compressedSize', this.compressedSize)
                    .withStreamInfo('uncompressedSize', this.uncompressedSize)
                    .withStreamInfo('crc32', this.crc32)
                    .withStreamInfo('compression', this.compression)
                }
              }),
              (c.createWorkerFrom = function (t, e, i) {
                return t
                  .pipe(new a())
                  .pipe(new n('uncompressedSize'))
                  .pipe(e.compressWorker(i))
                  .pipe(new n('compressedSize'))
                  .withStreamInfo('compression', e)
              }),
              (e.exports = c)
          },
          {
            './external': 6,
            './stream/Crc32Probe': 25,
            './stream/DataLengthProbe': 26,
            './stream/DataWorker': 27
          }
        ],
        3: [
          function (t, e, i) {
            var l = t('./stream/GenericWorker')
            ;(i.STORE = {
              magic: '\0\0',
              compressWorker: function (t) {
                return new l('STORE compression')
              },
              uncompressWorker: function () {
                return new l('STORE decompression')
              }
            }),
              (i.DEFLATE = t('./flate'))
          },
          { './flate': 7, './stream/GenericWorker': 28 }
        ],
        4: [
          function (t, e, i) {
            var l = t('./utils'),
              s = (function () {
                for (var t, e = [], i = 0; i < 256; i++) {
                  t = i
                  for (var l = 0; l < 8; l++) t = 1 & t ? 3988292384 ^ (t >>> 1) : t >>> 1
                  e[i] = t
                }
                return e
              })()
            e.exports = function (t, e) {
              return void 0 !== t && t.length
                ? 'string' !== l.getTypeOf(t)
                  ? (function (t, e, i, l) {
                      var n = s,
                        a = 0 + i
                      t ^= -1
                      for (var c = 0; c < a; c++) t = (t >>> 8) ^ n[255 & (t ^ e[c])]
                      return -1 ^ t
                    })(0 | e, t, t.length)
                  : (function (t, e, i, l) {
                      var n = s,
                        a = 0 + i
                      t ^= -1
                      for (var c = 0; c < a; c++) t = (t >>> 8) ^ n[255 & (t ^ e.charCodeAt(c))]
                      return -1 ^ t
                    })(0 | e, t, t.length)
                : 0
            }
          },
          { './utils': 32 }
        ],
        5: [
          function (t, e, i) {
            ;(i.base64 = !1),
              (i.binary = !1),
              (i.dir = !1),
              (i.createFolders = !0),
              (i.date = null),
              (i.compression = null),
              (i.compressionOptions = null),
              (i.comment = null),
              (i.unixPermissions = null),
              (i.dosPermissions = null)
          },
          {}
        ],
        6: [
          function (t, e, i) {
            var l
            ;(l = 'undefined' != typeof Promise ? Promise : t('lie')), (e.exports = { Promise: l })
          },
          { lie: 37 }
        ],
        7: [
          function (t, e, i) {
            var l =
                'undefined' != typeof Uint8Array &&
                'undefined' != typeof Uint16Array &&
                'undefined' != typeof Uint32Array,
              s = t('pako'),
              n = t('./utils'),
              a = t('./stream/GenericWorker'),
              c = l ? 'uint8array' : 'array'
            function d(t, e) {
              a.call(this, 'FlateWorker/' + t),
                (this._pako = null),
                (this._pakoAction = t),
                (this._pakoOptions = e),
                (this.meta = {})
            }
            ;(i.magic = '\b\0'),
              n.inherits(d, a),
              (d.prototype.processChunk = function (t) {
                ;(this.meta = t.meta),
                  null === this._pako && this._createPako(),
                  this._pako.push(n.transformTo(c, t.data), !1)
              }),
              (d.prototype.flush = function () {
                a.prototype.flush.call(this),
                  null === this._pako && this._createPako(),
                  this._pako.push([], !0)
              }),
              (d.prototype.cleanUp = function () {
                a.prototype.cleanUp.call(this), (this._pako = null)
              }),
              (d.prototype._createPako = function () {
                this._pako = new s[this._pakoAction]({
                  raw: !0,
                  level: this._pakoOptions.level || -1
                })
                var t = this
                this._pako.onData = function (e) {
                  t.push({ data: e, meta: t.meta })
                }
              }),
              (i.compressWorker = function (t) {
                return new d('Deflate', t)
              }),
              (i.uncompressWorker = function () {
                return new d('Inflate', {})
              })
          },
          { './stream/GenericWorker': 28, './utils': 32, pako: 38 }
        ],
        8: [
          function (t, e, i) {
            function l(t, e) {
              var i,
                l = ''
              for (i = 0; i < e; i++) (l += String.fromCharCode(255 & t)), (t >>>= 8)
              return l
            }
            function s(t, e, i, s, a, o) {
              var m,
                u,
                b = t.file,
                h = t.compression,
                Z = o !== c.utf8encode,
                p = n.transformTo('string', o(b.name)),
                y = n.transformTo('string', c.utf8encode(b.name)),
                X = b.comment,
                G = n.transformTo('string', o(X)),
                W = n.transformTo('string', c.utf8encode(X)),
                V = y.length !== b.name.length,
                Y = W.length !== X.length,
                L = '',
                S = '',
                I = '',
                R = b.dir,
                f = b.date,
                x = { crc32: 0, compressedSize: 0, uncompressedSize: 0 }
              ;(e && !i) ||
                ((x.crc32 = t.crc32),
                (x.compressedSize = t.compressedSize),
                (x.uncompressedSize = t.uncompressedSize))
              var g = 0
              e && (g |= 8), Z || (!V && !Y) || (g |= 2048)
              var K = 0,
                J = 0
              R && (K |= 16),
                'UNIX' === a
                  ? ((J = 798),
                    (K |= (function (t, e) {
                      var i = t
                      return t || (i = e ? 16893 : 33204), (65535 & i) << 16
                    })(b.unixPermissions, R)))
                  : ((J = 20),
                    (K |= (function (t) {
                      return 63 & (t || 0)
                    })(b.dosPermissions))),
                (m = f.getUTCHours()),
                (m <<= 6),
                (m |= f.getUTCMinutes()),
                (m <<= 5),
                (m |= f.getUTCSeconds() / 2),
                (u = f.getUTCFullYear() - 1980),
                (u <<= 4),
                (u |= f.getUTCMonth() + 1),
                (u <<= 5),
                (u |= f.getUTCDate()),
                V && ((S = l(1, 1) + l(d(p), 4) + y), (L += 'up' + l(S.length, 2) + S)),
                Y && ((I = l(1, 1) + l(d(G), 4) + W), (L += 'uc' + l(I.length, 2) + I))
              var N = ''
              return (
                (N += '\n\0'),
                (N += l(g, 2)),
                (N += h.magic),
                (N += l(m, 2)),
                (N += l(u, 2)),
                (N += l(x.crc32, 4)),
                (N += l(x.compressedSize, 4)),
                (N += l(x.uncompressedSize, 4)),
                (N += l(p.length, 2)),
                (N += l(L.length, 2)),
                {
                  fileRecord: r.LOCAL_FILE_HEADER + N + p + L,
                  dirRecord:
                    r.CENTRAL_FILE_HEADER +
                    l(J, 2) +
                    N +
                    l(G.length, 2) +
                    '\0\0\0\0' +
                    l(K, 4) +
                    l(s, 4) +
                    p +
                    L +
                    G
                }
              )
            }
            var n = t('../utils'),
              a = t('../stream/GenericWorker'),
              c = t('../utf8'),
              d = t('../crc32'),
              r = t('../signature')
            function o(t, e, i, l) {
              a.call(this, 'ZipFileWorker'),
                (this.bytesWritten = 0),
                (this.zipComment = e),
                (this.zipPlatform = i),
                (this.encodeFileName = l),
                (this.streamFiles = t),
                (this.accumulate = !1),
                (this.contentBuffer = []),
                (this.dirRecords = []),
                (this.currentSourceOffset = 0),
                (this.entriesCount = 0),
                (this.currentFile = null),
                (this._sources = [])
            }
            n.inherits(o, a),
              (o.prototype.push = function (t) {
                var e = t.meta.percent || 0,
                  i = this.entriesCount,
                  l = this._sources.length
                this.accumulate
                  ? this.contentBuffer.push(t)
                  : ((this.bytesWritten += t.data.length),
                    a.prototype.push.call(this, {
                      data: t.data,
                      meta: {
                        currentFile: this.currentFile,
                        percent: i ? (e + 100 * (i - l - 1)) / i : 100
                      }
                    }))
              }),
              (o.prototype.openedSource = function (t) {
                ;(this.currentSourceOffset = this.bytesWritten), (this.currentFile = t.file.name)
                var e = this.streamFiles && !t.file.dir
                if (e) {
                  var i = s(
                    t,
                    e,
                    !1,
                    this.currentSourceOffset,
                    this.zipPlatform,
                    this.encodeFileName
                  )
                  this.push({ data: i.fileRecord, meta: { percent: 0 } })
                } else this.accumulate = !0
              }),
              (o.prototype.closedSource = function (t) {
                this.accumulate = !1
                var e = this.streamFiles && !t.file.dir,
                  i = s(t, e, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName)
                if ((this.dirRecords.push(i.dirRecord), e))
                  this.push({
                    data: (function (t) {
                      return (
                        r.DATA_DESCRIPTOR +
                        l(t.crc32, 4) +
                        l(t.compressedSize, 4) +
                        l(t.uncompressedSize, 4)
                      )
                    })(t),
                    meta: { percent: 100 }
                  })
                else
                  for (
                    this.push({ data: i.fileRecord, meta: { percent: 0 } });
                    this.contentBuffer.length;

                  )
                    this.push(this.contentBuffer.shift())
                this.currentFile = null
              }),
              (o.prototype.flush = function () {
                for (var t = this.bytesWritten, e = 0; e < this.dirRecords.length; e++)
                  this.push({ data: this.dirRecords[e], meta: { percent: 100 } })
                var i = this.bytesWritten - t,
                  s = (function (t, e, i, s, a) {
                    var c = n.transformTo('string', a(s))
                    return (
                      r.CENTRAL_DIRECTORY_END +
                      '\0\0\0\0' +
                      l(t, 2) +
                      l(t, 2) +
                      l(e, 4) +
                      l(i, 4) +
                      l(c.length, 2) +
                      c
                    )
                  })(this.dirRecords.length, i, t, this.zipComment, this.encodeFileName)
                this.push({ data: s, meta: { percent: 100 } })
              }),
              (o.prototype.prepareNextSource = function () {
                ;(this.previous = this._sources.shift()),
                  this.openedSource(this.previous.streamInfo),
                  this.isPaused ? this.previous.pause() : this.previous.resume()
              }),
              (o.prototype.registerPrevious = function (t) {
                this._sources.push(t)
                var e = this
                return (
                  t.on('data', function (t) {
                    e.processChunk(t)
                  }),
                  t.on('end', function () {
                    e.closedSource(e.previous.streamInfo),
                      e._sources.length ? e.prepareNextSource() : e.end()
                  }),
                  t.on('error', function (t) {
                    e.error(t)
                  }),
                  this
                )
              }),
              (o.prototype.resume = function () {
                return (
                  !!a.prototype.resume.call(this) &&
                  (!this.previous && this._sources.length
                    ? (this.prepareNextSource(), !0)
                    : this.previous || this._sources.length || this.generatedError
                    ? void 0
                    : (this.end(), !0))
                )
              }),
              (o.prototype.error = function (t) {
                var e = this._sources
                if (!a.prototype.error.call(this, t)) return !1
                for (var i = 0; i < e.length; i++)
                  try {
                    e[i].error(t)
                  } catch (t) {}
                return !0
              }),
              (o.prototype.lock = function () {
                a.prototype.lock.call(this)
                for (var t = this._sources, e = 0; e < t.length; e++) t[e].lock()
              }),
              (e.exports = o)
          },
          {
            '../crc32': 4,
            '../signature': 23,
            '../stream/GenericWorker': 28,
            '../utf8': 31,
            '../utils': 32
          }
        ],
        9: [
          function (t, e, i) {
            var l = t('../compressions'),
              s = t('./ZipFileWorker')
            i.generateWorker = function (t, e, i) {
              var n = new s(e.streamFiles, i, e.platform, e.encodeFileName),
                a = 0
              try {
                t.forEach(function (t, i) {
                  a++
                  var s = (function (t, e) {
                      var i = t || e,
                        s = l[i]
                      if (!s) throw new Error(i + ' is not a valid compression method !')
                      return s
                    })(i.options.compression, e.compression),
                    c = i.options.compressionOptions || e.compressionOptions || {},
                    d = i.dir,
                    r = i.date
                  i._compressWorker(s, c)
                    .withStreamInfo('file', {
                      name: t,
                      dir: d,
                      date: r,
                      comment: i.comment || '',
                      unixPermissions: i.unixPermissions,
                      dosPermissions: i.dosPermissions
                    })
                    .pipe(n)
                }),
                  (n.entriesCount = a)
              } catch (t) {
                n.error(t)
              }
              return n
            }
          },
          { '../compressions': 3, './ZipFileWorker': 8 }
        ],
        10: [
          function (t, e, i) {
            function l() {
              if (!(this instanceof l)) return new l()
              if (arguments.length)
                throw new Error(
                  'The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.'
                )
              ;(this.files = {}),
                (this.comment = null),
                (this.root = ''),
                (this.clone = function () {
                  var t = new l()
                  for (var e in this) 'function' != typeof this[e] && (t[e] = this[e])
                  return t
                })
            }
            ;((l.prototype = t('./object')).loadAsync = t('./load')),
              (l.support = t('./support')),
              (l.defaults = t('./defaults')),
              (l.version = '3.2.0'),
              (l.loadAsync = function (t, e) {
                return new l().loadAsync(t, e)
              }),
              (l.external = t('./external')),
              (e.exports = l)
          },
          { './defaults': 5, './external': 6, './load': 11, './object': 15, './support': 30 }
        ],
        11: [
          function (t, e, i) {
            var l = t('./utils'),
              s = t('./external'),
              n = t('./utf8'),
              a = ((l = t('./utils')), t('./zipEntries')),
              c = t('./stream/Crc32Probe'),
              d = t('./nodejsUtils')
            function r(t) {
              return new s.Promise(function (e, i) {
                var l = t.decompressed.getContentWorker().pipe(new c())
                l.on('error', function (t) {
                  i(t)
                })
                  .on('end', function () {
                    l.streamInfo.crc32 !== t.decompressed.crc32
                      ? i(new Error('Corrupted zip : CRC32 mismatch'))
                      : e()
                  })
                  .resume()
              })
            }
            e.exports = function (t, e) {
              var i = this
              return (
                (e = l.extend(e || {}, {
                  base64: !1,
                  checkCRC32: !1,
                  optimizedBinaryString: !1,
                  createFolders: !1,
                  decodeFileName: n.utf8decode
                })),
                d.isNode && d.isStream(t)
                  ? s.Promise.reject(
                      new Error("JSZip can't accept a stream when loading a zip file.")
                    )
                  : l
                      .prepareContent(
                        'the loaded zip file',
                        t,
                        !0,
                        e.optimizedBinaryString,
                        e.base64
                      )
                      .then(function (t) {
                        var i = new a(e)
                        return i.load(t), i
                      })
                      .then(function (t) {
                        var i = [s.Promise.resolve(t)],
                          l = t.files
                        if (e.checkCRC32) for (var n = 0; n < l.length; n++) i.push(r(l[n]))
                        return s.Promise.all(i)
                      })
                      .then(function (t) {
                        for (var l = t.shift(), s = l.files, n = 0; n < s.length; n++) {
                          var a = s[n]
                          i.file(a.fileNameStr, a.decompressed, {
                            binary: !0,
                            optimizedBinaryString: !0,
                            date: a.date,
                            dir: a.dir,
                            comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                            unixPermissions: a.unixPermissions,
                            dosPermissions: a.dosPermissions,
                            createFolders: e.createFolders
                          })
                        }
                        return l.zipComment.length && (i.comment = l.zipComment), i
                      })
              )
            }
          },
          {
            './external': 6,
            './nodejsUtils': 14,
            './stream/Crc32Probe': 25,
            './utf8': 31,
            './utils': 32,
            './zipEntries': 33
          }
        ],
        12: [
          function (t, e, i) {
            var l = t('../utils'),
              s = t('../stream/GenericWorker')
            function n(t, e) {
              s.call(this, 'Nodejs stream input adapter for ' + t),
                (this._upstreamEnded = !1),
                this._bindStream(e)
            }
            l.inherits(n, s),
              (n.prototype._bindStream = function (t) {
                var e = this
                ;(this._stream = t).pause(),
                  t
                    .on('data', function (t) {
                      e.push({ data: t, meta: { percent: 0 } })
                    })
                    .on('error', function (t) {
                      e.isPaused ? (this.generatedError = t) : e.error(t)
                    })
                    .on('end', function () {
                      e.isPaused ? (e._upstreamEnded = !0) : e.end()
                    })
              }),
              (n.prototype.pause = function () {
                return !!s.prototype.pause.call(this) && (this._stream.pause(), !0)
              }),
              (n.prototype.resume = function () {
                return (
                  !!s.prototype.resume.call(this) &&
                  (this._upstreamEnded ? this.end() : this._stream.resume(), !0)
                )
              }),
              (e.exports = n)
          },
          { '../stream/GenericWorker': 28, '../utils': 32 }
        ],
        13: [
          function (t, e, i) {
            var l = t('readable-stream').Readable
            function s(t, e, i) {
              l.call(this, e), (this._helper = t)
              var s = this
              t.on('data', function (t, e) {
                s.push(t) || s._helper.pause(), i && i(e)
              })
                .on('error', function (t) {
                  s.emit('error', t)
                })
                .on('end', function () {
                  s.push(null)
                })
            }
            t('../utils').inherits(s, l),
              (s.prototype._read = function () {
                this._helper.resume()
              }),
              (e.exports = s)
          },
          { '../utils': 32, 'readable-stream': 16 }
        ],
        14: [
          function (t, e, i) {
            e.exports = {
              isNode: 'undefined' != typeof Buffer,
              newBufferFrom: function (t, e) {
                if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(t, e)
                if ('number' == typeof t)
                  throw new Error('The "data" argument must not be a number')
                return new Buffer(t, e)
              },
              allocBuffer: function (t) {
                if (Buffer.alloc) return Buffer.alloc(t)
                var e = new Buffer(t)
                return e.fill(0), e
              },
              isBuffer: function (t) {
                return Buffer.isBuffer(t)
              },
              isStream: function (t) {
                return (
                  t &&
                  'function' == typeof t.on &&
                  'function' == typeof t.pause &&
                  'function' == typeof t.resume
                )
              }
            }
          },
          {}
        ],
        15: [
          function (t, e, i) {
            function l(t, e, i) {
              var l,
                s = n.getTypeOf(e),
                c = n.extend(i || {}, d)
              ;(c.date = c.date || new Date()),
                null !== c.compression && (c.compression = c.compression.toUpperCase()),
                'string' == typeof c.unixPermissions &&
                  (c.unixPermissions = parseInt(c.unixPermissions, 8)),
                c.unixPermissions && 16384 & c.unixPermissions && (c.dir = !0),
                c.dosPermissions && 16 & c.dosPermissions && (c.dir = !0),
                c.dir && (t = Z(t)),
                c.createFolders && (l = h(t)) && p.call(this, l, !0)
              var m,
                y = 'string' === s && !1 === c.binary && !1 === c.base64
              ;(i && void 0 !== i.binary) || (c.binary = !y),
                ((e instanceof r && 0 === e.uncompressedSize) || c.dir || !e || 0 === e.length) &&
                  ((c.base64 = !1),
                  (c.binary = !0),
                  (e = ''),
                  (c.compression = 'STORE'),
                  (s = 'string')),
                (m =
                  e instanceof r || e instanceof a
                    ? e
                    : u.isNode && u.isStream(e)
                    ? new b(t, e)
                    : n.prepareContent(t, e, c.binary, c.optimizedBinaryString, c.base64))
              var X = new o(t, m, c)
              this.files[t] = X
            }
            var s = t('./utf8'),
              n = t('./utils'),
              a = t('./stream/GenericWorker'),
              c = t('./stream/StreamHelper'),
              d = t('./defaults'),
              r = t('./compressedObject'),
              o = t('./zipObject'),
              m = t('./generate'),
              u = t('./nodejsUtils'),
              b = t('./nodejs/NodejsStreamInputAdapter'),
              h = function (t) {
                '/' === t.slice(-1) && (t = t.substring(0, t.length - 1))
                var e = t.lastIndexOf('/')
                return 0 < e ? t.substring(0, e) : ''
              },
              Z = function (t) {
                return '/' !== t.slice(-1) && (t += '/'), t
              },
              p = function (t, e) {
                return (
                  (e = void 0 !== e ? e : d.createFolders),
                  (t = Z(t)),
                  this.files[t] || l.call(this, t, null, { dir: !0, createFolders: e }),
                  this.files[t]
                )
              }
            function y(t) {
              return '[object RegExp]' === Object.prototype.toString.call(t)
            }
            var X = {
              load: function () {
                throw new Error(
                  'This method has been removed in JSZip 3.0, please check the upgrade guide.'
                )
              },
              forEach: function (t) {
                var e, i, l
                for (e in this.files)
                  this.files.hasOwnProperty(e) &&
                    ((l = this.files[e]),
                    (i = e.slice(this.root.length, e.length)) &&
                      e.slice(0, this.root.length) === this.root &&
                      t(i, l))
              },
              filter: function (t) {
                var e = []
                return (
                  this.forEach(function (i, l) {
                    t(i, l) && e.push(l)
                  }),
                  e
                )
              },
              file: function (t, e, i) {
                if (1 !== arguments.length) return (t = this.root + t), l.call(this, t, e, i), this
                if (y(t)) {
                  var s = t
                  return this.filter(function (t, e) {
                    return !e.dir && s.test(t)
                  })
                }
                var n = this.files[this.root + t]
                return n && !n.dir ? n : null
              },
              folder: function (t) {
                if (!t) return this
                if (y(t))
                  return this.filter(function (e, i) {
                    return i.dir && t.test(e)
                  })
                var e = this.root + t,
                  i = p.call(this, e),
                  l = this.clone()
                return (l.root = i.name), l
              },
              remove: function (t) {
                t = this.root + t
                var e = this.files[t]
                if ((e || ('/' !== t.slice(-1) && (t += '/'), (e = this.files[t])), e && !e.dir))
                  delete this.files[t]
                else
                  for (
                    var i = this.filter(function (e, i) {
                        return i.name.slice(0, t.length) === t
                      }),
                      l = 0;
                    l < i.length;
                    l++
                  )
                    delete this.files[i[l].name]
                return this
              },
              generate: function (t) {
                throw new Error(
                  'This method has been removed in JSZip 3.0, please check the upgrade guide.'
                )
              },
              generateInternalStream: function (t) {
                var e,
                  i = {}
                try {
                  if (
                    (((i = n.extend(t || {}, {
                      streamFiles: !1,
                      compression: 'STORE',
                      compressionOptions: null,
                      type: '',
                      platform: 'DOS',
                      comment: null,
                      mimeType: 'application/zip',
                      encodeFileName: s.utf8encode
                    })).type = i.type.toLowerCase()),
                    (i.compression = i.compression.toUpperCase()),
                    'binarystring' === i.type && (i.type = 'string'),
                    !i.type)
                  )
                    throw new Error('No output type specified.')
                  n.checkSupport(i.type),
                    ('darwin' !== i.platform &&
                      'freebsd' !== i.platform &&
                      'linux' !== i.platform &&
                      'sunos' !== i.platform) ||
                      (i.platform = 'UNIX'),
                    'win32' === i.platform && (i.platform = 'DOS')
                  var l = i.comment || this.comment || ''
                  e = m.generateWorker(this, i, l)
                } catch (t) {
                  ;(e = new a('error')).error(t)
                }
                return new c(e, i.type || 'string', i.mimeType)
              },
              generateAsync: function (t, e) {
                return this.generateInternalStream(t).accumulate(e)
              },
              generateNodeStream: function (t, e) {
                return (
                  (t = t || {}).type || (t.type = 'nodebuffer'),
                  this.generateInternalStream(t).toNodejsStream(e)
                )
              }
            }
            e.exports = X
          },
          {
            './compressedObject': 2,
            './defaults': 5,
            './generate': 9,
            './nodejs/NodejsStreamInputAdapter': 12,
            './nodejsUtils': 14,
            './stream/GenericWorker': 28,
            './stream/StreamHelper': 29,
            './utf8': 31,
            './utils': 32,
            './zipObject': 35
          }
        ],
        16: [
          function (t, e, i) {
            e.exports = t('stream')
          },
          { stream: void 0 }
        ],
        17: [
          function (t, e, i) {
            var l = t('./DataReader')
            function s(t) {
              l.call(this, t)
              for (var e = 0; e < this.data.length; e++) t[e] = 255 & t[e]
            }
            t('../utils').inherits(s, l),
              (s.prototype.byteAt = function (t) {
                return this.data[this.zero + t]
              }),
              (s.prototype.lastIndexOfSignature = function (t) {
                for (
                  var e = t.charCodeAt(0),
                    i = t.charCodeAt(1),
                    l = t.charCodeAt(2),
                    s = t.charCodeAt(3),
                    n = this.length - 4;
                  0 <= n;
                  --n
                )
                  if (
                    this.data[n] === e &&
                    this.data[n + 1] === i &&
                    this.data[n + 2] === l &&
                    this.data[n + 3] === s
                  )
                    return n - this.zero
                return -1
              }),
              (s.prototype.readAndCheckSignature = function (t) {
                var e = t.charCodeAt(0),
                  i = t.charCodeAt(1),
                  l = t.charCodeAt(2),
                  s = t.charCodeAt(3),
                  n = this.readData(4)
                return e === n[0] && i === n[1] && l === n[2] && s === n[3]
              }),
              (s.prototype.readData = function (t) {
                if ((this.checkOffset(t), 0 === t)) return []
                var e = this.data.slice(this.zero + this.index, this.zero + this.index + t)
                return (this.index += t), e
              }),
              (e.exports = s)
          },
          { '../utils': 32, './DataReader': 18 }
        ],
        18: [
          function (t, e, i) {
            var l = t('../utils')
            function s(t) {
              ;(this.data = t), (this.length = t.length), (this.index = 0), (this.zero = 0)
            }
            ;(s.prototype = {
              checkOffset: function (t) {
                this.checkIndex(this.index + t)
              },
              checkIndex: function (t) {
                if (this.length < this.zero + t || t < 0)
                  throw new Error(
                    'End of data reached (data length = ' +
                      this.length +
                      ', asked index = ' +
                      t +
                      '). Corrupted zip ?'
                  )
              },
              setIndex: function (t) {
                this.checkIndex(t), (this.index = t)
              },
              skip: function (t) {
                this.setIndex(this.index + t)
              },
              byteAt: function (t) {},
              readInt: function (t) {
                var e,
                  i = 0
                for (this.checkOffset(t), e = this.index + t - 1; e >= this.index; e--)
                  i = (i << 8) + this.byteAt(e)
                return (this.index += t), i
              },
              readString: function (t) {
                return l.transformTo('string', this.readData(t))
              },
              readData: function (t) {},
              lastIndexOfSignature: function (t) {},
              readAndCheckSignature: function (t) {},
              readDate: function () {
                var t = this.readInt(4)
                return new Date(
                  Date.UTC(
                    1980 + ((t >> 25) & 127),
                    ((t >> 21) & 15) - 1,
                    (t >> 16) & 31,
                    (t >> 11) & 31,
                    (t >> 5) & 63,
                    (31 & t) << 1
                  )
                )
              }
            }),
              (e.exports = s)
          },
          { '../utils': 32 }
        ],
        19: [
          function (t, e, i) {
            var l = t('./Uint8ArrayReader')
            function s(t) {
              l.call(this, t)
            }
            t('../utils').inherits(s, l),
              (s.prototype.readData = function (t) {
                this.checkOffset(t)
                var e = this.data.slice(this.zero + this.index, this.zero + this.index + t)
                return (this.index += t), e
              }),
              (e.exports = s)
          },
          { '../utils': 32, './Uint8ArrayReader': 21 }
        ],
        20: [
          function (t, e, i) {
            var l = t('./DataReader')
            function s(t) {
              l.call(this, t)
            }
            t('../utils').inherits(s, l),
              (s.prototype.byteAt = function (t) {
                return this.data.charCodeAt(this.zero + t)
              }),
              (s.prototype.lastIndexOfSignature = function (t) {
                return this.data.lastIndexOf(t) - this.zero
              }),
              (s.prototype.readAndCheckSignature = function (t) {
                return t === this.readData(4)
              }),
              (s.prototype.readData = function (t) {
                this.checkOffset(t)
                var e = this.data.slice(this.zero + this.index, this.zero + this.index + t)
                return (this.index += t), e
              }),
              (e.exports = s)
          },
          { '../utils': 32, './DataReader': 18 }
        ],
        21: [
          function (t, e, i) {
            var l = t('./ArrayReader')
            function s(t) {
              l.call(this, t)
            }
            t('../utils').inherits(s, l),
              (s.prototype.readData = function (t) {
                if ((this.checkOffset(t), 0 === t)) return new Uint8Array(0)
                var e = this.data.subarray(this.zero + this.index, this.zero + this.index + t)
                return (this.index += t), e
              }),
              (e.exports = s)
          },
          { '../utils': 32, './ArrayReader': 17 }
        ],
        22: [
          function (t, e, i) {
            var l = t('../utils'),
              s = t('../support'),
              n = t('./ArrayReader'),
              a = t('./StringReader'),
              c = t('./NodeBufferReader'),
              d = t('./Uint8ArrayReader')
            e.exports = function (t) {
              var e = l.getTypeOf(t)
              return (
                l.checkSupport(e),
                'string' !== e || s.uint8array
                  ? 'nodebuffer' === e
                    ? new c(t)
                    : s.uint8array
                    ? new d(l.transformTo('uint8array', t))
                    : new n(l.transformTo('array', t))
                  : new a(t)
              )
            }
          },
          {
            '../support': 30,
            '../utils': 32,
            './ArrayReader': 17,
            './NodeBufferReader': 19,
            './StringReader': 20,
            './Uint8ArrayReader': 21
          }
        ],
        23: [
          function (t, e, i) {
            ;(i.LOCAL_FILE_HEADER = 'PK'),
              (i.CENTRAL_FILE_HEADER = 'PK'),
              (i.CENTRAL_DIRECTORY_END = 'PK'),
              (i.ZIP64_CENTRAL_DIRECTORY_LOCATOR = 'PK'),
              (i.ZIP64_CENTRAL_DIRECTORY_END = 'PK'),
              (i.DATA_DESCRIPTOR = 'PK\b')
          },
          {}
        ],
        24: [
          function (t, e, i) {
            var l = t('./GenericWorker'),
              s = t('../utils')
            function n(t) {
              l.call(this, 'ConvertWorker to ' + t), (this.destType = t)
            }
            s.inherits(n, l),
              (n.prototype.processChunk = function (t) {
                this.push({ data: s.transformTo(this.destType, t.data), meta: t.meta })
              }),
              (e.exports = n)
          },
          { '../utils': 32, './GenericWorker': 28 }
        ],
        25: [
          function (t, e, i) {
            var l = t('./GenericWorker'),
              s = t('../crc32')
            function n() {
              l.call(this, 'Crc32Probe'), this.withStreamInfo('crc32', 0)
            }
            t('../utils').inherits(n, l),
              (n.prototype.processChunk = function (t) {
                ;(this.streamInfo.crc32 = s(t.data, this.streamInfo.crc32 || 0)), this.push(t)
              }),
              (e.exports = n)
          },
          { '../crc32': 4, '../utils': 32, './GenericWorker': 28 }
        ],
        26: [
          function (t, e, i) {
            var l = t('../utils'),
              s = t('./GenericWorker')
            function n(t) {
              s.call(this, 'DataLengthProbe for ' + t),
                (this.propName = t),
                this.withStreamInfo(t, 0)
            }
            l.inherits(n, s),
              (n.prototype.processChunk = function (t) {
                if (t) {
                  var e = this.streamInfo[this.propName] || 0
                  this.streamInfo[this.propName] = e + t.data.length
                }
                s.prototype.processChunk.call(this, t)
              }),
              (e.exports = n)
          },
          { '../utils': 32, './GenericWorker': 28 }
        ],
        27: [
          function (t, e, i) {
            var l = t('../utils'),
              s = t('./GenericWorker')
            function n(t) {
              s.call(this, 'DataWorker')
              var e = this
              ;(this.dataIsReady = !1),
                (this.index = 0),
                (this.max = 0),
                (this.data = null),
                (this.type = ''),
                (this._tickScheduled = !1),
                t.then(
                  function (t) {
                    ;(e.dataIsReady = !0),
                      (e.data = t),
                      (e.max = (t && t.length) || 0),
                      (e.type = l.getTypeOf(t)),
                      e.isPaused || e._tickAndRepeat()
                  },
                  function (t) {
                    e.error(t)
                  }
                )
            }
            l.inherits(n, s),
              (n.prototype.cleanUp = function () {
                s.prototype.cleanUp.call(this), (this.data = null)
              }),
              (n.prototype.resume = function () {
                return (
                  !!s.prototype.resume.call(this) &&
                  (!this._tickScheduled &&
                    this.dataIsReady &&
                    ((this._tickScheduled = !0), l.delay(this._tickAndRepeat, [], this)),
                  !0)
                )
              }),
              (n.prototype._tickAndRepeat = function () {
                ;(this._tickScheduled = !1),
                  this.isPaused ||
                    this.isFinished ||
                    (this._tick(),
                    this.isFinished ||
                      (l.delay(this._tickAndRepeat, [], this), (this._tickScheduled = !0)))
              }),
              (n.prototype._tick = function () {
                if (this.isPaused || this.isFinished) return !1
                var t = null,
                  e = Math.min(this.max, this.index + 16384)
                if (this.index >= this.max) return this.end()
                switch (this.type) {
                  case 'string':
                    t = this.data.substring(this.index, e)
                    break
                  case 'uint8array':
                    t = this.data.subarray(this.index, e)
                    break
                  case 'array':
                  case 'nodebuffer':
                    t = this.data.slice(this.index, e)
                }
                return (
                  (this.index = e),
                  this.push({
                    data: t,
                    meta: { percent: this.max ? (this.index / this.max) * 100 : 0 }
                  })
                )
              }),
              (e.exports = n)
          },
          { '../utils': 32, './GenericWorker': 28 }
        ],
        28: [
          function (t, e, i) {
            function l(t) {
              ;(this.name = t || 'default'),
                (this.streamInfo = {}),
                (this.generatedError = null),
                (this.extraStreamInfo = {}),
                (this.isPaused = !0),
                (this.isFinished = !1),
                (this.isLocked = !1),
                (this._listeners = { data: [], end: [], error: [] }),
                (this.previous = null)
            }
            ;(l.prototype = {
              push: function (t) {
                this.emit('data', t)
              },
              end: function () {
                if (this.isFinished) return !1
                this.flush()
                try {
                  this.emit('end'), this.cleanUp(), (this.isFinished = !0)
                } catch (t) {
                  this.emit('error', t)
                }
                return !0
              },
              error: function (t) {
                return (
                  !this.isFinished &&
                  (this.isPaused
                    ? (this.generatedError = t)
                    : ((this.isFinished = !0),
                      this.emit('error', t),
                      this.previous && this.previous.error(t),
                      this.cleanUp()),
                  !0)
                )
              },
              on: function (t, e) {
                return this._listeners[t].push(e), this
              },
              cleanUp: function () {
                ;(this.streamInfo = this.generatedError = this.extraStreamInfo = null),
                  (this._listeners = [])
              },
              emit: function (t, e) {
                if (this._listeners[t])
                  for (var i = 0; i < this._listeners[t].length; i++)
                    this._listeners[t][i].call(this, e)
              },
              pipe: function (t) {
                return t.registerPrevious(this)
              },
              registerPrevious: function (t) {
                if (this.isLocked)
                  throw new Error("The stream '" + this + "' has already been used.")
                ;(this.streamInfo = t.streamInfo), this.mergeStreamInfo(), (this.previous = t)
                var e = this
                return (
                  t.on('data', function (t) {
                    e.processChunk(t)
                  }),
                  t.on('end', function () {
                    e.end()
                  }),
                  t.on('error', function (t) {
                    e.error(t)
                  }),
                  this
                )
              },
              pause: function () {
                return (
                  !this.isPaused &&
                  !this.isFinished &&
                  ((this.isPaused = !0), this.previous && this.previous.pause(), !0)
                )
              },
              resume: function () {
                if (!this.isPaused || this.isFinished) return !1
                var t = (this.isPaused = !1)
                return (
                  this.generatedError && (this.error(this.generatedError), (t = !0)),
                  this.previous && this.previous.resume(),
                  !t
                )
              },
              flush: function () {},
              processChunk: function (t) {
                this.push(t)
              },
              withStreamInfo: function (t, e) {
                return (this.extraStreamInfo[t] = e), this.mergeStreamInfo(), this
              },
              mergeStreamInfo: function () {
                for (var t in this.extraStreamInfo)
                  this.extraStreamInfo.hasOwnProperty(t) &&
                    (this.streamInfo[t] = this.extraStreamInfo[t])
              },
              lock: function () {
                if (this.isLocked)
                  throw new Error("The stream '" + this + "' has already been used.")
                ;(this.isLocked = !0), this.previous && this.previous.lock()
              },
              toString: function () {
                var t = 'Worker ' + this.name
                return this.previous ? this.previous + ' -> ' + t : t
              }
            }),
              (e.exports = l)
          },
          {}
        ],
        29: [
          function (t, e, i) {
            var l = t('../utils'),
              s = t('./ConvertWorker'),
              n = t('./GenericWorker'),
              a = t('../base64'),
              c = t('../support'),
              d = t('../external'),
              r = null
            if (c.nodestream)
              try {
                r = t('../nodejs/NodejsStreamOutputAdapter')
              } catch (t) {}
            function o(t, e, i) {
              var a = e
              switch (e) {
                case 'blob':
                case 'arraybuffer':
                  a = 'uint8array'
                  break
                case 'base64':
                  a = 'string'
              }
              try {
                ;(this._internalType = a),
                  (this._outputType = e),
                  (this._mimeType = i),
                  l.checkSupport(a),
                  (this._worker = t.pipe(new s(a))),
                  t.lock()
              } catch (t) {
                ;(this._worker = new n('error')), this._worker.error(t)
              }
            }
            ;(o.prototype = {
              accumulate: function (t) {
                return (function (t, e) {
                  return new d.Promise(function (i, s) {
                    var n = [],
                      c = t._internalType,
                      d = t._outputType,
                      r = t._mimeType
                    t.on('data', function (t, i) {
                      n.push(t), e && e(i)
                    })
                      .on('error', function (t) {
                        ;(n = []), s(t)
                      })
                      .on('end', function () {
                        try {
                          var t = (function (t, e, i) {
                            switch (t) {
                              case 'blob':
                                return l.newBlob(l.transformTo('arraybuffer', e), i)
                              case 'base64':
                                return a.encode(e)
                              default:
                                return l.transformTo(t, e)
                            }
                          })(
                            d,
                            (function (t, e) {
                              var i,
                                l = 0,
                                s = null,
                                n = 0
                              for (i = 0; i < e.length; i++) n += e[i].length
                              switch (t) {
                                case 'string':
                                  return e.join('')
                                case 'array':
                                  return Array.prototype.concat.apply([], e)
                                case 'uint8array':
                                  for (s = new Uint8Array(n), i = 0; i < e.length; i++)
                                    s.set(e[i], l), (l += e[i].length)
                                  return s
                                case 'nodebuffer':
                                  return Buffer.concat(e)
                                default:
                                  throw new Error("concat : unsupported type '" + t + "'")
                              }
                            })(c, n),
                            r
                          )
                          i(t)
                        } catch (t) {
                          s(t)
                        }
                        n = []
                      })
                      .resume()
                  })
                })(this, t)
              },
              on: function (t, e) {
                var i = this
                return (
                  'data' === t
                    ? this._worker.on(t, function (t) {
                        e.call(i, t.data, t.meta)
                      })
                    : this._worker.on(t, function () {
                        l.delay(e, arguments, i)
                      }),
                  this
                )
              },
              resume: function () {
                return l.delay(this._worker.resume, [], this._worker), this
              },
              pause: function () {
                return this._worker.pause(), this
              },
              toNodejsStream: function (t) {
                if ((l.checkSupport('nodestream'), 'nodebuffer' !== this._outputType))
                  throw new Error(this._outputType + ' is not supported by this method')
                return new r(this, { objectMode: 'nodebuffer' !== this._outputType }, t)
              }
            }),
              (e.exports = o)
          },
          {
            '../base64': 1,
            '../external': 6,
            '../nodejs/NodejsStreamOutputAdapter': 13,
            '../support': 30,
            '../utils': 32,
            './ConvertWorker': 24,
            './GenericWorker': 28
          }
        ],
        30: [
          function (t, e, i) {
            if (
              ((i.base64 = !0),
              (i.array = !0),
              (i.string = !0),
              (i.arraybuffer =
                'undefined' != typeof ArrayBuffer && 'undefined' != typeof Uint8Array),
              (i.nodebuffer = 'undefined' != typeof Buffer),
              (i.uint8array = 'undefined' != typeof Uint8Array),
              'undefined' == typeof ArrayBuffer)
            )
              i.blob = !1
            else {
              var l = new ArrayBuffer(0)
              try {
                i.blob = 0 === new Blob([l], { type: 'application/zip' }).size
              } catch (t) {
                try {
                  var s = new (self.BlobBuilder ||
                    self.WebKitBlobBuilder ||
                    self.MozBlobBuilder ||
                    self.MSBlobBuilder)()
                  s.append(l), (i.blob = 0 === s.getBlob('application/zip').size)
                } catch (t) {
                  i.blob = !1
                }
              }
            }
            try {
              i.nodestream = !!t('readable-stream').Readable
            } catch (t) {
              i.nodestream = !1
            }
          },
          { 'readable-stream': 16 }
        ],
        31: [
          function (t, e, i) {
            for (
              var l = t('./utils'),
                s = t('./support'),
                n = t('./nodejsUtils'),
                a = t('./stream/GenericWorker'),
                c = new Array(256),
                d = 0;
              d < 256;
              d++
            )
              c[d] = 252 <= d ? 6 : 248 <= d ? 5 : 240 <= d ? 4 : 224 <= d ? 3 : 192 <= d ? 2 : 1
            function r() {
              a.call(this, 'utf-8 decode'), (this.leftOver = null)
            }
            function o() {
              a.call(this, 'utf-8 encode')
            }
            ;(c[254] = c[254] = 1),
              (i.utf8encode = function (t) {
                return s.nodebuffer
                  ? n.newBufferFrom(t, 'utf-8')
                  : (function (t) {
                      var e,
                        i,
                        l,
                        n,
                        a,
                        c = t.length,
                        d = 0
                      for (n = 0; n < c; n++)
                        55296 == (64512 & (i = t.charCodeAt(n))) &&
                          n + 1 < c &&
                          56320 == (64512 & (l = t.charCodeAt(n + 1))) &&
                          ((i = 65536 + ((i - 55296) << 10) + (l - 56320)), n++),
                          (d += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4)
                      for (
                        e = s.uint8array ? new Uint8Array(d) : new Array(d), n = a = 0;
                        a < d;
                        n++
                      )
                        55296 == (64512 & (i = t.charCodeAt(n))) &&
                          n + 1 < c &&
                          56320 == (64512 & (l = t.charCodeAt(n + 1))) &&
                          ((i = 65536 + ((i - 55296) << 10) + (l - 56320)), n++),
                          i < 128
                            ? (e[a++] = i)
                            : (i < 2048
                                ? (e[a++] = 192 | (i >>> 6))
                                : (i < 65536
                                    ? (e[a++] = 224 | (i >>> 12))
                                    : ((e[a++] = 240 | (i >>> 18)),
                                      (e[a++] = 128 | ((i >>> 12) & 63))),
                                  (e[a++] = 128 | ((i >>> 6) & 63))),
                              (e[a++] = 128 | (63 & i)))
                      return e
                    })(t)
              }),
              (i.utf8decode = function (t) {
                return s.nodebuffer
                  ? l.transformTo('nodebuffer', t).toString('utf-8')
                  : (function (t) {
                      var e,
                        i,
                        s,
                        n,
                        a = t.length,
                        d = new Array(2 * a)
                      for (e = i = 0; e < a; )
                        if ((s = t[e++]) < 128) d[i++] = s
                        else if (4 < (n = c[s])) (d[i++] = 65533), (e += n - 1)
                        else {
                          for (s &= 2 === n ? 31 : 3 === n ? 15 : 7; 1 < n && e < a; )
                            (s = (s << 6) | (63 & t[e++])), n--
                          1 < n
                            ? (d[i++] = 65533)
                            : s < 65536
                            ? (d[i++] = s)
                            : ((s -= 65536),
                              (d[i++] = 55296 | ((s >> 10) & 1023)),
                              (d[i++] = 56320 | (1023 & s)))
                        }
                      return (
                        d.length !== i && (d.subarray ? (d = d.subarray(0, i)) : (d.length = i)),
                        l.applyFromCharCode(d)
                      )
                    })((t = l.transformTo(s.uint8array ? 'uint8array' : 'array', t)))
              }),
              l.inherits(r, a),
              (r.prototype.processChunk = function (t) {
                var e = l.transformTo(s.uint8array ? 'uint8array' : 'array', t.data)
                if (this.leftOver && this.leftOver.length) {
                  if (s.uint8array) {
                    var n = e
                    ;(e = new Uint8Array(n.length + this.leftOver.length)).set(this.leftOver, 0),
                      e.set(n, this.leftOver.length)
                  } else e = this.leftOver.concat(e)
                  this.leftOver = null
                }
                var a = (function (t, e) {
                    var i
                    for (
                      (e = e || t.length) > t.length && (e = t.length), i = e - 1;
                      0 <= i && 128 == (192 & t[i]);

                    )
                      i--
                    return i < 0 ? e : 0 === i ? e : i + c[t[i]] > e ? i : e
                  })(e),
                  d = e
                a !== e.length &&
                  (s.uint8array
                    ? ((d = e.subarray(0, a)), (this.leftOver = e.subarray(a, e.length)))
                    : ((d = e.slice(0, a)), (this.leftOver = e.slice(a, e.length)))),
                  this.push({ data: i.utf8decode(d), meta: t.meta })
              }),
              (r.prototype.flush = function () {
                this.leftOver &&
                  this.leftOver.length &&
                  (this.push({ data: i.utf8decode(this.leftOver), meta: {} }),
                  (this.leftOver = null))
              }),
              (i.Utf8DecodeWorker = r),
              l.inherits(o, a),
              (o.prototype.processChunk = function (t) {
                this.push({ data: i.utf8encode(t.data), meta: t.meta })
              }),
              (i.Utf8EncodeWorker = o)
          },
          { './nodejsUtils': 14, './stream/GenericWorker': 28, './support': 30, './utils': 32 }
        ],
        32: [
          function (t, e, i) {
            var l = t('./support'),
              s = t('./base64'),
              n = t('./nodejsUtils'),
              a = t('set-immediate-shim'),
              c = t('./external')
            function d(t) {
              return t
            }
            function r(t, e) {
              for (var i = 0; i < t.length; ++i) e[i] = 255 & t.charCodeAt(i)
              return e
            }
            i.newBlob = function (t, e) {
              i.checkSupport('blob')
              try {
                return new Blob([t], { type: e })
              } catch (i) {
                try {
                  var l = new (self.BlobBuilder ||
                    self.WebKitBlobBuilder ||
                    self.MozBlobBuilder ||
                    self.MSBlobBuilder)()
                  return l.append(t), l.getBlob(e)
                } catch (t) {
                  throw new Error("Bug : can't construct the Blob.")
                }
              }
            }
            var o = {
              stringifyByChunk: function (t, e, i) {
                var l = [],
                  s = 0,
                  n = t.length
                if (n <= i) return String.fromCharCode.apply(null, t)
                for (; s < n; )
                  'array' === e || 'nodebuffer' === e
                    ? l.push(String.fromCharCode.apply(null, t.slice(s, Math.min(s + i, n))))
                    : l.push(String.fromCharCode.apply(null, t.subarray(s, Math.min(s + i, n)))),
                    (s += i)
                return l.join('')
              },
              stringifyByChar: function (t) {
                for (var e = '', i = 0; i < t.length; i++) e += String.fromCharCode(t[i])
                return e
              },
              applyCanBeUsed: {
                uint8array: (function () {
                  try {
                    return (
                      l.uint8array &&
                      1 === String.fromCharCode.apply(null, new Uint8Array(1)).length
                    )
                  } catch (t) {
                    return !1
                  }
                })(),
                nodebuffer: (function () {
                  try {
                    return (
                      l.nodebuffer && 1 === String.fromCharCode.apply(null, n.allocBuffer(1)).length
                    )
                  } catch (t) {
                    return !1
                  }
                })()
              }
            }
            function m(t) {
              var e = 65536,
                l = i.getTypeOf(t),
                s = !0
              if (
                ('uint8array' === l
                  ? (s = o.applyCanBeUsed.uint8array)
                  : 'nodebuffer' === l && (s = o.applyCanBeUsed.nodebuffer),
                s)
              )
                for (; 1 < e; )
                  try {
                    return o.stringifyByChunk(t, l, e)
                  } catch (t) {
                    e = Math.floor(e / 2)
                  }
              return o.stringifyByChar(t)
            }
            function u(t, e) {
              for (var i = 0; i < t.length; i++) e[i] = t[i]
              return e
            }
            i.applyFromCharCode = m
            var b = {}
            ;(b.string = {
              string: d,
              array: function (t) {
                return r(t, new Array(t.length))
              },
              arraybuffer: function (t) {
                return b.string.uint8array(t).buffer
              },
              uint8array: function (t) {
                return r(t, new Uint8Array(t.length))
              },
              nodebuffer: function (t) {
                return r(t, n.allocBuffer(t.length))
              }
            }),
              (b.array = {
                string: m,
                array: d,
                arraybuffer: function (t) {
                  return new Uint8Array(t).buffer
                },
                uint8array: function (t) {
                  return new Uint8Array(t)
                },
                nodebuffer: function (t) {
                  return n.newBufferFrom(t)
                }
              }),
              (b.arraybuffer = {
                string: function (t) {
                  return m(new Uint8Array(t))
                },
                array: function (t) {
                  return u(new Uint8Array(t), new Array(t.byteLength))
                },
                arraybuffer: d,
                uint8array: function (t) {
                  return new Uint8Array(t)
                },
                nodebuffer: function (t) {
                  return n.newBufferFrom(new Uint8Array(t))
                }
              }),
              (b.uint8array = {
                string: m,
                array: function (t) {
                  return u(t, new Array(t.length))
                },
                arraybuffer: function (t) {
                  return t.buffer
                },
                uint8array: d,
                nodebuffer: function (t) {
                  return n.newBufferFrom(t)
                }
              }),
              (b.nodebuffer = {
                string: m,
                array: function (t) {
                  return u(t, new Array(t.length))
                },
                arraybuffer: function (t) {
                  return b.nodebuffer.uint8array(t).buffer
                },
                uint8array: function (t) {
                  return u(t, new Uint8Array(t.length))
                },
                nodebuffer: d
              }),
              (i.transformTo = function (t, e) {
                if (((e = e || ''), !t)) return e
                i.checkSupport(t)
                var l = i.getTypeOf(e)
                return b[l][t](e)
              }),
              (i.getTypeOf = function (t) {
                return 'string' == typeof t
                  ? 'string'
                  : '[object Array]' === Object.prototype.toString.call(t)
                  ? 'array'
                  : l.nodebuffer && n.isBuffer(t)
                  ? 'nodebuffer'
                  : l.uint8array && t instanceof Uint8Array
                  ? 'uint8array'
                  : l.arraybuffer && t instanceof ArrayBuffer
                  ? 'arraybuffer'
                  : void 0
              }),
              (i.checkSupport = function (t) {
                if (!l[t.toLowerCase()]) throw new Error(t + ' is not supported by this platform')
              }),
              (i.MAX_VALUE_16BITS = 65535),
              (i.MAX_VALUE_32BITS = -1),
              (i.pretty = function (t) {
                var e,
                  i,
                  l = ''
                for (i = 0; i < (t || '').length; i++)
                  l +=
                    '\\x' + ((e = t.charCodeAt(i)) < 16 ? '0' : '') + e.toString(16).toUpperCase()
                return l
              }),
              (i.delay = function (t, e, i) {
                a(function () {
                  t.apply(i || null, e || [])
                })
              }),
              (i.inherits = function (t, e) {
                function i() {}
                ;(i.prototype = e.prototype), (t.prototype = new i())
              }),
              (i.extend = function () {
                var t,
                  e,
                  i = {}
                for (t = 0; t < arguments.length; t++)
                  for (e in arguments[t])
                    arguments[t].hasOwnProperty(e) && void 0 === i[e] && (i[e] = arguments[t][e])
                return i
              }),
              (i.prepareContent = function (t, e, n, a, d) {
                return c.Promise.resolve(e)
                  .then(function (t) {
                    return l.blob &&
                      (t instanceof Blob ||
                        -1 !==
                          ['[object File]', '[object Blob]'].indexOf(
                            Object.prototype.toString.call(t)
                          )) &&
                      'undefined' != typeof FileReader
                      ? new c.Promise(function (e, i) {
                          var l = new FileReader()
                          ;(l.onload = function (t) {
                            e(t.target.result)
                          }),
                            (l.onerror = function (t) {
                              i(t.target.error)
                            }),
                            l.readAsArrayBuffer(t)
                        })
                      : t
                  })
                  .then(function (e) {
                    var o = i.getTypeOf(e)
                    return o
                      ? ('arraybuffer' === o
                          ? (e = i.transformTo('uint8array', e))
                          : 'string' === o &&
                            (d
                              ? (e = s.decode(e))
                              : n &&
                                !0 !== a &&
                                (e = (function (t) {
                                  return r(
                                    t,
                                    l.uint8array ? new Uint8Array(t.length) : new Array(t.length)
                                  )
                                })(e))),
                        e)
                      : c.Promise.reject(
                          new Error(
                            "Can't read the data of '" +
                              t +
                              "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"
                          )
                        )
                  })
              })
          },
          {
            './base64': 1,
            './external': 6,
            './nodejsUtils': 14,
            './support': 30,
            'set-immediate-shim': 54
          }
        ],
        33: [
          function (t, e, i) {
            var l = t('./reader/readerFor'),
              s = t('./utils'),
              n = t('./signature'),
              a = t('./zipEntry'),
              c = (t('./utf8'), t('./support'))
            function d(t) {
              ;(this.files = []), (this.loadOptions = t)
            }
            ;(d.prototype = {
              checkSignature: function (t) {
                if (!this.reader.readAndCheckSignature(t)) {
                  this.reader.index -= 4
                  var e = this.reader.readString(4)
                  throw new Error(
                    'Corrupted zip or bug: unexpected signature (' +
                      s.pretty(e) +
                      ', expected ' +
                      s.pretty(t) +
                      ')'
                  )
                }
              },
              isSignature: function (t, e) {
                var i = this.reader.index
                this.reader.setIndex(t)
                var l = this.reader.readString(4) === e
                return this.reader.setIndex(i), l
              },
              readBlockEndOfCentral: function () {
                ;(this.diskNumber = this.reader.readInt(2)),
                  (this.diskWithCentralDirStart = this.reader.readInt(2)),
                  (this.centralDirRecordsOnThisDisk = this.reader.readInt(2)),
                  (this.centralDirRecords = this.reader.readInt(2)),
                  (this.centralDirSize = this.reader.readInt(4)),
                  (this.centralDirOffset = this.reader.readInt(4)),
                  (this.zipCommentLength = this.reader.readInt(2))
                var t = this.reader.readData(this.zipCommentLength),
                  e = c.uint8array ? 'uint8array' : 'array',
                  i = s.transformTo(e, t)
                this.zipComment = this.loadOptions.decodeFileName(i)
              },
              readBlockZip64EndOfCentral: function () {
                ;(this.zip64EndOfCentralSize = this.reader.readInt(8)),
                  this.reader.skip(4),
                  (this.diskNumber = this.reader.readInt(4)),
                  (this.diskWithCentralDirStart = this.reader.readInt(4)),
                  (this.centralDirRecordsOnThisDisk = this.reader.readInt(8)),
                  (this.centralDirRecords = this.reader.readInt(8)),
                  (this.centralDirSize = this.reader.readInt(8)),
                  (this.centralDirOffset = this.reader.readInt(8)),
                  (this.zip64ExtensibleData = {})
                for (var t, e, i, l = this.zip64EndOfCentralSize - 44; 0 < l; )
                  (t = this.reader.readInt(2)),
                    (e = this.reader.readInt(4)),
                    (i = this.reader.readData(e)),
                    (this.zip64ExtensibleData[t] = { id: t, length: e, value: i })
              },
              readBlockZip64EndOfCentralLocator: function () {
                if (
                  ((this.diskWithZip64CentralDirStart = this.reader.readInt(4)),
                  (this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8)),
                  (this.disksCount = this.reader.readInt(4)),
                  1 < this.disksCount)
                )
                  throw new Error('Multi-volumes zip are not supported')
              },
              readLocalFiles: function () {
                var t, e
                for (t = 0; t < this.files.length; t++)
                  (e = this.files[t]),
                    this.reader.setIndex(e.localHeaderOffset),
                    this.checkSignature(n.LOCAL_FILE_HEADER),
                    e.readLocalPart(this.reader),
                    e.handleUTF8(),
                    e.processAttributes()
              },
              readCentralDir: function () {
                var t
                for (
                  this.reader.setIndex(this.centralDirOffset);
                  this.reader.readAndCheckSignature(n.CENTRAL_FILE_HEADER);

                )
                  (t = new a({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader),
                    this.files.push(t)
                if (
                  this.centralDirRecords !== this.files.length &&
                  0 !== this.centralDirRecords &&
                  0 === this.files.length
                )
                  throw new Error(
                    'Corrupted zip or bug: expected ' +
                      this.centralDirRecords +
                      ' records in central dir, got ' +
                      this.files.length
                  )
              },
              readEndOfCentral: function () {
                var t = this.reader.lastIndexOfSignature(n.CENTRAL_DIRECTORY_END)
                if (t < 0)
                  throw this.isSignature(0, n.LOCAL_FILE_HEADER)
                    ? new Error("Corrupted zip: can't find end of central directory")
                    : new Error(
                        "Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"
                      )
                this.reader.setIndex(t)
                var e = t
                if (
                  (this.checkSignature(n.CENTRAL_DIRECTORY_END),
                  this.readBlockEndOfCentral(),
                  this.diskNumber === s.MAX_VALUE_16BITS ||
                    this.diskWithCentralDirStart === s.MAX_VALUE_16BITS ||
                    this.centralDirRecordsOnThisDisk === s.MAX_VALUE_16BITS ||
                    this.centralDirRecords === s.MAX_VALUE_16BITS ||
                    this.centralDirSize === s.MAX_VALUE_32BITS ||
                    this.centralDirOffset === s.MAX_VALUE_32BITS)
                ) {
                  if (
                    ((this.zip64 = !0),
                    (t = this.reader.lastIndexOfSignature(n.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
                  )
                    throw new Error(
                      "Corrupted zip: can't find the ZIP64 end of central directory locator"
                    )
                  if (
                    (this.reader.setIndex(t),
                    this.checkSignature(n.ZIP64_CENTRAL_DIRECTORY_LOCATOR),
                    this.readBlockZip64EndOfCentralLocator(),
                    !this.isSignature(
                      this.relativeOffsetEndOfZip64CentralDir,
                      n.ZIP64_CENTRAL_DIRECTORY_END
                    ) &&
                      ((this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(
                        n.ZIP64_CENTRAL_DIRECTORY_END
                      )),
                      this.relativeOffsetEndOfZip64CentralDir < 0))
                  )
                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory")
                  this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),
                    this.checkSignature(n.ZIP64_CENTRAL_DIRECTORY_END),
                    this.readBlockZip64EndOfCentral()
                }
                var i = this.centralDirOffset + this.centralDirSize
                this.zip64 && ((i += 20), (i += 12 + this.zip64EndOfCentralSize))
                var l = e - i
                if (0 < l) this.isSignature(e, n.CENTRAL_FILE_HEADER) || (this.reader.zero = l)
                else if (l < 0) throw new Error('Corrupted zip: missing ' + Math.abs(l) + ' bytes.')
              },
              prepareReader: function (t) {
                this.reader = l(t)
              },
              load: function (t) {
                this.prepareReader(t),
                  this.readEndOfCentral(),
                  this.readCentralDir(),
                  this.readLocalFiles()
              }
            }),
              (e.exports = d)
          },
          {
            './reader/readerFor': 22,
            './signature': 23,
            './support': 30,
            './utf8': 31,
            './utils': 32,
            './zipEntry': 34
          }
        ],
        34: [
          function (t, e, i) {
            var l = t('./reader/readerFor'),
              s = t('./utils'),
              n = t('./compressedObject'),
              a = t('./crc32'),
              c = t('./utf8'),
              d = t('./compressions'),
              r = t('./support')
            function o(t, e) {
              ;(this.options = t), (this.loadOptions = e)
            }
            ;(o.prototype = {
              isEncrypted: function () {
                return 1 == (1 & this.bitFlag)
              },
              useUTF8: function () {
                return 2048 == (2048 & this.bitFlag)
              },
              readLocalPart: function (t) {
                var e, i
                if (
                  (t.skip(22),
                  (this.fileNameLength = t.readInt(2)),
                  (i = t.readInt(2)),
                  (this.fileName = t.readData(this.fileNameLength)),
                  t.skip(i),
                  -1 === this.compressedSize || -1 === this.uncompressedSize)
                )
                  throw new Error(
                    "Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize === -1 || uncompressedSize === -1)"
                  )
                if (
                  null ===
                  (e = (function (t) {
                    for (var e in d) if (d.hasOwnProperty(e) && d[e].magic === t) return d[e]
                    return null
                  })(this.compressionMethod))
                )
                  throw new Error(
                    'Corrupted zip : compression ' +
                      s.pretty(this.compressionMethod) +
                      ' unknown (inner file : ' +
                      s.transformTo('string', this.fileName) +
                      ')'
                  )
                this.decompressed = new n(
                  this.compressedSize,
                  this.uncompressedSize,
                  this.crc32,
                  e,
                  t.readData(this.compressedSize)
                )
              },
              readCentralPart: function (t) {
                ;(this.versionMadeBy = t.readInt(2)),
                  t.skip(2),
                  (this.bitFlag = t.readInt(2)),
                  (this.compressionMethod = t.readString(2)),
                  (this.date = t.readDate()),
                  (this.crc32 = t.readInt(4)),
                  (this.compressedSize = t.readInt(4)),
                  (this.uncompressedSize = t.readInt(4))
                var e = t.readInt(2)
                if (
                  ((this.extraFieldsLength = t.readInt(2)),
                  (this.fileCommentLength = t.readInt(2)),
                  (this.diskNumberStart = t.readInt(2)),
                  (this.internalFileAttributes = t.readInt(2)),
                  (this.externalFileAttributes = t.readInt(4)),
                  (this.localHeaderOffset = t.readInt(4)),
                  this.isEncrypted())
                )
                  throw new Error('Encrypted zip are not supported')
                t.skip(e),
                  this.readExtraFields(t),
                  this.parseZIP64ExtraField(t),
                  (this.fileComment = t.readData(this.fileCommentLength))
              },
              processAttributes: function () {
                ;(this.unixPermissions = null), (this.dosPermissions = null)
                var t = this.versionMadeBy >> 8
                ;(this.dir = !!(16 & this.externalFileAttributes)),
                  0 == t && (this.dosPermissions = 63 & this.externalFileAttributes),
                  3 == t && (this.unixPermissions = (this.externalFileAttributes >> 16) & 65535),
                  this.dir || '/' !== this.fileNameStr.slice(-1) || (this.dir = !0)
              },
              parseZIP64ExtraField: function (t) {
                if (this.extraFields[1]) {
                  var e = l(this.extraFields[1].value)
                  this.uncompressedSize === s.MAX_VALUE_32BITS &&
                    (this.uncompressedSize = e.readInt(8)),
                    this.compressedSize === s.MAX_VALUE_32BITS &&
                      (this.compressedSize = e.readInt(8)),
                    this.localHeaderOffset === s.MAX_VALUE_32BITS &&
                      (this.localHeaderOffset = e.readInt(8)),
                    this.diskNumberStart === s.MAX_VALUE_32BITS &&
                      (this.diskNumberStart = e.readInt(4))
                }
              },
              readExtraFields: function (t) {
                var e,
                  i,
                  l,
                  s = t.index + this.extraFieldsLength
                for (this.extraFields || (this.extraFields = {}); t.index < s; )
                  (e = t.readInt(2)),
                    (i = t.readInt(2)),
                    (l = t.readData(i)),
                    (this.extraFields[e] = { id: e, length: i, value: l })
              },
              handleUTF8: function () {
                var t = r.uint8array ? 'uint8array' : 'array'
                if (this.useUTF8())
                  (this.fileNameStr = c.utf8decode(this.fileName)),
                    (this.fileCommentStr = c.utf8decode(this.fileComment))
                else {
                  var e = this.findExtraFieldUnicodePath()
                  if (null !== e) this.fileNameStr = e
                  else {
                    var i = s.transformTo(t, this.fileName)
                    this.fileNameStr = this.loadOptions.decodeFileName(i)
                  }
                  var l = this.findExtraFieldUnicodeComment()
                  if (null !== l) this.fileCommentStr = l
                  else {
                    var n = s.transformTo(t, this.fileComment)
                    this.fileCommentStr = this.loadOptions.decodeFileName(n)
                  }
                }
              },
              findExtraFieldUnicodePath: function () {
                var t = this.extraFields[28789]
                if (t) {
                  var e = l(t.value)
                  return 1 !== e.readInt(1)
                    ? null
                    : a(this.fileName) !== e.readInt(4)
                    ? null
                    : c.utf8decode(e.readData(t.length - 5))
                }
                return null
              },
              findExtraFieldUnicodeComment: function () {
                var t = this.extraFields[25461]
                if (t) {
                  var e = l(t.value)
                  return 1 !== e.readInt(1)
                    ? null
                    : a(this.fileComment) !== e.readInt(4)
                    ? null
                    : c.utf8decode(e.readData(t.length - 5))
                }
                return null
              }
            }),
              (e.exports = o)
          },
          {
            './compressedObject': 2,
            './compressions': 3,
            './crc32': 4,
            './reader/readerFor': 22,
            './support': 30,
            './utf8': 31,
            './utils': 32
          }
        ],
        35: [
          function (t, e, i) {
            function l(t, e, i) {
              ;(this.name = t),
                (this.dir = i.dir),
                (this.date = i.date),
                (this.comment = i.comment),
                (this.unixPermissions = i.unixPermissions),
                (this.dosPermissions = i.dosPermissions),
                (this._data = e),
                (this._dataBinary = i.binary),
                (this.options = {
                  compression: i.compression,
                  compressionOptions: i.compressionOptions
                })
            }
            var s = t('./stream/StreamHelper'),
              n = t('./stream/DataWorker'),
              a = t('./utf8'),
              c = t('./compressedObject'),
              d = t('./stream/GenericWorker')
            l.prototype = {
              internalStream: function (t) {
                var e = null,
                  i = 'string'
                try {
                  if (!t) throw new Error('No output type specified.')
                  var l = 'string' === (i = t.toLowerCase()) || 'text' === i
                  ;('binarystring' !== i && 'text' !== i) || (i = 'string'),
                    (e = this._decompressWorker())
                  var n = !this._dataBinary
                  n && !l && (e = e.pipe(new a.Utf8EncodeWorker())),
                    !n && l && (e = e.pipe(new a.Utf8DecodeWorker()))
                } catch (t) {
                  ;(e = new d('error')).error(t)
                }
                return new s(e, i, '')
              },
              async: function (t, e) {
                return this.internalStream(t).accumulate(e)
              },
              nodeStream: function (t, e) {
                return this.internalStream(t || 'nodebuffer').toNodejsStream(e)
              },
              _compressWorker: function (t, e) {
                if (this._data instanceof c && this._data.compression.magic === t.magic)
                  return this._data.getCompressedWorker()
                var i = this._decompressWorker()
                return (
                  this._dataBinary || (i = i.pipe(new a.Utf8EncodeWorker())),
                  c.createWorkerFrom(i, t, e)
                )
              },
              _decompressWorker: function () {
                return this._data instanceof c
                  ? this._data.getContentWorker()
                  : this._data instanceof d
                  ? this._data
                  : new n(this._data)
              }
            }
            for (
              var r = ['asText', 'asBinary', 'asNodeBuffer', 'asUint8Array', 'asArrayBuffer'],
                o = function () {
                  throw new Error(
                    'This method has been removed in JSZip 3.0, please check the upgrade guide.'
                  )
                },
                m = 0;
              m < r.length;
              m++
            )
              l.prototype[r[m]] = o
            e.exports = l
          },
          {
            './compressedObject': 2,
            './stream/DataWorker': 27,
            './stream/GenericWorker': 28,
            './stream/StreamHelper': 29,
            './utf8': 31
          }
        ],
        36: [
          function (t, e, i) {
            ;(function (t) {
              var i,
                l,
                s = t.MutationObserver || t.WebKitMutationObserver
              if (s) {
                var n = 0,
                  a = new s(o),
                  c = t.document.createTextNode('')
                a.observe(c, { characterData: !0 }),
                  (i = function () {
                    c.data = n = ++n % 2
                  })
              } else if (t.setImmediate || void 0 === t.MessageChannel)
                i =
                  'document' in t && 'onreadystatechange' in t.document.createElement('script')
                    ? function () {
                        var e = t.document.createElement('script')
                        ;(e.onreadystatechange = function () {
                          o(),
                            (e.onreadystatechange = null),
                            e.parentNode.removeChild(e),
                            (e = null)
                        }),
                          t.document.documentElement.appendChild(e)
                      }
                    : function () {
                        setTimeout(o, 0)
                      }
              else {
                var d = new t.MessageChannel()
                ;(d.port1.onmessage = o),
                  (i = function () {
                    d.port2.postMessage(0)
                  })
              }
              var r = []
              function o() {
                var t, e
                l = !0
                for (var i = r.length; i; ) {
                  for (e = r, r = [], t = -1; ++t < i; ) e[t]()
                  i = r.length
                }
                l = !1
              }
              e.exports = function (t) {
                1 !== r.push(t) || l || i()
              }
            }.call(
              this,
              void 0 !== L
                ? L
                : 'undefined' != typeof self
                ? self
                : 'undefined' != typeof window
                ? window
                : {}
            ))
          },
          {}
        ],
        37: [
          function (t, e, i) {
            var l = t('immediate')
            function s() {}
            var n = {},
              a = ['REJECTED'],
              c = ['FULFILLED'],
              d = ['PENDING']
            function r(t) {
              if ('function' != typeof t) throw new TypeError('resolver must be a function')
              ;(this.state = d), (this.queue = []), (this.outcome = void 0), t !== s && b(this, t)
            }
            function o(t, e, i) {
              ;(this.promise = t),
                'function' == typeof e &&
                  ((this.onFulfilled = e), (this.callFulfilled = this.otherCallFulfilled)),
                'function' == typeof i &&
                  ((this.onRejected = i), (this.callRejected = this.otherCallRejected))
            }
            function m(t, e, i) {
              l(function () {
                var l
                try {
                  l = e(i)
                } catch (l) {
                  return n.reject(t, l)
                }
                l === t
                  ? n.reject(t, new TypeError('Cannot resolve promise with itself'))
                  : n.resolve(t, l)
              })
            }
            function u(t) {
              var e = t && t.then
              if (t && ('object' == typeof t || 'function' == typeof t) && 'function' == typeof e)
                return function () {
                  e.apply(t, arguments)
                }
            }
            function b(t, e) {
              var i = !1
              function l(e) {
                i || ((i = !0), n.reject(t, e))
              }
              function s(e) {
                i || ((i = !0), n.resolve(t, e))
              }
              var a = h(function () {
                e(s, l)
              })
              'error' === a.status && l(a.value)
            }
            function h(t, e) {
              var i = {}
              try {
                ;(i.value = t(e)), (i.status = 'success')
              } catch (t) {
                ;(i.status = 'error'), (i.value = t)
              }
              return i
            }
            ;((e.exports = r).prototype.finally = function (t) {
              if ('function' != typeof t) return this
              var e = this.constructor
              return this.then(
                function (i) {
                  return e.resolve(t()).then(function () {
                    return i
                  })
                },
                function (i) {
                  return e.resolve(t()).then(function () {
                    throw i
                  })
                }
              )
            }),
              (r.prototype.catch = function (t) {
                return this.then(null, t)
              }),
              (r.prototype.then = function (t, e) {
                if (
                  ('function' != typeof t && this.state === c) ||
                  ('function' != typeof e && this.state === a)
                )
                  return this
                var i = new this.constructor(s)
                return (
                  this.state !== d
                    ? m(i, this.state === c ? t : e, this.outcome)
                    : this.queue.push(new o(i, t, e)),
                  i
                )
              }),
              (o.prototype.callFulfilled = function (t) {
                n.resolve(this.promise, t)
              }),
              (o.prototype.otherCallFulfilled = function (t) {
                m(this.promise, this.onFulfilled, t)
              }),
              (o.prototype.callRejected = function (t) {
                n.reject(this.promise, t)
              }),
              (o.prototype.otherCallRejected = function (t) {
                m(this.promise, this.onRejected, t)
              }),
              (n.resolve = function (t, e) {
                var i = h(u, e)
                if ('error' === i.status) return n.reject(t, i.value)
                var l = i.value
                if (l) b(t, l)
                else {
                  ;(t.state = c), (t.outcome = e)
                  for (var s = -1, a = t.queue.length; ++s < a; ) t.queue[s].callFulfilled(e)
                }
                return t
              }),
              (n.reject = function (t, e) {
                ;(t.state = a), (t.outcome = e)
                for (var i = -1, l = t.queue.length; ++i < l; ) t.queue[i].callRejected(e)
                return t
              }),
              (r.resolve = function (t) {
                return t instanceof this ? t : n.resolve(new this(s), t)
              }),
              (r.reject = function (t) {
                var e = new this(s)
                return n.reject(e, t)
              }),
              (r.all = function (t) {
                var e = this
                if ('[object Array]' !== Object.prototype.toString.call(t))
                  return this.reject(new TypeError('must be an array'))
                var i = t.length,
                  l = !1
                if (!i) return this.resolve([])
                for (var a = new Array(i), c = 0, d = -1, r = new this(s); ++d < i; ) o(t[d], d)
                return r
                function o(t, s) {
                  e.resolve(t).then(
                    function (t) {
                      ;(a[s] = t), ++c !== i || l || ((l = !0), n.resolve(r, a))
                    },
                    function (t) {
                      l || ((l = !0), n.reject(r, t))
                    }
                  )
                }
              }),
              (r.race = function (t) {
                if ('[object Array]' !== Object.prototype.toString.call(t))
                  return this.reject(new TypeError('must be an array'))
                var e = t.length,
                  i = !1
                if (!e) return this.resolve([])
                for (var l, a = -1, c = new this(s); ++a < e; )
                  (l = t[a]),
                    this.resolve(l).then(
                      function (t) {
                        i || ((i = !0), n.resolve(c, t))
                      },
                      function (t) {
                        i || ((i = !0), n.reject(c, t))
                      }
                    )
                return c
              })
          },
          { immediate: 36 }
        ],
        38: [
          function (t, e, i) {
            var l = {}
            ;(0, t('./lib/utils/common').assign)(
              l,
              t('./lib/deflate'),
              t('./lib/inflate'),
              t('./lib/zlib/constants')
            ),
              (e.exports = l)
          },
          {
            './lib/deflate': 39,
            './lib/inflate': 40,
            './lib/utils/common': 41,
            './lib/zlib/constants': 44
          }
        ],
        39: [
          function (t, e, i) {
            var l = t('./zlib/deflate'),
              s = t('./utils/common'),
              n = t('./utils/strings'),
              a = t('./zlib/messages'),
              c = t('./zlib/zstream'),
              d = Object.prototype.toString
            function r(t) {
              if (!(this instanceof r)) return new r(t)
              this.options = s.assign(
                {
                  level: -1,
                  method: 8,
                  chunkSize: 16384,
                  windowBits: 15,
                  memLevel: 8,
                  strategy: 0,
                  to: ''
                },
                t || {}
              )
              var e = this.options
              e.raw && 0 < e.windowBits
                ? (e.windowBits = -e.windowBits)
                : e.gzip && 0 < e.windowBits && e.windowBits < 16 && (e.windowBits += 16),
                (this.err = 0),
                (this.msg = ''),
                (this.ended = !1),
                (this.chunks = []),
                (this.strm = new c()),
                (this.strm.avail_out = 0)
              var i = l.deflateInit2(
                this.strm,
                e.level,
                e.method,
                e.windowBits,
                e.memLevel,
                e.strategy
              )
              if (0 !== i) throw new Error(a[i])
              if ((e.header && l.deflateSetHeader(this.strm, e.header), e.dictionary)) {
                var o
                if (
                  ((o =
                    'string' == typeof e.dictionary
                      ? n.string2buf(e.dictionary)
                      : '[object ArrayBuffer]' === d.call(e.dictionary)
                      ? new Uint8Array(e.dictionary)
                      : e.dictionary),
                  0 !== (i = l.deflateSetDictionary(this.strm, o)))
                )
                  throw new Error(a[i])
                this._dict_set = !0
              }
            }
            function o(t, e) {
              var i = new r(e)
              if ((i.push(t, !0), i.err)) throw i.msg || a[i.err]
              return i.result
            }
            ;(r.prototype.push = function (t, e) {
              var i,
                a,
                c = this.strm,
                r = this.options.chunkSize
              if (this.ended) return !1
              ;(a = e === ~~e ? e : !0 === e ? 4 : 0),
                'string' == typeof t
                  ? (c.input = n.string2buf(t))
                  : '[object ArrayBuffer]' === d.call(t)
                  ? (c.input = new Uint8Array(t))
                  : (c.input = t),
                (c.next_in = 0),
                (c.avail_in = c.input.length)
              do {
                if (
                  (0 === c.avail_out &&
                    ((c.output = new s.Buf8(r)), (c.next_out = 0), (c.avail_out = r)),
                  1 !== (i = l.deflate(c, a)) && 0 !== i)
                )
                  return this.onEnd(i), !(this.ended = !0)
                ;(0 !== c.avail_out && (0 !== c.avail_in || (4 !== a && 2 !== a))) ||
                  ('string' === this.options.to
                    ? this.onData(n.buf2binstring(s.shrinkBuf(c.output, c.next_out)))
                    : this.onData(s.shrinkBuf(c.output, c.next_out)))
              } while ((0 < c.avail_in || 0 === c.avail_out) && 1 !== i)
              return 4 === a
                ? ((i = l.deflateEnd(this.strm)), this.onEnd(i), (this.ended = !0), 0 === i)
                : 2 !== a || (this.onEnd(0), !(c.avail_out = 0))
            }),
              (r.prototype.onData = function (t) {
                this.chunks.push(t)
              }),
              (r.prototype.onEnd = function (t) {
                0 === t &&
                  ('string' === this.options.to
                    ? (this.result = this.chunks.join(''))
                    : (this.result = s.flattenChunks(this.chunks))),
                  (this.chunks = []),
                  (this.err = t),
                  (this.msg = this.strm.msg)
              }),
              (i.Deflate = r),
              (i.deflate = o),
              (i.deflateRaw = function (t, e) {
                return ((e = e || {}).raw = !0), o(t, e)
              }),
              (i.gzip = function (t, e) {
                return ((e = e || {}).gzip = !0), o(t, e)
              })
          },
          {
            './utils/common': 41,
            './utils/strings': 42,
            './zlib/deflate': 46,
            './zlib/messages': 51,
            './zlib/zstream': 53
          }
        ],
        40: [
          function (t, e, i) {
            var l = t('./zlib/inflate'),
              s = t('./utils/common'),
              n = t('./utils/strings'),
              a = t('./zlib/constants'),
              c = t('./zlib/messages'),
              d = t('./zlib/zstream'),
              r = t('./zlib/gzheader'),
              o = Object.prototype.toString
            function m(t) {
              if (!(this instanceof m)) return new m(t)
              this.options = s.assign({ chunkSize: 16384, windowBits: 0, to: '' }, t || {})
              var e = this.options
              e.raw &&
                0 <= e.windowBits &&
                e.windowBits < 16 &&
                ((e.windowBits = -e.windowBits), 0 === e.windowBits && (e.windowBits = -15)),
                !(0 <= e.windowBits && e.windowBits < 16) ||
                  (t && t.windowBits) ||
                  (e.windowBits += 32),
                15 < e.windowBits &&
                  e.windowBits < 48 &&
                  0 == (15 & e.windowBits) &&
                  (e.windowBits |= 15),
                (this.err = 0),
                (this.msg = ''),
                (this.ended = !1),
                (this.chunks = []),
                (this.strm = new d()),
                (this.strm.avail_out = 0)
              var i = l.inflateInit2(this.strm, e.windowBits)
              if (i !== a.Z_OK) throw new Error(c[i])
              ;(this.header = new r()), l.inflateGetHeader(this.strm, this.header)
            }
            function u(t, e) {
              var i = new m(e)
              if ((i.push(t, !0), i.err)) throw i.msg || c[i.err]
              return i.result
            }
            ;(m.prototype.push = function (t, e) {
              var i,
                c,
                d,
                r,
                m,
                u,
                b = this.strm,
                h = this.options.chunkSize,
                Z = this.options.dictionary,
                p = !1
              if (this.ended) return !1
              ;(c = e === ~~e ? e : !0 === e ? a.Z_FINISH : a.Z_NO_FLUSH),
                'string' == typeof t
                  ? (b.input = n.binstring2buf(t))
                  : '[object ArrayBuffer]' === o.call(t)
                  ? (b.input = new Uint8Array(t))
                  : (b.input = t),
                (b.next_in = 0),
                (b.avail_in = b.input.length)
              do {
                if (
                  (0 === b.avail_out &&
                    ((b.output = new s.Buf8(h)), (b.next_out = 0), (b.avail_out = h)),
                  (i = l.inflate(b, a.Z_NO_FLUSH)) === a.Z_NEED_DICT &&
                    Z &&
                    ((u =
                      'string' == typeof Z
                        ? n.string2buf(Z)
                        : '[object ArrayBuffer]' === o.call(Z)
                        ? new Uint8Array(Z)
                        : Z),
                    (i = l.inflateSetDictionary(this.strm, u))),
                  i === a.Z_BUF_ERROR && !0 === p && ((i = a.Z_OK), (p = !1)),
                  i !== a.Z_STREAM_END && i !== a.Z_OK)
                )
                  return this.onEnd(i), !(this.ended = !0)
                b.next_out &&
                  ((0 !== b.avail_out &&
                    i !== a.Z_STREAM_END &&
                    (0 !== b.avail_in || (c !== a.Z_FINISH && c !== a.Z_SYNC_FLUSH))) ||
                    ('string' === this.options.to
                      ? ((d = n.utf8border(b.output, b.next_out)),
                        (r = b.next_out - d),
                        (m = n.buf2string(b.output, d)),
                        (b.next_out = r),
                        (b.avail_out = h - r),
                        r && s.arraySet(b.output, b.output, d, r, 0),
                        this.onData(m))
                      : this.onData(s.shrinkBuf(b.output, b.next_out)))),
                  0 === b.avail_in && 0 === b.avail_out && (p = !0)
              } while ((0 < b.avail_in || 0 === b.avail_out) && i !== a.Z_STREAM_END)
              return (
                i === a.Z_STREAM_END && (c = a.Z_FINISH),
                c === a.Z_FINISH
                  ? ((i = l.inflateEnd(this.strm)), this.onEnd(i), (this.ended = !0), i === a.Z_OK)
                  : c !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), !(b.avail_out = 0))
              )
            }),
              (m.prototype.onData = function (t) {
                this.chunks.push(t)
              }),
              (m.prototype.onEnd = function (t) {
                t === a.Z_OK &&
                  ('string' === this.options.to
                    ? (this.result = this.chunks.join(''))
                    : (this.result = s.flattenChunks(this.chunks))),
                  (this.chunks = []),
                  (this.err = t),
                  (this.msg = this.strm.msg)
              }),
              (i.Inflate = m),
              (i.inflate = u),
              (i.inflateRaw = function (t, e) {
                return ((e = e || {}).raw = !0), u(t, e)
              }),
              (i.ungzip = u)
          },
          {
            './utils/common': 41,
            './utils/strings': 42,
            './zlib/constants': 44,
            './zlib/gzheader': 47,
            './zlib/inflate': 49,
            './zlib/messages': 51,
            './zlib/zstream': 53
          }
        ],
        41: [
          function (t, e, i) {
            var l =
              'undefined' != typeof Uint8Array &&
              'undefined' != typeof Uint16Array &&
              'undefined' != typeof Int32Array
            ;(i.assign = function (t) {
              for (var e = Array.prototype.slice.call(arguments, 1); e.length; ) {
                var i = e.shift()
                if (i) {
                  if ('object' != typeof i) throw new TypeError(i + 'must be non-object')
                  for (var l in i) i.hasOwnProperty(l) && (t[l] = i[l])
                }
              }
              return t
            }),
              (i.shrinkBuf = function (t, e) {
                return t.length === e ? t : t.subarray ? t.subarray(0, e) : ((t.length = e), t)
              })
            var s = {
                arraySet: function (t, e, i, l, s) {
                  if (e.subarray && t.subarray) t.set(e.subarray(i, i + l), s)
                  else for (var n = 0; n < l; n++) t[s + n] = e[i + n]
                },
                flattenChunks: function (t) {
                  var e, i, l, s, n, a
                  for (e = l = 0, i = t.length; e < i; e++) l += t[e].length
                  for (a = new Uint8Array(l), e = s = 0, i = t.length; e < i; e++)
                    (n = t[e]), a.set(n, s), (s += n.length)
                  return a
                }
              },
              n = {
                arraySet: function (t, e, i, l, s) {
                  for (var n = 0; n < l; n++) t[s + n] = e[i + n]
                },
                flattenChunks: function (t) {
                  return [].concat.apply([], t)
                }
              }
            ;(i.setTyped = function (t) {
              t
                ? ((i.Buf8 = Uint8Array),
                  (i.Buf16 = Uint16Array),
                  (i.Buf32 = Int32Array),
                  i.assign(i, s))
                : ((i.Buf8 = Array), (i.Buf16 = Array), (i.Buf32 = Array), i.assign(i, n))
            }),
              i.setTyped(l)
          },
          {}
        ],
        42: [
          function (t, e, i) {
            var l = t('./common'),
              s = !0,
              n = !0
            try {
              String.fromCharCode.apply(null, [0])
            } catch (t) {
              s = !1
            }
            try {
              String.fromCharCode.apply(null, new Uint8Array(1))
            } catch (t) {
              n = !1
            }
            for (var a = new l.Buf8(256), c = 0; c < 256; c++)
              a[c] = 252 <= c ? 6 : 248 <= c ? 5 : 240 <= c ? 4 : 224 <= c ? 3 : 192 <= c ? 2 : 1
            function d(t, e) {
              if (e < 65537 && ((t.subarray && n) || (!t.subarray && s)))
                return String.fromCharCode.apply(null, l.shrinkBuf(t, e))
              for (var i = '', a = 0; a < e; a++) i += String.fromCharCode(t[a])
              return i
            }
            ;(a[254] = a[254] = 1),
              (i.string2buf = function (t) {
                var e,
                  i,
                  s,
                  n,
                  a,
                  c = t.length,
                  d = 0
                for (n = 0; n < c; n++)
                  55296 == (64512 & (i = t.charCodeAt(n))) &&
                    n + 1 < c &&
                    56320 == (64512 & (s = t.charCodeAt(n + 1))) &&
                    ((i = 65536 + ((i - 55296) << 10) + (s - 56320)), n++),
                    (d += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4)
                for (e = new l.Buf8(d), n = a = 0; a < d; n++)
                  55296 == (64512 & (i = t.charCodeAt(n))) &&
                    n + 1 < c &&
                    56320 == (64512 & (s = t.charCodeAt(n + 1))) &&
                    ((i = 65536 + ((i - 55296) << 10) + (s - 56320)), n++),
                    i < 128
                      ? (e[a++] = i)
                      : (i < 2048
                          ? (e[a++] = 192 | (i >>> 6))
                          : (i < 65536
                              ? (e[a++] = 224 | (i >>> 12))
                              : ((e[a++] = 240 | (i >>> 18)), (e[a++] = 128 | ((i >>> 12) & 63))),
                            (e[a++] = 128 | ((i >>> 6) & 63))),
                        (e[a++] = 128 | (63 & i)))
                return e
              }),
              (i.buf2binstring = function (t) {
                return d(t, t.length)
              }),
              (i.binstring2buf = function (t) {
                for (var e = new l.Buf8(t.length), i = 0, s = e.length; i < s; i++)
                  e[i] = t.charCodeAt(i)
                return e
              }),
              (i.buf2string = function (t, e) {
                var i,
                  l,
                  s,
                  n,
                  c = e || t.length,
                  r = new Array(2 * c)
                for (i = l = 0; i < c; )
                  if ((s = t[i++]) < 128) r[l++] = s
                  else if (4 < (n = a[s])) (r[l++] = 65533), (i += n - 1)
                  else {
                    for (s &= 2 === n ? 31 : 3 === n ? 15 : 7; 1 < n && i < c; )
                      (s = (s << 6) | (63 & t[i++])), n--
                    1 < n
                      ? (r[l++] = 65533)
                      : s < 65536
                      ? (r[l++] = s)
                      : ((s -= 65536),
                        (r[l++] = 55296 | ((s >> 10) & 1023)),
                        (r[l++] = 56320 | (1023 & s)))
                  }
                return d(r, l)
              }),
              (i.utf8border = function (t, e) {
                var i
                for (
                  (e = e || t.length) > t.length && (e = t.length), i = e - 1;
                  0 <= i && 128 == (192 & t[i]);

                )
                  i--
                return i < 0 ? e : 0 === i ? e : i + a[t[i]] > e ? i : e
              })
          },
          { './common': 41 }
        ],
        43: [
          function (t, e, i) {
            e.exports = function (t, e, i, l) {
              for (var s = (65535 & t) | 0, n = ((t >>> 16) & 65535) | 0, a = 0; 0 !== i; ) {
                for (i -= a = 2e3 < i ? 2e3 : i; (n = (n + (s = (s + e[l++]) | 0)) | 0), --a; );
                ;(s %= 65521), (n %= 65521)
              }
              return s | (n << 16) | 0
            }
          },
          {}
        ],
        44: [
          function (t, e, i) {
            e.exports = {
              Z_NO_FLUSH: 0,
              Z_PARTIAL_FLUSH: 1,
              Z_SYNC_FLUSH: 2,
              Z_FULL_FLUSH: 3,
              Z_FINISH: 4,
              Z_BLOCK: 5,
              Z_TREES: 6,
              Z_OK: 0,
              Z_STREAM_END: 1,
              Z_NEED_DICT: 2,
              Z_ERRNO: -1,
              Z_STREAM_ERROR: -2,
              Z_DATA_ERROR: -3,
              Z_BUF_ERROR: -5,
              Z_NO_COMPRESSION: 0,
              Z_BEST_SPEED: 1,
              Z_BEST_COMPRESSION: 9,
              Z_DEFAULT_COMPRESSION: -1,
              Z_FILTERED: 1,
              Z_HUFFMAN_ONLY: 2,
              Z_RLE: 3,
              Z_FIXED: 4,
              Z_DEFAULT_STRATEGY: 0,
              Z_BINARY: 0,
              Z_TEXT: 1,
              Z_UNKNOWN: 2,
              Z_DEFLATED: 8
            }
          },
          {}
        ],
        45: [
          function (t, e, i) {
            var l = (function () {
              for (var t, e = [], i = 0; i < 256; i++) {
                t = i
                for (var l = 0; l < 8; l++) t = 1 & t ? 3988292384 ^ (t >>> 1) : t >>> 1
                e[i] = t
              }
              return e
            })()
            e.exports = function (t, e, i, s) {
              var n = l,
                a = s + i
              t ^= -1
              for (var c = s; c < a; c++) t = (t >>> 8) ^ n[255 & (t ^ e[c])]
              return -1 ^ t
            }
          },
          {}
        ],
        46: [
          function (t, e, i) {
            var l,
              s = t('../utils/common'),
              n = t('./trees'),
              a = t('./adler32'),
              c = t('./crc32'),
              d = t('./messages'),
              r = -2,
              o = 258,
              m = 262,
              u = 113
            function b(t, e) {
              return (t.msg = d[e]), e
            }
            function h(t) {
              return (t << 1) - (4 < t ? 9 : 0)
            }
            function Z(t) {
              for (var e = t.length; 0 <= --e; ) t[e] = 0
            }
            function p(t) {
              var e = t.state,
                i = e.pending
              i > t.avail_out && (i = t.avail_out),
                0 !== i &&
                  (s.arraySet(t.output, e.pending_buf, e.pending_out, i, t.next_out),
                  (t.next_out += i),
                  (e.pending_out += i),
                  (t.total_out += i),
                  (t.avail_out -= i),
                  (e.pending -= i),
                  0 === e.pending && (e.pending_out = 0))
            }
            function y(t, e) {
              n._tr_flush_block(
                t,
                0 <= t.block_start ? t.block_start : -1,
                t.strstart - t.block_start,
                e
              ),
                (t.block_start = t.strstart),
                p(t.strm)
            }
            function X(t, e) {
              t.pending_buf[t.pending++] = e
            }
            function G(t, e) {
              ;(t.pending_buf[t.pending++] = (e >>> 8) & 255),
                (t.pending_buf[t.pending++] = 255 & e)
            }
            function W(t, e) {
              var i,
                l,
                s = t.max_chain_length,
                n = t.strstart,
                a = t.prev_length,
                c = t.nice_match,
                d = t.strstart > t.w_size - m ? t.strstart - (t.w_size - m) : 0,
                r = t.window,
                u = t.w_mask,
                b = t.prev,
                h = t.strstart + o,
                Z = r[n + a - 1],
                p = r[n + a]
              t.prev_length >= t.good_match && (s >>= 2), c > t.lookahead && (c = t.lookahead)
              do {
                if (
                  r[(i = e) + a] === p &&
                  r[i + a - 1] === Z &&
                  r[i] === r[n] &&
                  r[++i] === r[n + 1]
                ) {
                  ;(n += 2), i++
                  do {} while (
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    r[++n] === r[++i] &&
                    n < h
                  )
                  if (((l = o - (h - n)), (n = h - o), a < l)) {
                    if (((t.match_start = e), c <= (a = l))) break
                    ;(Z = r[n + a - 1]), (p = r[n + a])
                  }
                }
              } while ((e = b[e & u]) > d && 0 != --s)
              return a <= t.lookahead ? a : t.lookahead
            }
            function V(t) {
              var e,
                i,
                l,
                n,
                d,
                r,
                o,
                u,
                b,
                h,
                Z = t.w_size
              do {
                if (((n = t.window_size - t.lookahead - t.strstart), t.strstart >= Z + (Z - m))) {
                  for (
                    s.arraySet(t.window, t.window, Z, Z, 0),
                      t.match_start -= Z,
                      t.strstart -= Z,
                      t.block_start -= Z,
                      e = i = t.hash_size;
                    (l = t.head[--e]), (t.head[e] = Z <= l ? l - Z : 0), --i;

                  );
                  for (e = i = Z; (l = t.prev[--e]), (t.prev[e] = Z <= l ? l - Z : 0), --i; );
                  n += Z
                }
                if (0 === t.strm.avail_in) break
                if (
                  ((r = t.strm),
                  (o = t.window),
                  (u = t.strstart + t.lookahead),
                  (h = void 0),
                  (b = n) < (h = r.avail_in) && (h = b),
                  (i =
                    0 === h
                      ? 0
                      : ((r.avail_in -= h),
                        s.arraySet(o, r.input, r.next_in, h, u),
                        1 === r.state.wrap
                          ? (r.adler = a(r.adler, o, h, u))
                          : 2 === r.state.wrap && (r.adler = c(r.adler, o, h, u)),
                        (r.next_in += h),
                        (r.total_in += h),
                        h)),
                  (t.lookahead += i),
                  t.lookahead + t.insert >= 3)
                )
                  for (
                    d = t.strstart - t.insert,
                      t.ins_h = t.window[d],
                      t.ins_h = ((t.ins_h << t.hash_shift) ^ t.window[d + 1]) & t.hash_mask;
                    t.insert &&
                    ((t.ins_h = ((t.ins_h << t.hash_shift) ^ t.window[d + 3 - 1]) & t.hash_mask),
                    (t.prev[d & t.w_mask] = t.head[t.ins_h]),
                    (t.head[t.ins_h] = d),
                    d++,
                    t.insert--,
                    !(t.lookahead + t.insert < 3));

                  );
              } while (t.lookahead < m && 0 !== t.strm.avail_in)
            }
            function Y(t, e) {
              for (var i, l; ; ) {
                if (t.lookahead < m) {
                  if ((V(t), t.lookahead < m && 0 === e)) return 1
                  if (0 === t.lookahead) break
                }
                if (
                  ((i = 0),
                  t.lookahead >= 3 &&
                    ((t.ins_h =
                      ((t.ins_h << t.hash_shift) ^ t.window[t.strstart + 3 - 1]) & t.hash_mask),
                    (i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h]),
                    (t.head[t.ins_h] = t.strstart)),
                  0 !== i && t.strstart - i <= t.w_size - m && (t.match_length = W(t, i)),
                  t.match_length >= 3)
                )
                  if (
                    ((l = n._tr_tally(t, t.strstart - t.match_start, t.match_length - 3)),
                    (t.lookahead -= t.match_length),
                    t.match_length <= t.max_lazy_match && t.lookahead >= 3)
                  ) {
                    for (
                      t.match_length--;
                      t.strstart++,
                        (t.ins_h =
                          ((t.ins_h << t.hash_shift) ^ t.window[t.strstart + 3 - 1]) & t.hash_mask),
                        (i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h]),
                        (t.head[t.ins_h] = t.strstart),
                        0 != --t.match_length;

                    );
                    t.strstart++
                  } else
                    (t.strstart += t.match_length),
                      (t.match_length = 0),
                      (t.ins_h = t.window[t.strstart]),
                      (t.ins_h =
                        ((t.ins_h << t.hash_shift) ^ t.window[t.strstart + 1]) & t.hash_mask)
                else (l = n._tr_tally(t, 0, t.window[t.strstart])), t.lookahead--, t.strstart++
                if (l && (y(t, !1), 0 === t.strm.avail_out)) return 1
              }
              return (
                (t.insert = t.strstart < 2 ? t.strstart : 2),
                4 === e
                  ? (y(t, !0), 0 === t.strm.avail_out ? 3 : 4)
                  : t.last_lit && (y(t, !1), 0 === t.strm.avail_out)
                  ? 1
                  : 2
              )
            }
            function L(t, e) {
              for (var i, l, s; ; ) {
                if (t.lookahead < m) {
                  if ((V(t), t.lookahead < m && 0 === e)) return 1
                  if (0 === t.lookahead) break
                }
                if (
                  ((i = 0),
                  t.lookahead >= 3 &&
                    ((t.ins_h =
                      ((t.ins_h << t.hash_shift) ^ t.window[t.strstart + 3 - 1]) & t.hash_mask),
                    (i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h]),
                    (t.head[t.ins_h] = t.strstart)),
                  (t.prev_length = t.match_length),
                  (t.prev_match = t.match_start),
                  (t.match_length = 2),
                  0 !== i &&
                    t.prev_length < t.max_lazy_match &&
                    t.strstart - i <= t.w_size - m &&
                    ((t.match_length = W(t, i)),
                    t.match_length <= 5 &&
                      (1 === t.strategy ||
                        (3 === t.match_length && 4096 < t.strstart - t.match_start)) &&
                      (t.match_length = 2)),
                  t.prev_length >= 3 && t.match_length <= t.prev_length)
                ) {
                  for (
                    s = t.strstart + t.lookahead - 3,
                      l = n._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - 3),
                      t.lookahead -= t.prev_length - 1,
                      t.prev_length -= 2;
                    ++t.strstart <= s &&
                      ((t.ins_h =
                        ((t.ins_h << t.hash_shift) ^ t.window[t.strstart + 3 - 1]) & t.hash_mask),
                      (i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h]),
                      (t.head[t.ins_h] = t.strstart)),
                      0 != --t.prev_length;

                  );
                  if (
                    ((t.match_available = 0),
                    (t.match_length = 2),
                    t.strstart++,
                    l && (y(t, !1), 0 === t.strm.avail_out))
                  )
                    return 1
                } else if (t.match_available) {
                  if (
                    ((l = n._tr_tally(t, 0, t.window[t.strstart - 1])) && y(t, !1),
                    t.strstart++,
                    t.lookahead--,
                    0 === t.strm.avail_out)
                  )
                    return 1
                } else (t.match_available = 1), t.strstart++, t.lookahead--
              }
              return (
                t.match_available &&
                  ((l = n._tr_tally(t, 0, t.window[t.strstart - 1])), (t.match_available = 0)),
                (t.insert = t.strstart < 2 ? t.strstart : 2),
                4 === e
                  ? (y(t, !0), 0 === t.strm.avail_out ? 3 : 4)
                  : t.last_lit && (y(t, !1), 0 === t.strm.avail_out)
                  ? 1
                  : 2
              )
            }
            function S(t, e, i, l, s) {
              ;(this.good_length = t),
                (this.max_lazy = e),
                (this.nice_length = i),
                (this.max_chain = l),
                (this.func = s)
            }
            function I() {
              ;(this.strm = null),
                (this.status = 0),
                (this.pending_buf = null),
                (this.pending_buf_size = 0),
                (this.pending_out = 0),
                (this.pending = 0),
                (this.wrap = 0),
                (this.gzhead = null),
                (this.gzindex = 0),
                (this.method = 8),
                (this.last_flush = -1),
                (this.w_size = 0),
                (this.w_bits = 0),
                (this.w_mask = 0),
                (this.window = null),
                (this.window_size = 0),
                (this.prev = null),
                (this.head = null),
                (this.ins_h = 0),
                (this.hash_size = 0),
                (this.hash_bits = 0),
                (this.hash_mask = 0),
                (this.hash_shift = 0),
                (this.block_start = 0),
                (this.match_length = 0),
                (this.prev_match = 0),
                (this.match_available = 0),
                (this.strstart = 0),
                (this.match_start = 0),
                (this.lookahead = 0),
                (this.prev_length = 0),
                (this.max_chain_length = 0),
                (this.max_lazy_match = 0),
                (this.level = 0),
                (this.strategy = 0),
                (this.good_match = 0),
                (this.nice_match = 0),
                (this.dyn_ltree = new s.Buf16(1146)),
                (this.dyn_dtree = new s.Buf16(122)),
                (this.bl_tree = new s.Buf16(78)),
                Z(this.dyn_ltree),
                Z(this.dyn_dtree),
                Z(this.bl_tree),
                (this.l_desc = null),
                (this.d_desc = null),
                (this.bl_desc = null),
                (this.bl_count = new s.Buf16(16)),
                (this.heap = new s.Buf16(573)),
                Z(this.heap),
                (this.heap_len = 0),
                (this.heap_max = 0),
                (this.depth = new s.Buf16(573)),
                Z(this.depth),
                (this.l_buf = 0),
                (this.lit_bufsize = 0),
                (this.last_lit = 0),
                (this.d_buf = 0),
                (this.opt_len = 0),
                (this.static_len = 0),
                (this.matches = 0),
                (this.insert = 0),
                (this.bi_buf = 0),
                (this.bi_valid = 0)
            }
            function R(t) {
              var e
              return t && t.state
                ? ((t.total_in = t.total_out = 0),
                  (t.data_type = 2),
                  ((e = t.state).pending = 0),
                  (e.pending_out = 0),
                  e.wrap < 0 && (e.wrap = -e.wrap),
                  (e.status = e.wrap ? 42 : u),
                  (t.adler = 2 === e.wrap ? 0 : 1),
                  (e.last_flush = 0),
                  n._tr_init(e),
                  0)
                : b(t, r)
            }
            function f(t) {
              var e = R(t)
              return (
                0 === e &&
                  (function (t) {
                    ;(t.window_size = 2 * t.w_size),
                      Z(t.head),
                      (t.max_lazy_match = l[t.level].max_lazy),
                      (t.good_match = l[t.level].good_length),
                      (t.nice_match = l[t.level].nice_length),
                      (t.max_chain_length = l[t.level].max_chain),
                      (t.strstart = 0),
                      (t.block_start = 0),
                      (t.lookahead = 0),
                      (t.insert = 0),
                      (t.match_length = t.prev_length = 2),
                      (t.match_available = 0),
                      (t.ins_h = 0)
                  })(t.state),
                e
              )
            }
            function x(t, e, i, l, n, a) {
              if (!t) return r
              var c = 1
              if (
                (-1 === e && (e = 6),
                l < 0 ? ((c = 0), (l = -l)) : 15 < l && ((c = 2), (l -= 16)),
                n < 1 || 9 < n || 8 !== i || l < 8 || 15 < l || e < 0 || 9 < e || a < 0 || 4 < a)
              )
                return b(t, r)
              8 === l && (l = 9)
              var d = new I()
              return (
                ((t.state = d).strm = t),
                (d.wrap = c),
                (d.gzhead = null),
                (d.w_bits = l),
                (d.w_size = 1 << d.w_bits),
                (d.w_mask = d.w_size - 1),
                (d.hash_bits = n + 7),
                (d.hash_size = 1 << d.hash_bits),
                (d.hash_mask = d.hash_size - 1),
                (d.hash_shift = ~~((d.hash_bits + 3 - 1) / 3)),
                (d.window = new s.Buf8(2 * d.w_size)),
                (d.head = new s.Buf16(d.hash_size)),
                (d.prev = new s.Buf16(d.w_size)),
                (d.lit_bufsize = 1 << (n + 6)),
                (d.pending_buf_size = 4 * d.lit_bufsize),
                (d.pending_buf = new s.Buf8(d.pending_buf_size)),
                (d.d_buf = 1 * d.lit_bufsize),
                (d.l_buf = 3 * d.lit_bufsize),
                (d.level = e),
                (d.strategy = a),
                (d.method = i),
                f(t)
              )
            }
            ;(l = [
              new S(0, 0, 0, 0, function (t, e) {
                var i = 65535
                for (i > t.pending_buf_size - 5 && (i = t.pending_buf_size - 5); ; ) {
                  if (t.lookahead <= 1) {
                    if ((V(t), 0 === t.lookahead && 0 === e)) return 1
                    if (0 === t.lookahead) break
                  }
                  ;(t.strstart += t.lookahead), (t.lookahead = 0)
                  var l = t.block_start + i
                  if (
                    (0 === t.strstart || t.strstart >= l) &&
                    ((t.lookahead = t.strstart - l),
                    (t.strstart = l),
                    y(t, !1),
                    0 === t.strm.avail_out)
                  )
                    return 1
                  if (
                    t.strstart - t.block_start >= t.w_size - m &&
                    (y(t, !1), 0 === t.strm.avail_out)
                  )
                    return 1
                }
                return (
                  (t.insert = 0),
                  4 === e
                    ? (y(t, !0), 0 === t.strm.avail_out ? 3 : 4)
                    : (t.strstart > t.block_start && (y(t, !1), t.strm.avail_out), 1)
                )
              }),
              new S(4, 4, 8, 4, Y),
              new S(4, 5, 16, 8, Y),
              new S(4, 6, 32, 32, Y),
              new S(4, 4, 16, 16, L),
              new S(8, 16, 32, 32, L),
              new S(8, 16, 128, 128, L),
              new S(8, 32, 128, 256, L),
              new S(32, 128, 258, 1024, L),
              new S(32, 258, 258, 4096, L)
            ]),
              (i.deflateInit = function (t, e) {
                return x(t, e, 8, 15, 8, 0)
              }),
              (i.deflateInit2 = x),
              (i.deflateReset = f),
              (i.deflateResetKeep = R),
              (i.deflateSetHeader = function (t, e) {
                return t && t.state ? (2 !== t.state.wrap ? r : ((t.state.gzhead = e), 0)) : r
              }),
              (i.deflate = function (t, e) {
                var i, s, a, d
                if (!t || !t.state || 5 < e || e < 0) return t ? b(t, r) : r
                if (
                  ((s = t.state),
                  !t.output || (!t.input && 0 !== t.avail_in) || (666 === s.status && 4 !== e))
                )
                  return b(t, 0 === t.avail_out ? -5 : r)
                if (((s.strm = t), (i = s.last_flush), (s.last_flush = e), 42 === s.status))
                  if (2 === s.wrap)
                    (t.adler = 0),
                      X(s, 31),
                      X(s, 139),
                      X(s, 8),
                      s.gzhead
                        ? (X(
                            s,
                            (s.gzhead.text ? 1 : 0) +
                              (s.gzhead.hcrc ? 2 : 0) +
                              (s.gzhead.extra ? 4 : 0) +
                              (s.gzhead.name ? 8 : 0) +
                              (s.gzhead.comment ? 16 : 0)
                          ),
                          X(s, 255 & s.gzhead.time),
                          X(s, (s.gzhead.time >> 8) & 255),
                          X(s, (s.gzhead.time >> 16) & 255),
                          X(s, (s.gzhead.time >> 24) & 255),
                          X(s, 9 === s.level ? 2 : 2 <= s.strategy || s.level < 2 ? 4 : 0),
                          X(s, 255 & s.gzhead.os),
                          s.gzhead.extra &&
                            s.gzhead.extra.length &&
                            (X(s, 255 & s.gzhead.extra.length),
                            X(s, (s.gzhead.extra.length >> 8) & 255)),
                          s.gzhead.hcrc && (t.adler = c(t.adler, s.pending_buf, s.pending, 0)),
                          (s.gzindex = 0),
                          (s.status = 69))
                        : (X(s, 0),
                          X(s, 0),
                          X(s, 0),
                          X(s, 0),
                          X(s, 0),
                          X(s, 9 === s.level ? 2 : 2 <= s.strategy || s.level < 2 ? 4 : 0),
                          X(s, 3),
                          (s.status = u))
                  else {
                    var m = (8 + ((s.w_bits - 8) << 4)) << 8
                    ;(m |=
                      (2 <= s.strategy || s.level < 2
                        ? 0
                        : s.level < 6
                        ? 1
                        : 6 === s.level
                        ? 2
                        : 3) << 6),
                      0 !== s.strstart && (m |= 32),
                      (m += 31 - (m % 31)),
                      (s.status = u),
                      G(s, m),
                      0 !== s.strstart && (G(s, t.adler >>> 16), G(s, 65535 & t.adler)),
                      (t.adler = 1)
                  }
                if (69 === s.status)
                  if (s.gzhead.extra) {
                    for (
                      a = s.pending;
                      s.gzindex < (65535 & s.gzhead.extra.length) &&
                      (s.pending !== s.pending_buf_size ||
                        (s.gzhead.hcrc &&
                          s.pending > a &&
                          (t.adler = c(t.adler, s.pending_buf, s.pending - a, a)),
                        p(t),
                        (a = s.pending),
                        s.pending !== s.pending_buf_size));

                    )
                      X(s, 255 & s.gzhead.extra[s.gzindex]), s.gzindex++
                    s.gzhead.hcrc &&
                      s.pending > a &&
                      (t.adler = c(t.adler, s.pending_buf, s.pending - a, a)),
                      s.gzindex === s.gzhead.extra.length && ((s.gzindex = 0), (s.status = 73))
                  } else s.status = 73
                if (73 === s.status)
                  if (s.gzhead.name) {
                    a = s.pending
                    do {
                      if (
                        s.pending === s.pending_buf_size &&
                        (s.gzhead.hcrc &&
                          s.pending > a &&
                          (t.adler = c(t.adler, s.pending_buf, s.pending - a, a)),
                        p(t),
                        (a = s.pending),
                        s.pending === s.pending_buf_size)
                      ) {
                        d = 1
                        break
                      }
                      ;(d =
                        s.gzindex < s.gzhead.name.length
                          ? 255 & s.gzhead.name.charCodeAt(s.gzindex++)
                          : 0),
                        X(s, d)
                    } while (0 !== d)
                    s.gzhead.hcrc &&
                      s.pending > a &&
                      (t.adler = c(t.adler, s.pending_buf, s.pending - a, a)),
                      0 === d && ((s.gzindex = 0), (s.status = 91))
                  } else s.status = 91
                if (91 === s.status)
                  if (s.gzhead.comment) {
                    a = s.pending
                    do {
                      if (
                        s.pending === s.pending_buf_size &&
                        (s.gzhead.hcrc &&
                          s.pending > a &&
                          (t.adler = c(t.adler, s.pending_buf, s.pending - a, a)),
                        p(t),
                        (a = s.pending),
                        s.pending === s.pending_buf_size)
                      ) {
                        d = 1
                        break
                      }
                      ;(d =
                        s.gzindex < s.gzhead.comment.length
                          ? 255 & s.gzhead.comment.charCodeAt(s.gzindex++)
                          : 0),
                        X(s, d)
                    } while (0 !== d)
                    s.gzhead.hcrc &&
                      s.pending > a &&
                      (t.adler = c(t.adler, s.pending_buf, s.pending - a, a)),
                      0 === d && (s.status = 103)
                  } else s.status = 103
                if (
                  (103 === s.status &&
                    (s.gzhead.hcrc
                      ? (s.pending + 2 > s.pending_buf_size && p(t),
                        s.pending + 2 <= s.pending_buf_size &&
                          (X(s, 255 & t.adler),
                          X(s, (t.adler >> 8) & 255),
                          (t.adler = 0),
                          (s.status = u)))
                      : (s.status = u)),
                  0 !== s.pending)
                ) {
                  if ((p(t), 0 === t.avail_out)) return (s.last_flush = -1), 0
                } else if (0 === t.avail_in && h(e) <= h(i) && 4 !== e) return b(t, -5)
                if (666 === s.status && 0 !== t.avail_in) return b(t, -5)
                if (0 !== t.avail_in || 0 !== s.lookahead || (0 !== e && 666 !== s.status)) {
                  var W =
                    2 === s.strategy
                      ? (function (t, e) {
                          for (var i; ; ) {
                            if (0 === t.lookahead && (V(t), 0 === t.lookahead)) {
                              if (0 === e) return 1
                              break
                            }
                            if (
                              ((t.match_length = 0),
                              (i = n._tr_tally(t, 0, t.window[t.strstart])),
                              t.lookahead--,
                              t.strstart++,
                              i && (y(t, !1), 0 === t.strm.avail_out))
                            )
                              return 1
                          }
                          return (
                            (t.insert = 0),
                            4 === e
                              ? (y(t, !0), 0 === t.strm.avail_out ? 3 : 4)
                              : t.last_lit && (y(t, !1), 0 === t.strm.avail_out)
                              ? 1
                              : 2
                          )
                        })(s, e)
                      : 3 === s.strategy
                      ? (function (t, e) {
                          for (var i, l, s, a, c = t.window; ; ) {
                            if (t.lookahead <= o) {
                              if ((V(t), t.lookahead <= o && 0 === e)) return 1
                              if (0 === t.lookahead) break
                            }
                            if (
                              ((t.match_length = 0),
                              t.lookahead >= 3 &&
                                0 < t.strstart &&
                                (l = c[(s = t.strstart - 1)]) === c[++s] &&
                                l === c[++s] &&
                                l === c[++s])
                            ) {
                              a = t.strstart + o
                              do {} while (
                                l === c[++s] &&
                                l === c[++s] &&
                                l === c[++s] &&
                                l === c[++s] &&
                                l === c[++s] &&
                                l === c[++s] &&
                                l === c[++s] &&
                                l === c[++s] &&
                                s < a
                              )
                              ;(t.match_length = o - (a - s)),
                                t.match_length > t.lookahead && (t.match_length = t.lookahead)
                            }
                            if (
                              (t.match_length >= 3
                                ? ((i = n._tr_tally(t, 1, t.match_length - 3)),
                                  (t.lookahead -= t.match_length),
                                  (t.strstart += t.match_length),
                                  (t.match_length = 0))
                                : ((i = n._tr_tally(t, 0, t.window[t.strstart])),
                                  t.lookahead--,
                                  t.strstart++),
                              i && (y(t, !1), 0 === t.strm.avail_out))
                            )
                              return 1
                          }
                          return (
                            (t.insert = 0),
                            4 === e
                              ? (y(t, !0), 0 === t.strm.avail_out ? 3 : 4)
                              : t.last_lit && (y(t, !1), 0 === t.strm.avail_out)
                              ? 1
                              : 2
                          )
                        })(s, e)
                      : l[s.level].func(s, e)
                  if (((3 !== W && 4 !== W) || (s.status = 666), 1 === W || 3 === W))
                    return 0 === t.avail_out && (s.last_flush = -1), 0
                  if (
                    2 === W &&
                    (1 === e
                      ? n._tr_align(s)
                      : 5 !== e &&
                        (n._tr_stored_block(s, 0, 0, !1),
                        3 === e &&
                          (Z(s.head),
                          0 === s.lookahead &&
                            ((s.strstart = 0), (s.block_start = 0), (s.insert = 0)))),
                    p(t),
                    0 === t.avail_out)
                  )
                    return (s.last_flush = -1), 0
                }
                return 4 !== e
                  ? 0
                  : s.wrap <= 0
                  ? 1
                  : (2 === s.wrap
                      ? (X(s, 255 & t.adler),
                        X(s, (t.adler >> 8) & 255),
                        X(s, (t.adler >> 16) & 255),
                        X(s, (t.adler >> 24) & 255),
                        X(s, 255 & t.total_in),
                        X(s, (t.total_in >> 8) & 255),
                        X(s, (t.total_in >> 16) & 255),
                        X(s, (t.total_in >> 24) & 255))
                      : (G(s, t.adler >>> 16), G(s, 65535 & t.adler)),
                    p(t),
                    0 < s.wrap && (s.wrap = -s.wrap),
                    0 !== s.pending ? 0 : 1)
              }),
              (i.deflateEnd = function (t) {
                var e
                return t && t.state
                  ? 42 !== (e = t.state.status) &&
                    69 !== e &&
                    73 !== e &&
                    91 !== e &&
                    103 !== e &&
                    e !== u &&
                    666 !== e
                    ? b(t, r)
                    : ((t.state = null), e === u ? b(t, -3) : 0)
                  : r
              }),
              (i.deflateSetDictionary = function (t, e) {
                var i,
                  l,
                  n,
                  c,
                  d,
                  o,
                  m,
                  u,
                  b = e.length
                if (!t || !t.state) return r
                if (2 === (c = (i = t.state).wrap) || (1 === c && 42 !== i.status) || i.lookahead)
                  return r
                for (
                  1 === c && (t.adler = a(t.adler, e, b, 0)),
                    i.wrap = 0,
                    b >= i.w_size &&
                      (0 === c &&
                        (Z(i.head), (i.strstart = 0), (i.block_start = 0), (i.insert = 0)),
                      (u = new s.Buf8(i.w_size)),
                      s.arraySet(u, e, b - i.w_size, i.w_size, 0),
                      (e = u),
                      (b = i.w_size)),
                    d = t.avail_in,
                    o = t.next_in,
                    m = t.input,
                    t.avail_in = b,
                    t.next_in = 0,
                    t.input = e,
                    V(i);
                  i.lookahead >= 3;

                ) {
                  for (
                    l = i.strstart, n = i.lookahead - 2;
                    (i.ins_h = ((i.ins_h << i.hash_shift) ^ i.window[l + 3 - 1]) & i.hash_mask),
                      (i.prev[l & i.w_mask] = i.head[i.ins_h]),
                      (i.head[i.ins_h] = l),
                      l++,
                      --n;

                  );
                  ;(i.strstart = l), (i.lookahead = 2), V(i)
                }
                return (
                  (i.strstart += i.lookahead),
                  (i.block_start = i.strstart),
                  (i.insert = i.lookahead),
                  (i.lookahead = 0),
                  (i.match_length = i.prev_length = 2),
                  (i.match_available = 0),
                  (t.next_in = o),
                  (t.input = m),
                  (t.avail_in = d),
                  (i.wrap = c),
                  0
                )
              }),
              (i.deflateInfo = 'pako deflate (from Nodeca project)')
          },
          { '../utils/common': 41, './adler32': 43, './crc32': 45, './messages': 51, './trees': 52 }
        ],
        47: [
          function (t, e, i) {
            e.exports = function () {
              ;(this.text = 0),
                (this.time = 0),
                (this.xflags = 0),
                (this.os = 0),
                (this.extra = null),
                (this.extra_len = 0),
                (this.name = ''),
                (this.comment = ''),
                (this.hcrc = 0),
                (this.done = !1)
            }
          },
          {}
        ],
        48: [
          function (t, e, i) {
            e.exports = function (t, e) {
              var i, l, s, n, a, c, d, r, o, m, u, b, h, Z, p, y, X, G, W, V, Y, L, S, I, R
              ;(i = t.state),
                (l = t.next_in),
                (I = t.input),
                (s = l + (t.avail_in - 5)),
                (n = t.next_out),
                (R = t.output),
                (a = n - (e - t.avail_out)),
                (c = n + (t.avail_out - 257)),
                (d = i.dmax),
                (r = i.wsize),
                (o = i.whave),
                (m = i.wnext),
                (u = i.window),
                (b = i.hold),
                (h = i.bits),
                (Z = i.lencode),
                (p = i.distcode),
                (y = (1 << i.lenbits) - 1),
                (X = (1 << i.distbits) - 1)
              t: do {
                h < 15 && ((b += I[l++] << h), (h += 8), (b += I[l++] << h), (h += 8)),
                  (G = Z[b & y])
                e: for (;;) {
                  if (((b >>>= W = G >>> 24), (h -= W), 0 == (W = (G >>> 16) & 255)))
                    R[n++] = 65535 & G
                  else {
                    if (!(16 & W)) {
                      if (0 == (64 & W)) {
                        G = Z[(65535 & G) + (b & ((1 << W) - 1))]
                        continue e
                      }
                      if (32 & W) {
                        i.mode = 12
                        break t
                      }
                      ;(t.msg = 'invalid literal/length code'), (i.mode = 30)
                      break t
                    }
                    ;(V = 65535 & G),
                      (W &= 15) &&
                        (h < W && ((b += I[l++] << h), (h += 8)),
                        (V += b & ((1 << W) - 1)),
                        (b >>>= W),
                        (h -= W)),
                      h < 15 && ((b += I[l++] << h), (h += 8), (b += I[l++] << h), (h += 8)),
                      (G = p[b & X])
                    i: for (;;) {
                      if (((b >>>= W = G >>> 24), (h -= W), !(16 & (W = (G >>> 16) & 255)))) {
                        if (0 == (64 & W)) {
                          G = p[(65535 & G) + (b & ((1 << W) - 1))]
                          continue i
                        }
                        ;(t.msg = 'invalid distance code'), (i.mode = 30)
                        break t
                      }
                      if (
                        ((Y = 65535 & G),
                        h < (W &= 15) &&
                          ((b += I[l++] << h), (h += 8) < W && ((b += I[l++] << h), (h += 8))),
                        d < (Y += b & ((1 << W) - 1)))
                      ) {
                        ;(t.msg = 'invalid distance too far back'), (i.mode = 30)
                        break t
                      }
                      if (((b >>>= W), (h -= W), (W = n - a) < Y)) {
                        if (o < (W = Y - W) && i.sane) {
                          ;(t.msg = 'invalid distance too far back'), (i.mode = 30)
                          break t
                        }
                        if (((S = u), (L = 0) === m)) {
                          if (((L += r - W), W < V)) {
                            for (V -= W; (R[n++] = u[L++]), --W; );
                            ;(L = n - Y), (S = R)
                          }
                        } else if (m < W) {
                          if (((L += r + m - W), (W -= m) < V)) {
                            for (V -= W; (R[n++] = u[L++]), --W; );
                            if (((L = 0), m < V)) {
                              for (V -= W = m; (R[n++] = u[L++]), --W; );
                              ;(L = n - Y), (S = R)
                            }
                          }
                        } else if (((L += m - W), W < V)) {
                          for (V -= W; (R[n++] = u[L++]), --W; );
                          ;(L = n - Y), (S = R)
                        }
                        for (; 2 < V; )
                          (R[n++] = S[L++]), (R[n++] = S[L++]), (R[n++] = S[L++]), (V -= 3)
                        V && ((R[n++] = S[L++]), 1 < V && (R[n++] = S[L++]))
                      } else {
                        for (
                          L = n - Y;
                          (R[n++] = R[L++]), (R[n++] = R[L++]), (R[n++] = R[L++]), 2 < (V -= 3);

                        );
                        V && ((R[n++] = R[L++]), 1 < V && (R[n++] = R[L++]))
                      }
                      break
                    }
                  }
                  break
                }
              } while (l < s && n < c)
              ;(l -= V = h >> 3),
                (b &= (1 << (h -= V << 3)) - 1),
                (t.next_in = l),
                (t.next_out = n),
                (t.avail_in = l < s ? s - l + 5 : 5 - (l - s)),
                (t.avail_out = n < c ? c - n + 257 : 257 - (n - c)),
                (i.hold = b),
                (i.bits = h)
            }
          },
          {}
        ],
        49: [
          function (t, e, i) {
            var l = t('../utils/common'),
              s = t('./adler32'),
              n = t('./crc32'),
              a = t('./inffast'),
              c = t('./inftrees'),
              d = -2
            function r(t) {
              return (
                ((t >>> 24) & 255) + ((t >>> 8) & 65280) + ((65280 & t) << 8) + ((255 & t) << 24)
              )
            }
            function o() {
              ;(this.mode = 0),
                (this.last = !1),
                (this.wrap = 0),
                (this.havedict = !1),
                (this.flags = 0),
                (this.dmax = 0),
                (this.check = 0),
                (this.total = 0),
                (this.head = null),
                (this.wbits = 0),
                (this.wsize = 0),
                (this.whave = 0),
                (this.wnext = 0),
                (this.window = null),
                (this.hold = 0),
                (this.bits = 0),
                (this.length = 0),
                (this.offset = 0),
                (this.extra = 0),
                (this.lencode = null),
                (this.distcode = null),
                (this.lenbits = 0),
                (this.distbits = 0),
                (this.ncode = 0),
                (this.nlen = 0),
                (this.ndist = 0),
                (this.have = 0),
                (this.next = null),
                (this.lens = new l.Buf16(320)),
                (this.work = new l.Buf16(288)),
                (this.lendyn = null),
                (this.distdyn = null),
                (this.sane = 0),
                (this.back = 0),
                (this.was = 0)
            }
            function m(t) {
              var e
              return t && t.state
                ? ((e = t.state),
                  (t.total_in = t.total_out = e.total = 0),
                  (t.msg = ''),
                  e.wrap && (t.adler = 1 & e.wrap),
                  (e.mode = 1),
                  (e.last = 0),
                  (e.havedict = 0),
                  (e.dmax = 32768),
                  (e.head = null),
                  (e.hold = 0),
                  (e.bits = 0),
                  (e.lencode = e.lendyn = new l.Buf32(852)),
                  (e.distcode = e.distdyn = new l.Buf32(592)),
                  (e.sane = 1),
                  (e.back = -1),
                  0)
                : d
            }
            function u(t) {
              var e
              return t && t.state
                ? (((e = t.state).wsize = 0), (e.whave = 0), (e.wnext = 0), m(t))
                : d
            }
            function b(t, e) {
              var i, l
              return t && t.state
                ? ((l = t.state),
                  e < 0 ? ((i = 0), (e = -e)) : ((i = 1 + (e >> 4)), e < 48 && (e &= 15)),
                  e && (e < 8 || 15 < e)
                    ? d
                    : (null !== l.window && l.wbits !== e && (l.window = null),
                      (l.wrap = i),
                      (l.wbits = e),
                      u(t)))
                : d
            }
            function h(t, e) {
              var i, l
              return t
                ? ((l = new o()),
                  ((t.state = l).window = null),
                  0 !== (i = b(t, e)) && (t.state = null),
                  i)
                : d
            }
            var Z,
              p,
              y = !0
            function X(t) {
              if (y) {
                var e
                for (Z = new l.Buf32(512), p = new l.Buf32(32), e = 0; e < 144; ) t.lens[e++] = 8
                for (; e < 256; ) t.lens[e++] = 9
                for (; e < 280; ) t.lens[e++] = 7
                for (; e < 288; ) t.lens[e++] = 8
                for (c(1, t.lens, 0, 288, Z, 0, t.work, { bits: 9 }), e = 0; e < 32; )
                  t.lens[e++] = 5
                c(2, t.lens, 0, 32, p, 0, t.work, { bits: 5 }), (y = !1)
              }
              ;(t.lencode = Z), (t.lenbits = 9), (t.distcode = p), (t.distbits = 5)
            }
            function G(t, e, i, s) {
              var n,
                a = t.state
              return (
                null === a.window &&
                  ((a.wsize = 1 << a.wbits),
                  (a.wnext = 0),
                  (a.whave = 0),
                  (a.window = new l.Buf8(a.wsize))),
                s >= a.wsize
                  ? (l.arraySet(a.window, e, i - a.wsize, a.wsize, 0),
                    (a.wnext = 0),
                    (a.whave = a.wsize))
                  : (s < (n = a.wsize - a.wnext) && (n = s),
                    l.arraySet(a.window, e, i - s, n, a.wnext),
                    (s -= n)
                      ? (l.arraySet(a.window, e, i - s, s, 0), (a.wnext = s), (a.whave = a.wsize))
                      : ((a.wnext += n),
                        a.wnext === a.wsize && (a.wnext = 0),
                        a.whave < a.wsize && (a.whave += n))),
                0
              )
            }
            ;(i.inflateReset = u),
              (i.inflateReset2 = b),
              (i.inflateResetKeep = m),
              (i.inflateInit = function (t) {
                return h(t, 15)
              }),
              (i.inflateInit2 = h),
              (i.inflate = function (t, e) {
                var i,
                  o,
                  m,
                  u,
                  b,
                  h,
                  Z,
                  p,
                  y,
                  W,
                  V,
                  Y,
                  L,
                  S,
                  I,
                  R,
                  f,
                  x,
                  g,
                  K,
                  J,
                  N,
                  z,
                  v,
                  H = 0,
                  w = new l.Buf8(4),
                  T = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
                if (!t || !t.state || !t.output || (!t.input && 0 !== t.avail_in)) return d
                12 === (i = t.state).mode && (i.mode = 13),
                  (b = t.next_out),
                  (m = t.output),
                  (Z = t.avail_out),
                  (u = t.next_in),
                  (o = t.input),
                  (h = t.avail_in),
                  (p = i.hold),
                  (y = i.bits),
                  (W = h),
                  (V = Z),
                  (N = 0)
                t: for (;;)
                  switch (i.mode) {
                    case 1:
                      if (0 === i.wrap) {
                        i.mode = 13
                        break
                      }
                      for (; y < 16; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      if (2 & i.wrap && 35615 === p) {
                        ;(w[(i.check = 0)] = 255 & p),
                          (w[1] = (p >>> 8) & 255),
                          (i.check = n(i.check, w, 2, 0)),
                          (y = p = 0),
                          (i.mode = 2)
                        break
                      }
                      if (
                        ((i.flags = 0),
                        i.head && (i.head.done = !1),
                        !(1 & i.wrap) || (((255 & p) << 8) + (p >> 8)) % 31)
                      ) {
                        ;(t.msg = 'incorrect header check'), (i.mode = 30)
                        break
                      }
                      if (8 != (15 & p)) {
                        ;(t.msg = 'unknown compression method'), (i.mode = 30)
                        break
                      }
                      if (((y -= 4), (J = 8 + (15 & (p >>>= 4))), 0 === i.wbits)) i.wbits = J
                      else if (J > i.wbits) {
                        ;(t.msg = 'invalid window size'), (i.mode = 30)
                        break
                      }
                      ;(i.dmax = 1 << J),
                        (t.adler = i.check = 1),
                        (i.mode = 512 & p ? 10 : 12),
                        (y = p = 0)
                      break
                    case 2:
                      for (; y < 16; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      if (((i.flags = p), 8 != (255 & i.flags))) {
                        ;(t.msg = 'unknown compression method'), (i.mode = 30)
                        break
                      }
                      if (57344 & i.flags) {
                        ;(t.msg = 'unknown header flags set'), (i.mode = 30)
                        break
                      }
                      i.head && (i.head.text = (p >> 8) & 1),
                        512 & i.flags &&
                          ((w[0] = 255 & p),
                          (w[1] = (p >>> 8) & 255),
                          (i.check = n(i.check, w, 2, 0))),
                        (y = p = 0),
                        (i.mode = 3)
                    case 3:
                      for (; y < 32; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      i.head && (i.head.time = p),
                        512 & i.flags &&
                          ((w[0] = 255 & p),
                          (w[1] = (p >>> 8) & 255),
                          (w[2] = (p >>> 16) & 255),
                          (w[3] = (p >>> 24) & 255),
                          (i.check = n(i.check, w, 4, 0))),
                        (y = p = 0),
                        (i.mode = 4)
                    case 4:
                      for (; y < 16; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      i.head && ((i.head.xflags = 255 & p), (i.head.os = p >> 8)),
                        512 & i.flags &&
                          ((w[0] = 255 & p),
                          (w[1] = (p >>> 8) & 255),
                          (i.check = n(i.check, w, 2, 0))),
                        (y = p = 0),
                        (i.mode = 5)
                    case 5:
                      if (1024 & i.flags) {
                        for (; y < 16; ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        ;(i.length = p),
                          i.head && (i.head.extra_len = p),
                          512 & i.flags &&
                            ((w[0] = 255 & p),
                            (w[1] = (p >>> 8) & 255),
                            (i.check = n(i.check, w, 2, 0))),
                          (y = p = 0)
                      } else i.head && (i.head.extra = null)
                      i.mode = 6
                    case 6:
                      if (
                        1024 & i.flags &&
                        (h < (Y = i.length) && (Y = h),
                        Y &&
                          (i.head &&
                            ((J = i.head.extra_len - i.length),
                            i.head.extra || (i.head.extra = new Array(i.head.extra_len)),
                            l.arraySet(i.head.extra, o, u, Y, J)),
                          512 & i.flags && (i.check = n(i.check, o, Y, u)),
                          (h -= Y),
                          (u += Y),
                          (i.length -= Y)),
                        i.length)
                      )
                        break t
                      ;(i.length = 0), (i.mode = 7)
                    case 7:
                      if (2048 & i.flags) {
                        if (0 === h) break t
                        for (
                          Y = 0;
                          (J = o[u + Y++]),
                            i.head &&
                              J &&
                              i.length < 65536 &&
                              (i.head.name += String.fromCharCode(J)),
                            J && Y < h;

                        );
                        if (
                          (512 & i.flags && (i.check = n(i.check, o, Y, u)), (h -= Y), (u += Y), J)
                        )
                          break t
                      } else i.head && (i.head.name = null)
                      ;(i.length = 0), (i.mode = 8)
                    case 8:
                      if (4096 & i.flags) {
                        if (0 === h) break t
                        for (
                          Y = 0;
                          (J = o[u + Y++]),
                            i.head &&
                              J &&
                              i.length < 65536 &&
                              (i.head.comment += String.fromCharCode(J)),
                            J && Y < h;

                        );
                        if (
                          (512 & i.flags && (i.check = n(i.check, o, Y, u)), (h -= Y), (u += Y), J)
                        )
                          break t
                      } else i.head && (i.head.comment = null)
                      i.mode = 9
                    case 9:
                      if (512 & i.flags) {
                        for (; y < 16; ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        if (p !== (65535 & i.check)) {
                          ;(t.msg = 'header crc mismatch'), (i.mode = 30)
                          break
                        }
                        y = p = 0
                      }
                      i.head && ((i.head.hcrc = (i.flags >> 9) & 1), (i.head.done = !0)),
                        (t.adler = i.check = 0),
                        (i.mode = 12)
                      break
                    case 10:
                      for (; y < 32; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      ;(t.adler = i.check = r(p)), (y = p = 0), (i.mode = 11)
                    case 11:
                      if (0 === i.havedict)
                        return (
                          (t.next_out = b),
                          (t.avail_out = Z),
                          (t.next_in = u),
                          (t.avail_in = h),
                          (i.hold = p),
                          (i.bits = y),
                          2
                        )
                      ;(t.adler = i.check = 1), (i.mode = 12)
                    case 12:
                      if (5 === e || 6 === e) break t
                    case 13:
                      if (i.last) {
                        ;(p >>>= 7 & y), (y -= 7 & y), (i.mode = 27)
                        break
                      }
                      for (; y < 3; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      switch (((i.last = 1 & p), (y -= 1), 3 & (p >>>= 1))) {
                        case 0:
                          i.mode = 14
                          break
                        case 1:
                          if ((X(i), (i.mode = 20), 6 !== e)) break
                          ;(p >>>= 2), (y -= 2)
                          break t
                        case 2:
                          i.mode = 17
                          break
                        case 3:
                          ;(t.msg = 'invalid block type'), (i.mode = 30)
                      }
                      ;(p >>>= 2), (y -= 2)
                      break
                    case 14:
                      for (p >>>= 7 & y, y -= 7 & y; y < 32; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      if ((65535 & p) != ((p >>> 16) ^ 65535)) {
                        ;(t.msg = 'invalid stored block lengths'), (i.mode = 30)
                        break
                      }
                      if (((i.length = 65535 & p), (y = p = 0), (i.mode = 15), 6 === e)) break t
                    case 15:
                      i.mode = 16
                    case 16:
                      if ((Y = i.length)) {
                        if ((h < Y && (Y = h), Z < Y && (Y = Z), 0 === Y)) break t
                        l.arraySet(m, o, u, Y, b),
                          (h -= Y),
                          (u += Y),
                          (Z -= Y),
                          (b += Y),
                          (i.length -= Y)
                        break
                      }
                      i.mode = 12
                      break
                    case 17:
                      for (; y < 14; ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      if (
                        ((i.nlen = 257 + (31 & p)),
                        (p >>>= 5),
                        (y -= 5),
                        (i.ndist = 1 + (31 & p)),
                        (p >>>= 5),
                        (y -= 5),
                        (i.ncode = 4 + (15 & p)),
                        (p >>>= 4),
                        (y -= 4),
                        286 < i.nlen || 30 < i.ndist)
                      ) {
                        ;(t.msg = 'too many length or distance symbols'), (i.mode = 30)
                        break
                      }
                      ;(i.have = 0), (i.mode = 18)
                    case 18:
                      for (; i.have < i.ncode; ) {
                        for (; y < 3; ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        ;(i.lens[T[i.have++]] = 7 & p), (p >>>= 3), (y -= 3)
                      }
                      for (; i.have < 19; ) i.lens[T[i.have++]] = 0
                      if (
                        ((i.lencode = i.lendyn),
                        (i.lenbits = 7),
                        (z = { bits: i.lenbits }),
                        (N = c(0, i.lens, 0, 19, i.lencode, 0, i.work, z)),
                        (i.lenbits = z.bits),
                        N)
                      ) {
                        ;(t.msg = 'invalid code lengths set'), (i.mode = 30)
                        break
                      }
                      ;(i.have = 0), (i.mode = 19)
                    case 19:
                      for (; i.have < i.nlen + i.ndist; ) {
                        for (
                          ;
                          (R = ((H = i.lencode[p & ((1 << i.lenbits) - 1)]) >>> 16) & 255),
                            (f = 65535 & H),
                            !((I = H >>> 24) <= y);

                        ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        if (f < 16) (p >>>= I), (y -= I), (i.lens[i.have++] = f)
                        else {
                          if (16 === f) {
                            for (v = I + 2; y < v; ) {
                              if (0 === h) break t
                              h--, (p += o[u++] << y), (y += 8)
                            }
                            if (((p >>>= I), (y -= I), 0 === i.have)) {
                              ;(t.msg = 'invalid bit length repeat'), (i.mode = 30)
                              break
                            }
                            ;(J = i.lens[i.have - 1]), (Y = 3 + (3 & p)), (p >>>= 2), (y -= 2)
                          } else if (17 === f) {
                            for (v = I + 3; y < v; ) {
                              if (0 === h) break t
                              h--, (p += o[u++] << y), (y += 8)
                            }
                            ;(y -= I), (J = 0), (Y = 3 + (7 & (p >>>= I))), (p >>>= 3), (y -= 3)
                          } else {
                            for (v = I + 7; y < v; ) {
                              if (0 === h) break t
                              h--, (p += o[u++] << y), (y += 8)
                            }
                            ;(y -= I), (J = 0), (Y = 11 + (127 & (p >>>= I))), (p >>>= 7), (y -= 7)
                          }
                          if (i.have + Y > i.nlen + i.ndist) {
                            ;(t.msg = 'invalid bit length repeat'), (i.mode = 30)
                            break
                          }
                          for (; Y--; ) i.lens[i.have++] = J
                        }
                      }
                      if (30 === i.mode) break
                      if (0 === i.lens[256]) {
                        ;(t.msg = 'invalid code -- missing end-of-block'), (i.mode = 30)
                        break
                      }
                      if (
                        ((i.lenbits = 9),
                        (z = { bits: i.lenbits }),
                        (N = c(1, i.lens, 0, i.nlen, i.lencode, 0, i.work, z)),
                        (i.lenbits = z.bits),
                        N)
                      ) {
                        ;(t.msg = 'invalid literal/lengths set'), (i.mode = 30)
                        break
                      }
                      if (
                        ((i.distbits = 6),
                        (i.distcode = i.distdyn),
                        (z = { bits: i.distbits }),
                        (N = c(2, i.lens, i.nlen, i.ndist, i.distcode, 0, i.work, z)),
                        (i.distbits = z.bits),
                        N)
                      ) {
                        ;(t.msg = 'invalid distances set'), (i.mode = 30)
                        break
                      }
                      if (((i.mode = 20), 6 === e)) break t
                    case 20:
                      i.mode = 21
                    case 21:
                      if (6 <= h && 258 <= Z) {
                        ;(t.next_out = b),
                          (t.avail_out = Z),
                          (t.next_in = u),
                          (t.avail_in = h),
                          (i.hold = p),
                          (i.bits = y),
                          a(t, V),
                          (b = t.next_out),
                          (m = t.output),
                          (Z = t.avail_out),
                          (u = t.next_in),
                          (o = t.input),
                          (h = t.avail_in),
                          (p = i.hold),
                          (y = i.bits),
                          12 === i.mode && (i.back = -1)
                        break
                      }
                      for (
                        i.back = 0;
                        (R = ((H = i.lencode[p & ((1 << i.lenbits) - 1)]) >>> 16) & 255),
                          (f = 65535 & H),
                          !((I = H >>> 24) <= y);

                      ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      if (R && 0 == (240 & R)) {
                        for (
                          x = I, g = R, K = f;
                          (R =
                            ((H = i.lencode[K + ((p & ((1 << (x + g)) - 1)) >> x)]) >>> 16) & 255),
                            (f = 65535 & H),
                            !(x + (I = H >>> 24) <= y);

                        ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        ;(p >>>= x), (y -= x), (i.back += x)
                      }
                      if (((p >>>= I), (y -= I), (i.back += I), (i.length = f), 0 === R)) {
                        i.mode = 26
                        break
                      }
                      if (32 & R) {
                        ;(i.back = -1), (i.mode = 12)
                        break
                      }
                      if (64 & R) {
                        ;(t.msg = 'invalid literal/length code'), (i.mode = 30)
                        break
                      }
                      ;(i.extra = 15 & R), (i.mode = 22)
                    case 22:
                      if (i.extra) {
                        for (v = i.extra; y < v; ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        ;(i.length += p & ((1 << i.extra) - 1)),
                          (p >>>= i.extra),
                          (y -= i.extra),
                          (i.back += i.extra)
                      }
                      ;(i.was = i.length), (i.mode = 23)
                    case 23:
                      for (
                        ;
                        (R = ((H = i.distcode[p & ((1 << i.distbits) - 1)]) >>> 16) & 255),
                          (f = 65535 & H),
                          !((I = H >>> 24) <= y);

                      ) {
                        if (0 === h) break t
                        h--, (p += o[u++] << y), (y += 8)
                      }
                      if (0 == (240 & R)) {
                        for (
                          x = I, g = R, K = f;
                          (R =
                            ((H = i.distcode[K + ((p & ((1 << (x + g)) - 1)) >> x)]) >>> 16) & 255),
                            (f = 65535 & H),
                            !(x + (I = H >>> 24) <= y);

                        ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        ;(p >>>= x), (y -= x), (i.back += x)
                      }
                      if (((p >>>= I), (y -= I), (i.back += I), 64 & R)) {
                        ;(t.msg = 'invalid distance code'), (i.mode = 30)
                        break
                      }
                      ;(i.offset = f), (i.extra = 15 & R), (i.mode = 24)
                    case 24:
                      if (i.extra) {
                        for (v = i.extra; y < v; ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        ;(i.offset += p & ((1 << i.extra) - 1)),
                          (p >>>= i.extra),
                          (y -= i.extra),
                          (i.back += i.extra)
                      }
                      if (i.offset > i.dmax) {
                        ;(t.msg = 'invalid distance too far back'), (i.mode = 30)
                        break
                      }
                      i.mode = 25
                    case 25:
                      if (0 === Z) break t
                      if (((Y = V - Z), i.offset > Y)) {
                        if ((Y = i.offset - Y) > i.whave && i.sane) {
                          ;(t.msg = 'invalid distance too far back'), (i.mode = 30)
                          break
                        }
                        ;(L = Y > i.wnext ? ((Y -= i.wnext), i.wsize - Y) : i.wnext - Y),
                          Y > i.length && (Y = i.length),
                          (S = i.window)
                      } else (S = m), (L = b - i.offset), (Y = i.length)
                      for (Z < Y && (Y = Z), Z -= Y, i.length -= Y; (m[b++] = S[L++]), --Y; );
                      0 === i.length && (i.mode = 21)
                      break
                    case 26:
                      if (0 === Z) break t
                      ;(m[b++] = i.length), Z--, (i.mode = 21)
                      break
                    case 27:
                      if (i.wrap) {
                        for (; y < 32; ) {
                          if (0 === h) break t
                          h--, (p |= o[u++] << y), (y += 8)
                        }
                        if (
                          ((V -= Z),
                          (t.total_out += V),
                          (i.total += V),
                          V &&
                            (t.adler = i.check =
                              i.flags ? n(i.check, m, V, b - V) : s(i.check, m, V, b - V)),
                          (V = Z),
                          (i.flags ? p : r(p)) !== i.check)
                        ) {
                          ;(t.msg = 'incorrect data check'), (i.mode = 30)
                          break
                        }
                        y = p = 0
                      }
                      i.mode = 28
                    case 28:
                      if (i.wrap && i.flags) {
                        for (; y < 32; ) {
                          if (0 === h) break t
                          h--, (p += o[u++] << y), (y += 8)
                        }
                        if (p !== (4294967295 & i.total)) {
                          ;(t.msg = 'incorrect length check'), (i.mode = 30)
                          break
                        }
                        y = p = 0
                      }
                      i.mode = 29
                    case 29:
                      N = 1
                      break t
                    case 30:
                      N = -3
                      break t
                    case 31:
                      return -4
                    case 32:
                    default:
                      return d
                  }
                return (
                  (t.next_out = b),
                  (t.avail_out = Z),
                  (t.next_in = u),
                  (t.avail_in = h),
                  (i.hold = p),
                  (i.bits = y),
                  (i.wsize || (V !== t.avail_out && i.mode < 30 && (i.mode < 27 || 4 !== e))) &&
                  G(t, t.output, t.next_out, V - t.avail_out)
                    ? ((i.mode = 31), -4)
                    : ((W -= t.avail_in),
                      (V -= t.avail_out),
                      (t.total_in += W),
                      (t.total_out += V),
                      (i.total += V),
                      i.wrap &&
                        V &&
                        (t.adler = i.check =
                          i.flags
                            ? n(i.check, m, V, t.next_out - V)
                            : s(i.check, m, V, t.next_out - V)),
                      (t.data_type =
                        i.bits +
                        (i.last ? 64 : 0) +
                        (12 === i.mode ? 128 : 0) +
                        (20 === i.mode || 15 === i.mode ? 256 : 0)),
                      ((0 == W && 0 === V) || 4 === e) && 0 === N && (N = -5),
                      N)
                )
              }),
              (i.inflateEnd = function (t) {
                if (!t || !t.state) return d
                var e = t.state
                return e.window && (e.window = null), (t.state = null), 0
              }),
              (i.inflateGetHeader = function (t, e) {
                var i
                return t && t.state
                  ? 0 == (2 & (i = t.state).wrap)
                    ? d
                    : (((i.head = e).done = !1), 0)
                  : d
              }),
              (i.inflateSetDictionary = function (t, e) {
                var i,
                  l = e.length
                return t && t.state
                  ? 0 !== (i = t.state).wrap && 11 !== i.mode
                    ? d
                    : 11 === i.mode && s(1, e, l, 0) !== i.check
                    ? -3
                    : G(t, e, l, l)
                    ? ((i.mode = 31), -4)
                    : ((i.havedict = 1), 0)
                  : d
              }),
              (i.inflateInfo = 'pako inflate (from Nodeca project)')
          },
          {
            '../utils/common': 41,
            './adler32': 43,
            './crc32': 45,
            './inffast': 48,
            './inftrees': 50
          }
        ],
        50: [
          function (t, e, i) {
            var l = t('../utils/common'),
              s = [
                3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99,
                115, 131, 163, 195, 227, 258, 0, 0
              ],
              n = [
                16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20,
                20, 20, 20, 21, 21, 21, 21, 16, 72, 78
              ],
              a = [
                1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025,
                1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0
              ],
              c = [
                16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25,
                25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64
              ]
            e.exports = function (t, e, i, d, r, o, m, u) {
              var b,
                h,
                Z,
                p,
                y,
                X,
                G,
                W,
                V,
                Y = u.bits,
                L = 0,
                S = 0,
                I = 0,
                R = 0,
                f = 0,
                x = 0,
                g = 0,
                K = 0,
                J = 0,
                N = 0,
                z = null,
                v = 0,
                H = new l.Buf16(16),
                w = new l.Buf16(16),
                T = null,
                F = 0
              for (L = 0; L <= 15; L++) H[L] = 0
              for (S = 0; S < d; S++) H[e[i + S]]++
              for (f = Y, R = 15; 1 <= R && 0 === H[R]; R--);
              if ((R < f && (f = R), 0 === R))
                return (r[o++] = 20971520), (r[o++] = 20971520), (u.bits = 1), 0
              for (I = 1; I < R && 0 === H[I]; I++);
              for (f < I && (f = I), L = K = 1; L <= 15; L++)
                if (((K <<= 1), (K -= H[L]) < 0)) return -1
              if (0 < K && (0 === t || 1 !== R)) return -1
              for (w[1] = 0, L = 1; L < 15; L++) w[L + 1] = w[L] + H[L]
              for (S = 0; S < d; S++) 0 !== e[i + S] && (m[w[e[i + S]]++] = S)
              if (
                ((X =
                  0 === t
                    ? ((z = T = m), 19)
                    : 1 === t
                    ? ((z = s), (v -= 257), (T = n), (F -= 257), 256)
                    : ((z = a), (T = c), -1)),
                (L = I),
                (y = o),
                (g = S = N = 0),
                (Z = -1),
                (p = (J = 1 << (x = f)) - 1),
                (1 === t && 852 < J) || (2 === t && 592 < J))
              )
                return 1
              for (;;) {
                for (
                  G = L - g,
                    V =
                      m[S] < X
                        ? ((W = 0), m[S])
                        : m[S] > X
                        ? ((W = T[F + m[S]]), z[v + m[S]])
                        : ((W = 96), 0),
                    b = 1 << (L - g),
                    I = h = 1 << x;
                  (r[y + (N >> g) + (h -= b)] = (G << 24) | (W << 16) | V | 0), 0 !== h;

                );
                for (b = 1 << (L - 1); N & b; ) b >>= 1
                if ((0 !== b ? ((N &= b - 1), (N += b)) : (N = 0), S++, 0 == --H[L])) {
                  if (L === R) break
                  L = e[i + m[S]]
                }
                if (f < L && (N & p) !== Z) {
                  for (
                    0 === g && (g = f), y += I, K = 1 << (x = L - g);
                    x + g < R && !((K -= H[x + g]) <= 0);

                  )
                    x++, (K <<= 1)
                  if (((J += 1 << x), (1 === t && 852 < J) || (2 === t && 592 < J))) return 1
                  r[(Z = N & p)] = (f << 24) | (x << 16) | (y - o) | 0
                }
              }
              return 0 !== N && (r[y + N] = ((L - g) << 24) | (64 << 16) | 0), (u.bits = f), 0
            }
          },
          { '../utils/common': 41 }
        ],
        51: [
          function (t, e, i) {
            e.exports = {
              2: 'need dictionary',
              1: 'stream end',
              0: '',
              '-1': 'file error',
              '-2': 'stream error',
              '-3': 'data error',
              '-4': 'insufficient memory',
              '-5': 'buffer error',
              '-6': 'incompatible version'
            }
          },
          {}
        ],
        52: [
          function (t, e, i) {
            var l = t('../utils/common')
            function s(t) {
              for (var e = t.length; 0 <= --e; ) t[e] = 0
            }
            var n = 256,
              a = 286,
              c = 30,
              d = 15,
              r = [
                0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5,
                0
              ],
              o = [
                0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11,
                12, 12, 13, 13
              ],
              m = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
              u = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
              b = new Array(576)
            s(b)
            var h = new Array(60)
            s(h)
            var Z = new Array(512)
            s(Z)
            var p = new Array(256)
            s(p)
            var y = new Array(29)
            s(y)
            var X,
              G,
              W,
              V = new Array(c)
            function Y(t, e, i, l, s) {
              ;(this.static_tree = t),
                (this.extra_bits = e),
                (this.extra_base = i),
                (this.elems = l),
                (this.max_length = s),
                (this.has_stree = t && t.length)
            }
            function L(t, e) {
              ;(this.dyn_tree = t), (this.max_code = 0), (this.stat_desc = e)
            }
            function S(t) {
              return t < 256 ? Z[t] : Z[256 + (t >>> 7)]
            }
            function I(t, e) {
              ;(t.pending_buf[t.pending++] = 255 & e),
                (t.pending_buf[t.pending++] = (e >>> 8) & 255)
            }
            function R(t, e, i) {
              t.bi_valid > 16 - i
                ? ((t.bi_buf |= (e << t.bi_valid) & 65535),
                  I(t, t.bi_buf),
                  (t.bi_buf = e >> (16 - t.bi_valid)),
                  (t.bi_valid += i - 16))
                : ((t.bi_buf |= (e << t.bi_valid) & 65535), (t.bi_valid += i))
            }
            function f(t, e, i) {
              R(t, i[2 * e], i[2 * e + 1])
            }
            function x(t, e) {
              for (var i = 0; (i |= 1 & t), (t >>>= 1), (i <<= 1), 0 < --e; );
              return i >>> 1
            }
            function g(t, e, i) {
              var l,
                s,
                n = new Array(16),
                a = 0
              for (l = 1; l <= d; l++) n[l] = a = (a + i[l - 1]) << 1
              for (s = 0; s <= e; s++) {
                var c = t[2 * s + 1]
                0 !== c && (t[2 * s] = x(n[c]++, c))
              }
            }
            function K(t) {
              var e
              for (e = 0; e < a; e++) t.dyn_ltree[2 * e] = 0
              for (e = 0; e < c; e++) t.dyn_dtree[2 * e] = 0
              for (e = 0; e < 19; e++) t.bl_tree[2 * e] = 0
              ;(t.dyn_ltree[512] = 1), (t.opt_len = t.static_len = 0), (t.last_lit = t.matches = 0)
            }
            function J(t) {
              8 < t.bi_valid
                ? I(t, t.bi_buf)
                : 0 < t.bi_valid && (t.pending_buf[t.pending++] = t.bi_buf),
                (t.bi_buf = 0),
                (t.bi_valid = 0)
            }
            function N(t, e, i, l) {
              var s = 2 * e,
                n = 2 * i
              return t[s] < t[n] || (t[s] === t[n] && l[e] <= l[i])
            }
            function z(t, e, i) {
              for (
                var l = t.heap[i], s = i << 1;
                s <= t.heap_len &&
                (s < t.heap_len && N(e, t.heap[s + 1], t.heap[s], t.depth) && s++,
                !N(e, l, t.heap[s], t.depth));

              )
                (t.heap[i] = t.heap[s]), (i = s), (s <<= 1)
              t.heap[i] = l
            }
            function v(t, e, i) {
              var l,
                s,
                a,
                c,
                d = 0
              if (0 !== t.last_lit)
                for (
                  ;
                  (l = (t.pending_buf[t.d_buf + 2 * d] << 8) | t.pending_buf[t.d_buf + 2 * d + 1]),
                    (s = t.pending_buf[t.l_buf + d]),
                    d++,
                    0 === l
                      ? f(t, s, e)
                      : (f(t, (a = p[s]) + n + 1, e),
                        0 !== (c = r[a]) && R(t, (s -= y[a]), c),
                        f(t, (a = S(--l)), i),
                        0 !== (c = o[a]) && R(t, (l -= V[a]), c)),
                    d < t.last_lit;

                );
              f(t, 256, e)
            }
            function H(t, e) {
              var i,
                l,
                s,
                n = e.dyn_tree,
                a = e.stat_desc.static_tree,
                c = e.stat_desc.has_stree,
                r = e.stat_desc.elems,
                o = -1
              for (t.heap_len = 0, t.heap_max = 573, i = 0; i < r; i++)
                0 !== n[2 * i]
                  ? ((t.heap[++t.heap_len] = o = i), (t.depth[i] = 0))
                  : (n[2 * i + 1] = 0)
              for (; t.heap_len < 2; )
                (n[2 * (s = t.heap[++t.heap_len] = o < 2 ? ++o : 0)] = 1),
                  (t.depth[s] = 0),
                  t.opt_len--,
                  c && (t.static_len -= a[2 * s + 1])
              for (e.max_code = o, i = t.heap_len >> 1; 1 <= i; i--) z(t, n, i)
              for (
                s = r;
                (i = t.heap[1]),
                  (t.heap[1] = t.heap[t.heap_len--]),
                  z(t, n, 1),
                  (l = t.heap[1]),
                  (t.heap[--t.heap_max] = i),
                  (t.heap[--t.heap_max] = l),
                  (n[2 * s] = n[2 * i] + n[2 * l]),
                  (t.depth[s] = (t.depth[i] >= t.depth[l] ? t.depth[i] : t.depth[l]) + 1),
                  (n[2 * i + 1] = n[2 * l + 1] = s),
                  (t.heap[1] = s++),
                  z(t, n, 1),
                  2 <= t.heap_len;

              );
              ;(t.heap[--t.heap_max] = t.heap[1]),
                (function (t, e) {
                  var i,
                    l,
                    s,
                    n,
                    a,
                    c,
                    r = e.dyn_tree,
                    o = e.max_code,
                    m = e.stat_desc.static_tree,
                    u = e.stat_desc.has_stree,
                    b = e.stat_desc.extra_bits,
                    h = e.stat_desc.extra_base,
                    Z = e.stat_desc.max_length,
                    p = 0
                  for (n = 0; n <= d; n++) t.bl_count[n] = 0
                  for (r[2 * t.heap[t.heap_max] + 1] = 0, i = t.heap_max + 1; i < 573; i++)
                    Z < (n = r[2 * r[2 * (l = t.heap[i]) + 1] + 1] + 1) && ((n = Z), p++),
                      (r[2 * l + 1] = n),
                      o < l ||
                        (t.bl_count[n]++,
                        (a = 0),
                        h <= l && (a = b[l - h]),
                        (c = r[2 * l]),
                        (t.opt_len += c * (n + a)),
                        u && (t.static_len += c * (m[2 * l + 1] + a)))
                  if (0 !== p) {
                    do {
                      for (n = Z - 1; 0 === t.bl_count[n]; ) n--
                      t.bl_count[n]--, (t.bl_count[n + 1] += 2), t.bl_count[Z]--, (p -= 2)
                    } while (0 < p)
                    for (n = Z; 0 !== n; n--)
                      for (l = t.bl_count[n]; 0 !== l; )
                        o < (s = t.heap[--i]) ||
                          (r[2 * s + 1] !== n &&
                            ((t.opt_len += (n - r[2 * s + 1]) * r[2 * s]), (r[2 * s + 1] = n)),
                          l--)
                  }
                })(t, e),
                g(n, o, t.bl_count)
            }
            function w(t, e, i) {
              var l,
                s,
                n = -1,
                a = e[1],
                c = 0,
                d = 7,
                r = 4
              for (0 === a && ((d = 138), (r = 3)), e[2 * (i + 1) + 1] = 65535, l = 0; l <= i; l++)
                (s = a),
                  (a = e[2 * (l + 1) + 1]),
                  (++c < d && s === a) ||
                    (c < r
                      ? (t.bl_tree[2 * s] += c)
                      : 0 !== s
                      ? (s !== n && t.bl_tree[2 * s]++, t.bl_tree[32]++)
                      : c <= 10
                      ? t.bl_tree[34]++
                      : t.bl_tree[36]++,
                    (n = s),
                    (r = (c = 0) === a ? ((d = 138), 3) : s === a ? ((d = 6), 3) : ((d = 7), 4)))
            }
            function T(t, e, i) {
              var l,
                s,
                n = -1,
                a = e[1],
                c = 0,
                d = 7,
                r = 4
              for (0 === a && ((d = 138), (r = 3)), l = 0; l <= i; l++)
                if (((s = a), (a = e[2 * (l + 1) + 1]), !(++c < d && s === a))) {
                  if (c < r) for (; f(t, s, t.bl_tree), 0 != --c; );
                  else
                    0 !== s
                      ? (s !== n && (f(t, s, t.bl_tree), c--), f(t, 16, t.bl_tree), R(t, c - 3, 2))
                      : c <= 10
                      ? (f(t, 17, t.bl_tree), R(t, c - 3, 3))
                      : (f(t, 18, t.bl_tree), R(t, c - 11, 7))
                  ;(n = s),
                    (r = (c = 0) === a ? ((d = 138), 3) : s === a ? ((d = 6), 3) : ((d = 7), 4))
                }
            }
            s(V)
            var F = !1
            function M(t, e, i, s) {
              R(t, 0 + (s ? 1 : 0), 3),
                (function (t, e, i, s) {
                  J(t),
                    I(t, i),
                    I(t, ~i),
                    l.arraySet(t.pending_buf, t.window, e, i, t.pending),
                    (t.pending += i)
                })(t, e, i)
            }
            ;(i._tr_init = function (t) {
              F ||
                ((function () {
                  var t,
                    e,
                    i,
                    l,
                    s,
                    n = new Array(16)
                  for (l = i = 0; l < 28; l++) for (y[l] = i, t = 0; t < 1 << r[l]; t++) p[i++] = l
                  for (p[i - 1] = l, l = s = 0; l < 16; l++)
                    for (V[l] = s, t = 0; t < 1 << o[l]; t++) Z[s++] = l
                  for (s >>= 7; l < c; l++)
                    for (V[l] = s << 7, t = 0; t < 1 << (o[l] - 7); t++) Z[256 + s++] = l
                  for (e = 0; e <= d; e++) n[e] = 0
                  for (t = 0; t <= 143; ) (b[2 * t + 1] = 8), t++, n[8]++
                  for (; t <= 255; ) (b[2 * t + 1] = 9), t++, n[9]++
                  for (; t <= 279; ) (b[2 * t + 1] = 7), t++, n[7]++
                  for (; t <= 287; ) (b[2 * t + 1] = 8), t++, n[8]++
                  for (g(b, 287, n), t = 0; t < c; t++) (h[2 * t + 1] = 5), (h[2 * t] = x(t, 5))
                  ;(X = new Y(b, r, 257, a, d)),
                    (G = new Y(h, o, 0, c, d)),
                    (W = new Y(new Array(0), m, 0, 19, 7))
                })(),
                (F = !0)),
                (t.l_desc = new L(t.dyn_ltree, X)),
                (t.d_desc = new L(t.dyn_dtree, G)),
                (t.bl_desc = new L(t.bl_tree, W)),
                (t.bi_buf = 0),
                (t.bi_valid = 0),
                K(t)
            }),
              (i._tr_stored_block = M),
              (i._tr_flush_block = function (t, e, i, l) {
                var s,
                  a,
                  c = 0
                0 < t.level
                  ? (2 === t.strm.data_type &&
                      (t.strm.data_type = (function (t) {
                        var e,
                          i = 4093624447
                        for (e = 0; e <= 31; e++, i >>>= 1)
                          if (1 & i && 0 !== t.dyn_ltree[2 * e]) return 0
                        if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26])
                          return 1
                        for (e = 32; e < n; e++) if (0 !== t.dyn_ltree[2 * e]) return 1
                        return 0
                      })(t)),
                    H(t, t.l_desc),
                    H(t, t.d_desc),
                    (c = (function (t) {
                      var e
                      for (
                        w(t, t.dyn_ltree, t.l_desc.max_code),
                          w(t, t.dyn_dtree, t.d_desc.max_code),
                          H(t, t.bl_desc),
                          e = 18;
                        3 <= e && 0 === t.bl_tree[2 * u[e] + 1];
                        e--
                      );
                      return (t.opt_len += 3 * (e + 1) + 5 + 5 + 4), e
                    })(t)),
                    (s = (t.opt_len + 3 + 7) >>> 3),
                    (a = (t.static_len + 3 + 7) >>> 3) <= s && (s = a))
                  : (s = a = i + 5),
                  i + 4 <= s && -1 !== e
                    ? M(t, e, i, l)
                    : 4 === t.strategy || a === s
                    ? (R(t, 2 + (l ? 1 : 0), 3), v(t, b, h))
                    : (R(t, 4 + (l ? 1 : 0), 3),
                      (function (t, e, i, l) {
                        var s
                        for (R(t, e - 257, 5), R(t, i - 1, 5), R(t, l - 4, 4), s = 0; s < l; s++)
                          R(t, t.bl_tree[2 * u[s] + 1], 3)
                        T(t, t.dyn_ltree, e - 1), T(t, t.dyn_dtree, i - 1)
                      })(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, c + 1),
                      v(t, t.dyn_ltree, t.dyn_dtree)),
                  K(t),
                  l && J(t)
              }),
              (i._tr_tally = function (t, e, i) {
                return (
                  (t.pending_buf[t.d_buf + 2 * t.last_lit] = (e >>> 8) & 255),
                  (t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e),
                  (t.pending_buf[t.l_buf + t.last_lit] = 255 & i),
                  t.last_lit++,
                  0 === e
                    ? t.dyn_ltree[2 * i]++
                    : (t.matches++,
                      e--,
                      t.dyn_ltree[2 * (p[i] + n + 1)]++,
                      t.dyn_dtree[2 * S(e)]++),
                  t.last_lit === t.lit_bufsize - 1
                )
              }),
              (i._tr_align = function (t) {
                R(t, 2, 3),
                  f(t, 256, b),
                  (function (t) {
                    16 === t.bi_valid
                      ? (I(t, t.bi_buf), (t.bi_buf = 0), (t.bi_valid = 0))
                      : 8 <= t.bi_valid &&
                        ((t.pending_buf[t.pending++] = 255 & t.bi_buf),
                        (t.bi_buf >>= 8),
                        (t.bi_valid -= 8))
                  })(t)
              })
          },
          { '../utils/common': 41 }
        ],
        53: [
          function (t, e, i) {
            e.exports = function () {
              ;(this.input = null),
                (this.next_in = 0),
                (this.avail_in = 0),
                (this.total_in = 0),
                (this.output = null),
                (this.next_out = 0),
                (this.avail_out = 0),
                (this.total_out = 0),
                (this.msg = ''),
                (this.state = null),
                (this.data_type = 2),
                (this.adler = 0)
            }
          },
          {}
        ],
        54: [
          function (t, e, i) {
            e.exports =
              'function' == typeof setImmediate
                ? setImmediate
                : function () {
                    var t = [].slice.apply(arguments)
                    t.splice(1, 0, 0), setTimeout.apply(null, t)
                  }
          },
          {}
        ]
      },
      {},
      [10]
    )(10)
  })
const sl =
    '[object process]' ===
    Object.prototype.toString.call('undefined' != typeof process ? process : 0),
  nl = sl && 'function' == typeof module.require ? module.require : null
const al = (function (t, e = null, i = !1) {
  const l = sl
      ? (function (t, e) {
          return Buffer.from(t, 'base64').toString(e ? 'utf16' : 'utf8')
        })(t, i)
      : (function (t, e) {
          const i = atob(t)
          if (e) {
            const t = new Uint8Array(i.length)
            return (
              Array.prototype.forEach.call(t, (t, e, l) => {
                l[e] = i.charCodeAt(e)
              }),
              String.fromCharCode.apply(null, new Uint16Array(t.buffer))
            )
          }
          return i
        })(t, i),
    s = l.indexOf('\n', 10) + 1,
    n = l.substring(s) + (e ? `//# sourceMappingURL=${e}` : '')
  if (nl) {
    const t = nl('worker_threads').Worker
    return function (e) {
      return new t(n, Object.assign({}, e, { eval: !0 }))
    }
  }
  const a = new Blob([n], { type: 'application/javascript' }),
    c = URL.createObjectURL(a)
  return function (t) {
    return new Worker(c, t)
  }
})(
  'Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwp2YXIgY29tbW9uanNHbG9iYWwgPSB0eXBlb2YgZ2xvYmFsVGhpcyAhPT0gJ3VuZGVmaW5lZCcgPyBnbG9iYWxUaGlzIDogdHlwZW9mIHdpbmRvdyAhPT0gJ3VuZGVmaW5lZCcgPyB3aW5kb3cgOiB0eXBlb2YgZ2xvYmFsICE9PSAndW5kZWZpbmVkJyA/IGdsb2JhbCA6IHR5cGVvZiBzZWxmICE9PSAndW5kZWZpbmVkJyA/IHNlbGYgOiB7fTsKCnZhciBlPWZ1bmN0aW9uKHQscil7cmV0dXJuIChlPU9iamVjdC5zZXRQcm90b3R5cGVPZnx8e19fcHJvdG9fXzpbXX1pbnN0YW5jZW9mIEFycmF5JiZmdW5jdGlvbihlLHQpe2UuX19wcm90b19fPXQ7fXx8ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHIgaW4gdCl0Lmhhc093blByb3BlcnR5KHIpJiYoZVtyXT10W3JdKTt9KSh0LHIpfTtmdW5jdGlvbiB0KHQscil7ZnVuY3Rpb24gbigpe3RoaXMuY29uc3RydWN0b3I9dDt9ZSh0LHIpLHQucHJvdG90eXBlPW51bGw9PT1yP09iamVjdC5jcmVhdGUocik6KG4ucHJvdG90eXBlPXIucHJvdG90eXBlLG5ldyBuKTt9dmFyIHI9ZnVuY3Rpb24oKXtyZXR1cm4gKHI9T2JqZWN0LmFzc2lnbnx8ZnVuY3Rpb24oZSl7Zm9yKHZhciB0LHI9MSxuPWFyZ3VtZW50cy5sZW5ndGg7cjxuO3IrKylmb3IodmFyIGEgaW4gdD1hcmd1bWVudHNbcl0pT2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eS5jYWxsKHQsYSkmJihlW2FdPXRbYV0pO3JldHVybiBlfSkuYXBwbHkodGhpcyxhcmd1bWVudHMpfTtmdW5jdGlvbiBuKGUsdCxyLG4pe3JldHVybiBuZXcocnx8KHI9UHJvbWlzZSkpKChmdW5jdGlvbihhLGkpe2Z1bmN0aW9uIHMoZSl7dHJ5e3Uobi5uZXh0KGUpKTt9Y2F0Y2goZSl7aShlKTt9fWZ1bmN0aW9uIG8oZSl7dHJ5e3Uobi50aHJvdyhlKSk7fWNhdGNoKGUpe2koZSk7fX1mdW5jdGlvbiB1KGUpe2UuZG9uZT9hKGUudmFsdWUpOm5ldyByKChmdW5jdGlvbih0KXt0KGUudmFsdWUpO30pKS50aGVuKHMsbyk7fXUoKG49bi5hcHBseShlLHR8fFtdKSkubmV4dCgpKTt9KSl9ZnVuY3Rpb24gYShlLHQpe3ZhciByLG4sYSxpLHM9e2xhYmVsOjAsc2VudDpmdW5jdGlvbigpe2lmKDEmYVswXSl0aHJvdyBhWzFdO3JldHVybiBhWzFdfSx0cnlzOltdLG9wczpbXX07cmV0dXJuIGk9e25leHQ6bygwKSx0aHJvdzpvKDEpLHJldHVybjpvKDIpfSwiZnVuY3Rpb24iPT10eXBlb2YgU3ltYm9sJiYoaVtTeW1ib2wuaXRlcmF0b3JdPWZ1bmN0aW9uKCl7cmV0dXJuIHRoaXN9KSxpO2Z1bmN0aW9uIG8oaSl7cmV0dXJuIGZ1bmN0aW9uKG8pe3JldHVybiBmdW5jdGlvbihpKXtpZihyKXRocm93IG5ldyBUeXBlRXJyb3IoIkdlbmVyYXRvciBpcyBhbHJlYWR5IGV4ZWN1dGluZy4iKTtmb3IoO3M7KXRyeXtpZihyPTEsbiYmKGE9MiZpWzBdP24ucmV0dXJuOmlbMF0/bi50aHJvd3x8KChhPW4ucmV0dXJuKSYmYS5jYWxsKG4pLDApOm4ubmV4dCkmJiEoYT1hLmNhbGwobixpWzFdKSkuZG9uZSlyZXR1cm4gYTtzd2l0Y2gobj0wLGEmJihpPVsyJmlbMF0sYS52YWx1ZV0pLGlbMF0pe2Nhc2UgMDpjYXNlIDE6YT1pO2JyZWFrO2Nhc2UgNDpyZXR1cm4gcy5sYWJlbCsrLHt2YWx1ZTppWzFdLGRvbmU6ITF9O2Nhc2UgNTpzLmxhYmVsKyssbj1pWzFdLGk9WzBdO2NvbnRpbnVlO2Nhc2UgNzppPXMub3BzLnBvcCgpLHMudHJ5cy5wb3AoKTtjb250aW51ZTtkZWZhdWx0OmlmKCEoYT0oYT1zLnRyeXMpLmxlbmd0aD4wJiZhW2EubGVuZ3RoLTFdKSYmKDY9PT1pWzBdfHwyPT09aVswXSkpe3M9MDtjb250aW51ZX1pZigzPT09aVswXSYmKCFhfHxpWzFdPmFbMF0mJmlbMV08YVszXSkpe3MubGFiZWw9aVsxXTticmVha31pZig2PT09aVswXSYmcy5sYWJlbDxhWzFdKXtzLmxhYmVsPWFbMV0sYT1pO2JyZWFrfWlmKGEmJnMubGFiZWw8YVsyXSl7cy5sYWJlbD1hWzJdLHMub3BzLnB1c2goaSk7YnJlYWt9YVsyXSYmcy5vcHMucG9wKCkscy50cnlzLnBvcCgpO2NvbnRpbnVlfWk9dC5jYWxsKGUscyk7fWNhdGNoKGUpe2k9WzYsZV0sbj0wO31maW5hbGx5e3I9YT0wO31pZig1JmlbMF0pdGhyb3cgaVsxXTtyZXR1cm4ge3ZhbHVlOmlbMF0/aVsxXTp2b2lkIDAsZG9uZTohMH19KFtpLG9dKX19fXZhciBpPSJ1bmRlZmluZWQiIT10eXBlb2YgZ2xvYmFsVGhpcz9nbG9iYWxUaGlzOiJ1bmRlZmluZWQiIT10eXBlb2Ygd2luZG93P3dpbmRvdzoidW5kZWZpbmVkIiE9dHlwZW9mIGNvbW1vbmpzR2xvYmFsP2NvbW1vbmpzR2xvYmFsOiJ1bmRlZmluZWQiIT10eXBlb2Ygc2VsZj9zZWxmOnt9O2Z1bmN0aW9uIHMoKXt0aHJvdyBuZXcgRXJyb3IoIkR5bmFtaWMgcmVxdWlyZXMgYXJlIG5vdCBjdXJyZW50bHkgc3VwcG9ydGVkIGJ5IEByb2xsdXAvcGx1Z2luLWNvbW1vbmpzIil9ZnVuY3Rpb24gbyhlLHQpe3JldHVybiBlKHQ9e2V4cG9ydHM6e319LHQuZXhwb3J0cyksdC5leHBvcnRzfXZhciB1PW8oKGZ1bmN0aW9uKGUsdCl7ZS5leHBvcnRzPWZ1bmN0aW9uIGUodCxyLG4pe2Z1bmN0aW9uIGEobyx1KXtpZighcltvXSl7aWYoIXRbb10pe2lmKCF1JiZzKXJldHVybiBzKCk7aWYoaSlyZXR1cm4gaShvLCEwKTt2YXIgbD1uZXcgRXJyb3IoIkNhbm5vdCBmaW5kIG1vZHVsZSAnIitvKyInIik7dGhyb3cgbC5jb2RlPSJNT0RVTEVfTk9UX0ZPVU5EIixsfXZhciBjPXJbb109e2V4cG9ydHM6e319O3Rbb11bMF0uY2FsbChjLmV4cG9ydHMsKGZ1bmN0aW9uKGUpe3JldHVybiBhKHRbb11bMV1bZV18fGUpfSksYyxjLmV4cG9ydHMsZSx0LHIsbik7fXJldHVybiByW29dLmV4cG9ydHN9Zm9yKHZhciBpPXMsbz0wO288bi5sZW5ndGg7bysrKWEobltvXSk7cmV0dXJuIGF9KHsxOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi91dGlscyIpLGE9ZSgiLi9zdXBwb3J0IiksaT0iQUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5ejAxMjM0NTY3ODkrLz0iO3IuZW5jb2RlPWZ1bmN0aW9uKGUpe2Zvcih2YXIgdCxyLGEscyxvLHUsbCxjPVtdLGg9MCxkPWUubGVuZ3RoLGY9ZCxwPSJzdHJpbmciIT09bi5nZXRUeXBlT2YoZSk7aDxlLmxlbmd0aDspZj1kLWgsYT1wPyh0PWVbaCsrXSxyPWg8ZD9lW2grK106MCxoPGQ/ZVtoKytdOjApOih0PWUuY2hhckNvZGVBdChoKyspLHI9aDxkP2UuY2hhckNvZGVBdChoKyspOjAsaDxkP2UuY2hhckNvZGVBdChoKyspOjApLHM9dD4+MixvPSgzJnQpPDw0fHI+PjQsdT0xPGY/KDE1JnIpPDwyfGE+PjY6NjQsbD0yPGY/NjMmYTo2NCxjLnB1c2goaS5jaGFyQXQocykraS5jaGFyQXQobykraS5jaGFyQXQodSkraS5jaGFyQXQobCkpO3JldHVybiBjLmpvaW4oIiIpfSxyLmRlY29kZT1mdW5jdGlvbihlKXt2YXIgdCxyLG4scyxvLHUsbD0wLGM9MCxoPSJkYXRhOiI7aWYoZS5zdWJzdHIoMCxoLmxlbmd0aCk9PT1oKXRocm93IG5ldyBFcnJvcigiSW52YWxpZCBiYXNlNjQgaW5wdXQsIGl0IGxvb2tzIGxpa2UgYSBkYXRhIHVybC4iKTt2YXIgZCxmPTMqKGU9ZS5yZXBsYWNlKC9bXkEtWmEtejAtOVwrXC9cPV0vZywiIikpLmxlbmd0aC80O2lmKGUuY2hhckF0KGUubGVuZ3RoLTEpPT09aS5jaGFyQXQoNjQpJiZmLS0sZS5jaGFyQXQoZS5sZW5ndGgtMik9PT1pLmNoYXJBdCg2NCkmJmYtLSxmJTEhPTApdGhyb3cgbmV3IEVycm9yKCJJbnZhbGlkIGJhc2U2NCBpbnB1dCwgYmFkIGNvbnRlbnQgbGVuZ3RoLiIpO2ZvcihkPWEudWludDhhcnJheT9uZXcgVWludDhBcnJheSgwfGYpOm5ldyBBcnJheSgwfGYpO2w8ZS5sZW5ndGg7KXQ9aS5pbmRleE9mKGUuY2hhckF0KGwrKykpPDwyfChzPWkuaW5kZXhPZihlLmNoYXJBdChsKyspKSk+PjQscj0oMTUmcyk8PDR8KG89aS5pbmRleE9mKGUuY2hhckF0KGwrKykpKT4+MixuPSgzJm8pPDw2fCh1PWkuaW5kZXhPZihlLmNoYXJBdChsKyspKSksZFtjKytdPXQsNjQhPT1vJiYoZFtjKytdPXIpLDY0IT09dSYmKGRbYysrXT1uKTtyZXR1cm4gZH07fSx7Ii4vc3VwcG9ydCI6MzAsIi4vdXRpbHMiOjMyfV0sMjpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoIi4vZXh0ZXJuYWwiKSxhPWUoIi4vc3RyZWFtL0RhdGFXb3JrZXIiKSxpPWUoIi4vc3RyZWFtL0RhdGFMZW5ndGhQcm9iZSIpLHM9ZSgiLi9zdHJlYW0vQ3JjMzJQcm9iZSIpO2Z1bmN0aW9uIG8oZSx0LHIsbixhKXt0aGlzLmNvbXByZXNzZWRTaXplPWUsdGhpcy51bmNvbXByZXNzZWRTaXplPXQsdGhpcy5jcmMzMj1yLHRoaXMuY29tcHJlc3Npb249bix0aGlzLmNvbXByZXNzZWRDb250ZW50PWE7fWk9ZSgiLi9zdHJlYW0vRGF0YUxlbmd0aFByb2JlIiksby5wcm90b3R5cGU9e2dldENvbnRlbnRXb3JrZXI6ZnVuY3Rpb24oKXt2YXIgZT1uZXcgYShuLlByb21pc2UucmVzb2x2ZSh0aGlzLmNvbXByZXNzZWRDb250ZW50KSkucGlwZSh0aGlzLmNvbXByZXNzaW9uLnVuY29tcHJlc3NXb3JrZXIoKSkucGlwZShuZXcgaSgiZGF0YV9sZW5ndGgiKSksdD10aGlzO3JldHVybiBlLm9uKCJlbmQiLChmdW5jdGlvbigpe2lmKHRoaXMuc3RyZWFtSW5mby5kYXRhX2xlbmd0aCE9PXQudW5jb21wcmVzc2VkU2l6ZSl0aHJvdyBuZXcgRXJyb3IoIkJ1ZyA6IHVuY29tcHJlc3NlZCBkYXRhIHNpemUgbWlzbWF0Y2giKX0pKSxlfSxnZXRDb21wcmVzc2VkV29ya2VyOmZ1bmN0aW9uKCl7cmV0dXJuIG5ldyBhKG4uUHJvbWlzZS5yZXNvbHZlKHRoaXMuY29tcHJlc3NlZENvbnRlbnQpKS53aXRoU3RyZWFtSW5mbygiY29tcHJlc3NlZFNpemUiLHRoaXMuY29tcHJlc3NlZFNpemUpLndpdGhTdHJlYW1JbmZvKCJ1bmNvbXByZXNzZWRTaXplIix0aGlzLnVuY29tcHJlc3NlZFNpemUpLndpdGhTdHJlYW1JbmZvKCJjcmMzMiIsdGhpcy5jcmMzMikud2l0aFN0cmVhbUluZm8oImNvbXByZXNzaW9uIix0aGlzLmNvbXByZXNzaW9uKX19LG8uY3JlYXRlV29ya2VyRnJvbT1mdW5jdGlvbihlLHQscil7cmV0dXJuIGUucGlwZShuZXcgcykucGlwZShuZXcgaSgidW5jb21wcmVzc2VkU2l6ZSIpKS5waXBlKHQuY29tcHJlc3NXb3JrZXIocikpLnBpcGUobmV3IGkoImNvbXByZXNzZWRTaXplIikpLndpdGhTdHJlYW1JbmZvKCJjb21wcmVzc2lvbiIsdCl9LHQuZXhwb3J0cz1vO30seyIuL2V4dGVybmFsIjo2LCIuL3N0cmVhbS9DcmMzMlByb2JlIjoyNSwiLi9zdHJlYW0vRGF0YUxlbmd0aFByb2JlIjoyNiwiLi9zdHJlYW0vRGF0YVdvcmtlciI6Mjd9XSwzOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi9zdHJlYW0vR2VuZXJpY1dvcmtlciIpO3IuU1RPUkU9e21hZ2ljOiJcMFwwIixjb21wcmVzc1dvcmtlcjpmdW5jdGlvbihlKXtyZXR1cm4gbmV3IG4oIlNUT1JFIGNvbXByZXNzaW9uIil9LHVuY29tcHJlc3NXb3JrZXI6ZnVuY3Rpb24oKXtyZXR1cm4gbmV3IG4oIlNUT1JFIGRlY29tcHJlc3Npb24iKX19LHIuREVGTEFURT1lKCIuL2ZsYXRlIik7fSx7Ii4vZmxhdGUiOjcsIi4vc3RyZWFtL0dlbmVyaWNXb3JrZXIiOjI4fV0sNDpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoIi4vdXRpbHMiKSxhPWZ1bmN0aW9uKCl7Zm9yKHZhciBlLHQ9W10scj0wO3I8MjU2O3IrKyl7ZT1yO2Zvcih2YXIgbj0wO248ODtuKyspZT0xJmU/Mzk4ODI5MjM4NF5lPj4+MTplPj4+MTt0W3JdPWU7fXJldHVybiB0fSgpO3QuZXhwb3J0cz1mdW5jdGlvbihlLHQpe3JldHVybiB2b2lkIDAhPT1lJiZlLmxlbmd0aD8ic3RyaW5nIiE9PW4uZ2V0VHlwZU9mKGUpP2Z1bmN0aW9uKGUsdCxyLG4pe3ZhciBpPWEscz0wK3I7ZV49LTE7Zm9yKHZhciBvPTA7bzxzO28rKyllPWU+Pj44XmlbMjU1JihlXnRbb10pXTtyZXR1cm4gLTFeZX0oMHx0LGUsZS5sZW5ndGgpOmZ1bmN0aW9uKGUsdCxyLG4pe3ZhciBpPWEscz0wK3I7ZV49LTE7Zm9yKHZhciBvPTA7bzxzO28rKyllPWU+Pj44XmlbMjU1JihlXnQuY2hhckNvZGVBdChvKSldO3JldHVybiAtMV5lfSgwfHQsZSxlLmxlbmd0aCk6MH07fSx7Ii4vdXRpbHMiOjMyfV0sNTpbZnVuY3Rpb24oZSx0LHIpe3IuYmFzZTY0PSExLHIuYmluYXJ5PSExLHIuZGlyPSExLHIuY3JlYXRlRm9sZGVycz0hMCxyLmRhdGU9bnVsbCxyLmNvbXByZXNzaW9uPW51bGwsci5jb21wcmVzc2lvbk9wdGlvbnM9bnVsbCxyLmNvbW1lbnQ9bnVsbCxyLnVuaXhQZXJtaXNzaW9ucz1udWxsLHIuZG9zUGVybWlzc2lvbnM9bnVsbDt9LHt9XSw2OltmdW5jdGlvbihlLHQscil7dmFyIG47bj0idW5kZWZpbmVkIiE9dHlwZW9mIFByb21pc2U/UHJvbWlzZTplKCJsaWUiKSx0LmV4cG9ydHM9e1Byb21pc2U6bn07fSx7bGllOjM3fV0sNzpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPSJ1bmRlZmluZWQiIT10eXBlb2YgVWludDhBcnJheSYmInVuZGVmaW5lZCIhPXR5cGVvZiBVaW50MTZBcnJheSYmInVuZGVmaW5lZCIhPXR5cGVvZiBVaW50MzJBcnJheSxhPWUoInBha28iKSxpPWUoIi4vdXRpbHMiKSxzPWUoIi4vc3RyZWFtL0dlbmVyaWNXb3JrZXIiKSxvPW4/InVpbnQ4YXJyYXkiOiJhcnJheSI7ZnVuY3Rpb24gdShlLHQpe3MuY2FsbCh0aGlzLCJGbGF0ZVdvcmtlci8iK2UpLHRoaXMuX3Bha289bnVsbCx0aGlzLl9wYWtvQWN0aW9uPWUsdGhpcy5fcGFrb09wdGlvbnM9dCx0aGlzLm1ldGE9e307fXIubWFnaWM9IlxiXDAiLGkuaW5oZXJpdHModSxzKSx1LnByb3RvdHlwZS5wcm9jZXNzQ2h1bms9ZnVuY3Rpb24oZSl7dGhpcy5tZXRhPWUubWV0YSxudWxsPT09dGhpcy5fcGFrbyYmdGhpcy5fY3JlYXRlUGFrbygpLHRoaXMuX3Bha28ucHVzaChpLnRyYW5zZm9ybVRvKG8sZS5kYXRhKSwhMSk7fSx1LnByb3RvdHlwZS5mbHVzaD1mdW5jdGlvbigpe3MucHJvdG90eXBlLmZsdXNoLmNhbGwodGhpcyksbnVsbD09PXRoaXMuX3Bha28mJnRoaXMuX2NyZWF0ZVBha28oKSx0aGlzLl9wYWtvLnB1c2goW10sITApO30sdS5wcm90b3R5cGUuY2xlYW5VcD1mdW5jdGlvbigpe3MucHJvdG90eXBlLmNsZWFuVXAuY2FsbCh0aGlzKSx0aGlzLl9wYWtvPW51bGw7fSx1LnByb3RvdHlwZS5fY3JlYXRlUGFrbz1mdW5jdGlvbigpe3RoaXMuX3Bha289bmV3IGFbdGhpcy5fcGFrb0FjdGlvbl0oe3JhdzohMCxsZXZlbDp0aGlzLl9wYWtvT3B0aW9ucy5sZXZlbHx8LTF9KTt2YXIgZT10aGlzO3RoaXMuX3Bha28ub25EYXRhPWZ1bmN0aW9uKHQpe2UucHVzaCh7ZGF0YTp0LG1ldGE6ZS5tZXRhfSk7fTt9LHIuY29tcHJlc3NXb3JrZXI9ZnVuY3Rpb24oZSl7cmV0dXJuIG5ldyB1KCJEZWZsYXRlIixlKX0sci51bmNvbXByZXNzV29ya2VyPWZ1bmN0aW9uKCl7cmV0dXJuIG5ldyB1KCJJbmZsYXRlIix7fSl9O30seyIuL3N0cmVhbS9HZW5lcmljV29ya2VyIjoyOCwiLi91dGlscyI6MzIscGFrbzozOH1dLDg6W2Z1bmN0aW9uKGUsdCxyKXtmdW5jdGlvbiBuKGUsdCl7dmFyIHIsbj0iIjtmb3Iocj0wO3I8dDtyKyspbis9U3RyaW5nLmZyb21DaGFyQ29kZSgyNTUmZSksZT4+Pj04O3JldHVybiBufWZ1bmN0aW9uIGEoZSx0LHIsYSxzLGMpe3ZhciBoLGQsZj1lLmZpbGUscD1lLmNvbXByZXNzaW9uLG09YyE9PW8udXRmOGVuY29kZSxnPWkudHJhbnNmb3JtVG8oInN0cmluZyIsYyhmLm5hbWUpKSxfPWkudHJhbnNmb3JtVG8oInN0cmluZyIsby51dGY4ZW5jb2RlKGYubmFtZSkpLHk9Zi5jb21tZW50LHY9aS50cmFuc2Zvcm1Ubygic3RyaW5nIixjKHkpKSxiPWkudHJhbnNmb3JtVG8oInN0cmluZyIsby51dGY4ZW5jb2RlKHkpKSx3PV8ubGVuZ3RoIT09Zi5uYW1lLmxlbmd0aCxrPWIubGVuZ3RoIT09eS5sZW5ndGgsTj0iIixTPSIiLHg9IiIsQz1mLmRpcixQPWYuZGF0ZSxFPXtjcmMzMjowLGNvbXByZXNzZWRTaXplOjAsdW5jb21wcmVzc2VkU2l6ZTowfTt0JiYhcnx8KEUuY3JjMzI9ZS5jcmMzMixFLmNvbXByZXNzZWRTaXplPWUuY29tcHJlc3NlZFNpemUsRS51bmNvbXByZXNzZWRTaXplPWUudW5jb21wcmVzc2VkU2l6ZSk7dmFyIE89MDt0JiYoT3w9OCksbXx8IXcmJiFrfHwoT3w9MjA0OCk7dmFyIEE9MCxNPTA7QyYmKEF8PTE2KSwiVU5JWCI9PT1zPyhNPTc5OCxBfD1mdW5jdGlvbihlLHQpe3ZhciByPWU7cmV0dXJuIGV8fChyPXQ/MTY4OTM6MzMyMDQpLCg2NTUzNSZyKTw8MTZ9KGYudW5peFBlcm1pc3Npb25zLEMpKTooTT0yMCxBfD1mdW5jdGlvbihlKXtyZXR1cm4gNjMmKGV8fDApfShmLmRvc1Blcm1pc3Npb25zKSksaD1QLmdldFVUQ0hvdXJzKCksaDw8PTYsaHw9UC5nZXRVVENNaW51dGVzKCksaDw8PTUsaHw9UC5nZXRVVENTZWNvbmRzKCkvMixkPVAuZ2V0VVRDRnVsbFllYXIoKS0xOTgwLGQ8PD00LGR8PVAuZ2V0VVRDTW9udGgoKSsxLGQ8PD01LGR8PVAuZ2V0VVRDRGF0ZSgpLHcmJihTPW4oMSwxKStuKHUoZyksNCkrXyxOKz0idXAiK24oUy5sZW5ndGgsMikrUyksayYmKHg9bigxLDEpK24odSh2KSw0KStiLE4rPSJ1YyIrbih4Lmxlbmd0aCwyKSt4KTt2YXIgTD0iIjtyZXR1cm4gTCs9IlxuXDAiLEwrPW4oTywyKSxMKz1wLm1hZ2ljLEwrPW4oaCwyKSxMKz1uKGQsMiksTCs9bihFLmNyYzMyLDQpLEwrPW4oRS5jb21wcmVzc2VkU2l6ZSw0KSxMKz1uKEUudW5jb21wcmVzc2VkU2l6ZSw0KSxMKz1uKGcubGVuZ3RoLDIpLEwrPW4oTi5sZW5ndGgsMikse2ZpbGVSZWNvcmQ6bC5MT0NBTF9GSUxFX0hFQURFUitMK2crTixkaXJSZWNvcmQ6bC5DRU5UUkFMX0ZJTEVfSEVBREVSK24oTSwyKStMK24odi5sZW5ndGgsMikrIlwwXDBcMFwwIituKEEsNCkrbihhLDQpK2crTit2fX12YXIgaT1lKCIuLi91dGlscyIpLHM9ZSgiLi4vc3RyZWFtL0dlbmVyaWNXb3JrZXIiKSxvPWUoIi4uL3V0ZjgiKSx1PWUoIi4uL2NyYzMyIiksbD1lKCIuLi9zaWduYXR1cmUiKTtmdW5jdGlvbiBjKGUsdCxyLG4pe3MuY2FsbCh0aGlzLCJaaXBGaWxlV29ya2VyIiksdGhpcy5ieXRlc1dyaXR0ZW49MCx0aGlzLnppcENvbW1lbnQ9dCx0aGlzLnppcFBsYXRmb3JtPXIsdGhpcy5lbmNvZGVGaWxlTmFtZT1uLHRoaXMuc3RyZWFtRmlsZXM9ZSx0aGlzLmFjY3VtdWxhdGU9ITEsdGhpcy5jb250ZW50QnVmZmVyPVtdLHRoaXMuZGlyUmVjb3Jkcz1bXSx0aGlzLmN1cnJlbnRTb3VyY2VPZmZzZXQ9MCx0aGlzLmVudHJpZXNDb3VudD0wLHRoaXMuY3VycmVudEZpbGU9bnVsbCx0aGlzLl9zb3VyY2VzPVtdO31pLmluaGVyaXRzKGMscyksYy5wcm90b3R5cGUucHVzaD1mdW5jdGlvbihlKXt2YXIgdD1lLm1ldGEucGVyY2VudHx8MCxyPXRoaXMuZW50cmllc0NvdW50LG49dGhpcy5fc291cmNlcy5sZW5ndGg7dGhpcy5hY2N1bXVsYXRlP3RoaXMuY29udGVudEJ1ZmZlci5wdXNoKGUpOih0aGlzLmJ5dGVzV3JpdHRlbis9ZS5kYXRhLmxlbmd0aCxzLnByb3RvdHlwZS5wdXNoLmNhbGwodGhpcyx7ZGF0YTplLmRhdGEsbWV0YTp7Y3VycmVudEZpbGU6dGhpcy5jdXJyZW50RmlsZSxwZXJjZW50OnI/KHQrMTAwKihyLW4tMSkpL3I6MTAwfX0pKTt9LGMucHJvdG90eXBlLm9wZW5lZFNvdXJjZT1mdW5jdGlvbihlKXt0aGlzLmN1cnJlbnRTb3VyY2VPZmZzZXQ9dGhpcy5ieXRlc1dyaXR0ZW4sdGhpcy5jdXJyZW50RmlsZT1lLmZpbGUubmFtZTt2YXIgdD10aGlzLnN0cmVhbUZpbGVzJiYhZS5maWxlLmRpcjtpZih0KXt2YXIgcj1hKGUsdCwhMSx0aGlzLmN1cnJlbnRTb3VyY2VPZmZzZXQsdGhpcy56aXBQbGF0Zm9ybSx0aGlzLmVuY29kZUZpbGVOYW1lKTt0aGlzLnB1c2goe2RhdGE6ci5maWxlUmVjb3JkLG1ldGE6e3BlcmNlbnQ6MH19KTt9ZWxzZSB0aGlzLmFjY3VtdWxhdGU9ITA7fSxjLnByb3RvdHlwZS5jbG9zZWRTb3VyY2U9ZnVuY3Rpb24oZSl7dGhpcy5hY2N1bXVsYXRlPSExO3ZhciB0PXRoaXMuc3RyZWFtRmlsZXMmJiFlLmZpbGUuZGlyLHI9YShlLHQsITAsdGhpcy5jdXJyZW50U291cmNlT2Zmc2V0LHRoaXMuemlwUGxhdGZvcm0sdGhpcy5lbmNvZGVGaWxlTmFtZSk7aWYodGhpcy5kaXJSZWNvcmRzLnB1c2goci5kaXJSZWNvcmQpLHQpdGhpcy5wdXNoKHtkYXRhOmZ1bmN0aW9uKGUpe3JldHVybiBsLkRBVEFfREVTQ1JJUFRPUituKGUuY3JjMzIsNCkrbihlLmNvbXByZXNzZWRTaXplLDQpK24oZS51bmNvbXByZXNzZWRTaXplLDQpfShlKSxtZXRhOntwZXJjZW50OjEwMH19KTtlbHNlIGZvcih0aGlzLnB1c2goe2RhdGE6ci5maWxlUmVjb3JkLG1ldGE6e3BlcmNlbnQ6MH19KTt0aGlzLmNvbnRlbnRCdWZmZXIubGVuZ3RoOyl0aGlzLnB1c2godGhpcy5jb250ZW50QnVmZmVyLnNoaWZ0KCkpO3RoaXMuY3VycmVudEZpbGU9bnVsbDt9LGMucHJvdG90eXBlLmZsdXNoPWZ1bmN0aW9uKCl7Zm9yKHZhciBlPXRoaXMuYnl0ZXNXcml0dGVuLHQ9MDt0PHRoaXMuZGlyUmVjb3Jkcy5sZW5ndGg7dCsrKXRoaXMucHVzaCh7ZGF0YTp0aGlzLmRpclJlY29yZHNbdF0sbWV0YTp7cGVyY2VudDoxMDB9fSk7dmFyIHI9dGhpcy5ieXRlc1dyaXR0ZW4tZSxhPWZ1bmN0aW9uKGUsdCxyLGEscyl7dmFyIG89aS50cmFuc2Zvcm1Ubygic3RyaW5nIixzKGEpKTtyZXR1cm4gbC5DRU5UUkFMX0RJUkVDVE9SWV9FTkQrIlwwXDBcMFwwIituKGUsMikrbihlLDIpK24odCw0KStuKHIsNCkrbihvLmxlbmd0aCwyKStvfSh0aGlzLmRpclJlY29yZHMubGVuZ3RoLHIsZSx0aGlzLnppcENvbW1lbnQsdGhpcy5lbmNvZGVGaWxlTmFtZSk7dGhpcy5wdXNoKHtkYXRhOmEsbWV0YTp7cGVyY2VudDoxMDB9fSk7fSxjLnByb3RvdHlwZS5wcmVwYXJlTmV4dFNvdXJjZT1mdW5jdGlvbigpe3RoaXMucHJldmlvdXM9dGhpcy5fc291cmNlcy5zaGlmdCgpLHRoaXMub3BlbmVkU291cmNlKHRoaXMucHJldmlvdXMuc3RyZWFtSW5mbyksdGhpcy5pc1BhdXNlZD90aGlzLnByZXZpb3VzLnBhdXNlKCk6dGhpcy5wcmV2aW91cy5yZXN1bWUoKTt9LGMucHJvdG90eXBlLnJlZ2lzdGVyUHJldmlvdXM9ZnVuY3Rpb24oZSl7dGhpcy5fc291cmNlcy5wdXNoKGUpO3ZhciB0PXRoaXM7cmV0dXJuIGUub24oImRhdGEiLChmdW5jdGlvbihlKXt0LnByb2Nlc3NDaHVuayhlKTt9KSksZS5vbigiZW5kIiwoZnVuY3Rpb24oKXt0LmNsb3NlZFNvdXJjZSh0LnByZXZpb3VzLnN0cmVhbUluZm8pLHQuX3NvdXJjZXMubGVuZ3RoP3QucHJlcGFyZU5leHRTb3VyY2UoKTp0LmVuZCgpO30pKSxlLm9uKCJlcnJvciIsKGZ1bmN0aW9uKGUpe3QuZXJyb3IoZSk7fSkpLHRoaXN9LGMucHJvdG90eXBlLnJlc3VtZT1mdW5jdGlvbigpe3JldHVybiAhIXMucHJvdG90eXBlLnJlc3VtZS5jYWxsKHRoaXMpJiYoIXRoaXMucHJldmlvdXMmJnRoaXMuX3NvdXJjZXMubGVuZ3RoPyh0aGlzLnByZXBhcmVOZXh0U291cmNlKCksITApOnRoaXMucHJldmlvdXN8fHRoaXMuX3NvdXJjZXMubGVuZ3RofHx0aGlzLmdlbmVyYXRlZEVycm9yP3ZvaWQgMDoodGhpcy5lbmQoKSwhMCkpfSxjLnByb3RvdHlwZS5lcnJvcj1mdW5jdGlvbihlKXt2YXIgdD10aGlzLl9zb3VyY2VzO2lmKCFzLnByb3RvdHlwZS5lcnJvci5jYWxsKHRoaXMsZSkpcmV0dXJuICExO2Zvcih2YXIgcj0wO3I8dC5sZW5ndGg7cisrKXRyeXt0W3JdLmVycm9yKGUpO31jYXRjaChlKXt9cmV0dXJuICEwfSxjLnByb3RvdHlwZS5sb2NrPWZ1bmN0aW9uKCl7cy5wcm90b3R5cGUubG9jay5jYWxsKHRoaXMpO2Zvcih2YXIgZT10aGlzLl9zb3VyY2VzLHQ9MDt0PGUubGVuZ3RoO3QrKyllW3RdLmxvY2soKTt9LHQuZXhwb3J0cz1jO30seyIuLi9jcmMzMiI6NCwiLi4vc2lnbmF0dXJlIjoyMywiLi4vc3RyZWFtL0dlbmVyaWNXb3JrZXIiOjI4LCIuLi91dGY4IjozMSwiLi4vdXRpbHMiOjMyfV0sOTpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoIi4uL2NvbXByZXNzaW9ucyIpLGE9ZSgiLi9aaXBGaWxlV29ya2VyIik7ci5nZW5lcmF0ZVdvcmtlcj1mdW5jdGlvbihlLHQscil7dmFyIGk9bmV3IGEodC5zdHJlYW1GaWxlcyxyLHQucGxhdGZvcm0sdC5lbmNvZGVGaWxlTmFtZSkscz0wO3RyeXtlLmZvckVhY2goKGZ1bmN0aW9uKGUscil7cysrO3ZhciBhPWZ1bmN0aW9uKGUsdCl7dmFyIHI9ZXx8dCxhPW5bcl07aWYoIWEpdGhyb3cgbmV3IEVycm9yKHIrIiBpcyBub3QgYSB2YWxpZCBjb21wcmVzc2lvbiBtZXRob2QgISIpO3JldHVybiBhfShyLm9wdGlvbnMuY29tcHJlc3Npb24sdC5jb21wcmVzc2lvbiksbz1yLm9wdGlvbnMuY29tcHJlc3Npb25PcHRpb25zfHx0LmNvbXByZXNzaW9uT3B0aW9uc3x8e30sdT1yLmRpcixsPXIuZGF0ZTtyLl9jb21wcmVzc1dvcmtlcihhLG8pLndpdGhTdHJlYW1JbmZvKCJmaWxlIix7bmFtZTplLGRpcjp1LGRhdGU6bCxjb21tZW50OnIuY29tbWVudHx8IiIsdW5peFBlcm1pc3Npb25zOnIudW5peFBlcm1pc3Npb25zLGRvc1Blcm1pc3Npb25zOnIuZG9zUGVybWlzc2lvbnN9KS5waXBlKGkpO30pKSxpLmVudHJpZXNDb3VudD1zO31jYXRjaChlKXtpLmVycm9yKGUpO31yZXR1cm4gaX07fSx7Ii4uL2NvbXByZXNzaW9ucyI6MywiLi9aaXBGaWxlV29ya2VyIjo4fV0sMTA6W2Z1bmN0aW9uKGUsdCxyKXtmdW5jdGlvbiBuKCl7aWYoISh0aGlzIGluc3RhbmNlb2YgbikpcmV0dXJuIG5ldyBuO2lmKGFyZ3VtZW50cy5sZW5ndGgpdGhyb3cgbmV3IEVycm9yKCJUaGUgY29uc3RydWN0b3Igd2l0aCBwYXJhbWV0ZXJzIGhhcyBiZWVuIHJlbW92ZWQgaW4gSlNaaXAgMy4wLCBwbGVhc2UgY2hlY2sgdGhlIHVwZ3JhZGUgZ3VpZGUuIik7dGhpcy5maWxlcz17fSx0aGlzLmNvbW1lbnQ9bnVsbCx0aGlzLnJvb3Q9IiIsdGhpcy5jbG9uZT1mdW5jdGlvbigpe3ZhciBlPW5ldyBuO2Zvcih2YXIgdCBpbiB0aGlzKSJmdW5jdGlvbiIhPXR5cGVvZiB0aGlzW3RdJiYoZVt0XT10aGlzW3RdKTtyZXR1cm4gZX07fShuLnByb3RvdHlwZT1lKCIuL29iamVjdCIpKS5sb2FkQXN5bmM9ZSgiLi9sb2FkIiksbi5zdXBwb3J0PWUoIi4vc3VwcG9ydCIpLG4uZGVmYXVsdHM9ZSgiLi9kZWZhdWx0cyIpLG4udmVyc2lvbj0iMy4yLjAiLG4ubG9hZEFzeW5jPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIChuZXcgbikubG9hZEFzeW5jKGUsdCl9LG4uZXh0ZXJuYWw9ZSgiLi9leHRlcm5hbCIpLHQuZXhwb3J0cz1uO30seyIuL2RlZmF1bHRzIjo1LCIuL2V4dGVybmFsIjo2LCIuL2xvYWQiOjExLCIuL29iamVjdCI6MTUsIi4vc3VwcG9ydCI6MzB9XSwxMTpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoIi4vdXRpbHMiKSxhPWUoIi4vZXh0ZXJuYWwiKSxpPWUoIi4vdXRmOCIpLHM9KG49ZSgiLi91dGlscyIpLGUoIi4vemlwRW50cmllcyIpKSxvPWUoIi4vc3RyZWFtL0NyYzMyUHJvYmUiKSx1PWUoIi4vbm9kZWpzVXRpbHMiKTtmdW5jdGlvbiBsKGUpe3JldHVybiBuZXcgYS5Qcm9taXNlKChmdW5jdGlvbih0LHIpe3ZhciBuPWUuZGVjb21wcmVzc2VkLmdldENvbnRlbnRXb3JrZXIoKS5waXBlKG5ldyBvKTtuLm9uKCJlcnJvciIsKGZ1bmN0aW9uKGUpe3IoZSk7fSkpLm9uKCJlbmQiLChmdW5jdGlvbigpe24uc3RyZWFtSW5mby5jcmMzMiE9PWUuZGVjb21wcmVzc2VkLmNyYzMyP3IobmV3IEVycm9yKCJDb3JydXB0ZWQgemlwIDogQ1JDMzIgbWlzbWF0Y2giKSk6dCgpO30pKS5yZXN1bWUoKTt9KSl9dC5leHBvcnRzPWZ1bmN0aW9uKGUsdCl7dmFyIHI9dGhpcztyZXR1cm4gdD1uLmV4dGVuZCh0fHx7fSx7YmFzZTY0OiExLGNoZWNrQ1JDMzI6ITEsb3B0aW1pemVkQmluYXJ5U3RyaW5nOiExLGNyZWF0ZUZvbGRlcnM6ITEsZGVjb2RlRmlsZU5hbWU6aS51dGY4ZGVjb2RlfSksdS5pc05vZGUmJnUuaXNTdHJlYW0oZSk/YS5Qcm9taXNlLnJlamVjdChuZXcgRXJyb3IoIkpTWmlwIGNhbid0IGFjY2VwdCBhIHN0cmVhbSB3aGVuIGxvYWRpbmcgYSB6aXAgZmlsZS4iKSk6bi5wcmVwYXJlQ29udGVudCgidGhlIGxvYWRlZCB6aXAgZmlsZSIsZSwhMCx0Lm9wdGltaXplZEJpbmFyeVN0cmluZyx0LmJhc2U2NCkudGhlbigoZnVuY3Rpb24oZSl7dmFyIHI9bmV3IHModCk7cmV0dXJuIHIubG9hZChlKSxyfSkpLnRoZW4oKGZ1bmN0aW9uKGUpe3ZhciByPVthLlByb21pc2UucmVzb2x2ZShlKV0sbj1lLmZpbGVzO2lmKHQuY2hlY2tDUkMzMilmb3IodmFyIGk9MDtpPG4ubGVuZ3RoO2krKylyLnB1c2gobChuW2ldKSk7cmV0dXJuIGEuUHJvbWlzZS5hbGwocil9KSkudGhlbigoZnVuY3Rpb24oZSl7Zm9yKHZhciBuPWUuc2hpZnQoKSxhPW4uZmlsZXMsaT0wO2k8YS5sZW5ndGg7aSsrKXt2YXIgcz1hW2ldO3IuZmlsZShzLmZpbGVOYW1lU3RyLHMuZGVjb21wcmVzc2VkLHtiaW5hcnk6ITAsb3B0aW1pemVkQmluYXJ5U3RyaW5nOiEwLGRhdGU6cy5kYXRlLGRpcjpzLmRpcixjb21tZW50OnMuZmlsZUNvbW1lbnRTdHIubGVuZ3RoP3MuZmlsZUNvbW1lbnRTdHI6bnVsbCx1bml4UGVybWlzc2lvbnM6cy51bml4UGVybWlzc2lvbnMsZG9zUGVybWlzc2lvbnM6cy5kb3NQZXJtaXNzaW9ucyxjcmVhdGVGb2xkZXJzOnQuY3JlYXRlRm9sZGVyc30pO31yZXR1cm4gbi56aXBDb21tZW50Lmxlbmd0aCYmKHIuY29tbWVudD1uLnppcENvbW1lbnQpLHJ9KSl9O30seyIuL2V4dGVybmFsIjo2LCIuL25vZGVqc1V0aWxzIjoxNCwiLi9zdHJlYW0vQ3JjMzJQcm9iZSI6MjUsIi4vdXRmOCI6MzEsIi4vdXRpbHMiOjMyLCIuL3ppcEVudHJpZXMiOjMzfV0sMTI6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuLi91dGlscyIpLGE9ZSgiLi4vc3RyZWFtL0dlbmVyaWNXb3JrZXIiKTtmdW5jdGlvbiBpKGUsdCl7YS5jYWxsKHRoaXMsIk5vZGVqcyBzdHJlYW0gaW5wdXQgYWRhcHRlciBmb3IgIitlKSx0aGlzLl91cHN0cmVhbUVuZGVkPSExLHRoaXMuX2JpbmRTdHJlYW0odCk7fW4uaW5oZXJpdHMoaSxhKSxpLnByb3RvdHlwZS5fYmluZFN0cmVhbT1mdW5jdGlvbihlKXt2YXIgdD10aGlzOyh0aGlzLl9zdHJlYW09ZSkucGF1c2UoKSxlLm9uKCJkYXRhIiwoZnVuY3Rpb24oZSl7dC5wdXNoKHtkYXRhOmUsbWV0YTp7cGVyY2VudDowfX0pO30pKS5vbigiZXJyb3IiLChmdW5jdGlvbihlKXt0LmlzUGF1c2VkP3RoaXMuZ2VuZXJhdGVkRXJyb3I9ZTp0LmVycm9yKGUpO30pKS5vbigiZW5kIiwoZnVuY3Rpb24oKXt0LmlzUGF1c2VkP3QuX3Vwc3RyZWFtRW5kZWQ9ITA6dC5lbmQoKTt9KSk7fSxpLnByb3RvdHlwZS5wYXVzZT1mdW5jdGlvbigpe3JldHVybiAhIWEucHJvdG90eXBlLnBhdXNlLmNhbGwodGhpcykmJih0aGlzLl9zdHJlYW0ucGF1c2UoKSwhMCl9LGkucHJvdG90eXBlLnJlc3VtZT1mdW5jdGlvbigpe3JldHVybiAhIWEucHJvdG90eXBlLnJlc3VtZS5jYWxsKHRoaXMpJiYodGhpcy5fdXBzdHJlYW1FbmRlZD90aGlzLmVuZCgpOnRoaXMuX3N0cmVhbS5yZXN1bWUoKSwhMCl9LHQuZXhwb3J0cz1pO30seyIuLi9zdHJlYW0vR2VuZXJpY1dvcmtlciI6MjgsIi4uL3V0aWxzIjozMn1dLDEzOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgicmVhZGFibGUtc3RyZWFtIikuUmVhZGFibGU7ZnVuY3Rpb24gYShlLHQscil7bi5jYWxsKHRoaXMsdCksdGhpcy5faGVscGVyPWU7dmFyIGE9dGhpcztlLm9uKCJkYXRhIiwoZnVuY3Rpb24oZSx0KXthLnB1c2goZSl8fGEuX2hlbHBlci5wYXVzZSgpLHImJnIodCk7fSkpLm9uKCJlcnJvciIsKGZ1bmN0aW9uKGUpe2EuZW1pdCgiZXJyb3IiLGUpO30pKS5vbigiZW5kIiwoZnVuY3Rpb24oKXthLnB1c2gobnVsbCk7fSkpO31lKCIuLi91dGlscyIpLmluaGVyaXRzKGEsbiksYS5wcm90b3R5cGUuX3JlYWQ9ZnVuY3Rpb24oKXt0aGlzLl9oZWxwZXIucmVzdW1lKCk7fSx0LmV4cG9ydHM9YTt9LHsiLi4vdXRpbHMiOjMyLCJyZWFkYWJsZS1zdHJlYW0iOjE2fV0sMTQ6W2Z1bmN0aW9uKGUsdCxyKXt0LmV4cG9ydHM9e2lzTm9kZToidW5kZWZpbmVkIiE9dHlwZW9mIEJ1ZmZlcixuZXdCdWZmZXJGcm9tOmZ1bmN0aW9uKGUsdCl7aWYoQnVmZmVyLmZyb20mJkJ1ZmZlci5mcm9tIT09VWludDhBcnJheS5mcm9tKXJldHVybiBCdWZmZXIuZnJvbShlLHQpO2lmKCJudW1iZXIiPT10eXBlb2YgZSl0aHJvdyBuZXcgRXJyb3IoJ1RoZSAiZGF0YSIgYXJndW1lbnQgbXVzdCBub3QgYmUgYSBudW1iZXInKTtyZXR1cm4gbmV3IEJ1ZmZlcihlLHQpfSxhbGxvY0J1ZmZlcjpmdW5jdGlvbihlKXtpZihCdWZmZXIuYWxsb2MpcmV0dXJuIEJ1ZmZlci5hbGxvYyhlKTt2YXIgdD1uZXcgQnVmZmVyKGUpO3JldHVybiB0LmZpbGwoMCksdH0saXNCdWZmZXI6ZnVuY3Rpb24oZSl7cmV0dXJuIEJ1ZmZlci5pc0J1ZmZlcihlKX0saXNTdHJlYW06ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJiJmdW5jdGlvbiI9PXR5cGVvZiBlLm9uJiYiZnVuY3Rpb24iPT10eXBlb2YgZS5wYXVzZSYmImZ1bmN0aW9uIj09dHlwZW9mIGUucmVzdW1lfX07fSx7fV0sMTU6W2Z1bmN0aW9uKGUsdCxyKXtmdW5jdGlvbiBuKGUsdCxyKXt2YXIgbixhPWkuZ2V0VHlwZU9mKHQpLG89aS5leHRlbmQocnx8e30sdSk7by5kYXRlPW8uZGF0ZXx8bmV3IERhdGUsbnVsbCE9PW8uY29tcHJlc3Npb24mJihvLmNvbXByZXNzaW9uPW8uY29tcHJlc3Npb24udG9VcHBlckNhc2UoKSksInN0cmluZyI9PXR5cGVvZiBvLnVuaXhQZXJtaXNzaW9ucyYmKG8udW5peFBlcm1pc3Npb25zPXBhcnNlSW50KG8udW5peFBlcm1pc3Npb25zLDgpKSxvLnVuaXhQZXJtaXNzaW9ucyYmMTYzODQmby51bml4UGVybWlzc2lvbnMmJihvLmRpcj0hMCksby5kb3NQZXJtaXNzaW9ucyYmMTYmby5kb3NQZXJtaXNzaW9ucyYmKG8uZGlyPSEwKSxvLmRpciYmKGU9bShlKSksby5jcmVhdGVGb2xkZXJzJiYobj1wKGUpKSYmZy5jYWxsKHRoaXMsbiwhMCk7dmFyIGgsXz0ic3RyaW5nIj09PWEmJiExPT09by5iaW5hcnkmJiExPT09by5iYXNlNjQ7ciYmdm9pZCAwIT09ci5iaW5hcnl8fChvLmJpbmFyeT0hXyksKHQgaW5zdGFuY2VvZiBsJiYwPT09dC51bmNvbXByZXNzZWRTaXplfHxvLmRpcnx8IXR8fDA9PT10Lmxlbmd0aCkmJihvLmJhc2U2ND0hMSxvLmJpbmFyeT0hMCx0PSIiLG8uY29tcHJlc3Npb249IlNUT1JFIixhPSJzdHJpbmciKSxoPXQgaW5zdGFuY2VvZiBsfHx0IGluc3RhbmNlb2Ygcz90OmQuaXNOb2RlJiZkLmlzU3RyZWFtKHQpP25ldyBmKGUsdCk6aS5wcmVwYXJlQ29udGVudChlLHQsby5iaW5hcnksby5vcHRpbWl6ZWRCaW5hcnlTdHJpbmcsby5iYXNlNjQpO3ZhciB5PW5ldyBjKGUsaCxvKTt0aGlzLmZpbGVzW2VdPXk7fXZhciBhPWUoIi4vdXRmOCIpLGk9ZSgiLi91dGlscyIpLHM9ZSgiLi9zdHJlYW0vR2VuZXJpY1dvcmtlciIpLG89ZSgiLi9zdHJlYW0vU3RyZWFtSGVscGVyIiksdT1lKCIuL2RlZmF1bHRzIiksbD1lKCIuL2NvbXByZXNzZWRPYmplY3QiKSxjPWUoIi4vemlwT2JqZWN0IiksaD1lKCIuL2dlbmVyYXRlIiksZD1lKCIuL25vZGVqc1V0aWxzIiksZj1lKCIuL25vZGVqcy9Ob2RlanNTdHJlYW1JbnB1dEFkYXB0ZXIiKSxwPWZ1bmN0aW9uKGUpeyIvIj09PWUuc2xpY2UoLTEpJiYoZT1lLnN1YnN0cmluZygwLGUubGVuZ3RoLTEpKTt2YXIgdD1lLmxhc3RJbmRleE9mKCIvIik7cmV0dXJuIDA8dD9lLnN1YnN0cmluZygwLHQpOiIifSxtPWZ1bmN0aW9uKGUpe3JldHVybiAiLyIhPT1lLnNsaWNlKC0xKSYmKGUrPSIvIiksZX0sZz1mdW5jdGlvbihlLHQpe3JldHVybiB0PXZvaWQgMCE9PXQ/dDp1LmNyZWF0ZUZvbGRlcnMsZT1tKGUpLHRoaXMuZmlsZXNbZV18fG4uY2FsbCh0aGlzLGUsbnVsbCx7ZGlyOiEwLGNyZWF0ZUZvbGRlcnM6dH0pLHRoaXMuZmlsZXNbZV19O2Z1bmN0aW9uIF8oZSl7cmV0dXJuICJbb2JqZWN0IFJlZ0V4cF0iPT09T2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKGUpfXZhciB5PXtsb2FkOmZ1bmN0aW9uKCl7dGhyb3cgbmV3IEVycm9yKCJUaGlzIG1ldGhvZCBoYXMgYmVlbiByZW1vdmVkIGluIEpTWmlwIDMuMCwgcGxlYXNlIGNoZWNrIHRoZSB1cGdyYWRlIGd1aWRlLiIpfSxmb3JFYWNoOmZ1bmN0aW9uKGUpe3ZhciB0LHIsbjtmb3IodCBpbiB0aGlzLmZpbGVzKXRoaXMuZmlsZXMuaGFzT3duUHJvcGVydHkodCkmJihuPXRoaXMuZmlsZXNbdF0sKHI9dC5zbGljZSh0aGlzLnJvb3QubGVuZ3RoLHQubGVuZ3RoKSkmJnQuc2xpY2UoMCx0aGlzLnJvb3QubGVuZ3RoKT09PXRoaXMucm9vdCYmZShyLG4pKTt9LGZpbHRlcjpmdW5jdGlvbihlKXt2YXIgdD1bXTtyZXR1cm4gdGhpcy5mb3JFYWNoKChmdW5jdGlvbihyLG4pe2UocixuKSYmdC5wdXNoKG4pO30pKSx0fSxmaWxlOmZ1bmN0aW9uKGUsdCxyKXtpZigxIT09YXJndW1lbnRzLmxlbmd0aClyZXR1cm4gZT10aGlzLnJvb3QrZSxuLmNhbGwodGhpcyxlLHQsciksdGhpcztpZihfKGUpKXt2YXIgYT1lO3JldHVybiB0aGlzLmZpbHRlcigoZnVuY3Rpb24oZSx0KXtyZXR1cm4gIXQuZGlyJiZhLnRlc3QoZSl9KSl9dmFyIGk9dGhpcy5maWxlc1t0aGlzLnJvb3QrZV07cmV0dXJuIGkmJiFpLmRpcj9pOm51bGx9LGZvbGRlcjpmdW5jdGlvbihlKXtpZighZSlyZXR1cm4gdGhpcztpZihfKGUpKXJldHVybiB0aGlzLmZpbHRlcigoZnVuY3Rpb24odCxyKXtyZXR1cm4gci5kaXImJmUudGVzdCh0KX0pKTt2YXIgdD10aGlzLnJvb3QrZSxyPWcuY2FsbCh0aGlzLHQpLG49dGhpcy5jbG9uZSgpO3JldHVybiBuLnJvb3Q9ci5uYW1lLG59LHJlbW92ZTpmdW5jdGlvbihlKXtlPXRoaXMucm9vdCtlO3ZhciB0PXRoaXMuZmlsZXNbZV07aWYodHx8KCIvIiE9PWUuc2xpY2UoLTEpJiYoZSs9Ii8iKSx0PXRoaXMuZmlsZXNbZV0pLHQmJiF0LmRpcilkZWxldGUgdGhpcy5maWxlc1tlXTtlbHNlIGZvcih2YXIgcj10aGlzLmZpbHRlcigoZnVuY3Rpb24odCxyKXtyZXR1cm4gci5uYW1lLnNsaWNlKDAsZS5sZW5ndGgpPT09ZX0pKSxuPTA7bjxyLmxlbmd0aDtuKyspZGVsZXRlIHRoaXMuZmlsZXNbcltuXS5uYW1lXTtyZXR1cm4gdGhpc30sZ2VuZXJhdGU6ZnVuY3Rpb24oZSl7dGhyb3cgbmV3IEVycm9yKCJUaGlzIG1ldGhvZCBoYXMgYmVlbiByZW1vdmVkIGluIEpTWmlwIDMuMCwgcGxlYXNlIGNoZWNrIHRoZSB1cGdyYWRlIGd1aWRlLiIpfSxnZW5lcmF0ZUludGVybmFsU3RyZWFtOmZ1bmN0aW9uKGUpe3ZhciB0LHI9e307dHJ5e2lmKChyPWkuZXh0ZW5kKGV8fHt9LHtzdHJlYW1GaWxlczohMSxjb21wcmVzc2lvbjoiU1RPUkUiLGNvbXByZXNzaW9uT3B0aW9uczpudWxsLHR5cGU6IiIscGxhdGZvcm06IkRPUyIsY29tbWVudDpudWxsLG1pbWVUeXBlOiJhcHBsaWNhdGlvbi96aXAiLGVuY29kZUZpbGVOYW1lOmEudXRmOGVuY29kZX0pKS50eXBlPXIudHlwZS50b0xvd2VyQ2FzZSgpLHIuY29tcHJlc3Npb249ci5jb21wcmVzc2lvbi50b1VwcGVyQ2FzZSgpLCJiaW5hcnlzdHJpbmciPT09ci50eXBlJiYoci50eXBlPSJzdHJpbmciKSwhci50eXBlKXRocm93IG5ldyBFcnJvcigiTm8gb3V0cHV0IHR5cGUgc3BlY2lmaWVkLiIpO2kuY2hlY2tTdXBwb3J0KHIudHlwZSksImRhcndpbiIhPT1yLnBsYXRmb3JtJiYiZnJlZWJzZCIhPT1yLnBsYXRmb3JtJiYibGludXgiIT09ci5wbGF0Zm9ybSYmInN1bm9zIiE9PXIucGxhdGZvcm18fChyLnBsYXRmb3JtPSJVTklYIiksIndpbjMyIj09PXIucGxhdGZvcm0mJihyLnBsYXRmb3JtPSJET1MiKTt2YXIgbj1yLmNvbW1lbnR8fHRoaXMuY29tbWVudHx8IiI7dD1oLmdlbmVyYXRlV29ya2VyKHRoaXMscixuKTt9Y2F0Y2goZSl7KHQ9bmV3IHMoImVycm9yIikpLmVycm9yKGUpO31yZXR1cm4gbmV3IG8odCxyLnR5cGV8fCJzdHJpbmciLHIubWltZVR5cGUpfSxnZW5lcmF0ZUFzeW5jOmZ1bmN0aW9uKGUsdCl7cmV0dXJuIHRoaXMuZ2VuZXJhdGVJbnRlcm5hbFN0cmVhbShlKS5hY2N1bXVsYXRlKHQpfSxnZW5lcmF0ZU5vZGVTdHJlYW06ZnVuY3Rpb24oZSx0KXtyZXR1cm4gKGU9ZXx8e30pLnR5cGV8fChlLnR5cGU9Im5vZGVidWZmZXIiKSx0aGlzLmdlbmVyYXRlSW50ZXJuYWxTdHJlYW0oZSkudG9Ob2RlanNTdHJlYW0odCl9fTt0LmV4cG9ydHM9eTt9LHsiLi9jb21wcmVzc2VkT2JqZWN0IjoyLCIuL2RlZmF1bHRzIjo1LCIuL2dlbmVyYXRlIjo5LCIuL25vZGVqcy9Ob2RlanNTdHJlYW1JbnB1dEFkYXB0ZXIiOjEyLCIuL25vZGVqc1V0aWxzIjoxNCwiLi9zdHJlYW0vR2VuZXJpY1dvcmtlciI6MjgsIi4vc3RyZWFtL1N0cmVhbUhlbHBlciI6MjksIi4vdXRmOCI6MzEsIi4vdXRpbHMiOjMyLCIuL3ppcE9iamVjdCI6MzV9XSwxNjpbZnVuY3Rpb24oZSx0LHIpe3QuZXhwb3J0cz1lKCJzdHJlYW0iKTt9LHtzdHJlYW06dm9pZCAwfV0sMTc6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuL0RhdGFSZWFkZXIiKTtmdW5jdGlvbiBhKGUpe24uY2FsbCh0aGlzLGUpO2Zvcih2YXIgdD0wO3Q8dGhpcy5kYXRhLmxlbmd0aDt0KyspZVt0XT0yNTUmZVt0XTt9ZSgiLi4vdXRpbHMiKS5pbmhlcml0cyhhLG4pLGEucHJvdG90eXBlLmJ5dGVBdD1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5kYXRhW3RoaXMuemVybytlXX0sYS5wcm90b3R5cGUubGFzdEluZGV4T2ZTaWduYXR1cmU9ZnVuY3Rpb24oZSl7Zm9yKHZhciB0PWUuY2hhckNvZGVBdCgwKSxyPWUuY2hhckNvZGVBdCgxKSxuPWUuY2hhckNvZGVBdCgyKSxhPWUuY2hhckNvZGVBdCgzKSxpPXRoaXMubGVuZ3RoLTQ7MDw9aTstLWkpaWYodGhpcy5kYXRhW2ldPT09dCYmdGhpcy5kYXRhW2krMV09PT1yJiZ0aGlzLmRhdGFbaSsyXT09PW4mJnRoaXMuZGF0YVtpKzNdPT09YSlyZXR1cm4gaS10aGlzLnplcm87cmV0dXJuIC0xfSxhLnByb3RvdHlwZS5yZWFkQW5kQ2hlY2tTaWduYXR1cmU9ZnVuY3Rpb24oZSl7dmFyIHQ9ZS5jaGFyQ29kZUF0KDApLHI9ZS5jaGFyQ29kZUF0KDEpLG49ZS5jaGFyQ29kZUF0KDIpLGE9ZS5jaGFyQ29kZUF0KDMpLGk9dGhpcy5yZWFkRGF0YSg0KTtyZXR1cm4gdD09PWlbMF0mJnI9PT1pWzFdJiZuPT09aVsyXSYmYT09PWlbM119LGEucHJvdG90eXBlLnJlYWREYXRhPWZ1bmN0aW9uKGUpe2lmKHRoaXMuY2hlY2tPZmZzZXQoZSksMD09PWUpcmV0dXJuIFtdO3ZhciB0PXRoaXMuZGF0YS5zbGljZSh0aGlzLnplcm8rdGhpcy5pbmRleCx0aGlzLnplcm8rdGhpcy5pbmRleCtlKTtyZXR1cm4gdGhpcy5pbmRleCs9ZSx0fSx0LmV4cG9ydHM9YTt9LHsiLi4vdXRpbHMiOjMyLCIuL0RhdGFSZWFkZXIiOjE4fV0sMTg6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuLi91dGlscyIpO2Z1bmN0aW9uIGEoZSl7dGhpcy5kYXRhPWUsdGhpcy5sZW5ndGg9ZS5sZW5ndGgsdGhpcy5pbmRleD0wLHRoaXMuemVybz0wO31hLnByb3RvdHlwZT17Y2hlY2tPZmZzZXQ6ZnVuY3Rpb24oZSl7dGhpcy5jaGVja0luZGV4KHRoaXMuaW5kZXgrZSk7fSxjaGVja0luZGV4OmZ1bmN0aW9uKGUpe2lmKHRoaXMubGVuZ3RoPHRoaXMuemVybytlfHxlPDApdGhyb3cgbmV3IEVycm9yKCJFbmQgb2YgZGF0YSByZWFjaGVkIChkYXRhIGxlbmd0aCA9ICIrdGhpcy5sZW5ndGgrIiwgYXNrZWQgaW5kZXggPSAiK2UrIikuIENvcnJ1cHRlZCB6aXAgPyIpfSxzZXRJbmRleDpmdW5jdGlvbihlKXt0aGlzLmNoZWNrSW5kZXgoZSksdGhpcy5pbmRleD1lO30sc2tpcDpmdW5jdGlvbihlKXt0aGlzLnNldEluZGV4KHRoaXMuaW5kZXgrZSk7fSxieXRlQXQ6ZnVuY3Rpb24oZSl7fSxyZWFkSW50OmZ1bmN0aW9uKGUpe3ZhciB0LHI9MDtmb3IodGhpcy5jaGVja09mZnNldChlKSx0PXRoaXMuaW5kZXgrZS0xO3Q+PXRoaXMuaW5kZXg7dC0tKXI9KHI8PDgpK3RoaXMuYnl0ZUF0KHQpO3JldHVybiB0aGlzLmluZGV4Kz1lLHJ9LHJlYWRTdHJpbmc6ZnVuY3Rpb24oZSl7cmV0dXJuIG4udHJhbnNmb3JtVG8oInN0cmluZyIsdGhpcy5yZWFkRGF0YShlKSl9LHJlYWREYXRhOmZ1bmN0aW9uKGUpe30sbGFzdEluZGV4T2ZTaWduYXR1cmU6ZnVuY3Rpb24oZSl7fSxyZWFkQW5kQ2hlY2tTaWduYXR1cmU6ZnVuY3Rpb24oZSl7fSxyZWFkRGF0ZTpmdW5jdGlvbigpe3ZhciBlPXRoaXMucmVhZEludCg0KTtyZXR1cm4gbmV3IERhdGUoRGF0ZS5VVEMoMTk4MCsoZT4+MjUmMTI3KSwoZT4+MjEmMTUpLTEsZT4+MTYmMzEsZT4+MTEmMzEsZT4+NSY2MywoMzEmZSk8PDEpKX19LHQuZXhwb3J0cz1hO30seyIuLi91dGlscyI6MzJ9XSwxOTpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoIi4vVWludDhBcnJheVJlYWRlciIpO2Z1bmN0aW9uIGEoZSl7bi5jYWxsKHRoaXMsZSk7fWUoIi4uL3V0aWxzIikuaW5oZXJpdHMoYSxuKSxhLnByb3RvdHlwZS5yZWFkRGF0YT1mdW5jdGlvbihlKXt0aGlzLmNoZWNrT2Zmc2V0KGUpO3ZhciB0PXRoaXMuZGF0YS5zbGljZSh0aGlzLnplcm8rdGhpcy5pbmRleCx0aGlzLnplcm8rdGhpcy5pbmRleCtlKTtyZXR1cm4gdGhpcy5pbmRleCs9ZSx0fSx0LmV4cG9ydHM9YTt9LHsiLi4vdXRpbHMiOjMyLCIuL1VpbnQ4QXJyYXlSZWFkZXIiOjIxfV0sMjA6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuL0RhdGFSZWFkZXIiKTtmdW5jdGlvbiBhKGUpe24uY2FsbCh0aGlzLGUpO31lKCIuLi91dGlscyIpLmluaGVyaXRzKGEsbiksYS5wcm90b3R5cGUuYnl0ZUF0PWZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLmRhdGEuY2hhckNvZGVBdCh0aGlzLnplcm8rZSl9LGEucHJvdG90eXBlLmxhc3RJbmRleE9mU2lnbmF0dXJlPWZ1bmN0aW9uKGUpe3JldHVybiB0aGlzLmRhdGEubGFzdEluZGV4T2YoZSktdGhpcy56ZXJvfSxhLnByb3RvdHlwZS5yZWFkQW5kQ2hlY2tTaWduYXR1cmU9ZnVuY3Rpb24oZSl7cmV0dXJuIGU9PT10aGlzLnJlYWREYXRhKDQpfSxhLnByb3RvdHlwZS5yZWFkRGF0YT1mdW5jdGlvbihlKXt0aGlzLmNoZWNrT2Zmc2V0KGUpO3ZhciB0PXRoaXMuZGF0YS5zbGljZSh0aGlzLnplcm8rdGhpcy5pbmRleCx0aGlzLnplcm8rdGhpcy5pbmRleCtlKTtyZXR1cm4gdGhpcy5pbmRleCs9ZSx0fSx0LmV4cG9ydHM9YTt9LHsiLi4vdXRpbHMiOjMyLCIuL0RhdGFSZWFkZXIiOjE4fV0sMjE6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuL0FycmF5UmVhZGVyIik7ZnVuY3Rpb24gYShlKXtuLmNhbGwodGhpcyxlKTt9ZSgiLi4vdXRpbHMiKS5pbmhlcml0cyhhLG4pLGEucHJvdG90eXBlLnJlYWREYXRhPWZ1bmN0aW9uKGUpe2lmKHRoaXMuY2hlY2tPZmZzZXQoZSksMD09PWUpcmV0dXJuIG5ldyBVaW50OEFycmF5KDApO3ZhciB0PXRoaXMuZGF0YS5zdWJhcnJheSh0aGlzLnplcm8rdGhpcy5pbmRleCx0aGlzLnplcm8rdGhpcy5pbmRleCtlKTtyZXR1cm4gdGhpcy5pbmRleCs9ZSx0fSx0LmV4cG9ydHM9YTt9LHsiLi4vdXRpbHMiOjMyLCIuL0FycmF5UmVhZGVyIjoxN31dLDIyOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi4vdXRpbHMiKSxhPWUoIi4uL3N1cHBvcnQiKSxpPWUoIi4vQXJyYXlSZWFkZXIiKSxzPWUoIi4vU3RyaW5nUmVhZGVyIiksbz1lKCIuL05vZGVCdWZmZXJSZWFkZXIiKSx1PWUoIi4vVWludDhBcnJheVJlYWRlciIpO3QuZXhwb3J0cz1mdW5jdGlvbihlKXt2YXIgdD1uLmdldFR5cGVPZihlKTtyZXR1cm4gbi5jaGVja1N1cHBvcnQodCksInN0cmluZyIhPT10fHxhLnVpbnQ4YXJyYXk/Im5vZGVidWZmZXIiPT09dD9uZXcgbyhlKTphLnVpbnQ4YXJyYXk/bmV3IHUobi50cmFuc2Zvcm1UbygidWludDhhcnJheSIsZSkpOm5ldyBpKG4udHJhbnNmb3JtVG8oImFycmF5IixlKSk6bmV3IHMoZSl9O30seyIuLi9zdXBwb3J0IjozMCwiLi4vdXRpbHMiOjMyLCIuL0FycmF5UmVhZGVyIjoxNywiLi9Ob2RlQnVmZmVyUmVhZGVyIjoxOSwiLi9TdHJpbmdSZWFkZXIiOjIwLCIuL1VpbnQ4QXJyYXlSZWFkZXIiOjIxfV0sMjM6W2Z1bmN0aW9uKGUsdCxyKXtyLkxPQ0FMX0ZJTEVfSEVBREVSPSJQSwMEIixyLkNFTlRSQUxfRklMRV9IRUFERVI9IlBLAQIiLHIuQ0VOVFJBTF9ESVJFQ1RPUllfRU5EPSJQSwUGIixyLlpJUDY0X0NFTlRSQUxfRElSRUNUT1JZX0xPQ0FUT1I9IlBLBgciLHIuWklQNjRfQ0VOVFJBTF9ESVJFQ1RPUllfRU5EPSJQSwYGIixyLkRBVEFfREVTQ1JJUFRPUj0iUEsHXGIiO30se31dLDI0OltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi9HZW5lcmljV29ya2VyIiksYT1lKCIuLi91dGlscyIpO2Z1bmN0aW9uIGkoZSl7bi5jYWxsKHRoaXMsIkNvbnZlcnRXb3JrZXIgdG8gIitlKSx0aGlzLmRlc3RUeXBlPWU7fWEuaW5oZXJpdHMoaSxuKSxpLnByb3RvdHlwZS5wcm9jZXNzQ2h1bms9ZnVuY3Rpb24oZSl7dGhpcy5wdXNoKHtkYXRhOmEudHJhbnNmb3JtVG8odGhpcy5kZXN0VHlwZSxlLmRhdGEpLG1ldGE6ZS5tZXRhfSk7fSx0LmV4cG9ydHM9aTt9LHsiLi4vdXRpbHMiOjMyLCIuL0dlbmVyaWNXb3JrZXIiOjI4fV0sMjU6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuL0dlbmVyaWNXb3JrZXIiKSxhPWUoIi4uL2NyYzMyIik7ZnVuY3Rpb24gaSgpe24uY2FsbCh0aGlzLCJDcmMzMlByb2JlIiksdGhpcy53aXRoU3RyZWFtSW5mbygiY3JjMzIiLDApO31lKCIuLi91dGlscyIpLmluaGVyaXRzKGksbiksaS5wcm90b3R5cGUucHJvY2Vzc0NodW5rPWZ1bmN0aW9uKGUpe3RoaXMuc3RyZWFtSW5mby5jcmMzMj1hKGUuZGF0YSx0aGlzLnN0cmVhbUluZm8uY3JjMzJ8fDApLHRoaXMucHVzaChlKTt9LHQuZXhwb3J0cz1pO30seyIuLi9jcmMzMiI6NCwiLi4vdXRpbHMiOjMyLCIuL0dlbmVyaWNXb3JrZXIiOjI4fV0sMjY6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuLi91dGlscyIpLGE9ZSgiLi9HZW5lcmljV29ya2VyIik7ZnVuY3Rpb24gaShlKXthLmNhbGwodGhpcywiRGF0YUxlbmd0aFByb2JlIGZvciAiK2UpLHRoaXMucHJvcE5hbWU9ZSx0aGlzLndpdGhTdHJlYW1JbmZvKGUsMCk7fW4uaW5oZXJpdHMoaSxhKSxpLnByb3RvdHlwZS5wcm9jZXNzQ2h1bms9ZnVuY3Rpb24oZSl7aWYoZSl7dmFyIHQ9dGhpcy5zdHJlYW1JbmZvW3RoaXMucHJvcE5hbWVdfHwwO3RoaXMuc3RyZWFtSW5mb1t0aGlzLnByb3BOYW1lXT10K2UuZGF0YS5sZW5ndGg7fWEucHJvdG90eXBlLnByb2Nlc3NDaHVuay5jYWxsKHRoaXMsZSk7fSx0LmV4cG9ydHM9aTt9LHsiLi4vdXRpbHMiOjMyLCIuL0dlbmVyaWNXb3JrZXIiOjI4fV0sMjc6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuLi91dGlscyIpLGE9ZSgiLi9HZW5lcmljV29ya2VyIik7ZnVuY3Rpb24gaShlKXthLmNhbGwodGhpcywiRGF0YVdvcmtlciIpO3ZhciB0PXRoaXM7dGhpcy5kYXRhSXNSZWFkeT0hMSx0aGlzLmluZGV4PTAsdGhpcy5tYXg9MCx0aGlzLmRhdGE9bnVsbCx0aGlzLnR5cGU9IiIsdGhpcy5fdGlja1NjaGVkdWxlZD0hMSxlLnRoZW4oKGZ1bmN0aW9uKGUpe3QuZGF0YUlzUmVhZHk9ITAsdC5kYXRhPWUsdC5tYXg9ZSYmZS5sZW5ndGh8fDAsdC50eXBlPW4uZ2V0VHlwZU9mKGUpLHQuaXNQYXVzZWR8fHQuX3RpY2tBbmRSZXBlYXQoKTt9KSwoZnVuY3Rpb24oZSl7dC5lcnJvcihlKTt9KSk7fW4uaW5oZXJpdHMoaSxhKSxpLnByb3RvdHlwZS5jbGVhblVwPWZ1bmN0aW9uKCl7YS5wcm90b3R5cGUuY2xlYW5VcC5jYWxsKHRoaXMpLHRoaXMuZGF0YT1udWxsO30saS5wcm90b3R5cGUucmVzdW1lPWZ1bmN0aW9uKCl7cmV0dXJuICEhYS5wcm90b3R5cGUucmVzdW1lLmNhbGwodGhpcykmJighdGhpcy5fdGlja1NjaGVkdWxlZCYmdGhpcy5kYXRhSXNSZWFkeSYmKHRoaXMuX3RpY2tTY2hlZHVsZWQ9ITAsbi5kZWxheSh0aGlzLl90aWNrQW5kUmVwZWF0LFtdLHRoaXMpKSwhMCl9LGkucHJvdG90eXBlLl90aWNrQW5kUmVwZWF0PWZ1bmN0aW9uKCl7dGhpcy5fdGlja1NjaGVkdWxlZD0hMSx0aGlzLmlzUGF1c2VkfHx0aGlzLmlzRmluaXNoZWR8fCh0aGlzLl90aWNrKCksdGhpcy5pc0ZpbmlzaGVkfHwobi5kZWxheSh0aGlzLl90aWNrQW5kUmVwZWF0LFtdLHRoaXMpLHRoaXMuX3RpY2tTY2hlZHVsZWQ9ITApKTt9LGkucHJvdG90eXBlLl90aWNrPWZ1bmN0aW9uKCl7aWYodGhpcy5pc1BhdXNlZHx8dGhpcy5pc0ZpbmlzaGVkKXJldHVybiAhMTt2YXIgZT1udWxsLHQ9TWF0aC5taW4odGhpcy5tYXgsdGhpcy5pbmRleCsxNjM4NCk7aWYodGhpcy5pbmRleD49dGhpcy5tYXgpcmV0dXJuIHRoaXMuZW5kKCk7c3dpdGNoKHRoaXMudHlwZSl7Y2FzZSJzdHJpbmciOmU9dGhpcy5kYXRhLnN1YnN0cmluZyh0aGlzLmluZGV4LHQpO2JyZWFrO2Nhc2UidWludDhhcnJheSI6ZT10aGlzLmRhdGEuc3ViYXJyYXkodGhpcy5pbmRleCx0KTticmVhaztjYXNlImFycmF5IjpjYXNlIm5vZGVidWZmZXIiOmU9dGhpcy5kYXRhLnNsaWNlKHRoaXMuaW5kZXgsdCk7fXJldHVybiB0aGlzLmluZGV4PXQsdGhpcy5wdXNoKHtkYXRhOmUsbWV0YTp7cGVyY2VudDp0aGlzLm1heD90aGlzLmluZGV4L3RoaXMubWF4KjEwMDowfX0pfSx0LmV4cG9ydHM9aTt9LHsiLi4vdXRpbHMiOjMyLCIuL0dlbmVyaWNXb3JrZXIiOjI4fV0sMjg6W2Z1bmN0aW9uKGUsdCxyKXtmdW5jdGlvbiBuKGUpe3RoaXMubmFtZT1lfHwiZGVmYXVsdCIsdGhpcy5zdHJlYW1JbmZvPXt9LHRoaXMuZ2VuZXJhdGVkRXJyb3I9bnVsbCx0aGlzLmV4dHJhU3RyZWFtSW5mbz17fSx0aGlzLmlzUGF1c2VkPSEwLHRoaXMuaXNGaW5pc2hlZD0hMSx0aGlzLmlzTG9ja2VkPSExLHRoaXMuX2xpc3RlbmVycz17ZGF0YTpbXSxlbmQ6W10sZXJyb3I6W119LHRoaXMucHJldmlvdXM9bnVsbDt9bi5wcm90b3R5cGU9e3B1c2g6ZnVuY3Rpb24oZSl7dGhpcy5lbWl0KCJkYXRhIixlKTt9LGVuZDpmdW5jdGlvbigpe2lmKHRoaXMuaXNGaW5pc2hlZClyZXR1cm4gITE7dGhpcy5mbHVzaCgpO3RyeXt0aGlzLmVtaXQoImVuZCIpLHRoaXMuY2xlYW5VcCgpLHRoaXMuaXNGaW5pc2hlZD0hMDt9Y2F0Y2goZSl7dGhpcy5lbWl0KCJlcnJvciIsZSk7fXJldHVybiAhMH0sZXJyb3I6ZnVuY3Rpb24oZSl7cmV0dXJuICF0aGlzLmlzRmluaXNoZWQmJih0aGlzLmlzUGF1c2VkP3RoaXMuZ2VuZXJhdGVkRXJyb3I9ZToodGhpcy5pc0ZpbmlzaGVkPSEwLHRoaXMuZW1pdCgiZXJyb3IiLGUpLHRoaXMucHJldmlvdXMmJnRoaXMucHJldmlvdXMuZXJyb3IoZSksdGhpcy5jbGVhblVwKCkpLCEwKX0sb246ZnVuY3Rpb24oZSx0KXtyZXR1cm4gdGhpcy5fbGlzdGVuZXJzW2VdLnB1c2godCksdGhpc30sY2xlYW5VcDpmdW5jdGlvbigpe3RoaXMuc3RyZWFtSW5mbz10aGlzLmdlbmVyYXRlZEVycm9yPXRoaXMuZXh0cmFTdHJlYW1JbmZvPW51bGwsdGhpcy5fbGlzdGVuZXJzPVtdO30sZW1pdDpmdW5jdGlvbihlLHQpe2lmKHRoaXMuX2xpc3RlbmVyc1tlXSlmb3IodmFyIHI9MDtyPHRoaXMuX2xpc3RlbmVyc1tlXS5sZW5ndGg7cisrKXRoaXMuX2xpc3RlbmVyc1tlXVtyXS5jYWxsKHRoaXMsdCk7fSxwaXBlOmZ1bmN0aW9uKGUpe3JldHVybiBlLnJlZ2lzdGVyUHJldmlvdXModGhpcyl9LHJlZ2lzdGVyUHJldmlvdXM6ZnVuY3Rpb24oZSl7aWYodGhpcy5pc0xvY2tlZCl0aHJvdyBuZXcgRXJyb3IoIlRoZSBzdHJlYW0gJyIrdGhpcysiJyBoYXMgYWxyZWFkeSBiZWVuIHVzZWQuIik7dGhpcy5zdHJlYW1JbmZvPWUuc3RyZWFtSW5mbyx0aGlzLm1lcmdlU3RyZWFtSW5mbygpLHRoaXMucHJldmlvdXM9ZTt2YXIgdD10aGlzO3JldHVybiBlLm9uKCJkYXRhIiwoZnVuY3Rpb24oZSl7dC5wcm9jZXNzQ2h1bmsoZSk7fSkpLGUub24oImVuZCIsKGZ1bmN0aW9uKCl7dC5lbmQoKTt9KSksZS5vbigiZXJyb3IiLChmdW5jdGlvbihlKXt0LmVycm9yKGUpO30pKSx0aGlzfSxwYXVzZTpmdW5jdGlvbigpe3JldHVybiAhdGhpcy5pc1BhdXNlZCYmIXRoaXMuaXNGaW5pc2hlZCYmKHRoaXMuaXNQYXVzZWQ9ITAsdGhpcy5wcmV2aW91cyYmdGhpcy5wcmV2aW91cy5wYXVzZSgpLCEwKX0scmVzdW1lOmZ1bmN0aW9uKCl7aWYoIXRoaXMuaXNQYXVzZWR8fHRoaXMuaXNGaW5pc2hlZClyZXR1cm4gITE7dmFyIGU9dGhpcy5pc1BhdXNlZD0hMTtyZXR1cm4gdGhpcy5nZW5lcmF0ZWRFcnJvciYmKHRoaXMuZXJyb3IodGhpcy5nZW5lcmF0ZWRFcnJvciksZT0hMCksdGhpcy5wcmV2aW91cyYmdGhpcy5wcmV2aW91cy5yZXN1bWUoKSwhZX0sZmx1c2g6ZnVuY3Rpb24oKXt9LHByb2Nlc3NDaHVuazpmdW5jdGlvbihlKXt0aGlzLnB1c2goZSk7fSx3aXRoU3RyZWFtSW5mbzpmdW5jdGlvbihlLHQpe3JldHVybiB0aGlzLmV4dHJhU3RyZWFtSW5mb1tlXT10LHRoaXMubWVyZ2VTdHJlYW1JbmZvKCksdGhpc30sbWVyZ2VTdHJlYW1JbmZvOmZ1bmN0aW9uKCl7Zm9yKHZhciBlIGluIHRoaXMuZXh0cmFTdHJlYW1JbmZvKXRoaXMuZXh0cmFTdHJlYW1JbmZvLmhhc093blByb3BlcnR5KGUpJiYodGhpcy5zdHJlYW1JbmZvW2VdPXRoaXMuZXh0cmFTdHJlYW1JbmZvW2VdKTt9LGxvY2s6ZnVuY3Rpb24oKXtpZih0aGlzLmlzTG9ja2VkKXRocm93IG5ldyBFcnJvcigiVGhlIHN0cmVhbSAnIit0aGlzKyInIGhhcyBhbHJlYWR5IGJlZW4gdXNlZC4iKTt0aGlzLmlzTG9ja2VkPSEwLHRoaXMucHJldmlvdXMmJnRoaXMucHJldmlvdXMubG9jaygpO30sdG9TdHJpbmc6ZnVuY3Rpb24oKXt2YXIgZT0iV29ya2VyICIrdGhpcy5uYW1lO3JldHVybiB0aGlzLnByZXZpb3VzP3RoaXMucHJldmlvdXMrIiAtPiAiK2U6ZX19LHQuZXhwb3J0cz1uO30se31dLDI5OltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi4vdXRpbHMiKSxhPWUoIi4vQ29udmVydFdvcmtlciIpLGk9ZSgiLi9HZW5lcmljV29ya2VyIikscz1lKCIuLi9iYXNlNjQiKSxvPWUoIi4uL3N1cHBvcnQiKSx1PWUoIi4uL2V4dGVybmFsIiksbD1udWxsO2lmKG8ubm9kZXN0cmVhbSl0cnl7bD1lKCIuLi9ub2RlanMvTm9kZWpzU3RyZWFtT3V0cHV0QWRhcHRlciIpO31jYXRjaChlKXt9ZnVuY3Rpb24gYyhlLHQscil7dmFyIHM9dDtzd2l0Y2godCl7Y2FzZSJibG9iIjpjYXNlImFycmF5YnVmZmVyIjpzPSJ1aW50OGFycmF5IjticmVhaztjYXNlImJhc2U2NCI6cz0ic3RyaW5nIjt9dHJ5e3RoaXMuX2ludGVybmFsVHlwZT1zLHRoaXMuX291dHB1dFR5cGU9dCx0aGlzLl9taW1lVHlwZT1yLG4uY2hlY2tTdXBwb3J0KHMpLHRoaXMuX3dvcmtlcj1lLnBpcGUobmV3IGEocykpLGUubG9jaygpO31jYXRjaChlKXt0aGlzLl93b3JrZXI9bmV3IGkoImVycm9yIiksdGhpcy5fd29ya2VyLmVycm9yKGUpO319Yy5wcm90b3R5cGU9e2FjY3VtdWxhdGU6ZnVuY3Rpb24oZSl7cmV0dXJuIGZ1bmN0aW9uKGUsdCl7cmV0dXJuIG5ldyB1LlByb21pc2UoKGZ1bmN0aW9uKHIsYSl7dmFyIGk9W10sbz1lLl9pbnRlcm5hbFR5cGUsdT1lLl9vdXRwdXRUeXBlLGw9ZS5fbWltZVR5cGU7ZS5vbigiZGF0YSIsKGZ1bmN0aW9uKGUscil7aS5wdXNoKGUpLHQmJnQocik7fSkpLm9uKCJlcnJvciIsKGZ1bmN0aW9uKGUpe2k9W10sYShlKTt9KSkub24oImVuZCIsKGZ1bmN0aW9uKCl7dHJ5e3ZhciBlPWZ1bmN0aW9uKGUsdCxyKXtzd2l0Y2goZSl7Y2FzZSJibG9iIjpyZXR1cm4gbi5uZXdCbG9iKG4udHJhbnNmb3JtVG8oImFycmF5YnVmZmVyIix0KSxyKTtjYXNlImJhc2U2NCI6cmV0dXJuIHMuZW5jb2RlKHQpO2RlZmF1bHQ6cmV0dXJuIG4udHJhbnNmb3JtVG8oZSx0KX19KHUsZnVuY3Rpb24oZSx0KXt2YXIgcixuPTAsYT1udWxsLGk9MDtmb3Iocj0wO3I8dC5sZW5ndGg7cisrKWkrPXRbcl0ubGVuZ3RoO3N3aXRjaChlKXtjYXNlInN0cmluZyI6cmV0dXJuIHQuam9pbigiIik7Y2FzZSJhcnJheSI6cmV0dXJuIEFycmF5LnByb3RvdHlwZS5jb25jYXQuYXBwbHkoW10sdCk7Y2FzZSJ1aW50OGFycmF5Ijpmb3IoYT1uZXcgVWludDhBcnJheShpKSxyPTA7cjx0Lmxlbmd0aDtyKyspYS5zZXQodFtyXSxuKSxuKz10W3JdLmxlbmd0aDtyZXR1cm4gYTtjYXNlIm5vZGVidWZmZXIiOnJldHVybiBCdWZmZXIuY29uY2F0KHQpO2RlZmF1bHQ6dGhyb3cgbmV3IEVycm9yKCJjb25jYXQgOiB1bnN1cHBvcnRlZCB0eXBlICciK2UrIiciKX19KG8saSksbCk7cihlKTt9Y2F0Y2goZSl7YShlKTt9aT1bXTt9KSkucmVzdW1lKCk7fSkpfSh0aGlzLGUpfSxvbjpmdW5jdGlvbihlLHQpe3ZhciByPXRoaXM7cmV0dXJuICJkYXRhIj09PWU/dGhpcy5fd29ya2VyLm9uKGUsKGZ1bmN0aW9uKGUpe3QuY2FsbChyLGUuZGF0YSxlLm1ldGEpO30pKTp0aGlzLl93b3JrZXIub24oZSwoZnVuY3Rpb24oKXtuLmRlbGF5KHQsYXJndW1lbnRzLHIpO30pKSx0aGlzfSxyZXN1bWU6ZnVuY3Rpb24oKXtyZXR1cm4gbi5kZWxheSh0aGlzLl93b3JrZXIucmVzdW1lLFtdLHRoaXMuX3dvcmtlciksdGhpc30scGF1c2U6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fd29ya2VyLnBhdXNlKCksdGhpc30sdG9Ob2RlanNTdHJlYW06ZnVuY3Rpb24oZSl7aWYobi5jaGVja1N1cHBvcnQoIm5vZGVzdHJlYW0iKSwibm9kZWJ1ZmZlciIhPT10aGlzLl9vdXRwdXRUeXBlKXRocm93IG5ldyBFcnJvcih0aGlzLl9vdXRwdXRUeXBlKyIgaXMgbm90IHN1cHBvcnRlZCBieSB0aGlzIG1ldGhvZCIpO3JldHVybiBuZXcgbCh0aGlzLHtvYmplY3RNb2RlOiJub2RlYnVmZmVyIiE9PXRoaXMuX291dHB1dFR5cGV9LGUpfX0sdC5leHBvcnRzPWM7fSx7Ii4uL2Jhc2U2NCI6MSwiLi4vZXh0ZXJuYWwiOjYsIi4uL25vZGVqcy9Ob2RlanNTdHJlYW1PdXRwdXRBZGFwdGVyIjoxMywiLi4vc3VwcG9ydCI6MzAsIi4uL3V0aWxzIjozMiwiLi9Db252ZXJ0V29ya2VyIjoyNCwiLi9HZW5lcmljV29ya2VyIjoyOH1dLDMwOltmdW5jdGlvbihlLHQscil7aWYoci5iYXNlNjQ9ITAsci5hcnJheT0hMCxyLnN0cmluZz0hMCxyLmFycmF5YnVmZmVyPSJ1bmRlZmluZWQiIT10eXBlb2YgQXJyYXlCdWZmZXImJiJ1bmRlZmluZWQiIT10eXBlb2YgVWludDhBcnJheSxyLm5vZGVidWZmZXI9InVuZGVmaW5lZCIhPXR5cGVvZiBCdWZmZXIsci51aW50OGFycmF5PSJ1bmRlZmluZWQiIT10eXBlb2YgVWludDhBcnJheSwidW5kZWZpbmVkIj09dHlwZW9mIEFycmF5QnVmZmVyKXIuYmxvYj0hMTtlbHNlIHt2YXIgbj1uZXcgQXJyYXlCdWZmZXIoMCk7dHJ5e3IuYmxvYj0wPT09bmV3IEJsb2IoW25dLHt0eXBlOiJhcHBsaWNhdGlvbi96aXAifSkuc2l6ZTt9Y2F0Y2goZSl7dHJ5e3ZhciBhPW5ldyhzZWxmLkJsb2JCdWlsZGVyfHxzZWxmLldlYktpdEJsb2JCdWlsZGVyfHxzZWxmLk1vekJsb2JCdWlsZGVyfHxzZWxmLk1TQmxvYkJ1aWxkZXIpO2EuYXBwZW5kKG4pLHIuYmxvYj0wPT09YS5nZXRCbG9iKCJhcHBsaWNhdGlvbi96aXAiKS5zaXplO31jYXRjaChlKXtyLmJsb2I9ITE7fX19dHJ5e3Iubm9kZXN0cmVhbT0hIWUoInJlYWRhYmxlLXN0cmVhbSIpLlJlYWRhYmxlO31jYXRjaChlKXtyLm5vZGVzdHJlYW09ITE7fX0seyJyZWFkYWJsZS1zdHJlYW0iOjE2fV0sMzE6W2Z1bmN0aW9uKGUsdCxyKXtmb3IodmFyIG49ZSgiLi91dGlscyIpLGE9ZSgiLi9zdXBwb3J0IiksaT1lKCIuL25vZGVqc1V0aWxzIikscz1lKCIuL3N0cmVhbS9HZW5lcmljV29ya2VyIiksbz1uZXcgQXJyYXkoMjU2KSx1PTA7dTwyNTY7dSsrKW9bdV09MjUyPD11PzY6MjQ4PD11PzU6MjQwPD11PzQ6MjI0PD11PzM6MTkyPD11PzI6MTtmdW5jdGlvbiBsKCl7cy5jYWxsKHRoaXMsInV0Zi04IGRlY29kZSIpLHRoaXMubGVmdE92ZXI9bnVsbDt9ZnVuY3Rpb24gYygpe3MuY2FsbCh0aGlzLCJ1dGYtOCBlbmNvZGUiKTt9b1syNTRdPW9bMjU0XT0xLHIudXRmOGVuY29kZT1mdW5jdGlvbihlKXtyZXR1cm4gYS5ub2RlYnVmZmVyP2kubmV3QnVmZmVyRnJvbShlLCJ1dGYtOCIpOmZ1bmN0aW9uKGUpe3ZhciB0LHIsbixpLHMsbz1lLmxlbmd0aCx1PTA7Zm9yKGk9MDtpPG87aSsrKTU1Mjk2PT0oNjQ1MTImKHI9ZS5jaGFyQ29kZUF0KGkpKSkmJmkrMTxvJiY1NjMyMD09KDY0NTEyJihuPWUuY2hhckNvZGVBdChpKzEpKSkmJihyPTY1NTM2KyhyLTU1Mjk2PDwxMCkrKG4tNTYzMjApLGkrKyksdSs9cjwxMjg/MTpyPDIwNDg/MjpyPDY1NTM2PzM6NDtmb3IodD1hLnVpbnQ4YXJyYXk/bmV3IFVpbnQ4QXJyYXkodSk6bmV3IEFycmF5KHUpLGk9cz0wO3M8dTtpKyspNTUyOTY9PSg2NDUxMiYocj1lLmNoYXJDb2RlQXQoaSkpKSYmaSsxPG8mJjU2MzIwPT0oNjQ1MTImKG49ZS5jaGFyQ29kZUF0KGkrMSkpKSYmKHI9NjU1MzYrKHItNTUyOTY8PDEwKSsobi01NjMyMCksaSsrKSxyPDEyOD90W3MrK109cjoocjwyMDQ4P3RbcysrXT0xOTJ8cj4+PjY6KHI8NjU1MzY/dFtzKytdPTIyNHxyPj4+MTI6KHRbcysrXT0yNDB8cj4+PjE4LHRbcysrXT0xMjh8cj4+PjEyJjYzKSx0W3MrK109MTI4fHI+Pj42JjYzKSx0W3MrK109MTI4fDYzJnIpO3JldHVybiB0fShlKX0sci51dGY4ZGVjb2RlPWZ1bmN0aW9uKGUpe3JldHVybiBhLm5vZGVidWZmZXI/bi50cmFuc2Zvcm1Ubygibm9kZWJ1ZmZlciIsZSkudG9TdHJpbmcoInV0Zi04Iik6ZnVuY3Rpb24oZSl7dmFyIHQscixhLGkscz1lLmxlbmd0aCx1PW5ldyBBcnJheSgyKnMpO2Zvcih0PXI9MDt0PHM7KWlmKChhPWVbdCsrXSk8MTI4KXVbcisrXT1hO2Vsc2UgaWYoNDwoaT1vW2FdKSl1W3IrK109NjU1MzMsdCs9aS0xO2Vsc2Uge2ZvcihhJj0yPT09aT8zMTozPT09aT8xNTo3OzE8aSYmdDxzOylhPWE8PDZ8NjMmZVt0KytdLGktLTsxPGk/dVtyKytdPTY1NTMzOmE8NjU1MzY/dVtyKytdPWE6KGEtPTY1NTM2LHVbcisrXT01NTI5NnxhPj4xMCYxMDIzLHVbcisrXT01NjMyMHwxMDIzJmEpO31yZXR1cm4gdS5sZW5ndGghPT1yJiYodS5zdWJhcnJheT91PXUuc3ViYXJyYXkoMCxyKTp1Lmxlbmd0aD1yKSxuLmFwcGx5RnJvbUNoYXJDb2RlKHUpfShlPW4udHJhbnNmb3JtVG8oYS51aW50OGFycmF5PyJ1aW50OGFycmF5IjoiYXJyYXkiLGUpKX0sbi5pbmhlcml0cyhsLHMpLGwucHJvdG90eXBlLnByb2Nlc3NDaHVuaz1mdW5jdGlvbihlKXt2YXIgdD1uLnRyYW5zZm9ybVRvKGEudWludDhhcnJheT8idWludDhhcnJheSI6ImFycmF5IixlLmRhdGEpO2lmKHRoaXMubGVmdE92ZXImJnRoaXMubGVmdE92ZXIubGVuZ3RoKXtpZihhLnVpbnQ4YXJyYXkpe3ZhciBpPXQ7KHQ9bmV3IFVpbnQ4QXJyYXkoaS5sZW5ndGgrdGhpcy5sZWZ0T3Zlci5sZW5ndGgpKS5zZXQodGhpcy5sZWZ0T3ZlciwwKSx0LnNldChpLHRoaXMubGVmdE92ZXIubGVuZ3RoKTt9ZWxzZSB0PXRoaXMubGVmdE92ZXIuY29uY2F0KHQpO3RoaXMubGVmdE92ZXI9bnVsbDt9dmFyIHM9ZnVuY3Rpb24oZSx0KXt2YXIgcjtmb3IoKHQ9dHx8ZS5sZW5ndGgpPmUubGVuZ3RoJiYodD1lLmxlbmd0aCkscj10LTE7MDw9ciYmMTI4PT0oMTkyJmVbcl0pOylyLS07cmV0dXJuIHI8MD90OjA9PT1yP3Q6citvW2Vbcl1dPnQ/cjp0fSh0KSx1PXQ7cyE9PXQubGVuZ3RoJiYoYS51aW50OGFycmF5Pyh1PXQuc3ViYXJyYXkoMCxzKSx0aGlzLmxlZnRPdmVyPXQuc3ViYXJyYXkocyx0Lmxlbmd0aCkpOih1PXQuc2xpY2UoMCxzKSx0aGlzLmxlZnRPdmVyPXQuc2xpY2Uocyx0Lmxlbmd0aCkpKSx0aGlzLnB1c2goe2RhdGE6ci51dGY4ZGVjb2RlKHUpLG1ldGE6ZS5tZXRhfSk7fSxsLnByb3RvdHlwZS5mbHVzaD1mdW5jdGlvbigpe3RoaXMubGVmdE92ZXImJnRoaXMubGVmdE92ZXIubGVuZ3RoJiYodGhpcy5wdXNoKHtkYXRhOnIudXRmOGRlY29kZSh0aGlzLmxlZnRPdmVyKSxtZXRhOnt9fSksdGhpcy5sZWZ0T3Zlcj1udWxsKTt9LHIuVXRmOERlY29kZVdvcmtlcj1sLG4uaW5oZXJpdHMoYyxzKSxjLnByb3RvdHlwZS5wcm9jZXNzQ2h1bms9ZnVuY3Rpb24oZSl7dGhpcy5wdXNoKHtkYXRhOnIudXRmOGVuY29kZShlLmRhdGEpLG1ldGE6ZS5tZXRhfSk7fSxyLlV0ZjhFbmNvZGVXb3JrZXI9Yzt9LHsiLi9ub2RlanNVdGlscyI6MTQsIi4vc3RyZWFtL0dlbmVyaWNXb3JrZXIiOjI4LCIuL3N1cHBvcnQiOjMwLCIuL3V0aWxzIjozMn1dLDMyOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi9zdXBwb3J0IiksYT1lKCIuL2Jhc2U2NCIpLGk9ZSgiLi9ub2RlanNVdGlscyIpLHM9ZSgic2V0LWltbWVkaWF0ZS1zaGltIiksbz1lKCIuL2V4dGVybmFsIik7ZnVuY3Rpb24gdShlKXtyZXR1cm4gZX1mdW5jdGlvbiBsKGUsdCl7Zm9yKHZhciByPTA7cjxlLmxlbmd0aDsrK3IpdFtyXT0yNTUmZS5jaGFyQ29kZUF0KHIpO3JldHVybiB0fXIubmV3QmxvYj1mdW5jdGlvbihlLHQpe3IuY2hlY2tTdXBwb3J0KCJibG9iIik7dHJ5e3JldHVybiBuZXcgQmxvYihbZV0se3R5cGU6dH0pfWNhdGNoKHIpe3RyeXt2YXIgbj1uZXcoc2VsZi5CbG9iQnVpbGRlcnx8c2VsZi5XZWJLaXRCbG9iQnVpbGRlcnx8c2VsZi5Nb3pCbG9iQnVpbGRlcnx8c2VsZi5NU0Jsb2JCdWlsZGVyKTtyZXR1cm4gbi5hcHBlbmQoZSksbi5nZXRCbG9iKHQpfWNhdGNoKGUpe3Rocm93IG5ldyBFcnJvcigiQnVnIDogY2FuJ3QgY29uc3RydWN0IHRoZSBCbG9iLiIpfX19O3ZhciBjPXtzdHJpbmdpZnlCeUNodW5rOmZ1bmN0aW9uKGUsdCxyKXt2YXIgbj1bXSxhPTAsaT1lLmxlbmd0aDtpZihpPD1yKXJldHVybiBTdHJpbmcuZnJvbUNoYXJDb2RlLmFwcGx5KG51bGwsZSk7Zm9yKDthPGk7KSJhcnJheSI9PT10fHwibm9kZWJ1ZmZlciI9PT10P24ucHVzaChTdHJpbmcuZnJvbUNoYXJDb2RlLmFwcGx5KG51bGwsZS5zbGljZShhLE1hdGgubWluKGErcixpKSkpKTpuLnB1c2goU3RyaW5nLmZyb21DaGFyQ29kZS5hcHBseShudWxsLGUuc3ViYXJyYXkoYSxNYXRoLm1pbihhK3IsaSkpKSksYSs9cjtyZXR1cm4gbi5qb2luKCIiKX0sc3RyaW5naWZ5QnlDaGFyOmZ1bmN0aW9uKGUpe2Zvcih2YXIgdD0iIixyPTA7cjxlLmxlbmd0aDtyKyspdCs9U3RyaW5nLmZyb21DaGFyQ29kZShlW3JdKTtyZXR1cm4gdH0sYXBwbHlDYW5CZVVzZWQ6e3VpbnQ4YXJyYXk6ZnVuY3Rpb24oKXt0cnl7cmV0dXJuIG4udWludDhhcnJheSYmMT09PVN0cmluZy5mcm9tQ2hhckNvZGUuYXBwbHkobnVsbCxuZXcgVWludDhBcnJheSgxKSkubGVuZ3RofWNhdGNoKGUpe3JldHVybiAhMX19KCksbm9kZWJ1ZmZlcjpmdW5jdGlvbigpe3RyeXtyZXR1cm4gbi5ub2RlYnVmZmVyJiYxPT09U3RyaW5nLmZyb21DaGFyQ29kZS5hcHBseShudWxsLGkuYWxsb2NCdWZmZXIoMSkpLmxlbmd0aH1jYXRjaChlKXtyZXR1cm4gITF9fSgpfX07ZnVuY3Rpb24gaChlKXt2YXIgdD02NTUzNixuPXIuZ2V0VHlwZU9mKGUpLGE9ITA7aWYoInVpbnQ4YXJyYXkiPT09bj9hPWMuYXBwbHlDYW5CZVVzZWQudWludDhhcnJheToibm9kZWJ1ZmZlciI9PT1uJiYoYT1jLmFwcGx5Q2FuQmVVc2VkLm5vZGVidWZmZXIpLGEpZm9yKDsxPHQ7KXRyeXtyZXR1cm4gYy5zdHJpbmdpZnlCeUNodW5rKGUsbix0KX1jYXRjaChlKXt0PU1hdGguZmxvb3IodC8yKTt9cmV0dXJuIGMuc3RyaW5naWZ5QnlDaGFyKGUpfWZ1bmN0aW9uIGQoZSx0KXtmb3IodmFyIHI9MDtyPGUubGVuZ3RoO3IrKyl0W3JdPWVbcl07cmV0dXJuIHR9ci5hcHBseUZyb21DaGFyQ29kZT1oO3ZhciBmPXt9O2Yuc3RyaW5nPXtzdHJpbmc6dSxhcnJheTpmdW5jdGlvbihlKXtyZXR1cm4gbChlLG5ldyBBcnJheShlLmxlbmd0aCkpfSxhcnJheWJ1ZmZlcjpmdW5jdGlvbihlKXtyZXR1cm4gZi5zdHJpbmcudWludDhhcnJheShlKS5idWZmZXJ9LHVpbnQ4YXJyYXk6ZnVuY3Rpb24oZSl7cmV0dXJuIGwoZSxuZXcgVWludDhBcnJheShlLmxlbmd0aCkpfSxub2RlYnVmZmVyOmZ1bmN0aW9uKGUpe3JldHVybiBsKGUsaS5hbGxvY0J1ZmZlcihlLmxlbmd0aCkpfX0sZi5hcnJheT17c3RyaW5nOmgsYXJyYXk6dSxhcnJheWJ1ZmZlcjpmdW5jdGlvbihlKXtyZXR1cm4gbmV3IFVpbnQ4QXJyYXkoZSkuYnVmZmVyfSx1aW50OGFycmF5OmZ1bmN0aW9uKGUpe3JldHVybiBuZXcgVWludDhBcnJheShlKX0sbm9kZWJ1ZmZlcjpmdW5jdGlvbihlKXtyZXR1cm4gaS5uZXdCdWZmZXJGcm9tKGUpfX0sZi5hcnJheWJ1ZmZlcj17c3RyaW5nOmZ1bmN0aW9uKGUpe3JldHVybiBoKG5ldyBVaW50OEFycmF5KGUpKX0sYXJyYXk6ZnVuY3Rpb24oZSl7cmV0dXJuIGQobmV3IFVpbnQ4QXJyYXkoZSksbmV3IEFycmF5KGUuYnl0ZUxlbmd0aCkpfSxhcnJheWJ1ZmZlcjp1LHVpbnQ4YXJyYXk6ZnVuY3Rpb24oZSl7cmV0dXJuIG5ldyBVaW50OEFycmF5KGUpfSxub2RlYnVmZmVyOmZ1bmN0aW9uKGUpe3JldHVybiBpLm5ld0J1ZmZlckZyb20obmV3IFVpbnQ4QXJyYXkoZSkpfX0sZi51aW50OGFycmF5PXtzdHJpbmc6aCxhcnJheTpmdW5jdGlvbihlKXtyZXR1cm4gZChlLG5ldyBBcnJheShlLmxlbmd0aCkpfSxhcnJheWJ1ZmZlcjpmdW5jdGlvbihlKXtyZXR1cm4gZS5idWZmZXJ9LHVpbnQ4YXJyYXk6dSxub2RlYnVmZmVyOmZ1bmN0aW9uKGUpe3JldHVybiBpLm5ld0J1ZmZlckZyb20oZSl9fSxmLm5vZGVidWZmZXI9e3N0cmluZzpoLGFycmF5OmZ1bmN0aW9uKGUpe3JldHVybiBkKGUsbmV3IEFycmF5KGUubGVuZ3RoKSl9LGFycmF5YnVmZmVyOmZ1bmN0aW9uKGUpe3JldHVybiBmLm5vZGVidWZmZXIudWludDhhcnJheShlKS5idWZmZXJ9LHVpbnQ4YXJyYXk6ZnVuY3Rpb24oZSl7cmV0dXJuIGQoZSxuZXcgVWludDhBcnJheShlLmxlbmd0aCkpfSxub2RlYnVmZmVyOnV9LHIudHJhbnNmb3JtVG89ZnVuY3Rpb24oZSx0KXtpZih0PXR8fCIiLCFlKXJldHVybiB0O3IuY2hlY2tTdXBwb3J0KGUpO3ZhciBuPXIuZ2V0VHlwZU9mKHQpO3JldHVybiBmW25dW2VdKHQpfSxyLmdldFR5cGVPZj1mdW5jdGlvbihlKXtyZXR1cm4gInN0cmluZyI9PXR5cGVvZiBlPyJzdHJpbmciOiJbb2JqZWN0IEFycmF5XSI9PT1PYmplY3QucHJvdG90eXBlLnRvU3RyaW5nLmNhbGwoZSk/ImFycmF5IjpuLm5vZGVidWZmZXImJmkuaXNCdWZmZXIoZSk/Im5vZGVidWZmZXIiOm4udWludDhhcnJheSYmZSBpbnN0YW5jZW9mIFVpbnQ4QXJyYXk/InVpbnQ4YXJyYXkiOm4uYXJyYXlidWZmZXImJmUgaW5zdGFuY2VvZiBBcnJheUJ1ZmZlcj8iYXJyYXlidWZmZXIiOnZvaWQgMH0sci5jaGVja1N1cHBvcnQ9ZnVuY3Rpb24oZSl7aWYoIW5bZS50b0xvd2VyQ2FzZSgpXSl0aHJvdyBuZXcgRXJyb3IoZSsiIGlzIG5vdCBzdXBwb3J0ZWQgYnkgdGhpcyBwbGF0Zm9ybSIpfSxyLk1BWF9WQUxVRV8xNkJJVFM9NjU1MzUsci5NQVhfVkFMVUVfMzJCSVRTPS0xLHIucHJldHR5PWZ1bmN0aW9uKGUpe3ZhciB0LHIsbj0iIjtmb3Iocj0wO3I8KGV8fCIiKS5sZW5ndGg7cisrKW4rPSJcXHgiKygodD1lLmNoYXJDb2RlQXQocikpPDE2PyIwIjoiIikrdC50b1N0cmluZygxNikudG9VcHBlckNhc2UoKTtyZXR1cm4gbn0sci5kZWxheT1mdW5jdGlvbihlLHQscil7cygoZnVuY3Rpb24oKXtlLmFwcGx5KHJ8fG51bGwsdHx8W10pO30pKTt9LHIuaW5oZXJpdHM9ZnVuY3Rpb24oZSx0KXtmdW5jdGlvbiByKCl7fXIucHJvdG90eXBlPXQucHJvdG90eXBlLGUucHJvdG90eXBlPW5ldyByO30sci5leHRlbmQ9ZnVuY3Rpb24oKXt2YXIgZSx0LHI9e307Zm9yKGU9MDtlPGFyZ3VtZW50cy5sZW5ndGg7ZSsrKWZvcih0IGluIGFyZ3VtZW50c1tlXSlhcmd1bWVudHNbZV0uaGFzT3duUHJvcGVydHkodCkmJnZvaWQgMD09PXJbdF0mJihyW3RdPWFyZ3VtZW50c1tlXVt0XSk7cmV0dXJuIHJ9LHIucHJlcGFyZUNvbnRlbnQ9ZnVuY3Rpb24oZSx0LGkscyx1KXtyZXR1cm4gby5Qcm9taXNlLnJlc29sdmUodCkudGhlbigoZnVuY3Rpb24oZSl7cmV0dXJuIG4uYmxvYiYmKGUgaW5zdGFuY2VvZiBCbG9ifHwtMSE9PVsiW29iamVjdCBGaWxlXSIsIltvYmplY3QgQmxvYl0iXS5pbmRleE9mKE9iamVjdC5wcm90b3R5cGUudG9TdHJpbmcuY2FsbChlKSkpJiYidW5kZWZpbmVkIiE9dHlwZW9mIEZpbGVSZWFkZXI/bmV3IG8uUHJvbWlzZSgoZnVuY3Rpb24odCxyKXt2YXIgbj1uZXcgRmlsZVJlYWRlcjtuLm9ubG9hZD1mdW5jdGlvbihlKXt0KGUudGFyZ2V0LnJlc3VsdCk7fSxuLm9uZXJyb3I9ZnVuY3Rpb24oZSl7cihlLnRhcmdldC5lcnJvcik7fSxuLnJlYWRBc0FycmF5QnVmZmVyKGUpO30pKTplfSkpLnRoZW4oKGZ1bmN0aW9uKHQpe3ZhciBjPXIuZ2V0VHlwZU9mKHQpO3JldHVybiBjPygiYXJyYXlidWZmZXIiPT09Yz90PXIudHJhbnNmb3JtVG8oInVpbnQ4YXJyYXkiLHQpOiJzdHJpbmciPT09YyYmKHU/dD1hLmRlY29kZSh0KTppJiYhMCE9PXMmJih0PWZ1bmN0aW9uKGUpe3JldHVybiBsKGUsbi51aW50OGFycmF5P25ldyBVaW50OEFycmF5KGUubGVuZ3RoKTpuZXcgQXJyYXkoZS5sZW5ndGgpKX0odCkpKSx0KTpvLlByb21pc2UucmVqZWN0KG5ldyBFcnJvcigiQ2FuJ3QgcmVhZCB0aGUgZGF0YSBvZiAnIitlKyInLiBJcyBpdCBpbiBhIHN1cHBvcnRlZCBKYXZhU2NyaXB0IHR5cGUgKFN0cmluZywgQmxvYiwgQXJyYXlCdWZmZXIsIGV0YykgPyIpKX0pKX07fSx7Ii4vYmFzZTY0IjoxLCIuL2V4dGVybmFsIjo2LCIuL25vZGVqc1V0aWxzIjoxNCwiLi9zdXBwb3J0IjozMCwic2V0LWltbWVkaWF0ZS1zaGltIjo1NH1dLDMzOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi9yZWFkZXIvcmVhZGVyRm9yIiksYT1lKCIuL3V0aWxzIiksaT1lKCIuL3NpZ25hdHVyZSIpLHM9ZSgiLi96aXBFbnRyeSIpLG89KGUoIi4vdXRmOCIpLGUoIi4vc3VwcG9ydCIpKTtmdW5jdGlvbiB1KGUpe3RoaXMuZmlsZXM9W10sdGhpcy5sb2FkT3B0aW9ucz1lO311LnByb3RvdHlwZT17Y2hlY2tTaWduYXR1cmU6ZnVuY3Rpb24oZSl7aWYoIXRoaXMucmVhZGVyLnJlYWRBbmRDaGVja1NpZ25hdHVyZShlKSl7dGhpcy5yZWFkZXIuaW5kZXgtPTQ7dmFyIHQ9dGhpcy5yZWFkZXIucmVhZFN0cmluZyg0KTt0aHJvdyBuZXcgRXJyb3IoIkNvcnJ1cHRlZCB6aXAgb3IgYnVnOiB1bmV4cGVjdGVkIHNpZ25hdHVyZSAoIithLnByZXR0eSh0KSsiLCBleHBlY3RlZCAiK2EucHJldHR5KGUpKyIpIil9fSxpc1NpZ25hdHVyZTpmdW5jdGlvbihlLHQpe3ZhciByPXRoaXMucmVhZGVyLmluZGV4O3RoaXMucmVhZGVyLnNldEluZGV4KGUpO3ZhciBuPXRoaXMucmVhZGVyLnJlYWRTdHJpbmcoNCk9PT10O3JldHVybiB0aGlzLnJlYWRlci5zZXRJbmRleChyKSxufSxyZWFkQmxvY2tFbmRPZkNlbnRyYWw6ZnVuY3Rpb24oKXt0aGlzLmRpc2tOdW1iZXI9dGhpcy5yZWFkZXIucmVhZEludCgyKSx0aGlzLmRpc2tXaXRoQ2VudHJhbERpclN0YXJ0PXRoaXMucmVhZGVyLnJlYWRJbnQoMiksdGhpcy5jZW50cmFsRGlyUmVjb3Jkc09uVGhpc0Rpc2s9dGhpcy5yZWFkZXIucmVhZEludCgyKSx0aGlzLmNlbnRyYWxEaXJSZWNvcmRzPXRoaXMucmVhZGVyLnJlYWRJbnQoMiksdGhpcy5jZW50cmFsRGlyU2l6ZT10aGlzLnJlYWRlci5yZWFkSW50KDQpLHRoaXMuY2VudHJhbERpck9mZnNldD10aGlzLnJlYWRlci5yZWFkSW50KDQpLHRoaXMuemlwQ29tbWVudExlbmd0aD10aGlzLnJlYWRlci5yZWFkSW50KDIpO3ZhciBlPXRoaXMucmVhZGVyLnJlYWREYXRhKHRoaXMuemlwQ29tbWVudExlbmd0aCksdD1vLnVpbnQ4YXJyYXk/InVpbnQ4YXJyYXkiOiJhcnJheSIscj1hLnRyYW5zZm9ybVRvKHQsZSk7dGhpcy56aXBDb21tZW50PXRoaXMubG9hZE9wdGlvbnMuZGVjb2RlRmlsZU5hbWUocik7fSxyZWFkQmxvY2taaXA2NEVuZE9mQ2VudHJhbDpmdW5jdGlvbigpe3RoaXMuemlwNjRFbmRPZkNlbnRyYWxTaXplPXRoaXMucmVhZGVyLnJlYWRJbnQoOCksdGhpcy5yZWFkZXIuc2tpcCg0KSx0aGlzLmRpc2tOdW1iZXI9dGhpcy5yZWFkZXIucmVhZEludCg0KSx0aGlzLmRpc2tXaXRoQ2VudHJhbERpclN0YXJ0PXRoaXMucmVhZGVyLnJlYWRJbnQoNCksdGhpcy5jZW50cmFsRGlyUmVjb3Jkc09uVGhpc0Rpc2s9dGhpcy5yZWFkZXIucmVhZEludCg4KSx0aGlzLmNlbnRyYWxEaXJSZWNvcmRzPXRoaXMucmVhZGVyLnJlYWRJbnQoOCksdGhpcy5jZW50cmFsRGlyU2l6ZT10aGlzLnJlYWRlci5yZWFkSW50KDgpLHRoaXMuY2VudHJhbERpck9mZnNldD10aGlzLnJlYWRlci5yZWFkSW50KDgpLHRoaXMuemlwNjRFeHRlbnNpYmxlRGF0YT17fTtmb3IodmFyIGUsdCxyLG49dGhpcy56aXA2NEVuZE9mQ2VudHJhbFNpemUtNDQ7MDxuOyllPXRoaXMucmVhZGVyLnJlYWRJbnQoMiksdD10aGlzLnJlYWRlci5yZWFkSW50KDQpLHI9dGhpcy5yZWFkZXIucmVhZERhdGEodCksdGhpcy56aXA2NEV4dGVuc2libGVEYXRhW2VdPXtpZDplLGxlbmd0aDp0LHZhbHVlOnJ9O30scmVhZEJsb2NrWmlwNjRFbmRPZkNlbnRyYWxMb2NhdG9yOmZ1bmN0aW9uKCl7aWYodGhpcy5kaXNrV2l0aFppcDY0Q2VudHJhbERpclN0YXJ0PXRoaXMucmVhZGVyLnJlYWRJbnQoNCksdGhpcy5yZWxhdGl2ZU9mZnNldEVuZE9mWmlwNjRDZW50cmFsRGlyPXRoaXMucmVhZGVyLnJlYWRJbnQoOCksdGhpcy5kaXNrc0NvdW50PXRoaXMucmVhZGVyLnJlYWRJbnQoNCksMTx0aGlzLmRpc2tzQ291bnQpdGhyb3cgbmV3IEVycm9yKCJNdWx0aS12b2x1bWVzIHppcCBhcmUgbm90IHN1cHBvcnRlZCIpfSxyZWFkTG9jYWxGaWxlczpmdW5jdGlvbigpe3ZhciBlLHQ7Zm9yKGU9MDtlPHRoaXMuZmlsZXMubGVuZ3RoO2UrKyl0PXRoaXMuZmlsZXNbZV0sdGhpcy5yZWFkZXIuc2V0SW5kZXgodC5sb2NhbEhlYWRlck9mZnNldCksdGhpcy5jaGVja1NpZ25hdHVyZShpLkxPQ0FMX0ZJTEVfSEVBREVSKSx0LnJlYWRMb2NhbFBhcnQodGhpcy5yZWFkZXIpLHQuaGFuZGxlVVRGOCgpLHQucHJvY2Vzc0F0dHJpYnV0ZXMoKTt9LHJlYWRDZW50cmFsRGlyOmZ1bmN0aW9uKCl7dmFyIGU7Zm9yKHRoaXMucmVhZGVyLnNldEluZGV4KHRoaXMuY2VudHJhbERpck9mZnNldCk7dGhpcy5yZWFkZXIucmVhZEFuZENoZWNrU2lnbmF0dXJlKGkuQ0VOVFJBTF9GSUxFX0hFQURFUik7KShlPW5ldyBzKHt6aXA2NDp0aGlzLnppcDY0fSx0aGlzLmxvYWRPcHRpb25zKSkucmVhZENlbnRyYWxQYXJ0KHRoaXMucmVhZGVyKSx0aGlzLmZpbGVzLnB1c2goZSk7aWYodGhpcy5jZW50cmFsRGlyUmVjb3JkcyE9PXRoaXMuZmlsZXMubGVuZ3RoJiYwIT09dGhpcy5jZW50cmFsRGlyUmVjb3JkcyYmMD09PXRoaXMuZmlsZXMubGVuZ3RoKXRocm93IG5ldyBFcnJvcigiQ29ycnVwdGVkIHppcCBvciBidWc6IGV4cGVjdGVkICIrdGhpcy5jZW50cmFsRGlyUmVjb3JkcysiIHJlY29yZHMgaW4gY2VudHJhbCBkaXIsIGdvdCAiK3RoaXMuZmlsZXMubGVuZ3RoKX0scmVhZEVuZE9mQ2VudHJhbDpmdW5jdGlvbigpe3ZhciBlPXRoaXMucmVhZGVyLmxhc3RJbmRleE9mU2lnbmF0dXJlKGkuQ0VOVFJBTF9ESVJFQ1RPUllfRU5EKTtpZihlPDApdGhyb3cgdGhpcy5pc1NpZ25hdHVyZSgwLGkuTE9DQUxfRklMRV9IRUFERVIpP25ldyBFcnJvcigiQ29ycnVwdGVkIHppcDogY2FuJ3QgZmluZCBlbmQgb2YgY2VudHJhbCBkaXJlY3RvcnkiKTpuZXcgRXJyb3IoIkNhbid0IGZpbmQgZW5kIG9mIGNlbnRyYWwgZGlyZWN0b3J5IDogaXMgdGhpcyBhIHppcCBmaWxlID8gSWYgaXQgaXMsIHNlZSBodHRwczovL3N0dWsuZ2l0aHViLmlvL2pzemlwL2RvY3VtZW50YXRpb24vaG93dG8vcmVhZF96aXAuaHRtbCIpO3RoaXMucmVhZGVyLnNldEluZGV4KGUpO3ZhciB0PWU7aWYodGhpcy5jaGVja1NpZ25hdHVyZShpLkNFTlRSQUxfRElSRUNUT1JZX0VORCksdGhpcy5yZWFkQmxvY2tFbmRPZkNlbnRyYWwoKSx0aGlzLmRpc2tOdW1iZXI9PT1hLk1BWF9WQUxVRV8xNkJJVFN8fHRoaXMuZGlza1dpdGhDZW50cmFsRGlyU3RhcnQ9PT1hLk1BWF9WQUxVRV8xNkJJVFN8fHRoaXMuY2VudHJhbERpclJlY29yZHNPblRoaXNEaXNrPT09YS5NQVhfVkFMVUVfMTZCSVRTfHx0aGlzLmNlbnRyYWxEaXJSZWNvcmRzPT09YS5NQVhfVkFMVUVfMTZCSVRTfHx0aGlzLmNlbnRyYWxEaXJTaXplPT09YS5NQVhfVkFMVUVfMzJCSVRTfHx0aGlzLmNlbnRyYWxEaXJPZmZzZXQ9PT1hLk1BWF9WQUxVRV8zMkJJVFMpe2lmKHRoaXMuemlwNjQ9ITAsKGU9dGhpcy5yZWFkZXIubGFzdEluZGV4T2ZTaWduYXR1cmUoaS5aSVA2NF9DRU5UUkFMX0RJUkVDVE9SWV9MT0NBVE9SKSk8MCl0aHJvdyBuZXcgRXJyb3IoIkNvcnJ1cHRlZCB6aXA6IGNhbid0IGZpbmQgdGhlIFpJUDY0IGVuZCBvZiBjZW50cmFsIGRpcmVjdG9yeSBsb2NhdG9yIik7aWYodGhpcy5yZWFkZXIuc2V0SW5kZXgoZSksdGhpcy5jaGVja1NpZ25hdHVyZShpLlpJUDY0X0NFTlRSQUxfRElSRUNUT1JZX0xPQ0FUT1IpLHRoaXMucmVhZEJsb2NrWmlwNjRFbmRPZkNlbnRyYWxMb2NhdG9yKCksIXRoaXMuaXNTaWduYXR1cmUodGhpcy5yZWxhdGl2ZU9mZnNldEVuZE9mWmlwNjRDZW50cmFsRGlyLGkuWklQNjRfQ0VOVFJBTF9ESVJFQ1RPUllfRU5EKSYmKHRoaXMucmVsYXRpdmVPZmZzZXRFbmRPZlppcDY0Q2VudHJhbERpcj10aGlzLnJlYWRlci5sYXN0SW5kZXhPZlNpZ25hdHVyZShpLlpJUDY0X0NFTlRSQUxfRElSRUNUT1JZX0VORCksdGhpcy5yZWxhdGl2ZU9mZnNldEVuZE9mWmlwNjRDZW50cmFsRGlyPDApKXRocm93IG5ldyBFcnJvcigiQ29ycnVwdGVkIHppcDogY2FuJ3QgZmluZCB0aGUgWklQNjQgZW5kIG9mIGNlbnRyYWwgZGlyZWN0b3J5Iik7dGhpcy5yZWFkZXIuc2V0SW5kZXgodGhpcy5yZWxhdGl2ZU9mZnNldEVuZE9mWmlwNjRDZW50cmFsRGlyKSx0aGlzLmNoZWNrU2lnbmF0dXJlKGkuWklQNjRfQ0VOVFJBTF9ESVJFQ1RPUllfRU5EKSx0aGlzLnJlYWRCbG9ja1ppcDY0RW5kT2ZDZW50cmFsKCk7fXZhciByPXRoaXMuY2VudHJhbERpck9mZnNldCt0aGlzLmNlbnRyYWxEaXJTaXplO3RoaXMuemlwNjQmJihyKz0yMCxyKz0xMit0aGlzLnppcDY0RW5kT2ZDZW50cmFsU2l6ZSk7dmFyIG49dC1yO2lmKDA8bil0aGlzLmlzU2lnbmF0dXJlKHQsaS5DRU5UUkFMX0ZJTEVfSEVBREVSKXx8KHRoaXMucmVhZGVyLnplcm89bik7ZWxzZSBpZihuPDApdGhyb3cgbmV3IEVycm9yKCJDb3JydXB0ZWQgemlwOiBtaXNzaW5nICIrTWF0aC5hYnMobikrIiBieXRlcy4iKX0scHJlcGFyZVJlYWRlcjpmdW5jdGlvbihlKXt0aGlzLnJlYWRlcj1uKGUpO30sbG9hZDpmdW5jdGlvbihlKXt0aGlzLnByZXBhcmVSZWFkZXIoZSksdGhpcy5yZWFkRW5kT2ZDZW50cmFsKCksdGhpcy5yZWFkQ2VudHJhbERpcigpLHRoaXMucmVhZExvY2FsRmlsZXMoKTt9fSx0LmV4cG9ydHM9dTt9LHsiLi9yZWFkZXIvcmVhZGVyRm9yIjoyMiwiLi9zaWduYXR1cmUiOjIzLCIuL3N1cHBvcnQiOjMwLCIuL3V0ZjgiOjMxLCIuL3V0aWxzIjozMiwiLi96aXBFbnRyeSI6MzR9XSwzNDpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoIi4vcmVhZGVyL3JlYWRlckZvciIpLGE9ZSgiLi91dGlscyIpLGk9ZSgiLi9jb21wcmVzc2VkT2JqZWN0Iikscz1lKCIuL2NyYzMyIiksbz1lKCIuL3V0ZjgiKSx1PWUoIi4vY29tcHJlc3Npb25zIiksbD1lKCIuL3N1cHBvcnQiKTtmdW5jdGlvbiBjKGUsdCl7dGhpcy5vcHRpb25zPWUsdGhpcy5sb2FkT3B0aW9ucz10O31jLnByb3RvdHlwZT17aXNFbmNyeXB0ZWQ6ZnVuY3Rpb24oKXtyZXR1cm4gMT09KDEmdGhpcy5iaXRGbGFnKX0sdXNlVVRGODpmdW5jdGlvbigpe3JldHVybiAyMDQ4PT0oMjA0OCZ0aGlzLmJpdEZsYWcpfSxyZWFkTG9jYWxQYXJ0OmZ1bmN0aW9uKGUpe3ZhciB0LHI7aWYoZS5za2lwKDIyKSx0aGlzLmZpbGVOYW1lTGVuZ3RoPWUucmVhZEludCgyKSxyPWUucmVhZEludCgyKSx0aGlzLmZpbGVOYW1lPWUucmVhZERhdGEodGhpcy5maWxlTmFtZUxlbmd0aCksZS5za2lwKHIpLC0xPT09dGhpcy5jb21wcmVzc2VkU2l6ZXx8LTE9PT10aGlzLnVuY29tcHJlc3NlZFNpemUpdGhyb3cgbmV3IEVycm9yKCJCdWcgb3IgY29ycnVwdGVkIHppcCA6IGRpZG4ndCBnZXQgZW5vdWdoIGluZm9ybWF0aW9ucyBmcm9tIHRoZSBjZW50cmFsIGRpcmVjdG9yeSAoY29tcHJlc3NlZFNpemUgPT09IC0xIHx8IHVuY29tcHJlc3NlZFNpemUgPT09IC0xKSIpO2lmKG51bGw9PT0odD1mdW5jdGlvbihlKXtmb3IodmFyIHQgaW4gdSlpZih1Lmhhc093blByb3BlcnR5KHQpJiZ1W3RdLm1hZ2ljPT09ZSlyZXR1cm4gdVt0XTtyZXR1cm4gbnVsbH0odGhpcy5jb21wcmVzc2lvbk1ldGhvZCkpKXRocm93IG5ldyBFcnJvcigiQ29ycnVwdGVkIHppcCA6IGNvbXByZXNzaW9uICIrYS5wcmV0dHkodGhpcy5jb21wcmVzc2lvbk1ldGhvZCkrIiB1bmtub3duIChpbm5lciBmaWxlIDogIithLnRyYW5zZm9ybVRvKCJzdHJpbmciLHRoaXMuZmlsZU5hbWUpKyIpIik7dGhpcy5kZWNvbXByZXNzZWQ9bmV3IGkodGhpcy5jb21wcmVzc2VkU2l6ZSx0aGlzLnVuY29tcHJlc3NlZFNpemUsdGhpcy5jcmMzMix0LGUucmVhZERhdGEodGhpcy5jb21wcmVzc2VkU2l6ZSkpO30scmVhZENlbnRyYWxQYXJ0OmZ1bmN0aW9uKGUpe3RoaXMudmVyc2lvbk1hZGVCeT1lLnJlYWRJbnQoMiksZS5za2lwKDIpLHRoaXMuYml0RmxhZz1lLnJlYWRJbnQoMiksdGhpcy5jb21wcmVzc2lvbk1ldGhvZD1lLnJlYWRTdHJpbmcoMiksdGhpcy5kYXRlPWUucmVhZERhdGUoKSx0aGlzLmNyYzMyPWUucmVhZEludCg0KSx0aGlzLmNvbXByZXNzZWRTaXplPWUucmVhZEludCg0KSx0aGlzLnVuY29tcHJlc3NlZFNpemU9ZS5yZWFkSW50KDQpO3ZhciB0PWUucmVhZEludCgyKTtpZih0aGlzLmV4dHJhRmllbGRzTGVuZ3RoPWUucmVhZEludCgyKSx0aGlzLmZpbGVDb21tZW50TGVuZ3RoPWUucmVhZEludCgyKSx0aGlzLmRpc2tOdW1iZXJTdGFydD1lLnJlYWRJbnQoMiksdGhpcy5pbnRlcm5hbEZpbGVBdHRyaWJ1dGVzPWUucmVhZEludCgyKSx0aGlzLmV4dGVybmFsRmlsZUF0dHJpYnV0ZXM9ZS5yZWFkSW50KDQpLHRoaXMubG9jYWxIZWFkZXJPZmZzZXQ9ZS5yZWFkSW50KDQpLHRoaXMuaXNFbmNyeXB0ZWQoKSl0aHJvdyBuZXcgRXJyb3IoIkVuY3J5cHRlZCB6aXAgYXJlIG5vdCBzdXBwb3J0ZWQiKTtlLnNraXAodCksdGhpcy5yZWFkRXh0cmFGaWVsZHMoZSksdGhpcy5wYXJzZVpJUDY0RXh0cmFGaWVsZChlKSx0aGlzLmZpbGVDb21tZW50PWUucmVhZERhdGEodGhpcy5maWxlQ29tbWVudExlbmd0aCk7fSxwcm9jZXNzQXR0cmlidXRlczpmdW5jdGlvbigpe3RoaXMudW5peFBlcm1pc3Npb25zPW51bGwsdGhpcy5kb3NQZXJtaXNzaW9ucz1udWxsO3ZhciBlPXRoaXMudmVyc2lvbk1hZGVCeT4+ODt0aGlzLmRpcj0hISgxNiZ0aGlzLmV4dGVybmFsRmlsZUF0dHJpYnV0ZXMpLDA9PWUmJih0aGlzLmRvc1Blcm1pc3Npb25zPTYzJnRoaXMuZXh0ZXJuYWxGaWxlQXR0cmlidXRlcyksMz09ZSYmKHRoaXMudW5peFBlcm1pc3Npb25zPXRoaXMuZXh0ZXJuYWxGaWxlQXR0cmlidXRlcz4+MTYmNjU1MzUpLHRoaXMuZGlyfHwiLyIhPT10aGlzLmZpbGVOYW1lU3RyLnNsaWNlKC0xKXx8KHRoaXMuZGlyPSEwKTt9LHBhcnNlWklQNjRFeHRyYUZpZWxkOmZ1bmN0aW9uKGUpe2lmKHRoaXMuZXh0cmFGaWVsZHNbMV0pe3ZhciB0PW4odGhpcy5leHRyYUZpZWxkc1sxXS52YWx1ZSk7dGhpcy51bmNvbXByZXNzZWRTaXplPT09YS5NQVhfVkFMVUVfMzJCSVRTJiYodGhpcy51bmNvbXByZXNzZWRTaXplPXQucmVhZEludCg4KSksdGhpcy5jb21wcmVzc2VkU2l6ZT09PWEuTUFYX1ZBTFVFXzMyQklUUyYmKHRoaXMuY29tcHJlc3NlZFNpemU9dC5yZWFkSW50KDgpKSx0aGlzLmxvY2FsSGVhZGVyT2Zmc2V0PT09YS5NQVhfVkFMVUVfMzJCSVRTJiYodGhpcy5sb2NhbEhlYWRlck9mZnNldD10LnJlYWRJbnQoOCkpLHRoaXMuZGlza051bWJlclN0YXJ0PT09YS5NQVhfVkFMVUVfMzJCSVRTJiYodGhpcy5kaXNrTnVtYmVyU3RhcnQ9dC5yZWFkSW50KDQpKTt9fSxyZWFkRXh0cmFGaWVsZHM6ZnVuY3Rpb24oZSl7dmFyIHQscixuLGE9ZS5pbmRleCt0aGlzLmV4dHJhRmllbGRzTGVuZ3RoO2Zvcih0aGlzLmV4dHJhRmllbGRzfHwodGhpcy5leHRyYUZpZWxkcz17fSk7ZS5pbmRleDxhOyl0PWUucmVhZEludCgyKSxyPWUucmVhZEludCgyKSxuPWUucmVhZERhdGEociksdGhpcy5leHRyYUZpZWxkc1t0XT17aWQ6dCxsZW5ndGg6cix2YWx1ZTpufTt9LGhhbmRsZVVURjg6ZnVuY3Rpb24oKXt2YXIgZT1sLnVpbnQ4YXJyYXk/InVpbnQ4YXJyYXkiOiJhcnJheSI7aWYodGhpcy51c2VVVEY4KCkpdGhpcy5maWxlTmFtZVN0cj1vLnV0ZjhkZWNvZGUodGhpcy5maWxlTmFtZSksdGhpcy5maWxlQ29tbWVudFN0cj1vLnV0ZjhkZWNvZGUodGhpcy5maWxlQ29tbWVudCk7ZWxzZSB7dmFyIHQ9dGhpcy5maW5kRXh0cmFGaWVsZFVuaWNvZGVQYXRoKCk7aWYobnVsbCE9PXQpdGhpcy5maWxlTmFtZVN0cj10O2Vsc2Uge3ZhciByPWEudHJhbnNmb3JtVG8oZSx0aGlzLmZpbGVOYW1lKTt0aGlzLmZpbGVOYW1lU3RyPXRoaXMubG9hZE9wdGlvbnMuZGVjb2RlRmlsZU5hbWUocik7fXZhciBuPXRoaXMuZmluZEV4dHJhRmllbGRVbmljb2RlQ29tbWVudCgpO2lmKG51bGwhPT1uKXRoaXMuZmlsZUNvbW1lbnRTdHI9bjtlbHNlIHt2YXIgaT1hLnRyYW5zZm9ybVRvKGUsdGhpcy5maWxlQ29tbWVudCk7dGhpcy5maWxlQ29tbWVudFN0cj10aGlzLmxvYWRPcHRpb25zLmRlY29kZUZpbGVOYW1lKGkpO319fSxmaW5kRXh0cmFGaWVsZFVuaWNvZGVQYXRoOmZ1bmN0aW9uKCl7dmFyIGU9dGhpcy5leHRyYUZpZWxkc1syODc4OV07aWYoZSl7dmFyIHQ9bihlLnZhbHVlKTtyZXR1cm4gMSE9PXQucmVhZEludCgxKT9udWxsOnModGhpcy5maWxlTmFtZSkhPT10LnJlYWRJbnQoNCk/bnVsbDpvLnV0ZjhkZWNvZGUodC5yZWFkRGF0YShlLmxlbmd0aC01KSl9cmV0dXJuIG51bGx9LGZpbmRFeHRyYUZpZWxkVW5pY29kZUNvbW1lbnQ6ZnVuY3Rpb24oKXt2YXIgZT10aGlzLmV4dHJhRmllbGRzWzI1NDYxXTtpZihlKXt2YXIgdD1uKGUudmFsdWUpO3JldHVybiAxIT09dC5yZWFkSW50KDEpP251bGw6cyh0aGlzLmZpbGVDb21tZW50KSE9PXQucmVhZEludCg0KT9udWxsOm8udXRmOGRlY29kZSh0LnJlYWREYXRhKGUubGVuZ3RoLTUpKX1yZXR1cm4gbnVsbH19LHQuZXhwb3J0cz1jO30seyIuL2NvbXByZXNzZWRPYmplY3QiOjIsIi4vY29tcHJlc3Npb25zIjozLCIuL2NyYzMyIjo0LCIuL3JlYWRlci9yZWFkZXJGb3IiOjIyLCIuL3N1cHBvcnQiOjMwLCIuL3V0ZjgiOjMxLCIuL3V0aWxzIjozMn1dLDM1OltmdW5jdGlvbihlLHQscil7ZnVuY3Rpb24gbihlLHQscil7dGhpcy5uYW1lPWUsdGhpcy5kaXI9ci5kaXIsdGhpcy5kYXRlPXIuZGF0ZSx0aGlzLmNvbW1lbnQ9ci5jb21tZW50LHRoaXMudW5peFBlcm1pc3Npb25zPXIudW5peFBlcm1pc3Npb25zLHRoaXMuZG9zUGVybWlzc2lvbnM9ci5kb3NQZXJtaXNzaW9ucyx0aGlzLl9kYXRhPXQsdGhpcy5fZGF0YUJpbmFyeT1yLmJpbmFyeSx0aGlzLm9wdGlvbnM9e2NvbXByZXNzaW9uOnIuY29tcHJlc3Npb24sY29tcHJlc3Npb25PcHRpb25zOnIuY29tcHJlc3Npb25PcHRpb25zfTt9dmFyIGE9ZSgiLi9zdHJlYW0vU3RyZWFtSGVscGVyIiksaT1lKCIuL3N0cmVhbS9EYXRhV29ya2VyIikscz1lKCIuL3V0ZjgiKSxvPWUoIi4vY29tcHJlc3NlZE9iamVjdCIpLHU9ZSgiLi9zdHJlYW0vR2VuZXJpY1dvcmtlciIpO24ucHJvdG90eXBlPXtpbnRlcm5hbFN0cmVhbTpmdW5jdGlvbihlKXt2YXIgdD1udWxsLHI9InN0cmluZyI7dHJ5e2lmKCFlKXRocm93IG5ldyBFcnJvcigiTm8gb3V0cHV0IHR5cGUgc3BlY2lmaWVkLiIpO3ZhciBuPSJzdHJpbmciPT09KHI9ZS50b0xvd2VyQ2FzZSgpKXx8InRleHQiPT09cjsiYmluYXJ5c3RyaW5nIiE9PXImJiJ0ZXh0IiE9PXJ8fChyPSJzdHJpbmciKSx0PXRoaXMuX2RlY29tcHJlc3NXb3JrZXIoKTt2YXIgaT0hdGhpcy5fZGF0YUJpbmFyeTtpJiYhbiYmKHQ9dC5waXBlKG5ldyBzLlV0ZjhFbmNvZGVXb3JrZXIpKSwhaSYmbiYmKHQ9dC5waXBlKG5ldyBzLlV0ZjhEZWNvZGVXb3JrZXIpKTt9Y2F0Y2goZSl7KHQ9bmV3IHUoImVycm9yIikpLmVycm9yKGUpO31yZXR1cm4gbmV3IGEodCxyLCIiKX0sYXN5bmM6ZnVuY3Rpb24oZSx0KXtyZXR1cm4gdGhpcy5pbnRlcm5hbFN0cmVhbShlKS5hY2N1bXVsYXRlKHQpfSxub2RlU3RyZWFtOmZ1bmN0aW9uKGUsdCl7cmV0dXJuIHRoaXMuaW50ZXJuYWxTdHJlYW0oZXx8Im5vZGVidWZmZXIiKS50b05vZGVqc1N0cmVhbSh0KX0sX2NvbXByZXNzV29ya2VyOmZ1bmN0aW9uKGUsdCl7aWYodGhpcy5fZGF0YSBpbnN0YW5jZW9mIG8mJnRoaXMuX2RhdGEuY29tcHJlc3Npb24ubWFnaWM9PT1lLm1hZ2ljKXJldHVybiB0aGlzLl9kYXRhLmdldENvbXByZXNzZWRXb3JrZXIoKTt2YXIgcj10aGlzLl9kZWNvbXByZXNzV29ya2VyKCk7cmV0dXJuIHRoaXMuX2RhdGFCaW5hcnl8fChyPXIucGlwZShuZXcgcy5VdGY4RW5jb2RlV29ya2VyKSksby5jcmVhdGVXb3JrZXJGcm9tKHIsZSx0KX0sX2RlY29tcHJlc3NXb3JrZXI6ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fZGF0YSBpbnN0YW5jZW9mIG8/dGhpcy5fZGF0YS5nZXRDb250ZW50V29ya2VyKCk6dGhpcy5fZGF0YSBpbnN0YW5jZW9mIHU/dGhpcy5fZGF0YTpuZXcgaSh0aGlzLl9kYXRhKX19O2Zvcih2YXIgbD1bImFzVGV4dCIsImFzQmluYXJ5IiwiYXNOb2RlQnVmZmVyIiwiYXNVaW50OEFycmF5IiwiYXNBcnJheUJ1ZmZlciJdLGM9ZnVuY3Rpb24oKXt0aHJvdyBuZXcgRXJyb3IoIlRoaXMgbWV0aG9kIGhhcyBiZWVuIHJlbW92ZWQgaW4gSlNaaXAgMy4wLCBwbGVhc2UgY2hlY2sgdGhlIHVwZ3JhZGUgZ3VpZGUuIil9LGg9MDtoPGwubGVuZ3RoO2grKyluLnByb3RvdHlwZVtsW2hdXT1jO3QuZXhwb3J0cz1uO30seyIuL2NvbXByZXNzZWRPYmplY3QiOjIsIi4vc3RyZWFtL0RhdGFXb3JrZXIiOjI3LCIuL3N0cmVhbS9HZW5lcmljV29ya2VyIjoyOCwiLi9zdHJlYW0vU3RyZWFtSGVscGVyIjoyOSwiLi91dGY4IjozMX1dLDM2OltmdW5jdGlvbihlLHQscil7KGZ1bmN0aW9uKGUpe3ZhciByLG4sYT1lLk11dGF0aW9uT2JzZXJ2ZXJ8fGUuV2ViS2l0TXV0YXRpb25PYnNlcnZlcjtpZihhKXt2YXIgaT0wLHM9bmV3IGEoYyksbz1lLmRvY3VtZW50LmNyZWF0ZVRleHROb2RlKCIiKTtzLm9ic2VydmUobyx7Y2hhcmFjdGVyRGF0YTohMH0pLHI9ZnVuY3Rpb24oKXtvLmRhdGE9aT0rK2klMjt9O31lbHNlIGlmKGUuc2V0SW1tZWRpYXRlfHx2b2lkIDA9PT1lLk1lc3NhZ2VDaGFubmVsKXI9ImRvY3VtZW50ImluIGUmJiJvbnJlYWR5c3RhdGVjaGFuZ2UiaW4gZS5kb2N1bWVudC5jcmVhdGVFbGVtZW50KCJzY3JpcHQiKT9mdW5jdGlvbigpe3ZhciB0PWUuZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgic2NyaXB0Iik7dC5vbnJlYWR5c3RhdGVjaGFuZ2U9ZnVuY3Rpb24oKXtjKCksdC5vbnJlYWR5c3RhdGVjaGFuZ2U9bnVsbCx0LnBhcmVudE5vZGUucmVtb3ZlQ2hpbGQodCksdD1udWxsO30sZS5kb2N1bWVudC5kb2N1bWVudEVsZW1lbnQuYXBwZW5kQ2hpbGQodCk7fTpmdW5jdGlvbigpe3NldFRpbWVvdXQoYywwKTt9O2Vsc2Uge3ZhciB1PW5ldyBlLk1lc3NhZ2VDaGFubmVsO3UucG9ydDEub25tZXNzYWdlPWMscj1mdW5jdGlvbigpe3UucG9ydDIucG9zdE1lc3NhZ2UoMCk7fTt9dmFyIGw9W107ZnVuY3Rpb24gYygpe3ZhciBlLHQ7bj0hMDtmb3IodmFyIHI9bC5sZW5ndGg7cjspe2Zvcih0PWwsbD1bXSxlPS0xOysrZTxyOyl0W2VdKCk7cj1sLmxlbmd0aDt9bj0hMTt9dC5leHBvcnRzPWZ1bmN0aW9uKGUpezEhPT1sLnB1c2goZSl8fG58fHIoKTt9O30pLmNhbGwodGhpcyx2b2lkIDAhPT1pP2k6InVuZGVmaW5lZCIhPXR5cGVvZiBzZWxmP3NlbGY6InVuZGVmaW5lZCIhPXR5cGVvZiB3aW5kb3c/d2luZG93Ont9KTt9LHt9XSwzNzpbZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUoImltbWVkaWF0ZSIpO2Z1bmN0aW9uIGEoKXt9dmFyIGk9e30scz1bIlJFSkVDVEVEIl0sbz1bIkZVTEZJTExFRCJdLHU9WyJQRU5ESU5HIl07ZnVuY3Rpb24gbChlKXtpZigiZnVuY3Rpb24iIT10eXBlb2YgZSl0aHJvdyBuZXcgVHlwZUVycm9yKCJyZXNvbHZlciBtdXN0IGJlIGEgZnVuY3Rpb24iKTt0aGlzLnN0YXRlPXUsdGhpcy5xdWV1ZT1bXSx0aGlzLm91dGNvbWU9dm9pZCAwLGUhPT1hJiZmKHRoaXMsZSk7fWZ1bmN0aW9uIGMoZSx0LHIpe3RoaXMucHJvbWlzZT1lLCJmdW5jdGlvbiI9PXR5cGVvZiB0JiYodGhpcy5vbkZ1bGZpbGxlZD10LHRoaXMuY2FsbEZ1bGZpbGxlZD10aGlzLm90aGVyQ2FsbEZ1bGZpbGxlZCksImZ1bmN0aW9uIj09dHlwZW9mIHImJih0aGlzLm9uUmVqZWN0ZWQ9cix0aGlzLmNhbGxSZWplY3RlZD10aGlzLm90aGVyQ2FsbFJlamVjdGVkKTt9ZnVuY3Rpb24gaChlLHQscil7bigoZnVuY3Rpb24oKXt2YXIgbjt0cnl7bj10KHIpO31jYXRjaChuKXtyZXR1cm4gaS5yZWplY3QoZSxuKX1uPT09ZT9pLnJlamVjdChlLG5ldyBUeXBlRXJyb3IoIkNhbm5vdCByZXNvbHZlIHByb21pc2Ugd2l0aCBpdHNlbGYiKSk6aS5yZXNvbHZlKGUsbik7fSkpO31mdW5jdGlvbiBkKGUpe3ZhciB0PWUmJmUudGhlbjtpZihlJiYoIm9iamVjdCI9PXR5cGVvZiBlfHwiZnVuY3Rpb24iPT10eXBlb2YgZSkmJiJmdW5jdGlvbiI9PXR5cGVvZiB0KXJldHVybiBmdW5jdGlvbigpe3QuYXBwbHkoZSxhcmd1bWVudHMpO319ZnVuY3Rpb24gZihlLHQpe3ZhciByPSExO2Z1bmN0aW9uIG4odCl7cnx8KHI9ITAsaS5yZWplY3QoZSx0KSk7fWZ1bmN0aW9uIGEodCl7cnx8KHI9ITAsaS5yZXNvbHZlKGUsdCkpO312YXIgcz1wKChmdW5jdGlvbigpe3QoYSxuKTt9KSk7ImVycm9yIj09PXMuc3RhdHVzJiZuKHMudmFsdWUpO31mdW5jdGlvbiBwKGUsdCl7dmFyIHI9e307dHJ5e3IudmFsdWU9ZSh0KSxyLnN0YXR1cz0ic3VjY2VzcyI7fWNhdGNoKGUpe3Iuc3RhdHVzPSJlcnJvciIsci52YWx1ZT1lO31yZXR1cm4gcn0odC5leHBvcnRzPWwpLnByb3RvdHlwZS5maW5hbGx5PWZ1bmN0aW9uKGUpe2lmKCJmdW5jdGlvbiIhPXR5cGVvZiBlKXJldHVybiB0aGlzO3ZhciB0PXRoaXMuY29uc3RydWN0b3I7cmV0dXJuIHRoaXMudGhlbigoZnVuY3Rpb24ocil7cmV0dXJuIHQucmVzb2x2ZShlKCkpLnRoZW4oKGZ1bmN0aW9uKCl7cmV0dXJuIHJ9KSl9KSwoZnVuY3Rpb24ocil7cmV0dXJuIHQucmVzb2x2ZShlKCkpLnRoZW4oKGZ1bmN0aW9uKCl7dGhyb3cgcn0pKX0pKX0sbC5wcm90b3R5cGUuY2F0Y2g9ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMudGhlbihudWxsLGUpfSxsLnByb3RvdHlwZS50aGVuPWZ1bmN0aW9uKGUsdCl7aWYoImZ1bmN0aW9uIiE9dHlwZW9mIGUmJnRoaXMuc3RhdGU9PT1vfHwiZnVuY3Rpb24iIT10eXBlb2YgdCYmdGhpcy5zdGF0ZT09PXMpcmV0dXJuIHRoaXM7dmFyIHI9bmV3IHRoaXMuY29uc3RydWN0b3IoYSk7cmV0dXJuIHRoaXMuc3RhdGUhPT11P2gocix0aGlzLnN0YXRlPT09bz9lOnQsdGhpcy5vdXRjb21lKTp0aGlzLnF1ZXVlLnB1c2gobmV3IGMocixlLHQpKSxyfSxjLnByb3RvdHlwZS5jYWxsRnVsZmlsbGVkPWZ1bmN0aW9uKGUpe2kucmVzb2x2ZSh0aGlzLnByb21pc2UsZSk7fSxjLnByb3RvdHlwZS5vdGhlckNhbGxGdWxmaWxsZWQ9ZnVuY3Rpb24oZSl7aCh0aGlzLnByb21pc2UsdGhpcy5vbkZ1bGZpbGxlZCxlKTt9LGMucHJvdG90eXBlLmNhbGxSZWplY3RlZD1mdW5jdGlvbihlKXtpLnJlamVjdCh0aGlzLnByb21pc2UsZSk7fSxjLnByb3RvdHlwZS5vdGhlckNhbGxSZWplY3RlZD1mdW5jdGlvbihlKXtoKHRoaXMucHJvbWlzZSx0aGlzLm9uUmVqZWN0ZWQsZSk7fSxpLnJlc29sdmU9ZnVuY3Rpb24oZSx0KXt2YXIgcj1wKGQsdCk7aWYoImVycm9yIj09PXIuc3RhdHVzKXJldHVybiBpLnJlamVjdChlLHIudmFsdWUpO3ZhciBuPXIudmFsdWU7aWYobilmKGUsbik7ZWxzZSB7ZS5zdGF0ZT1vLGUub3V0Y29tZT10O2Zvcih2YXIgYT0tMSxzPWUucXVldWUubGVuZ3RoOysrYTxzOyllLnF1ZXVlW2FdLmNhbGxGdWxmaWxsZWQodCk7fXJldHVybiBlfSxpLnJlamVjdD1mdW5jdGlvbihlLHQpe2Uuc3RhdGU9cyxlLm91dGNvbWU9dDtmb3IodmFyIHI9LTEsbj1lLnF1ZXVlLmxlbmd0aDsrK3I8bjspZS5xdWV1ZVtyXS5jYWxsUmVqZWN0ZWQodCk7cmV0dXJuIGV9LGwucmVzb2x2ZT1mdW5jdGlvbihlKXtyZXR1cm4gZSBpbnN0YW5jZW9mIHRoaXM/ZTppLnJlc29sdmUobmV3IHRoaXMoYSksZSl9LGwucmVqZWN0PWZ1bmN0aW9uKGUpe3ZhciB0PW5ldyB0aGlzKGEpO3JldHVybiBpLnJlamVjdCh0LGUpfSxsLmFsbD1mdW5jdGlvbihlKXt2YXIgdD10aGlzO2lmKCJbb2JqZWN0IEFycmF5XSIhPT1PYmplY3QucHJvdG90eXBlLnRvU3RyaW5nLmNhbGwoZSkpcmV0dXJuIHRoaXMucmVqZWN0KG5ldyBUeXBlRXJyb3IoIm11c3QgYmUgYW4gYXJyYXkiKSk7dmFyIHI9ZS5sZW5ndGgsbj0hMTtpZighcilyZXR1cm4gdGhpcy5yZXNvbHZlKFtdKTtmb3IodmFyIHM9bmV3IEFycmF5KHIpLG89MCx1PS0xLGw9bmV3IHRoaXMoYSk7Kyt1PHI7KWMoZVt1XSx1KTtyZXR1cm4gbDtmdW5jdGlvbiBjKGUsYSl7dC5yZXNvbHZlKGUpLnRoZW4oKGZ1bmN0aW9uKGUpe3NbYV09ZSwrK28hPT1yfHxufHwobj0hMCxpLnJlc29sdmUobCxzKSk7fSksKGZ1bmN0aW9uKGUpe258fChuPSEwLGkucmVqZWN0KGwsZSkpO30pKTt9fSxsLnJhY2U9ZnVuY3Rpb24oZSl7aWYoIltvYmplY3QgQXJyYXldIiE9PU9iamVjdC5wcm90b3R5cGUudG9TdHJpbmcuY2FsbChlKSlyZXR1cm4gdGhpcy5yZWplY3QobmV3IFR5cGVFcnJvcigibXVzdCBiZSBhbiBhcnJheSIpKTt2YXIgdD1lLmxlbmd0aCxyPSExO2lmKCF0KXJldHVybiB0aGlzLnJlc29sdmUoW10pO2Zvcih2YXIgbixzPS0xLG89bmV3IHRoaXMoYSk7KytzPHQ7KW49ZVtzXSx0aGlzLnJlc29sdmUobikudGhlbigoZnVuY3Rpb24oZSl7cnx8KHI9ITAsaS5yZXNvbHZlKG8sZSkpO30pLChmdW5jdGlvbihlKXtyfHwocj0hMCxpLnJlamVjdChvLGUpKTt9KSk7cmV0dXJuIG99O30se2ltbWVkaWF0ZTozNn1dLDM4OltmdW5jdGlvbihlLHQscil7dmFyIG49e307KDAsIGUoIi4vbGliL3V0aWxzL2NvbW1vbiIpLmFzc2lnbikobixlKCIuL2xpYi9kZWZsYXRlIiksZSgiLi9saWIvaW5mbGF0ZSIpLGUoIi4vbGliL3psaWIvY29uc3RhbnRzIikpLHQuZXhwb3J0cz1uO30seyIuL2xpYi9kZWZsYXRlIjozOSwiLi9saWIvaW5mbGF0ZSI6NDAsIi4vbGliL3V0aWxzL2NvbW1vbiI6NDEsIi4vbGliL3psaWIvY29uc3RhbnRzIjo0NH1dLDM5OltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi96bGliL2RlZmxhdGUiKSxhPWUoIi4vdXRpbHMvY29tbW9uIiksaT1lKCIuL3V0aWxzL3N0cmluZ3MiKSxzPWUoIi4vemxpYi9tZXNzYWdlcyIpLG89ZSgiLi96bGliL3pzdHJlYW0iKSx1PU9iamVjdC5wcm90b3R5cGUudG9TdHJpbmc7ZnVuY3Rpb24gbChlKXtpZighKHRoaXMgaW5zdGFuY2VvZiBsKSlyZXR1cm4gbmV3IGwoZSk7dGhpcy5vcHRpb25zPWEuYXNzaWduKHtsZXZlbDotMSxtZXRob2Q6OCxjaHVua1NpemU6MTYzODQsd2luZG93Qml0czoxNSxtZW1MZXZlbDo4LHN0cmF0ZWd5OjAsdG86IiJ9LGV8fHt9KTt2YXIgdD10aGlzLm9wdGlvbnM7dC5yYXcmJjA8dC53aW5kb3dCaXRzP3Qud2luZG93Qml0cz0tdC53aW5kb3dCaXRzOnQuZ3ppcCYmMDx0LndpbmRvd0JpdHMmJnQud2luZG93Qml0czwxNiYmKHQud2luZG93Qml0cys9MTYpLHRoaXMuZXJyPTAsdGhpcy5tc2c9IiIsdGhpcy5lbmRlZD0hMSx0aGlzLmNodW5rcz1bXSx0aGlzLnN0cm09bmV3IG8sdGhpcy5zdHJtLmF2YWlsX291dD0wO3ZhciByPW4uZGVmbGF0ZUluaXQyKHRoaXMuc3RybSx0LmxldmVsLHQubWV0aG9kLHQud2luZG93Qml0cyx0Lm1lbUxldmVsLHQuc3RyYXRlZ3kpO2lmKDAhPT1yKXRocm93IG5ldyBFcnJvcihzW3JdKTtpZih0LmhlYWRlciYmbi5kZWZsYXRlU2V0SGVhZGVyKHRoaXMuc3RybSx0LmhlYWRlciksdC5kaWN0aW9uYXJ5KXt2YXIgYztpZihjPSJzdHJpbmciPT10eXBlb2YgdC5kaWN0aW9uYXJ5P2kuc3RyaW5nMmJ1Zih0LmRpY3Rpb25hcnkpOiJbb2JqZWN0IEFycmF5QnVmZmVyXSI9PT11LmNhbGwodC5kaWN0aW9uYXJ5KT9uZXcgVWludDhBcnJheSh0LmRpY3Rpb25hcnkpOnQuZGljdGlvbmFyeSwwIT09KHI9bi5kZWZsYXRlU2V0RGljdGlvbmFyeSh0aGlzLnN0cm0sYykpKXRocm93IG5ldyBFcnJvcihzW3JdKTt0aGlzLl9kaWN0X3NldD0hMDt9fWZ1bmN0aW9uIGMoZSx0KXt2YXIgcj1uZXcgbCh0KTtpZihyLnB1c2goZSwhMCksci5lcnIpdGhyb3cgci5tc2d8fHNbci5lcnJdO3JldHVybiByLnJlc3VsdH1sLnByb3RvdHlwZS5wdXNoPWZ1bmN0aW9uKGUsdCl7dmFyIHIscyxvPXRoaXMuc3RybSxsPXRoaXMub3B0aW9ucy5jaHVua1NpemU7aWYodGhpcy5lbmRlZClyZXR1cm4gITE7cz10PT09fn50P3Q6ITA9PT10PzQ6MCwic3RyaW5nIj09dHlwZW9mIGU/by5pbnB1dD1pLnN0cmluZzJidWYoZSk6IltvYmplY3QgQXJyYXlCdWZmZXJdIj09PXUuY2FsbChlKT9vLmlucHV0PW5ldyBVaW50OEFycmF5KGUpOm8uaW5wdXQ9ZSxvLm5leHRfaW49MCxvLmF2YWlsX2luPW8uaW5wdXQubGVuZ3RoO2Rve2lmKDA9PT1vLmF2YWlsX291dCYmKG8ub3V0cHV0PW5ldyBhLkJ1ZjgobCksby5uZXh0X291dD0wLG8uYXZhaWxfb3V0PWwpLDEhPT0ocj1uLmRlZmxhdGUobyxzKSkmJjAhPT1yKXJldHVybiB0aGlzLm9uRW5kKHIpLCEodGhpcy5lbmRlZD0hMCk7MCE9PW8uYXZhaWxfb3V0JiYoMCE9PW8uYXZhaWxfaW58fDQhPT1zJiYyIT09cyl8fCgic3RyaW5nIj09PXRoaXMub3B0aW9ucy50bz90aGlzLm9uRGF0YShpLmJ1ZjJiaW5zdHJpbmcoYS5zaHJpbmtCdWYoby5vdXRwdXQsby5uZXh0X291dCkpKTp0aGlzLm9uRGF0YShhLnNocmlua0J1ZihvLm91dHB1dCxvLm5leHRfb3V0KSkpO313aGlsZSgoMDxvLmF2YWlsX2lufHwwPT09by5hdmFpbF9vdXQpJiYxIT09cik7cmV0dXJuIDQ9PT1zPyhyPW4uZGVmbGF0ZUVuZCh0aGlzLnN0cm0pLHRoaXMub25FbmQociksdGhpcy5lbmRlZD0hMCwwPT09cik6MiE9PXN8fCh0aGlzLm9uRW5kKDApLCEoby5hdmFpbF9vdXQ9MCkpfSxsLnByb3RvdHlwZS5vbkRhdGE9ZnVuY3Rpb24oZSl7dGhpcy5jaHVua3MucHVzaChlKTt9LGwucHJvdG90eXBlLm9uRW5kPWZ1bmN0aW9uKGUpezA9PT1lJiYoInN0cmluZyI9PT10aGlzLm9wdGlvbnMudG8/dGhpcy5yZXN1bHQ9dGhpcy5jaHVua3Muam9pbigiIik6dGhpcy5yZXN1bHQ9YS5mbGF0dGVuQ2h1bmtzKHRoaXMuY2h1bmtzKSksdGhpcy5jaHVua3M9W10sdGhpcy5lcnI9ZSx0aGlzLm1zZz10aGlzLnN0cm0ubXNnO30sci5EZWZsYXRlPWwsci5kZWZsYXRlPWMsci5kZWZsYXRlUmF3PWZ1bmN0aW9uKGUsdCl7cmV0dXJuICh0PXR8fHt9KS5yYXc9ITAsYyhlLHQpfSxyLmd6aXA9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gKHQ9dHx8e30pLmd6aXA9ITAsYyhlLHQpfTt9LHsiLi91dGlscy9jb21tb24iOjQxLCIuL3V0aWxzL3N0cmluZ3MiOjQyLCIuL3psaWIvZGVmbGF0ZSI6NDYsIi4vemxpYi9tZXNzYWdlcyI6NTEsIi4vemxpYi96c3RyZWFtIjo1M31dLDQwOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi96bGliL2luZmxhdGUiKSxhPWUoIi4vdXRpbHMvY29tbW9uIiksaT1lKCIuL3V0aWxzL3N0cmluZ3MiKSxzPWUoIi4vemxpYi9jb25zdGFudHMiKSxvPWUoIi4vemxpYi9tZXNzYWdlcyIpLHU9ZSgiLi96bGliL3pzdHJlYW0iKSxsPWUoIi4vemxpYi9nemhlYWRlciIpLGM9T2JqZWN0LnByb3RvdHlwZS50b1N0cmluZztmdW5jdGlvbiBoKGUpe2lmKCEodGhpcyBpbnN0YW5jZW9mIGgpKXJldHVybiBuZXcgaChlKTt0aGlzLm9wdGlvbnM9YS5hc3NpZ24oe2NodW5rU2l6ZToxNjM4NCx3aW5kb3dCaXRzOjAsdG86IiJ9LGV8fHt9KTt2YXIgdD10aGlzLm9wdGlvbnM7dC5yYXcmJjA8PXQud2luZG93Qml0cyYmdC53aW5kb3dCaXRzPDE2JiYodC53aW5kb3dCaXRzPS10LndpbmRvd0JpdHMsMD09PXQud2luZG93Qml0cyYmKHQud2luZG93Qml0cz0tMTUpKSwhKDA8PXQud2luZG93Qml0cyYmdC53aW5kb3dCaXRzPDE2KXx8ZSYmZS53aW5kb3dCaXRzfHwodC53aW5kb3dCaXRzKz0zMiksMTU8dC53aW5kb3dCaXRzJiZ0LndpbmRvd0JpdHM8NDgmJjA9PSgxNSZ0LndpbmRvd0JpdHMpJiYodC53aW5kb3dCaXRzfD0xNSksdGhpcy5lcnI9MCx0aGlzLm1zZz0iIix0aGlzLmVuZGVkPSExLHRoaXMuY2h1bmtzPVtdLHRoaXMuc3RybT1uZXcgdSx0aGlzLnN0cm0uYXZhaWxfb3V0PTA7dmFyIHI9bi5pbmZsYXRlSW5pdDIodGhpcy5zdHJtLHQud2luZG93Qml0cyk7aWYociE9PXMuWl9PSyl0aHJvdyBuZXcgRXJyb3Iob1tyXSk7dGhpcy5oZWFkZXI9bmV3IGwsbi5pbmZsYXRlR2V0SGVhZGVyKHRoaXMuc3RybSx0aGlzLmhlYWRlcik7fWZ1bmN0aW9uIGQoZSx0KXt2YXIgcj1uZXcgaCh0KTtpZihyLnB1c2goZSwhMCksci5lcnIpdGhyb3cgci5tc2d8fG9bci5lcnJdO3JldHVybiByLnJlc3VsdH1oLnByb3RvdHlwZS5wdXNoPWZ1bmN0aW9uKGUsdCl7dmFyIHIsbyx1LGwsaCxkLGY9dGhpcy5zdHJtLHA9dGhpcy5vcHRpb25zLmNodW5rU2l6ZSxtPXRoaXMub3B0aW9ucy5kaWN0aW9uYXJ5LGc9ITE7aWYodGhpcy5lbmRlZClyZXR1cm4gITE7bz10PT09fn50P3Q6ITA9PT10P3MuWl9GSU5JU0g6cy5aX05PX0ZMVVNILCJzdHJpbmciPT10eXBlb2YgZT9mLmlucHV0PWkuYmluc3RyaW5nMmJ1ZihlKToiW29iamVjdCBBcnJheUJ1ZmZlcl0iPT09Yy5jYWxsKGUpP2YuaW5wdXQ9bmV3IFVpbnQ4QXJyYXkoZSk6Zi5pbnB1dD1lLGYubmV4dF9pbj0wLGYuYXZhaWxfaW49Zi5pbnB1dC5sZW5ndGg7ZG97aWYoMD09PWYuYXZhaWxfb3V0JiYoZi5vdXRwdXQ9bmV3IGEuQnVmOChwKSxmLm5leHRfb3V0PTAsZi5hdmFpbF9vdXQ9cCksKHI9bi5pbmZsYXRlKGYscy5aX05PX0ZMVVNIKSk9PT1zLlpfTkVFRF9ESUNUJiZtJiYoZD0ic3RyaW5nIj09dHlwZW9mIG0/aS5zdHJpbmcyYnVmKG0pOiJbb2JqZWN0IEFycmF5QnVmZmVyXSI9PT1jLmNhbGwobSk/bmV3IFVpbnQ4QXJyYXkobSk6bSxyPW4uaW5mbGF0ZVNldERpY3Rpb25hcnkodGhpcy5zdHJtLGQpKSxyPT09cy5aX0JVRl9FUlJPUiYmITA9PT1nJiYocj1zLlpfT0ssZz0hMSksciE9PXMuWl9TVFJFQU1fRU5EJiZyIT09cy5aX09LKXJldHVybiB0aGlzLm9uRW5kKHIpLCEodGhpcy5lbmRlZD0hMCk7Zi5uZXh0X291dCYmKDAhPT1mLmF2YWlsX291dCYmciE9PXMuWl9TVFJFQU1fRU5EJiYoMCE9PWYuYXZhaWxfaW58fG8hPT1zLlpfRklOSVNIJiZvIT09cy5aX1NZTkNfRkxVU0gpfHwoInN0cmluZyI9PT10aGlzLm9wdGlvbnMudG8/KHU9aS51dGY4Ym9yZGVyKGYub3V0cHV0LGYubmV4dF9vdXQpLGw9Zi5uZXh0X291dC11LGg9aS5idWYyc3RyaW5nKGYub3V0cHV0LHUpLGYubmV4dF9vdXQ9bCxmLmF2YWlsX291dD1wLWwsbCYmYS5hcnJheVNldChmLm91dHB1dCxmLm91dHB1dCx1LGwsMCksdGhpcy5vbkRhdGEoaCkpOnRoaXMub25EYXRhKGEuc2hyaW5rQnVmKGYub3V0cHV0LGYubmV4dF9vdXQpKSkpLDA9PT1mLmF2YWlsX2luJiYwPT09Zi5hdmFpbF9vdXQmJihnPSEwKTt9d2hpbGUoKDA8Zi5hdmFpbF9pbnx8MD09PWYuYXZhaWxfb3V0KSYmciE9PXMuWl9TVFJFQU1fRU5EKTtyZXR1cm4gcj09PXMuWl9TVFJFQU1fRU5EJiYobz1zLlpfRklOSVNIKSxvPT09cy5aX0ZJTklTSD8ocj1uLmluZmxhdGVFbmQodGhpcy5zdHJtKSx0aGlzLm9uRW5kKHIpLHRoaXMuZW5kZWQ9ITAscj09PXMuWl9PSyk6byE9PXMuWl9TWU5DX0ZMVVNIfHwodGhpcy5vbkVuZChzLlpfT0spLCEoZi5hdmFpbF9vdXQ9MCkpfSxoLnByb3RvdHlwZS5vbkRhdGE9ZnVuY3Rpb24oZSl7dGhpcy5jaHVua3MucHVzaChlKTt9LGgucHJvdG90eXBlLm9uRW5kPWZ1bmN0aW9uKGUpe2U9PT1zLlpfT0smJigic3RyaW5nIj09PXRoaXMub3B0aW9ucy50bz90aGlzLnJlc3VsdD10aGlzLmNodW5rcy5qb2luKCIiKTp0aGlzLnJlc3VsdD1hLmZsYXR0ZW5DaHVua3ModGhpcy5jaHVua3MpKSx0aGlzLmNodW5rcz1bXSx0aGlzLmVycj1lLHRoaXMubXNnPXRoaXMuc3RybS5tc2c7fSxyLkluZmxhdGU9aCxyLmluZmxhdGU9ZCxyLmluZmxhdGVSYXc9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gKHQ9dHx8e30pLnJhdz0hMCxkKGUsdCl9LHIudW5nemlwPWQ7fSx7Ii4vdXRpbHMvY29tbW9uIjo0MSwiLi91dGlscy9zdHJpbmdzIjo0MiwiLi96bGliL2NvbnN0YW50cyI6NDQsIi4vemxpYi9nemhlYWRlciI6NDcsIi4vemxpYi9pbmZsYXRlIjo0OSwiLi96bGliL21lc3NhZ2VzIjo1MSwiLi96bGliL3pzdHJlYW0iOjUzfV0sNDE6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj0idW5kZWZpbmVkIiE9dHlwZW9mIFVpbnQ4QXJyYXkmJiJ1bmRlZmluZWQiIT10eXBlb2YgVWludDE2QXJyYXkmJiJ1bmRlZmluZWQiIT10eXBlb2YgSW50MzJBcnJheTtyLmFzc2lnbj1mdW5jdGlvbihlKXtmb3IodmFyIHQ9QXJyYXkucHJvdG90eXBlLnNsaWNlLmNhbGwoYXJndW1lbnRzLDEpO3QubGVuZ3RoOyl7dmFyIHI9dC5zaGlmdCgpO2lmKHIpe2lmKCJvYmplY3QiIT10eXBlb2Ygcil0aHJvdyBuZXcgVHlwZUVycm9yKHIrIm11c3QgYmUgbm9uLW9iamVjdCIpO2Zvcih2YXIgbiBpbiByKXIuaGFzT3duUHJvcGVydHkobikmJihlW25dPXJbbl0pO319cmV0dXJuIGV9LHIuc2hyaW5rQnVmPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIGUubGVuZ3RoPT09dD9lOmUuc3ViYXJyYXk/ZS5zdWJhcnJheSgwLHQpOihlLmxlbmd0aD10LGUpfTt2YXIgYT17YXJyYXlTZXQ6ZnVuY3Rpb24oZSx0LHIsbixhKXtpZih0LnN1YmFycmF5JiZlLnN1YmFycmF5KWUuc2V0KHQuc3ViYXJyYXkocixyK24pLGEpO2Vsc2UgZm9yKHZhciBpPTA7aTxuO2krKyllW2EraV09dFtyK2ldO30sZmxhdHRlbkNodW5rczpmdW5jdGlvbihlKXt2YXIgdCxyLG4sYSxpLHM7Zm9yKHQ9bj0wLHI9ZS5sZW5ndGg7dDxyO3QrKyluKz1lW3RdLmxlbmd0aDtmb3Iocz1uZXcgVWludDhBcnJheShuKSx0PWE9MCxyPWUubGVuZ3RoO3Q8cjt0KyspaT1lW3RdLHMuc2V0KGksYSksYSs9aS5sZW5ndGg7cmV0dXJuIHN9fSxpPXthcnJheVNldDpmdW5jdGlvbihlLHQscixuLGEpe2Zvcih2YXIgaT0wO2k8bjtpKyspZVthK2ldPXRbcitpXTt9LGZsYXR0ZW5DaHVua3M6ZnVuY3Rpb24oZSl7cmV0dXJuIFtdLmNvbmNhdC5hcHBseShbXSxlKX19O3Iuc2V0VHlwZWQ9ZnVuY3Rpb24oZSl7ZT8oci5CdWY4PVVpbnQ4QXJyYXksci5CdWYxNj1VaW50MTZBcnJheSxyLkJ1ZjMyPUludDMyQXJyYXksci5hc3NpZ24ocixhKSk6KHIuQnVmOD1BcnJheSxyLkJ1ZjE2PUFycmF5LHIuQnVmMzI9QXJyYXksci5hc3NpZ24ocixpKSk7fSxyLnNldFR5cGVkKG4pO30se31dLDQyOltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi9jb21tb24iKSxhPSEwLGk9ITA7dHJ5e1N0cmluZy5mcm9tQ2hhckNvZGUuYXBwbHkobnVsbCxbMF0pO31jYXRjaChlKXthPSExO310cnl7U3RyaW5nLmZyb21DaGFyQ29kZS5hcHBseShudWxsLG5ldyBVaW50OEFycmF5KDEpKTt9Y2F0Y2goZSl7aT0hMTt9Zm9yKHZhciBzPW5ldyBuLkJ1ZjgoMjU2KSxvPTA7bzwyNTY7bysrKXNbb109MjUyPD1vPzY6MjQ4PD1vPzU6MjQwPD1vPzQ6MjI0PD1vPzM6MTkyPD1vPzI6MTtmdW5jdGlvbiB1KGUsdCl7aWYodDw2NTUzNyYmKGUuc3ViYXJyYXkmJml8fCFlLnN1YmFycmF5JiZhKSlyZXR1cm4gU3RyaW5nLmZyb21DaGFyQ29kZS5hcHBseShudWxsLG4uc2hyaW5rQnVmKGUsdCkpO2Zvcih2YXIgcj0iIixzPTA7czx0O3MrKylyKz1TdHJpbmcuZnJvbUNoYXJDb2RlKGVbc10pO3JldHVybiByfXNbMjU0XT1zWzI1NF09MSxyLnN0cmluZzJidWY9ZnVuY3Rpb24oZSl7dmFyIHQscixhLGkscyxvPWUubGVuZ3RoLHU9MDtmb3IoaT0wO2k8bztpKyspNTUyOTY9PSg2NDUxMiYocj1lLmNoYXJDb2RlQXQoaSkpKSYmaSsxPG8mJjU2MzIwPT0oNjQ1MTImKGE9ZS5jaGFyQ29kZUF0KGkrMSkpKSYmKHI9NjU1MzYrKHItNTUyOTY8PDEwKSsoYS01NjMyMCksaSsrKSx1Kz1yPDEyOD8xOnI8MjA0OD8yOnI8NjU1MzY/Mzo0O2Zvcih0PW5ldyBuLkJ1ZjgodSksaT1zPTA7czx1O2krKyk1NTI5Nj09KDY0NTEyJihyPWUuY2hhckNvZGVBdChpKSkpJiZpKzE8byYmNTYzMjA9PSg2NDUxMiYoYT1lLmNoYXJDb2RlQXQoaSsxKSkpJiYocj02NTUzNisoci01NTI5Njw8MTApKyhhLTU2MzIwKSxpKyspLHI8MTI4P3RbcysrXT1yOihyPDIwNDg/dFtzKytdPTE5MnxyPj4+Njoocjw2NTUzNj90W3MrK109MjI0fHI+Pj4xMjoodFtzKytdPTI0MHxyPj4+MTgsdFtzKytdPTEyOHxyPj4+MTImNjMpLHRbcysrXT0xMjh8cj4+PjYmNjMpLHRbcysrXT0xMjh8NjMmcik7cmV0dXJuIHR9LHIuYnVmMmJpbnN0cmluZz1mdW5jdGlvbihlKXtyZXR1cm4gdShlLGUubGVuZ3RoKX0sci5iaW5zdHJpbmcyYnVmPWZ1bmN0aW9uKGUpe2Zvcih2YXIgdD1uZXcgbi5CdWY4KGUubGVuZ3RoKSxyPTAsYT10Lmxlbmd0aDtyPGE7cisrKXRbcl09ZS5jaGFyQ29kZUF0KHIpO3JldHVybiB0fSxyLmJ1ZjJzdHJpbmc9ZnVuY3Rpb24oZSx0KXt2YXIgcixuLGEsaSxvPXR8fGUubGVuZ3RoLGw9bmV3IEFycmF5KDIqbyk7Zm9yKHI9bj0wO3I8bzspaWYoKGE9ZVtyKytdKTwxMjgpbFtuKytdPWE7ZWxzZSBpZig0PChpPXNbYV0pKWxbbisrXT02NTUzMyxyKz1pLTE7ZWxzZSB7Zm9yKGEmPTI9PT1pPzMxOjM9PT1pPzE1Ojc7MTxpJiZyPG87KWE9YTw8Nnw2MyZlW3IrK10saS0tOzE8aT9sW24rK109NjU1MzM6YTw2NTUzNj9sW24rK109YTooYS09NjU1MzYsbFtuKytdPTU1Mjk2fGE+PjEwJjEwMjMsbFtuKytdPTU2MzIwfDEwMjMmYSk7fXJldHVybiB1KGwsbil9LHIudXRmOGJvcmRlcj1mdW5jdGlvbihlLHQpe3ZhciByO2ZvcigodD10fHxlLmxlbmd0aCk+ZS5sZW5ndGgmJih0PWUubGVuZ3RoKSxyPXQtMTswPD1yJiYxMjg9PSgxOTImZVtyXSk7KXItLTtyZXR1cm4gcjwwP3Q6MD09PXI/dDpyK3NbZVtyXV0+dD9yOnR9O30seyIuL2NvbW1vbiI6NDF9XSw0MzpbZnVuY3Rpb24oZSx0LHIpe3QuZXhwb3J0cz1mdW5jdGlvbihlLHQscixuKXtmb3IodmFyIGE9NjU1MzUmZXwwLGk9ZT4+PjE2JjY1NTM1fDAscz0wOzAhPT1yOyl7Zm9yKHItPXM9MmUzPHI/MmUzOnI7aT1pKyhhPWErdFtuKytdfDApfDAsLS1zOyk7YSU9NjU1MjEsaSU9NjU1MjE7fXJldHVybiBhfGk8PDE2fDB9O30se31dLDQ0OltmdW5jdGlvbihlLHQscil7dC5leHBvcnRzPXtaX05PX0ZMVVNIOjAsWl9QQVJUSUFMX0ZMVVNIOjEsWl9TWU5DX0ZMVVNIOjIsWl9GVUxMX0ZMVVNIOjMsWl9GSU5JU0g6NCxaX0JMT0NLOjUsWl9UUkVFUzo2LFpfT0s6MCxaX1NUUkVBTV9FTkQ6MSxaX05FRURfRElDVDoyLFpfRVJSTk86LTEsWl9TVFJFQU1fRVJST1I6LTIsWl9EQVRBX0VSUk9SOi0zLFpfQlVGX0VSUk9SOi01LFpfTk9fQ09NUFJFU1NJT046MCxaX0JFU1RfU1BFRUQ6MSxaX0JFU1RfQ09NUFJFU1NJT046OSxaX0RFRkFVTFRfQ09NUFJFU1NJT046LTEsWl9GSUxURVJFRDoxLFpfSFVGRk1BTl9PTkxZOjIsWl9STEU6MyxaX0ZJWEVEOjQsWl9ERUZBVUxUX1NUUkFURUdZOjAsWl9CSU5BUlk6MCxaX1RFWFQ6MSxaX1VOS05PV046MixaX0RFRkxBVEVEOjh9O30se31dLDQ1OltmdW5jdGlvbihlLHQscil7dmFyIG49ZnVuY3Rpb24oKXtmb3IodmFyIGUsdD1bXSxyPTA7cjwyNTY7cisrKXtlPXI7Zm9yKHZhciBuPTA7bjw4O24rKyllPTEmZT8zOTg4MjkyMzg0XmU+Pj4xOmU+Pj4xO3Rbcl09ZTt9cmV0dXJuIHR9KCk7dC5leHBvcnRzPWZ1bmN0aW9uKGUsdCxyLGEpe3ZhciBpPW4scz1hK3I7ZV49LTE7Zm9yKHZhciBvPWE7bzxzO28rKyllPWU+Pj44XmlbMjU1JihlXnRbb10pXTtyZXR1cm4gLTFeZX07fSx7fV0sNDY6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbixhPWUoIi4uL3V0aWxzL2NvbW1vbiIpLGk9ZSgiLi90cmVlcyIpLHM9ZSgiLi9hZGxlcjMyIiksbz1lKCIuL2NyYzMyIiksdT1lKCIuL21lc3NhZ2VzIiksbD0tMixjPTI1OCxoPTI2MixkPTExMztmdW5jdGlvbiBmKGUsdCl7cmV0dXJuIGUubXNnPXVbdF0sdH1mdW5jdGlvbiBwKGUpe3JldHVybiAoZTw8MSktKDQ8ZT85OjApfWZ1bmN0aW9uIG0oZSl7Zm9yKHZhciB0PWUubGVuZ3RoOzA8PS0tdDspZVt0XT0wO31mdW5jdGlvbiBnKGUpe3ZhciB0PWUuc3RhdGUscj10LnBlbmRpbmc7cj5lLmF2YWlsX291dCYmKHI9ZS5hdmFpbF9vdXQpLDAhPT1yJiYoYS5hcnJheVNldChlLm91dHB1dCx0LnBlbmRpbmdfYnVmLHQucGVuZGluZ19vdXQscixlLm5leHRfb3V0KSxlLm5leHRfb3V0Kz1yLHQucGVuZGluZ19vdXQrPXIsZS50b3RhbF9vdXQrPXIsZS5hdmFpbF9vdXQtPXIsdC5wZW5kaW5nLT1yLDA9PT10LnBlbmRpbmcmJih0LnBlbmRpbmdfb3V0PTApKTt9ZnVuY3Rpb24gXyhlLHQpe2kuX3RyX2ZsdXNoX2Jsb2NrKGUsMDw9ZS5ibG9ja19zdGFydD9lLmJsb2NrX3N0YXJ0Oi0xLGUuc3Ryc3RhcnQtZS5ibG9ja19zdGFydCx0KSxlLmJsb2NrX3N0YXJ0PWUuc3Ryc3RhcnQsZyhlLnN0cm0pO31mdW5jdGlvbiB5KGUsdCl7ZS5wZW5kaW5nX2J1ZltlLnBlbmRpbmcrK109dDt9ZnVuY3Rpb24gdihlLHQpe2UucGVuZGluZ19idWZbZS5wZW5kaW5nKytdPXQ+Pj44JjI1NSxlLnBlbmRpbmdfYnVmW2UucGVuZGluZysrXT0yNTUmdDt9ZnVuY3Rpb24gYihlLHQpe3ZhciByLG4sYT1lLm1heF9jaGFpbl9sZW5ndGgsaT1lLnN0cnN0YXJ0LHM9ZS5wcmV2X2xlbmd0aCxvPWUubmljZV9tYXRjaCx1PWUuc3Ryc3RhcnQ+ZS53X3NpemUtaD9lLnN0cnN0YXJ0LShlLndfc2l6ZS1oKTowLGw9ZS53aW5kb3csZD1lLndfbWFzayxmPWUucHJldixwPWUuc3Ryc3RhcnQrYyxtPWxbaStzLTFdLGc9bFtpK3NdO2UucHJldl9sZW5ndGg+PWUuZ29vZF9tYXRjaCYmKGE+Pj0yKSxvPmUubG9va2FoZWFkJiYobz1lLmxvb2thaGVhZCk7ZG97aWYobFsocj10KStzXT09PWcmJmxbcitzLTFdPT09bSYmbFtyXT09PWxbaV0mJmxbKytyXT09PWxbaSsxXSl7aSs9MixyKys7ZG97fXdoaWxlKGxbKytpXT09PWxbKytyXSYmbFsrK2ldPT09bFsrK3JdJiZsWysraV09PT1sWysrcl0mJmxbKytpXT09PWxbKytyXSYmbFsrK2ldPT09bFsrK3JdJiZsWysraV09PT1sWysrcl0mJmxbKytpXT09PWxbKytyXSYmbFsrK2ldPT09bFsrK3JdJiZpPHApO2lmKG49Yy0ocC1pKSxpPXAtYyxzPG4pe2lmKGUubWF0Y2hfc3RhcnQ9dCxvPD0ocz1uKSlicmVhazttPWxbaStzLTFdLGc9bFtpK3NdO319fXdoaWxlKCh0PWZbdCZkXSk+dSYmMCE9LS1hKTtyZXR1cm4gczw9ZS5sb29rYWhlYWQ/czplLmxvb2thaGVhZH1mdW5jdGlvbiB3KGUpe3ZhciB0LHIsbixpLHUsbCxjLGQsZixwLG09ZS53X3NpemU7ZG97aWYoaT1lLndpbmRvd19zaXplLWUubG9va2FoZWFkLWUuc3Ryc3RhcnQsZS5zdHJzdGFydD49bSsobS1oKSl7Zm9yKGEuYXJyYXlTZXQoZS53aW5kb3csZS53aW5kb3csbSxtLDApLGUubWF0Y2hfc3RhcnQtPW0sZS5zdHJzdGFydC09bSxlLmJsb2NrX3N0YXJ0LT1tLHQ9cj1lLmhhc2hfc2l6ZTtuPWUuaGVhZFstLXRdLGUuaGVhZFt0XT1tPD1uP24tbTowLC0tcjspO2Zvcih0PXI9bTtuPWUucHJldlstLXRdLGUucHJldlt0XT1tPD1uP24tbTowLC0tcjspO2krPW07fWlmKDA9PT1lLnN0cm0uYXZhaWxfaW4pYnJlYWs7aWYobD1lLnN0cm0sYz1lLndpbmRvdyxkPWUuc3Ryc3RhcnQrZS5sb29rYWhlYWQscD12b2lkIDAsKGY9aSk8KHA9bC5hdmFpbF9pbikmJihwPWYpLHI9MD09PXA/MDoobC5hdmFpbF9pbi09cCxhLmFycmF5U2V0KGMsbC5pbnB1dCxsLm5leHRfaW4scCxkKSwxPT09bC5zdGF0ZS53cmFwP2wuYWRsZXI9cyhsLmFkbGVyLGMscCxkKToyPT09bC5zdGF0ZS53cmFwJiYobC5hZGxlcj1vKGwuYWRsZXIsYyxwLGQpKSxsLm5leHRfaW4rPXAsbC50b3RhbF9pbis9cCxwKSxlLmxvb2thaGVhZCs9cixlLmxvb2thaGVhZCtlLmluc2VydD49Mylmb3IodT1lLnN0cnN0YXJ0LWUuaW5zZXJ0LGUuaW5zX2g9ZS53aW5kb3dbdV0sZS5pbnNfaD0oZS5pbnNfaDw8ZS5oYXNoX3NoaWZ0XmUud2luZG93W3UrMV0pJmUuaGFzaF9tYXNrO2UuaW5zZXJ0JiYoZS5pbnNfaD0oZS5pbnNfaDw8ZS5oYXNoX3NoaWZ0XmUud2luZG93W3UrMy0xXSkmZS5oYXNoX21hc2ssZS5wcmV2W3UmZS53X21hc2tdPWUuaGVhZFtlLmluc19oXSxlLmhlYWRbZS5pbnNfaF09dSx1KyssZS5pbnNlcnQtLSwhKGUubG9va2FoZWFkK2UuaW5zZXJ0PDMpKTspO313aGlsZShlLmxvb2thaGVhZDxoJiYwIT09ZS5zdHJtLmF2YWlsX2luKX1mdW5jdGlvbiBrKGUsdCl7Zm9yKHZhciByLG47Oyl7aWYoZS5sb29rYWhlYWQ8aCl7aWYodyhlKSxlLmxvb2thaGVhZDxoJiYwPT09dClyZXR1cm4gMTtpZigwPT09ZS5sb29rYWhlYWQpYnJlYWt9aWYocj0wLGUubG9va2FoZWFkPj0zJiYoZS5pbnNfaD0oZS5pbnNfaDw8ZS5oYXNoX3NoaWZ0XmUud2luZG93W2Uuc3Ryc3RhcnQrMy0xXSkmZS5oYXNoX21hc2sscj1lLnByZXZbZS5zdHJzdGFydCZlLndfbWFza109ZS5oZWFkW2UuaW5zX2hdLGUuaGVhZFtlLmluc19oXT1lLnN0cnN0YXJ0KSwwIT09ciYmZS5zdHJzdGFydC1yPD1lLndfc2l6ZS1oJiYoZS5tYXRjaF9sZW5ndGg9YihlLHIpKSxlLm1hdGNoX2xlbmd0aD49MylpZihuPWkuX3RyX3RhbGx5KGUsZS5zdHJzdGFydC1lLm1hdGNoX3N0YXJ0LGUubWF0Y2hfbGVuZ3RoLTMpLGUubG9va2FoZWFkLT1lLm1hdGNoX2xlbmd0aCxlLm1hdGNoX2xlbmd0aDw9ZS5tYXhfbGF6eV9tYXRjaCYmZS5sb29rYWhlYWQ+PTMpe2ZvcihlLm1hdGNoX2xlbmd0aC0tO2Uuc3Ryc3RhcnQrKyxlLmluc19oPShlLmluc19oPDxlLmhhc2hfc2hpZnReZS53aW5kb3dbZS5zdHJzdGFydCszLTFdKSZlLmhhc2hfbWFzayxyPWUucHJldltlLnN0cnN0YXJ0JmUud19tYXNrXT1lLmhlYWRbZS5pbnNfaF0sZS5oZWFkW2UuaW5zX2hdPWUuc3Ryc3RhcnQsMCE9LS1lLm1hdGNoX2xlbmd0aDspO2Uuc3Ryc3RhcnQrKzt9ZWxzZSBlLnN0cnN0YXJ0Kz1lLm1hdGNoX2xlbmd0aCxlLm1hdGNoX2xlbmd0aD0wLGUuaW5zX2g9ZS53aW5kb3dbZS5zdHJzdGFydF0sZS5pbnNfaD0oZS5pbnNfaDw8ZS5oYXNoX3NoaWZ0XmUud2luZG93W2Uuc3Ryc3RhcnQrMV0pJmUuaGFzaF9tYXNrO2Vsc2Ugbj1pLl90cl90YWxseShlLDAsZS53aW5kb3dbZS5zdHJzdGFydF0pLGUubG9va2FoZWFkLS0sZS5zdHJzdGFydCsrO2lmKG4mJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KSlyZXR1cm4gMX1yZXR1cm4gZS5pbnNlcnQ9ZS5zdHJzdGFydDwyP2Uuc3Ryc3RhcnQ6Miw0PT09dD8oXyhlLCEwKSwwPT09ZS5zdHJtLmF2YWlsX291dD8zOjQpOmUubGFzdF9saXQmJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KT8xOjJ9ZnVuY3Rpb24gTihlLHQpe2Zvcih2YXIgcixuLGE7Oyl7aWYoZS5sb29rYWhlYWQ8aCl7aWYodyhlKSxlLmxvb2thaGVhZDxoJiYwPT09dClyZXR1cm4gMTtpZigwPT09ZS5sb29rYWhlYWQpYnJlYWt9aWYocj0wLGUubG9va2FoZWFkPj0zJiYoZS5pbnNfaD0oZS5pbnNfaDw8ZS5oYXNoX3NoaWZ0XmUud2luZG93W2Uuc3Ryc3RhcnQrMy0xXSkmZS5oYXNoX21hc2sscj1lLnByZXZbZS5zdHJzdGFydCZlLndfbWFza109ZS5oZWFkW2UuaW5zX2hdLGUuaGVhZFtlLmluc19oXT1lLnN0cnN0YXJ0KSxlLnByZXZfbGVuZ3RoPWUubWF0Y2hfbGVuZ3RoLGUucHJldl9tYXRjaD1lLm1hdGNoX3N0YXJ0LGUubWF0Y2hfbGVuZ3RoPTIsMCE9PXImJmUucHJldl9sZW5ndGg8ZS5tYXhfbGF6eV9tYXRjaCYmZS5zdHJzdGFydC1yPD1lLndfc2l6ZS1oJiYoZS5tYXRjaF9sZW5ndGg9YihlLHIpLGUubWF0Y2hfbGVuZ3RoPD01JiYoMT09PWUuc3RyYXRlZ3l8fDM9PT1lLm1hdGNoX2xlbmd0aCYmNDA5NjxlLnN0cnN0YXJ0LWUubWF0Y2hfc3RhcnQpJiYoZS5tYXRjaF9sZW5ndGg9MikpLGUucHJldl9sZW5ndGg+PTMmJmUubWF0Y2hfbGVuZ3RoPD1lLnByZXZfbGVuZ3RoKXtmb3IoYT1lLnN0cnN0YXJ0K2UubG9va2FoZWFkLTMsbj1pLl90cl90YWxseShlLGUuc3Ryc3RhcnQtMS1lLnByZXZfbWF0Y2gsZS5wcmV2X2xlbmd0aC0zKSxlLmxvb2thaGVhZC09ZS5wcmV2X2xlbmd0aC0xLGUucHJldl9sZW5ndGgtPTI7KytlLnN0cnN0YXJ0PD1hJiYoZS5pbnNfaD0oZS5pbnNfaDw8ZS5oYXNoX3NoaWZ0XmUud2luZG93W2Uuc3Ryc3RhcnQrMy0xXSkmZS5oYXNoX21hc2sscj1lLnByZXZbZS5zdHJzdGFydCZlLndfbWFza109ZS5oZWFkW2UuaW5zX2hdLGUuaGVhZFtlLmluc19oXT1lLnN0cnN0YXJ0KSwwIT0tLWUucHJldl9sZW5ndGg7KTtpZihlLm1hdGNoX2F2YWlsYWJsZT0wLGUubWF0Y2hfbGVuZ3RoPTIsZS5zdHJzdGFydCsrLG4mJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KSlyZXR1cm4gMX1lbHNlIGlmKGUubWF0Y2hfYXZhaWxhYmxlKXtpZigobj1pLl90cl90YWxseShlLDAsZS53aW5kb3dbZS5zdHJzdGFydC0xXSkpJiZfKGUsITEpLGUuc3Ryc3RhcnQrKyxlLmxvb2thaGVhZC0tLDA9PT1lLnN0cm0uYXZhaWxfb3V0KXJldHVybiAxfWVsc2UgZS5tYXRjaF9hdmFpbGFibGU9MSxlLnN0cnN0YXJ0KyssZS5sb29rYWhlYWQtLTt9cmV0dXJuIGUubWF0Y2hfYXZhaWxhYmxlJiYobj1pLl90cl90YWxseShlLDAsZS53aW5kb3dbZS5zdHJzdGFydC0xXSksZS5tYXRjaF9hdmFpbGFibGU9MCksZS5pbnNlcnQ9ZS5zdHJzdGFydDwyP2Uuc3Ryc3RhcnQ6Miw0PT09dD8oXyhlLCEwKSwwPT09ZS5zdHJtLmF2YWlsX291dD8zOjQpOmUubGFzdF9saXQmJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KT8xOjJ9ZnVuY3Rpb24gUyhlLHQscixuLGEpe3RoaXMuZ29vZF9sZW5ndGg9ZSx0aGlzLm1heF9sYXp5PXQsdGhpcy5uaWNlX2xlbmd0aD1yLHRoaXMubWF4X2NoYWluPW4sdGhpcy5mdW5jPWE7fWZ1bmN0aW9uIHgoKXt0aGlzLnN0cm09bnVsbCx0aGlzLnN0YXR1cz0wLHRoaXMucGVuZGluZ19idWY9bnVsbCx0aGlzLnBlbmRpbmdfYnVmX3NpemU9MCx0aGlzLnBlbmRpbmdfb3V0PTAsdGhpcy5wZW5kaW5nPTAsdGhpcy53cmFwPTAsdGhpcy5nemhlYWQ9bnVsbCx0aGlzLmd6aW5kZXg9MCx0aGlzLm1ldGhvZD04LHRoaXMubGFzdF9mbHVzaD0tMSx0aGlzLndfc2l6ZT0wLHRoaXMud19iaXRzPTAsdGhpcy53X21hc2s9MCx0aGlzLndpbmRvdz1udWxsLHRoaXMud2luZG93X3NpemU9MCx0aGlzLnByZXY9bnVsbCx0aGlzLmhlYWQ9bnVsbCx0aGlzLmluc19oPTAsdGhpcy5oYXNoX3NpemU9MCx0aGlzLmhhc2hfYml0cz0wLHRoaXMuaGFzaF9tYXNrPTAsdGhpcy5oYXNoX3NoaWZ0PTAsdGhpcy5ibG9ja19zdGFydD0wLHRoaXMubWF0Y2hfbGVuZ3RoPTAsdGhpcy5wcmV2X21hdGNoPTAsdGhpcy5tYXRjaF9hdmFpbGFibGU9MCx0aGlzLnN0cnN0YXJ0PTAsdGhpcy5tYXRjaF9zdGFydD0wLHRoaXMubG9va2FoZWFkPTAsdGhpcy5wcmV2X2xlbmd0aD0wLHRoaXMubWF4X2NoYWluX2xlbmd0aD0wLHRoaXMubWF4X2xhenlfbWF0Y2g9MCx0aGlzLmxldmVsPTAsdGhpcy5zdHJhdGVneT0wLHRoaXMuZ29vZF9tYXRjaD0wLHRoaXMubmljZV9tYXRjaD0wLHRoaXMuZHluX2x0cmVlPW5ldyBhLkJ1ZjE2KDExNDYpLHRoaXMuZHluX2R0cmVlPW5ldyBhLkJ1ZjE2KDEyMiksdGhpcy5ibF90cmVlPW5ldyBhLkJ1ZjE2KDc4KSxtKHRoaXMuZHluX2x0cmVlKSxtKHRoaXMuZHluX2R0cmVlKSxtKHRoaXMuYmxfdHJlZSksdGhpcy5sX2Rlc2M9bnVsbCx0aGlzLmRfZGVzYz1udWxsLHRoaXMuYmxfZGVzYz1udWxsLHRoaXMuYmxfY291bnQ9bmV3IGEuQnVmMTYoMTYpLHRoaXMuaGVhcD1uZXcgYS5CdWYxNig1NzMpLG0odGhpcy5oZWFwKSx0aGlzLmhlYXBfbGVuPTAsdGhpcy5oZWFwX21heD0wLHRoaXMuZGVwdGg9bmV3IGEuQnVmMTYoNTczKSxtKHRoaXMuZGVwdGgpLHRoaXMubF9idWY9MCx0aGlzLmxpdF9idWZzaXplPTAsdGhpcy5sYXN0X2xpdD0wLHRoaXMuZF9idWY9MCx0aGlzLm9wdF9sZW49MCx0aGlzLnN0YXRpY19sZW49MCx0aGlzLm1hdGNoZXM9MCx0aGlzLmluc2VydD0wLHRoaXMuYmlfYnVmPTAsdGhpcy5iaV92YWxpZD0wO31mdW5jdGlvbiBDKGUpe3ZhciB0O3JldHVybiBlJiZlLnN0YXRlPyhlLnRvdGFsX2luPWUudG90YWxfb3V0PTAsZS5kYXRhX3R5cGU9MiwodD1lLnN0YXRlKS5wZW5kaW5nPTAsdC5wZW5kaW5nX291dD0wLHQud3JhcDwwJiYodC53cmFwPS10LndyYXApLHQuc3RhdHVzPXQud3JhcD80MjpkLGUuYWRsZXI9Mj09PXQud3JhcD8wOjEsdC5sYXN0X2ZsdXNoPTAsaS5fdHJfaW5pdCh0KSwwKTpmKGUsbCl9ZnVuY3Rpb24gUChlKXt2YXIgdD1DKGUpO3JldHVybiAwPT09dCYmZnVuY3Rpb24oZSl7ZS53aW5kb3dfc2l6ZT0yKmUud19zaXplLG0oZS5oZWFkKSxlLm1heF9sYXp5X21hdGNoPW5bZS5sZXZlbF0ubWF4X2xhenksZS5nb29kX21hdGNoPW5bZS5sZXZlbF0uZ29vZF9sZW5ndGgsZS5uaWNlX21hdGNoPW5bZS5sZXZlbF0ubmljZV9sZW5ndGgsZS5tYXhfY2hhaW5fbGVuZ3RoPW5bZS5sZXZlbF0ubWF4X2NoYWluLGUuc3Ryc3RhcnQ9MCxlLmJsb2NrX3N0YXJ0PTAsZS5sb29rYWhlYWQ9MCxlLmluc2VydD0wLGUubWF0Y2hfbGVuZ3RoPWUucHJldl9sZW5ndGg9MixlLm1hdGNoX2F2YWlsYWJsZT0wLGUuaW5zX2g9MDt9KGUuc3RhdGUpLHR9ZnVuY3Rpb24gRShlLHQscixuLGkscyl7aWYoIWUpcmV0dXJuIGw7dmFyIG89MTtpZigtMT09PXQmJih0PTYpLG48MD8obz0wLG49LW4pOjE1PG4mJihvPTIsbi09MTYpLGk8MXx8OTxpfHw4IT09cnx8bjw4fHwxNTxufHx0PDB8fDk8dHx8czwwfHw0PHMpcmV0dXJuIGYoZSxsKTs4PT09biYmKG49OSk7dmFyIHU9bmV3IHg7cmV0dXJuIChlLnN0YXRlPXUpLnN0cm09ZSx1LndyYXA9byx1Lmd6aGVhZD1udWxsLHUud19iaXRzPW4sdS53X3NpemU9MTw8dS53X2JpdHMsdS53X21hc2s9dS53X3NpemUtMSx1Lmhhc2hfYml0cz1pKzcsdS5oYXNoX3NpemU9MTw8dS5oYXNoX2JpdHMsdS5oYXNoX21hc2s9dS5oYXNoX3NpemUtMSx1Lmhhc2hfc2hpZnQ9fn4oKHUuaGFzaF9iaXRzKzMtMSkvMyksdS53aW5kb3c9bmV3IGEuQnVmOCgyKnUud19zaXplKSx1LmhlYWQ9bmV3IGEuQnVmMTYodS5oYXNoX3NpemUpLHUucHJldj1uZXcgYS5CdWYxNih1Lndfc2l6ZSksdS5saXRfYnVmc2l6ZT0xPDxpKzYsdS5wZW5kaW5nX2J1Zl9zaXplPTQqdS5saXRfYnVmc2l6ZSx1LnBlbmRpbmdfYnVmPW5ldyBhLkJ1ZjgodS5wZW5kaW5nX2J1Zl9zaXplKSx1LmRfYnVmPTEqdS5saXRfYnVmc2l6ZSx1LmxfYnVmPTMqdS5saXRfYnVmc2l6ZSx1LmxldmVsPXQsdS5zdHJhdGVneT1zLHUubWV0aG9kPXIsUChlKX1uPVtuZXcgUygwLDAsMCwwLChmdW5jdGlvbihlLHQpe3ZhciByPTY1NTM1O2ZvcihyPmUucGVuZGluZ19idWZfc2l6ZS01JiYocj1lLnBlbmRpbmdfYnVmX3NpemUtNSk7Oyl7aWYoZS5sb29rYWhlYWQ8PTEpe2lmKHcoZSksMD09PWUubG9va2FoZWFkJiYwPT09dClyZXR1cm4gMTtpZigwPT09ZS5sb29rYWhlYWQpYnJlYWt9ZS5zdHJzdGFydCs9ZS5sb29rYWhlYWQsZS5sb29rYWhlYWQ9MDt2YXIgbj1lLmJsb2NrX3N0YXJ0K3I7aWYoKDA9PT1lLnN0cnN0YXJ0fHxlLnN0cnN0YXJ0Pj1uKSYmKGUubG9va2FoZWFkPWUuc3Ryc3RhcnQtbixlLnN0cnN0YXJ0PW4sXyhlLCExKSwwPT09ZS5zdHJtLmF2YWlsX291dCkpcmV0dXJuIDE7aWYoZS5zdHJzdGFydC1lLmJsb2NrX3N0YXJ0Pj1lLndfc2l6ZS1oJiYoXyhlLCExKSwwPT09ZS5zdHJtLmF2YWlsX291dCkpcmV0dXJuIDF9cmV0dXJuIGUuaW5zZXJ0PTAsND09PXQ/KF8oZSwhMCksMD09PWUuc3RybS5hdmFpbF9vdXQ/Mzo0KTooZS5zdHJzdGFydD5lLmJsb2NrX3N0YXJ0JiYoXyhlLCExKSxlLnN0cm0uYXZhaWxfb3V0KSwxKX0pKSxuZXcgUyg0LDQsOCw0LGspLG5ldyBTKDQsNSwxNiw4LGspLG5ldyBTKDQsNiwzMiwzMixrKSxuZXcgUyg0LDQsMTYsMTYsTiksbmV3IFMoOCwxNiwzMiwzMixOKSxuZXcgUyg4LDE2LDEyOCwxMjgsTiksbmV3IFMoOCwzMiwxMjgsMjU2LE4pLG5ldyBTKDMyLDEyOCwyNTgsMTAyNCxOKSxuZXcgUygzMiwyNTgsMjU4LDQwOTYsTildLHIuZGVmbGF0ZUluaXQ9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gRShlLHQsOCwxNSw4LDApfSxyLmRlZmxhdGVJbml0Mj1FLHIuZGVmbGF0ZVJlc2V0PVAsci5kZWZsYXRlUmVzZXRLZWVwPUMsci5kZWZsYXRlU2V0SGVhZGVyPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIGUmJmUuc3RhdGU/MiE9PWUuc3RhdGUud3JhcD9sOihlLnN0YXRlLmd6aGVhZD10LDApOmx9LHIuZGVmbGF0ZT1mdW5jdGlvbihlLHQpe3ZhciByLGEscyx1O2lmKCFlfHwhZS5zdGF0ZXx8NTx0fHx0PDApcmV0dXJuIGU/ZihlLGwpOmw7aWYoYT1lLnN0YXRlLCFlLm91dHB1dHx8IWUuaW5wdXQmJjAhPT1lLmF2YWlsX2lufHw2NjY9PT1hLnN0YXR1cyYmNCE9PXQpcmV0dXJuIGYoZSwwPT09ZS5hdmFpbF9vdXQ/LTU6bCk7aWYoYS5zdHJtPWUscj1hLmxhc3RfZmx1c2gsYS5sYXN0X2ZsdXNoPXQsNDI9PT1hLnN0YXR1cylpZigyPT09YS53cmFwKWUuYWRsZXI9MCx5KGEsMzEpLHkoYSwxMzkpLHkoYSw4KSxhLmd6aGVhZD8oeShhLChhLmd6aGVhZC50ZXh0PzE6MCkrKGEuZ3poZWFkLmhjcmM/MjowKSsoYS5nemhlYWQuZXh0cmE/NDowKSsoYS5nemhlYWQubmFtZT84OjApKyhhLmd6aGVhZC5jb21tZW50PzE2OjApKSx5KGEsMjU1JmEuZ3poZWFkLnRpbWUpLHkoYSxhLmd6aGVhZC50aW1lPj44JjI1NSkseShhLGEuZ3poZWFkLnRpbWU+PjE2JjI1NSkseShhLGEuZ3poZWFkLnRpbWU+PjI0JjI1NSkseShhLDk9PT1hLmxldmVsPzI6Mjw9YS5zdHJhdGVneXx8YS5sZXZlbDwyPzQ6MCkseShhLDI1NSZhLmd6aGVhZC5vcyksYS5nemhlYWQuZXh0cmEmJmEuZ3poZWFkLmV4dHJhLmxlbmd0aCYmKHkoYSwyNTUmYS5nemhlYWQuZXh0cmEubGVuZ3RoKSx5KGEsYS5nemhlYWQuZXh0cmEubGVuZ3RoPj44JjI1NSkpLGEuZ3poZWFkLmhjcmMmJihlLmFkbGVyPW8oZS5hZGxlcixhLnBlbmRpbmdfYnVmLGEucGVuZGluZywwKSksYS5nemluZGV4PTAsYS5zdGF0dXM9NjkpOih5KGEsMCkseShhLDApLHkoYSwwKSx5KGEsMCkseShhLDApLHkoYSw5PT09YS5sZXZlbD8yOjI8PWEuc3RyYXRlZ3l8fGEubGV2ZWw8Mj80OjApLHkoYSwzKSxhLnN0YXR1cz1kKTtlbHNlIHt2YXIgaD04KyhhLndfYml0cy04PDw0KTw8ODtofD0oMjw9YS5zdHJhdGVneXx8YS5sZXZlbDwyPzA6YS5sZXZlbDw2PzE6Nj09PWEubGV2ZWw/MjozKTw8NiwwIT09YS5zdHJzdGFydCYmKGh8PTMyKSxoKz0zMS1oJTMxLGEuc3RhdHVzPWQsdihhLGgpLDAhPT1hLnN0cnN0YXJ0JiYodihhLGUuYWRsZXI+Pj4xNiksdihhLDY1NTM1JmUuYWRsZXIpKSxlLmFkbGVyPTE7fWlmKDY5PT09YS5zdGF0dXMpaWYoYS5nemhlYWQuZXh0cmEpe2ZvcihzPWEucGVuZGluZzthLmd6aW5kZXg8KDY1NTM1JmEuZ3poZWFkLmV4dHJhLmxlbmd0aCkmJihhLnBlbmRpbmchPT1hLnBlbmRpbmdfYnVmX3NpemV8fChhLmd6aGVhZC5oY3JjJiZhLnBlbmRpbmc+cyYmKGUuYWRsZXI9byhlLmFkbGVyLGEucGVuZGluZ19idWYsYS5wZW5kaW5nLXMscykpLGcoZSkscz1hLnBlbmRpbmcsYS5wZW5kaW5nIT09YS5wZW5kaW5nX2J1Zl9zaXplKSk7KXkoYSwyNTUmYS5nemhlYWQuZXh0cmFbYS5nemluZGV4XSksYS5nemluZGV4Kys7YS5nemhlYWQuaGNyYyYmYS5wZW5kaW5nPnMmJihlLmFkbGVyPW8oZS5hZGxlcixhLnBlbmRpbmdfYnVmLGEucGVuZGluZy1zLHMpKSxhLmd6aW5kZXg9PT1hLmd6aGVhZC5leHRyYS5sZW5ndGgmJihhLmd6aW5kZXg9MCxhLnN0YXR1cz03Myk7fWVsc2UgYS5zdGF0dXM9NzM7aWYoNzM9PT1hLnN0YXR1cylpZihhLmd6aGVhZC5uYW1lKXtzPWEucGVuZGluZztkb3tpZihhLnBlbmRpbmc9PT1hLnBlbmRpbmdfYnVmX3NpemUmJihhLmd6aGVhZC5oY3JjJiZhLnBlbmRpbmc+cyYmKGUuYWRsZXI9byhlLmFkbGVyLGEucGVuZGluZ19idWYsYS5wZW5kaW5nLXMscykpLGcoZSkscz1hLnBlbmRpbmcsYS5wZW5kaW5nPT09YS5wZW5kaW5nX2J1Zl9zaXplKSl7dT0xO2JyZWFrfXU9YS5nemluZGV4PGEuZ3poZWFkLm5hbWUubGVuZ3RoPzI1NSZhLmd6aGVhZC5uYW1lLmNoYXJDb2RlQXQoYS5nemluZGV4KyspOjAseShhLHUpO313aGlsZSgwIT09dSk7YS5nemhlYWQuaGNyYyYmYS5wZW5kaW5nPnMmJihlLmFkbGVyPW8oZS5hZGxlcixhLnBlbmRpbmdfYnVmLGEucGVuZGluZy1zLHMpKSwwPT09dSYmKGEuZ3ppbmRleD0wLGEuc3RhdHVzPTkxKTt9ZWxzZSBhLnN0YXR1cz05MTtpZig5MT09PWEuc3RhdHVzKWlmKGEuZ3poZWFkLmNvbW1lbnQpe3M9YS5wZW5kaW5nO2Rve2lmKGEucGVuZGluZz09PWEucGVuZGluZ19idWZfc2l6ZSYmKGEuZ3poZWFkLmhjcmMmJmEucGVuZGluZz5zJiYoZS5hZGxlcj1vKGUuYWRsZXIsYS5wZW5kaW5nX2J1ZixhLnBlbmRpbmctcyxzKSksZyhlKSxzPWEucGVuZGluZyxhLnBlbmRpbmc9PT1hLnBlbmRpbmdfYnVmX3NpemUpKXt1PTE7YnJlYWt9dT1hLmd6aW5kZXg8YS5nemhlYWQuY29tbWVudC5sZW5ndGg/MjU1JmEuZ3poZWFkLmNvbW1lbnQuY2hhckNvZGVBdChhLmd6aW5kZXgrKyk6MCx5KGEsdSk7fXdoaWxlKDAhPT11KTthLmd6aGVhZC5oY3JjJiZhLnBlbmRpbmc+cyYmKGUuYWRsZXI9byhlLmFkbGVyLGEucGVuZGluZ19idWYsYS5wZW5kaW5nLXMscykpLDA9PT11JiYoYS5zdGF0dXM9MTAzKTt9ZWxzZSBhLnN0YXR1cz0xMDM7aWYoMTAzPT09YS5zdGF0dXMmJihhLmd6aGVhZC5oY3JjPyhhLnBlbmRpbmcrMj5hLnBlbmRpbmdfYnVmX3NpemUmJmcoZSksYS5wZW5kaW5nKzI8PWEucGVuZGluZ19idWZfc2l6ZSYmKHkoYSwyNTUmZS5hZGxlcikseShhLGUuYWRsZXI+PjgmMjU1KSxlLmFkbGVyPTAsYS5zdGF0dXM9ZCkpOmEuc3RhdHVzPWQpLDAhPT1hLnBlbmRpbmcpe2lmKGcoZSksMD09PWUuYXZhaWxfb3V0KXJldHVybiBhLmxhc3RfZmx1c2g9LTEsMH1lbHNlIGlmKDA9PT1lLmF2YWlsX2luJiZwKHQpPD1wKHIpJiY0IT09dClyZXR1cm4gZihlLC01KTtpZig2NjY9PT1hLnN0YXR1cyYmMCE9PWUuYXZhaWxfaW4pcmV0dXJuIGYoZSwtNSk7aWYoMCE9PWUuYXZhaWxfaW58fDAhPT1hLmxvb2thaGVhZHx8MCE9PXQmJjY2NiE9PWEuc3RhdHVzKXt2YXIgYj0yPT09YS5zdHJhdGVneT9mdW5jdGlvbihlLHQpe2Zvcih2YXIgcjs7KXtpZigwPT09ZS5sb29rYWhlYWQmJih3KGUpLDA9PT1lLmxvb2thaGVhZCkpe2lmKDA9PT10KXJldHVybiAxO2JyZWFrfWlmKGUubWF0Y2hfbGVuZ3RoPTAscj1pLl90cl90YWxseShlLDAsZS53aW5kb3dbZS5zdHJzdGFydF0pLGUubG9va2FoZWFkLS0sZS5zdHJzdGFydCsrLHImJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KSlyZXR1cm4gMX1yZXR1cm4gZS5pbnNlcnQ9MCw0PT09dD8oXyhlLCEwKSwwPT09ZS5zdHJtLmF2YWlsX291dD8zOjQpOmUubGFzdF9saXQmJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KT8xOjJ9KGEsdCk6Mz09PWEuc3RyYXRlZ3k/ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHIsbixhLHMsbz1lLndpbmRvdzs7KXtpZihlLmxvb2thaGVhZDw9Yyl7aWYodyhlKSxlLmxvb2thaGVhZDw9YyYmMD09PXQpcmV0dXJuIDE7aWYoMD09PWUubG9va2FoZWFkKWJyZWFrfWlmKGUubWF0Y2hfbGVuZ3RoPTAsZS5sb29rYWhlYWQ+PTMmJjA8ZS5zdHJzdGFydCYmKG49b1thPWUuc3Ryc3RhcnQtMV0pPT09b1srK2FdJiZuPT09b1srK2FdJiZuPT09b1srK2FdKXtzPWUuc3Ryc3RhcnQrYztkb3t9d2hpbGUobj09PW9bKythXSYmbj09PW9bKythXSYmbj09PW9bKythXSYmbj09PW9bKythXSYmbj09PW9bKythXSYmbj09PW9bKythXSYmbj09PW9bKythXSYmbj09PW9bKythXSYmYTxzKTtlLm1hdGNoX2xlbmd0aD1jLShzLWEpLGUubWF0Y2hfbGVuZ3RoPmUubG9va2FoZWFkJiYoZS5tYXRjaF9sZW5ndGg9ZS5sb29rYWhlYWQpO31pZihlLm1hdGNoX2xlbmd0aD49Mz8ocj1pLl90cl90YWxseShlLDEsZS5tYXRjaF9sZW5ndGgtMyksZS5sb29rYWhlYWQtPWUubWF0Y2hfbGVuZ3RoLGUuc3Ryc3RhcnQrPWUubWF0Y2hfbGVuZ3RoLGUubWF0Y2hfbGVuZ3RoPTApOihyPWkuX3RyX3RhbGx5KGUsMCxlLndpbmRvd1tlLnN0cnN0YXJ0XSksZS5sb29rYWhlYWQtLSxlLnN0cnN0YXJ0KyspLHImJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KSlyZXR1cm4gMX1yZXR1cm4gZS5pbnNlcnQ9MCw0PT09dD8oXyhlLCEwKSwwPT09ZS5zdHJtLmF2YWlsX291dD8zOjQpOmUubGFzdF9saXQmJihfKGUsITEpLDA9PT1lLnN0cm0uYXZhaWxfb3V0KT8xOjJ9KGEsdCk6blthLmxldmVsXS5mdW5jKGEsdCk7aWYoMyE9PWImJjQhPT1ifHwoYS5zdGF0dXM9NjY2KSwxPT09Ynx8Mz09PWIpcmV0dXJuIDA9PT1lLmF2YWlsX291dCYmKGEubGFzdF9mbHVzaD0tMSksMDtpZigyPT09YiYmKDE9PT10P2kuX3RyX2FsaWduKGEpOjUhPT10JiYoaS5fdHJfc3RvcmVkX2Jsb2NrKGEsMCwwLCExKSwzPT09dCYmKG0oYS5oZWFkKSwwPT09YS5sb29rYWhlYWQmJihhLnN0cnN0YXJ0PTAsYS5ibG9ja19zdGFydD0wLGEuaW5zZXJ0PTApKSksZyhlKSwwPT09ZS5hdmFpbF9vdXQpKXJldHVybiBhLmxhc3RfZmx1c2g9LTEsMH1yZXR1cm4gNCE9PXQ/MDphLndyYXA8PTA/MTooMj09PWEud3JhcD8oeShhLDI1NSZlLmFkbGVyKSx5KGEsZS5hZGxlcj4+OCYyNTUpLHkoYSxlLmFkbGVyPj4xNiYyNTUpLHkoYSxlLmFkbGVyPj4yNCYyNTUpLHkoYSwyNTUmZS50b3RhbF9pbikseShhLGUudG90YWxfaW4+PjgmMjU1KSx5KGEsZS50b3RhbF9pbj4+MTYmMjU1KSx5KGEsZS50b3RhbF9pbj4+MjQmMjU1KSk6KHYoYSxlLmFkbGVyPj4+MTYpLHYoYSw2NTUzNSZlLmFkbGVyKSksZyhlKSwwPGEud3JhcCYmKGEud3JhcD0tYS53cmFwKSwwIT09YS5wZW5kaW5nPzA6MSl9LHIuZGVmbGF0ZUVuZD1mdW5jdGlvbihlKXt2YXIgdDtyZXR1cm4gZSYmZS5zdGF0ZT80MiE9PSh0PWUuc3RhdGUuc3RhdHVzKSYmNjkhPT10JiY3MyE9PXQmJjkxIT09dCYmMTAzIT09dCYmdCE9PWQmJjY2NiE9PXQ/ZihlLGwpOihlLnN0YXRlPW51bGwsdD09PWQ/ZihlLC0zKTowKTpsfSxyLmRlZmxhdGVTZXREaWN0aW9uYXJ5PWZ1bmN0aW9uKGUsdCl7dmFyIHIsbixpLG8sdSxjLGgsZCxmPXQubGVuZ3RoO2lmKCFlfHwhZS5zdGF0ZSlyZXR1cm4gbDtpZigyPT09KG89KHI9ZS5zdGF0ZSkud3JhcCl8fDE9PT1vJiY0MiE9PXIuc3RhdHVzfHxyLmxvb2thaGVhZClyZXR1cm4gbDtmb3IoMT09PW8mJihlLmFkbGVyPXMoZS5hZGxlcix0LGYsMCkpLHIud3JhcD0wLGY+PXIud19zaXplJiYoMD09PW8mJihtKHIuaGVhZCksci5zdHJzdGFydD0wLHIuYmxvY2tfc3RhcnQ9MCxyLmluc2VydD0wKSxkPW5ldyBhLkJ1Zjgoci53X3NpemUpLGEuYXJyYXlTZXQoZCx0LGYtci53X3NpemUsci53X3NpemUsMCksdD1kLGY9ci53X3NpemUpLHU9ZS5hdmFpbF9pbixjPWUubmV4dF9pbixoPWUuaW5wdXQsZS5hdmFpbF9pbj1mLGUubmV4dF9pbj0wLGUuaW5wdXQ9dCx3KHIpO3IubG9va2FoZWFkPj0zOyl7Zm9yKG49ci5zdHJzdGFydCxpPXIubG9va2FoZWFkLTI7ci5pbnNfaD0oci5pbnNfaDw8ci5oYXNoX3NoaWZ0XnIud2luZG93W24rMy0xXSkmci5oYXNoX21hc2ssci5wcmV2W24mci53X21hc2tdPXIuaGVhZFtyLmluc19oXSxyLmhlYWRbci5pbnNfaF09bixuKyssLS1pOyk7ci5zdHJzdGFydD1uLHIubG9va2FoZWFkPTIsdyhyKTt9cmV0dXJuIHIuc3Ryc3RhcnQrPXIubG9va2FoZWFkLHIuYmxvY2tfc3RhcnQ9ci5zdHJzdGFydCxyLmluc2VydD1yLmxvb2thaGVhZCxyLmxvb2thaGVhZD0wLHIubWF0Y2hfbGVuZ3RoPXIucHJldl9sZW5ndGg9MixyLm1hdGNoX2F2YWlsYWJsZT0wLGUubmV4dF9pbj1jLGUuaW5wdXQ9aCxlLmF2YWlsX2luPXUsci53cmFwPW8sMH0sci5kZWZsYXRlSW5mbz0icGFrbyBkZWZsYXRlIChmcm9tIE5vZGVjYSBwcm9qZWN0KSI7fSx7Ii4uL3V0aWxzL2NvbW1vbiI6NDEsIi4vYWRsZXIzMiI6NDMsIi4vY3JjMzIiOjQ1LCIuL21lc3NhZ2VzIjo1MSwiLi90cmVlcyI6NTJ9XSw0NzpbZnVuY3Rpb24oZSx0LHIpe3QuZXhwb3J0cz1mdW5jdGlvbigpe3RoaXMudGV4dD0wLHRoaXMudGltZT0wLHRoaXMueGZsYWdzPTAsdGhpcy5vcz0wLHRoaXMuZXh0cmE9bnVsbCx0aGlzLmV4dHJhX2xlbj0wLHRoaXMubmFtZT0iIix0aGlzLmNvbW1lbnQ9IiIsdGhpcy5oY3JjPTAsdGhpcy5kb25lPSExO307fSx7fV0sNDg6W2Z1bmN0aW9uKGUsdCxyKXt0LmV4cG9ydHM9ZnVuY3Rpb24oZSx0KXt2YXIgcixuLGEsaSxzLG8sdSxsLGMsaCxkLGYscCxtLGcsXyx5LHYsYix3LGssTixTLHgsQztyPWUuc3RhdGUsbj1lLm5leHRfaW4seD1lLmlucHV0LGE9bisoZS5hdmFpbF9pbi01KSxpPWUubmV4dF9vdXQsQz1lLm91dHB1dCxzPWktKHQtZS5hdmFpbF9vdXQpLG89aSsoZS5hdmFpbF9vdXQtMjU3KSx1PXIuZG1heCxsPXIud3NpemUsYz1yLndoYXZlLGg9ci53bmV4dCxkPXIud2luZG93LGY9ci5ob2xkLHA9ci5iaXRzLG09ci5sZW5jb2RlLGc9ci5kaXN0Y29kZSxfPSgxPDxyLmxlbmJpdHMpLTEseT0oMTw8ci5kaXN0Yml0cyktMTtlOmRve3A8MTUmJihmKz14W24rK108PHAscCs9OCxmKz14W24rK108PHAscCs9OCksdj1tW2YmX107dDpmb3IoOzspe2lmKGY+Pj49Yj12Pj4+MjQscC09YiwwPT0oYj12Pj4+MTYmMjU1KSlDW2krK109NjU1MzUmdjtlbHNlIHtpZighKDE2JmIpKXtpZigwPT0oNjQmYikpe3Y9bVsoNjU1MzUmdikrKGYmKDE8PGIpLTEpXTtjb250aW51ZSB0fWlmKDMyJmIpe3IubW9kZT0xMjticmVhayBlfWUubXNnPSJpbnZhbGlkIGxpdGVyYWwvbGVuZ3RoIGNvZGUiLHIubW9kZT0zMDticmVhayBlfXc9NjU1MzUmdiwoYiY9MTUpJiYocDxiJiYoZis9eFtuKytdPDxwLHArPTgpLHcrPWYmKDE8PGIpLTEsZj4+Pj1iLHAtPWIpLHA8MTUmJihmKz14W24rK108PHAscCs9OCxmKz14W24rK108PHAscCs9OCksdj1nW2YmeV07cjpmb3IoOzspe2lmKGY+Pj49Yj12Pj4+MjQscC09YiwhKDE2JihiPXY+Pj4xNiYyNTUpKSl7aWYoMD09KDY0JmIpKXt2PWdbKDY1NTM1JnYpKyhmJigxPDxiKS0xKV07Y29udGludWUgcn1lLm1zZz0iaW52YWxpZCBkaXN0YW5jZSBjb2RlIixyLm1vZGU9MzA7YnJlYWsgZX1pZihrPTY1NTM1JnYscDwoYiY9MTUpJiYoZis9eFtuKytdPDxwLChwKz04KTxiJiYoZis9eFtuKytdPDxwLHArPTgpKSx1PChrKz1mJigxPDxiKS0xKSl7ZS5tc2c9ImludmFsaWQgZGlzdGFuY2UgdG9vIGZhciBiYWNrIixyLm1vZGU9MzA7YnJlYWsgZX1pZihmPj4+PWIscC09YiwoYj1pLXMpPGspe2lmKGM8KGI9ay1iKSYmci5zYW5lKXtlLm1zZz0iaW52YWxpZCBkaXN0YW5jZSB0b28gZmFyIGJhY2siLHIubW9kZT0zMDticmVhayBlfWlmKFM9ZCwoTj0wKT09PWgpe2lmKE4rPWwtYixiPHcpe2Zvcih3LT1iO0NbaSsrXT1kW04rK10sLS1iOyk7Tj1pLWssUz1DO319ZWxzZSBpZihoPGIpe2lmKE4rPWwraC1iLChiLT1oKTx3KXtmb3Iody09YjtDW2krK109ZFtOKytdLC0tYjspO2lmKE49MCxoPHcpe2Zvcih3LT1iPWg7Q1tpKytdPWRbTisrXSwtLWI7KTtOPWktayxTPUM7fX19ZWxzZSBpZihOKz1oLWIsYjx3KXtmb3Iody09YjtDW2krK109ZFtOKytdLC0tYjspO049aS1rLFM9Qzt9Zm9yKDsyPHc7KUNbaSsrXT1TW04rK10sQ1tpKytdPVNbTisrXSxDW2krK109U1tOKytdLHctPTM7dyYmKENbaSsrXT1TW04rK10sMTx3JiYoQ1tpKytdPVNbTisrXSkpO31lbHNlIHtmb3IoTj1pLWs7Q1tpKytdPUNbTisrXSxDW2krK109Q1tOKytdLENbaSsrXT1DW04rK10sMjwody09Myk7KTt3JiYoQ1tpKytdPUNbTisrXSwxPHcmJihDW2krK109Q1tOKytdKSk7fWJyZWFrfX1icmVha319d2hpbGUobjxhJiZpPG8pO24tPXc9cD4+MyxmJj0oMTw8KHAtPXc8PDMpKS0xLGUubmV4dF9pbj1uLGUubmV4dF9vdXQ9aSxlLmF2YWlsX2luPW48YT9hLW4rNTo1LShuLWEpLGUuYXZhaWxfb3V0PWk8bz9vLWkrMjU3OjI1Ny0oaS1vKSxyLmhvbGQ9ZixyLmJpdHM9cDt9O30se31dLDQ5OltmdW5jdGlvbihlLHQscil7dmFyIG49ZSgiLi4vdXRpbHMvY29tbW9uIiksYT1lKCIuL2FkbGVyMzIiKSxpPWUoIi4vY3JjMzIiKSxzPWUoIi4vaW5mZmFzdCIpLG89ZSgiLi9pbmZ0cmVlcyIpLHU9LTI7ZnVuY3Rpb24gbChlKXtyZXR1cm4gKGU+Pj4yNCYyNTUpKyhlPj4+OCY2NTI4MCkrKCg2NTI4MCZlKTw8OCkrKCgyNTUmZSk8PDI0KX1mdW5jdGlvbiBjKCl7dGhpcy5tb2RlPTAsdGhpcy5sYXN0PSExLHRoaXMud3JhcD0wLHRoaXMuaGF2ZWRpY3Q9ITEsdGhpcy5mbGFncz0wLHRoaXMuZG1heD0wLHRoaXMuY2hlY2s9MCx0aGlzLnRvdGFsPTAsdGhpcy5oZWFkPW51bGwsdGhpcy53Yml0cz0wLHRoaXMud3NpemU9MCx0aGlzLndoYXZlPTAsdGhpcy53bmV4dD0wLHRoaXMud2luZG93PW51bGwsdGhpcy5ob2xkPTAsdGhpcy5iaXRzPTAsdGhpcy5sZW5ndGg9MCx0aGlzLm9mZnNldD0wLHRoaXMuZXh0cmE9MCx0aGlzLmxlbmNvZGU9bnVsbCx0aGlzLmRpc3Rjb2RlPW51bGwsdGhpcy5sZW5iaXRzPTAsdGhpcy5kaXN0Yml0cz0wLHRoaXMubmNvZGU9MCx0aGlzLm5sZW49MCx0aGlzLm5kaXN0PTAsdGhpcy5oYXZlPTAsdGhpcy5uZXh0PW51bGwsdGhpcy5sZW5zPW5ldyBuLkJ1ZjE2KDMyMCksdGhpcy53b3JrPW5ldyBuLkJ1ZjE2KDI4OCksdGhpcy5sZW5keW49bnVsbCx0aGlzLmRpc3RkeW49bnVsbCx0aGlzLnNhbmU9MCx0aGlzLmJhY2s9MCx0aGlzLndhcz0wO31mdW5jdGlvbiBoKGUpe3ZhciB0O3JldHVybiBlJiZlLnN0YXRlPyh0PWUuc3RhdGUsZS50b3RhbF9pbj1lLnRvdGFsX291dD10LnRvdGFsPTAsZS5tc2c9IiIsdC53cmFwJiYoZS5hZGxlcj0xJnQud3JhcCksdC5tb2RlPTEsdC5sYXN0PTAsdC5oYXZlZGljdD0wLHQuZG1heD0zMjc2OCx0LmhlYWQ9bnVsbCx0LmhvbGQ9MCx0LmJpdHM9MCx0LmxlbmNvZGU9dC5sZW5keW49bmV3IG4uQnVmMzIoODUyKSx0LmRpc3Rjb2RlPXQuZGlzdGR5bj1uZXcgbi5CdWYzMig1OTIpLHQuc2FuZT0xLHQuYmFjaz0tMSwwKTp1fWZ1bmN0aW9uIGQoZSl7dmFyIHQ7cmV0dXJuIGUmJmUuc3RhdGU/KCh0PWUuc3RhdGUpLndzaXplPTAsdC53aGF2ZT0wLHQud25leHQ9MCxoKGUpKTp1fWZ1bmN0aW9uIGYoZSx0KXt2YXIgcixuO3JldHVybiBlJiZlLnN0YXRlPyhuPWUuc3RhdGUsdDwwPyhyPTAsdD0tdCk6KHI9MSsodD4+NCksdDw0OCYmKHQmPTE1KSksdCYmKHQ8OHx8MTU8dCk/dToobnVsbCE9PW4ud2luZG93JiZuLndiaXRzIT09dCYmKG4ud2luZG93PW51bGwpLG4ud3JhcD1yLG4ud2JpdHM9dCxkKGUpKSk6dX1mdW5jdGlvbiBwKGUsdCl7dmFyIHIsbjtyZXR1cm4gZT8obj1uZXcgYywoZS5zdGF0ZT1uKS53aW5kb3c9bnVsbCwwIT09KHI9ZihlLHQpKSYmKGUuc3RhdGU9bnVsbCkscik6dX12YXIgbSxnLF89ITA7ZnVuY3Rpb24geShlKXtpZihfKXt2YXIgdDtmb3IobT1uZXcgbi5CdWYzMig1MTIpLGc9bmV3IG4uQnVmMzIoMzIpLHQ9MDt0PDE0NDspZS5sZW5zW3QrK109ODtmb3IoO3Q8MjU2OyllLmxlbnNbdCsrXT05O2Zvcig7dDwyODA7KWUubGVuc1t0KytdPTc7Zm9yKDt0PDI4ODspZS5sZW5zW3QrK109ODtmb3IobygxLGUubGVucywwLDI4OCxtLDAsZS53b3JrLHtiaXRzOjl9KSx0PTA7dDwzMjspZS5sZW5zW3QrK109NTtvKDIsZS5sZW5zLDAsMzIsZywwLGUud29yayx7Yml0czo1fSksXz0hMTt9ZS5sZW5jb2RlPW0sZS5sZW5iaXRzPTksZS5kaXN0Y29kZT1nLGUuZGlzdGJpdHM9NTt9ZnVuY3Rpb24gdihlLHQscixhKXt2YXIgaSxzPWUuc3RhdGU7cmV0dXJuIG51bGw9PT1zLndpbmRvdyYmKHMud3NpemU9MTw8cy53Yml0cyxzLnduZXh0PTAscy53aGF2ZT0wLHMud2luZG93PW5ldyBuLkJ1Zjgocy53c2l6ZSkpLGE+PXMud3NpemU/KG4uYXJyYXlTZXQocy53aW5kb3csdCxyLXMud3NpemUscy53c2l6ZSwwKSxzLnduZXh0PTAscy53aGF2ZT1zLndzaXplKTooYTwoaT1zLndzaXplLXMud25leHQpJiYoaT1hKSxuLmFycmF5U2V0KHMud2luZG93LHQsci1hLGkscy53bmV4dCksKGEtPWkpPyhuLmFycmF5U2V0KHMud2luZG93LHQsci1hLGEsMCkscy53bmV4dD1hLHMud2hhdmU9cy53c2l6ZSk6KHMud25leHQrPWkscy53bmV4dD09PXMud3NpemUmJihzLnduZXh0PTApLHMud2hhdmU8cy53c2l6ZSYmKHMud2hhdmUrPWkpKSksMH1yLmluZmxhdGVSZXNldD1kLHIuaW5mbGF0ZVJlc2V0Mj1mLHIuaW5mbGF0ZVJlc2V0S2VlcD1oLHIuaW5mbGF0ZUluaXQ9ZnVuY3Rpb24oZSl7cmV0dXJuIHAoZSwxNSl9LHIuaW5mbGF0ZUluaXQyPXAsci5pbmZsYXRlPWZ1bmN0aW9uKGUsdCl7dmFyIHIsYyxoLGQsZixwLG0sZyxfLGIsdyxrLE4sUyx4LEMsUCxFLE8sQSxNLEwseixJLFI9MCxGPW5ldyBuLkJ1ZjgoNCksaj1bMTYsMTcsMTgsMCw4LDcsOSw2LDEwLDUsMTEsNCwxMiwzLDEzLDIsMTQsMSwxNV07aWYoIWV8fCFlLnN0YXRlfHwhZS5vdXRwdXR8fCFlLmlucHV0JiYwIT09ZS5hdmFpbF9pbilyZXR1cm4gdTsxMj09PShyPWUuc3RhdGUpLm1vZGUmJihyLm1vZGU9MTMpLGY9ZS5uZXh0X291dCxoPWUub3V0cHV0LG09ZS5hdmFpbF9vdXQsZD1lLm5leHRfaW4sYz1lLmlucHV0LHA9ZS5hdmFpbF9pbixnPXIuaG9sZCxfPXIuYml0cyxiPXAsdz1tLEw9MDtlOmZvcig7Oylzd2l0Y2goci5tb2RlKXtjYXNlIDE6aWYoMD09PXIud3JhcCl7ci5tb2RlPTEzO2JyZWFrfWZvcig7XzwxNjspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31pZigyJnIud3JhcCYmMzU2MTU9PT1nKXtGW3IuY2hlY2s9MF09MjU1JmcsRlsxXT1nPj4+OCYyNTUsci5jaGVjaz1pKHIuY2hlY2ssRiwyLDApLF89Zz0wLHIubW9kZT0yO2JyZWFrfWlmKHIuZmxhZ3M9MCxyLmhlYWQmJihyLmhlYWQuZG9uZT0hMSksISgxJnIud3JhcCl8fCgoKDI1NSZnKTw8OCkrKGc+PjgpKSUzMSl7ZS5tc2c9ImluY29ycmVjdCBoZWFkZXIgY2hlY2siLHIubW9kZT0zMDticmVha31pZig4IT0oMTUmZykpe2UubXNnPSJ1bmtub3duIGNvbXByZXNzaW9uIG1ldGhvZCIsci5tb2RlPTMwO2JyZWFrfWlmKF8tPTQsTT04KygxNSYoZz4+Pj00KSksMD09PXIud2JpdHMpci53Yml0cz1NO2Vsc2UgaWYoTT5yLndiaXRzKXtlLm1zZz0iaW52YWxpZCB3aW5kb3cgc2l6ZSIsci5tb2RlPTMwO2JyZWFrfXIuZG1heD0xPDxNLGUuYWRsZXI9ci5jaGVjaz0xLHIubW9kZT01MTImZz8xMDoxMixfPWc9MDticmVhaztjYXNlIDI6Zm9yKDtfPDE2Oyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWlmKHIuZmxhZ3M9Zyw4IT0oMjU1JnIuZmxhZ3MpKXtlLm1zZz0idW5rbm93biBjb21wcmVzc2lvbiBtZXRob2QiLHIubW9kZT0zMDticmVha31pZig1NzM0NCZyLmZsYWdzKXtlLm1zZz0idW5rbm93biBoZWFkZXIgZmxhZ3Mgc2V0IixyLm1vZGU9MzA7YnJlYWt9ci5oZWFkJiYoci5oZWFkLnRleHQ9Zz4+OCYxKSw1MTImci5mbGFncyYmKEZbMF09MjU1JmcsRlsxXT1nPj4+OCYyNTUsci5jaGVjaz1pKHIuY2hlY2ssRiwyLDApKSxfPWc9MCxyLm1vZGU9MztjYXNlIDM6Zm9yKDtfPDMyOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fXIuaGVhZCYmKHIuaGVhZC50aW1lPWcpLDUxMiZyLmZsYWdzJiYoRlswXT0yNTUmZyxGWzFdPWc+Pj44JjI1NSxGWzJdPWc+Pj4xNiYyNTUsRlszXT1nPj4+MjQmMjU1LHIuY2hlY2s9aShyLmNoZWNrLEYsNCwwKSksXz1nPTAsci5tb2RlPTQ7Y2FzZSA0OmZvcig7XzwxNjspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31yLmhlYWQmJihyLmhlYWQueGZsYWdzPTI1NSZnLHIuaGVhZC5vcz1nPj44KSw1MTImci5mbGFncyYmKEZbMF09MjU1JmcsRlsxXT1nPj4+OCYyNTUsci5jaGVjaz1pKHIuY2hlY2ssRiwyLDApKSxfPWc9MCxyLm1vZGU9NTtjYXNlIDU6aWYoMTAyNCZyLmZsYWdzKXtmb3IoO188MTY7KXtpZigwPT09cClicmVhayBlO3AtLSxnKz1jW2QrK108PF8sXys9ODt9ci5sZW5ndGg9ZyxyLmhlYWQmJihyLmhlYWQuZXh0cmFfbGVuPWcpLDUxMiZyLmZsYWdzJiYoRlswXT0yNTUmZyxGWzFdPWc+Pj44JjI1NSxyLmNoZWNrPWkoci5jaGVjayxGLDIsMCkpLF89Zz0wO31lbHNlIHIuaGVhZCYmKHIuaGVhZC5leHRyYT1udWxsKTtyLm1vZGU9NjtjYXNlIDY6aWYoMTAyNCZyLmZsYWdzJiYocDwoaz1yLmxlbmd0aCkmJihrPXApLGsmJihyLmhlYWQmJihNPXIuaGVhZC5leHRyYV9sZW4tci5sZW5ndGgsci5oZWFkLmV4dHJhfHwoci5oZWFkLmV4dHJhPW5ldyBBcnJheShyLmhlYWQuZXh0cmFfbGVuKSksbi5hcnJheVNldChyLmhlYWQuZXh0cmEsYyxkLGssTSkpLDUxMiZyLmZsYWdzJiYoci5jaGVjaz1pKHIuY2hlY2ssYyxrLGQpKSxwLT1rLGQrPWssci5sZW5ndGgtPWspLHIubGVuZ3RoKSlicmVhayBlO3IubGVuZ3RoPTAsci5tb2RlPTc7Y2FzZSA3OmlmKDIwNDgmci5mbGFncyl7aWYoMD09PXApYnJlYWsgZTtmb3Ioaz0wO009Y1tkK2srK10sci5oZWFkJiZNJiZyLmxlbmd0aDw2NTUzNiYmKHIuaGVhZC5uYW1lKz1TdHJpbmcuZnJvbUNoYXJDb2RlKE0pKSxNJiZrPHA7KTtpZig1MTImci5mbGFncyYmKHIuY2hlY2s9aShyLmNoZWNrLGMsayxkKSkscC09ayxkKz1rLE0pYnJlYWsgZX1lbHNlIHIuaGVhZCYmKHIuaGVhZC5uYW1lPW51bGwpO3IubGVuZ3RoPTAsci5tb2RlPTg7Y2FzZSA4OmlmKDQwOTYmci5mbGFncyl7aWYoMD09PXApYnJlYWsgZTtmb3Ioaz0wO009Y1tkK2srK10sci5oZWFkJiZNJiZyLmxlbmd0aDw2NTUzNiYmKHIuaGVhZC5jb21tZW50Kz1TdHJpbmcuZnJvbUNoYXJDb2RlKE0pKSxNJiZrPHA7KTtpZig1MTImci5mbGFncyYmKHIuY2hlY2s9aShyLmNoZWNrLGMsayxkKSkscC09ayxkKz1rLE0pYnJlYWsgZX1lbHNlIHIuaGVhZCYmKHIuaGVhZC5jb21tZW50PW51bGwpO3IubW9kZT05O2Nhc2UgOTppZig1MTImci5mbGFncyl7Zm9yKDtfPDE2Oyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWlmKGchPT0oNjU1MzUmci5jaGVjaykpe2UubXNnPSJoZWFkZXIgY3JjIG1pc21hdGNoIixyLm1vZGU9MzA7YnJlYWt9Xz1nPTA7fXIuaGVhZCYmKHIuaGVhZC5oY3JjPXIuZmxhZ3M+PjkmMSxyLmhlYWQuZG9uZT0hMCksZS5hZGxlcj1yLmNoZWNrPTAsci5tb2RlPTEyO2JyZWFrO2Nhc2UgMTA6Zm9yKDtfPDMyOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWUuYWRsZXI9ci5jaGVjaz1sKGcpLF89Zz0wLHIubW9kZT0xMTtjYXNlIDExOmlmKDA9PT1yLmhhdmVkaWN0KXJldHVybiBlLm5leHRfb3V0PWYsZS5hdmFpbF9vdXQ9bSxlLm5leHRfaW49ZCxlLmF2YWlsX2luPXAsci5ob2xkPWcsci5iaXRzPV8sMjtlLmFkbGVyPXIuY2hlY2s9MSxyLm1vZGU9MTI7Y2FzZSAxMjppZig1PT09dHx8Nj09PXQpYnJlYWsgZTtjYXNlIDEzOmlmKHIubGFzdCl7Zz4+Pj03Jl8sXy09NyZfLHIubW9kZT0yNzticmVha31mb3IoO188Mzspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31zd2l0Y2goci5sYXN0PTEmZyxfLT0xLDMmKGc+Pj49MSkpe2Nhc2UgMDpyLm1vZGU9MTQ7YnJlYWs7Y2FzZSAxOmlmKHkociksci5tb2RlPTIwLDYhPT10KWJyZWFrO2c+Pj49MixfLT0yO2JyZWFrIGU7Y2FzZSAyOnIubW9kZT0xNzticmVhaztjYXNlIDM6ZS5tc2c9ImludmFsaWQgYmxvY2sgdHlwZSIsci5tb2RlPTMwO31nPj4+PTIsXy09MjticmVhaztjYXNlIDE0OmZvcihnPj4+PTcmXyxfLT03Jl87XzwzMjspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31pZigoNjU1MzUmZykhPShnPj4+MTZeNjU1MzUpKXtlLm1zZz0iaW52YWxpZCBzdG9yZWQgYmxvY2sgbGVuZ3RocyIsci5tb2RlPTMwO2JyZWFrfWlmKHIubGVuZ3RoPTY1NTM1JmcsXz1nPTAsci5tb2RlPTE1LDY9PT10KWJyZWFrIGU7Y2FzZSAxNTpyLm1vZGU9MTY7Y2FzZSAxNjppZihrPXIubGVuZ3RoKXtpZihwPGsmJihrPXApLG08ayYmKGs9bSksMD09PWspYnJlYWsgZTtuLmFycmF5U2V0KGgsYyxkLGssZikscC09ayxkKz1rLG0tPWssZis9ayxyLmxlbmd0aC09azticmVha31yLm1vZGU9MTI7YnJlYWs7Y2FzZSAxNzpmb3IoO188MTQ7KXtpZigwPT09cClicmVhayBlO3AtLSxnKz1jW2QrK108PF8sXys9ODt9aWYoci5ubGVuPTI1NysoMzEmZyksZz4+Pj01LF8tPTUsci5uZGlzdD0xKygzMSZnKSxnPj4+PTUsXy09NSxyLm5jb2RlPTQrKDE1JmcpLGc+Pj49NCxfLT00LDI4NjxyLm5sZW58fDMwPHIubmRpc3Qpe2UubXNnPSJ0b28gbWFueSBsZW5ndGggb3IgZGlzdGFuY2Ugc3ltYm9scyIsci5tb2RlPTMwO2JyZWFrfXIuaGF2ZT0wLHIubW9kZT0xODtjYXNlIDE4OmZvcig7ci5oYXZlPHIubmNvZGU7KXtmb3IoO188Mzspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31yLmxlbnNbaltyLmhhdmUrK11dPTcmZyxnPj4+PTMsXy09Mzt9Zm9yKDtyLmhhdmU8MTk7KXIubGVuc1tqW3IuaGF2ZSsrXV09MDtpZihyLmxlbmNvZGU9ci5sZW5keW4sci5sZW5iaXRzPTcsej17Yml0czpyLmxlbmJpdHN9LEw9bygwLHIubGVucywwLDE5LHIubGVuY29kZSwwLHIud29yayx6KSxyLmxlbmJpdHM9ei5iaXRzLEwpe2UubXNnPSJpbnZhbGlkIGNvZGUgbGVuZ3RocyBzZXQiLHIubW9kZT0zMDticmVha31yLmhhdmU9MCxyLm1vZGU9MTk7Y2FzZSAxOTpmb3IoO3IuaGF2ZTxyLm5sZW4rci5uZGlzdDspe2Zvcig7Qz0oUj1yLmxlbmNvZGVbZyYoMTw8ci5sZW5iaXRzKS0xXSk+Pj4xNiYyNTUsUD02NTUzNSZSLCEoKHg9Uj4+PjI0KTw9Xyk7KXtpZigwPT09cClicmVhayBlO3AtLSxnKz1jW2QrK108PF8sXys9ODt9aWYoUDwxNilnPj4+PXgsXy09eCxyLmxlbnNbci5oYXZlKytdPVA7ZWxzZSB7aWYoMTY9PT1QKXtmb3IoST14KzI7XzxJOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWlmKGc+Pj49eCxfLT14LDA9PT1yLmhhdmUpe2UubXNnPSJpbnZhbGlkIGJpdCBsZW5ndGggcmVwZWF0IixyLm1vZGU9MzA7YnJlYWt9TT1yLmxlbnNbci5oYXZlLTFdLGs9MysoMyZnKSxnPj4+PTIsXy09Mjt9ZWxzZSBpZigxNz09PVApe2ZvcihJPXgrMztfPEk7KXtpZigwPT09cClicmVhayBlO3AtLSxnKz1jW2QrK108PF8sXys9ODt9Xy09eCxNPTAsaz0zKyg3JihnPj4+PXgpKSxnPj4+PTMsXy09Mzt9ZWxzZSB7Zm9yKEk9eCs3O188STspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31fLT14LE09MCxrPTExKygxMjcmKGc+Pj49eCkpLGc+Pj49NyxfLT03O31pZihyLmhhdmUraz5yLm5sZW4rci5uZGlzdCl7ZS5tc2c9ImludmFsaWQgYml0IGxlbmd0aCByZXBlYXQiLHIubW9kZT0zMDticmVha31mb3IoO2stLTspci5sZW5zW3IuaGF2ZSsrXT1NO319aWYoMzA9PT1yLm1vZGUpYnJlYWs7aWYoMD09PXIubGVuc1syNTZdKXtlLm1zZz0iaW52YWxpZCBjb2RlIC0tIG1pc3NpbmcgZW5kLW9mLWJsb2NrIixyLm1vZGU9MzA7YnJlYWt9aWYoci5sZW5iaXRzPTksej17Yml0czpyLmxlbmJpdHN9LEw9bygxLHIubGVucywwLHIubmxlbixyLmxlbmNvZGUsMCxyLndvcmsseiksci5sZW5iaXRzPXouYml0cyxMKXtlLm1zZz0iaW52YWxpZCBsaXRlcmFsL2xlbmd0aHMgc2V0IixyLm1vZGU9MzA7YnJlYWt9aWYoci5kaXN0Yml0cz02LHIuZGlzdGNvZGU9ci5kaXN0ZHluLHo9e2JpdHM6ci5kaXN0Yml0c30sTD1vKDIsci5sZW5zLHIubmxlbixyLm5kaXN0LHIuZGlzdGNvZGUsMCxyLndvcmsseiksci5kaXN0Yml0cz16LmJpdHMsTCl7ZS5tc2c9ImludmFsaWQgZGlzdGFuY2VzIHNldCIsci5tb2RlPTMwO2JyZWFrfWlmKHIubW9kZT0yMCw2PT09dClicmVhayBlO2Nhc2UgMjA6ci5tb2RlPTIxO2Nhc2UgMjE6aWYoNjw9cCYmMjU4PD1tKXtlLm5leHRfb3V0PWYsZS5hdmFpbF9vdXQ9bSxlLm5leHRfaW49ZCxlLmF2YWlsX2luPXAsci5ob2xkPWcsci5iaXRzPV8scyhlLHcpLGY9ZS5uZXh0X291dCxoPWUub3V0cHV0LG09ZS5hdmFpbF9vdXQsZD1lLm5leHRfaW4sYz1lLmlucHV0LHA9ZS5hdmFpbF9pbixnPXIuaG9sZCxfPXIuYml0cywxMj09PXIubW9kZSYmKHIuYmFjaz0tMSk7YnJlYWt9Zm9yKHIuYmFjaz0wO0M9KFI9ci5sZW5jb2RlW2cmKDE8PHIubGVuYml0cyktMV0pPj4+MTYmMjU1LFA9NjU1MzUmUiwhKCh4PVI+Pj4yNCk8PV8pOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWlmKEMmJjA9PSgyNDAmQykpe2ZvcihFPXgsTz1DLEE9UDtDPShSPXIubGVuY29kZVtBKygoZyYoMTw8RStPKS0xKT4+RSldKT4+PjE2JjI1NSxQPTY1NTM1JlIsIShFKyh4PVI+Pj4yNCk8PV8pOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWc+Pj49RSxfLT1FLHIuYmFjays9RTt9aWYoZz4+Pj14LF8tPXgsci5iYWNrKz14LHIubGVuZ3RoPVAsMD09PUMpe3IubW9kZT0yNjticmVha31pZigzMiZDKXtyLmJhY2s9LTEsci5tb2RlPTEyO2JyZWFrfWlmKDY0JkMpe2UubXNnPSJpbnZhbGlkIGxpdGVyYWwvbGVuZ3RoIGNvZGUiLHIubW9kZT0zMDticmVha31yLmV4dHJhPTE1JkMsci5tb2RlPTIyO2Nhc2UgMjI6aWYoci5leHRyYSl7Zm9yKEk9ci5leHRyYTtfPEk7KXtpZigwPT09cClicmVhayBlO3AtLSxnKz1jW2QrK108PF8sXys9ODt9ci5sZW5ndGgrPWcmKDE8PHIuZXh0cmEpLTEsZz4+Pj1yLmV4dHJhLF8tPXIuZXh0cmEsci5iYWNrKz1yLmV4dHJhO31yLndhcz1yLmxlbmd0aCxyLm1vZGU9MjM7Y2FzZSAyMzpmb3IoO0M9KFI9ci5kaXN0Y29kZVtnJigxPDxyLmRpc3RiaXRzKS0xXSk+Pj4xNiYyNTUsUD02NTUzNSZSLCEoKHg9Uj4+PjI0KTw9Xyk7KXtpZigwPT09cClicmVhayBlO3AtLSxnKz1jW2QrK108PF8sXys9ODt9aWYoMD09KDI0MCZDKSl7Zm9yKEU9eCxPPUMsQT1QO0M9KFI9ci5kaXN0Y29kZVtBKygoZyYoMTw8RStPKS0xKT4+RSldKT4+PjE2JjI1NSxQPTY1NTM1JlIsIShFKyh4PVI+Pj4yNCk8PV8pOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWc+Pj49RSxfLT1FLHIuYmFjays9RTt9aWYoZz4+Pj14LF8tPXgsci5iYWNrKz14LDY0JkMpe2UubXNnPSJpbnZhbGlkIGRpc3RhbmNlIGNvZGUiLHIubW9kZT0zMDticmVha31yLm9mZnNldD1QLHIuZXh0cmE9MTUmQyxyLm1vZGU9MjQ7Y2FzZSAyNDppZihyLmV4dHJhKXtmb3IoST1yLmV4dHJhO188STspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGcrPWNbZCsrXTw8XyxfKz04O31yLm9mZnNldCs9ZyYoMTw8ci5leHRyYSktMSxnPj4+PXIuZXh0cmEsXy09ci5leHRyYSxyLmJhY2srPXIuZXh0cmE7fWlmKHIub2Zmc2V0PnIuZG1heCl7ZS5tc2c9ImludmFsaWQgZGlzdGFuY2UgdG9vIGZhciBiYWNrIixyLm1vZGU9MzA7YnJlYWt9ci5tb2RlPTI1O2Nhc2UgMjU6aWYoMD09PW0pYnJlYWsgZTtpZihrPXctbSxyLm9mZnNldD5rKXtpZigoaz1yLm9mZnNldC1rKT5yLndoYXZlJiZyLnNhbmUpe2UubXNnPSJpbnZhbGlkIGRpc3RhbmNlIHRvbyBmYXIgYmFjayIsci5tb2RlPTMwO2JyZWFrfU49az5yLnduZXh0PyhrLT1yLnduZXh0LHIud3NpemUtayk6ci53bmV4dC1rLGs+ci5sZW5ndGgmJihrPXIubGVuZ3RoKSxTPXIud2luZG93O31lbHNlIFM9aCxOPWYtci5vZmZzZXQsaz1yLmxlbmd0aDtmb3IobTxrJiYoaz1tKSxtLT1rLHIubGVuZ3RoLT1rO2hbZisrXT1TW04rK10sLS1rOyk7MD09PXIubGVuZ3RoJiYoci5tb2RlPTIxKTticmVhaztjYXNlIDI2OmlmKDA9PT1tKWJyZWFrIGU7aFtmKytdPXIubGVuZ3RoLG0tLSxyLm1vZGU9MjE7YnJlYWs7Y2FzZSAyNzppZihyLndyYXApe2Zvcig7XzwzMjspe2lmKDA9PT1wKWJyZWFrIGU7cC0tLGd8PWNbZCsrXTw8XyxfKz04O31pZih3LT1tLGUudG90YWxfb3V0Kz13LHIudG90YWwrPXcsdyYmKGUuYWRsZXI9ci5jaGVjaz1yLmZsYWdzP2koci5jaGVjayxoLHcsZi13KTphKHIuY2hlY2ssaCx3LGYtdykpLHc9bSwoci5mbGFncz9nOmwoZykpIT09ci5jaGVjayl7ZS5tc2c9ImluY29ycmVjdCBkYXRhIGNoZWNrIixyLm1vZGU9MzA7YnJlYWt9Xz1nPTA7fXIubW9kZT0yODtjYXNlIDI4OmlmKHIud3JhcCYmci5mbGFncyl7Zm9yKDtfPDMyOyl7aWYoMD09PXApYnJlYWsgZTtwLS0sZys9Y1tkKytdPDxfLF8rPTg7fWlmKGchPT0oNDI5NDk2NzI5NSZyLnRvdGFsKSl7ZS5tc2c9ImluY29ycmVjdCBsZW5ndGggY2hlY2siLHIubW9kZT0zMDticmVha31fPWc9MDt9ci5tb2RlPTI5O2Nhc2UgMjk6TD0xO2JyZWFrIGU7Y2FzZSAzMDpMPS0zO2JyZWFrIGU7Y2FzZSAzMTpyZXR1cm4gLTQ7Y2FzZSAzMjpkZWZhdWx0OnJldHVybiB1fXJldHVybiBlLm5leHRfb3V0PWYsZS5hdmFpbF9vdXQ9bSxlLm5leHRfaW49ZCxlLmF2YWlsX2luPXAsci5ob2xkPWcsci5iaXRzPV8sKHIud3NpemV8fHchPT1lLmF2YWlsX291dCYmci5tb2RlPDMwJiYoci5tb2RlPDI3fHw0IT09dCkpJiZ2KGUsZS5vdXRwdXQsZS5uZXh0X291dCx3LWUuYXZhaWxfb3V0KT8oci5tb2RlPTMxLC00KTooYi09ZS5hdmFpbF9pbix3LT1lLmF2YWlsX291dCxlLnRvdGFsX2luKz1iLGUudG90YWxfb3V0Kz13LHIudG90YWwrPXcsci53cmFwJiZ3JiYoZS5hZGxlcj1yLmNoZWNrPXIuZmxhZ3M/aShyLmNoZWNrLGgsdyxlLm5leHRfb3V0LXcpOmEoci5jaGVjayxoLHcsZS5uZXh0X291dC13KSksZS5kYXRhX3R5cGU9ci5iaXRzKyhyLmxhc3Q/NjQ6MCkrKDEyPT09ci5tb2RlPzEyODowKSsoMjA9PT1yLm1vZGV8fDE1PT09ci5tb2RlPzI1NjowKSwoMD09YiYmMD09PXd8fDQ9PT10KSYmMD09PUwmJihMPS01KSxMKX0sci5pbmZsYXRlRW5kPWZ1bmN0aW9uKGUpe2lmKCFlfHwhZS5zdGF0ZSlyZXR1cm4gdTt2YXIgdD1lLnN0YXRlO3JldHVybiB0LndpbmRvdyYmKHQud2luZG93PW51bGwpLGUuc3RhdGU9bnVsbCwwfSxyLmluZmxhdGVHZXRIZWFkZXI9ZnVuY3Rpb24oZSx0KXt2YXIgcjtyZXR1cm4gZSYmZS5zdGF0ZT8wPT0oMiYocj1lLnN0YXRlKS53cmFwKT91Oigoci5oZWFkPXQpLmRvbmU9ITEsMCk6dX0sci5pbmZsYXRlU2V0RGljdGlvbmFyeT1mdW5jdGlvbihlLHQpe3ZhciByLG49dC5sZW5ndGg7cmV0dXJuIGUmJmUuc3RhdGU/MCE9PShyPWUuc3RhdGUpLndyYXAmJjExIT09ci5tb2RlP3U6MTE9PT1yLm1vZGUmJmEoMSx0LG4sMCkhPT1yLmNoZWNrPy0zOnYoZSx0LG4sbik/KHIubW9kZT0zMSwtNCk6KHIuaGF2ZWRpY3Q9MSwwKTp1fSxyLmluZmxhdGVJbmZvPSJwYWtvIGluZmxhdGUgKGZyb20gTm9kZWNhIHByb2plY3QpIjt9LHsiLi4vdXRpbHMvY29tbW9uIjo0MSwiLi9hZGxlcjMyIjo0MywiLi9jcmMzMiI6NDUsIi4vaW5mZmFzdCI6NDgsIi4vaW5mdHJlZXMiOjUwfV0sNTA6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuLi91dGlscy9jb21tb24iKSxhPVszLDQsNSw2LDcsOCw5LDEwLDExLDEzLDE1LDE3LDE5LDIzLDI3LDMxLDM1LDQzLDUxLDU5LDY3LDgzLDk5LDExNSwxMzEsMTYzLDE5NSwyMjcsMjU4LDAsMF0saT1bMTYsMTYsMTYsMTYsMTYsMTYsMTYsMTYsMTcsMTcsMTcsMTcsMTgsMTgsMTgsMTgsMTksMTksMTksMTksMjAsMjAsMjAsMjAsMjEsMjEsMjEsMjEsMTYsNzIsNzhdLHM9WzEsMiwzLDQsNSw3LDksMTMsMTcsMjUsMzMsNDksNjUsOTcsMTI5LDE5MywyNTcsMzg1LDUxMyw3NjksMTAyNSwxNTM3LDIwNDksMzA3Myw0MDk3LDYxNDUsODE5MywxMjI4OSwxNjM4NSwyNDU3NywwLDBdLG89WzE2LDE2LDE2LDE2LDE3LDE3LDE4LDE4LDE5LDE5LDIwLDIwLDIxLDIxLDIyLDIyLDIzLDIzLDI0LDI0LDI1LDI1LDI2LDI2LDI3LDI3LDI4LDI4LDI5LDI5LDY0LDY0XTt0LmV4cG9ydHM9ZnVuY3Rpb24oZSx0LHIsdSxsLGMsaCxkKXt2YXIgZixwLG0sZyxfLHksdixiLHcsaz1kLmJpdHMsTj0wLFM9MCx4PTAsQz0wLFA9MCxFPTAsTz0wLEE9MCxNPTAsTD0wLHo9bnVsbCxJPTAsUj1uZXcgbi5CdWYxNigxNiksRj1uZXcgbi5CdWYxNigxNiksaj1udWxsLEQ9MDtmb3IoTj0wO048PTE1O04rKylSW05dPTA7Zm9yKFM9MDtTPHU7UysrKVJbdFtyK1NdXSsrO2ZvcihQPWssQz0xNTsxPD1DJiYwPT09UltDXTtDLS0pO2lmKEM8UCYmKFA9QyksMD09PUMpcmV0dXJuIGxbYysrXT0yMDk3MTUyMCxsW2MrK109MjA5NzE1MjAsZC5iaXRzPTEsMDtmb3IoeD0xO3g8QyYmMD09PVJbeF07eCsrKTtmb3IoUDx4JiYoUD14KSxOPUE9MTtOPD0xNTtOKyspaWYoQTw8PTEsKEEtPVJbTl0pPDApcmV0dXJuIC0xO2lmKDA8QSYmKDA9PT1lfHwxIT09QykpcmV0dXJuIC0xO2ZvcihGWzFdPTAsTj0xO048MTU7TisrKUZbTisxXT1GW05dK1JbTl07Zm9yKFM9MDtTPHU7UysrKTAhPT10W3IrU10mJihoW0ZbdFtyK1NdXSsrXT1TKTtpZih5PTA9PT1lPyh6PWo9aCwxOSk6MT09PWU/KHo9YSxJLT0yNTcsaj1pLEQtPTI1NywyNTYpOih6PXMsaj1vLC0xKSxOPXgsXz1jLE89Uz1MPTAsbT0tMSxnPShNPTE8PChFPVApKS0xLDE9PT1lJiY4NTI8TXx8Mj09PWUmJjU5MjxNKXJldHVybiAxO2Zvcig7Oyl7Zm9yKHY9Ti1PLHc9aFtTXTx5PyhiPTAsaFtTXSk6aFtTXT55PyhiPWpbRCtoW1NdXSx6W0kraFtTXV0pOihiPTk2LDApLGY9MTw8Ti1PLHg9cD0xPDxFO2xbXysoTD4+TykrKHAtPWYpXT12PDwyNHxiPDwxNnx3fDAsMCE9PXA7KTtmb3IoZj0xPDxOLTE7TCZmOylmPj49MTtpZigwIT09Zj8oTCY9Zi0xLEwrPWYpOkw9MCxTKyssMD09LS1SW05dKXtpZihOPT09QylicmVhaztOPXRbcitoW1NdXTt9aWYoUDxOJiYoTCZnKSE9PW0pe2ZvcigwPT09TyYmKE89UCksXys9eCxBPTE8PChFPU4tTyk7RStPPEMmJiEoKEEtPVJbRStPXSk8PTApOylFKyssQTw8PTE7aWYoTSs9MTw8RSwxPT09ZSYmODUyPE18fDI9PT1lJiY1OTI8TSlyZXR1cm4gMTtsW209TCZnXT1QPDwyNHxFPDwxNnxfLWN8MDt9fXJldHVybiAwIT09TCYmKGxbXytMXT1OLU88PDI0fDY0PDwxNnwwKSxkLmJpdHM9UCwwfTt9LHsiLi4vdXRpbHMvY29tbW9uIjo0MX1dLDUxOltmdW5jdGlvbihlLHQscil7dC5leHBvcnRzPXsyOiJuZWVkIGRpY3Rpb25hcnkiLDE6InN0cmVhbSBlbmQiLDA6IiIsIi0xIjoiZmlsZSBlcnJvciIsIi0yIjoic3RyZWFtIGVycm9yIiwiLTMiOiJkYXRhIGVycm9yIiwiLTQiOiJpbnN1ZmZpY2llbnQgbWVtb3J5IiwiLTUiOiJidWZmZXIgZXJyb3IiLCItNiI6ImluY29tcGF0aWJsZSB2ZXJzaW9uIn07fSx7fV0sNTI6W2Z1bmN0aW9uKGUsdCxyKXt2YXIgbj1lKCIuLi91dGlscy9jb21tb24iKTtmdW5jdGlvbiBhKGUpe2Zvcih2YXIgdD1lLmxlbmd0aDswPD0tLXQ7KWVbdF09MDt9dmFyIGk9MjU2LHM9Mjg2LG89MzAsdT0xNSxsPVswLDAsMCwwLDAsMCwwLDAsMSwxLDEsMSwyLDIsMiwyLDMsMywzLDMsNCw0LDQsNCw1LDUsNSw1LDBdLGM9WzAsMCwwLDAsMSwxLDIsMiwzLDMsNCw0LDUsNSw2LDYsNyw3LDgsOCw5LDksMTAsMTAsMTEsMTEsMTIsMTIsMTMsMTNdLGg9WzAsMCwwLDAsMCwwLDAsMCwwLDAsMCwwLDAsMCwwLDAsMiwzLDddLGQ9WzE2LDE3LDE4LDAsOCw3LDksNiwxMCw1LDExLDQsMTIsMywxMywyLDE0LDEsMTVdLGY9bmV3IEFycmF5KDU3Nik7YShmKTt2YXIgcD1uZXcgQXJyYXkoNjApO2EocCk7dmFyIG09bmV3IEFycmF5KDUxMik7YShtKTt2YXIgZz1uZXcgQXJyYXkoMjU2KTthKGcpO3ZhciBfPW5ldyBBcnJheSgyOSk7YShfKTt2YXIgeSx2LGIsdz1uZXcgQXJyYXkobyk7ZnVuY3Rpb24gayhlLHQscixuLGEpe3RoaXMuc3RhdGljX3RyZWU9ZSx0aGlzLmV4dHJhX2JpdHM9dCx0aGlzLmV4dHJhX2Jhc2U9cix0aGlzLmVsZW1zPW4sdGhpcy5tYXhfbGVuZ3RoPWEsdGhpcy5oYXNfc3RyZWU9ZSYmZS5sZW5ndGg7fWZ1bmN0aW9uIE4oZSx0KXt0aGlzLmR5bl90cmVlPWUsdGhpcy5tYXhfY29kZT0wLHRoaXMuc3RhdF9kZXNjPXQ7fWZ1bmN0aW9uIFMoZSl7cmV0dXJuIGU8MjU2P21bZV06bVsyNTYrKGU+Pj43KV19ZnVuY3Rpb24geChlLHQpe2UucGVuZGluZ19idWZbZS5wZW5kaW5nKytdPTI1NSZ0LGUucGVuZGluZ19idWZbZS5wZW5kaW5nKytdPXQ+Pj44JjI1NTt9ZnVuY3Rpb24gQyhlLHQscil7ZS5iaV92YWxpZD4xNi1yPyhlLmJpX2J1Znw9dDw8ZS5iaV92YWxpZCY2NTUzNSx4KGUsZS5iaV9idWYpLGUuYmlfYnVmPXQ+PjE2LWUuYmlfdmFsaWQsZS5iaV92YWxpZCs9ci0xNik6KGUuYmlfYnVmfD10PDxlLmJpX3ZhbGlkJjY1NTM1LGUuYmlfdmFsaWQrPXIpO31mdW5jdGlvbiBQKGUsdCxyKXtDKGUsclsyKnRdLHJbMip0KzFdKTt9ZnVuY3Rpb24gRShlLHQpe2Zvcih2YXIgcj0wO3J8PTEmZSxlPj4+PTEscjw8PTEsMDwtLXQ7KTtyZXR1cm4gcj4+PjF9ZnVuY3Rpb24gTyhlLHQscil7dmFyIG4sYSxpPW5ldyBBcnJheSgxNikscz0wO2ZvcihuPTE7bjw9dTtuKyspaVtuXT1zPXMrcltuLTFdPDwxO2ZvcihhPTA7YTw9dDthKyspe3ZhciBvPWVbMiphKzFdOzAhPT1vJiYoZVsyKmFdPUUoaVtvXSsrLG8pKTt9fWZ1bmN0aW9uIEEoZSl7dmFyIHQ7Zm9yKHQ9MDt0PHM7dCsrKWUuZHluX2x0cmVlWzIqdF09MDtmb3IodD0wO3Q8bzt0KyspZS5keW5fZHRyZWVbMip0XT0wO2Zvcih0PTA7dDwxOTt0KyspZS5ibF90cmVlWzIqdF09MDtlLmR5bl9sdHJlZVs1MTJdPTEsZS5vcHRfbGVuPWUuc3RhdGljX2xlbj0wLGUubGFzdF9saXQ9ZS5tYXRjaGVzPTA7fWZ1bmN0aW9uIE0oZSl7ODxlLmJpX3ZhbGlkP3goZSxlLmJpX2J1Zik6MDxlLmJpX3ZhbGlkJiYoZS5wZW5kaW5nX2J1ZltlLnBlbmRpbmcrK109ZS5iaV9idWYpLGUuYmlfYnVmPTAsZS5iaV92YWxpZD0wO31mdW5jdGlvbiBMKGUsdCxyLG4pe3ZhciBhPTIqdCxpPTIqcjtyZXR1cm4gZVthXTxlW2ldfHxlW2FdPT09ZVtpXSYmblt0XTw9bltyXX1mdW5jdGlvbiB6KGUsdCxyKXtmb3IodmFyIG49ZS5oZWFwW3JdLGE9cjw8MTthPD1lLmhlYXBfbGVuJiYoYTxlLmhlYXBfbGVuJiZMKHQsZS5oZWFwW2ErMV0sZS5oZWFwW2FdLGUuZGVwdGgpJiZhKyssIUwodCxuLGUuaGVhcFthXSxlLmRlcHRoKSk7KWUuaGVhcFtyXT1lLmhlYXBbYV0scj1hLGE8PD0xO2UuaGVhcFtyXT1uO31mdW5jdGlvbiBJKGUsdCxyKXt2YXIgbixhLHMsbyx1PTA7aWYoMCE9PWUubGFzdF9saXQpZm9yKDtuPWUucGVuZGluZ19idWZbZS5kX2J1ZisyKnVdPDw4fGUucGVuZGluZ19idWZbZS5kX2J1ZisyKnUrMV0sYT1lLnBlbmRpbmdfYnVmW2UubF9idWYrdV0sdSsrLDA9PT1uP1AoZSxhLHQpOihQKGUsKHM9Z1thXSkraSsxLHQpLDAhPT0obz1sW3NdKSYmQyhlLGEtPV9bc10sbyksUChlLHM9UygtLW4pLHIpLDAhPT0obz1jW3NdKSYmQyhlLG4tPXdbc10sbykpLHU8ZS5sYXN0X2xpdDspO1AoZSwyNTYsdCk7fWZ1bmN0aW9uIFIoZSx0KXt2YXIgcixuLGEsaT10LmR5bl90cmVlLHM9dC5zdGF0X2Rlc2Muc3RhdGljX3RyZWUsbz10LnN0YXRfZGVzYy5oYXNfc3RyZWUsbD10LnN0YXRfZGVzYy5lbGVtcyxjPS0xO2ZvcihlLmhlYXBfbGVuPTAsZS5oZWFwX21heD01NzMscj0wO3I8bDtyKyspMCE9PWlbMipyXT8oZS5oZWFwWysrZS5oZWFwX2xlbl09Yz1yLGUuZGVwdGhbcl09MCk6aVsyKnIrMV09MDtmb3IoO2UuaGVhcF9sZW48MjspaVsyKihhPWUuaGVhcFsrK2UuaGVhcF9sZW5dPWM8Mj8rK2M6MCldPTEsZS5kZXB0aFthXT0wLGUub3B0X2xlbi0tLG8mJihlLnN0YXRpY19sZW4tPXNbMiphKzFdKTtmb3IodC5tYXhfY29kZT1jLHI9ZS5oZWFwX2xlbj4+MTsxPD1yO3ItLSl6KGUsaSxyKTtmb3IoYT1sO3I9ZS5oZWFwWzFdLGUuaGVhcFsxXT1lLmhlYXBbZS5oZWFwX2xlbi0tXSx6KGUsaSwxKSxuPWUuaGVhcFsxXSxlLmhlYXBbLS1lLmhlYXBfbWF4XT1yLGUuaGVhcFstLWUuaGVhcF9tYXhdPW4saVsyKmFdPWlbMipyXStpWzIqbl0sZS5kZXB0aFthXT0oZS5kZXB0aFtyXT49ZS5kZXB0aFtuXT9lLmRlcHRoW3JdOmUuZGVwdGhbbl0pKzEsaVsyKnIrMV09aVsyKm4rMV09YSxlLmhlYXBbMV09YSsrLHooZSxpLDEpLDI8PWUuaGVhcF9sZW47KTtlLmhlYXBbLS1lLmhlYXBfbWF4XT1lLmhlYXBbMV0sZnVuY3Rpb24oZSx0KXt2YXIgcixuLGEsaSxzLG8sbD10LmR5bl90cmVlLGM9dC5tYXhfY29kZSxoPXQuc3RhdF9kZXNjLnN0YXRpY190cmVlLGQ9dC5zdGF0X2Rlc2MuaGFzX3N0cmVlLGY9dC5zdGF0X2Rlc2MuZXh0cmFfYml0cyxwPXQuc3RhdF9kZXNjLmV4dHJhX2Jhc2UsbT10LnN0YXRfZGVzYy5tYXhfbGVuZ3RoLGc9MDtmb3IoaT0wO2k8PXU7aSsrKWUuYmxfY291bnRbaV09MDtmb3IobFsyKmUuaGVhcFtlLmhlYXBfbWF4XSsxXT0wLHI9ZS5oZWFwX21heCsxO3I8NTczO3IrKyltPChpPWxbMipsWzIqKG49ZS5oZWFwW3JdKSsxXSsxXSsxKSYmKGk9bSxnKyspLGxbMipuKzFdPWksYzxufHwoZS5ibF9jb3VudFtpXSsrLHM9MCxwPD1uJiYocz1mW24tcF0pLG89bFsyKm5dLGUub3B0X2xlbis9byooaStzKSxkJiYoZS5zdGF0aWNfbGVuKz1vKihoWzIqbisxXStzKSkpO2lmKDAhPT1nKXtkb3tmb3IoaT1tLTE7MD09PWUuYmxfY291bnRbaV07KWktLTtlLmJsX2NvdW50W2ldLS0sZS5ibF9jb3VudFtpKzFdKz0yLGUuYmxfY291bnRbbV0tLSxnLT0yO313aGlsZSgwPGcpO2ZvcihpPW07MCE9PWk7aS0tKWZvcihuPWUuYmxfY291bnRbaV07MCE9PW47KWM8KGE9ZS5oZWFwWy0tcl0pfHwobFsyKmErMV0hPT1pJiYoZS5vcHRfbGVuKz0oaS1sWzIqYSsxXSkqbFsyKmFdLGxbMiphKzFdPWkpLG4tLSk7fX0oZSx0KSxPKGksYyxlLmJsX2NvdW50KTt9ZnVuY3Rpb24gRihlLHQscil7dmFyIG4sYSxpPS0xLHM9dFsxXSxvPTAsdT03LGw9NDtmb3IoMD09PXMmJih1PTEzOCxsPTMpLHRbMioocisxKSsxXT02NTUzNSxuPTA7bjw9cjtuKyspYT1zLHM9dFsyKihuKzEpKzFdLCsrbzx1JiZhPT09c3x8KG88bD9lLmJsX3RyZWVbMiphXSs9bzowIT09YT8oYSE9PWkmJmUuYmxfdHJlZVsyKmFdKyssZS5ibF90cmVlWzMyXSsrKTpvPD0xMD9lLmJsX3RyZWVbMzRdKys6ZS5ibF90cmVlWzM2XSsrLGk9YSxsPShvPTApPT09cz8odT0xMzgsMyk6YT09PXM/KHU9NiwzKToodT03LDQpKTt9ZnVuY3Rpb24gaihlLHQscil7dmFyIG4sYSxpPS0xLHM9dFsxXSxvPTAsdT03LGw9NDtmb3IoMD09PXMmJih1PTEzOCxsPTMpLG49MDtuPD1yO24rKylpZihhPXMscz10WzIqKG4rMSkrMV0sISgrK288dSYmYT09PXMpKXtpZihvPGwpZm9yKDtQKGUsYSxlLmJsX3RyZWUpLDAhPS0tbzspO2Vsc2UgMCE9PWE/KGEhPT1pJiYoUChlLGEsZS5ibF90cmVlKSxvLS0pLFAoZSwxNixlLmJsX3RyZWUpLEMoZSxvLTMsMikpOm88PTEwPyhQKGUsMTcsZS5ibF90cmVlKSxDKGUsby0zLDMpKTooUChlLDE4LGUuYmxfdHJlZSksQyhlLG8tMTEsNykpO2k9YSxsPShvPTApPT09cz8odT0xMzgsMyk6YT09PXM/KHU9NiwzKToodT03LDQpO319YSh3KTt2YXIgRD0hMTtmdW5jdGlvbiBUKGUsdCxyLGEpe0MoZSwwKyhhPzE6MCksMyksZnVuY3Rpb24oZSx0LHIsYSl7TShlKSx4KGUscikseChlLH5yKSxuLmFycmF5U2V0KGUucGVuZGluZ19idWYsZS53aW5kb3csdCxyLGUucGVuZGluZyksZS5wZW5kaW5nKz1yO30oZSx0LHIpO31yLl90cl9pbml0PWZ1bmN0aW9uKGUpe0R8fChmdW5jdGlvbigpe3ZhciBlLHQscixuLGEsaT1uZXcgQXJyYXkoMTYpO2ZvcihuPXI9MDtuPDI4O24rKylmb3IoX1tuXT1yLGU9MDtlPDE8PGxbbl07ZSsrKWdbcisrXT1uO2ZvcihnW3ItMV09bixuPWE9MDtuPDE2O24rKylmb3Iod1tuXT1hLGU9MDtlPDE8PGNbbl07ZSsrKW1bYSsrXT1uO2ZvcihhPj49NztuPG87bisrKWZvcih3W25dPWE8PDcsZT0wO2U8MTw8Y1tuXS03O2UrKyltWzI1NithKytdPW47Zm9yKHQ9MDt0PD11O3QrKylpW3RdPTA7Zm9yKGU9MDtlPD0xNDM7KWZbMiplKzFdPTgsZSsrLGlbOF0rKztmb3IoO2U8PTI1NTspZlsyKmUrMV09OSxlKyssaVs5XSsrO2Zvcig7ZTw9Mjc5OylmWzIqZSsxXT03LGUrKyxpWzddKys7Zm9yKDtlPD0yODc7KWZbMiplKzFdPTgsZSsrLGlbOF0rKztmb3IoTyhmLDI4NyxpKSxlPTA7ZTxvO2UrKylwWzIqZSsxXT01LHBbMiplXT1FKGUsNSk7eT1uZXcgayhmLGwsMjU3LHMsdSksdj1uZXcgayhwLGMsMCxvLHUpLGI9bmV3IGsobmV3IEFycmF5KDApLGgsMCwxOSw3KTt9KCksRD0hMCksZS5sX2Rlc2M9bmV3IE4oZS5keW5fbHRyZWUseSksZS5kX2Rlc2M9bmV3IE4oZS5keW5fZHRyZWUsdiksZS5ibF9kZXNjPW5ldyBOKGUuYmxfdHJlZSxiKSxlLmJpX2J1Zj0wLGUuYmlfdmFsaWQ9MCxBKGUpO30sci5fdHJfc3RvcmVkX2Jsb2NrPVQsci5fdHJfZmx1c2hfYmxvY2s9ZnVuY3Rpb24oZSx0LHIsbil7dmFyIGEscyxvPTA7MDxlLmxldmVsPygyPT09ZS5zdHJtLmRhdGFfdHlwZSYmKGUuc3RybS5kYXRhX3R5cGU9ZnVuY3Rpb24oZSl7dmFyIHQscj00MDkzNjI0NDQ3O2Zvcih0PTA7dDw9MzE7dCsrLHI+Pj49MSlpZigxJnImJjAhPT1lLmR5bl9sdHJlZVsyKnRdKXJldHVybiAwO2lmKDAhPT1lLmR5bl9sdHJlZVsxOF18fDAhPT1lLmR5bl9sdHJlZVsyMF18fDAhPT1lLmR5bl9sdHJlZVsyNl0pcmV0dXJuIDE7Zm9yKHQ9MzI7dDxpO3QrKylpZigwIT09ZS5keW5fbHRyZWVbMip0XSlyZXR1cm4gMTtyZXR1cm4gMH0oZSkpLFIoZSxlLmxfZGVzYyksUihlLGUuZF9kZXNjKSxvPWZ1bmN0aW9uKGUpe3ZhciB0O2ZvcihGKGUsZS5keW5fbHRyZWUsZS5sX2Rlc2MubWF4X2NvZGUpLEYoZSxlLmR5bl9kdHJlZSxlLmRfZGVzYy5tYXhfY29kZSksUihlLGUuYmxfZGVzYyksdD0xODszPD10JiYwPT09ZS5ibF90cmVlWzIqZFt0XSsxXTt0LS0pO3JldHVybiBlLm9wdF9sZW4rPTMqKHQrMSkrNSs1KzQsdH0oZSksYT1lLm9wdF9sZW4rMys3Pj4+Mywocz1lLnN0YXRpY19sZW4rMys3Pj4+Myk8PWEmJihhPXMpKTphPXM9cis1LHIrNDw9YSYmLTEhPT10P1QoZSx0LHIsbik6ND09PWUuc3RyYXRlZ3l8fHM9PT1hPyhDKGUsMisobj8xOjApLDMpLEkoZSxmLHApKTooQyhlLDQrKG4/MTowKSwzKSxmdW5jdGlvbihlLHQscixuKXt2YXIgYTtmb3IoQyhlLHQtMjU3LDUpLEMoZSxyLTEsNSksQyhlLG4tNCw0KSxhPTA7YTxuO2ErKylDKGUsZS5ibF90cmVlWzIqZFthXSsxXSwzKTtqKGUsZS5keW5fbHRyZWUsdC0xKSxqKGUsZS5keW5fZHRyZWUsci0xKTt9KGUsZS5sX2Rlc2MubWF4X2NvZGUrMSxlLmRfZGVzYy5tYXhfY29kZSsxLG8rMSksSShlLGUuZHluX2x0cmVlLGUuZHluX2R0cmVlKSksQShlKSxuJiZNKGUpO30sci5fdHJfdGFsbHk9ZnVuY3Rpb24oZSx0LHIpe3JldHVybiBlLnBlbmRpbmdfYnVmW2UuZF9idWYrMiplLmxhc3RfbGl0XT10Pj4+OCYyNTUsZS5wZW5kaW5nX2J1ZltlLmRfYnVmKzIqZS5sYXN0X2xpdCsxXT0yNTUmdCxlLnBlbmRpbmdfYnVmW2UubF9idWYrZS5sYXN0X2xpdF09MjU1JnIsZS5sYXN0X2xpdCsrLDA9PT10P2UuZHluX2x0cmVlWzIqcl0rKzooZS5tYXRjaGVzKyssdC0tLGUuZHluX2x0cmVlWzIqKGdbcl0raSsxKV0rKyxlLmR5bl9kdHJlZVsyKlModCldKyspLGUubGFzdF9saXQ9PT1lLmxpdF9idWZzaXplLTF9LHIuX3RyX2FsaWduPWZ1bmN0aW9uKGUpe0MoZSwyLDMpLFAoZSwyNTYsZiksZnVuY3Rpb24oZSl7MTY9PT1lLmJpX3ZhbGlkPyh4KGUsZS5iaV9idWYpLGUuYmlfYnVmPTAsZS5iaV92YWxpZD0wKTo4PD1lLmJpX3ZhbGlkJiYoZS5wZW5kaW5nX2J1ZltlLnBlbmRpbmcrK109MjU1JmUuYmlfYnVmLGUuYmlfYnVmPj49OCxlLmJpX3ZhbGlkLT04KTt9KGUpO307fSx7Ii4uL3V0aWxzL2NvbW1vbiI6NDF9XSw1MzpbZnVuY3Rpb24oZSx0LHIpe3QuZXhwb3J0cz1mdW5jdGlvbigpe3RoaXMuaW5wdXQ9bnVsbCx0aGlzLm5leHRfaW49MCx0aGlzLmF2YWlsX2luPTAsdGhpcy50b3RhbF9pbj0wLHRoaXMub3V0cHV0PW51bGwsdGhpcy5uZXh0X291dD0wLHRoaXMuYXZhaWxfb3V0PTAsdGhpcy50b3RhbF9vdXQ9MCx0aGlzLm1zZz0iIix0aGlzLnN0YXRlPW51bGwsdGhpcy5kYXRhX3R5cGU9Mix0aGlzLmFkbGVyPTA7fTt9LHt9XSw1NDpbZnVuY3Rpb24oZSx0LHIpe3QuZXhwb3J0cz0iZnVuY3Rpb24iPT10eXBlb2Ygc2V0SW1tZWRpYXRlP3NldEltbWVkaWF0ZTpmdW5jdGlvbigpe3ZhciBlPVtdLnNsaWNlLmFwcGx5KGFyZ3VtZW50cyk7ZS5zcGxpY2UoMSwwLDApLHNldFRpbWVvdXQuYXBwbHkobnVsbCxlKTt9O30se31dfSx7fSxbMTBdKSgxMCk7fSkpOyFmdW5jdGlvbihlKXtmdW5jdGlvbiByKHQscil7cmV0dXJuIGUuY2FsbCh0aGlzLHQscil8fHRoaXN9dChyLGUpLHIuZnJvbURhdGE9ZnVuY3Rpb24oZSl7dmFyIHQ9TmFOLG49TmFOLGE9bmV3IFNldChbInkiXSksaT1uZXcgU2V0KFsieCJdKTtyZXR1cm4gT2JqZWN0LmtleXMoZSkuZm9yRWFjaCgoZnVuY3Rpb24ocil7dmFyIHM9ci50b0xvd2VyQ2FzZSgpO2lzTmFOKHQpJiZhLmhhcyhzKSYmIm51bWJlciI9PXR5cGVvZiBlW3JdP3Q9ZVtyXTppc05hTihuKSYmaS5oYXMocykmJiJudW1iZXIiPT10eXBlb2YgZVtyXSYmKG49ZVtyXSk7fSkpLGlzTmFOKHQpfHxpc05hTihuKT9udWxsOm5ldyByKHQsbil9LHIuZ2V0WD1mdW5jdGlvbihlKXtyZXR1cm4gZS5sZW5ndGg+MD9lWzBdOk5hTn0sci5nZXRZPWZ1bmN0aW9uKGUpe3JldHVybiBlLmxlbmd0aD4xP2VbMV06TmFOfSxyLmdldERlc3RpbmF0aW9uPWZ1bmN0aW9uKGUsdCxuKXtyZXR1cm4gbmV3IHIoci5nZXRYKGUpK24qTWF0aC5jb3MoKHQrMjcwKSpNYXRoLlBJLzE4MCksci5nZXRZKGUpK24qTWF0aC5zaW4oKHQrMjcwKSpNYXRoLlBJLzE4MCkpfSxyLmdldERpc3RhbmNlPWZ1bmN0aW9uKGUsdCl7dmFyIG49ci5nZXRYKGUpLXIuZ2V0WCh0KSxhPXIuZ2V0WShlKS1yLmdldFkodCk7cmV0dXJuIE1hdGguc3FydChuKm4rYSphKX0sci5nZXRIZWFkaW5nPWZ1bmN0aW9uKGUsdCl7dmFyIG49ci5nZXRYKHQpLXIuZ2V0WChlKSxhPXIuZ2V0WShlKS1yLmdldFkodCk7cmV0dXJuIDE4MCooMi41Kk1hdGguUEktTWF0aC5hdGFuMihhLG4pKS9NYXRoLlBJJTM2MH07fShBcnJheSk7dmFyIGw9ZnVuY3Rpb24oKXt0aGlzLl9fZGF0YV9fPVtdLHRoaXMuc2l6ZT0wO307dmFyIGM9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZT09PXR8fGUhPWUmJnQhPXR9O3ZhciBoPWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciByPWUubGVuZ3RoO3ItLTspaWYoYyhlW3JdWzBdLHQpKXJldHVybiByO3JldHVybiAtMX0sZD1BcnJheS5wcm90b3R5cGUuc3BsaWNlO3ZhciBmPWZ1bmN0aW9uKGUpe3ZhciB0PXRoaXMuX19kYXRhX18scj1oKHQsZSk7cmV0dXJuICEocjwwKSYmKHI9PXQubGVuZ3RoLTE/dC5wb3AoKTpkLmNhbGwodCxyLDEpLC0tdGhpcy5zaXplLCEwKX07dmFyIHA9ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5fX2RhdGFfXyxyPWgodCxlKTtyZXR1cm4gcjwwP3ZvaWQgMDp0W3JdWzFdfTt2YXIgbT1mdW5jdGlvbihlKXtyZXR1cm4gaCh0aGlzLl9fZGF0YV9fLGUpPi0xfTt2YXIgZz1mdW5jdGlvbihlLHQpe3ZhciByPXRoaXMuX19kYXRhX18sbj1oKHIsZSk7cmV0dXJuIG48MD8oKyt0aGlzLnNpemUsci5wdXNoKFtlLHRdKSk6cltuXVsxXT10LHRoaXN9O2Z1bmN0aW9uIF8oZSl7dmFyIHQ9LTEscj1udWxsPT1lPzA6ZS5sZW5ndGg7Zm9yKHRoaXMuY2xlYXIoKTsrK3Q8cjspe3ZhciBuPWVbdF07dGhpcy5zZXQoblswXSxuWzFdKTt9fV8ucHJvdG90eXBlLmNsZWFyPWwsXy5wcm90b3R5cGUuZGVsZXRlPWYsXy5wcm90b3R5cGUuZ2V0PXAsXy5wcm90b3R5cGUuaGFzPW0sXy5wcm90b3R5cGUuc2V0PWc7dmFyIHk9Xzt2YXIgdj1mdW5jdGlvbigpe3RoaXMuX19kYXRhX189bmV3IHksdGhpcy5zaXplPTA7fTt2YXIgYj1mdW5jdGlvbihlKXt2YXIgdD10aGlzLl9fZGF0YV9fLHI9dC5kZWxldGUoZSk7cmV0dXJuIHRoaXMuc2l6ZT10LnNpemUscn07dmFyIHc9ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX19kYXRhX18uZ2V0KGUpfTt2YXIgaz1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fX2RhdGFfXy5oYXMoZSl9LE49Im9iamVjdCI9PXR5cGVvZiBpJiZpJiZpLk9iamVjdD09PU9iamVjdCYmaSxTPSJvYmplY3QiPT10eXBlb2Ygc2VsZiYmc2VsZiYmc2VsZi5PYmplY3Q9PT1PYmplY3QmJnNlbGYseD1OfHxTfHxGdW5jdGlvbigicmV0dXJuIHRoaXMiKSgpLEM9eC5TeW1ib2wsUD1PYmplY3QucHJvdG90eXBlLEU9UC5oYXNPd25Qcm9wZXJ0eSxPPVAudG9TdHJpbmcsQT1DP0MudG9TdHJpbmdUYWc6dm9pZCAwO3ZhciBNPWZ1bmN0aW9uKGUpe3ZhciB0PUUuY2FsbChlLEEpLHI9ZVtBXTt0cnl7ZVtBXT12b2lkIDA7dmFyIG49ITA7fWNhdGNoKGUpe312YXIgYT1PLmNhbGwoZSk7cmV0dXJuIG4mJih0P2VbQV09cjpkZWxldGUgZVtBXSksYX0sTD1PYmplY3QucHJvdG90eXBlLnRvU3RyaW5nO3ZhciB6PWZ1bmN0aW9uKGUpe3JldHVybiBMLmNhbGwoZSl9LEk9Qz9DLnRvU3RyaW5nVGFnOnZvaWQgMDt2YXIgUj1mdW5jdGlvbihlKXtyZXR1cm4gbnVsbD09ZT92b2lkIDA9PT1lPyJbb2JqZWN0IFVuZGVmaW5lZF0iOiJbb2JqZWN0IE51bGxdIjpJJiZJIGluIE9iamVjdChlKT9NKGUpOnooZSl9O3ZhciBGPWZ1bmN0aW9uKGUpe3ZhciB0PXR5cGVvZiBlO3JldHVybiBudWxsIT1lJiYoIm9iamVjdCI9PXR8fCJmdW5jdGlvbiI9PXQpfTt2YXIgaixEPWZ1bmN0aW9uKGUpe2lmKCFGKGUpKXJldHVybiAhMTt2YXIgdD1SKGUpO3JldHVybiAiW29iamVjdCBGdW5jdGlvbl0iPT10fHwiW29iamVjdCBHZW5lcmF0b3JGdW5jdGlvbl0iPT10fHwiW29iamVjdCBBc3luY0Z1bmN0aW9uXSI9PXR8fCJbb2JqZWN0IFByb3h5XSI9PXR9LFQ9eFsiX19jb3JlLWpzX3NoYXJlZF9fIl0sQj0oaj0vW14uXSskLy5leGVjKFQmJlQua2V5cyYmVC5rZXlzLklFX1BST1RPfHwiIikpPyJTeW1ib2woc3JjKV8xLiIrajoiIjt2YXIgVT1mdW5jdGlvbihlKXtyZXR1cm4gISFCJiZCIGluIGV9LFc9RnVuY3Rpb24ucHJvdG90eXBlLnRvU3RyaW5nO3ZhciBHPWZ1bmN0aW9uKGUpe2lmKG51bGwhPWUpe3RyeXtyZXR1cm4gVy5jYWxsKGUpfWNhdGNoKGUpe310cnl7cmV0dXJuIGUrIiJ9Y2F0Y2goZSl7fX1yZXR1cm4gIiJ9LFo9L15cW29iamVjdCAuKz9Db25zdHJ1Y3RvclxdJC8sVj1GdW5jdGlvbi5wcm90b3R5cGUsSD1PYmplY3QucHJvdG90eXBlLEs9Vi50b1N0cmluZyxxPUguaGFzT3duUHJvcGVydHksWD1SZWdFeHAoIl4iK0suY2FsbChxKS5yZXBsYWNlKC9bXFxeJC4qKz8oKVtcXXt9fF0vZywiXFwkJiIpLnJlcGxhY2UoL2hhc093blByb3BlcnR5fChmdW5jdGlvbikuKj8oPz1cXFwoKXwgZm9yIC4rPyg/PVxcXF0pL2csIiQxLio/IikrIiQiKTt2YXIgWT1mdW5jdGlvbihlKXtyZXR1cm4gISghRihlKXx8VShlKSkmJihEKGUpP1g6WikudGVzdChHKGUpKX07dmFyICQ9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gbnVsbD09ZT92b2lkIDA6ZVt0XX07dmFyIEo9ZnVuY3Rpb24oZSx0KXt2YXIgcj0kKGUsdCk7cmV0dXJuIFkocik/cjp2b2lkIDB9LFE9Sih4LCJNYXAiKSxlZT1KKE9iamVjdCwiY3JlYXRlIik7dmFyIHRlPWZ1bmN0aW9uKCl7dGhpcy5fX2RhdGFfXz1lZT9lZShudWxsKTp7fSx0aGlzLnNpemU9MDt9O3ZhciByZT1mdW5jdGlvbihlKXt2YXIgdD10aGlzLmhhcyhlKSYmZGVsZXRlIHRoaXMuX19kYXRhX19bZV07cmV0dXJuIHRoaXMuc2l6ZS09dD8xOjAsdH0sbmU9T2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eTt2YXIgYWU9ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5fX2RhdGFfXztpZihlZSl7dmFyIHI9dFtlXTtyZXR1cm4gIl9fbG9kYXNoX2hhc2hfdW5kZWZpbmVkX18iPT09cj92b2lkIDA6cn1yZXR1cm4gbmUuY2FsbCh0LGUpP3RbZV06dm9pZCAwfSxpZT1PYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5O3ZhciBzZT1mdW5jdGlvbihlKXt2YXIgdD10aGlzLl9fZGF0YV9fO3JldHVybiBlZT92b2lkIDAhPT10W2VdOmllLmNhbGwodCxlKX07dmFyIG9lPWZ1bmN0aW9uKGUsdCl7dmFyIHI9dGhpcy5fX2RhdGFfXztyZXR1cm4gdGhpcy5zaXplKz10aGlzLmhhcyhlKT8wOjEscltlXT1lZSYmdm9pZCAwPT09dD8iX19sb2Rhc2hfaGFzaF91bmRlZmluZWRfXyI6dCx0aGlzfTtmdW5jdGlvbiB1ZShlKXt2YXIgdD0tMSxyPW51bGw9PWU/MDplLmxlbmd0aDtmb3IodGhpcy5jbGVhcigpOysrdDxyOyl7dmFyIG49ZVt0XTt0aGlzLnNldChuWzBdLG5bMV0pO319dWUucHJvdG90eXBlLmNsZWFyPXRlLHVlLnByb3RvdHlwZS5kZWxldGU9cmUsdWUucHJvdG90eXBlLmdldD1hZSx1ZS5wcm90b3R5cGUuaGFzPXNlLHVlLnByb3RvdHlwZS5zZXQ9b2U7dmFyIGxlPXVlO3ZhciBjZT1mdW5jdGlvbigpe3RoaXMuc2l6ZT0wLHRoaXMuX19kYXRhX189e2hhc2g6bmV3IGxlLG1hcDpuZXcoUXx8eSksc3RyaW5nOm5ldyBsZX07fTt2YXIgaGU9ZnVuY3Rpb24oZSl7dmFyIHQ9dHlwZW9mIGU7cmV0dXJuICJzdHJpbmciPT10fHwibnVtYmVyIj09dHx8InN5bWJvbCI9PXR8fCJib29sZWFuIj09dD8iX19wcm90b19fIiE9PWU6bnVsbD09PWV9O3ZhciBkZT1mdW5jdGlvbihlLHQpe3ZhciByPWUuX19kYXRhX187cmV0dXJuIGhlKHQpP3JbInN0cmluZyI9PXR5cGVvZiB0PyJzdHJpbmciOiJoYXNoIl06ci5tYXB9O3ZhciBmZT1mdW5jdGlvbihlKXt2YXIgdD1kZSh0aGlzLGUpLmRlbGV0ZShlKTtyZXR1cm4gdGhpcy5zaXplLT10PzE6MCx0fTt2YXIgcGU9ZnVuY3Rpb24oZSl7cmV0dXJuIGRlKHRoaXMsZSkuZ2V0KGUpfTt2YXIgbWU9ZnVuY3Rpb24oZSl7cmV0dXJuIGRlKHRoaXMsZSkuaGFzKGUpfTt2YXIgZ2U9ZnVuY3Rpb24oZSx0KXt2YXIgcj1kZSh0aGlzLGUpLG49ci5zaXplO3JldHVybiByLnNldChlLHQpLHRoaXMuc2l6ZSs9ci5zaXplPT1uPzA6MSx0aGlzfTtmdW5jdGlvbiBfZShlKXt2YXIgdD0tMSxyPW51bGw9PWU/MDplLmxlbmd0aDtmb3IodGhpcy5jbGVhcigpOysrdDxyOyl7dmFyIG49ZVt0XTt0aGlzLnNldChuWzBdLG5bMV0pO319X2UucHJvdG90eXBlLmNsZWFyPWNlLF9lLnByb3RvdHlwZS5kZWxldGU9ZmUsX2UucHJvdG90eXBlLmdldD1wZSxfZS5wcm90b3R5cGUuaGFzPW1lLF9lLnByb3RvdHlwZS5zZXQ9Z2U7dmFyIHllPV9lO3ZhciB2ZT1mdW5jdGlvbihlLHQpe3ZhciByPXRoaXMuX19kYXRhX187aWYociBpbnN0YW5jZW9mIHkpe3ZhciBuPXIuX19kYXRhX187aWYoIVF8fG4ubGVuZ3RoPDE5OSlyZXR1cm4gbi5wdXNoKFtlLHRdKSx0aGlzLnNpemU9KytyLnNpemUsdGhpcztyPXRoaXMuX19kYXRhX189bmV3IHllKG4pO31yZXR1cm4gci5zZXQoZSx0KSx0aGlzLnNpemU9ci5zaXplLHRoaXN9O2Z1bmN0aW9uIGJlKGUpe3ZhciB0PXRoaXMuX19kYXRhX189bmV3IHkoZSk7dGhpcy5zaXplPXQuc2l6ZTt9YmUucHJvdG90eXBlLmNsZWFyPXYsYmUucHJvdG90eXBlLmRlbGV0ZT1iLGJlLnByb3RvdHlwZS5nZXQ9dyxiZS5wcm90b3R5cGUuaGFzPWssYmUucHJvdG90eXBlLnNldD12ZTt2YXIgd2U9YmU7dmFyIGtlPWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciByPS0xLG49bnVsbD09ZT8wOmUubGVuZ3RoOysrcjxuJiYhMSE9PXQoZVtyXSxyLGUpOyk7cmV0dXJuIGV9LE5lPWZ1bmN0aW9uKCl7dHJ5e3ZhciBlPUooT2JqZWN0LCJkZWZpbmVQcm9wZXJ0eSIpO3JldHVybiBlKHt9LCIiLHt9KSxlfWNhdGNoKGUpe319KCk7dmFyIFNlPWZ1bmN0aW9uKGUsdCxyKXsiX19wcm90b19fIj09dCYmTmU/TmUoZSx0LHtjb25maWd1cmFibGU6ITAsZW51bWVyYWJsZTohMCx2YWx1ZTpyLHdyaXRhYmxlOiEwfSk6ZVt0XT1yO30seGU9T2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eTt2YXIgQ2U9ZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWVbdF07eGUuY2FsbChlLHQpJiZjKG4scikmJih2b2lkIDAhPT1yfHx0IGluIGUpfHxTZShlLHQscik7fTt2YXIgUGU9ZnVuY3Rpb24oZSx0LHIsbil7dmFyIGE9IXI7cnx8KHI9e30pO2Zvcih2YXIgaT0tMSxzPXQubGVuZ3RoOysraTxzOyl7dmFyIG89dFtpXSx1PW4/bihyW29dLGVbb10sbyxyLGUpOnZvaWQgMDt2b2lkIDA9PT11JiYodT1lW29dKSxhP1NlKHIsbyx1KTpDZShyLG8sdSk7fXJldHVybiByfTt2YXIgRWU9ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHI9LTEsbj1BcnJheShlKTsrK3I8ZTspbltyXT10KHIpO3JldHVybiBufTt2YXIgT2U9ZnVuY3Rpb24oZSl7cmV0dXJuIG51bGwhPWUmJiJvYmplY3QiPT10eXBlb2YgZX07dmFyIEFlPWZ1bmN0aW9uKGUpe3JldHVybiBPZShlKSYmIltvYmplY3QgQXJndW1lbnRzXSI9PVIoZSl9LE1lPU9iamVjdC5wcm90b3R5cGUsTGU9TWUuaGFzT3duUHJvcGVydHksemU9TWUucHJvcGVydHlJc0VudW1lcmFibGUsSWU9QWUoZnVuY3Rpb24oKXtyZXR1cm4gYXJndW1lbnRzfSgpKT9BZTpmdW5jdGlvbihlKXtyZXR1cm4gT2UoZSkmJkxlLmNhbGwoZSwiY2FsbGVlIikmJiF6ZS5jYWxsKGUsImNhbGxlZSIpfSxSZT1BcnJheS5pc0FycmF5O3ZhciBGZT1mdW5jdGlvbigpe3JldHVybiAhMX0samU9bygoZnVuY3Rpb24oZSx0KXt2YXIgcj10JiYhdC5ub2RlVHlwZSYmdCxuPXImJmUmJiFlLm5vZGVUeXBlJiZlLGE9biYmbi5leHBvcnRzPT09cj94LkJ1ZmZlcjp2b2lkIDAsaT0oYT9hLmlzQnVmZmVyOnZvaWQgMCl8fEZlO2UuZXhwb3J0cz1pO30pKSxEZT0vXig/OjB8WzEtOV1cZCopJC87dmFyIFRlPWZ1bmN0aW9uKGUsdCl7dmFyIHI9dHlwZW9mIGU7cmV0dXJuICEhKHQ9bnVsbD09dD85MDA3MTk5MjU0NzQwOTkxOnQpJiYoIm51bWJlciI9PXJ8fCJzeW1ib2wiIT1yJiZEZS50ZXN0KGUpKSYmZT4tMSYmZSUxPT0wJiZlPHR9O3ZhciBCZT1mdW5jdGlvbihlKXtyZXR1cm4gIm51bWJlciI9PXR5cGVvZiBlJiZlPi0xJiZlJTE9PTAmJmU8PTkwMDcxOTkyNTQ3NDA5OTF9LFVlPXt9O1VlWyJbb2JqZWN0IEZsb2F0MzJBcnJheV0iXT1VZVsiW29iamVjdCBGbG9hdDY0QXJyYXldIl09VWVbIltvYmplY3QgSW50OEFycmF5XSJdPVVlWyJbb2JqZWN0IEludDE2QXJyYXldIl09VWVbIltvYmplY3QgSW50MzJBcnJheV0iXT1VZVsiW29iamVjdCBVaW50OEFycmF5XSJdPVVlWyJbb2JqZWN0IFVpbnQ4Q2xhbXBlZEFycmF5XSJdPVVlWyJbb2JqZWN0IFVpbnQxNkFycmF5XSJdPVVlWyJbb2JqZWN0IFVpbnQzMkFycmF5XSJdPSEwLFVlWyJbb2JqZWN0IEFyZ3VtZW50c10iXT1VZVsiW29iamVjdCBBcnJheV0iXT1VZVsiW29iamVjdCBBcnJheUJ1ZmZlcl0iXT1VZVsiW29iamVjdCBCb29sZWFuXSJdPVVlWyJbb2JqZWN0IERhdGFWaWV3XSJdPVVlWyJbb2JqZWN0IERhdGVdIl09VWVbIltvYmplY3QgRXJyb3JdIl09VWVbIltvYmplY3QgRnVuY3Rpb25dIl09VWVbIltvYmplY3QgTWFwXSJdPVVlWyJbb2JqZWN0IE51bWJlcl0iXT1VZVsiW29iamVjdCBPYmplY3RdIl09VWVbIltvYmplY3QgUmVnRXhwXSJdPVVlWyJbb2JqZWN0IFNldF0iXT1VZVsiW29iamVjdCBTdHJpbmddIl09VWVbIltvYmplY3QgV2Vha01hcF0iXT0hMTt2YXIgV2U9ZnVuY3Rpb24oZSl7cmV0dXJuIE9lKGUpJiZCZShlLmxlbmd0aCkmJiEhVWVbUihlKV19O3ZhciBHZT1mdW5jdGlvbihlKXtyZXR1cm4gZnVuY3Rpb24odCl7cmV0dXJuIGUodCl9fSxaZT1vKChmdW5jdGlvbihlLHQpe3ZhciByPXQmJiF0Lm5vZGVUeXBlJiZ0LG49ciYmZSYmIWUubm9kZVR5cGUmJmUsYT1uJiZuLmV4cG9ydHM9PT1yJiZOLnByb2Nlc3MsaT1mdW5jdGlvbigpe3RyeXt2YXIgZT1uJiZuLnJlcXVpcmUmJm4ucmVxdWlyZSgidXRpbCIpLnR5cGVzO3JldHVybiBlfHxhJiZhLmJpbmRpbmcmJmEuYmluZGluZygidXRpbCIpfWNhdGNoKGUpe319KCk7ZS5leHBvcnRzPWk7fSkpLFZlPVplJiZaZS5pc1R5cGVkQXJyYXksSGU9VmU/R2UoVmUpOldlLEtlPU9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHk7dmFyIHFlPWZ1bmN0aW9uKGUsdCl7dmFyIHI9UmUoZSksbj0hciYmSWUoZSksYT0hciYmIW4mJmplKGUpLGk9IXImJiFuJiYhYSYmSGUoZSkscz1yfHxufHxhfHxpLG89cz9FZShlLmxlbmd0aCxTdHJpbmcpOltdLHU9by5sZW5ndGg7Zm9yKHZhciBsIGluIGUpIXQmJiFLZS5jYWxsKGUsbCl8fHMmJigibGVuZ3RoIj09bHx8YSYmKCJvZmZzZXQiPT1sfHwicGFyZW50Ij09bCl8fGkmJigiYnVmZmVyIj09bHx8ImJ5dGVMZW5ndGgiPT1sfHwiYnl0ZU9mZnNldCI9PWwpfHxUZShsLHUpKXx8by5wdXNoKGwpO3JldHVybiBvfSxYZT1PYmplY3QucHJvdG90eXBlO3ZhciBZZT1mdW5jdGlvbihlKXt2YXIgdD1lJiZlLmNvbnN0cnVjdG9yO3JldHVybiBlPT09KCJmdW5jdGlvbiI9PXR5cGVvZiB0JiZ0LnByb3RvdHlwZXx8WGUpfTt2YXIgJGU9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZnVuY3Rpb24ocil7cmV0dXJuIGUodChyKSl9fSxKZT0kZShPYmplY3Qua2V5cyxPYmplY3QpLFFlPU9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHk7dmFyIGV0PWZ1bmN0aW9uKGUpe2lmKCFZZShlKSlyZXR1cm4gSmUoZSk7dmFyIHQ9W107Zm9yKHZhciByIGluIE9iamVjdChlKSlRZS5jYWxsKGUscikmJiJjb25zdHJ1Y3RvciIhPXImJnQucHVzaChyKTtyZXR1cm4gdH07dmFyIHR0PWZ1bmN0aW9uKGUpe3JldHVybiBudWxsIT1lJiZCZShlLmxlbmd0aCkmJiFEKGUpfTt2YXIgcnQ9ZnVuY3Rpb24oZSl7cmV0dXJuIHR0KGUpP3FlKGUpOmV0KGUpfTt2YXIgbnQ9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZSYmUGUodCxydCh0KSxlKX07dmFyIGF0PWZ1bmN0aW9uKGUpe3ZhciB0PVtdO2lmKG51bGwhPWUpZm9yKHZhciByIGluIE9iamVjdChlKSl0LnB1c2gocik7cmV0dXJuIHR9LGl0PU9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHk7dmFyIHN0PWZ1bmN0aW9uKGUpe2lmKCFGKGUpKXJldHVybiBhdChlKTt2YXIgdD1ZZShlKSxyPVtdO2Zvcih2YXIgbiBpbiBlKSgiY29uc3RydWN0b3IiIT1ufHwhdCYmaXQuY2FsbChlLG4pKSYmci5wdXNoKG4pO3JldHVybiByfTt2YXIgb3Q9ZnVuY3Rpb24oZSl7cmV0dXJuIHR0KGUpP3FlKGUsITApOnN0KGUpfTt2YXIgdXQ9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZSYmUGUodCxvdCh0KSxlKX0sbHQ9bygoZnVuY3Rpb24oZSx0KXt2YXIgcj10JiYhdC5ub2RlVHlwZSYmdCxuPXImJmUmJiFlLm5vZGVUeXBlJiZlLGE9biYmbi5leHBvcnRzPT09cj94LkJ1ZmZlcjp2b2lkIDAsaT1hP2EuYWxsb2NVbnNhZmU6dm9pZCAwO2UuZXhwb3J0cz1mdW5jdGlvbihlLHQpe2lmKHQpcmV0dXJuIGUuc2xpY2UoKTt2YXIgcj1lLmxlbmd0aCxuPWk/aShyKTpuZXcgZS5jb25zdHJ1Y3RvcihyKTtyZXR1cm4gZS5jb3B5KG4pLG59O30pKTt2YXIgY3Q9ZnVuY3Rpb24oZSx0KXt2YXIgcj0tMSxuPWUubGVuZ3RoO2Zvcih0fHwodD1BcnJheShuKSk7KytyPG47KXRbcl09ZVtyXTtyZXR1cm4gdH07dmFyIGh0PWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciByPS0xLG49bnVsbD09ZT8wOmUubGVuZ3RoLGE9MCxpPVtdOysrcjxuOyl7dmFyIHM9ZVtyXTt0KHMscixlKSYmKGlbYSsrXT1zKTt9cmV0dXJuIGl9O3ZhciBkdD1mdW5jdGlvbigpe3JldHVybiBbXX0sZnQ9T2JqZWN0LnByb3RvdHlwZS5wcm9wZXJ0eUlzRW51bWVyYWJsZSxwdD1PYmplY3QuZ2V0T3duUHJvcGVydHlTeW1ib2xzLG10PXB0P2Z1bmN0aW9uKGUpe3JldHVybiBudWxsPT1lP1tdOihlPU9iamVjdChlKSxodChwdChlKSwoZnVuY3Rpb24odCl7cmV0dXJuIGZ0LmNhbGwoZSx0KX0pKSl9OmR0O3ZhciBndD1mdW5jdGlvbihlLHQpe3JldHVybiBQZShlLG10KGUpLHQpfTt2YXIgX3Q9ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHI9LTEsbj10Lmxlbmd0aCxhPWUubGVuZ3RoOysrcjxuOyllW2Ercl09dFtyXTtyZXR1cm4gZX0seXQ9JGUoT2JqZWN0LmdldFByb3RvdHlwZU9mLE9iamVjdCksdnQ9T2JqZWN0LmdldE93blByb3BlcnR5U3ltYm9scz9mdW5jdGlvbihlKXtmb3IodmFyIHQ9W107ZTspX3QodCxtdChlKSksZT15dChlKTtyZXR1cm4gdH06ZHQ7dmFyIGJ0PWZ1bmN0aW9uKGUsdCl7cmV0dXJuIFBlKGUsdnQoZSksdCl9O3ZhciB3dD1mdW5jdGlvbihlLHQscil7dmFyIG49dChlKTtyZXR1cm4gUmUoZSk/bjpfdChuLHIoZSkpfTt2YXIga3Q9ZnVuY3Rpb24oZSl7cmV0dXJuIHd0KGUscnQsbXQpfTt2YXIgTnQ9ZnVuY3Rpb24oZSl7cmV0dXJuIHd0KGUsb3QsdnQpfSxTdD1KKHgsIkRhdGFWaWV3IikseHQ9Sih4LCJQcm9taXNlIiksQ3Q9Sih4LCJTZXQiKSxQdD1KKHgsIldlYWtNYXAiKSxFdD1HKFN0KSxPdD1HKFEpLEF0PUcoeHQpLE10PUcoQ3QpLEx0PUcoUHQpLHp0PVI7KFN0JiYiW29iamVjdCBEYXRhVmlld10iIT16dChuZXcgU3QobmV3IEFycmF5QnVmZmVyKDEpKSl8fFEmJiJbb2JqZWN0IE1hcF0iIT16dChuZXcgUSl8fHh0JiYiW29iamVjdCBQcm9taXNlXSIhPXp0KHh0LnJlc29sdmUoKSl8fEN0JiYiW29iamVjdCBTZXRdIiE9enQobmV3IEN0KXx8UHQmJiJbb2JqZWN0IFdlYWtNYXBdIiE9enQobmV3IFB0KSkmJih6dD1mdW5jdGlvbihlKXt2YXIgdD1SKGUpLHI9IltvYmplY3QgT2JqZWN0XSI9PXQ/ZS5jb25zdHJ1Y3Rvcjp2b2lkIDAsbj1yP0cocik6IiI7aWYobilzd2l0Y2gobil7Y2FzZSBFdDpyZXR1cm4gIltvYmplY3QgRGF0YVZpZXddIjtjYXNlIE90OnJldHVybiAiW29iamVjdCBNYXBdIjtjYXNlIEF0OnJldHVybiAiW29iamVjdCBQcm9taXNlXSI7Y2FzZSBNdDpyZXR1cm4gIltvYmplY3QgU2V0XSI7Y2FzZSBMdDpyZXR1cm4gIltvYmplY3QgV2Vha01hcF0ifXJldHVybiB0fSk7dmFyIEl0PXp0LFJ0PU9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHk7dmFyIEZ0PWZ1bmN0aW9uKGUpe3ZhciB0PWUubGVuZ3RoLHI9bmV3IGUuY29uc3RydWN0b3IodCk7cmV0dXJuIHQmJiJzdHJpbmciPT10eXBlb2YgZVswXSYmUnQuY2FsbChlLCJpbmRleCIpJiYoci5pbmRleD1lLmluZGV4LHIuaW5wdXQ9ZS5pbnB1dCkscn0sanQ9eC5VaW50OEFycmF5O3ZhciBEdD1mdW5jdGlvbihlKXt2YXIgdD1uZXcgZS5jb25zdHJ1Y3RvcihlLmJ5dGVMZW5ndGgpO3JldHVybiBuZXcganQodCkuc2V0KG5ldyBqdChlKSksdH07dmFyIFR0PWZ1bmN0aW9uKGUsdCl7dmFyIHI9dD9EdChlLmJ1ZmZlcik6ZS5idWZmZXI7cmV0dXJuIG5ldyBlLmNvbnN0cnVjdG9yKHIsZS5ieXRlT2Zmc2V0LGUuYnl0ZUxlbmd0aCl9LEJ0PS9cdyokLzt2YXIgVXQ9ZnVuY3Rpb24oZSl7dmFyIHQ9bmV3IGUuY29uc3RydWN0b3IoZS5zb3VyY2UsQnQuZXhlYyhlKSk7cmV0dXJuIHQubGFzdEluZGV4PWUubGFzdEluZGV4LHR9LFd0PUM/Qy5wcm90b3R5cGU6dm9pZCAwLEd0PVd0P1d0LnZhbHVlT2Y6dm9pZCAwO3ZhciBadD1mdW5jdGlvbihlKXtyZXR1cm4gR3Q/T2JqZWN0KEd0LmNhbGwoZSkpOnt9fTt2YXIgVnQ9ZnVuY3Rpb24oZSx0KXt2YXIgcj10P0R0KGUuYnVmZmVyKTplLmJ1ZmZlcjtyZXR1cm4gbmV3IGUuY29uc3RydWN0b3IocixlLmJ5dGVPZmZzZXQsZS5sZW5ndGgpfTt2YXIgSHQ9ZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWUuY29uc3RydWN0b3I7c3dpdGNoKHQpe2Nhc2UiW29iamVjdCBBcnJheUJ1ZmZlcl0iOnJldHVybiBEdChlKTtjYXNlIltvYmplY3QgQm9vbGVhbl0iOmNhc2UiW29iamVjdCBEYXRlXSI6cmV0dXJuIG5ldyBuKCtlKTtjYXNlIltvYmplY3QgRGF0YVZpZXddIjpyZXR1cm4gVHQoZSxyKTtjYXNlIltvYmplY3QgRmxvYXQzMkFycmF5XSI6Y2FzZSJbb2JqZWN0IEZsb2F0NjRBcnJheV0iOmNhc2UiW29iamVjdCBJbnQ4QXJyYXldIjpjYXNlIltvYmplY3QgSW50MTZBcnJheV0iOmNhc2UiW29iamVjdCBJbnQzMkFycmF5XSI6Y2FzZSJbb2JqZWN0IFVpbnQ4QXJyYXldIjpjYXNlIltvYmplY3QgVWludDhDbGFtcGVkQXJyYXldIjpjYXNlIltvYmplY3QgVWludDE2QXJyYXldIjpjYXNlIltvYmplY3QgVWludDMyQXJyYXldIjpyZXR1cm4gVnQoZSxyKTtjYXNlIltvYmplY3QgTWFwXSI6cmV0dXJuIG5ldyBuO2Nhc2UiW29iamVjdCBOdW1iZXJdIjpjYXNlIltvYmplY3QgU3RyaW5nXSI6cmV0dXJuIG5ldyBuKGUpO2Nhc2UiW29iamVjdCBSZWdFeHBdIjpyZXR1cm4gVXQoZSk7Y2FzZSJbb2JqZWN0IFNldF0iOnJldHVybiBuZXcgbjtjYXNlIltvYmplY3QgU3ltYm9sXSI6cmV0dXJuIFp0KGUpfX0sS3Q9T2JqZWN0LmNyZWF0ZSxxdD1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt9cmV0dXJuIGZ1bmN0aW9uKHQpe2lmKCFGKHQpKXJldHVybiB7fTtpZihLdClyZXR1cm4gS3QodCk7ZS5wcm90b3R5cGU9dDt2YXIgcj1uZXcgZTtyZXR1cm4gZS5wcm90b3R5cGU9dm9pZCAwLHJ9fSgpO3ZhciBYdD1mdW5jdGlvbihlKXtyZXR1cm4gImZ1bmN0aW9uIiE9dHlwZW9mIGUuY29uc3RydWN0b3J8fFllKGUpP3t9OnF0KHl0KGUpKX07dmFyIFl0PWZ1bmN0aW9uKGUpe3JldHVybiBPZShlKSYmIltvYmplY3QgTWFwXSI9PUl0KGUpfSwkdD1aZSYmWmUuaXNNYXAsSnQ9JHQ/R2UoJHQpOll0O3ZhciBRdD1mdW5jdGlvbihlKXtyZXR1cm4gT2UoZSkmJiJbb2JqZWN0IFNldF0iPT1JdChlKX0sZXI9WmUmJlplLmlzU2V0LHRyPWVyP0dlKGVyKTpRdCxycj17fTtyclsiW29iamVjdCBBcmd1bWVudHNdIl09cnJbIltvYmplY3QgQXJyYXldIl09cnJbIltvYmplY3QgQXJyYXlCdWZmZXJdIl09cnJbIltvYmplY3QgRGF0YVZpZXddIl09cnJbIltvYmplY3QgQm9vbGVhbl0iXT1yclsiW29iamVjdCBEYXRlXSJdPXJyWyJbb2JqZWN0IEZsb2F0MzJBcnJheV0iXT1yclsiW29iamVjdCBGbG9hdDY0QXJyYXldIl09cnJbIltvYmplY3QgSW50OEFycmF5XSJdPXJyWyJbb2JqZWN0IEludDE2QXJyYXldIl09cnJbIltvYmplY3QgSW50MzJBcnJheV0iXT1yclsiW29iamVjdCBNYXBdIl09cnJbIltvYmplY3QgTnVtYmVyXSJdPXJyWyJbb2JqZWN0IE9iamVjdF0iXT1yclsiW29iamVjdCBSZWdFeHBdIl09cnJbIltvYmplY3QgU2V0XSJdPXJyWyJbb2JqZWN0IFN0cmluZ10iXT1yclsiW29iamVjdCBTeW1ib2xdIl09cnJbIltvYmplY3QgVWludDhBcnJheV0iXT1yclsiW29iamVjdCBVaW50OENsYW1wZWRBcnJheV0iXT1yclsiW29iamVjdCBVaW50MTZBcnJheV0iXT1yclsiW29iamVjdCBVaW50MzJBcnJheV0iXT0hMCxyclsiW29iamVjdCBFcnJvcl0iXT1yclsiW29iamVjdCBGdW5jdGlvbl0iXT1yclsiW29iamVjdCBXZWFrTWFwXSJdPSExO3ZhciBucj1mdW5jdGlvbiBlKHQscixuLGEsaSxzKXt2YXIgbyx1PTEmcixsPTImcixjPTQmcjtpZihuJiYobz1pP24odCxhLGkscyk6bih0KSksdm9pZCAwIT09bylyZXR1cm4gbztpZighRih0KSlyZXR1cm4gdDt2YXIgaD1SZSh0KTtpZihoKXtpZihvPUZ0KHQpLCF1KXJldHVybiBjdCh0LG8pfWVsc2Uge3ZhciBkPUl0KHQpLGY9IltvYmplY3QgRnVuY3Rpb25dIj09ZHx8IltvYmplY3QgR2VuZXJhdG9yRnVuY3Rpb25dIj09ZDtpZihqZSh0KSlyZXR1cm4gbHQodCx1KTtpZigiW29iamVjdCBPYmplY3RdIj09ZHx8IltvYmplY3QgQXJndW1lbnRzXSI9PWR8fGYmJiFpKXtpZihvPWx8fGY/e306WHQodCksIXUpcmV0dXJuIGw/YnQodCx1dChvLHQpKTpndCh0LG50KG8sdCkpfWVsc2Uge2lmKCFycltkXSlyZXR1cm4gaT90Ont9O289SHQodCxkLHUpO319c3x8KHM9bmV3IHdlKTt2YXIgcD1zLmdldCh0KTtpZihwKXJldHVybiBwO3Muc2V0KHQsbyksdHIodCk/dC5mb3JFYWNoKChmdW5jdGlvbihhKXtvLmFkZChlKGEscixuLGEsdCxzKSk7fSkpOkp0KHQpJiZ0LmZvckVhY2goKGZ1bmN0aW9uKGEsaSl7by5zZXQoaSxlKGEscixuLGksdCxzKSk7fSkpO3ZhciBtPWM/bD9OdDprdDpsP2tleXNJbjpydCxnPWg/dm9pZCAwOm0odCk7cmV0dXJuIGtlKGd8fHQsKGZ1bmN0aW9uKGEsaSl7ZyYmKGE9dFtpPWFdKSxDZShvLGksZShhLHIsbixpLHQscykpO30pKSxvfTt2YXIgYXI9ZnVuY3Rpb24oZSl7cmV0dXJuIG5yKGUsNSl9O3ZhciBpcj1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fX2RhdGFfXy5zZXQoZSwiX19sb2Rhc2hfaGFzaF91bmRlZmluZWRfXyIpLHRoaXN9O3ZhciBzcj1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fX2RhdGFfXy5oYXMoZSl9O2Z1bmN0aW9uIG9yKGUpe3ZhciB0PS0xLHI9bnVsbD09ZT8wOmUubGVuZ3RoO2Zvcih0aGlzLl9fZGF0YV9fPW5ldyB5ZTsrK3Q8cjspdGhpcy5hZGQoZVt0XSk7fW9yLnByb3RvdHlwZS5hZGQ9b3IucHJvdG90eXBlLnB1c2g9aXIsb3IucHJvdG90eXBlLmhhcz1zcjt2YXIgdXI9b3I7dmFyIGxyPWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciByPS0xLG49bnVsbD09ZT8wOmUubGVuZ3RoOysrcjxuOylpZih0KGVbcl0scixlKSlyZXR1cm4gITA7cmV0dXJuICExfTt2YXIgY3I9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZS5oYXModCl9O3ZhciBocj1mdW5jdGlvbihlLHQscixuLGEsaSl7dmFyIHM9MSZyLG89ZS5sZW5ndGgsdT10Lmxlbmd0aDtpZihvIT11JiYhKHMmJnU+bykpcmV0dXJuICExO3ZhciBsPWkuZ2V0KGUpO2lmKGwmJmkuZ2V0KHQpKXJldHVybiBsPT10O3ZhciBjPS0xLGg9ITAsZD0yJnI/bmV3IHVyOnZvaWQgMDtmb3IoaS5zZXQoZSx0KSxpLnNldCh0LGUpOysrYzxvOyl7dmFyIGY9ZVtjXSxwPXRbY107aWYobil2YXIgbT1zP24ocCxmLGMsdCxlLGkpOm4oZixwLGMsZSx0LGkpO2lmKHZvaWQgMCE9PW0pe2lmKG0pY29udGludWU7aD0hMTticmVha31pZihkKXtpZighbHIodCwoZnVuY3Rpb24oZSx0KXtpZighY3IoZCx0KSYmKGY9PT1lfHxhKGYsZSxyLG4saSkpKXJldHVybiBkLnB1c2godCl9KSkpe2g9ITE7YnJlYWt9fWVsc2UgaWYoZiE9PXAmJiFhKGYscCxyLG4saSkpe2g9ITE7YnJlYWt9fXJldHVybiBpLmRlbGV0ZShlKSxpLmRlbGV0ZSh0KSxofTt2YXIgZHI9ZnVuY3Rpb24oZSl7dmFyIHQ9LTEscj1BcnJheShlLnNpemUpO3JldHVybiBlLmZvckVhY2goKGZ1bmN0aW9uKGUsbil7clsrK3RdPVtuLGVdO30pKSxyfTt2YXIgZnI9ZnVuY3Rpb24oZSl7dmFyIHQ9LTEscj1BcnJheShlLnNpemUpO3JldHVybiBlLmZvckVhY2goKGZ1bmN0aW9uKGUpe3JbKyt0XT1lO30pKSxyfSxwcj1DP0MucHJvdG90eXBlOnZvaWQgMCxtcj1wcj9wci52YWx1ZU9mOnZvaWQgMDt2YXIgZ3I9ZnVuY3Rpb24oZSx0LHIsbixhLGkscyl7c3dpdGNoKHIpe2Nhc2UiW29iamVjdCBEYXRhVmlld10iOmlmKGUuYnl0ZUxlbmd0aCE9dC5ieXRlTGVuZ3RofHxlLmJ5dGVPZmZzZXQhPXQuYnl0ZU9mZnNldClyZXR1cm4gITE7ZT1lLmJ1ZmZlcix0PXQuYnVmZmVyO2Nhc2UiW29iamVjdCBBcnJheUJ1ZmZlcl0iOnJldHVybiAhKGUuYnl0ZUxlbmd0aCE9dC5ieXRlTGVuZ3RofHwhaShuZXcganQoZSksbmV3IGp0KHQpKSk7Y2FzZSJbb2JqZWN0IEJvb2xlYW5dIjpjYXNlIltvYmplY3QgRGF0ZV0iOmNhc2UiW29iamVjdCBOdW1iZXJdIjpyZXR1cm4gYygrZSwrdCk7Y2FzZSJbb2JqZWN0IEVycm9yXSI6cmV0dXJuIGUubmFtZT09dC5uYW1lJiZlLm1lc3NhZ2U9PXQubWVzc2FnZTtjYXNlIltvYmplY3QgUmVnRXhwXSI6Y2FzZSJbb2JqZWN0IFN0cmluZ10iOnJldHVybiBlPT10KyIiO2Nhc2UiW29iamVjdCBNYXBdIjp2YXIgbz1kcjtjYXNlIltvYmplY3QgU2V0XSI6dmFyIHU9MSZuO2lmKG98fChvPWZyKSxlLnNpemUhPXQuc2l6ZSYmIXUpcmV0dXJuICExO3ZhciBsPXMuZ2V0KGUpO2lmKGwpcmV0dXJuIGw9PXQ7bnw9MixzLnNldChlLHQpO3ZhciBoPWhyKG8oZSksbyh0KSxuLGEsaSxzKTtyZXR1cm4gcy5kZWxldGUoZSksaDtjYXNlIltvYmplY3QgU3ltYm9sXSI6aWYobXIpcmV0dXJuIG1yLmNhbGwoZSk9PW1yLmNhbGwodCl9cmV0dXJuICExfSxfcj1PYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5O3ZhciB5cj1mdW5jdGlvbihlLHQscixuLGEsaSl7dmFyIHM9MSZyLG89a3QoZSksdT1vLmxlbmd0aDtpZih1IT1rdCh0KS5sZW5ndGgmJiFzKXJldHVybiAhMTtmb3IodmFyIGw9dTtsLS07KXt2YXIgYz1vW2xdO2lmKCEocz9jIGluIHQ6X3IuY2FsbCh0LGMpKSlyZXR1cm4gITF9dmFyIGg9aS5nZXQoZSk7aWYoaCYmaS5nZXQodCkpcmV0dXJuIGg9PXQ7dmFyIGQ9ITA7aS5zZXQoZSx0KSxpLnNldCh0LGUpO2Zvcih2YXIgZj1zOysrbDx1Oyl7dmFyIHA9ZVtjPW9bbF1dLG09dFtjXTtpZihuKXZhciBnPXM/bihtLHAsYyx0LGUsaSk6bihwLG0sYyxlLHQsaSk7aWYoISh2b2lkIDA9PT1nP3A9PT1tfHxhKHAsbSxyLG4saSk6Zykpe2Q9ITE7YnJlYWt9Znx8KGY9ImNvbnN0cnVjdG9yIj09Yyk7fWlmKGQmJiFmKXt2YXIgXz1lLmNvbnN0cnVjdG9yLHk9dC5jb25zdHJ1Y3RvcjtfIT15JiYiY29uc3RydWN0b3IiaW4gZSYmImNvbnN0cnVjdG9yImluIHQmJiEoImZ1bmN0aW9uIj09dHlwZW9mIF8mJl8gaW5zdGFuY2VvZiBfJiYiZnVuY3Rpb24iPT10eXBlb2YgeSYmeSBpbnN0YW5jZW9mIHkpJiYoZD0hMSk7fXJldHVybiBpLmRlbGV0ZShlKSxpLmRlbGV0ZSh0KSxkfSx2cj1PYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5O3ZhciBicj1mdW5jdGlvbihlLHQscixuLGEsaSl7dmFyIHM9UmUoZSksbz1SZSh0KSx1PXM/IltvYmplY3QgQXJyYXldIjpJdChlKSxsPW8/IltvYmplY3QgQXJyYXldIjpJdCh0KSxjPSJbb2JqZWN0IE9iamVjdF0iPT0odT0iW29iamVjdCBBcmd1bWVudHNdIj09dT8iW29iamVjdCBPYmplY3RdIjp1KSxoPSJbb2JqZWN0IE9iamVjdF0iPT0obD0iW29iamVjdCBBcmd1bWVudHNdIj09bD8iW29iamVjdCBPYmplY3RdIjpsKSxkPXU9PWw7aWYoZCYmamUoZSkpe2lmKCFqZSh0KSlyZXR1cm4gITE7cz0hMCxjPSExO31pZihkJiYhYylyZXR1cm4gaXx8KGk9bmV3IHdlKSxzfHxIZShlKT9ocihlLHQscixuLGEsaSk6Z3IoZSx0LHUscixuLGEsaSk7aWYoISgxJnIpKXt2YXIgZj1jJiZ2ci5jYWxsKGUsIl9fd3JhcHBlZF9fIikscD1oJiZ2ci5jYWxsKHQsIl9fd3JhcHBlZF9fIik7aWYoZnx8cCl7dmFyIG09Zj9lLnZhbHVlKCk6ZSxnPXA/dC52YWx1ZSgpOnQ7cmV0dXJuIGl8fChpPW5ldyB3ZSksYShtLGcscixuLGkpfX1yZXR1cm4gISFkJiYoaXx8KGk9bmV3IHdlKSx5cihlLHQscixuLGEsaSkpfTt2YXIgd3I9ZnVuY3Rpb24gZSh0LHIsbixhLGkpe3JldHVybiB0PT09cnx8KG51bGw9PXR8fG51bGw9PXJ8fCFPZSh0KSYmIU9lKHIpP3QhPXQmJnIhPXI6YnIodCxyLG4sYSxlLGkpKX07dmFyIGtyLE5yLFNyLHhyLENyLFByLEVyPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIHdyKGUsdCl9LE9yPShrcj1PYmplY3QuZnJlZXplKHtfX3Byb3RvX186bnVsbCxkZWZhdWx0Ont9fSkpJiZrci5kZWZhdWx0fHxrcixBcj1vKChmdW5jdGlvbihlKXshZnVuY3Rpb24oKXt2YXIgdCxyLG4sYT0wLGk9W107Zm9yKHI9MDtyPDI1NjtyKyspaVtyXT0ocisyNTYpLnRvU3RyaW5nKDE2KS5zdWJzdHIoMSk7ZnVuY3Rpb24gcygpe3ZhciBlPWZ1bmN0aW9uKGUpe3JldHVybiAoIXR8fGErZT5vLkJVRkZFUl9TSVpFKSYmKGE9MCx0PW8ucmFuZG9tQnl0ZXMoby5CVUZGRVJfU0laRSkpLHQuc2xpY2UoYSxhKz1lKX0oMTYpO3JldHVybiBlWzZdPTE1JmVbNl18NjQsZVs4XT02MyZlWzhdfDEyOCxlfWZ1bmN0aW9uIG8oKXt2YXIgZT1zKCk7cmV0dXJuIGlbZVswXV0raVtlWzFdXStpW2VbMl1dK2lbZVszXV0rIi0iK2lbZVs0XV0raVtlWzVdXSsiLSIraVtlWzZdXStpW2VbN11dKyItIitpW2VbOF1dK2lbZVs5XV0rIi0iK2lbZVsxMF1dK2lbZVsxMV1dK2lbZVsxMl1dK2lbZVsxM11dK2lbZVsxNF1dK2lbZVsxNV1dfW8uQlVGRkVSX1NJWkU9NDA5NixvLmJpbj1zLG8uY2xlYXJCdWZmZXI9ZnVuY3Rpb24oKXt0PW51bGwsYT0wO30sby50ZXN0PWZ1bmN0aW9uKGUpe3JldHVybiAic3RyaW5nIj09dHlwZW9mIGUmJi9eWzAtOWEtZl17OH0tWzAtOWEtZl17NH0tNFswLTlhLWZdezN9LVs4OWFiXVswLTlhLWZdezN9LVswLTlhLWZdezEyfSQvLnRlc3QoZSl9LCJ1bmRlZmluZWQiIT10eXBlb2YgY3J5cHRvP249Y3J5cHRvOiJ1bmRlZmluZWQiIT10eXBlb2Ygd2luZG93JiZ2b2lkIDAhPT13aW5kb3cubXNDcnlwdG8mJihuPXdpbmRvdy5tc0NyeXB0byksbj1ufHxPcixlLmV4cG9ydHM9byxvLnJhbmRvbUJ5dGVzPWZ1bmN0aW9uKCl7aWYobil7aWYobi5yYW5kb21CeXRlcylyZXR1cm4gbi5yYW5kb21CeXRlcztpZihuLmdldFJhbmRvbVZhbHVlcylyZXR1cm4gZnVuY3Rpb24oZSl7dmFyIHQ9bmV3IFVpbnQ4QXJyYXkoZSk7cmV0dXJuIG4uZ2V0UmFuZG9tVmFsdWVzKHQpLHR9fXJldHVybiBmdW5jdGlvbihlKXt2YXIgdCxyPVtdO2Zvcih0PTA7dDxlO3QrKylyLnB1c2goTWF0aC5mbG9vcigyNTYqTWF0aC5yYW5kb20oKSkpO3JldHVybiByfX0oKTt9KCk7fSkpLE1yPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIodCxyLG4pe3JldHVybiBuP2UuY2FsbCh0aGlzLHQscixuKXx8dGhpczplLmNhbGwodGhpcyx0LHIpfHx0aGlzfXJldHVybiB0KHIsZSksci5mcm9tUG9zaXRpb249ZnVuY3Rpb24oZSl7cmV0dXJuIDI9PT1lLmxlbmd0aD9uZXcgcihlWzBdLGVbMV0pOmUubGVuZ3RoPjI/bmV3IHIoZVswXSxlWzFdLGVbMl0pOm51bGx9LHIuYXJlRXF1YWw9ZnVuY3Rpb24oZSx0LHIpe2lmKHZvaWQgMD09PXImJihyPTYpLGUmJmUubGVuZ3RoPj0yJiZ0JiZ0Lmxlbmd0aD49Mil7dmFyIG49TWF0aC5wb3coMTAsciksYT1YcihlWzFdKSxpPVhyKHRbMV0pLHM9WXIoZVswXSksbz1Zcih0WzBdKTtpZigwIT09TWF0aC5yb3VuZCgoYS1pKSpuKS9uKXJldHVybiAhMTt2YXIgdT1NYXRoLnJvdW5kKChzLW8pKm4pL247cmV0dXJuIDA9PT11fHwzNjA9PT11fXJldHVybiAhMX0sci5mcm9tTGF0TG5nPWZ1bmN0aW9uKGUsdCxyKXt2YXIgbj1bXTtpZigibnVtYmVyIj09dHlwZW9mIGUpbi5wdXNoKGUpLCJudW1iZXIiPT10eXBlb2YgdCYmbi5wdXNoKHQpLCJudW1iZXIiPT10eXBlb2YgciYmbi5wdXNoKHIpO2Vsc2UgaWYoQXJyYXkuaXNBcnJheShlKSllLmxlbmd0aD49MiYmIm51bWJlciI9PXR5cGVvZiBlWzBdJiYibnVtYmVyIj09dHlwZW9mIGVbMV0mJihlLmxlbmd0aD49MyYmIm51bWJlciI9PXR5cGVvZiBlWzJdP24ucHVzaChlWzBdLGVbMV0sZVsyXSk6bi5wdXNoKGVbMF0sZVsxXSkpO2Vsc2UgaWYoIm9iamVjdCI9PXR5cGVvZiBlKXt2YXIgYT1bImxhdCIsImxhdGl0dWRlIiwieSJdLGk9WyJsbmciLCJsb25naXR1ZGUiLCJsb24iLCJ4Il0scz1bImVsdiIsImVsZXZhdGlvbiIsImFsdCIsImFsdGl0dWRlIiwieiJdLG89TmFOLHU9TmFOLGw9TmFOO09iamVjdC5rZXlzKGUpLmZvckVhY2goKGZ1bmN0aW9uKHQscixuKXt2YXIgYz10LnRvTG93ZXJDYXNlKCk7aXNOYU4obykmJmEuaW5kZXhPZihjKT49MCYmIm51bWJlciI9PXR5cGVvZiBlW3RdP289ZVt0XTppc05hTih1KSYmaS5pbmRleE9mKGMpPj0wJiYibnVtYmVyIj09dHlwZW9mIGVbdF0/dT1lW3RdOmlzTmFOKGwpJiZzLmluZGV4T2YoYyk+PTAmJiJudW1iZXIiPT10eXBlb2YgZVt0XSYmKGw9ZVt0XSk7fSkpLGlzTmFOKG8pfHxpc05hTih1KXx8KG4ucHVzaCh1LG8pLGlzTmFOKGwpfHxuLnB1c2gobCkpO31yZXR1cm4gbi5sZW5ndGg+PTI/bjpudWxsfSxyLmZyb21MYXRMbmdzPWZ1bmN0aW9uKGUpe3ZhciB0PVtdO2lmKEFycmF5LmlzQXJyYXkoZSkpZm9yKHZhciBuPTAsYT1lLmxlbmd0aDtuPGE7bisrKXt2YXIgaT1yLmZyb21MYXRMbmcoZVtuXSk7aSYmdC5wdXNoKGkpO31yZXR1cm4gdH0sci5fZ2V0RGltZW5zaW9ucz1mdW5jdGlvbihlKXtmb3IodmFyIHQ9MDtBcnJheS5pc0FycmF5KGUpOyllPWVbMF0sdCsrO3JldHVybiAibnVtYmVyIj09dHlwZW9mIGUmJnQtLSx0fSxyfShBcnJheSksTHI9ZnVuY3Rpb24oZSl7ZnVuY3Rpb24gcih0LHIpe3ZhciBuPXRoaXM7aWYodCYmcil7dmFyIGE9dDtuPWFbMl0mJnJbMl0/ZS5jYWxsKHRoaXMsYVswXSxhWzFdLGFbMl18fDAsclswXSxyWzFdLHJbMl18fDApfHx0aGlzOmUuY2FsbCh0aGlzLGFbMF0sYVsxXSxyWzBdLHJbMV0pfHx0aGlzO31lbHNlIGlmKHQpe3ZhciBpPXQ7aSYmKDQ9PT1pLmxlbmd0aD9uPWUuY2FsbCh0aGlzLGlbMF0saVsxXSxpWzJdLGlbM10pfHx0aGlzOmkubGVuZ3RoPj02JiYobj1lLmNhbGwodGhpcyxpWzBdLGlbMV0saVsyXSxpWzNdLGlbNF0saVs1XSl8fHRoaXMpKTt9cmV0dXJuIG59cmV0dXJuIHQocixlKSxyLmZyb21Cb3VuZGluZ0JveD1mdW5jdGlvbihlKXt2YXIgdD1yLmdldFdlc3QoZSksbj1yLmdldFNvdXRoKGUpLGE9ci5nZXRFYXN0KGUpLGk9ci5nZXROb3J0aChlKTtyZXR1cm4gbmV3IHIoW3QsbixhLGldKX0sci5mcm9tRGltZW5zaW9ucz1mdW5jdGlvbihlLHQsbil7dmFyIGE9ZVswXSxpPWVbMV0scz1NYXRoLm1pbihNYXRoLm1heChpK24vMiwtODUuNSksODUuNSksbz1NYXRoLm1pbihNYXRoLm1heChpLW4vMiwtODUuNSksODUuNSksdT1ZcihhK3QvMik7cmV0dXJuIG5ldyByKFtZcihhLXQvMiksbyx1LHNdKX0sci5mcm9tRWRnZXM9ZnVuY3Rpb24oZSx0LG4sYSl7cmV0dXJuIG5ldyByKFtlLHQsbixhXSl9LHIuY29udGFpbnNQb3NpdGlvbj1mdW5jdGlvbihlLHQpe3ZhciBuPXIuZ2V0Q2VudGVyKGUpLGE9TWF0aC5hYnMoblsxXS10WzFdKSxpPU1hdGguYWJzKG5bMF0tdFswXSk7aT4xODAmJihpPTM2MC1pKTt2YXIgcz1yLmdldEhlaWdodChlKSxvPXIuZ2V0V2lkdGgoZSk7cmV0dXJuIGE8PXMvMisxZS04JiZpPD1vLzIrMWUtOH0sci5jcm9zc2VzQW50aW1lcmlkaWFuPWZ1bmN0aW9uKGUpe3JldHVybiBZcihyLmdldEVhc3QoZSkpLVlyKHIuZ2V0V2VzdChlKSk8MH0sci5nZXRDZW50ZXI9ZnVuY3Rpb24oZSl7dmFyIHQ9WXIoci5nZXRFYXN0KGUpKSxuPVlyKHIuZ2V0V2VzdChlKSk7bj50JiYodCs9MzYwKTt2YXIgYT1Zcigobit0KS8yKSxpPVhyKHIuZ2V0U291dGgoZSkpLHM9WHIoci5nZXROb3J0aChlKSk7cmV0dXJuIFthLFhyKChpK3MpLzIpXX0sci5nZXRIZWlnaHQ9ZnVuY3Rpb24oZSl7dmFyIHQ9WHIoci5nZXROb3J0aChlKSktWHIoci5nZXRTb3V0aChlKSk7cmV0dXJuIGlzTmFOKHQpPzA6dH0sci5nZXRXaWR0aD1mdW5jdGlvbihlKXt2YXIgdD1ZcihyLmdldEVhc3QoZSkpLVlyKHIuZ2V0V2VzdChlKSk7cmV0dXJuIGlzTmFOKHQpPzA6dDwwP3QrPTM2MDp0fSxyLmdldFNvdXRoV2VzdD1mdW5jdGlvbihlKXt2YXIgdD10aGlzLmdldFNvdXRoKGUpLHI9dGhpcy5nZXRXZXN0KGUpO3JldHVybiBpc05hTih0KXx8aXNOYU4ocik/bnVsbDpbcix0XX0sci5nZXROb3J0aEVhc3Q9ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5nZXROb3J0aChlKSxyPXRoaXMuZ2V0RWFzdChlKTtyZXR1cm4gaXNOYU4odCl8fGlzTmFOKHIpP251bGw6W3IsdF19LHIuZ2V0Tm9ydGhXZXN0PWZ1bmN0aW9uKGUpe3ZhciB0PXRoaXMuZ2V0Tm9ydGgoZSkscj10aGlzLmdldFdlc3QoZSk7cmV0dXJuIGlzTmFOKHQpfHxpc05hTihyKT9udWxsOltyLHRdfSxyLmdldFNvdXRoRWFzdD1mdW5jdGlvbihlKXt2YXIgdD10aGlzLmdldFNvdXRoKGUpLHI9dGhpcy5nZXRFYXN0KGUpO3JldHVybiBpc05hTih0KXx8aXNOYU4ocik/bnVsbDpbcix0XX0sci5nZXRTb3V0aD1mdW5jdGlvbihlKXtyZXR1cm4gZSYmZS5sZW5ndGg+PTQ/TnVtYmVyKGVbMV0pOk5hTn0sci5nZXRXZXN0PWZ1bmN0aW9uKGUpe3JldHVybiBlJiZlLmxlbmd0aD49ND9OdW1iZXIoZVswXSk6TmFOfSxyLmdldE5vcnRoPWZ1bmN0aW9uKGUpe2lmKGUpe2lmKDQ9PT1lLmxlbmd0aClyZXR1cm4gTnVtYmVyKGVbM10pO2lmKDY9PT1lLmxlbmd0aClyZXR1cm4gTnVtYmVyKGVbNF0pfXJldHVybiBOYU59LHIuZ2V0RWFzdD1mdW5jdGlvbihlKXtpZihlKXtpZig0PT09ZS5sZW5ndGgpcmV0dXJuIE51bWJlcihlWzJdKTtpZig2PT09ZS5sZW5ndGgpcmV0dXJuIE51bWJlcihlWzNdKX1yZXR1cm4gTmFOfSxyLmludGVyc2VjdD1mdW5jdGlvbihlLHQpe3ZhciBuPXIuZ2V0Q2VudGVyKGUpLGE9ci5nZXRDZW50ZXIodCksaT1NYXRoLmFicyhuWzFdLWFbMV0pLHM9TWF0aC5hYnMoblswXS1hWzBdKTtzPjE4MCYmKHM9MzYwLXMpO3ZhciBvPXIuZ2V0SGVpZ2h0KGUpLHU9ci5nZXRXaWR0aChlKSxsPXIuZ2V0SGVpZ2h0KHQpLGM9ci5nZXRXaWR0aCh0KTtyZXR1cm4gaTw9by8yK2wvMiYmczw9dS8yK2MvMn0sci5tZXJnZT1mdW5jdGlvbihlLHQpe3ZhciBuPWUmJjQ9PT1lLmxlbmd0aCxhPXQmJjQ9PT10Lmxlbmd0aDtpZihuJiYhYSlyZXR1cm4gZTtpZihhJiYhbilyZXR1cm4gdDtpZighbiYmIWEpcmV0dXJuIG51bGw7dmFyIGk9TWF0aC5tYXgoWHIoci5nZXROb3J0aChlKSksWHIoci5nZXROb3J0aCh0KSkpLHM9TWF0aC5taW4oWHIoci5nZXRTb3V0aChlKSksWHIoci5nZXRTb3V0aCh0KSkpLG89W2UsdF0sdT1bXSxsPTA7Zm9yKGw9MDtsPG8ubGVuZ3RoO2wrKyl7dmFyIGM9b1tsXSxoPVlyKHIuZ2V0V2VzdChjKSksZD1ZcihyLmdldEVhc3QoYykpO3IuY3Jvc3Nlc0FudGltZXJpZGlhbihjKT8odS5wdXNoKFtoLDE4MF0pLHUucHVzaChbLTE4MCxkXSkpOnUucHVzaChbaCxkXSk7fXUuc29ydCgoZnVuY3Rpb24oZSx0KXtyZXR1cm4gZVswXT09PXRbMF0/ZVsxXS10WzFdOmVbMF0tdFswXX0pKTt2YXIgZj1bXSxwPXVbMF07Zm9yKGw9MTtsPHUubGVuZ3RoOyl7dmFyIG09dVtsXTtwWzFdPj1tWzBdP3BbMV09TWF0aC5tYXgocFsxXSxtWzFdKTooZi5wdXNoKHApLHA9bSksbCsrO31mLnB1c2gocCk7dmFyIGc9Zi5sZW5ndGgsXz1mWzBdWzBdKzM2MC1mW2ctMV1bMV0seT1bZltnLTFdWzFdLGZbMF1bMF1dO2ZvcihsPTE7bDxnO2wrKyl7dmFyIHY9ZltsXVswXS1mW2wtMV1bMV07dj5fJiYoXz12LHk9W2ZbbC0xXVsxXSxmW2xdWzBdXSk7fXJldHVybiBuZXcgcihbeVsxXSxzXSxbeVswXSxpXSl9LHIuZnJvbVBvc2l0aW9ucz1mdW5jdGlvbihlKXtmb3IodmFyIHQsbj1OYU4sYT1OYU4saT1OYU4scz1OYU4sbz1lLmxlbmd0aCx1PW5ldyBBcnJheShvKSxsPTA7by0tOylpZigodD1lW29dKSYmdC5sZW5ndGg+PTIpe3ZhciBjPVhyKHRbMV0pO249aXNOYU4obik/YzpNYXRoLm1heChuLGMpLGE9aXNOYU4oYSk/YzpNYXRoLm1pbihhLGMpLHVbbCsrXT1Zcih0WzBdKTt9aWYobCl7dS5sZW5ndGg9bCx1LnNvcnQoKGZ1bmN0aW9uKGUsdCl7cmV0dXJuIGUtdH0pKTt2YXIgaD11WzBdKzM2MC11W2wtMV0sZD0wO2ZvcihvPTE7bzxsO28rKyl7dmFyIGY9dVtvXS11W28tMV07Zj5oJiYoaD1mLGQ9byk7fWk9dVtkXSxzPXVbKGR8fGwpLTFdO31yZXR1cm4gaXNOYU4oaSl8fGlzTmFOKGEpfHxpc05hTihzKXx8aXNOYU4obik/bnVsbDpuZXcgcihbaSxhLHMsbl0pfSxyLmZyb21MYXRMbmdzPWZ1bmN0aW9uKGUpe3JldHVybiByLmZyb21Qb3NpdGlvbnMoTXIuZnJvbUxhdExuZ3MoZSkpfSxyLmZyb21EYXRhPWZ1bmN0aW9uKGUpe3ZhciB0LG49bnVsbDtpZihBcnJheS5pc0FycmF5KGUpJiZlLmxlbmd0aD4wKXtmb3IodmFyIGE9MCxpPWU7YTxpLmxlbmd0aDthKyspe3ZhciBzPWlbYV07bnVsbCE9KHQ9ci5mcm9tRGF0YShzKSkmJihuPW51bGw9PT1uP3Q6ci5tZXJnZShuLHQpKTt9cmV0dXJuIG59aWYoZSBpbnN0YW5jZW9mIEZyKXJldHVybiBlLmdldEJvdW5kcygpO2lmKGUmJmUudHlwZSl7dmFyIG89ZTtpZihvLmJib3gmJjQ9PT1vLmJib3gubGVuZ3RoKXJldHVybiBvLmJib3g7c3dpdGNoKG8udHlwZSl7Y2FzZSJGZWF0dXJlQ29sbGVjdGlvbiI6cmV0dXJuIHIuZnJvbURhdGEoby5mZWF0dXJlcyk7Y2FzZSJGZWF0dXJlIjpyZXR1cm4gRnIuX2lzQ2lyY2xlKG8pP3IuZnJvbVBvc2l0aW9ucyhGci5fZ2V0Q2lyY2xlUG9zaXRpb25zKG8pKTpyLmZyb21EYXRhKG8uZ2VvbWV0cnkpO2Nhc2UiR2VvbWV0cnlDb2xsZWN0aW9uIjpyZXR1cm4gci5mcm9tRGF0YShvLmdlb21ldHJpZXMpO2Nhc2UiUG9pbnQiOnZhciB1PW8uY29vcmRpbmF0ZXM7aWYodSYmdS5sZW5ndGg+PTIpcmV0dXJuIFt1WzBdLHVbMV0sdVswXSx1WzFdXTticmVhaztjYXNlIkxpbmVTdHJpbmciOmNhc2UiTXVsdGlQb2ludCI6cmV0dXJuIHIuZnJvbVBvc2l0aW9ucyhvLmNvb3JkaW5hdGVzKTtjYXNlIlBvbHlnb24iOmNhc2UiTXVsdGlMaW5lU3RyaW5nIjp2YXIgbD1vLmNvb3JkaW5hdGVzO2lmKGwmJmwubGVuZ3RoPjApe2Zvcih2YXIgYz0wLGg9bC5sZW5ndGg7YzxoO2MrKyludWxsIT0odD1yLmZyb21Qb3NpdGlvbnMobFtjXSkpJiYobj1udWxsPT09bj90OnIubWVyZ2Uobix0KSk7aWYobnVsbCE9bilyZXR1cm4gbn1icmVhaztjYXNlIk11bHRpUG9seWdvbiI6dmFyIGQ9by5jb29yZGluYXRlcztpZihkJiZkLmxlbmd0aD4wKXtmb3IoYz0wLGg9ZC5sZW5ndGg7YzxoO2MrKylmb3IodmFyIGY9MCxwPWRbY10ubGVuZ3RoO2Y8cDtmKyspbnVsbCE9KHQ9ci5mcm9tUG9zaXRpb25zKGRbY11bZl0pKSYmKG49bnVsbD09PW4/dDpyLm1lcmdlKG4sdCkpO3JldHVybiBufX19cmV0dXJuIG51bGx9LHIuc3BsaXRPbkFudGltZXJpZGlhbj1mdW5jdGlvbihlKXt2YXIgdD1bXTtpZihyLmNyb3NzZXNBbnRpbWVyaWRpYW4oZSkpe3ZhciBuPXZvaWQgMCxhPXZvaWQgMCxpPVlyKHIuZ2V0V2VzdChlKSkscz1ZcihyLmdldEVhc3QoZSkpLG89WHIoci5nZXROb3J0aChlKSksdT1YcihyLmdldFNvdXRoKGUpKTtlLmxlbmd0aD49Nj8obj1uZXcgcihbaSx1LGVbMl0sMTgwLG8sZVs1XV0pLGE9bmV3IHIoWy0xODAsdSxlWzJdLHMsbyxlWzVdXSkpOihuPW5ldyByKFtpLHUsMTgwLG9dKSxhPW5ldyByKFstMTgwLHUscyxvXSkpLHQucHVzaChuLGEpO31lbHNlIHQucHVzaChuZXcgcihlKSk7cmV0dXJuIHR9LHJ9KEFycmF5KSx6cj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUodCxyLG4sYSl7dGhpcy50eXBlPSJGZWF0dXJlIix0aGlzLnR5cGU9ZS5UWVBFLHRoaXMucHJvcGVydGllcz1yfHx7fSx0aGlzLmlkPW4sdGhpcy5nZW9tZXRyeT10LHRoaXMuYmJveD1hO31yZXR1cm4gZS5UWVBFPSJGZWF0dXJlIixlfSgpLElyPWZ1bmN0aW9uKCl7ZnVuY3Rpb24gZSh0LHIpe3RoaXMudHlwZT0iUG9seWdvbiIsdGhpcy50eXBlPWUuVFlQRSwxPT09TXIuX2dldERpbWVuc2lvbnModCk/dGhpcy5jb29yZGluYXRlcz1bdF06dGhpcy5jb29yZGluYXRlcz10LHRoaXMuYmJveD1yO31yZXR1cm4gZS5UWVBFPSJQb2x5Z29uIixlfSgpLFJyPU1hcCxGcj1mdW5jdGlvbihlKXtmdW5jdGlvbiByKHQsbixhKXt2YXIgaSxzPWUuY2FsbCh0aGlzKXx8dGhpcztpZigiRmVhdHVyZSI9PT10LnR5cGUpe3ZhciBvPXQ7aT1hcihvLmdlb21ldHJ5KSxhPW8ucHJvcGVydGllcz9hcihvLnByb3BlcnRpZXMpOnt9LG49bnVsbD09by5pZHx8IiI9PT1vLmlkP0FyKCk6by5pZDt9ZWxzZSBpPWFyKHQpLG49bnVsbD09bnx8IiI9PT1uP0FyKCk6bixhPWE/YXIoYSk6e307cmV0dXJuIGFbci5fc2hhcGVJZFByb3BOYW1lXT1uLHMuZGF0YT1uZXcgenIoaSxhLG4pLHMuX2hhbmRsZUNpcmNsZSgpLHN9cmV0dXJuIHQocixlKSxyLnByb3RvdHlwZS5hZGRQcm9wZXJ0eT1mdW5jdGlvbihlLHQpe0VyKHRoaXMuZGF0YS5wcm9wZXJ0aWVzW2VdLHQpfHwodGhpcy5kYXRhLnByb3BlcnRpZXNbZV09YXIodCksInN1YlR5cGUiIT09ZSYmInJhZGl1cyIhPT1lfHx0aGlzLl9oYW5kbGVDaXJjbGUoKSx0aGlzLmRhdGFTb3VyY2UmJnRoaXMuZGF0YVNvdXJjZS5fdXBkYXRlU291cmNlKCksdGhpcy5faW52b2tlRXZlbnQoInNoYXBlY2hhbmdlZCIsdGhpcykpO30sci5wcm90b3R5cGUuZ2V0Qm91bmRzPWZ1bmN0aW9uKCl7dmFyIGUsdD10aGlzLmdldENvb3JkaW5hdGVzKCkscj10aGlzLmdldFR5cGUoKTtpZigiUG9pbnQiPT09cilpZih0aGlzLmNpcmNsZVBvbHlnb24pe3ZhciBuPXRoaXMuY2lyY2xlUG9seWdvbi5nZW9tZXRyeS5jb29yZGluYXRlcztlPUxyLmZyb21Qb3NpdGlvbnMoblswXSk7fWVsc2Uge2U9bmV3IExyKG49dCxuKTt9ZWxzZSBpZigiTXVsdGlQb2ludCI9PT1yfHwiTGluZVN0cmluZyI9PT1yKXtuPXQ7ZT1Mci5mcm9tUG9zaXRpb25zKG4pO31lbHNlIGlmKCJQb2x5Z29uIj09PXIpe249dDtlPUxyLmZyb21Qb3NpdGlvbnMoblswXSk7fWVsc2UgaWYoIk11bHRpTGluZVN0cmluZyI9PT1yKWZvcih2YXIgYT0wLGk9bj10O2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO2U9THIubWVyZ2UoZSxMci5mcm9tUG9zaXRpb25zKHMpKTt9ZWxzZSBpZigiTXVsdGlQb2x5Z29uIj09PXIpZm9yKHZhciBvPTAsdT1uPXQ7bzx1Lmxlbmd0aDtvKyspe3ZhciBsPXVbb107ZT1Mci5tZXJnZShlLExyLmZyb21Qb3NpdGlvbnMobFswXSkpO31yZXR1cm4gZX0sci5wcm90b3R5cGUuZ2V0Q29vcmRpbmF0ZXM9ZnVuY3Rpb24oKXtyZXR1cm4gYXIodGhpcy5kYXRhLmdlb21ldHJ5LmNvb3JkaW5hdGVzKX0sci5wcm90b3R5cGUuZ2V0Q2lyY2xlQ29vcmRpbmF0ZXM9ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5jaXJjbGVQb2x5Z29uP2FyKHRoaXMuY2lyY2xlUG9seWdvbi5nZW9tZXRyeS5jb29yZGluYXRlc1swXSk6bnVsbH0sci5wcm90b3R5cGUuZ2V0SWQ9ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5kYXRhLmlkfSxyLnByb3RvdHlwZS5nZXRQcm9wZXJ0aWVzPWZ1bmN0aW9uKCl7cmV0dXJuIGFyKHRoaXMuZGF0YS5wcm9wZXJ0aWVzKX0sci5wcm90b3R5cGUuZ2V0VHlwZT1mdW5jdGlvbigpe3JldHVybiB0aGlzLmRhdGEuZ2VvbWV0cnkudHlwZX0sci5wcm90b3R5cGUuaXNDaXJjbGU9ZnVuY3Rpb24oKXtyZXR1cm4gci5faXNDaXJjbGUodGhpcy5kYXRhKX0sci5wcm90b3R5cGUuaXNSZWN0YW5nbGU9ZnVuY3Rpb24oKXtyZXR1cm4gci5faXNSZWN0YW5nbGUodGhpcy5kYXRhKX0sci5wcm90b3R5cGUuc2V0Q29vcmRpbmF0ZXM9ZnVuY3Rpb24oZSl7dmFyIHQ7dD0iUG9seWdvbiI9PT10aGlzLmdldFR5cGUoKSYmMT09PU1yLl9nZXREaW1lbnNpb25zKGUpP1tlXTplLEVyKHRoaXMuZGF0YS5nZW9tZXRyeS5jb29yZGluYXRlcyx0KXx8KHRoaXMuZGF0YS5nZW9tZXRyeS5jb29yZGluYXRlcz1hcih0KSx0aGlzLl9oYW5kbGVDaXJjbGUoKSx0aGlzLmRhdGFTb3VyY2UmJnRoaXMuZGF0YVNvdXJjZS5fdXBkYXRlU291cmNlKCksdGhpcy5faW52b2tlRXZlbnQoInNoYXBlY2hhbmdlZCIsdGhpcykpO30sci5wcm90b3R5cGUuc2V0UHJvcGVydGllcz1mdW5jdGlvbihlKXtlW3IuX3NoYXBlSWRQcm9wTmFtZV09dGhpcy5kYXRhLmlkLEVyKHRoaXMuZGF0YS5wcm9wZXJ0aWVzLGUpfHwodGhpcy5kYXRhLnByb3BlcnRpZXM9YXIoZSksdGhpcy5faGFuZGxlQ2lyY2xlKCksdGhpcy5kYXRhU291cmNlJiZ0aGlzLmRhdGFTb3VyY2UuX3VwZGF0ZVNvdXJjZSgpLHRoaXMuX2ludm9rZUV2ZW50KCJzaGFwZWNoYW5nZWQiLHRoaXMpKTt9LHIucHJvdG90eXBlLnRvSnNvbj1mdW5jdGlvbigpe3JldHVybiBKU09OLnBhcnNlKEpTT04uc3RyaW5naWZ5KHRoaXMuZGF0YSkpfSxyLnByb3RvdHlwZS5fdG9Kc29uPWZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuY2lyY2xlUG9seWdvbnx8dGhpcy5kYXRhfSxyLnByb3RvdHlwZS5fc2V0RGF0YVNvdXJjZT1mdW5jdGlvbihlKXt2b2lkIDA9PT1lfHxudWxsPT1lP2RlbGV0ZSB0aGlzLmRhdGFTb3VyY2U6dGhpcy5kYXRhU291cmNlPWU7fSxyLnByb3RvdHlwZS5faGFuZGxlQ2lyY2xlPWZ1bmN0aW9uKCl7aWYodGhpcy5pc0NpcmNsZSgpKXt2YXIgZT1yLl9nZXRDaXJjbGVQb3NpdGlvbnModGhpcy5kYXRhKTt0aGlzLmNpcmNsZVBvbHlnb249bmV3IHpyKG5ldyBJcihbZV0pLHRoaXMuZGF0YS5wcm9wZXJ0aWVzLHRoaXMuZGF0YS5pZCksdGhpcy5kYXRhLnByb3BlcnRpZXMuc3ViVHlwZT0iQ2lyY2xlIjt9ZWxzZSBkZWxldGUgdGhpcy5jaXJjbGVQb2x5Z29uO30sci5faXNDaXJjbGU9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUuZ2VvbWV0cnkmJiJQb2ludCI9PT1lLmdlb21ldHJ5LnR5cGUmJmUuZ2VvbWV0cnkuY29vcmRpbmF0ZXMmJmUucHJvcGVydGllcyYmInN0cmluZyI9PXR5cGVvZiBlLnByb3BlcnRpZXMuc3ViVHlwZSYmImNpcmNsZSI9PT1lLnByb3BlcnRpZXMuc3ViVHlwZS50b0xvd2VyQ2FzZSgpJiYibnVtYmVyIj09dHlwZW9mIGUucHJvcGVydGllcy5yYWRpdXN9LHIuX2lzUmVjdGFuZ2xlPWZ1bmN0aW9uKGUpe2lmKCJQb2x5Z29uIj09PWUuZ2VvbWV0cnkudHlwZSYmZS5nZW9tZXRyeS5jb29yZGluYXRlcyYmInN0cmluZyI9PXR5cGVvZiBlLnByb3BlcnRpZXMuc3ViVHlwZSYmInJlY3RhbmdsZSI9PT1lLnByb3BlcnRpZXMuc3ViVHlwZS50b0xvd2VyQ2FzZSgpKXt2YXIgdD1lLmdlb21ldHJ5LmNvb3JkaW5hdGVzO2lmKDE9PT10Lmxlbmd0aCl7dmFyIHI9dFswXTtpZig1PT09ci5sZW5ndGgpcmV0dXJuIHJbMF1bMF09PT1yWzRdWzBdJiZyWzBdWzFdPT09cls0XVsxXTtpZig0PT09ci5sZW5ndGgpcmV0dXJuICEwfX1yZXR1cm4gITF9LHIuX2dldENpcmNsZVBvc2l0aW9ucz1mdW5jdGlvbihlKXtyZXR1cm4gZnVuY3Rpb24oZSx0LHIsbixhKXtuPW58fCJtZXRlcnMiLGE9YXx8MCxlPVFyKGUpO2Zvcih2YXIgaT1bXSxzPTM2MC9yLG89MDtvPD1yO28rKylpLnB1c2goSHIoZSwobypzK2EpJTM2MCx0LG4pKTtyZXR1cm4gaX0oZS5nZW9tZXRyeS5jb29yZGluYXRlcyxlLnByb3BlcnRpZXMucmFkaXVzLDcyLCJtZXRlcnMiKX0sci5fc2hhcGVJZFByb3BOYW1lPSJfYXp1cmVNYXBzU2hhcGVJZCIscn0oZnVuY3Rpb24oKXtmdW5jdGlvbiBlKCl7dGhpcy5saXN0ZW5lcnM9bmV3IFJyO31yZXR1cm4gZS5wcm90b3R5cGUuX2FkZEV2ZW50TGlzdGVuZXI9ZnVuY3Rpb24oZSx0LHIpe3RoaXMubGlzdGVuZXJzLmhhcyhlKXx8dGhpcy5saXN0ZW5lcnMuc2V0KGUsbmV3IFJyKSx0aGlzLmxpc3RlbmVycy5nZXQoZSkuc2V0KHQscik7fSxlLnByb3RvdHlwZS5fcmVtb3ZlRXZlbnRMaXN0ZW5lcj1mdW5jdGlvbihlLHQpe3RoaXMubGlzdGVuZXJzLmhhcyhlKSYmdGhpcy5saXN0ZW5lcnMuZ2V0KGUpLmRlbGV0ZSh0KTt9LGUucHJvdG90eXBlLl9pbnZva2VFdmVudD1mdW5jdGlvbihlLHQpe3ZhciByPXRoaXM7dGhpcy5saXN0ZW5lcnMuaGFzKGUpJiZ0aGlzLmxpc3RlbmVycy5nZXQoZSkuZm9yRWFjaCgoZnVuY3Rpb24obixhKXtuJiZyLl9yZW1vdmVFdmVudExpc3RlbmVyKGUsYSk7dHJ5e2EodCk7fWNhdGNoKGUpe2NvbnNvbGUuZXJyb3IoZSk7fX0pKTt9LGV9KCkpLGpyPU1hdGguUEkvMTgwLERyPTE4MC9NYXRoLlBJLFRyPVsxLDEwLDEwMCwxZTMsMWU0LDFlNSwxZTYsMWU3LDFlOCwxZTldO2Z1bmN0aW9uIEJyKGUpe3JldHVybiBlKmpyfWZ1bmN0aW9uIFVyKGUpe3JldHVybiBlKkRyfWZ1bmN0aW9uIFdyKGUpe2lmKGUpc3dpdGNoKGUudG9Mb3dlckNhc2UoKSl7Y2FzZSJmZWV0IjpjYXNlImZvb3QiOmNhc2UiZnQiOnJldHVybiBTci5mZWV0O2Nhc2Uia2lsb21ldGVycyI6Y2FzZSJraWxvbWV0ZXIiOmNhc2Uia2lsb21ldHJlcyI6Y2FzZSJraWxvbWV0cmUiOmNhc2Uia20iOmNhc2Uia21zIjpyZXR1cm4gU3Iua2lsb21ldGVycztjYXNlIm1pbGVzIjpjYXNlIm1pbGUiOmNhc2UibWkiOnJldHVybiBTci5taWxlcztjYXNlIm5hdXRpY2FsbWlsZXMiOmNhc2UibmF1dGljYWxtaWxlIjpjYXNlIm5tcyI6Y2FzZSJubSI6cmV0dXJuIFNyLm5hdXRpY2FsTWlsZXM7Y2FzZSJ5YXJkcyI6Y2FzZSJ5YXJkIjpjYXNlInlkcyI6Y2FzZSJ5cmQiOmNhc2UieXJkcyI6cmV0dXJuIFNyLnlhcmRzO2Nhc2UibWV0ZXJzIjpjYXNlIm1ldHJlcyI6Y2FzZSJtIjpkZWZhdWx0OnJldHVybiBTci5tZXRlcnN9cmV0dXJuIFNyLm1ldGVyc31mdW5jdGlvbiBHcihlLHQpe2lmKCFpc05hTihlKSYmIm51bWJlciI9PXR5cGVvZiB0JiZ0Pj0wKXt2YXIgcj12b2lkIDA7cj10PFRyLmxlbmd0aD9Uclt0XTpNYXRoLnBvdygxMCx0KSxlPU1hdGgucm91bmQoZSpyKS9yO31yZXR1cm4gZX1mdW5jdGlvbiBacihlKXt2YXIgdD1ZcihMci5nZXRXZXN0KGUpKSxyPVlyKExyLmdldEVhc3QoZSkpLG49WHIoTHIuZ2V0Tm9ydGgoZSkpLGE9WHIoTHIuZ2V0U291dGgoZSkpLGk9THIuZ2V0Q2VudGVyKGUpLHM9W1t0LG5dLFt0LGFdLFtpWzBdLGFdLFtyLGFdLFtyLG5dLFtpWzBdLG5dLFt0LG5dXTtyZXR1cm4gbmV3IElyKFtzXSl9ZnVuY3Rpb24gVnIoZSx0LHIsbil7c3dpdGNoKFdyKHQpKXtjYXNlIFNyLm1ldGVyczplLz0xZTM7YnJlYWs7Y2FzZSBTci5mZWV0OmUvPTMyODAuODM5OTticmVhaztjYXNlIFNyLm1pbGVzOmUvPS42MjEzNzExOTticmVhaztjYXNlIFNyLnlhcmRzOmUvPTEwOTMuNjEzMzticmVhaztjYXNlIFNyLm5hdXRpY2FsTWlsZXM6ZS89LjUzOTk1Njg7YnJlYWs7Y2FzZSBTci5raWxvbWV0ZXJzOn1zd2l0Y2goV3Iocikpe2Nhc2UgU3IubWV0ZXJzOmUqPTFlMzticmVhaztjYXNlIFNyLmZlZXQ6ZSo9MzI4MC44Mzk5O2JyZWFrO2Nhc2UgU3IubWlsZXM6ZSo9LjYyMTM3MTE5O2JyZWFrO2Nhc2UgU3IueWFyZHM6ZSo9MTA5My42MTMzO2JyZWFrO2Nhc2UgU3IubmF1dGljYWxNaWxlczplKj0uNTM5OTU2ODticmVhaztjYXNlIFNyLmtpbG9tZXRlcnM6fWlmKCJudW1iZXIiPT10eXBlb2YgbiYmbj49MCl7dmFyIGE9TWF0aC5wb3coMTAsbik7ZT1NYXRoLnJvdW5kKGUqYSkvYTt9cmV0dXJuIGV9ZnVuY3Rpb24gSHIoZSx0LHIsbil7bj1ufHwibWV0ZXJzIixlPVFyKGUpO3ZhciBhLGkscyxvPWZ1bmN0aW9uKGUpe3ZhciB0PVdyKGUpO3JldHVybiBWcig2Mzc4MTM3LFNyLm1ldGVycyx0KX0obiksdT1CcihlWzFdKSxsPUJyKGVbMF0pLGM9QnIodCksaD1yL28sZD1NYXRoLmFzaW4oTWF0aC5zaW4odSkqTWF0aC5jb3MoaCkrTWF0aC5jb3ModSkqTWF0aC5zaW4oaCkqTWF0aC5jb3MoYykpLGY9bCtNYXRoLmF0YW4yKE1hdGguc2luKGMpKk1hdGguc2luKGgpKk1hdGguY29zKHUpLE1hdGguY29zKGgpLU1hdGguc2luKHUpKk1hdGguc2luKGQpKSxwPShhPVhyKFVyKGQpKSxpPS04NSxzPTg1LE1hdGgubWluKE1hdGgubWF4KGEsaSkscykpO3JldHVybiBbWXIoVXIoZikpLHBdfWZ1bmN0aW9uIEtyKGUsdCxyKXt2YXIgbj1mdW5jdGlvbihlLHQpe3ZhciByPUJyKHRbMV0tZVsxXSksbj1Ccih0WzBdLWVbMF0pLGE9TWF0aC5wb3coTWF0aC5zaW4oci8yKSwyKStNYXRoLmNvcyhCcihlWzFdKSkqTWF0aC5jb3MoQnIodFsxXSkpKk1hdGgucG93KE1hdGguc2luKG4vMiksMiksaT0yKk1hdGguYXRhbjIoTWF0aC5zcXJ0KGEpLE1hdGguc3FydCgxLWEpKTtyZXR1cm4gTWF0aC5yb3VuZCg2Mzc4MTM3KmkqMTAwKS8xMDB9KGU9UXIoZSksdD1Rcih0KSk7cmV0dXJuICJtZXRlcnMiPT09cj9uOlZyKG4sIm1ldGVycyIscnx8Im1ldGVycyIpfWZ1bmN0aW9uIHFyKGUsdCl7aWYoZT1RcihlKSx0PVFyKHQpLGUmJmUubGVuZ3RoPj0yJiZ0JiZ0Lmxlbmd0aD49Mil7dmFyIHI9QnIoZVsxXSksbj1Ccih0WzFdKSxhPUJyKHRbMF0tZVswXSksaT1NYXRoLnNpbihhKSpNYXRoLmNvcyhuKSxzPU1hdGguY29zKHIpKk1hdGguc2luKG4pLU1hdGguc2luKHIpKk1hdGguY29zKG4pKk1hdGguY29zKGEpO3JldHVybiAoVXIoTWF0aC5hdGFuMihpLHMpKSszNjApJTM2MH1yZXR1cm4gTmFOfWZ1bmN0aW9uIFhyKGUpe3JldHVybiBlPjkwPyhlPShlKzkwKSUzNjApPjE4MD85MC0oZS0xODApOmUtOTA6ZTwtOTA/KGU9KGUtOTApJTM2MCk8LTE4MD8tOTAtKGUrMTgwKTplKzkwOmV9ZnVuY3Rpb24gWXIoZSl7cmV0dXJuIGU+MTgwPyhlKzE4MCklMzYwLTE4MDplPC0xODA/KGUtMTgwKSUzNjArMTgwOmV9ZnVuY3Rpb24gJHIoZSx0LHIpe2lmKDA9PT1yKXJldHVybiBPYmplY3QuYXNzaWduKHt9LGUpO3Q9UXIodCk7Zm9yKHZhciBuLGEsaT1bXSxzPTAsbz1lLmxlbmd0aDtzPG87cysrKW49S3IodCxlW3NdKSxhPXFyKHQsZVtzXSksaS5wdXNoKEhyKHQsYStyLG4pKTtyZXR1cm4gaX1mdW5jdGlvbiBKcihlKXtpZigiW29iamVjdCBEYXRlXSI9PT1PYmplY3QucHJvdG90eXBlLnRvU3RyaW5nLmNhbGwoZSkpcmV0dXJuIGU7aWYoInN0cmluZyI9PXR5cGVvZiBlKXt2YXIgdD1EYXRlLnBhcnNlKGUpO2lmKCFpc05hTih0KSlyZXR1cm4gbmV3IERhdGUodCk7aWYoZS5pbmRleE9mKCJEYXRlKCIpPj0wKXt2YXIgcj0wO3JldHVybiByPShlPWUucmVwbGFjZSgiL0RhdGUoIiwiIikucmVwbGFjZSgiKS8iLCIiKSkuaW5kZXhPZigiKyIpPjA/cGFyc2VJbnQoZS5zdWJzdHIoMCxlLmluZGV4T2YoIisiKSksMTApOmUuaW5kZXhPZigiLSIpPjA/cGFyc2VJbnQoZS5zdWJzdHIoMCxlLmluZGV4T2YoIi0iKSksMTApOnBhcnNlSW50KGUsMTApLG5ldyBEYXRlKHIpfX1lbHNlIGlmKCJudW1iZXIiPT10eXBlb2YgZSlyZXR1cm4gbmV3IERhdGUoZSk7cmV0dXJuIG51bGx9ZnVuY3Rpb24gUXIoZSl7aWYoQXJyYXkuaXNBcnJheShlKSYmIm51bWJlciI9PXR5cGVvZiBlWzBdKXJldHVybiBlO2lmKGUudHlwZSl7aWYoIlBvaW50Ij09PWUudHlwZSlyZXR1cm4gZS5jb29yZGluYXRlcztpZigiRmVhdHVyZSI9PT1lLnR5cGUmJiJQb2ludCI9PT1lLmdlb21ldHJ5LnR5cGUpcmV0dXJuIGUuZ2VvbWV0cnkuY29vcmRpbmF0ZXN9ZWxzZSBpZihlIGluc3RhbmNlb2YgRnImJiJQb2ludCI9PT1lLmdldFR5cGUoKSlyZXR1cm4gZS5nZXRDb29yZGluYXRlcygpO3JldHVybiBudWxsfSFmdW5jdGlvbihlKXtlLnNxdWFyZU1ldGVycz0ic3F1YXJlTWV0ZXJzIixlLmFjcmVzPSJhY3JlcyIsZS5oZWN0YXJlcz0iaGVjdGFyZXMiLGUuc3F1YXJlRmVldD0ic3F1YXJlRmVldCIsZS5zcXVhcmVLaWxvbWV0ZXJzPSJzcXVhcmVLaWxvbWV0ZXJzIixlLnNxdWFyZU1pbGVzPSJzcXVhcmVNaWxlcyIsZS5zcXVhcmVZYXJkcz0ic3F1YXJlWWFyZHMiO30oTnJ8fChOcj17fSkpLGZ1bmN0aW9uKGUpe2UubWV0ZXJzPSJtZXRlcnMiLGUua2lsb21ldGVycz0ia2lsb21ldGVycyIsZS5mZWV0PSJmZWV0IixlLm1pbGVzPSJtaWxlcyIsZS5uYXV0aWNhbE1pbGVzPSJuYXV0aWNhbE1pbGVzIixlLnlhcmRzPSJ5YXJkcyI7fShTcnx8KFNyPXt9KSksZnVuY3Rpb24oZSl7ZS5zZWNvbmRzPSJzZWNvbmRzIixlLmhvdXJzPSJob3VycyIsZS5tcz0ibXMiLGUubWludXRlcz0ibWludXRlcyIsZS5kYXlzPSJkYXlzIjt9KHhyfHwoeHI9e30pKSxmdW5jdGlvbihlKXtlLm1ldGVyc1BlclNlY29uZD0ibWV0ZXJzUGVyU2Vjb25kIixlLmtpbG9tZXRlcnNQZXJIb3VyPSJraWxvbWV0ZXJzUGVySG91ciIsZS5mZWV0UGVyU2Vjb25kPSJmZWV0UGVyU2Vjb25kIixlLm1pbGVzUGVySG91cj0ibWlsZXNQZXJIb3VyIixlLmtub3RzPSJrbm90cyIsZS5tYWNoPSJtYWNoIjt9KENyfHwoQ3I9e30pKSxmdW5jdGlvbihlKXtlLm1pbGVzUGVyU2Vjb25kU3F1YXJlZD0ibWlsZXNQZXJTZWNvbmRTcXVhcmVkIixlLmtpbG9tZXRlcnNQZXJTZWNvbmRTcXVhcmVkPSJraWxvbWV0ZXJzUGVyU2Vjb25kU3F1YXJlZCIsZS5rbm90c1BlclNlY29uZD0ia25vdHNQZXJTZWNvbmQiLGUuc3RhbmRhcmRHcmF2aXR5PSJzdGFuZGFyZEdyYXZpdHkiLGUuZmVldFBlclNlY29uZFNxdWFyZWQ9ImZlZXRQZXJTZWNvbmRTcXVhcmVkIixlLnlhcmRzUGVyU2Vjb25kU3F1YXJlZD0ieWFyZHNQZXJTZWNvbmRTcXVhcmVkIixlLm1pbGVzUGVySG91clNlY29uZD0ibWlsZXNQZXJIb3VyU2Vjb25kIixlLmtpbG9tZXRlcnNQZXJIb3VyU2Vjb25kPSJraWxvbWV0ZXJzUGVySG91clNlY29uZCIsZS5tZXRlcnNQZXJTZWNvbmRTcXVhcmVkPSJtZXRlcnNQZXJTZWNvbmRTcXVhcmVkIjt9KFByfHwoUHI9e30pKTshZnVuY3Rpb24oKXtmdW5jdGlvbiBlKHQscil7dGhpcy5NPWUuX2NhbGN1bGF0ZUFmZmluZVRyYW5zZm9ybSh0LHIpLHRoaXMuaW52ZXJzZU09ZS5fY2FsY3VsYXRlQWZmaW5lVHJhbnNmb3JtKHIsdCk7fWUucHJvdG90eXBlLnRvVGFyZ2V0PWZ1bmN0aW9uKGUsdCl7aWYodm9pZCAwIT09dHlwZW9mIGUpcmV0dXJuIHRoaXMudHJhbnNmb3JtQXJyYXkoZSx0aGlzLk0sdCk7dGhyb3cgbmV3IEVycm9yKCJJbnZhbGlkIHNvdXJjZVBvaW50cyBzcGVjaWZpZWQuIil9LGUucHJvdG90eXBlLnRvU291cmNlPWZ1bmN0aW9uKGUsdCl7aWYodm9pZCAwIT09dHlwZW9mIGUpcmV0dXJuIHRoaXMudHJhbnNmb3JtQXJyYXkoZSx0aGlzLmludmVyc2VNLHQpO3Rocm93IG5ldyBFcnJvcigiSW52YWxpZCB0YXJnZXRQb2ludHMgc3BlY2lmaWVkLiIpfSxlLnByb3RvdHlwZS50cmFuc2Zvcm1BcnJheT1mdW5jdGlvbihlLHQscil7aWYoZSYmQXJyYXkuaXNBcnJheShlKSYmQXJyYXkuaXNBcnJheShlWzBdKSl7Zm9yKHZhciBuPVtdLGE9MCxpPWU7YTxpLmxlbmd0aDthKyspe3ZhciBzPWlbYV07bi5wdXNoKHRoaXMudHJhbnNmb3JtKHMsdCxyKSk7fXJldHVybiBufXJldHVybiBudWxsfSxlLnByb3RvdHlwZS50cmFuc2Zvcm09ZnVuY3Rpb24oZSx0LHIpe3ZhciBuPWVbMF0qdFswXVszXStlWzFdKnRbMV1bM10rdFsyXVszXSxhPWVbMF0qdFswXVs0XStlWzFdKnRbMV1bNF0rdFsyXVs0XTtyZXR1cm4gIm51bWJlciI9PXR5cGVvZiByJiZyPj0wP1tHcihuLHIpLEdyKGEscildOltHcihuLDYpLEdyKGEsNildfSxlLl9jYWxjdWxhdGVBZmZpbmVUcmFuc2Zvcm09ZnVuY3Rpb24oZSx0KXtpZihlLmxlbmd0aCE9PXQubGVuZ3RofHxlLmxlbmd0aDwxKXRocm93IG5ldyBFcnJvcigiRXJyb3I6IHNvdXJjZSBhbmQgdGFyZ2V0IGFycmF5cyBtdXN0IGhhdmUgdGhlIHNhbWUgbGVuZ3RoLiIpO3ZhciByPU1hdGgubWluKGVbMF0ubGVuZ3RoLHRbMF0ubGVuZ3RoKSxuPXIrMTtpZihlLmxlbmd0aDxyKXRocm93IG5ldyBFcnJvcigiRXJvcnI6IEF0IGxlYXN0ICIrcisiIHJlZmVyZW5jZSBwb2ludHMgcmVxdWlyZWQuIik7Zm9yKHZhciBhPVtdLGk9W10scz0wO3M8bjtzKyspe2lbc109W107Zm9yKHZhciBvPTA7bzxuO28rKyl7bzxyJiYoYVtvXT0wKSxpW3NdW29dPTA7Zm9yKHZhciB1PTA7dTxlLmxlbmd0aDt1KyspbzxyJiYoYVtvXSs9czxyP2VbdV1bc10qdFt1XVtvXTp0W3VdW29dKSxpW3NdW29dKz1zPj1yJiZvPj1yPzE6cz49cj9lW3VdW29dOm8+PXI/ZVt1XVtzXTplW3VdW3NdKmVbdV1bb107fWlbc109aVtzXS5jb25jYXQoYSk7fWlmKCF0aGlzLl9nYXVzc0pvcmRhbkVsaW1pbmF0aW9uKGkpKXRocm93IG5ldyBFcnJvcigiRXJyb3I6IFNpbmd1bGFyIG1hdHJpeC4gUG9pbnRzIGFyZSBsaWtlbHkgY29wbGFuYXIuIik7cmV0dXJuIGl9LGUuX2dhdXNzSm9yZGFuRWxpbWluYXRpb249ZnVuY3Rpb24oZSl7Zm9yKHZhciB0LHIsbj1lLmxlbmd0aCxhPTIqbi0xLGk9MDtpPG47aSsrKXtmb3IodmFyIHM9aSxvPWkrMTtvPG47bysrKU1hdGguYWJzKGVbb11baV0pPk1hdGguYWJzKGVbc11baV0pJiYocz1vKTtpZihyPWVbc10sZVtzXT1lW2ldLGVbaV09cixNYXRoLmFicyhlW2ldW2ldKTw9MWUtMTApcmV0dXJuICExO2Zvcih2YXIgdT1pKzE7dTxuO3UrKyl7dD1lW3VdW2ldL2VbaV1baV07Zm9yKHZhciBsPWk7bDxhO2wrKyllW3VdW2xdLT1lW2ldW2xdKnQ7fX1mb3IoaT1uLTE7aT4tMTtpLS0pe3Q9ZVtpXVtpXTtmb3Iobz0wO288aTtvKyspZm9yKHZhciBjPWEtMTtjPmktMTtjLS0pZVtvXVtjXS09ZVtpXVtjXSplW29dW2ldL3Q7ZVtpXVtpXS89dDtmb3IodmFyIGg9bjtoPGE7aCsrKWVbaV1baF0vPXQ7fXJldHVybiAhMH07fSgpO3ZhciBlbj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt9cmV0dXJuIGUuYWRkQXR0cmlidXRlc1RvT2JqZWN0PWZ1bmN0aW9uKGUsdCl7aWYoZSYmZS5hdHRyaWJ1dGVzKXt2YXIgcj1lLmF0dHJpYnV0ZXM7T2JqZWN0LmtleXMocikuZm9yRWFjaCgoZnVuY3Rpb24oZSl7ImdtbDppZCI9PT1lP3QuaWQ9cltlXTplLnN0YXJ0c1dpdGgoInhtbG5zIil8fGUuc3RhcnRzV2l0aCgieHNpIil8fGUuc3RhcnRzV2l0aCgiXyIpfHwoZS5pbmNsdWRlcygiOiIpP3RbZS5zdWJzdHIoZS5pbmRleE9mKCI6IikrMSldPXJbZV06dFtlXT1yW2VdKTt9KSk7fX0sZS5hamF4R2V0QXN5bmM9ZnVuY3Rpb24odCxpLHMsbyx1KXtyZXR1cm4gbih0aGlzLHZvaWQgMCx2b2lkIDAsKGZ1bmN0aW9uKCl7dmFyIG4sbCxjLGgsZCxmLHAsbTtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOm49InN0cmluZyI9PXR5cGVvZiB0P3RoaXMucGFyc2VVUkwodCk6dCx0PW4uYWJzb2x1dGVQYXRoLGUuaXNWYWxpZFN0cmluZyhpKSYmKHQ9aStlbmNvZGVVUklDb21wb25lbnQodCkpLHU9dXx8IlNwYXRpYWxJb1JlcXVlc3QiLGw9e09yaWdpbjoiKiJ9LGEubGFiZWw9MTtjYXNlIDE6cmV0dXJuIGEudHJ5cy5wdXNoKFsxLDE4LCwxOV0pLGM9dm9pZCAwLHM/ImZ1bmN0aW9uIiE9dHlwZW9mIHM/WzMsM106KGg9cyh0LHUpfHx7fSxbNCxmZXRjaChoLnVybHx8dCx7Y3JlZGVudGlhbHM6aC5jcmVkZW50aWFscyxoZWFkZXJzOnIocih7fSxsKSxoLmhlYWRlcnMpfSldKTpbMyw2XTtjYXNlIDI6cmV0dXJuIGM9YS5zZW50KCksWzMsNV07Y2FzZSAzOnJldHVybiBbNCxzLl9zZW5kUmVxdWVzdCh0LHUsbCldO2Nhc2UgNDpjPWEuc2VudCgpLGEubGFiZWw9NTtjYXNlIDU6cmV0dXJuIFszLDhdO2Nhc2UgNjpyZXR1cm4gWzQsZmV0Y2godCx7aGVhZGVyczpsfSldO2Nhc2UgNzpjPWEuc2VudCgpLGEubGFiZWw9ODtjYXNlIDg6cmV0dXJuIGMub2s/bz8oZD1jLmhlYWRlcnMuZ2V0KCJDb250ZW50LVR5cGUiKSx0aGlzLmlzQ29tcHJlc3NlZENvbnRlbnRUeXBlKGQpP1s0LGMuYXJyYXlCdWZmZXIoKV06WzMsMTBdKTpbMywxM106WzMsMTZdO2Nhc2UgOTpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgMTA6cmV0dXJuIFs0LGMuYXJyYXlCdWZmZXIoKV07Y2FzZSAxMTpyZXR1cm4gZj1hLnNlbnQoKSxwPXRoaXMuYXJyYXlCdWZmZXJUb1N0cmluZyhmLDEwKSwhZCYmL14oUEt8UE5HfEpQRUd8SlBHfEJNUHxHSUYpLy50ZXN0KHApP1syLGZdOlsyLHRoaXMuYXJyYXlCdWZmZXJUb1N0cmluZyhmKV07Y2FzZSAxMjpyZXR1cm4gWzMsMTVdO2Nhc2UgMTM6cmV0dXJuIFs0LGMudGV4dCgpXTtjYXNlIDE0OnJldHVybiBbMixhLnNlbnQoKV07Y2FzZSAxNTpyZXR1cm4gWzMsMTddO2Nhc2UgMTY6dGhyb3cgbmV3IEVycm9yKCJFcnJvciBkb3dubG9hZGluZyBmaWxlLiBTdGF0dXMgY29kZTogIitjLnN0YXR1cyk7Y2FzZSAxNzpyZXR1cm4gWzMsMTldO2Nhc2UgMTg6aWYoKG09YS5zZW50KCkpJiYiRmFpbGVkIHRvIGZldGNoIj09PW0ubWVzc2FnZSl0aHJvdyBuZXcgRXJyb3IoIkZhaWxlZCB0byBmZXRjaC4gRW5zdXJlIHRoYXQgdGhlIHJlc291cmNlIHlvdSBhcmUgdHJ5aW5nIHRvIGFjY2VzcyBpcyBvbiBhIENPUnMgZW5hYmxlZCBlbmRwb2ludC4iKTt0aHJvdyBtO2Nhc2UgMTk6cmV0dXJuIFsyXX19KSl9KSl9LGUuYXJyYXlCdWZmZXJUb1N0cmluZz1mdW5jdGlvbihlLHQpe3ZhciByLG4sYSxpLHMsbz1uZXcgVWludDhBcnJheShlKSx1PVtdO2ZvcihuPXQ+MD9NYXRoLm1pbih0LG8ubGVuZ3RoKTpvLmxlbmd0aCxyPTA7cjxuOylzd2l0Y2goKGE9b1tyKytdKT4+NCl7Y2FzZSAwOmNhc2UgMTpjYXNlIDI6Y2FzZSAzOmNhc2UgNDpjYXNlIDU6Y2FzZSA2OmNhc2UgNzp1LnB1c2goU3RyaW5nLmZyb21DaGFyQ29kZShhKSk7YnJlYWs7Y2FzZSAxMjpjYXNlIDEzOmk9b1tyKytdLHUucHVzaChTdHJpbmcuZnJvbUNoYXJDb2RlKCgzMSZhKTw8Nnw2MyZpKSk7YnJlYWs7Y2FzZSAxNDppPW9bcisrXSxzPW9bcisrXSx1LnB1c2goU3RyaW5nLmZyb21DaGFyQ29kZSgoMTUmYSk8PDEyfCg2MyZpKTw8NnwoNjMmcyk8PDApKTt9cmV0dXJuIHUuam9pbigiIil9LGUuY2xvc2VSaW5nPWZ1bmN0aW9uKGUpe2UubGVuZ3RoPj0yJiYhTXIuYXJlRXF1YWwoZVswXSxlW2UubGVuZ3RoLTFdLDYpJiZlLnB1c2goZVswXSk7fSxlLmNvbG9yVG9IZXg9ZnVuY3Rpb24oZSl7dmFyIHQ7cmV0dXJuICIjIisoIjAiKyh0PUFycmF5LmlzQXJyYXkoZSk/ZTp0aGlzLmNvbG9yVG9SZ2JhQXJyYXkoZSkpWzBdLnRvU3RyaW5nKDE2KSkuc2xpY2UoLTIpKygiMCIrdFsxXS50b1N0cmluZygxNikpLnNsaWNlKC0yKSsoIjAiK3RbMl0udG9TdHJpbmcoMTYpKS5zbGljZSgtMil9LGUuY29sb3JUb1JnYmE9ZnVuY3Rpb24odCl7dmFyIHI7aWYoQXJyYXkuaXNBcnJheSh0KSlyPXQ7ZWxzZSB7aWYodC5pbmNsdWRlcygicmdiYSgiKXx8dC5pbmNsdWRlcygicmdiKCIpKXJldHVybiB0O2UuaXNWYWxpZFN0cmluZyh0KSYmKHI9dGhpcy5jb2xvclRvUmdiYUFycmF5KHQpKTt9ci5sZW5ndGg+PTQmJnJbM10+MSYmKHJbM10vPTI1NSkscnx8KHI9W10pO2Zvcih2YXIgbj0wO248NDtuKyspci5sZW5ndGg8bi0xP3IucHVzaCgwKTpyW25dPDAmJihyW25dPTApO3JldHVybiAicmdiYSgiK3JbMF0rIiwiK3JbMV0rIiwiK3JbMl0rIiwiK3JbM10rIikifSxlLmNvbG9yVG9SZ2JhQXJyYXk9ZnVuY3Rpb24odCl7aWYoZS5pc1ZhbGlkU3RyaW5nKHQpKXt2YXIgcj12b2lkIDA7aWYoKHQ9dC50b0xvd2VyQ2FzZSgpKS5pbmNsdWRlcygicmdiYSgiKXx8dC5pbmNsdWRlcygicmdiKCIpKXt2YXIgbj0odD10LnJlcGxhY2UoInJnYmEoIiwiIikucmVwbGFjZSgicmdiKCIsIiIpLnJlcGxhY2UoIikiLCIiKSkuc3BsaXQoL1xzKixccyovKTtpZihuLmxlbmd0aD49Myl7cj1bXTtmb3IodmFyIGE9MDthPG4ubGVuZ3RoO2ErKylpZihuW2FdLmluY2x1ZGVzKCIlIikpe3ZhciBpPXBhcnNlSW50KG5bYV0pLzEwMDszPT09YT9yLnB1c2goaSk6ci5wdXNoKDI1NSppKTt9ZWxzZSByLnB1c2gocGFyc2VJbnQoblthXSkpO3JldHVybiAzPT09ci5sZW5ndGg/ci5wdXNoKDEpOnIubGVuZ3RoPj00JiZyWzNdPjEmJihyWzNdPXJbM10vMjU1KSxyfXJldHVybiBbMCwwLDAsMF19aWYocj10aGlzLmNzc0NvbG9yTmFtZXNbdF0pcmV0dXJuIHI7dD10LnJlcGxhY2UoL14jPyhbYS1mXGRdKShbYS1mXGRdKShbYS1mXGRdKSQvaSwoZnVuY3Rpb24oZSx0LHIsbil7cmV0dXJuIHQrdCtyK3IrbitufSkpO3ZhciBzPS9eIz8oW2EtZlxkXXsyfSkoW2EtZlxkXXsyfSkoW2EtZlxkXXsyfSkkL2kuZXhlYyh0KTtyZXR1cm4gcz9bcGFyc2VJbnQoc1sxXSwxNikscGFyc2VJbnQoc1syXSwxNikscGFyc2VJbnQoc1szXSwxNiksMV06WzAsMCwwLDBdfX0sZS5jcmVhdGVQb3NpdGlvbj1mdW5jdGlvbih0LHIsbixhKXtpZihlLmlzVmFsaWROdW1iZXIodCkmJmUuaXNWYWxpZE51bWJlcihyKSl7dmFyIGk9W3Qscl07cmV0dXJuIGUuaXNWYWxpZE51bWJlcihuKSYmaS5wdXNoKG4pLGEmJihpWzBdPVlyKGlbMF0pLGlbMV09WHIoaVsxXSkpLGl9fSxlLmRvY0hhc0RhdGE9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJmUucm9vdCYmZS5yb290LmNoaWxkTm9kZXMmJmUucm9vdC5jaGlsZE5vZGVzLmxlbmd0aD4wfSxlLmRvZXNFbGVtZW50Q29udGFpblRhZ05hbWU9ZnVuY3Rpb24oZSx0KXtpZihlJiZ0JiZ0LmNoaWxkTm9kZXMpZm9yKHZhciByPTAsbj10LmNoaWxkTm9kZXM7cjxuLmxlbmd0aDtyKyspe2lmKG5bcl0udGFnTmFtZT09PWUpcmV0dXJuICEwfXJldHVybiAhMX0sZS5lc2NhcGVIdG1sPWZ1bmN0aW9uKGUpe3JldHVybiBlPyhlLmluY2x1ZGVzKCImbHQ7IikmJmUuaW5jbHVkZXMoIiZndDsiKSYmZS5pbmNsdWRlcygiJnF1b3Q7IikmJmUuaW5jbHVkZXMoIiZhcG9zOyIpJiZlLmluY2x1ZGVzKCImYW1wOyIpfHwoZT1lLnJlcGxhY2UoLyYvZywiJmFtcDsiKSksZS5yZXBsYWNlKC88L2csIiZsdDsiKS5yZXBsYWNlKC8+L2csIiZndDsiKS5yZXBsYWNlKC8iL2csIiZxdW90OyIpLnJlcGxhY2UoLycvZywiJmFwb3M7IikpOm51bGx9LGUuZ2V0RWxlbWVudEJ5VGFnTmFtZT1mdW5jdGlvbihlLHQpe2lmKGUmJnQmJnQuY2hpbGROb2Rlcylmb3IodmFyIHI9MCxuPXQuY2hpbGROb2RlcztyPG4ubGVuZ3RoO3IrKyl7dmFyIGE9bltyXTtpZihhLnRhZ05hbWU9PT1lKXJldHVybiBhfXJldHVybiBudWxsfSxlLmlnbm9yZVByb3BlcnR5PWZ1bmN0aW9uKGUsdCl7aWYoZSlzd2l0Y2goZSl7Y2FzZSJ0aXRsZSI6Y2FzZSJuYW1lIjpjYXNlImJhc2UiOmNhc2UicG9wdXBUZW1wbGF0ZSI6Y2FzZSJhbmNob3IiOmNhc2UiaW1hZ2UiOmNhc2UiaW1hZ2VVcmwiOmNhc2Uicm90YXRpb24iOmNhc2UiY29sb3IiOmNhc2Uic2l6ZSI6Y2FzZSJvZmZzZXQiOmNhc2Uic3Ryb2tlQ29sb3IiOmNhc2Uic3Ryb2tlV2lkdGgiOmNhc2Uic3Ryb2tlT3BhY2l0eSI6Y2FzZSJmaWxsQ29sb3IiOmNhc2UiZmlsbE9wYWNpdHkiOmNhc2UidmlzaWJpbGl0eSI6Y2FzZSJ2aXNpYmxlIjpyZXR1cm4gITA7ZGVmYXVsdDppZihlLnN0YXJ0c1dpdGgoIl8iKSlyZXR1cm4gITB9cmV0dXJuIG51bGw9PXR8fCIiPT09dH0sZS5pc0JpbmFyeURhdGE9ZnVuY3Rpb24oZSl7cmV0dXJuIDY3MzI0NzUyPT09bmV3IEludDMyQXJyYXkoZSwwLDEpWzBdfSxlLmlzQ29tcHJlc3NlZENvbnRlbnRUeXBlPWZ1bmN0aW9uKGUpe3JldHVybiAiYXBwbGljYXRpb24vdm5kLmdvb2dsZS1lYXJ0aC5rbXoiPT09ZXx8ImFwcGxpY2F0aW9uL3ppcCI9PT1lfHwiYXBwbGljYXRpb24vb2N0ZXQtc3RyZWFtIj09PWV8fGUuc3RhcnRzV2l0aCgiaW1hZ2UvIil9LGUuaXNVcmw9ZnVuY3Rpb24odCl7cmV0dXJuIHQmJiJzdHJpbmciPT10eXBlb2YgdCYmKHQuc3RhcnRzV2l0aCgiZGF0YTppbWFnZSIpfHxlLnByb3RvY29sUngudGVzdCh0KSl9LGUuaXNWYWxpZE51bWJlcj1mdW5jdGlvbihlKXtyZXR1cm4gIWlzTmFOKGUpJiZudWxsIT09ZSYmIm51bWJlciI9PXR5cGVvZiBlfSxlLmlzVmFsaWRTdHJpbmc9ZnVuY3Rpb24oZSl7cmV0dXJuIGUmJiJzdHJpbmciPT10eXBlb2YgZSYmIiIhPT1lfSxlLm1hdGNoRmlyc3RQcmVmZXJlbmNlPWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciByPTAsbj10O3I8bi5sZW5ndGg7cisrKXt2YXIgYT1uW3JdO2lmKGUuaW5jbHVkZXMoYSkpcmV0dXJuIGF9cmV0dXJuIG51bGx9LGUucGFyc2VCb29sZWFuPWZ1bmN0aW9uKGUpe3RyeXtpZihlPWUudHJpbSgpKXN3aXRjaChlLnRvTG93ZXJDYXNlKCkpe2Nhc2UidHJ1ZSI6Y2FzZSJ5ZXMiOmNhc2UiMSI6cmV0dXJuICEwO2Nhc2UiZmFsc2UiOmNhc2Uibm8iOmNhc2UiMCI6cmV0dXJuICExO2RlZmF1bHQ6cmV0dXJuIEJvb2xlYW4oZSl9fWNhdGNoKGUpe31yZXR1cm4gITF9LGUucGFyc2VRdWVyeVN0cmluZ1BhcmFtcz1mdW5jdGlvbihlLHQscil7ciYmKGU9ZS5yZXBsYWNlKC8mYW1wOy9naSwiJiIpKTt2YXIgbj1lLmluZGV4T2YoIj8iKTtpZihuPj0wKXt2YXIgYT1lLnN1YnN0cmluZyhuKzEpO2lmKGEpcmV0dXJuIGEuc3BsaXQoIiYiKS5tYXAoKGZ1bmN0aW9uKGUpe3JldHVybiBlLnNwbGl0KCI9Iil9KSkucmVkdWNlKChmdW5jdGlvbihlLHIpe3ZhciBuPXJbMF0sYT1yWzFdO3JldHVybiBlW3Q/bi50b0xvd2VyQ2FzZSgpOm5dPWRlY29kZVVSSShhKSxlfSkse30pfXJldHVybiB7fX0sZS5wYXJzZVVSTD1mdW5jdGlvbihlLHQpe3ZhciByPWUubWF0Y2godGhpcy5fdXJsUGFyc2VSeCksbj17ZmlsZU5hbWU6bnVsbCxoYXNoOnJbMTBdfHwiIixob3N0OnJbM118fCIiLGhvc3RuYW1lOnJbNl18fCIiLGhyZWY6clswXXx8IiIsb3JpZ2luOnJbMV18fCIiLHBhc3N3b3JkOnJbNV18fCIiLHBhdGhuYW1lOnJbOF18fChyWzFdPyIvIjoiIikscG9ydDpyWzddfHwiIixwcm90b2NvbDpyWzJdfHwiIixzZWFyY2g6cls5XXx8IiIsdXNlcm5hbWU6cls0XXx8IiJ9O2lmKDI9PT1uLnByb3RvY29sLmxlbmd0aCYmKG4ucHJvdG9jb2w9ImZpbGU6Ly8vIituLnByb3RvY29sLnRvVXBwZXJDYXNlKCksbi5vcmlnaW49bi5wcm90b2NvbCsiLy8iK24uaG9zdCksbi5ocmVmPW4ub3JpZ2luK24ucGF0aG5hbWUrbi5zZWFyY2grbi5oYXNoLG4ucGF0aG5hbWUmJiFuLnBhdGhuYW1lLmVuZHNXaXRoKCIvIikmJihuLmZpbGVOYW1lPW4ucGF0aG5hbWUucmVwbGFjZSgvXi4qW1xcXC9dLywiIikpLCF0aGlzLnByb3RvY29sUngudGVzdChlKSYmIWUuc3RhcnRzV2l0aCgiZGF0YToiKSYmdCYmdC5ob3N0JiZuLmhvc3QhPT10Lmhvc3Qpe3ZhciBhPXQucHJvdG9jb2wrIi8vIit0Lmhvc3Q7ZS5zdGFydHNXaXRoKCIvIik/YSs9ZTooYSs9Ii8iLHQuZmlsZU5hbWU/YSs9dC5wYXRoTmFtZS5zdWJzdHJpbmcoMCx0LnBhdGhOYW1lLmluZGV4T2YodC5maWxlTmFtZSkpOmErPXQucGF0aE5hbWUrIi8iLGErPWUpLG4uaHJlZj1hO31yZXR1cm4ge2Fic29sdXRlUGF0aDpuLmhyZWYsZmlsZU5hbWU6bi5maWxlTmFtZSxob3N0Om4uaG9zdCxob3N0TmFtZTpuLmhvc3RuYW1lLHBhdGhOYW1lOm4ucGF0aG5hbWUscHJvdG9jb2w6bi5wcm90b2NvbCxxdWVyeVN0cmluZzpuLnNlYXJjaH19LGUucmVwbGFjZU5ld2xpbmVzPWZ1bmN0aW9uKGUpe3JldHVybiBlLmluY2x1ZGVzKCI8Iik/ZS5yZXBsYWNlKC88cD48XC9wPi9nLCIiKS5yZXBsYWNlKC8oXHJcbnxcbnxccil7Mix9L2csIlxuIik6ZS5yZXBsYWNlKC8oXHJcbnxccnxcbikvZywiPGJyLz4iKX0sZS5yb3VuZEJCb3g9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gZS5sZW5ndGg+PTY/W3RoaXMucm91bmRUb1ByZWNpc2lvbihlWzBdLHQpLHRoaXMucm91bmRUb1ByZWNpc2lvbihlWzFdLHQpLGVbMl0sdGhpcy5yb3VuZFRvUHJlY2lzaW9uKGVbM10sdCksdGhpcy5yb3VuZFRvUHJlY2lzaW9uKGVbNF0sdCksZVs1XV06W3RoaXMucm91bmRUb1ByZWNpc2lvbihlWzBdLHQpLHRoaXMucm91bmRUb1ByZWNpc2lvbihlWzFdLHQpLHRoaXMucm91bmRUb1ByZWNpc2lvbihlWzJdLHQpLHRoaXMucm91bmRUb1ByZWNpc2lvbihlWzNdLHQpXX0sZS5yb3VuZFBvc2l0aW9uPWZ1bmN0aW9uKGUsdCl7dmFyIHI9W3RoaXMucm91bmRUb1ByZWNpc2lvbihlWzBdLHQpLHRoaXMucm91bmRUb1ByZWNpc2lvbihlWzFdLHQpXTtyZXR1cm4gZS5sZW5ndGg+MiYmci5wdXNoKHJbMl0pLHJ9LGUucm91bmRUb1ByZWNpc2lvbj1mdW5jdGlvbihlLHQpe3Q8MCYmKHQ9MCksdD4xMCYmKHQ9MTApO3ZhciByPXRoaXMuX3Bvd2VyRmFjdG9yW3RdO3JldHVybiBNYXRoLnJvdW5kKGUqcisxZS0xNCkvcn0sZS5zYW5pdGl6ZVR5cGVOYW1lPWZ1bmN0aW9uKGUpe2lmKGUpe2lmKGUuc3RhcnRzV2l0aCgiZ21sOiIpKXJldHVybiBlO3ZhciB0PWUudG9Mb3dlckNhc2UoKTtpZih0LmluY2x1ZGVzKCI6Iikpe3ZhciByPXQuc3BsaXQoIjoiKTtyLmxlbmd0aD4xJiYodD1yWzFdKTt9c3dpdGNoKHQpe2Nhc2UiYnl0ZSI6Y2FzZSJpbnQiOmNhc2UidWludCI6Y2FzZSJ1c2lnbmVkaW50IjpjYXNlInVzaWduZWRsb25nIjpjYXNlInVzaWduZWRzaG9ydCI6Y2FzZSJ1c2lnbmVkYnl0ZSI6Y2FzZSJpbnRlZ2VyIjpjYXNlIm5lZ2F0aXZlaW50ZWdlciI6Y2FzZSJwb3NpdGl2ZWludGVnZXIiOmNhc2Uibm9ubmVnYXRpdmVpbnRlZ2VyIjpjYXNlIm5vbnBvc2l0aXZlaW50ZWdlciI6Y2FzZSJzaG9ydCI6Y2FzZSJsb25nIjpjYXNlImRlY2ltYWwiOmNhc2UiZG91YmxlIjpjYXNlImZsb2F0IjpyZXR1cm4gIm51bWJlciI7Y2FzZSJib29sZWFuIjpjYXNlImJvb2wiOnJldHVybiAiYm9vbGVhbiI7Y2FzZSJkYXRlIjpjYXNlImRhdGV0aW1lIjpyZXR1cm4gImRhdGUifX1yZXR1cm4gZX0sZS5zaW1wbGlmeVhtbE5vZGU9ZnVuY3Rpb24oZSl7aWYoZSYmKGUuYXR0cmlidXRlc3x8ZS5jaGlsZE5vZGVzKSl7dmFyIHQ9e307aWYodGhpcy5hZGRBdHRyaWJ1dGVzVG9PYmplY3QoZSx0KSxlLmNoaWxkTm9kZXMpZm9yKHZhciByPTAsbj1lLmNoaWxkTm9kZXM7cjxuLmxlbmd0aDtyKyspe3ZhciBhPW5bcl07YS52YWx1ZT90W2EudGFnTmFtZV09YS52YWx1ZTphLmNoaWxkTm9kZXMmJmEuY2hpbGROb2Rlcy5sZW5ndGg+MCYmKHRbYS50YWdOYW1lXT10aGlzLnNpbXBsaWZ5WG1sTm9kZShhKSk7fXJldHVybiBlLnZhbHVlJiZ2b2lkIDA9PT10LnZhbHVlJiYodC52YWx1ZT1lLnZhbHVlKSx0fXJldHVybiBudWxsfSxlLnRyeUNhc3RPYmplY3Q9ZnVuY3Rpb24odCxyKXtpZihyKXRyeXtzd2l0Y2gocil7Y2FzZSJudW1iZXIiOnZhciBuPXBhcnNlRmxvYXQodCk7aWYoZS5pc1ZhbGlkTnVtYmVyKG4pKXJldHVybiBuO2JyZWFrO2Nhc2UiYm9vbGVhbiI6cmV0dXJuIGUucGFyc2VCb29sZWFuKHQpO2Nhc2UiZGF0ZSI6cmV0dXJuIEpyKHQpfX1jYXRjaChlKXt9cmV0dXJuIHR9LGUudW5lc2NhcGVIVE1MPWZ1bmN0aW9uKGUpe3JldHVybiBlP2UucmVwbGFjZSgvJmx0Oy9nLCI8IikucmVwbGFjZSgvJmd0Oy9nLCI+IikucmVwbGFjZSgvJnF1b3Q7L2csJyInKS5yZXBsYWNlKC8mYXBvczsvZywiJyIpLnJlcGxhY2UoLyZuYnNwOy9nLCIgIikucmVwbGFjZSgvJmFtcDsvZywiJiIpOm51bGx9LGUuX3Bvd2VyRmFjdG9yPVsxLDEwLDEwMCwxZTMsMWU0LDFlNSwxZTYsMWU3LDFlOCwxZTksMWUxMF0sZS5fdXJsUGFyc2VSeD0vXigoW146XC8/I10rOik/KD86XC9cLygoPzooW15cLz8jOl0qKTooW15cLz8jOl0qKUApPyhbXlwvPyM6XSopKD86OihbXlwvPyM6XSopKT8pKSk/KFtePyNdKikoXD9bXiNdKik/KCMuKik/JC8sZS5jb250YWluc0h0bWxSeD0vPFwvP1x3KygoXHMrXHcrKFxzKj1ccyooPzoiLio/InwnLio/J3xbXF4nIj5cc10rKSk/KStccyp8XHMqKVwvPz4vLGUuY29udGFpbnNTcGVjaWFsQ2hhclJ4PS9bJjw+IiddLyxlLmNzc0NvbG9yTmFtZXM9e2FsaWNlYmx1ZTpbMjQwLDI0OCwyNTUsMV0sYW50aXF1ZXdoaXRlOlsyNTAsMjM1LDIxNSwxXSxhcXVhOlswLDI1NSwyNTUsMV0sYXF1YW1hcmluZTpbMTI3LDI1NSwyMTIsMV0sYXp1cmU6WzI0MCwyNTUsMjU1LDFdLGJlaWdlOlsyNDUsMjQ1LDIyMCwxXSxiaXNxdWU6WzI1NSwyMjgsMTk2LDFdLGJsYWNrOlswLDAsMCwxXSxibGFuY2hlZGFsbW9uZDpbMjU1LDIzNSwyMDUsMV0sYmx1ZTpbMCwwLDI1NSwxXSxibHVldmlvbGV0OlsxMzgsNDMsMjI2LDFdLGJyb3duOlsxNjUsNDIsNDIsMV0sYnVybHl3b29kOlsyMjIsMTg0LDEzNSwxXSxjYWRldGJsdWU6Wzk1LDE1OCwxNjAsMV0sY2hhcnRyZXVzZTpbMTI3LDI1NSwwLDFdLGNob2NvbGF0ZTpbMjEwLDEwNSwzMCwxXSxjb3JhbDpbMjU1LDEyNyw4MCwxXSxjb3JuZmxvd2VyYmx1ZTpbMTAwLDE0OSwyMzcsMV0sY29ybnNpbGs6WzI1NSwyNDgsMjIwLDFdLGNyaW1zb246WzIyMCwyMCw2MCwxXSxjeWFuOlswLDI1NSwyNTUsMV0sZGFya2JsdWU6WzAsMCwxMzksMV0sZGFya2N5YW46WzAsMTM5LDEzOSwxXSxkYXJrZ29sZGVucm9kOlsxODQsMTM0LDExLDFdLGRhcmtncmF5OlsxNjksMTY5LDE2OSwxXSxkYXJrZ3JlZW46WzAsMTAwLDAsMV0sZGFya2dyZXk6WzE2OSwxNjksMTY5LDFdLGRhcmtraGFraTpbMTg5LDE4MywxMDcsMV0sZGFya21hZ2VudGE6WzEzOSwwLDEzOSwxXSxkYXJrb2xpdmVncmVlbjpbODUsMTA3LDQ3LDFdLGRhcmtvcmFuZ2U6WzI1NSwxNDAsMCwxXSxkYXJrb3JjaGlkOlsxNTMsNTAsMjA0LDFdLGRhcmtyZWQ6WzEzOSwwLDAsMV0sZGFya3NhbG1vbjpbMjMzLDE1MCwxMjIsMV0sZGFya3NlYWdyZWVuOlsxNDMsMTg4LDE0MywxXSxkYXJrc2xhdGVibHVlOls3Miw2MSwxMzksMV0sZGFya3NsYXRlZ3JheTpbNDcsNzksNzksMV0sZGFya3NsYXRlZ3JleTpbNDcsNzksNzksMV0sZGFya3R1cnF1b2lzZTpbMCwyMDYsMjA5LDFdLGRhcmt2aW9sZXQ6WzE0OCwwLDIxMSwxXSxkZWVwcGluazpbMjU1LDIwLDE0NywxXSxkZWVwc2t5Ymx1ZTpbMCwxOTEsMjU1LDFdLGRpbWdyYXk6WzEwNSwxMDUsMTA1LDFdLGRpbWdyZXk6WzEwNSwxMDUsMTA1LDFdLGRvZGdlcmJsdWU6WzMwLDE0NCwyNTUsMV0sZmlyZWJyaWNrOlsxNzgsMzQsMzQsMV0sZmxvcmFsd2hpdGU6WzI1NSwyNTAsMjQwLDFdLGZvcmVzdGdyZWVuOlszNCwxMzksMzQsMV0sZnVjaHNpYTpbMjU1LDAsMjU1LDFdLGdhaW5zYm9ybzpbMjIwLDIyMCwyMjAsMV0sZ2hvc3R3aGl0ZTpbMjQ4LDI0OCwyNTUsMV0sZ29sZDpbMjU1LDIxNSwwLDFdLGdvbGRlbnJvZDpbMjE4LDE2NSwzMiwxXSxncmF5OlsxMjgsMTI4LDEyOCwxXSxncmVlbjpbMCwxMjgsMCwxXSxncmVlbnllbGxvdzpbMTczLDI1NSw0NywxXSxncmV5OlsxMjgsMTI4LDEyOCwxXSxob25leWRldzpbMjQwLDI1NSwyNDAsMV0saG90cGluazpbMjU1LDEwNSwxODAsMV0saW5kaWFucmVkOlsyMDUsOTIsOTIsMV0saW5kaWdvOls3NSwwLDEzMCwxXSxpdm9yeTpbMjU1LDI1NSwyNDAsMV0sa2hha2k6WzI0MCwyMzAsMTQwLDFdLGxhdmVuZGVyOlsyMzAsMjMwLDI1MCwxXSxsYXZlbmRlcmJsdXNoOlsyNTUsMjQwLDI0NSwxXSxsYXduZ3JlZW46WzEyNCwyNTIsMCwxXSxsZW1vbmNoaWZmb246WzI1NSwyNTAsMjA1LDFdLGxpZ2h0Ymx1ZTpbMTczLDIxNiwyMzAsMV0sbGlnaHRjb3JhbDpbMjQwLDEyOCwxMjgsMV0sbGlnaHRjeWFuOlsyMjQsMjU1LDI1NSwxXSxsaWdodGdvbGRlbnJvZHllbGxvdzpbMjUwLDI1MCwyMTAsMV0sbGlnaHRncmF5OlsyMTEsMjExLDIxMSwxXSxsaWdodGdyZWVuOlsxNDQsMjM4LDE0NCwxXSxsaWdodGdyZXk6WzIxMSwyMTEsMjExLDFdLGxpZ2h0cGluazpbMjU1LDE4MiwxOTMsMV0sbGlnaHRzYWxtb246WzI1NSwxNjAsMTIyLDFdLGxpZ2h0c2VhZ3JlZW46WzMyLDE3OCwxNzAsMV0sbGlnaHRza3libHVlOlsxMzUsMjA2LDI1MCwxXSxsaWdodHNsYXRlZ3JheTpbMTE5LDEzNiwxNTMsMV0sbGlnaHRzbGF0ZWdyZXk6WzExOSwxMzYsMTUzLDFdLGxpZ2h0c3RlZWxibHVlOlsxNzYsMTk2LDIyMiwxXSxsaWdodHllbGxvdzpbMjU1LDI1NSwyMjQsMV0sbGltZTpbMCwyNTUsMCwxXSxsaW1lZ3JlZW46WzUwLDIwNSw1MCwxXSxsaW5lbjpbMjUwLDI0MCwyMzAsMV0sbWFnZW50YTpbMjU1LDAsMjU1LDFdLG1hcm9vbjpbMTI4LDAsMCwxXSxtZWRpdW1hcXVhbWFyaW5lOlsxMDIsMjA1LDE3MCwxXSxtZWRpdW1ibHVlOlswLDAsMjA1LDFdLG1lZGl1bW9yY2hpZDpbMTg2LDg1LDIxMSwxXSxtZWRpdW1wdXJwbGU6WzE0NywxMTIsMjE5LDFdLG1lZGl1bXNlYWdyZWVuOls2MCwxNzksMTEzLDFdLG1lZGl1bXNsYXRlYmx1ZTpbMTIzLDEwNCwyMzgsMV0sbWVkaXVtc3ByaW5nZ3JlZW46WzAsMjUwLDE1NCwxXSxtZWRpdW10dXJxdW9pc2U6WzcyLDIwOSwyMDQsMV0sbWVkaXVtdmlvbGV0cmVkOlsxOTksMjEsMTMzLDFdLG1pZG5pZ2h0Ymx1ZTpbMjUsMjUsMTEyLDFdLG1pbnRjcmVhbTpbMjQ1LDI1NSwyNTAsMV0sbWlzdHlyb3NlOlsyNTUsMjI4LDIyNSwxXSxtb2NjYXNpbjpbMjU1LDIyOCwxODEsMV0sbmF2YWpvd2hpdGU6WzI1NSwyMjIsMTczLDFdLG5hdnk6WzAsMCwxMjgsMV0sb2xkbGFjZTpbMjUzLDI0NSwyMzAsMV0sb2xpdmU6WzEyOCwxMjgsMCwxXSxvbGl2ZWRyYWI6WzEwNywxNDIsMzUsMV0sb3JhbmdlOlsyNTUsMTY1LDAsMV0sb3JhbmdlcmVkOlsyNTUsNjksMCwxXSxvcmNoaWQ6WzIxOCwxMTIsMjE0LDFdLHBhbGVnb2xkZW5yb2Q6WzIzOCwyMzIsMTcwLDFdLHBhbGVncmVlbjpbMTUyLDI1MSwxNTIsMV0scGFsZXR1cnF1b2lzZTpbMTc1LDIzOCwyMzgsMV0scGFsZXZpb2xldHJlZDpbMjE5LDExMiwxNDcsMV0scGFwYXlhd2hpcDpbMjU1LDIzOSwyMTMsMV0scGVhY2hwdWZmOlsyNTUsMjE4LDE4NSwxXSxwZXJ1OlsyMDUsMTMzLDYzLDFdLHBpbms6WzI1NSwxOTIsMjAzLDFdLHBsdW06WzIyMSwxNjAsMjIxLDFdLHBvd2RlcmJsdWU6WzE3NiwyMjQsMjMwLDFdLHB1cnBsZTpbMTI4LDAsMTI4LDFdLHJlZDpbMjU1LDAsMCwxXSxyb3N5YnJvd246WzE4OCwxNDMsMTQzLDFdLHJveWFsYmx1ZTpbNjUsMTA1LDIyNSwxXSxzYWRkbGVicm93bjpbMTM5LDY5LDE5LDFdLHNhbG1vbjpbMjUwLDEyOCwxMTQsMV0sc2FuZHlicm93bjpbMjQ0LDE2NCw5NiwxXSxzZWFncmVlbjpbNDYsMTM5LDg3LDFdLHNlYXNoZWxsOlsyNTUsMjQ1LDIzOCwxXSxzaWVubmE6WzE2MCw4Miw0NSwxXSxzaWx2ZXI6WzE5MiwxOTIsMTkyLDFdLHNreWJsdWU6WzEzNSwyMDYsMjM1LDFdLHNsYXRlYmx1ZTpbMTA2LDkwLDIwNSwxXSxzbGF0ZWdyYXk6WzExMiwxMjgsMTQ0LDFdLHNsYXRlZ3JleTpbMTEyLDEyOCwxNDQsMV0sc25vdzpbMjU1LDI1MCwyNTAsMV0sc3ByaW5nZ3JlZW46WzAsMjU1LDEyNywxXSxzdGVlbGJsdWU6WzcwLDEzMCwxODAsMV0sdGFuOlsyMTAsMTgwLDE0MCwxXSx0ZWFsOlswLDEyOCwxMjgsMV0sdGhpc3RsZTpbMjE2LDE5MSwyMTYsMV0sdG9tYXRvOlsyNTUsOTksNzEsMV0sdHJhbnNwYXJlbnQ6WzAsMCwwLDBdLHR1cnF1b2lzZTpbNjQsMjI0LDIwOCwxXSx2aW9sZXQ6WzIzOCwxMzAsMjM4LDFdLHdoZWF0OlsyNDUsMjIyLDE3OSwxXSx3aGl0ZTpbMjU1LDI1NSwyNTUsMV0sd2hpdGVzbW9rZTpbMjQ1LDI0NSwyNDUsMV0seWVsbG93OlsyNTUsMjU1LDAsMV0seWVsbG93Z3JlZW46WzE1NCwyMDUsNTAsMV0sZ3JuOlswLDEyOCwwLDFdLGx0Ymx1OlsxNzMsMjE2LDIzMCwxXSx3aHQ6WzI1NSwyNTUsMjU1LDFdLHlsdzpbMjU1LDI1NSwwLDFdLG1vZGlzXzAwX3RvXzA2aHJfZmlyZTpbMTM5LDAsMCwxXSxtb2Rpc18wNl90b18xMmhyX2ZpcmU6WzI1NSwwLDAsMV0sbW9kaXNfMTJfdG9fMjRocl9maXJlOlsyNTUsMTY1LDAsMV0sbW9kaXNfcHJldl82X2RheXNfZmlyZTpbMjU1LDI1NSwwLDFdfSxlLm1tUGVyUGl4ZWxHcHg9My43Nzk1Mjc1NTkxLGUucHJvdG9jb2xSeD0vXig/OlthLXpBLVpdKzopP1wvXC8vLGV9KCksdG49ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKCl7dGhpcy50eXBlPSJGZWF0dXJlQ29sbGVjdGlvbiIsdGhpcy5iYm94PW51bGwsdGhpcy5mZWF0dXJlcz1bXSx0aGlzLmdyb3VuZE92ZXJsYXlzPVtdLHRoaXMucHJvcGVydGllcz17fSx0aGlzLnN0YXRzPW51bGwsdGhpcy5pY29ucz17fSx0aGlzLl9ncm91bmRPdmVybGF5T3B0aW9ucz1bXTt9cmV0dXJuIGUuZW5yaWNoPWZ1bmN0aW9uKHQpe2lmKHQucHJvcGVydGllcyYmIXQucHJvcGVydGllcy50aXRsZSYmdC5wcm9wZXJ0aWVzLm5hbWUmJih0LnByb3BlcnRpZXMudGl0bGU9dC5wcm9wZXJ0aWVzLm5hbWUpLGUuZ2V0Qm91bmRzKHQpLCF0LnN0YXRzKXRyeXtlLmNvbXB1dGVTdGF0cyh0KTt9Y2F0Y2goZSl7dC5zdGF0cz17fTt9fSxlLm1lcmdlPWZ1bmN0aW9uKHQscil7aWYocil7dC5wcm9wZXJ0aWVzP3IucHJvcGVydGllc3x8T2JqZWN0LmtleXMoci5wcm9wZXJ0aWVzKS5mb3JFYWNoKChmdW5jdGlvbihlKXt0LnByb3BlcnRpZXNbZV18fCJib3VuZHMiPT09ZXx8KHQucHJvcGVydGllc1tlXT1yLnByb3BlcnRpZXNbZV0pO30pKTp0LnByb3BlcnRpZXM9ci5wcm9wZXJ0aWVzLHIuZmVhdHVyZXMmJnIuZmVhdHVyZXMubGVuZ3RoPjAmJih0LmZlYXR1cmVzJiZ0LmZlYXR1cmVzLmxlbmd0aD4wP3QuZmVhdHVyZXM9dC5mZWF0dXJlcy5jb25jYXQoci5mZWF0dXJlcyk6dC5mZWF0dXJlcz1yLmZlYXR1cmVzKSxyLl9ncm91bmRPdmVybGF5T3B0aW9ucyYmci5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMubGVuZ3RoPjAmJih0Ll9ncm91bmRPdmVybGF5T3B0aW9ucyYmdC5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMubGVuZ3RoPjA/dC5fZ3JvdW5kT3ZlcmxheU9wdGlvbnM9dC5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMuY29uY2F0KHIuX2dyb3VuZE92ZXJsYXlPcHRpb25zKTp0Ll9ncm91bmRPdmVybGF5T3B0aW9ucz1yLl9ncm91bmRPdmVybGF5T3B0aW9ucyksci5ncm91bmRPdmVybGF5cyYmci5ncm91bmRPdmVybGF5cy5sZW5ndGg+MCYmKHQuZ3JvdW5kT3ZlcmxheXMmJnQuZ3JvdW5kT3ZlcmxheXMubGVuZ3RoPjA/dC5ncm91bmRPdmVybGF5cz10Lmdyb3VuZE92ZXJsYXlzLmNvbmNhdChyLmdyb3VuZE92ZXJsYXlzKTp0Lmdyb3VuZE92ZXJsYXlzPXIuZ3JvdW5kT3ZlcmxheXMpLHIuaWNvbnMmJih0Lmljb25zPU9iamVjdC5hc3NpZ24odC5pY29uc3x8e30sci5pY29ucykpLHIuc3RhdHMmJih0LnN0YXRzPyh0LnN0YXRzLm51bVBvaW50cys9ci5zdGF0cy5udW1Qb2ludHMsdC5zdGF0cy5udW1MaW5lU3RyaW5ncys9ci5zdGF0cy5udW1MaW5lU3RyaW5ncyx0LnN0YXRzLm51bVBvbHlnb25zKz1yLnN0YXRzLm51bVBvbHlnb25zLHQuc3RhdHMubnVtR3JvdW5kT3ZlcmxheXMrPXIuc3RhdHMubnVtR3JvdW5kT3ZlcmxheXMsdC5zdGF0cy5udW1OZXR3b3JrTGlua3MrPXIuc3RhdHMubnVtTmV0d29ya0xpbmtzLHQuc3RhdHMubnVtUG9zaXRpb25zKz1yLnN0YXRzLm51bVBvc2l0aW9ucyx0LnN0YXRzLm51bUNoYXJhY3RlcnMrPXIuc3RhdHMubnVtQ2hhcmFjdGVycyk6dC5zdGF0cz1yLnN0YXRzKTt2YXIgbj10LmJib3gsYT1yLmJib3g7bnx8KG49ZS5nZXRCb3VuZHModCkpLGF8fChhPWUuZ2V0Qm91bmRzKHQpKSxudWxsIT09biYmbnVsbCE9PWE/dC5iYm94PUxyLm1lcmdlKG4sYSk6bnVsbCE9PWEmJih0LmJib3g9YSksdC5wcm9wZXJ0aWVzJiZ0LnByb3BlcnRpZXMuYm91bmRzJiYodC5wcm9wZXJ0aWVzLmJvdW5kcz12b2lkIDApO319LGUuY29tcHV0ZVN0YXRzPWZ1bmN0aW9uKGUpe2lmKGUpe3ZhciB0PXt9O2lmKGUuc3RhdHMmJih0PXtudW1DaGFyYWN0ZXJzOmUuc3RhdHMubnVtQ2hhcmFjdGVyc3x8MCxudW1OZXR3b3JrTGlua3M6ZS5zdGF0cy5udW1OZXR3b3JrTGlua3N8fDAscHJvY2Vzc2luZ1RpbWU6MH0pLGUuc3RhdHM9e251bUdyb3VuZE92ZXJsYXlzOjAsbnVtTGluZVN0cmluZ3M6MCxudW1Qb2ludHM6MCxudW1Qb2x5Z29uczowLG51bVBvc2l0aW9uczowfSxPYmplY3QuYXNzaWduKGUuc3RhdHMsdCksZS5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMmJmUuX2dyb3VuZE92ZXJsYXlPcHRpb25zLmxlbmd0aD4wJiYoZS5zdGF0cy5udW1Hcm91bmRPdmVybGF5cys9ZS5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMubGVuZ3RoLGUuc3RhdHMubnVtUG9zaXRpb25zKz00KmUuX2dyb3VuZE92ZXJsYXlPcHRpb25zLmxlbmd0aCksZS5mZWF0dXJlcyYmZS5mZWF0dXJlcy5sZW5ndGg+MClmb3IodmFyIHI9MCxuPWUuZmVhdHVyZXM7cjxuLmxlbmd0aDtyKyspe3ZhciBhPW5bcl0uZ2VvbWV0cnk7aWYoYSlzd2l0Y2goYS50eXBlKXtjYXNlIlBvaW50IjplLnN0YXRzLm51bVBvaW50cysrLGUuc3RhdHMubnVtUG9zaXRpb25zKys7YnJlYWs7Y2FzZSJMaW5lU3RyaW5nIjplLnN0YXRzLm51bUxpbmVTdHJpbmdzKyssZS5zdGF0cy5udW1Qb3NpdGlvbnMrPWEuY29vcmRpbmF0ZXMubGVuZ3RoO2JyZWFrO2Nhc2UiUG9seWdvbiI6ZS5zdGF0cy5udW1Qb2x5Z29ucysrO2Zvcih2YXIgaT0wLHM9YS5jb29yZGluYXRlcztpPHMubGVuZ3RoO2krKyl7dmFyIG89c1tpXTtlLnN0YXRzLm51bVBvc2l0aW9ucys9by5sZW5ndGg7fWJyZWFrO2Nhc2UiTXVsdGlQb2ludCI6ZS5zdGF0cy5udW1Qb2ludHMrPWEuY29vcmRpbmF0ZXMubGVuZ3RoLGUuc3RhdHMubnVtUG9zaXRpb25zKz1hLmNvb3JkaW5hdGVzLmxlbmd0aDticmVhaztjYXNlIk11bHRpTGluZVN0cmluZyI6ZS5zdGF0cy5udW1MaW5lU3RyaW5ncys9YS5jb29yZGluYXRlcy5sZW5ndGg7Zm9yKHZhciB1PTAsbD1hLmNvb3JkaW5hdGVzO3U8bC5sZW5ndGg7dSsrKXt2YXIgYz1sW3VdO2Uuc3RhdHMubnVtUG9zaXRpb25zKz1jLmxlbmd0aDt9YnJlYWs7Y2FzZSJNdWx0aVBvbHlnb24iOmUuc3RhdHMubnVtUG9seWdvbnMrPWEuY29vcmRpbmF0ZXMubGVuZ3RoO2Zvcih2YXIgaD0wLGQ9YS5jb29yZGluYXRlcztoPGQubGVuZ3RoO2grKylmb3IodmFyIGY9MCxwPWRbaF07ZjxwLmxlbmd0aDtmKyspe289cFtmXTtlLnN0YXRzLm51bVBvc2l0aW9ucys9by5sZW5ndGg7fX19fX0sZS5nZXRCb3VuZHM9ZnVuY3Rpb24oZSl7aWYoZS5iYm94KXJldHVybiBlLmJib3g7aWYoZS5wcm9wZXJ0aWVzJiZBcnJheS5pc0FycmF5KGUucHJvcGVydGllcy5ib3VuZHMpKXt2YXIgdD1lLnByb3BlcnRpZXMuYm91bmRzO3JldHVybiBlLmJib3g9dCx0fXZhciByPW51bGw7aWYoZS5mZWF0dXJlcyYmZS5mZWF0dXJlcy5sZW5ndGg+MCYmKHI9THIuZnJvbURhdGEoZS5mZWF0dXJlcykpLGUuX2dyb3VuZE92ZXJsYXlPcHRpb25zJiZlLl9ncm91bmRPdmVybGF5T3B0aW9ucy5sZW5ndGg+MClmb3IodmFyIG49MCxhPWUuX2dyb3VuZE92ZXJsYXlPcHRpb25zO248YS5sZW5ndGg7bisrKXt2YXIgaT1hW25dLHM9aS5ib3VuZHM7IXMmJmkuY29vcmRpbmF0ZXMmJihzPUxyLmZyb21Qb3NpdGlvbnMoaS5jb29yZGluYXRlcykpLHMmJihyPXI/THIubWVyZ2UocixzKTpzKTt9cmV0dXJuIGUuYmJveD1yLHJ9LGV9KCkscm49ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKCl7fXJldHVybiBlLmNyZWF0ZVVybFJlcXVlc3Q9ZnVuY3Rpb24oZSx0LHIpe3ZhciBuPU9iamVjdC5rZXlzKHQpO3JldHVybiBuPW4uZmlsdGVyKChmdW5jdGlvbihlKXtyZXR1cm4gdm9pZCAwIT09dFtlXX0pKSxyP2UrIj8iK24ubWFwKChmdW5jdGlvbihlKXtyZXR1cm4gZS50b1VwcGVyQ2FzZSgpKyI9IitlbmNvZGVVUklDb21wb25lbnQodFtlXSl9KSkuam9pbigiJiIpOmUrIj8iK24ubWFwKChmdW5jdGlvbihlKXtyZXR1cm4gZSsiPSIrZW5jb2RlVVJJQ29tcG9uZW50KHRbZV0pfSkpLmpvaW4oIiYiKX0sZS5nZXRCYXNlVXJsPWZ1bmN0aW9uKGUpe3JldHVybiBlbi5pc1ZhbGlkU3RyaW5nKGUpPyhlLmluY2x1ZGVzKCI/IikmJihlPWUuc3Vic3RyKDAsZS5pbmRleE9mKCI/IikpKSxlLmVuZHNXaXRoKCIvIikmJihlPWUuc2xpY2UoMCwtMSkpLGU9ZS5yZXBsYWNlKC9cL1dNVFNDYXBhYmlsaXRpZXMueG1sJC9pLCIiKS5yZXBsYWNlKC9cLzEuMC4wJC9pLCIiKSk6bnVsbH0sZS5nZXRCQm94U3RyaW5nPWZ1bmN0aW9uKHQscil7dmFyIG49ZS5pc1NyaWRTdXBwb3J0ZWQodCwid2dzODQiKSxhPWUuaXNTcmlkU3VwcG9ydGVkKHQsImV4dGVuZGVkIiksaT1lLmlzU3JpZFN1cHBvcnRlZCh0LCJtZXJjYXRvciIpO2lmKHImJkFycmF5LmlzQXJyYXkocikpNj09PXIubGVuZ3RoJiYocj1bclswXSxyWzFdLHJbM10scls0XV0pO2Vsc2UgaWYobnx8YSlyPWUud29ybGRCb3VuZHM7ZWxzZSBpZihpKXt2YXIgcz10aGlzLnRvV2ViTWVyY2F0b3IoWy0xODAsLTg1LjA1MTEyODc4XSksbz10aGlzLnRvV2ViTWVyY2F0b3IoWzE4MCw4NS4wNTExMjg3OF0pO3I9THIuZnJvbUVkZ2VzKHNbMF0sc1sxXSxvWzBdLG9bMV0pO31pZighcnx8IUFycmF5LmlzQXJyYXkocil8fDQhPT1yLmxlbmd0aCl0aHJvdyBuZXcgRXJyb3IoIkludmFsaWQgYm91bmRpbmcgYm94IHNwZWNpZmllZC4iKTtzd2l0Y2godD10LnRvTG93ZXJDYXNlKCkpe2Nhc2UiY3JzOjg0IjpjYXNlImNyczg0IjpyZXR1cm4gci5qb2luKCIsIik7ZGVmYXVsdDpyZXR1cm4gclsxXSsiLCIrclswXSsiLCIrclszXSsiLCIrclsyXX19LGUuZ2V0Wm9vbVJhbmdlPWZ1bmN0aW9uKGUsdCl7dmFyIHIsbjsibnVtYmVyIiE9dHlwZW9mIHR8fHQ+dGhpcy5fbWFwWm9vbVNjYWxlNTEyWzBdP3I9MDp0PHRoaXMuX21hcFpvb21TY2FsZTUxMlt0aGlzLl9tYXBab29tU2NhbGU1MTIubGVuZ3RoLTFdJiYocj10aGlzLl9tYXBab29tU2NhbGU1MTIubGVuZ3RoLTEpLCJudW1iZXIiIT10eXBlb2YgZXx8ZT50aGlzLl9tYXBab29tU2NhbGU1MTJbMF0/bj0yNDplPHRoaXMuX21hcFpvb21TY2FsZTUxMlt0aGlzLl9tYXBab29tU2NhbGU1MTIubGVuZ3RoLTFdJiYobj10aGlzLl9tYXBab29tU2NhbGU1MTIubGVuZ3RoLTEpO3ZhciBhPXZvaWQgMD09PXIsaT12b2lkIDA9PT1uO2lmKGF8fGkpZm9yKHZhciBzPXZvaWQgMCxvPXZvaWQgMCx1PTAsbD10aGlzLl9tYXBab29tU2NhbGU1MTIubGVuZ3RoLTE7dTxsJiYocz10aGlzLl9tYXBab29tU2NhbGU1MTJbdV0sbz10aGlzLl9tYXBab29tU2NhbGU1MTJbdSsxXSxhJiZ0PD1zJiZ0Pj1vJiYocj11KzEpLGkmJmU8PXMmJmU+PW8mJihuPXUpLGE9dm9pZCAwPT09ciwoaT12b2lkIDA9PT1uKXx8YSk7dSsrKTtyZXR1cm4gYSYmKHI9MCksaSYmKG49MjQpLHI+biYmKHI9biksW3Isbl19LGUuaXNFbmRwb2ludFJldmVyc2VkPWZ1bmN0aW9uKGUpe2lmKGUpZm9yKHZhciB0PTAscj10aGlzLmtub3dSZXZlcnNlZEF4aXNFbmRwb2ludHM7dDxyLmxlbmd0aDt0Kyspe3ZhciBuPXJbdF07aWYoZS5pbmNsdWRlcyhuKSlyZXR1cm4gITB9cmV0dXJuICExfSxlLmlzU3JpZEF4aXNMb25MYXQ9ZnVuY3Rpb24oZSl7cmV0dXJuICEhZSYmKChlPWUudG9Mb3dlckNhc2UoKSkmJmUuaW5jbHVkZXMoImNyczo4NCIpfHxlLmluY2x1ZGVzKCJjcnM4NCIpfHx0aGlzLl9jb250YWluc1NyaWQoZSx0aGlzLmF4aXNPcmRlcklzTG9uTGF0KSl9LGUuaXNTcmlkU3VwcG9ydGVkPWZ1bmN0aW9uKGUsdCl7aWYoZSl7dmFyIHI9dGhpcy53Z3M4NFNycztzd2l0Y2godCl7Y2FzZSJleHRlbmRlZCI6cj10aGlzLmV4dGVuZGVkU3JzU3VwcG9ydDticmVhaztjYXNlIm1lcmNhdG9yIjpyPXRoaXMubWVyY2F0b3JTcmlkczt9cmV0dXJuIHRoaXMuX2NvbnRhaW5zU3JpZChlLHIpfXJldHVybiAhMX0sZS5wYXJzZVdHUzg0Qm91bmRpbmdCb3g9ZnVuY3Rpb24oZSl7dmFyIHQ9ZW4uZ2V0RWxlbWVudEJ5VGFnTmFtZSgiTG93ZXJDb3JuZXIiLGUpLHI9ZW4uZ2V0RWxlbWVudEJ5VGFnTmFtZSgiVXBwZXJDb3JuZXIiLGUpO2lmKHQmJnQudmFsdWUmJnImJnIudmFsdWUpe3ZhciBuPXQudmFsdWUuc3BsaXQoIiAiKSxhPXIudmFsdWUuc3BsaXQoIiAiKTtyZXR1cm4gbi5sZW5ndGg+PTImJmEubGVuZ3RoPj0yP1twYXJzZUZsb2F0KG5bMF0pLHBhcnNlRmxvYXQoblsxXSkscGFyc2VGbG9hdChhWzBdKSxwYXJzZUZsb2F0KGFbMV0pXTpudWxsfX0sZS50b1dlYk1lcmNhdG9yPWZ1bmN0aW9uKGUpe2lmKGUmJmUubGVuZ3RoPj0yKXt2YXIgdD1lWzBdKnRoaXMuZXBzZzM4NTdNYXhFeHRlbnQvMTgwLHI9TWF0aC5sb2coTWF0aC50YW4oKDkwK2VbMV0pKk1hdGguUEkvMzYwKSkvKE1hdGguUEkvMTgwKSxuPVt0LHI9cip0aGlzLmVwc2czODU3TWF4RXh0ZW50LzE4MF07cmV0dXJuIGUubGVuZ3RoPjImJm4ucHVzaChlWzJdKSxufXJldHVybiBudWxsfSxlLnRvV2dzODQ9ZnVuY3Rpb24oZSl7aWYoZSYmZS5sZW5ndGg+PTIpe3ZhciB0PVsxODAqZVswXS90aGlzLmVwc2czODU3TWF4RXh0ZW50LDM2MCpNYXRoLmF0YW4oTWF0aC5leHAoZVsxXSpNYXRoLlBJL3RoaXMuZXBzZzM4NTdNYXhFeHRlbnQpKS9NYXRoLlBJLTkwXTtyZXR1cm4gZS5sZW5ndGg+MiYmdC5wdXNoKGVbMl0pLHR9cmV0dXJuIG51bGx9LGUuX2NvbnRhaW5zU3JpZD1mdW5jdGlvbihlLHQpe2lmKGUpe3ZhciByPWUubWF0Y2goL1swLTldezQsfS9naSk7aWYociYmMT09PXIubGVuZ3RoJiZ0LmluY2x1ZGVzKHJbMF0pKXJldHVybiAhMDtpZihlPWUudG9Mb3dlckNhc2UoKS5yZXBsYWNlKCJjcnM6IiwiIikucmVwbGFjZSgiY3JzIiwiIiksdC5pbmNsdWRlcyhlKSlyZXR1cm4gITB9cmV0dXJuICExfSxlLmF4aXNPcmRlcklzTG9uTGF0PVsiODQiLCI0MjU4Il0sZS5lcHNnMzg1N01heEV4dGVudD0yMDAzNzUwOC4zNCxlLmV4dGVuZGVkU3JzU3VwcG9ydD1bIjQyNjkiLCI0MjgzIiwiNDI1OCIsIjQzMDgiLCI0MjMwIiwiNDI3MiIsIjQyNzEiLCI0MjY3IiwiNDYwOCIsIjQ2NzQiXSxlLmtub3dSZXZlcnNlZEF4aXNFbmRwb2ludHM9WyJodHRwczovL2hhemFyZHMuZmVtYS5nb3YvZ2lzIl0sZS5fbWFwWm9vbVNjYWxlNTEyPVs1OTE2NTc1NTAuNSwyOTU4Mjg3NzUuMywxNDc5MTQzODcuNiw3Mzk1NzE5My44MSwzNjk3ODU5Ni45MSwxODQ4OTI5OC40NSw5MjQ0NjQ5LjIyNyw0NjIyMzI0LjYxMywyMzExMTYyLjMwNywxMTU1NTgxLjE1Myw1Nzc3OTAuNTc2NywyODg4OTUuMjg4MywxNDQ0NDcuNjQ0Miw3MjIyMy44MjIwOCwzNjExMS45MTEwNCwxODA1NS45NTU1Miw5MDI3Ljk3Nzc2LDQ1MTMuOTg4ODgsMjI1Ni45OTQ0NCwxMTI4LjQ5NzIyLDU2NC4yNDg2MSwyODIuMTI0MzA1LDE0MS4wNjIxNTI1LDcwLjUzMTA3NjI1LDM1LjI2NTUzODEzXSxlLm1lcmNhdG9yU3JpZHM9WyIzODU3IiwiMTAyMTAwIiwiMzc4NSIsIjkwMDkxMyIsIjEwMjExMyIsIjQxMDAxIiwiNTQwMDQiXSxlLndnczg0U3JzPVsiODQiLCI0MzI2Il0sZS5FUFNHMzg1Nz0iRVBTRzozODU3IixlLkVQU0c0MzI2PSJFUFNHOjQzMjYiLGUud29ybGRCb3VuZHM9Wy0xODAsLTkwLDE4MCw5MF0sZX0oKSxubj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt9cmV0dXJuIGUucHJvdG90eXBlLm1lcmdlPWZ1bmN0aW9uKCl7Zm9yKHZhciB0LHI9W10sbj0wO248YXJndW1lbnRzLmxlbmd0aDtuKyspcltuXT1hcmd1bWVudHNbbl07Zm9yKHZhciBhPTAsaT1yO2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO2lmKHMpZm9yKHZhciBvIGluIHMpcy5oYXNPd25Qcm9wZXJ0eShvKSYmdGhpcy5oYXNPd25Qcm9wZXJ0eShvKSYmKHZvaWQgMCE9PXNbb10mJm51bGwhPXNbb10/dGhpc1tvXWluc3RhbmNlb2YgZT90aGlzW29dLm1lcmdlKHNbb10pOnRoaXNbb109c1tvXToodHx8KHQ9bmV3KE9iamVjdC5nZXRQcm90b3R5cGVPZih0aGlzKS5jb25zdHJ1Y3RvcikpLHRoaXNbb109dFtvXSkpO31yZXR1cm4gdGhpc30sZX0oKSxhbj1mdW5jdGlvbihlKXtmdW5jdGlvbiByKCl7dmFyIHQ9bnVsbCE9PWUmJmUuYXBwbHkodGhpcyxhcmd1bWVudHMpfHx0aGlzO3JldHVybiB0Lm1heEZlYXR1cmVzPTEvMCx0LnByb3h5U2VydmljZT12b2lkIDAsdH1yZXR1cm4gdChyLGUpLHIucHJvdG90eXBlLm1lcmdlPWZ1bmN0aW9uKCl7Zm9yKHZhciB0PVtdLHI9MDtyPGFyZ3VtZW50cy5sZW5ndGg7cisrKXRbcl09YXJndW1lbnRzW3JdO3ZhciBuPWUucHJvdG90eXBlLm1lcmdlLmFwcGx5KHRoaXMsdCk7cmV0dXJuIG4ubWF4RmVhdHVyZXM8MCYmKG4ubWF4RmVhdHVyZXM9MS8wKSxufSxyfShubiksc249ZnVuY3Rpb24oZSl7ZnVuY3Rpb24gcigpe3ZhciB0PW51bGwhPT1lJiZlLmFwcGx5KHRoaXMsYXJndW1lbnRzKXx8dGhpcztyZXR1cm4gdC5wYXJzZVN0eWxlcz0hMCx0fXJldHVybiB0KHIsZSkscn0oYW4pLG9uPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIoKXt2YXIgdD1udWxsIT09ZSYmZS5hcHBseSh0aGlzLGFyZ3VtZW50cyl8fHRoaXM7cmV0dXJuIHQuaXNBeGlzT3JkZXJMb25MYXQ9dm9pZCAwLHQucHJvcGVydHlUeXBlcz12b2lkIDAsdH1yZXR1cm4gdChyLGUpLHJ9KHNuKSx1bj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoZSl7dGhpcy5fcG9zaXRpb249MCx0aGlzLl9wYXJzZU5hbWVzcGFjZXM9ITAsdGhpcy5fbGV0dGVyUng9L1thLXpBLVpdLyx0aGlzLl9hdHRyaWJ1dGVTdGFydFJ4PS9bYS16QS1aJyI+XS8sdGhpcy5fbmFtZVRlcm1pbmF0b3I9bmV3IFNldCgiXHJcblx0Pi89ICIpLHRoaXMuX25hbWVzcGFjZVByZWZpeFJ4PS9eeG1sbnMoOnwkKS9pLCJib29sZWFuIj09dHlwZW9mIGUmJih0aGlzLl9wYXJzZU5hbWVzcGFjZXM9ZSk7fXJldHVybiBlLnByb3RvdHlwZS5wYXJzZT1mdW5jdGlvbihlKXt0aGlzLl9wb3NpdGlvbj0wLHRoaXMuX25hbWVzcGFjZXM9e307dmFyIHQ9dGhpcy5fcGFyc2VDaGlsZHJlbihlKTtyZXR1cm4gMT09PXQubGVuZ3RoP3tuYW1lc3BhY2VzOnRoaXMuX25hbWVzcGFjZXMscm9vdDp0WzBdfTpudWxsfSxlLnByb3RvdHlwZS5fcGFyc2VDaGlsZHJlbj1mdW5jdGlvbihlKXtmb3IodmFyIHQscixuPVtdO2VbdGhpcy5fcG9zaXRpb25dOyl7aWYoIjwiPT09ZVt0aGlzLl9wb3NpdGlvbl0pe3N3aXRjaChlW3RoaXMuX3Bvc2l0aW9uKzFdKXtjYXNlIi8iOnJldHVybiB0aGlzLl9hZHZhbmNlUG9zaXRpb25Ub1N1YnN0cmluZyhlLCI+IiksbjtjYXNlIiEiOmNhc2UiPyI6c3dpdGNoKHRoaXMuX3Bvc2l0aW9uKz0yLGVbdGhpcy5fcG9zaXRpb25dKXtjYXNlIi0iOnRoaXMuX2FkdmFuY2VQb3NpdGlvblRvU3Vic3RyaW5nKGUsIi0tXHgzZSIpO2JyZWFrO2Nhc2UiWyI6dGhpcy5fcG9zaXRpb24rPTcscj10aGlzLl9wb3NpdGlvbix0aGlzLl9hZHZhbmNlUG9zaXRpb25Ub1N1YnN0cmluZyhlLCJdXT4iKSx0aGlzLl9wb3NpdGlvbj5yJiYodD1lLnN1YnN0cmluZyhyLHRoaXMuX3Bvc2l0aW9uLTIpKSYmdC50cmltKCkubGVuZ3RoPjAmJm4ucHVzaCh0KTticmVhaztkZWZhdWx0OnRoaXMuX2FkdmFuY2VQb3NpdGlvblRvU3Vic3RyaW5nKGUsIj4iKTt9dGhpcy5fcG9zaXRpb24rKztjb250aW51ZX1uLnB1c2godGhpcy5fcGFyc2VOb2RlKGUpKTt9ZWxzZSByPXRoaXMuX3Bvc2l0aW9uLHRoaXMuX3Bvc2l0aW9uPWUuaW5kZXhPZigiPCIsdGhpcy5fcG9zaXRpb24pLTEsLTI9PT10aGlzLl9wb3NpdGlvbiYmKHRoaXMuX3Bvc2l0aW9uPWUubGVuZ3RoKSwodD1lLnN1YnN0cmluZyhyLHRoaXMuX3Bvc2l0aW9uKzEpKSYmdC50cmltKCkubGVuZ3RoPjAmJm4ucHVzaCh0KTt0aGlzLl9wb3NpdGlvbisrO31yZXR1cm4gbn0sZS5wcm90b3R5cGUuX3BhcnNlTm9kZT1mdW5jdGlvbihlKXt0aGlzLl9wb3NpdGlvbisrO3ZhciB0LHI9dGhpcy5fcGFyc2VOYW1lKGUpO2lmKHRoaXMuX3BhcnNlTmFtZXNwYWNlcyYmci5pbmNsdWRlcygiOiIpKXt2YXIgbj1yLnNwbGl0KCI6Iik7Mj09PW4ubGVuZ3RoJiYodD1uWzBdLHI9blsxXSk7fXZhciBhPXthdHRyaWJ1dGVzOnRoaXMuX3BhcnNlQXR0cmlidXRlcyhlKSxuc1ByZWZpeDp0LHRhZ05hbWU6cn07aWYoIi8iIT09ZVt0aGlzLl9wb3NpdGlvbi0xXSl7dGhpcy5fcG9zaXRpb24rKzt2YXIgaT10aGlzLl9wYXJzZUNoaWxkcmVuKGUpOzE9PT1pLmxlbmd0aCYmInN0cmluZyI9PXR5cGVvZiBpWzBdP2EudmFsdWU9aVswXTphLmNoaWxkTm9kZXM9aTt9cmV0dXJuIGF9LGUucHJvdG90eXBlLl9wYXJzZUF0dHJpYnV0ZXM9ZnVuY3Rpb24oZSl7Zm9yKHZhciB0LHIsbixhLGk9bnVsbCxzPWVbdGhpcy5fcG9zaXRpb25dOyI+IiE9PXM7KXtpZih0aGlzLl9sZXR0ZXJSeC50ZXN0KHMpKXtmb3IoaXx8KGk9e30pLHQ9dGhpcy5fcGFyc2VOYW1lKGUpLHM9ZVt0aGlzLl9wb3NpdGlvbl07IXRoaXMuX2F0dHJpYnV0ZVN0YXJ0UngudGVzdChzKTspdGhpcy5fcG9zaXRpb24rKyxzPWVbdGhpcy5fcG9zaXRpb25dO2lmKCInIj09PXN8fCciJz09PXM/KGE9ZVt0aGlzLl9wb3NpdGlvbl0sbj0rK3RoaXMuX3Bvc2l0aW9uLHRoaXMuX3Bvc2l0aW9uPWUuaW5kZXhPZihhLG4pLHI9ZS5zdWJzdHJpbmcobix0aGlzLl9wb3NpdGlvbikpOihyPW51bGwsdGhpcy5fcG9zaXRpb24tLSksaVt0XT1yLHRoaXMuX3BhcnNlTmFtZXNwYWNlcyYmdGhpcy5fbmFtZXNwYWNlUHJlZml4UngudGVzdCh0KSlpZih0LmluY2x1ZGVzKCI6Iikpe3ZhciBvPXQuc3BsaXQoIjoiKTsyPT09by5sZW5ndGgmJih0aGlzLl9uYW1lc3BhY2VzW29bMV1dPXIpO31lbHNlIHRoaXMuX25hbWVzcGFjZXNbdF09cjt9dGhpcy5fcG9zaXRpb24rKyxzPWVbdGhpcy5fcG9zaXRpb25dO31yZXR1cm4gaX0sZS5wcm90b3R5cGUuX3BhcnNlTmFtZT1mdW5jdGlvbihlKXtmb3IodmFyIHQ9dGhpcy5fcG9zaXRpb247IXRoaXMuX25hbWVUZXJtaW5hdG9yLmhhcyhlW3RoaXMuX3Bvc2l0aW9uXSk7KXRoaXMuX3Bvc2l0aW9uKys7cmV0dXJuIGUuc3Vic3RyaW5nKHQsdGhpcy5fcG9zaXRpb24pfSxlLnByb3RvdHlwZS5fYWR2YW5jZVBvc2l0aW9uVG9TdWJzdHJpbmc9ZnVuY3Rpb24oZSx0KXt0aGlzLl9wb3NpdGlvbj1lLmluZGV4T2YodCx0aGlzLl9wb3NpdGlvbiktMSwtMT09PXRoaXMuX3Bvc2l0aW9uP3RoaXMuX3Bvc2l0aW9uPWUubGVuZ3RoOnRoaXMuX3Bvc2l0aW9uKz10Lmxlbmd0aDt9LGV9KCksbG49ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKCl7fXJldHVybiBlLnJlYWQ9ZnVuY3Rpb24oZSx0KXtpZighZSlyZXR1cm4gbnVsbDt0PShuZXcgb24pLm1lcmdlKHQpO3ZhciBuPShuZXcgdW4pLnBhcnNlKGUpO2lmKGVuLmRvY0hhc0RhdGEobikpe2lmKCJNdWx0aUdlb21ldHJ5Ij09PW4ucm9vdC50YWdOYW1lfHwiRmVhdHVyZUNvbGxlY3Rpb24iPT09bi5yb290LnRhZ05hbWUpcmV0dXJuIHRoaXMuX3BhcnNlRmVhdHVyZUNvbGxlY3Rpb24obi5yb290LHQpO3ZhciBhPXRoaXMuX3BhcnNlR2VvbWV0cnkobi5yb290LHQpO2lmKGEpcmV0dXJuIHIocih7fSxhLmJib3gmJntiYm94OmEuYmJveH0pLHtmZWF0dXJlczpbYV0sdHlwZToiRmVhdHVyZUNvbGxlY3Rpb24ifSl9cmV0dXJuIG51bGx9LGUucmVhZEdlb21ldHJ5PWZ1bmN0aW9uKGUsdCl7cmV0dXJuIHQ9KG5ldyBvbikubWVyZ2UodCksdGhpcy5fcGFyc2VHZW9tZXRyeShlLHQpfSxlLl9wYXJzZUdlb21ldHJ5PWZ1bmN0aW9uKGUsdCl7aWYoZSlpZigic3RyaW5nIj09dHlwZW9mIGUpe3ZhciByPShuZXcgdW4pLnBhcnNlKGUpO3N3aXRjaChyLnJvb3QudGFnTmFtZSl7Y2FzZSJQb2ludCI6Y2FzZSJMaW5lU3RyaW5nIjpjYXNlIlBvbHlnb24iOmNhc2UiTXVsdGlQb2ludCI6Y2FzZSJNdWx0aUxpbmVTdHJpbmciOmNhc2UiTXVsdGlDdXJ2ZSI6Y2FzZSJNdWx0aVN1cmZhY2UiOmNhc2UiTXVsdGlQb2x5Z29uIjpjYXNlIkZlYXR1cmUiOnJldHVybiB0PXRoaXMuX2FuYWx5emVOb2RlKHIucm9vdCx0KSx0aGlzLl9wYXJzZUdlb21ldHJ5KHIucm9vdCx0KX19ZWxzZSBzd2l0Y2godD10aGlzLl9hbmFseXplTm9kZShlLHQpLGUudGFnTmFtZSl7Y2FzZSJQb2ludCI6cmV0dXJuIHRoaXMuX3BhcnNlUG9pbnQoZSx0KTtjYXNlIkxpbmVTdHJpbmciOnJldHVybiB0aGlzLl9wYXJzZUxpbmVTdHJpbmcoZSx0KTtjYXNlIlBvbHlnb24iOnJldHVybiB0aGlzLl9wYXJzZVBvbHlnb24oZSx0KTtjYXNlIkZlYXR1cmUiOnJldHVybiB0aGlzLl9wYXJzZUZlYXR1cmUoZSx0KTtjYXNlIk11bHRpUG9pbnQiOmNhc2UiTXVsdGlMaW5lU3RyaW5nIjpjYXNlIk11bHRpQ3VydmUiOmNhc2UiTXVsdGlTdXJmYWNlIjpjYXNlIk11bHRpUG9seWdvbiI6cmV0dXJuIHRoaXMuX3BhcnNlTXVsdGlHZW9tZXRyeShlLHQpO2Nhc2Uid2hlcmUiOmNhc2UiZ2VvbWV0cnkiOmlmKGUuY2hpbGROb2Rlcy5sZW5ndGg+PTEpcmV0dXJuIHRoaXMuX3BhcnNlR2VvbWV0cnkoZS5jaGlsZE5vZGVzWzBdLHQpO2JyZWFrO2RlZmF1bHQ6aWYoZW4uZG9lc0VsZW1lbnRDb250YWluVGFnTmFtZSgiZ2VvbWV0cnkiLGUpKXJldHVybiB0aGlzLl9wYXJzZUZlYXR1cmUoZSx0KTtpZihlLmNoaWxkTm9kZXMmJjE9PT1lLmNoaWxkTm9kZXMubGVuZ3RoJiZlbi5kb2VzRWxlbWVudENvbnRhaW5UYWdOYW1lKCJnZW9tZXRyeSIsZS5jaGlsZE5vZGVzWzBdKSlyZXR1cm4gdGhpcy5fcGFyc2VGZWF0dXJlKGUuY2hpbGROb2Rlc1swXSx0KX1yZXR1cm4gbnVsbH0sZS5fcGFyc2VGZWF0dXJlQ29sbGVjdGlvbj1mdW5jdGlvbihlLHQpe3ZhciByPXRoaXM7aWYoZSlzd2l0Y2goZS50YWdOYW1lKXtjYXNlIk11bHRpR2VvbWV0cnkiOmNhc2UiRmVhdHVyZUNvbGxlY3Rpb24iOmlmKGUuY2hpbGROb2Rlcyl7dmFyIG49W10sYT1udWxsO3Q9dGhpcy5fYW5hbHl6ZU5vZGUoZSx0KTtmb3IodmFyIGk9ZnVuY3Rpb24oZSl7c3dpdGNoKGUudGFnTmFtZSl7Y2FzZSJib3VuZGVkQnkiOmE9cy5fcGFyc2VFbnZlbG9wZShlLHQpO2JyZWFrO2Nhc2UiZ2VvbWV0cnlNZW1iZXIiOmNhc2UiZmVhdHVyZU1lbWJlciI6Y2FzZSJnZW9tZXRyeU1lbWJlcnMiOmNhc2UiZmVhdHVyZU1lbWJlcnMiOmNhc2UibWVtYmVyIjp2YXIgaT1udWxsLG89e30sdT1udWxsO2UuY2hpbGROb2Rlcy5mb3JFYWNoKChmdW5jdGlvbihlKXtpZigiYm91bmRlZEJ5Ij09PWUudGFnTmFtZSl1PXIuX3BhcnNlRW52ZWxvcGUoZSx0KTtlbHNlIHt2YXIgbj1yLl90cnlQYXJzZUZlYXR1cmUoZSxvLHQpO24mJihpPW4pO319KSksaSYmKHUmJihpLmJib3g9dSksT2JqZWN0LmFzc2lnbihpLnByb3BlcnRpZXMsbyksby5pZD9pLmlkPW8uaWQ6by5maWQmJihpLmlkPW8uZmlkKSxuLnB1c2goaSkpO31pZihuLmxlbmd0aD49dC5tYXhGZWF0dXJlcylyZXR1cm4gImJyZWFrIn0scz10aGlzLG89MCx1PWUuY2hpbGROb2RlcztvPHUubGVuZ3RoO28rKyl7aWYoImJyZWFrIj09PWkodVtvXSkpYnJlYWt9aWYobi5sZW5ndGg+MCl7YXx8KGE9THIuZnJvbURhdGEobikpLG4ubGVuZ3RoPnQubWF4RmVhdHVyZXMmJihuPW4uc3BsaWNlKDAsdC5tYXhGZWF0dXJlcykpO3ZhciBsPXtiYm94OmEsZmVhdHVyZXM6bix0eXBlOiJGZWF0dXJlQ29sbGVjdGlvbiJ9LGM9e307cmV0dXJuIGVuLmFkZEF0dHJpYnV0ZXNUb09iamVjdChlLGMpLE9iamVjdC5rZXlzKGMpLmxlbmd0aD4wJiYobC5wcm9wZXJ0aWVzPWMpLGx9fX1yZXR1cm4gbnVsbH0sZS5fdHJ5UGFyc2VGZWF0dXJlPWZ1bmN0aW9uKGUsdCxyKXt2YXIgbixhPXRoaXM7c3dpdGNoKHI9dGhpcy5fYW5hbHl6ZU5vZGUoZSxyKSxlLnRhZ05hbWUpe2Nhc2UiUG9pbnQiOmNhc2UiTGluZVN0cmluZyI6Y2FzZSJQb2x5Z29uIjpjYXNlIk11bHRpUG9pbnQiOmNhc2UiTXVsdGlMaW5lU3RyaW5nIjpjYXNlIk11bHRpQ3VydmUiOmNhc2UiTXVsdGlTdXJmYWNlIjpjYXNlIk11bHRpUG9seWdvbiI6Y2FzZSJGZWF0dXJlIjpyZXR1cm4gdGhpcy5fcGFyc2VHZW9tZXRyeShlLHIpO2Nhc2UiZ2VvbWV0cnkiOnJldHVybiBlLmNoaWxkTm9kZXMuZm9yRWFjaCgoZnVuY3Rpb24oZSl7dmFyIGk9YS5fdHJ5UGFyc2VGZWF0dXJlKGUsdCxyKTtpJiYobj1pKTt9KSksbjtjYXNlImJvdW5kZWRCeSI6YnJlYWs7ZGVmYXVsdDppZihlLmF0dHJpYnV0ZXMmJk9iamVjdC5rZXlzKGUuYXR0cmlidXRlcykuZm9yRWFjaCgoZnVuY3Rpb24ocil7ImdtbDppZCI9PT1yP3QuaWQ9ZS5hdHRyaWJ1dGVzW3JdOnIuc3RhcnRzV2l0aCgieG1sbnMiKXx8ci5pbmNsdWRlcygiOiIpfHxyLnN0YXJ0c1dpdGgoIl8iKXx8KHRbcl09ZS5hdHRyaWJ1dGVzW3JdKTt9KSksZS5jaGlsZE5vZGVzJiYwIT09ZS5jaGlsZE5vZGVzLmxlbmd0aClyZXR1cm4gZS5jaGlsZE5vZGVzLmZvckVhY2goKGZ1bmN0aW9uKGUpe3ZhciBpPWEuX3RyeVBhcnNlRmVhdHVyZShlLHQscik7aSYmKG49aSk7fSkpLG47dGhpcy5fcGFyc2VNZXRhZGF0YShlLHQscik7fXJldHVybiBudWxsfSxlLl9wYXJzZUZlYXR1cmU9ZnVuY3Rpb24oZSx0KXt2YXIgcixuPXt9LGE9bnVsbDt0PXRoaXMuX2FuYWx5emVOb2RlKGUsdCk7Zm9yKHZhciBpPTAscz1lLmNoaWxkTm9kZXM7aTxzLmxlbmd0aDtpKyspe3ZhciBvPXNbaV07c3dpdGNoKG8udGFnTmFtZSl7Y2FzZSJib3VuZGVkQnkiOmE9dGhpcy5fcGFyc2VFbnZlbG9wZShvLHQpO2JyZWFrO2Nhc2UiZ2VvbWV0cnkiOnI9dGhpcy5fcGFyc2VHZW9tZXRyeShvLHQpO2JyZWFrO2RlZmF1bHQ6dGhpcy5fcGFyc2VNZXRhZGF0YShvLG4sdCk7fX1yZXR1cm4gcj8oZS5hdHRyaWJ1dGVzJiZlLmF0dHJpYnV0ZXMuaWQmJihyLmlkPWUuYXR0cmlidXRlcy5pZCksci5iYm94PWEsci5wcm9wZXJ0aWVzPU9iamVjdC5hc3NpZ24oci5wcm9wZXJ0aWVzLG4pLHIpOm51bGx9LGUuX3BhcnNlTWV0YWRhdGE9ZnVuY3Rpb24oZSx0LHIpeyFyLnBhcnNlU3R5bGVzJiZlbi5pZ25vcmVQcm9wZXJ0eShlLnRhZ05hbWUsZS52YWx1ZSl8fCh0W2UudGFnTmFtZV09ci5wcm9wZXJ0eVR5cGVzJiZyLnByb3BlcnR5VHlwZXNbZS50YWdOYW1lXT9lbi50cnlDYXN0T2JqZWN0KGUudmFsdWUsci5wcm9wZXJ0eVR5cGVzW2UudGFnTmFtZV0pOmUudmFsdWUpO30sZS5fcGFyc2VFbnZlbG9wZT1mdW5jdGlvbihlLHQpe3ZhciByLG49dGhpcyxhPWVuLmdldEVsZW1lbnRCeVRhZ05hbWUoIkVudmVsb3BlIixlKTtpZihhKXt2YXIgaSxzO2lmKHQ9dGhpcy5fYW5hbHl6ZU5vZGUoYSx0KSxhLmNoaWxkTm9kZXMuZm9yRWFjaCgoZnVuY3Rpb24oZSl7c3dpdGNoKGUudGFnTmFtZSl7Y2FzZSJsb3dlckNvcm5lciI6KHI9bi5fcGFyc2VDb29yZGluYXRlcyhlLHQpKSYmci5sZW5ndGg+MCYmKGk9clswXSk7YnJlYWs7Y2FzZSJ1cHBlckNvcm5lciI6KHI9bi5fcGFyc2VDb29yZGluYXRlcyhlLHQpKSYmci5sZW5ndGg+MCYmKHM9clswXSk7fX0pKSxpJiZzKXJldHVybiBpLmxlbmd0aD49MyYmcy5sZW5ndGg+PTM/W2lbMF0saVsxXSxpWzJdLHNbMF0sc1sxXSxzWzJdXTpbaVswXSxpWzFdLHNbMF0sc1sxXV19ZWxzZSB7dmFyIG89ZW4uZ2V0RWxlbWVudEJ5VGFnTmFtZSgiQm94IixlKTtpZihvJiZvLmNoaWxkTm9kZXMpe3Q9dGhpcy5fYW5hbHl6ZU5vZGUobyx0KTt2YXIgdT1lbi5nZXRFbGVtZW50QnlUYWdOYW1lKCJjb29yZGluYXRlcyIsbyk7aWYodSYmdS52YWx1ZSYmKHI9dGhpcy5fcGFyc2VDb29yZGluYXRlcyh1LHQpKSYmci5sZW5ndGg+PTIpcmV0dXJuIFtyWzBdWzBdLHJbMF1bMV0sclsxXVswXSxyWzFdWzFdXX19cmV0dXJuIG51bGx9LGUuX3BhcnNlUG9pbnQ9ZnVuY3Rpb24oZSx0KXtpZihlLmNoaWxkTm9kZXMpe2Zvcih2YXIgcj12b2lkIDAsbj17fSxhPTAsaT1lLmNoaWxkTm9kZXM7YTxpLmxlbmd0aDthKyspe3ZhciBzPWlbYV07c3dpdGNoKHMudGFnTmFtZSl7Y2FzZSJwb3MiOmNhc2UiY29vcmRpbmF0ZXMiOnZhciBvPXRoaXMuX3BhcnNlQ29vcmRpbmF0ZXMocyx0KTtvJiZvLmxlbmd0aD4wJiYocj1vWzBdKTticmVhaztkZWZhdWx0OnRoaXMuX3BhcnNlTWV0YWRhdGEocyxuLHQpO319aWYocilyZXR1cm4ge2dlb21ldHJ5Ontjb29yZGluYXRlczpyLHR5cGU6IlBvaW50In0scHJvcGVydGllczpuLHR5cGU6IkZlYXR1cmUifX1yZXR1cm4gbnVsbH0sZS5fcGFyc2VMaW5lU3RyaW5nPWZ1bmN0aW9uKGUsdCl7aWYoZS5jaGlsZE5vZGVzKXtmb3IodmFyIHI9dm9pZCAwLG49e30sYT0wLGk9ZS5jaGlsZE5vZGVzO2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO3N3aXRjaChzLnRhZ05hbWUpe2Nhc2UicG9zIjpjYXNlInBvc0xpc3QiOmNhc2UiY29vcmRpbmF0ZXMiOnI9dGhpcy5fcGFyc2VDb29yZGluYXRlcyhzLHQpO2JyZWFrO2RlZmF1bHQ6dGhpcy5fcGFyc2VNZXRhZGF0YShzLG4sdCk7fX1pZihyJiZyLmxlbmd0aD49MilyZXR1cm4ge2dlb21ldHJ5Ontjb29yZGluYXRlczpyLHR5cGU6IkxpbmVTdHJpbmcifSxwcm9wZXJ0aWVzOm4sdHlwZToiRmVhdHVyZSJ9fXJldHVybiBudWxsfSxlLl9wYXJzZVBvbHlnb249ZnVuY3Rpb24oZSx0KXt2YXIgcj10aGlzO2lmKGUuY2hpbGROb2Rlcyl7Zm9yKHZhciBuLGE9W10saT17fSxzPTAsbz1lLmNoaWxkTm9kZXM7czxvLmxlbmd0aDtzKyspe3ZhciB1PW9bc107c3dpdGNoKHUudGFnTmFtZSl7Y2FzZSJvdXRlckJvdW5kYXJ5SXMiOmNhc2UiaW5uZXJCb3VuZGFyeUlzIjpjYXNlImV4dGVyaW9yIjpjYXNlImludGVyaW9yIjp1LmNoaWxkTm9kZXMmJnUuY2hpbGROb2Rlcy5mb3JFYWNoKChmdW5jdGlvbihlKXsiTGluZWFyUmluZyI9PT1lLnRhZ05hbWUmJmUuY2hpbGROb2RlcyYmZS5jaGlsZE5vZGVzLmxlbmd0aD4wJiYobj1yLl9wYXJzZUNvb3JkaW5hdGVzKGUuY2hpbGROb2Rlc1swXSx0KSkubGVuZ3RoPj0zJiYoZW4uY2xvc2VSaW5nKG4pLGEucHVzaChuKSk7fSkpO2JyZWFrO2RlZmF1bHQ6dGhpcy5fcGFyc2VNZXRhZGF0YSh1LGksdCk7fX1pZihhLmxlbmd0aD49MSlyZXR1cm4ge2dlb21ldHJ5Ontjb29yZGluYXRlczphLHR5cGU6IlBvbHlnb24ifSxwcm9wZXJ0aWVzOmksdHlwZToiRmVhdHVyZSJ9fXJldHVybiBudWxsfSxlLl9wYXJzZU11bHRpR2VvbWV0cnk9ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHIsbixhPVtdLGk9e30scz0wLG89ZS5jaGlsZE5vZGVzO3M8by5sZW5ndGg7cysrKXt2YXIgdT1vW3NdO3N3aXRjaCh1LnRhZ05hbWUpe2Nhc2UicG9pbnRNZW1iZXIiOmNhc2UicG9pbnRNZW1iZXJzIjpjYXNlImxpbmVTdHJpbmdNZW1iZXIiOmNhc2UibGluZVN0cmluZ01lbWJlcnMiOmNhc2UicG9seWdvbk1lbWJlciI6Y2FzZSJwb2x5Z29uTWVtYmVycyI6Y2FzZSJjdXJ2ZU1lbWJlciI6Y2FzZSJjdXJ2ZU1lbWJlcnMiOmNhc2Uic3VyZmFjZU1lbWJlciI6Y2FzZSJzdXJmYWNlTWVtYmVycyI6Zm9yKHZhciBsPTAsYz11LmNoaWxkTm9kZXM7bDxjLmxlbmd0aDtsKyspe3ZhciBoPWNbbF07KHI9dGhpcy5fcGFyc2VHZW9tZXRyeShoLHQpKSYmYS5wdXNoKHIuZ2VvbWV0cnkpO31icmVhaztkZWZhdWx0OnRoaXMuX3BhcnNlTWV0YWRhdGEodSxpLHQpO319dmFyIGQ9W107c3dpdGNoKGUudGFnTmFtZSl7Y2FzZSJNdWx0aVBvaW50Ijpmb3IodmFyIGY9MCxwPWE7ZjxwLmxlbmd0aDtmKyspeyJQb2ludCI9PT0odj1wW2ZdKS50eXBlP2QucHVzaCh2LmNvb3JkaW5hdGVzKToiTXVsdGlQb2ludCI9PT12LnR5cGUmJihkPWQuY29uY2F0KHYuY29vcmRpbmF0ZXMpKTt9ZC5sZW5ndGg+MCYmKG49e2Nvb3JkaW5hdGVzOmQsdHlwZToiTXVsdGlQb2ludCJ9KTticmVhaztjYXNlIk11bHRpTGluZVN0cmluZyI6Y2FzZSJNdWx0aUN1cnZlIjpmb3IodmFyIG09MCxnPWE7bTxnLmxlbmd0aDttKyspeyJMaW5lU3RyaW5nIj09PSh2PWdbbV0pLnR5cGU/ZC5wdXNoKHYuY29vcmRpbmF0ZXMpOiJNdWx0aUxpbmVTdHJpbmciPT09di50eXBlJiYoZD1kLmNvbmNhdCh2LmNvb3JkaW5hdGVzKSk7fWQubGVuZ3RoPjAmJihuPXtjb29yZGluYXRlczpkLHR5cGU6Ik11bHRpTGluZVN0cmluZyJ9KTticmVhaztjYXNlIk11bHRpU3VyZmFjZSI6Y2FzZSJNdWx0aVBvbHlnb24iOmZvcih2YXIgXz0wLHk9YTtfPHkubGVuZ3RoO18rKyl7dmFyIHY7IlBvbHlnb24iPT09KHY9eVtfXSkudHlwZT9kLnB1c2godi5jb29yZGluYXRlcyk6Ik11bHRpUG9seWdvbiI9PT12LnR5cGUmJihkPWQuY29uY2F0KHYuY29vcmRpbmF0ZXMpKTt9ZC5sZW5ndGg+MCYmKG49e2Nvb3JkaW5hdGVzOmQsdHlwZToiTXVsdGlQb2x5Z29uIn0pO31yZXR1cm4gbj97Z2VvbWV0cnk6bixwcm9wZXJ0aWVzOmksdHlwZToiRmVhdHVyZSJ9Om51bGx9LGUuX2FuYWx5emVOb2RlPWZ1bmN0aW9uKGUsdCl7aWYodD10fHx7fSxlJiZlLmF0dHJpYnV0ZXMpe3ZhciByPWUuYXR0cmlidXRlcy5kaW1lbnNpb258fGUuYXR0cmlidXRlcy5zcnNEaW1lbnNpb247ciYmKHQuZGltZW5zaW9uPXIpO3ZhciBuPWUuYXR0cmlidXRlcy5zcnNOYW1lO2lmKCJib29sZWFuIiE9dHlwZW9mIHQuaXNNZXJjYXRvciYmcm4uaXNTcmlkU3VwcG9ydGVkKG4sIm1lcmNhdG9yIikmJih0LmlzTWVyY2F0b3I9ITApLCJib29sZWFuIiE9dHlwZW9mIHQuaXNBeGlzT3JkZXJMb25MYXQpaWYocm4uaXNTcmlkQXhpc0xvbkxhdChuKSl0LmlzQXhpc09yZGVyTG9uTGF0PSEwO2Vsc2UgaWYoZS5hdHRyaWJ1dGVzLnNjaGVtYUxvY2F0aW9uKXt2YXIgYT1lLmF0dHJpYnV0ZXMuc2NoZW1hTG9jYXRpb24udG9Mb3dlckNhc2UoKTsoYS5pbmNsdWRlcygic2VydmljZT13ZnMiKSYmYS5pbmNsdWRlcygidmVyc2lvbj0xLjAuMCIpfHxhLmluY2x1ZGVzKCIvd2ZzLzEuMC4wLyIpfHxybi5pc0VuZHBvaW50UmV2ZXJzZWQoYSkpJiYodC5pc0F4aXNPcmRlckxvbkxhdD0hMCk7fX1yZXR1cm4gdH0sZS5fcGFyc2VDb29yZGluYXRlcz1mdW5jdGlvbihlLHQpe3Q9dHx8e307dmFyIHI9W107aWYoZSYmdGhpcy5fY29vcmRpbmF0ZVRhZ3MuaGFzKGUudGFnTmFtZSkpe3ZhciBuPXZvaWQgMCxhPXZvaWQgMCxpPXZvaWQgMCxzPWUudmFsdWUsbz0hMSx1PXRoaXMuX2Nvb3JkaW5hdGUyUng7aWYoIjMiPT09dC5kaW1lbnNpb24mJih1PXRoaXMuX2Nvb3JkaW5hdGUzUngpLGUuYXR0cmlidXRlcyYmKCgiMyIhPT10LmRpbWVuc2lvbiYmIjMiPT09ZS5hdHRyaWJ1dGVzLmRpbWVuc2lvbnx8IjMiPT09ZS5hdHRyaWJ1dGVzLnNyc0RpbWVuc2lvbikmJih1PXRoaXMuX2Nvb3JkaW5hdGUzUngpLCJjb29yZGluYXRlcyI9PT1lLnRhZ05hbWUpKXt2YXIgbD0iLiIsYz0iLCIsaD0iICI7ZS5hdHRyaWJ1dGVzLmRlY2ltYWwmJiIuIiE9PShsPWUuYXR0cmlidXRlcy5kZWNpbWFsKSYmKHM9cy5yZXBsYWNlKG5ldyBSZWdFeHAobCwiZyIpLCJYIikpLGUuYXR0cmlidXRlcy5jcyYmIiwiIT09KGM9ZS5hdHRyaWJ1dGVzLmNzKSYmKHM9cy5yZXBsYWNlKG5ldyBSZWdFeHAoYywiZyIpLCIsIikpLGUuYXR0cmlidXRlcy50cyYmIiAiIT09KGg9ZS5hdHRyaWJ1dGVzLnRzKSYmKHM9cy5yZXBsYWNlKG5ldyBSZWdFeHAoaCwiZyIpLCIgIikpLCIuIiE9PWwmJihzPXMucmVwbGFjZSgvWC9nLCIuIikpO31mb3Iobj11LmV4ZWMocyk7bjspe2lmKG4ubGVuZ3RoPj0zJiYoYT1wYXJzZUZsb2F0KG5bMV0pLGk9cGFyc2VGbG9hdChuWzJdKSxlbi5pc1ZhbGlkTnVtYmVyKGEpJiZlbi5pc1ZhbGlkTnVtYmVyKGkpKSl7dmFyIGQ9bnVsbDtpZihuLmxlbmd0aD49NCYmKGQ9cGFyc2VGbG9hdChuWzNdKSxlbi5pc1ZhbGlkTnVtYmVyKGQpfHwoZD1udWxsKSksdC5pc01lcmNhdG9yKXt2YXIgZj1bYSxpXTt0LmlzQXhpc09yZGVyTG9uTGF0JiYoZj1baSxhXSksbnVsbCE9PWQmJmYucHVzaChkKSxyLnB1c2gocm4udG9XZ3M4NChmKSk7fWVsc2Uge2lmKCJib29sZWFuIiE9dHlwZW9mIHQuaXNBeGlzT3JkZXJMb25MYXQmJih0LmlzQXhpc09yZGVyTG9uTGF0PShhPj05MHx8YTw9LTkwKSYmaTw9OTAmJmk+PS05MCx0LmlzQXhpc09yZGVyTG9uTGF0JiZyLmxlbmd0aD4wKSl7bz0hMDticmVha310LmlzQXhpc09yZGVyTG9uTGF0P3IucHVzaChlbi5jcmVhdGVQb3NpdGlvbihhLGksZCwhMCkpOnIucHVzaChlbi5jcmVhdGVQb3NpdGlvbihpLGEsZCwhMCkpO319bj11LmV4ZWMocyk7fWlmKG8pcmV0dXJuIHRoaXMuX3BhcnNlQ29vcmRpbmF0ZXMoZSx0KX1yZXR1cm4gcn0sZS5fY29vcmRpbmF0ZTJSeD0vKC0/WzAtOV0rWy4wLTlFXSopWyxcc10rKC0/WzAtOV0rWy4wLTlFXSopW1xzXHJcblx0XSovZyxlLl9jb29yZGluYXRlM1J4PS8oLT9bMC05XStbLjAtOUVdKilbLFxzXSsoLT9bMC05XStbLjAtOUVdKilbLFxzXSsoLT9bMC05XStbLjAtOUVdKilbXHNcclxuXHRdKi9nLGUuX2Nvb3JkaW5hdGVUYWdzPW5ldyBTZXQoWyJwb3MiLCJjb29yZGluYXRlcyIsInBvc0xpc3QiLCJsb3dlckNvcm5lciIsInVwcGVyQ29ybmVyIl0pLGV9KCksY249ZnVuY3Rpb24oZSl7ZnVuY3Rpb24gcigpe3ZhciB0PW51bGwhPT1lJiZlLmFwcGx5KHRoaXMsYXJndW1lbnRzKXx8dGhpcztyZXR1cm4gdC5jYXB0dXJlUGF0aFdheXBvaW50cz0hMSx0fXJldHVybiB0KHIsZSkscn0oc24pLGhuPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIoKXt2YXIgdD1udWxsIT09ZSYmZS5hcHBseSh0aGlzLGFyZ3VtZW50cyl8fHRoaXM7cmV0dXJuIHQuaWdub3JlVmlzaWJpbGl0eT0hMCx0Lm1heE5ldHdvcmtMaW5rcz0xMCx0Lm1heE5ldHdvcmtMaW5rRGVwdGg9Myx0LmV4dHJ1ZGVQb2x5Z29ucz0hMCx0fXJldHVybiB0KHIsZSkscn0oc24pLGRuPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIoKXt2YXIgdD1udWxsIT09ZSYmZS5hcHBseSh0aGlzLGFyZ3VtZW50cyl8fHRoaXM7cmV0dXJuIHQuaGVhZGVyPXZvaWQgMCx0LmR5bmFtaWNUeXBpbmc9ITEsdC5kZWxpbWl0ZXI9ImF1dG8iLHR9cmV0dXJuIHQocixlKSxyfShhbiksZm49ZnVuY3Rpb24oKXtmb3IodmFyIGUsdCxuLGEsaT1bXSxzPTA7czxhcmd1bWVudHMubGVuZ3RoO3MrKylpW3NdPWFyZ3VtZW50c1tzXTtyZXR1cm4gcihyKHIocih7fSwoZT1uZXcgb24pLm1lcmdlLmFwcGx5KGUsaSkpLCh0PW5ldyBjbikubWVyZ2UuYXBwbHkodCxpKSksKG49bmV3IGhuKS5tZXJnZS5hcHBseShuLGkpKSwoYT1uZXcgZG4pLm1lcmdlLmFwcGx5KGEsaSkpfSxwbj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt0aGlzLl9pbWFnZXM9W10sdGhpcy5faWRMb29rdXA9e30sdGhpcy5fZmFpbGVkVXJscz1uZXcgU2V0O31yZXR1cm4gZS5wcm90b3R5cGUuYWRkSW1hZ2U9ZnVuY3Rpb24odCxyLGkscyl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciBuLG8sdTtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOnJldHVybiB0JiYodD10LnJlcGxhY2UoInJvb3Q6Ly8iLCIiKS5yZXBsYWNlKC8mYW1wOy9nLCImIikpP3RoaXMuX2ZhaWxlZFVybHMuaGFzKHQpP1syLG51bGxdOihuPXZvaWQgMCxpP1szLDZdOihyJiYobj10aGlzLmdldEltYWdlKHIpKSxuP1syLG5dOihuPXRoaXMuZ2V0SW1hZ2UodCkpP1syLG5dOnQuc3RhcnRzV2l0aCgiZGF0YToiKT9bNCxlLl90cnlMb2FkSW1hZ2UodCldOlszLDJdKSk6WzMsN107Y2FzZSAxOnJldHVybiBuPWEuc2VudCgpLFszLDZdO2Nhc2UgMjpyZXR1cm4gbz1lbi5wYXJzZVVSTCh0KSwiIj09PSh1PW8ucHJvdG9jb2wrby5ob3N0TmFtZSk/WzMsNl06ZS5fbm9Db3JzRG9tYWlucy5oYXModSk/WzMsNF06WzQsZS5fdHJ5TG9hZEltYWdlKHQpXTtjYXNlIDM6KG49YS5zZW50KCkpJiZuLm5vQ29ycyYmKGUuX25vQ29yc0RvbWFpbnMuYWRkKHUpLG49bnVsbCksYS5sYWJlbD00O2Nhc2UgNDpyZXR1cm4gIW4mJm8ucHJvdG9jb2wmJiIiIT09by5wcm90b2NvbCYmcz9bNCxlLl90cnlMb2FkSW1hZ2UodCxzKV06WzMsNl07Y2FzZSA1Om49YS5zZW50KCksYS5sYWJlbD02O2Nhc2UgNjppZihufHwobj1lLl90cnlHZXRGYWxsYmFja0NvbG9yKHQpLHImJihufHwobj1lLl90cnlHZXRGYWxsYmFja0NvbG9yKHIpKSx0aGlzLl9pZExvb2t1cFtyXT10aGlzLl9pbWFnZXMubGVuZ3RoLG4mJihuLmlkPXIpKSksbilyZXR1cm4gbi51cmwmJihyP24uaWQ9cjpyPW4udXJsKSx0aGlzLl9pZExvb2t1cFtyXT10aGlzLl9pbWFnZXMubGVuZ3RoLHIhPT1uLmlkJiYodGhpcy5faWRMb29rdXBbbi5pZF09dGhpcy5faWRMb29rdXBbcl0pLHRoaXMuX2ltYWdlcy5wdXNoKG4pLFsyLG5dO3RoaXMuX2ZhaWxlZFVybHMuYWRkKHQpLGEubGFiZWw9NztjYXNlIDc6cmV0dXJuIFsyLG51bGxdfX0pKX0pKX0sZS5wcm90b3R5cGUuZ2V0SW1hZ2U9ZnVuY3Rpb24oZSl7ZT1lLnJlcGxhY2UoInJvb3Q6Ly8iLCIiKTt2YXIgdD10aGlzLl9pZExvb2t1cFtlXTtyZXR1cm4gdD49MD90aGlzLl9pbWFnZXNbdF06bnVsbH0sZS5wcm90b3R5cGUuZ2V0SWNvbnM9ZnVuY3Rpb24oKXt2YXIgZT17fTtyZXR1cm4gdGhpcy5faW1hZ2VzLmZvckVhY2goKGZ1bmN0aW9uKHQpe3QuaXNJY29uJiZ0LnVybCYmKGVbdC5pZF09dC51cmwpO30pKSxlfSxlLnByb3RvdHlwZS5nZXRBbGxJbWFnZXM9ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5faW1hZ2VzfSxlLnByb3RvdHlwZS5pc0NvcnNFbmFibGVkRG9tYWluPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgdCxyO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKG4pe3N3aXRjaChuLmxhYmVsKXtjYXNlIDA6aWYoIWVuLmlzVmFsaWRTdHJpbmcoZSkpcmV0dXJuIFszLDhdO24ubGFiZWw9MTtjYXNlIDE6aWYobi50cnlzLnB1c2goWzEsNywsOF0pLHQ9ZW4ucGFyc2VVUkwoZSksIiI9PT0ocj10LnByb3RvY29sK3QuaG9zdE5hbWUpfHx0aGlzLl9mYWlsZWRVcmxzLmhhcyhyKSlyZXR1cm4gWzMsNl07bi5sYWJlbD0yO2Nhc2UgMjpyZXR1cm4gbi50cnlzLnB1c2goWzIsNCwsNV0pLFs0LGVuLmFqYXhHZXRBc3luYyhlLG51bGwsbnVsbCwhMCwiaW1hZ2UiKV07Y2FzZSAzOnJldHVybiBuLnNlbnQoKT9bMiwhMF06WzMsNV07Y2FzZSA0OnJldHVybiBuLnNlbnQoKSxbMyw1XTtjYXNlIDU6dGhpcy5fZmFpbGVkVXJscy5hZGQociksbi5sYWJlbD02O2Nhc2UgNjpyZXR1cm4gWzMsOF07Y2FzZSA3OnJldHVybiBuLnNlbnQoKSxbMyw4XTtjYXNlIDg6cmV0dXJuIFsyLCExXX19KSl9KSl9LGUuX3RyeUxvYWRJbWFnZT1mdW5jdGlvbihlLHQpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgcixuLGkscyxvLHU7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDpyZXR1cm4gYS50cnlzLnB1c2goWzAsOCwsOV0pLHI9e2lkOmUsdXJsOnQ/dCtlbmNvZGVVUklDb21wb25lbnQoZSk6ZX0sWzQsZW4uYWpheEdldEFzeW5jKGUsdCxudWxsLCEwLCJpbWFnZSIpXTtjYXNlIDE6aWYoISgobj1hLnNlbnQoKSlpbnN0YW5jZW9mIEFycmF5QnVmZmVyJiZjcmVhdGVJbWFnZUJpdG1hcCkpcmV0dXJuIFszLDZdO2EubGFiZWw9MjtjYXNlIDI6cmV0dXJuIGEudHJ5cy5wdXNoKFsyLDQsLDVdKSwoaT1lbi5hcnJheUJ1ZmZlclRvU3RyaW5nKG4sMTApLnRvTG93ZXJDYXNlKCkpLnN0YXJ0c1dpdGgoInBuZyIpP3IudHlwZT0iUE5HIjppLnN0YXJ0c1dpdGgoImpwZyIpfHxpLnN0YXJ0c1dpdGgoImpwZWciKT9yLnR5cGU9IkpQRyI6aS5zdGFydHNXaXRoKCJibXAiKT9yLnR5cGU9IkJNUCI6aS5zdGFydHNXaXRoKCJnaWYiKSYmKHIudHlwZT0iR0lGIiksWzQsY3JlYXRlSW1hZ2VCaXRtYXAobmV3IEJsb2IoW25dKSldO2Nhc2UgMzpyZXR1cm4gcz1hLnNlbnQoKSxyLmhlaWdodD1zLmhlaWdodCxyLndpZHRoPXMud2lkdGgsWzMsNV07Y2FzZSA0OnJldHVybiBhLnNlbnQoKSxbMyw1XTtjYXNlIDU6cmV0dXJuIFszLDddO2Nhc2UgNjpyZXR1cm4gWzIsbnVsbF07Y2FzZSA3OnJldHVybiBbMixyXTtjYXNlIDg6cmV0dXJuIG89YS5zZW50KCksdT12b2lkIDAsInN0cmluZyI9PXR5cGVvZiBvP3U9bzpvIGluc3RhbmNlb2YgRXJyb3ImJih1PW8ubWVzc2FnZSksdSYmdS5pbmNsdWRlcygiQ09ScyIpP1syLHtub0NvcnM6ITB9XTpbMixudWxsXTtjYXNlIDk6cmV0dXJuIFsyXX19KSl9KSl9LGUuX3RyeUdldEZhbGxiYWNrQ29sb3I9ZnVuY3Rpb24oZSl7aWYoZSl7dmFyIHQ9ZW4ucGFyc2VVUkwoZSk7aWYodC5maWxlTmFtZSl7dmFyIHI9dC5maWxlTmFtZS50b0xvd2VyQ2FzZSgpO3IuaW5kZXhPZigiLiIpPjAmJihyPXIuc3Vic3RyKDAsci5sYXN0SW5kZXhPZigiLiIpKSk7dmFyIG49ZW4uY3NzQ29sb3JOYW1lc1tyXTtpZighbil7dmFyIGE9ci5pbmRleE9mKCItIiksaT0xO2lmKC0xPT09YSYmKGE9ci5pbmRleE9mKCIsICIpLGk9MiksYT4tMSYmYTxyLmxlbmd0aC1pKXt2YXIgcz1yLnN1YnN0cigwLGEpLG89ci5zdWJzdHIoYStpKTsobj1lbi5jc3NDb2xvck5hbWVzW3NdKXx8KG49ZW4uY3NzQ29sb3JOYW1lc1tvXSk7fX1pZihuKXJldHVybiB7Y29sb3I6bn19fXJldHVybiBudWxsfSxlLl9ub0NvcnNEb21haW5zPW5ldyBTZXQsZX0oKSxtbj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoZSx0KXt0aGlzLl9udW1OZXR3b3JrTGlua3M9MCx0JiYodGhpcy5fYmFzZVVybD10KSx0aGlzLl9pbWFnZU1hbmFnZXI9bmV3IHBuLHRoaXMuX29wdGlvbnM9Zm4oZSk7fXJldHVybiBlLl9nZXRFbnJpY2hlZERhdGFTZXQ9ZnVuY3Rpb24odCxyLGkpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgbixzLG8sdSxsO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6KG49bmV3IGUoaSkpLl9pbml0UmVhZCh0KSxuLl9hZGRGZWF0dXJlcyhyKSxzPTAsbz1yLGEubGFiZWw9MTtjYXNlIDE6cmV0dXJuIHM8by5sZW5ndGg/ISh1PW9bc10pLmdlb21ldHJ5fHwiUG9pbnQiIT09dS5nZW9tZXRyeS50eXBlJiYiTXVsdGlQb2ludCIhPT11Lmdlb21ldHJ5LnR5cGU/WzMsNl06KGw9dm9pZCAwLHUucHJvcGVydGllcy5pbWFnZVVybD9bNCxuLl9pbWFnZU1hbmFnZXIuYWRkSW1hZ2UodS5wcm9wZXJ0aWVzLmltYWdlVXJsLHUucHJvcGVydGllcy5pbWFnZSxudWxsLGkucHJveHlTZXJ2aWNlKV06WzMsM10pOlszLDddO2Nhc2UgMjpyZXR1cm4gbD1hLnNlbnQoKSxbMyw1XTtjYXNlIDM6cmV0dXJuIHUucHJvcGVydGllcy5pY29uP1s0LG4uX2ltYWdlTWFuYWdlci5hZGRJbWFnZSh1LnByb3BlcnRpZXMuaWNvbix1LnByb3BlcnRpZXMuaW1hZ2UsbnVsbCxpLnByb3h5U2VydmljZSldOlszLDVdO2Nhc2UgNDpsPWEuc2VudCgpLGEubGFiZWw9NTtjYXNlIDU6bCYmKGwudXJsfHxsLmNvbG9yKT8obC5pc0ljb249ITAsbC51cmw/KHUucHJvcGVydGllcy5pbWFnZT1sLmlkLHUucHJvcGVydGllcy5pbWFnZVVybD1sLnVybCk6dS5wcm9wZXJ0aWVzLmNvbG9yPWwuY29sb3IpOih1LnByb3BlcnRpZXMuaW1hZ2U9dm9pZCAwLHUucHJvcGVydGllcy5pbWFnZVVybD12b2lkIDApLGEubGFiZWw9NjtjYXNlIDY6cmV0dXJuIHMrKyxbMywxXTtjYXNlIDc6cmV0dXJuIG4uX2NvbXBsZXRlUmVhZCgpLFsyLG4uX2dldFBhcnNlZERhdGFTZXQoKV19fSkpfSkpfSxlLnByb3RvdHlwZS5faW5pdFJlYWQ9ZnVuY3Rpb24oZSl7aWYoIWUpdGhyb3cgbmV3IEVycm9yKCJObyBYTUwgZGF0YSB3YXMgcGFzc2VkIGluIHRvIHJlYWQuIik7dGhpcy5fcGFyc2VkRGF0YT1uZXcgdG4sdGhpcy5fbnVtQ2hhcmFjdGVycz1lP2UubGVuZ3RoOjA7fSxlLnByb3RvdHlwZS5fY29tcGxldGVSZWFkPWZ1bmN0aW9uKCl7dmFyIGU9dGhpcy5faW1hZ2VNYW5hZ2VyLmdldEljb25zKCk7dGhpcy5fcGFyc2VkRGF0YS5pY29ucz90aGlzLl9wYXJzZWREYXRhLmljb25zPU9iamVjdC5hc3NpZ24odGhpcy5fcGFyc2VkRGF0YS5pY29ucyxlKTp0aGlzLl9wYXJzZWREYXRhLmljb25zPWUsdG4uZW5yaWNoKHRoaXMuX3BhcnNlZERhdGEpLHRoaXMuX2hhc1RpbWVzdGFtcCYmdGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcyYmdGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5sZW5ndGg+MCYmdGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5zb3J0KHRoaXMuX2ZlYXR1cmVUaW1lc3RhbXBTb3J0ZXIpLE9iamVjdC5hc3NpZ24odGhpcy5fcGFyc2VkRGF0YS5zdGF0cyx7bnVtQ2hhcmFjdGVyczp0aGlzLl9udW1DaGFyYWN0ZXJzLG51bU5ldHdvcmtMaW5rczp0aGlzLl9udW1OZXR3b3JrTGlua3N9KTt9LGUucHJvdG90eXBlLl9hZGRGZWF0dXJlcz1mdW5jdGlvbihlKXswPT09dGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5sZW5ndGg/dGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcz1lOnRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXM9dGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5jb25jYXQoZSk7fSxlLnByb3RvdHlwZS5fZ2V0UGFyc2VkRGF0YVNldD1mdW5jdGlvbigpe3JldHVybiB0aGlzLl9wYXJzZWREYXRhfSxlLnByb3RvdHlwZS5fZmVhdHVyZVRpbWVzdGFtcFNvcnRlcj1mdW5jdGlvbihlLHQpe3JldHVybiAoZS5wcm9wZXJ0aWVzLl90aW1lc3RhbXA/ZS5wcm9wZXJ0aWVzLl90aW1lc3RhbXA6MCktKHQucHJvcGVydGllcy5fdGltZXN0YW1wP3QucHJvcGVydGllcy5fdGltZXN0YW1wOjApfSxlfSgpLGduPWZ1bmN0aW9uKCl7ZnVuY3Rpb24gZSgpe31yZXR1cm4gZS5yZWFkPWZ1bmN0aW9uKGUsdCl7dmFyIHI9W107dHx8KHQ9WzAsMF0pO3ZhciBuPShuZXcgdW4pLnBhcnNlKGUpO2lmKGVuLmRvY0hhc0RhdGEobikmJiJGZWF0dXJlSW5mb1Jlc3BvbnNlIj09PW4ucm9vdC50YWdOYW1lKWZvcih2YXIgYT0wLGk9bi5yb290LmNoaWxkTm9kZXM7YTxpLmxlbmd0aDthKyspe3ZhciBzPWlbYV07c3dpdGNoKHMudGFnTmFtZS50b0xvd2VyQ2FzZSgpKXtjYXNlImZpZWxkcyI6ci5wdXNoKHtnZW9tZXRyeTp7Y29vcmRpbmF0ZXM6dCx0eXBlOiJQb2ludCJ9LHByb3BlcnRpZXM6bi5yb290LmNoaWxkTm9kZXNbMF0uYXR0cmlidXRlc3x8e30sdHlwZToiRmVhdHVyZSJ9KTticmVhaztjYXNlImZlYXR1cmVpbmZvY29sbGVjdGlvbiI6dmFyIG89cy5hdHRyaWJ1dGVzLmxheWVybmFtZTtpZihzLmNoaWxkTm9kZXMmJnMuY2hpbGROb2Rlcy5sZW5ndGg+MCYmIkZlYXR1cmVJbmZvIj09PXMuY2hpbGROb2Rlc1swXS50YWdOYW1lKXt2YXIgdT10aGlzLl9wYXJzZUZlYXR1cmVJbmZvKG8scy5jaGlsZE5vZGVzWzBdLHQpO3UmJnIucHVzaCh1KTt9fX1yZXR1cm4ge2ZlYXR1cmVzOnIsdHlwZToiRmVhdHVyZUNvbGxlY3Rpb24ifX0sZS5fcGFyc2VGZWF0dXJlSW5mbz1mdW5jdGlvbihlLHQscil7aWYodCl7Zm9yKHZhciBuPXt9LGE9dm9pZCAwLGk9MCxzPXQuY2hpbGROb2RlcztpPHMubGVuZ3RoO2krKyl7dmFyIG89c1tpXTtpZigiRmllbGQiPT09by50YWdOYW1lKXtmb3IodmFyIHU9dm9pZCAwLGw9dm9pZCAwLGM9dm9pZCAwLGg9MCxkPW8uY2hpbGROb2RlcztoPGQubGVuZ3RoO2grKyl7dmFyIGY9ZFtoXTtzd2l0Y2goZi50YWdOYW1lKXtjYXNlIkZpZWxkTmFtZSI6bD1mLnZhbHVlO2JyZWFrO2Nhc2UiRmllbGRWYWx1ZSI6Yz1mLnZhbHVlO2JyZWFrO2Nhc2UiRmllbGRHZW9tZXRyeSI6dT10aGlzLl9wYXJzZUdlb21ldHJ5KGYpO319dT9hPXU6bCYmYyYmKG5bbF09Yyk7fX1pZihPYmplY3Qua2V5cyhuKS5sZW5ndGg+MHx8YSlyZXR1cm4ge2dlb21ldHJ5OmF8fHtjb29yZGluYXRlczpyLHR5cGU6IlBvaW50In0sbGF5ZXJOYW1lOmUscHJvcGVydGllczpuLHR5cGU6IkZlYXR1cmUifX1yZXR1cm4gbnVsbH0sZS5fcGFyc2VHZW9tZXRyeT1mdW5jdGlvbihlKXt2YXIgdD10aGlzO2lmKGUmJmUuY2hpbGROb2Rlcy5sZW5ndGg+MCl7Zm9yKHZhciByPXZvaWQgMCxuPVtdLGE9ZnVuY3Rpb24oZSl7aWYocnx8KHI9ZS50YWdOYW1lKSxyPT09ZS50YWdOYW1lfHwiUG9pbnQiPT09ciYmIk11bHRpcG9pbnQiPT09ZS50YWdOYW1lKXN3aXRjaChlLnRhZ05hbWUpe2Nhc2UiUG9pbnQiOnZhciBhPWkuX3BhcnNlUG9zaXRpb24oZSk7YSYmbi5wdXNoKHt0eXBlOiJQb2ludCIsY29vcmRpbmF0ZXM6YX0pO2JyZWFrO2Nhc2UiTXVsdGlwb2ludCI6cj0iUG9pbnQiO3ZhciBzPWkuX3BhcnNlUG9zaXRpb25zKGUpO3MubGVuZ3RoPjAmJnMuZm9yRWFjaCgoZnVuY3Rpb24oZSl7bi5wdXNoKHt0eXBlOiJQb2ludCIsY29vcmRpbmF0ZXM6ZX0pO30pKTticmVhaztjYXNlIlBvbHlsaW5lIjplLmNoaWxkTm9kZXMuZm9yRWFjaCgoZnVuY3Rpb24oZSl7aWYoIlBhdGgiPT09ZS50YWdOYW1lKXt2YXIgcj10Ll9wYXJzZVBvc2l0aW9ucyhlKTtyLmxlbmd0aD4wJiZuLnB1c2goe3R5cGU6IkxpbmVTdHJpbmciLGNvb3JkaW5hdGVzOnJ9KTt9fSkpO2JyZWFrO2Nhc2UiUG9seWdvbiI6dmFyIG89W107ZS5jaGlsZE5vZGVzLmZvckVhY2goKGZ1bmN0aW9uKGUpe2lmKCJSaW5nIj09PWUudGFnTmFtZSl7dmFyIHI9dC5fcGFyc2VQb3NpdGlvbnMoZSk7ci5sZW5ndGg+MCYmby5wdXNoKHIpO319KSksby5sZW5ndGg+MCYmbi5wdXNoKHt0eXBlOiJQb2x5Z29uIixjb29yZGluYXRlczpvfSk7fX0saT10aGlzLHM9MCxvPWUuY2hpbGROb2RlcztzPG8ubGVuZ3RoO3MrKyl7YShvW3NdKTt9aWYobi5sZW5ndGg+MCl7aWYoMT09PW4ubGVuZ3RoKXJldHVybiBuWzBdO2Zvcih2YXIgdT1bXSxsPTAsYz1uO2w8Yy5sZW5ndGg7bCsrKXt2YXIgaD1jW2xdO3UucHVzaChoLmNvb3JkaW5hdGVzKTt9c3dpdGNoKHIpe2Nhc2UiUG9pbnQiOnJldHVybiB7dHlwZToiTXVsdGlQb2ludCIsY29vcmRpbmF0ZXM6dX07Y2FzZSJQb2x5bGluZSI6cmV0dXJuIHt0eXBlOiJNdWx0aUxpbmVTdHJpbmciLGNvb3JkaW5hdGVzOnV9O2Nhc2UiUG9seWdvbiI6cmV0dXJuIHt0eXBlOiJNdWx0aVBvbHlnb24iLGNvb3JkaW5hdGVzOnV9fX19cmV0dXJuIG51bGx9LGUuX3BhcnNlUG9zaXRpb249ZnVuY3Rpb24oZSl7aWYoZSYmZS52YWx1ZSl7dmFyIHQ9ZS52YWx1ZS5zcGxpdCgiLCIpO2lmKHQubGVuZ3RoPj0yKXt2YXIgcj1wYXJzZUZsb2F0KHRbMF0pLG49cGFyc2VGbG9hdCh0WzFdKSxhPXZvaWQgMDt0Lmxlbmd0aD49MyYmKGE9cGFyc2VGbG9hdCh0WzJdKSksZW4uY3JlYXRlUG9zaXRpb24ocixuLGEpO319cmV0dXJuIG51bGx9LGUuX3BhcnNlUG9zaXRpb25zPWZ1bmN0aW9uKGUpe2lmKGUpe2Zvcih2YXIgdD1bXSxyPTAsbj1lLmNoaWxkTm9kZXM7cjxuLmxlbmd0aDtyKyspe3ZhciBhPW5bcl0saT10aGlzLl9wYXJzZVBvc2l0aW9uKGEpO2kmJnQucHVzaChpKTt9cmV0dXJuIHR9cmV0dXJuIG51bGx9LGV9KCk7dmFyIF9uPWZ1bmN0aW9uKGUsdCxyKXsodm9pZCAwPT09cnx8YyhlW3RdLHIpKSYmKHZvaWQgMCE9PXJ8fHQgaW4gZSl8fFNlKGUsdCxyKTt9O3ZhciB5bj1mdW5jdGlvbihlKXtyZXR1cm4gZnVuY3Rpb24odCxyLG4pe2Zvcih2YXIgYT0tMSxpPU9iamVjdCh0KSxzPW4odCksbz1zLmxlbmd0aDtvLS07KXt2YXIgdT1zW2U/bzorK2FdO2lmKCExPT09cihpW3VdLHUsaSkpYnJlYWt9cmV0dXJuIHR9fSgpO3ZhciB2bj1mdW5jdGlvbihlKXtyZXR1cm4gT2UoZSkmJnR0KGUpfSxibj1GdW5jdGlvbi5wcm90b3R5cGUsd249T2JqZWN0LnByb3RvdHlwZSxrbj1ibi50b1N0cmluZyxObj13bi5oYXNPd25Qcm9wZXJ0eSxTbj1rbi5jYWxsKE9iamVjdCk7dmFyIHhuPWZ1bmN0aW9uKGUpe2lmKCFPZShlKXx8IltvYmplY3QgT2JqZWN0XSIhPVIoZSkpcmV0dXJuICExO3ZhciB0PXl0KGUpO2lmKG51bGw9PT10KXJldHVybiAhMDt2YXIgcj1Obi5jYWxsKHQsImNvbnN0cnVjdG9yIikmJnQuY29uc3RydWN0b3I7cmV0dXJuICJmdW5jdGlvbiI9PXR5cGVvZiByJiZyIGluc3RhbmNlb2YgciYma24uY2FsbChyKT09U259O3ZhciBDbj1mdW5jdGlvbihlLHQpe2lmKCgiY29uc3RydWN0b3IiIT09dHx8ImZ1bmN0aW9uIiE9dHlwZW9mIGVbdF0pJiYiX19wcm90b19fIiE9dClyZXR1cm4gZVt0XX07dmFyIFBuPWZ1bmN0aW9uKGUpe3JldHVybiBQZShlLG90KGUpKX07dmFyIEVuPWZ1bmN0aW9uKGUsdCxyLG4sYSxpLHMpe3ZhciBvPUNuKGUsciksdT1Dbih0LHIpLGw9cy5nZXQodSk7aWYobClfbihlLHIsbCk7ZWxzZSB7dmFyIGM9aT9pKG8sdSxyKyIiLGUsdCxzKTp2b2lkIDAsaD12b2lkIDA9PT1jO2lmKGgpe3ZhciBkPVJlKHUpLGY9IWQmJmplKHUpLHA9IWQmJiFmJiZIZSh1KTtjPXUsZHx8Znx8cD9SZShvKT9jPW86dm4obyk/Yz1jdChvKTpmPyhoPSExLGM9bHQodSwhMCkpOnA/KGg9ITEsYz1WdCh1LCEwKSk6Yz1bXTp4bih1KXx8SWUodSk/KGM9byxJZShvKT9jPVBuKG8pOkYobykmJiFEKG8pfHwoYz1YdCh1KSkpOmg9ITE7fWgmJihzLnNldCh1LGMpLGEoYyx1LG4saSxzKSxzLmRlbGV0ZSh1KSksX24oZSxyLGMpO319O3ZhciBPbj1mdW5jdGlvbiBlKHQscixuLGEsaSl7dCE9PXImJnluKHIsKGZ1bmN0aW9uKHMsbyl7aWYoaXx8KGk9bmV3IHdlKSxGKHMpKUVuKHQscixvLG4sZSxhLGkpO2Vsc2Uge3ZhciB1PWE/YShDbih0LG8pLHMsbysiIix0LHIsaSk6dm9pZCAwO3ZvaWQgMD09PXUmJih1PXMpLF9uKHQsbyx1KTt9fSksb3QpO307dmFyIEFuPWZ1bmN0aW9uKGUpe3JldHVybiBlfTt2YXIgTW49ZnVuY3Rpb24oZSx0LHIpe3N3aXRjaChyLmxlbmd0aCl7Y2FzZSAwOnJldHVybiBlLmNhbGwodCk7Y2FzZSAxOnJldHVybiBlLmNhbGwodCxyWzBdKTtjYXNlIDI6cmV0dXJuIGUuY2FsbCh0LHJbMF0sclsxXSk7Y2FzZSAzOnJldHVybiBlLmNhbGwodCxyWzBdLHJbMV0sclsyXSl9cmV0dXJuIGUuYXBwbHkodCxyKX0sTG49TWF0aC5tYXg7dmFyIHpuPWZ1bmN0aW9uKGUsdCxyKXtyZXR1cm4gdD1Mbih2b2lkIDA9PT10P2UubGVuZ3RoLTE6dCwwKSxmdW5jdGlvbigpe2Zvcih2YXIgbj1hcmd1bWVudHMsYT0tMSxpPUxuKG4ubGVuZ3RoLXQsMCkscz1BcnJheShpKTsrK2E8aTspc1thXT1uW3QrYV07YT0tMTtmb3IodmFyIG89QXJyYXkodCsxKTsrK2E8dDspb1thXT1uW2FdO3JldHVybiBvW3RdPXIocyksTW4oZSx0aGlzLG8pfX07dmFyIEluPWZ1bmN0aW9uKGUpe3JldHVybiBmdW5jdGlvbigpe3JldHVybiBlfX0sUm49TmU/ZnVuY3Rpb24oZSx0KXtyZXR1cm4gTmUoZSwidG9TdHJpbmciLHtjb25maWd1cmFibGU6ITAsZW51bWVyYWJsZTohMSx2YWx1ZTpJbih0KSx3cml0YWJsZTohMH0pfTpBbixGbj1EYXRlLm5vdzt2YXIgam49ZnVuY3Rpb24oZSl7dmFyIHQ9MCxyPTA7cmV0dXJuIGZ1bmN0aW9uKCl7dmFyIG49Rm4oKSxhPTE2LShuLXIpO2lmKHI9bixhPjApe2lmKCsrdD49ODAwKXJldHVybiBhcmd1bWVudHNbMF19ZWxzZSB0PTA7cmV0dXJuIGUuYXBwbHkodm9pZCAwLGFyZ3VtZW50cyl9fShSbik7dmFyIERuPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIGpuKHpuKGUsdCxBbiksZSsiIil9O3ZhciBUbj1mdW5jdGlvbihlLHQscil7aWYoIUYocikpcmV0dXJuICExO3ZhciBuPXR5cGVvZiB0O3JldHVybiAhISgibnVtYmVyIj09bj90dChyKSYmVGUodCxyLmxlbmd0aCk6InN0cmluZyI9PW4mJnQgaW4gcikmJmMoclt0XSxlKX07dmFyIEJuPWZ1bmN0aW9uKGUpe3JldHVybiBEbigoZnVuY3Rpb24odCxyKXt2YXIgbj0tMSxhPXIubGVuZ3RoLGk9YT4xP3JbYS0xXTp2b2lkIDAscz1hPjI/clsyXTp2b2lkIDA7Zm9yKGk9ZS5sZW5ndGg+MyYmImZ1bmN0aW9uIj09dHlwZW9mIGk/KGEtLSxpKTp2b2lkIDAscyYmVG4oclswXSxyWzFdLHMpJiYoaT1hPDM/dm9pZCAwOmksYT0xKSx0PU9iamVjdCh0KTsrK248YTspe3ZhciBvPXJbbl07byYmZSh0LG8sbixpKTt9cmV0dXJuIHR9KSl9KChmdW5jdGlvbihlLHQscil7T24oZSx0LHIpO30pKSxVbj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt9cmV0dXJuIGUucmVhZENvbnRlbnQ9ZnVuY3Rpb24oZSl7dmFyIHQ9ZS52YWx1ZTtpZihlLmF0dHJpYnV0ZXMmJmUuYXR0cmlidXRlcy50eXBlKXN3aXRjaChlLmF0dHJpYnV0ZXMudHlwZSl7Y2FzZSJodG1sIjpjYXNlInhodG1sIjpyZXR1cm4gZS52YWx1ZX1yZXR1cm4gdH0sZS53cml0ZUF1dGhvcj1mdW5jdGlvbihlLHQscil7aWYoZSl7dmFyIG49IiI7aWYociYmKG49ImF0b206IiksQXJyYXkuaXNBcnJheShlKSlmb3IodmFyIGE9MCxpPWU7YTxpLmxlbmd0aDthKyspe3ZhciBzPWlbYV07dGhpcy53cml0ZUF1dGhvcihzLHQscik7fWVsc2UgZW4uaXNWYWxpZFN0cmluZyhlKT90LndyaXRlU3RhcnRFbGVtZW50KG4rImF1dGhvciIpLndyaXRlRWxlbWVudChuKyJuYW1lIixlKS53cml0ZUVuZEVsZW1lbnQoKToodC53cml0ZVN0YXJ0RWxlbWVudChuKyJhdXRob3IiKSxlLm5hbWUmJnQud3JpdGVFbGVtZW50KG4rIm5hbWUiLGUubmFtZSksZS51cmkmJnQud3JpdGVFbGVtZW50KG4rInVyaSIsZS51cmkpLGUuZW1haWwmJnQud3JpdGVFbGVtZW50KG4rImVtYWlsIixlLmVtYWlsKSx0LndyaXRlRW5kRWxlbWVudCgpKTt9fSxlLndyaXRlQ2F0ZWdvcnk9ZnVuY3Rpb24oZSx0LHIpe2lmKGUpe3ZhciBuPSIiO2lmKHImJihuPSJhdG9tOiIpLEFycmF5LmlzQXJyYXkoZSkpZm9yKHZhciBhPTAsaT1lO2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO3RoaXMud3JpdGVDYXRlZ29yeShzLHQscik7fWVsc2UgZW4uaXNWYWxpZFN0cmluZyhlKT90LndyaXRlU3RhcnRFbGVtZW50KG4rImNhdGVnb3J5Iix7dGVybTplfSwhMCk6ZW4uaXNWYWxpZFN0cmluZyhlLnRlcm0pJiZ0LndyaXRlU3RhcnRFbGVtZW50KG4rImNhdGVnb3J5IixlLCEwKTt9fSxlLndyaXRlQ29udHJpYnV0b3I9ZnVuY3Rpb24oZSx0LHIpe2lmKGUpe3ZhciBuPSIiO2lmKHImJihuPSJhdG9tOiIpLEFycmF5LmlzQXJyYXkoZSkpZm9yKHZhciBhPTAsaT1lO2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO3RoaXMud3JpdGVDb250cmlidXRvcihzLHQscik7fWVsc2UgZW4uaXNWYWxpZFN0cmluZyhlKT90LndyaXRlU3RhcnRFbGVtZW50KG4rImNvbnRyaWJ1dG9yIikud3JpdGVFbGVtZW50KG4rIm5hbWUiLGUpLndyaXRlRW5kRWxlbWVudCgpOih0LndyaXRlU3RhcnRFbGVtZW50KG4rImNvbnRyaWJ1dG9yIiksZS5uYW1lJiZ0LndyaXRlRWxlbWVudChuKyJuYW1lIixlLm5hbWUpLGUudXJpJiZ0LndyaXRlRWxlbWVudChuKyJ1cmkiLGUudXJpKSxlLmVtYWlsJiZ0LndyaXRlRWxlbWVudChuKyJlbWFpbCIsZS5lbWFpbCksdC53cml0ZUVuZEVsZW1lbnQoKSk7fX0sZS53cml0ZUxpbms9ZnVuY3Rpb24oZSx0LHIpe2lmKGUpe3ZhciBuPSIiO2lmKHImJihuPSJhdG9tOiIpLEFycmF5LmlzQXJyYXkoZSkpZm9yKHZhciBhPTAsaT1lO2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO3RoaXMud3JpdGVMaW5rKHMsdCxyKTt9ZWxzZSBlbi5pc1ZhbGlkU3RyaW5nKGUpP3Qud3JpdGVTdGFydEVsZW1lbnQobisibGluayIse2hyZWY6ZX0sITApOmVuLmlzVmFsaWRTdHJpbmcoZS5ocmVmKSYmdC53cml0ZVN0YXJ0RWxlbWVudChuKyJsaW5rIixlLCEwKTt9fSxlfSgpLFduPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIodCl7dmFyIHI9ZS5jYWxsKHRoaXMsdCxudWxsKXx8dGhpcztyZXR1cm4gci5fY29vcmRpbmF0ZVJ4PS8oLT9bMC05XStbLjAtOUVdKilbXHNcclxuXHRdKygtP1swLTldK1suMC05RV0qKVtcc1xyXG5cdF0qL2csci5fY2lyY2xlUng9LygtP1swLTldK1suMC05RV0qKVtcc1xyXG5cdF0rKC0/WzAtOV0rWy4wLTlFXSopW1xzXHJcblx0XSsoLT9bMC05XStbLjAtOUVdKikqL2cscn1yZXR1cm4gdChyLGUpLHIucHJvdG90eXBlLnJlYWQ9ZnVuY3Rpb24odCl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciByO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKG4pe3N3aXRjaChuLmxhYmVsKXtjYXNlIDA6cmV0dXJuIGUucHJvdG90eXBlLl9pbml0UmVhZC5jYWxsKHRoaXMsdCkscj0obmV3IHVuKS5wYXJzZSh0KSxlbi5kb2NIYXNEYXRhKHIpPyh0aGlzLl9uYW1lc3BhY2VzPXIubmFtZXNwYWNlcywiZmVlZCIhPT1yLnJvb3QudGFnTmFtZT9bMywyXTpbNCx0aGlzLl9wYXJzZUdlb1Jzc0RvYyhyLnJvb3QpXSk6WzMsNF07Y2FzZSAxOnJldHVybiBbMixuLnNlbnQoKV07Y2FzZSAyOnJldHVybiAicnNzIiE9PXIucm9vdC50YWdOYW1lfHwiY2hhbm5lbCIhPT1yLnJvb3QuY2hpbGROb2Rlc1swXS50YWdOYW1lP1szLDRdOls0LHRoaXMuX3BhcnNlR2VvUnNzRG9jKHIucm9vdC5jaGlsZE5vZGVzWzBdKV07Y2FzZSAzOnJldHVybiBbMixuLnNlbnQoKV07Y2FzZSA0OnRocm93IG5ldyBFcnJvcigiVW5hYmxlIHRvIHJlYWQgR2VvUlNTIGRvY3VtZW50LiIpfX0pKX0pKX0sci5wcm90b3R5cGUuX3BhcnNlR2VvUnNzRG9jPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgdCxyLG4saSxzO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6aWYoIWUuY2hpbGROb2RlcylyZXR1cm4gWzMsN107dD0wLHI9ZS5jaGlsZE5vZGVzLGEubGFiZWw9MTtjYXNlIDE6aWYoISh0PHIubGVuZ3RoKSlyZXR1cm4gWzMsN107c3dpdGNoKG49clt0XSxuLnRhZ05hbWUpe2Nhc2UiZW50cnkiOmNhc2UiaXRlbSI6cmV0dXJuIFszLDJdO2Nhc2UiYm94IjpyZXR1cm4gWzMsNF19cmV0dXJuIFszLDVdO2Nhc2UgMjpyZXR1cm4gWzQsdGhpcy5fcGFyc2VHZW9Sc3NJdGVtKG4pXTtjYXNlIDM6cmV0dXJuIChpPWEuc2VudCgpKSYmKHRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXMucHVzaChpKSx0aGlzLl9wYXJzZWREYXRhLmZlYXR1cmVzLmxlbmd0aCx0aGlzLl9vcHRpb25zLm1heEZlYXR1cmVzKSxbMyw2XTtjYXNlIDQ6cmV0dXJuIChzPXRoaXMuX3BhcnNlR2VvUnNzQm94KG4pKSYmTHIubWVyZ2UodGhpcy5fcGFyc2VkRGF0YS5iYm94LHMpLFszLDZdO2Nhc2UgNTpyZXR1cm4gdGhpcy5fcGFyc2VNZXRhZGF0YShuLHRoaXMuX3BhcnNlZERhdGEucHJvcGVydGllcyksWzMsNl07Y2FzZSA2OnJldHVybiB0KyssWzMsMV07Y2FzZSA3OnJldHVybiB0aGlzLl9jb21wbGV0ZVJlYWQoKSxbMix0aGlzLl9wYXJzZWREYXRhXX19KSl9KSl9LHIucHJvdG90eXBlLl9wYXJzZUdlb1Jzc0l0ZW09ZnVuY3Rpb24oZSl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciB0LHIsbixpLHMsbyx1LGwsYyxoLGQsZixwLG0sZztyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOmZvcihyPXt9LHM9bnVsbCxvPU5hTixjPTAsaD1lLmNoaWxkTm9kZXM7YzxoLmxlbmd0aDtjKyspaWYoZD1oW2NdLHRoaXMuX25hbWVzcGFjZXMmJnRoaXMuX25hbWVzcGFjZXNbZS5uc1ByZWZpeF0mJnRoaXMuX25hbWVzcGFjZXNbZS5uc1ByZWZpeF0uaW5jbHVkZXMoImh0dHA6Ly93d3cub3Blbmdpcy5uZXQvZ21sIikpKGY9bG4ucmVhZEdlb21ldHJ5KGQsdGhpcy5fb3B0aW9ucykpJiYodD1mLmdlb21ldHJ5LGYucHJvcGVydGllcyYmKHI9Qm4ocixmLnByb3BlcnRpZXMpKSk7ZWxzZSBzd2l0Y2goZC50YWdOYW1lKXtjYXNlInBvaW50IjpsPXRoaXMuX3BhcnNlR2VvUnNzUG9pbnQoZCk7YnJlYWs7Y2FzZSJsaW5lIjp0PXRoaXMuX3BhcnNlR2VvUnNzTGluZShkKTticmVhaztjYXNlInBvbHlnb24iOnQ9dGhpcy5fcGFyc2VHZW9Sc3NQb2x5Z29uKGQpO2JyZWFrO2Nhc2Uid2hlcmUiOmNhc2UicG9zaXRpb24iOmQuY2hpbGROb2RlcyYmZC5jaGlsZE5vZGVzLmxlbmd0aD4wPyhmPWxuLnJlYWRHZW9tZXRyeShkLHRoaXMuX29wdGlvbnMpKSYmKHQ9Zi5nZW9tZXRyeSxmLnByb3BlcnRpZXMmJihyPUJuKHIsZi5wcm9wZXJ0aWVzKSkpOnRoaXMuX3BhcnNlTWV0YWRhdGEoZCxyKTticmVhaztjYXNlImNpcmNsZSI6cD10aGlzLl9wYXJzZUdlb1Jzc0NpcmNsZShkKSx0PXAuZ2VvbWV0cnkscj1CbihyLHAucHJvcGVydGllcyk7YnJlYWs7Y2FzZSJib3giOih1PXRoaXMuX3BhcnNlR2VvUnNzQm94KGQpKSYmIXQmJih0PVpyKHUpLHIuc3ViVHlwZT0iUmVjdGFuZ2xlIik7YnJlYWs7Y2FzZSJsYXQiOmNhc2UibGF0aXR1ZGUiOm49cGFyc2VGbG9hdChkLnZhbHVlKTticmVhaztjYXNlImxvbiI6Y2FzZSJsb25nIjpjYXNlImxvbmdpdHVkZSI6aT1wYXJzZUZsb2F0KGQudmFsdWUpO2JyZWFrO2Nhc2UicmFkaXVzIjpvPXBhcnNlRmxvYXQoZC52YWx1ZSk7YnJlYWs7Y2FzZSJlbGV2IjpzPXBhcnNlRmxvYXQoZC52YWx1ZSk7YnJlYWs7Y2FzZSJpY29uIjpkLnZhbHVlJiZ0aGlzLl9vcHRpb25zLnBhcnNlU3R5bGVzJiYoci5pY29uPWQudmFsdWUpO2JyZWFrO2RlZmF1bHQ6dGhpcy5fcGFyc2VNZXRhZGF0YShkLHIpO31yZXR1cm4gIWwmJmVuLmlzVmFsaWROdW1iZXIobikmJmVuLmlzVmFsaWROdW1iZXIoaSk/bD1baSxuXTp0JiYiUG9pbnQiPT09dC50eXBlJiYiQ2lyY2xlIj09PXIuc3ViVHlwZSYmKGw9dC5jb29yZGluYXRlcyksbCYmKGVuLmlzVmFsaWROdW1iZXIocykmJmwucHVzaChzKSx0fHwodD17dHlwZToiUG9pbnQiLGNvb3JkaW5hdGVzOmx9KSksdD8oci5uYW1lJiYhci50aXRsZSYmKHIudGl0bGU9ci5uYW1lKSwhdGhpcy5fb3B0aW9ucy5wYXJzZVN0eWxlc3x8IXIuaWNvbnx8IlBvaW50IiE9PXQudHlwZSYmIk11bHRpUG9pbnQiIT09dC50eXBlP1szLDJdOls0LHRoaXMuX2ltYWdlTWFuYWdlci5hZGRJbWFnZShyLmljb24sbnVsbCxudWxsLHRoaXMuX29wdGlvbnMucHJveHlTZXJ2aWNlKV0pOlszLDNdO2Nhc2UgMToobT1hLnNlbnQoKSkmJihtLnVybHx8bS5jb2xvcikmJihtLmlzSWNvbj0hMCxtLnVybD8oci5pbWFnZT1tLmlkLHIuaW1hZ2VVcmw9bS51cmwpOnIuY29sb3J8fChyLmNvbG9yPW0uY29sb3IpKSxhLmxhYmVsPTI7Y2FzZSAyOnJldHVybiAiUG9pbnQiPT09dC50eXBlJiZlbi5pc1ZhbGlkTnVtYmVyKG8pJiYhci5zdWJUeXBlJiYoci5zdWJUeXBlPSJDaXJjbGUiKSxnPXtnZW9tZXRyeTp0LHByb3BlcnRpZXM6cix0eXBlOiJGZWF0dXJlIn0sci5pZD8oZy5pZD1yLmlkLGRlbGV0ZSByLmlkKTpyLmd1aWQmJihnLmlkPXIuZ3VpZCxkZWxldGUgci5ndWlkKSx1JiYoZy5iYm94PXUpLFsyLGddO2Nhc2UgMzpyZXR1cm4gWzIsbnVsbF19fSkpfSkpfSxyLnByb3RvdHlwZS5fcGFyc2VNZXRhZGF0YT1mdW5jdGlvbihlLHQpe2lmKGUmJnQpc3dpdGNoKGUudGFnTmFtZSl7Y2FzZSJ0aXRsZSI6Y2FzZSJzdWJ0aXRsZSI6Y2FzZSJuYW1lIjpjYXNlImlkIjpjYXNlImxhbmd1YWdlIjpjYXNlImRvY3MiOmNhc2UibWFuYWdpbmdFZGl0b3IiOmNhc2Uid2ViTWFzdGVyIjpjYXNlImNvcHlyaWdodCI6Y2FzZSJjb21tZW50cyI6Y2FzZSJyYXRpbmciOmNhc2UibG9nbyI6Y2FzZSJyaWdodHMiOmNhc2UiZmVhdHVyZXR5cGV0YWciOmNhc2UicmVsYXRpb25zaGlwdGFnIjpjYXNlImZlYXR1cmVuYW1lIjp0W2UudGFnTmFtZV09ZS52YWx1ZTticmVhaztjYXNlImRlc2NyaXB0aW9uIjpjYXNlInN1bW1hcnkiOmUudmFsdWUmJih0W2UudGFnTmFtZV09ZW4ucmVwbGFjZU5ld2xpbmVzKGUudmFsdWUpKTticmVhaztjYXNlImNvbnRlbnQiOnZhciByPVVuLnJlYWRDb250ZW50KGUpO3ImJih0LmRlc2NyaXB0aW9ufHwodC5kZXNjcmlwdGlvbj1yKSx0W2UudGFnTmFtZV09cik7YnJlYWs7Y2FzZSJndWlkIjp0LmlkfHwodC5pZD1lLnZhbHVlKSx0W2UudGFnTmFtZV09ZS52YWx1ZTticmVhaztjYXNlInR0bCI6Y2FzZSJza2lwSG91cnMiOmNhc2UiZmxvb3IiOmlmKGUudmFsdWUpe3ZhciBuPXBhcnNlSW50KGUudmFsdWUpO2VuLmlzVmFsaWROdW1iZXIobikmJih0W2UudGFnTmFtZV09bik7fWJyZWFrO2Nhc2Uic2tpcERheXMiOmlmKGUuY2hpbGROb2RlcyYmZS5jaGlsZE5vZGVzLmxlbmd0aD4wKXtmb3IodmFyIGE9W10saT0wLHM9ZS5jaGlsZE5vZGVzO2k8cy5sZW5ndGg7aSsrKXt2YXIgbz1zW2ldOyJkYXkiPT09by50YWdOYW1lJiZvLnZhbHVlJiZhLnB1c2goby52YWx1ZSk7fWEubGVuZ3RoPjAmJih0W2UudGFnTmFtZV09YSk7fWJyZWFrO2Nhc2UiYXV0aG9yIjpjYXNlImxpbmsiOmNhc2UiY2F0ZWdvcnkiOmNhc2UiY29udHJpYnV0b3IiOnZhciB1PXZvaWQgMDtlLmNoaWxkTm9kZXMmJmUuY2hpbGROb2Rlcy5sZW5ndGg+MHx8ZS5hdHRyaWJ1dGVzJiZPYmplY3Qua2V5cyhlLmF0dHJpYnV0ZXMpLmxlbmd0aD4wP3U9ZW4uc2ltcGxpZnlYbWxOb2RlKGUpOmUudmFsdWUmJih1PWUudmFsdWUpLHUmJihBcnJheS5pc0FycmF5KHRbZS50YWdOYW1lXSk/dFtlLnRhZ05hbWVdLnB1c2godSk6dFtlLnRhZ05hbWVdPVt1XSk7YnJlYWs7Y2FzZSJ1cGRhdGVkIjpjYXNlImxhc3RCdWlsZERhdGUiOmlmKGUudmFsdWUpKGw9RGF0ZS5wYXJzZShlLnZhbHVlKSkmJih0W2UudGFnTmFtZV09bmV3IERhdGUobCksdC5fdGltZXN0YW1wPWwsdGhpcy5faGFzVGltZXN0YW1wPSEwKTticmVhaztjYXNlInB1YkRhdGUiOmNhc2UicHVibGlzaGVkIjp2YXIgbDtpZihlLnZhbHVlKShsPURhdGUucGFyc2UoZS52YWx1ZSkpJiYodFtlLnRhZ05hbWVdPW5ldyBEYXRlKGwpLHQuX3RpbWVzdGFtcHx8KHQuX3RpbWVzdGFtcD1sLHRoaXMuX2hhc1RpbWVzdGFtcD0hMCkpO2JyZWFrO2Nhc2UiY2xvdWQiOmNhc2UiZW5jbG9zdXJlIjpjYXNlInRleHRJbnB1dCI6Y2FzZSJpbWFnZSI6Y2FzZSJzb3VyY2UiOmUuY2hpbGROb2RlcyYmZS5jaGlsZE5vZGVzLmxlbmd0aD4wfHxlLmF0dHJpYnV0ZXMmJk9iamVjdC5rZXlzKGUuYXR0cmlidXRlcykubGVuZ3RoPjA/dFtlLnRhZ05hbWVdPWVuLnNpbXBsaWZ5WG1sTm9kZShlKTplLnZhbHVlJiYodFtlLnRhZ05hbWVdPWUudmFsdWUpO2JyZWFrO2Nhc2UicmFkaXVzIjpjYXNlImVsZXYiOnZhciBjPXBhcnNlRmxvYXQoZS52YWx1ZSk7ZW4uaXNWYWxpZE51bWJlcihjKSYmKHRbZS50YWdOYW1lXT1jKTticmVhaztkZWZhdWx0OmVuLmlnbm9yZVByb3BlcnR5KGUudGFnTmFtZSxlLnZhbHVlKXx8KGUudmFsdWU/dFtlLnRhZ05hbWVdPWUudmFsdWU6dFtlLnRhZ05hbWVdPWVuLnNpbXBsaWZ5WG1sTm9kZShlKSk7fX0sci5wcm90b3R5cGUuX3BhcnNlR2VvUnNzUG9pbnQ9ZnVuY3Rpb24oZSl7aWYoZSYmZS5jaGlsZE5vZGVzJiZlLmNoaWxkTm9kZXMubGVuZ3RoPj0yKXtmb3IodmFyIHQ9dm9pZCAwLHI9dm9pZCAwLG49MCxhPWUuY2hpbGROb2RlcztuPGEubGVuZ3RoO24rKyl7dmFyIGk9YVtuXTtzd2l0Y2goaS50YWdOYW1lKXtjYXNlImxhdCI6Y2FzZSJsYXRpdHVkZSI6dD1wYXJzZUZsb2F0KGkudmFsdWUpO2JyZWFrO2Nhc2UibG9uIjpjYXNlImxvbmciOmNhc2UibG9uZ2l0dWRlIjpyPXBhcnNlRmxvYXQoaS52YWx1ZSk7fX12YXIgcz1lbi5jcmVhdGVQb3NpdGlvbihyLHQpO2lmKHMpcmV0dXJuIHN9dmFyIG89dGhpcy5fcGFyc2VDb29yZGluYXRlcyhlKTtyZXR1cm4gbyYmby5sZW5ndGg+MD9vWzBdOm51bGx9LHIucHJvdG90eXBlLl9wYXJzZUdlb1Jzc0xpbmU9ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5fcGFyc2VDb29yZGluYXRlcyhlKTtyZXR1cm4gdC5sZW5ndGg+PTI/e2Nvb3JkaW5hdGVzOnQsdHlwZToiTGluZVN0cmluZyJ9Om51bGx9LHIucHJvdG90eXBlLl9wYXJzZUdlb1Jzc1BvbHlnb249ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5fcGFyc2VDb29yZGluYXRlcyhlKTtyZXR1cm4gdC5sZW5ndGg+PTM/KGVuLmNsb3NlUmluZyh0KSx7Y29vcmRpbmF0ZXM6W3RdLHR5cGU6IlBvbHlnb24ifSk6bnVsbH0sci5wcm90b3R5cGUuX3BhcnNlR2VvUnNzQ2lyY2xlPWZ1bmN0aW9uKGUpe2lmKGUmJmUudmFsdWUpe3ZhciB0PXRoaXMuX2NpcmNsZVJ4LmV4ZWMoZS52YWx1ZSk7aWYodCl7dmFyIHI9ZW4uY3JlYXRlUG9zaXRpb24ocGFyc2VGbG9hdCh0WzJdKSxwYXJzZUZsb2F0KHRbMV0pKSxuPXBhcnNlRmxvYXQodFszXSksYT17fTtyZXR1cm4gbj4wJiYoYT17cmFkaXVzOm4sc3ViVHlwZToiQ2lyY2xlIn0pLHtnZW9tZXRyeTp7Y29vcmRpbmF0ZXM6cix0eXBlOiJQb2ludCJ9LHByb3BlcnRpZXM6YSx0eXBlOiJGZWF0dXJlIn19fXJldHVybiBudWxsfSxyLnByb3RvdHlwZS5fcGFyc2VHZW9Sc3NCb3g9ZnVuY3Rpb24oZSl7dmFyIHQ9dGhpcy5fcGFyc2VDb29yZGluYXRlcyhlKTtyZXR1cm4gdC5sZW5ndGg+PTI/THIuZnJvbUVkZ2VzKHRbMF1bMF0sdFswXVsxXSx0WzFdWzBdLHRbMV1bMV0pOm51bGx9LHIucHJvdG90eXBlLl9wYXJzZUNvb3JkaW5hdGVzPWZ1bmN0aW9uKGUpe2lmKGUmJmUudmFsdWUpe2Zvcih2YXIgdD1bXSxyPXZvaWQgMCxuPXRoaXMuX2Nvb3JkaW5hdGVSeC5leGVjKGUudmFsdWUpO247KShyPWVuLmNyZWF0ZVBvc2l0aW9uKHBhcnNlRmxvYXQoblsyXSkscGFyc2VGbG9hdChuWzFdKSkpJiZ0LnB1c2gociksbj10aGlzLl9jb29yZGluYXRlUnguZXhlYyhlLnZhbHVlKTtyZXR1cm4gdH1yZXR1cm4gbnVsbH0scn0obW4pLEduPWZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIodCl7cmV0dXJuIGUuY2FsbCh0aGlzLHQsbnVsbCl8fHRoaXN9cmV0dXJuIHQocixlKSxyLnByb3RvdHlwZS5yZWFkPWZ1bmN0aW9uKHQpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgcjtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihuKXtzd2l0Y2gobi5sYWJlbCl7Y2FzZSAwOnJldHVybiBlLnByb3RvdHlwZS5faW5pdFJlYWQuY2FsbCh0aGlzLHQpLChyPShuZXcgdW4pLnBhcnNlKHQpKSYmci5yb290JiZyLnJvb3QudGFnTmFtZSYmImdweCI9PT1yLnJvb3QudGFnTmFtZT9bNCx0aGlzLl9wYXJzZUdweERvYyhyLnJvb3QpXTpbMywyXTtjYXNlIDE6cmV0dXJuIFsyLG4uc2VudCgpXTtjYXNlIDI6dGhyb3cgbmV3IEVycm9yKCJVbmFibGUgdG8gcmVhZCBHUFggZG9jdW1lbnQuIil9fSkpfSkpfSxyLnByb3RvdHlwZS5fcGFyc2VHcHhEb2M9ZnVuY3Rpb24oZSl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciB0LHIsbixpLHMsbyx1O3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6aWYoIWUuY2hpbGROb2RlcylyZXR1cm4gWzMsMTFdO3Q9MCxyPWUuY2hpbGROb2RlcyxhLmxhYmVsPTE7Y2FzZSAxOmlmKCEodDxyLmxlbmd0aCkpcmV0dXJuIFszLDExXTtzd2l0Y2gobj1yW3RdLG4udGFnTmFtZSl7Y2FzZSJtZXRhZGF0YSI6cmV0dXJuIFszLDJdO2Nhc2UicnRlIjpjYXNlInRyayI6Y2FzZSJ3cHQiOnJldHVybiBbMyw3XX1yZXR1cm4gWzMsOV07Y2FzZSAyOmk9MCxzPW4uY2hpbGROb2RlcyxhLmxhYmVsPTM7Y2FzZSAzOnJldHVybiBpPHMubGVuZ3RoPyhvPXNbaV0sWzQsdGhpcy5fcGFyc2VNZXRhZGF0YShvLHRoaXMuX3BhcnNlZERhdGEucHJvcGVydGllcyldKTpbMyw2XTtjYXNlIDQ6YS5zZW50KCksYS5sYWJlbD01O2Nhc2UgNTpyZXR1cm4gaSsrLFszLDNdO2Nhc2UgNjpyZXR1cm4gWzMsMTBdO2Nhc2UgNzpyZXR1cm4gWzQsdGhpcy5fcGFyc2VTaGFwZShuKV07Y2FzZSA4OnJldHVybiAodT1hLnNlbnQoKSkmJih0aGlzLl9wYXJzZWREYXRhLmZlYXR1cmVzLnB1c2godSksdGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5sZW5ndGgsdGhpcy5fb3B0aW9ucy5tYXhGZWF0dXJlcyksWzMsMTBdO2Nhc2UgOTpyZXR1cm4gWzMsMTBdO2Nhc2UgMTA6cmV0dXJuIHQrKyxbMywxXTtjYXNlIDExOnJldHVybiB0aGlzLl9jb21wbGV0ZVJlYWQoKSxbMix0aGlzLl9wYXJzZWREYXRhXX19KSl9KSl9LHIucHJvdG90eXBlLl9wYXJzZU1ldGFkYXRhPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciByLG4saSxzLG8sdSxsLGMsaCxkLGYscCxtO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6aWYoIWV8fCF0KXJldHVybiBbMywyXTtzd2l0Y2gocj12b2lkIDAsZS50YWdOYW1lKXtjYXNlIm5hbWUiOnQudGl0bGU9ZS52YWx1ZSx0W2UudGFnTmFtZV09ZS52YWx1ZTticmVhaztjYXNlInN5bSI6cj1lLnZhbHVlO2JyZWFrO2Nhc2UiY210IjpjYXNlInNyYyI6Y2FzZSJ0eXBlIjpjYXNlImtleXdvcmRzIjpjYXNlImZpeCI6dFtlLnRhZ05hbWVdPWUudmFsdWU7YnJlYWs7Y2FzZSJkZXNjIjplLnZhbHVlJiYodFtlLnRhZ05hbWVdPWVuLnJlcGxhY2VOZXdsaW5lcyhlLnZhbHVlKSx0LmRlc2NyaXB0aW9uPXRbZS50YWdOYW1lXSk7YnJlYWs7Y2FzZSJib3VuZHMiOm49cGFyc2VGbG9hdChlLmF0dHJpYnV0ZXMubWF4TGF0KSxpPXBhcnNlRmxvYXQoZS5hdHRyaWJ1dGVzLm1pbkxhdCkscz1wYXJzZUZsb2F0KGUuYXR0cmlidXRlcy5tYXhMb24pLG89cGFyc2VGbG9hdChlLmF0dHJpYnV0ZXMubWluTG9uKSxlbi5pc1ZhbGlkTnVtYmVyKG4pJiZlbi5pc1ZhbGlkTnVtYmVyKGkpJiZlbi5pc1ZhbGlkTnVtYmVyKHMpJiZlbi5pc1ZhbGlkTnVtYmVyKG8pJiYodT1bbyxuXSxsPVtzLGldLHQuYm91bmRzPUxyLmZyb21Qb3NpdGlvbnMoW3UsbF0pKTticmVhaztjYXNlImVsZSI6Y2FzZSJtYWd2YXIiOmNhc2UiZ2VvaWRoZWlnaHQiOmNhc2UiaGRvcCI6Y2FzZSJ2ZG9wIjpjYXNlInBkb3AiOmNhc2UiYWdlb2ZkZ3BzZGF0YSI6Yz1wYXJzZUZsb2F0KGUudmFsdWUpLGVuLmlzVmFsaWROdW1iZXIoYykmJih0W2UudGFnTmFtZV09Yyk7YnJlYWs7Y2FzZSJzYXQiOmNhc2UiZGdwc2lkIjpoPXBhcnNlSW50KGUudmFsdWUpLGVuLmlzVmFsaWROdW1iZXIoaCkmJih0W2UudGFnTmFtZV09aCk7YnJlYWs7Y2FzZSJ0aW1lIjplLnZhbHVlJiYoZD1EYXRlLnBhcnNlKGUudmFsdWUpKSYmKHQudGltZT1uZXcgRGF0ZShkKSx0Ll90aW1lc3RhbXA9ZCx0aGlzLl9oYXNUaW1lc3RhbXA9ITApO2JyZWFrO2Nhc2UiYXV0aG9yIjooZj1lbi5zaW1wbGlmeVhtbE5vZGUoZSkpPyhmLmxpbmsmJmYubGluay50ZXh0JiYhZi5saW5rLnRpdGxlJiYoZi5saW5rLnRpdGxlPWYubGluay50ZXh0KSx0W2UudGFnTmFtZV09Zik6ZW4uaXNWYWxpZFN0cmluZyhlLnZhbHVlKSYmKHRbZS50YWdOYW1lXT1lLnZhbHVlKTticmVhaztjYXNlImxpbmsiOihwPWVuLnNpbXBsaWZ5WG1sTm9kZShlKSk/KHAudGV4dCYmIXAudGl0bGUmJihwLnRpdGxlPXAudGV4dCksdFtlLnRhZ05hbWVdPXApOmVuLmlzVmFsaWRTdHJpbmcoZS52YWx1ZSkmJih0W2UudGFnTmFtZV09ZS52YWx1ZSk7YnJlYWs7Y2FzZSJjb3B5cmlnaHQiOmRlZmF1bHQ6ZW4uaWdub3JlUHJvcGVydHkoZS50YWdOYW1lLGUudmFsdWUpfHwoZS52YWx1ZT90W2UudGFnTmFtZV09ZS52YWx1ZTp0W2UudGFnTmFtZV09ZW4uc2ltcGxpZnlYbWxOb2RlKGUpKTt9cmV0dXJuIGVuLmlzVmFsaWRTdHJpbmcocik/KHQuc3ltPXIsIXRoaXMuX29wdGlvbnMucGFyc2VTdHlsZXN8fHQuY29sb3I/WzMsMl06WzQsdGhpcy5faW1hZ2VNYW5hZ2VyLmFkZEltYWdlKHIsbnVsbCwhMCldKTpbMywyXTtjYXNlIDE6KG09YS5zZW50KCkpJiZtLmNvbG9yJiYodC5jb2xvcj1tLmNvbG9yKSxhLmxhYmVsPTI7Y2FzZSAyOnJldHVybiBbMl19fSkpfSkpfSxyLnByb3RvdHlwZS5fcGFyc2VTaGFwZT1mdW5jdGlvbihlKXtyZXR1cm4gbih0aGlzLHZvaWQgMCx2b2lkIDAsKGZ1bmN0aW9uKCl7dmFyIHQ7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24ocil7c3dpdGNoKHIubGFiZWwpe2Nhc2UgMDpzd2l0Y2godD1udWxsLGUudGFnTmFtZSl7Y2FzZSJ3cHQiOnJldHVybiBbMywxXTtjYXNlInJ0ZSI6cmV0dXJuIFszLDNdO2Nhc2UidHJrIjpyZXR1cm4gWzMsNV19cmV0dXJuIFszLDddO2Nhc2UgMTpyZXR1cm4gWzQsdGhpcy5fcGFyc2VXYXlwb2ludChlKV07Y2FzZSAyOnJldHVybiB0PXIuc2VudCgpLFszLDhdO2Nhc2UgMzpyZXR1cm4gWzQsdGhpcy5fcGFyc2VSb3V0ZShlKV07Y2FzZSA0OnJldHVybiB0PXIuc2VudCgpLFszLDhdO2Nhc2UgNTpyZXR1cm4gWzQsdGhpcy5fcGFyc2VUcmFjayhlKV07Y2FzZSA2OnJldHVybiB0PXIuc2VudCgpLFszLDhdO2Nhc2UgNzpyZXR1cm4gWzMsOF07Y2FzZSA4OnJldHVybiB0JiZ0LnByb3BlcnRpZXMuYm91bmRzJiYodC5iYm94PXQucHJvcGVydGllcy5ib3VuZHMsZGVsZXRlIHQucHJvcGVydGllcy5ib3VuZHMpLFsyLHRdfX0pKX0pKX0sci5wcm90b3R5cGUuX3BhcnNlV2F5cG9pbnQ9ZnVuY3Rpb24oZSl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciB0LHIsbixpLHMsbztyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOmlmKG51bGw9PWUpcmV0dXJuIFszLDZdO2lmKCEodD10aGlzLl9wYXJzZVBvc2l0aW9uKGUsITEpKSlyZXR1cm4gWzMsNl07cj17fSxuPTAsaT1lLmNoaWxkTm9kZXMsYS5sYWJlbD0xO2Nhc2UgMTpyZXR1cm4gbjxpLmxlbmd0aD8iZXh0ZW5zaW9ucyIhPT0ocz1pW25dKS50YWdOYW1lP1szLDJdOih0aGlzLl9vcHRpb25zLnBhcnNlU3R5bGVzJiYobz10aGlzLl9wYXJzZUV4dGVuc2lvbnMocyxyKSkmJm8uc3Ryb2tlQ29sb3ImJihyLmNvbG9yPW8uc3Ryb2tlQ29sb3IpLFszLDRdKTpbMyw1XTtjYXNlIDI6cmV0dXJuIFs0LHRoaXMuX3BhcnNlTWV0YWRhdGEocyxyKV07Y2FzZSAzOmEuc2VudCgpLGEubGFiZWw9NDtjYXNlIDQ6cmV0dXJuIG4rKyxbMywxXTtjYXNlIDU6cmV0dXJuIHIubmFtZSYmKHIudGl0bGU9ci5uYW1lKSxyLmVsZSYmdC5wdXNoKHIuZWxlKSxbMix7YmJveDpBcnJheS5pc0FycmF5KHIuYm91bmRzKT9yLmJvdW5kczpudWxsLGdlb21ldHJ5Ontjb29yZGluYXRlczp0LHR5cGU6IlBvaW50In0scHJvcGVydGllczpyLHR5cGU6IkZlYXR1cmUifV07Y2FzZSA2OnJldHVybiBbMixudWxsXX19KSl9KSl9LHIucHJvdG90eXBlLl9wYXJzZVJvdXRlPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgdCxyLG4saSxzLG8sdSxsLGM7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDppZih0PXt9LHI9W10sbnVsbD09ZSlyZXR1cm4gWzMsMTBdO2k9dm9pZCAwLHM9dm9pZCAwLHRoaXMuX29wdGlvbnMuY2FwdHVyZVBhdGhXYXlwb2ludHMmJih0LndheXBvaW50cz1bXSksZS5hdHRyaWJ1dGVzJiYodC5udW1iZXI9ZS5hdHRyaWJ1dGVzLm51bWJlciksbz0wLHU9ZS5jaGlsZE5vZGVzLGEubGFiZWw9MTtjYXNlIDE6aWYoIShvPHUubGVuZ3RoKSlyZXR1cm4gWzMsMTBdO3N3aXRjaChsPXVbb10sbC50YWdOYW1lKXtjYXNlInJ0ZXB0IjpyZXR1cm4gWzMsMl07Y2FzZSJleHRlbnNpb25zIjpyZXR1cm4gWzMsNl19cmV0dXJuIFszLDddO2Nhc2UgMjpyZXR1cm4gdGhpcy5fb3B0aW9ucy5jYXB0dXJlUGF0aFdheXBvaW50cz9bNCx0aGlzLl9wYXJzZVdheXBvaW50KGwpXTpbMyw0XTtjYXNlIDM6cmV0dXJuIChzPWEuc2VudCgpKSYmKHQud2F5cG9pbnRzLnB1c2gocyksci5wdXNoKHMuZ2VvbWV0cnkuY29vcmRpbmF0ZXMpKSxbMyw1XTtjYXNlIDQ6KGk9dGhpcy5fcGFyc2VQb3NpdGlvbihsLCEwKSkmJigoYz1lbi5nZXRFbGVtZW50QnlUYWdOYW1lKCJlbGUiLGwpKSYmaS5wdXNoKHBhcnNlRmxvYXQoYy52YWx1ZSkpLHIucHVzaChpKSksYS5sYWJlbD01O2Nhc2UgNTpyZXR1cm4gWzMsOV07Y2FzZSA2OnJldHVybiBuPXRoaXMuX3BhcnNlRXh0ZW5zaW9ucyhsLHQpLFszLDldO2Nhc2UgNzpyZXR1cm4gWzQsdGhpcy5fcGFyc2VNZXRhZGF0YShsLHQpXTtjYXNlIDg6cmV0dXJuIGEuc2VudCgpLFszLDldO2Nhc2UgOTpyZXR1cm4gbysrLFszLDFdO2Nhc2UgMTA6cmV0dXJuIHIubGVuZ3RoPj0yPyhuJiZ0aGlzLl9vcHRpb25zLnBhcnNlU3R5bGVzJiYobi5zdHJva2VDb2xvciYmKHQuc3Ryb2tlQ29sb3I9bi5zdHJva2VDb2xvciksbi5zdHJva2VPcGFjaXR5JiYodC5zdHJva2VPcGFjaXR5PW4uc3Ryb2tlT3BhY2l0eSksbi5zdHJva2VXaWR0aCYmKHQuc3Ryb2tlV2lkdGg9bi5zdHJva2VXaWR0aCkpLFsyLHtiYm94OkFycmF5LmlzQXJyYXkodC5ib3VuZHMpP3QuYm91bmRzOm51bGwsZ2VvbWV0cnk6e2Nvb3JkaW5hdGVzOnIsdHlwZToiTGluZVN0cmluZyJ9LHByb3BlcnRpZXM6dCx0eXBlOiJGZWF0dXJlIn1dKTpbMixudWxsXX19KSl9KSl9LHIucHJvdG90eXBlLl9wYXJzZVRyYWNrPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgdCxyLG4saSxzLG8sdSxsLGMsaCxkLGYscCxtLGcsXyx5LHY7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDppZihudWxsPT1lKXJldHVybiBbMywxNF07dD17fSxyPVtdLG49W10saT12b2lkIDAscz12b2lkIDAsbz12b2lkIDAsdT12b2lkIDAsbD0wLGM9ZS5jaGlsZE5vZGVzLGEubGFiZWw9MTtjYXNlIDE6aWYoIShsPGMubGVuZ3RoKSlyZXR1cm4gWzMsMTNdO3N3aXRjaChoPWNbbF0saC50YWdOYW1lKXtjYXNlInRya3NlZyI6cmV0dXJuIFszLDJdO2Nhc2UiZXh0ZW5zaW9ucyI6cmV0dXJuIFszLDldfXJldHVybiBbMywxMF07Y2FzZSAyOmlmKCF0aGlzLl9vcHRpb25zLmNhcHR1cmVQYXRoV2F5cG9pbnRzKXJldHVybiBbMyw3XTtuPVtdLG89W10sZD0wLGY9aC5jaGlsZE5vZGVzLGEubGFiZWw9MztjYXNlIDM6cmV0dXJuIGQ8Zi5sZW5ndGg/InRya3B0IiE9PShnPWZbZF0pLnRhZ05hbWU/WzMsNV06WzQsdGhpcy5fcGFyc2VXYXlwb2ludChnKV06WzMsNl07Y2FzZSA0OihzPWEuc2VudCgpKSYmKG4ucHVzaChzLmdlb21ldHJ5LmNvb3JkaW5hdGVzKSxvLnB1c2gocykpLGEubGFiZWw9NTtjYXNlIDU6cmV0dXJuIGQrKyxbMywzXTtjYXNlIDY6cmV0dXJuIG4ubGVuZ3RoPj0yJiZyLnB1c2gobiksWzMsOF07Y2FzZSA3OmZvcihuPVtdLHA9MCxtPWguY2hpbGROb2RlcztwPG0ubGVuZ3RoO3ArKykidHJrcHQiPT09KGc9bVtwXSkudGFnTmFtZSYmKGk9dGhpcy5fcGFyc2VQb3NpdGlvbihnLCEwKSkmJigoXz1lbi5nZXRFbGVtZW50QnlUYWdOYW1lKCJlbGUiLGgpKSYmaS5wdXNoKHBhcnNlRmxvYXQoXy52YWx1ZSkpLG4ucHVzaChpKSk7bi5sZW5ndGg+PTImJnIucHVzaChuKSxhLmxhYmVsPTg7Y2FzZSA4OnJldHVybiBbMywxMl07Y2FzZSA5OnJldHVybiB1PXRoaXMuX3BhcnNlRXh0ZW5zaW9ucyhoLHQpLFszLDEyXTtjYXNlIDEwOnJldHVybiBbNCx0aGlzLl9wYXJzZU1ldGFkYXRhKGgsdCldO2Nhc2UgMTE6cmV0dXJuIGEuc2VudCgpLFszLDEyXTtjYXNlIDEyOnJldHVybiBsKyssWzMsMV07Y2FzZSAxMzpyZXR1cm4gMD09PSh5PXIubGVuZ3RoKT9bMixudWxsXToodj12b2lkIDAsdj0xPT09eT97Y29vcmRpbmF0ZXM6clswXSx0eXBlOiJMaW5lU3RyaW5nIn06e2Nvb3JkaW5hdGVzOnIsdHlwZToiTXVsdGlMaW5lU3RyaW5nIn0sdGhpcy5fb3B0aW9ucy5jYXB0dXJlUGF0aFdheXBvaW50cyYmKHQud2F5cG9pbnRzPW8pLHUmJnRoaXMuX29wdGlvbnMucGFyc2VTdHlsZXMmJih1LnN0cm9rZUNvbG9yJiYodC5zdHJva2VDb2xvcj11LnN0cm9rZUNvbG9yKSx1LnN0cm9rZU9wYWNpdHkmJih0LnN0cm9rZU9wYWNpdHk9dS5zdHJva2VPcGFjaXR5KSx1LnN0cm9rZVdpZHRoJiYodC5zdHJva2VXaWR0aD11LnN0cm9rZVdpZHRoKSksWzIse2Jib3g6QXJyYXkuaXNBcnJheSh0LmJvdW5kcyk/dC5ib3VuZHM6bnVsbCxnZW9tZXRyeTp2LHByb3BlcnRpZXM6dCx0eXBlOiJGZWF0dXJlIn1dKTtjYXNlIDE0OnJldHVybiBbMixudWxsXX19KSl9KSl9LHIucHJvdG90eXBlLl9wYXJzZVBvc2l0aW9uPWZ1bmN0aW9uKGUsdCl7dmFyIHI9cGFyc2VGbG9hdChlLmF0dHJpYnV0ZXMubGF0KSxuPXBhcnNlRmxvYXQoZS5hdHRyaWJ1dGVzLmxvbik7cmV0dXJuIGVuLmNyZWF0ZVBvc2l0aW9uKG4scixudWxsLHQpfSxyLnByb3RvdHlwZS5fcGFyc2VFeHRlbnNpb25zPWZ1bmN0aW9uKGUsdCl7aWYoZS5jaGlsZE5vZGVzKXtmb3IodmFyIHI9dm9pZCAwLG49dm9pZCAwLGE9MCxpPWUuY2hpbGROb2RlczthPGkubGVuZ3RoO2ErKyl7dmFyIHM9aVthXTtzd2l0Y2gocy50YWdOYW1lKXtjYXNlImxpbmUiOm49dGhpcy5fcGFyc2VHcHhMaW5lU3R5bGVFeHRlbnNpb24ocyk7YnJlYWs7Y2FzZSJXYXlwb2ludEV4dGVuc2lvbiI6Y2FzZSJSb3V0ZUV4dGVuc2lvbiI6Y2FzZSJUcmFja0V4dGVuc2lvbiI6cj10aGlzLl9wYXJzZUdweHhFeHRlbnNpb25zKHMsdCk7YnJlYWs7Y2FzZSJEaXNwbGF5Q29sb3IiOnI9cy52YWx1ZTticmVhaztjYXNlImZpbGwiOmNhc2UidGV4dCI6Y2FzZSJhbGlnbiI6Y2FzZSJ2ZXJ0aWNhbC1hbGlnbiI6YnJlYWs7ZGVmYXVsdDplbi5pZ25vcmVQcm9wZXJ0eShlLnRhZ05hbWUsZS52YWx1ZSl8fChzLnZhbHVlP3Rbcy50YWdOYW1lXT1zLnZhbHVlOnRbcy50YWdOYW1lXT1lbi5zaW1wbGlmeVhtbE5vZGUocykpO319cmV0dXJuIHImJihuJiYhbi5zdHJva2VDb2xvcj9uLnN0cm9rZUNvbG9yPXI6bj17c3Ryb2tlQ29sb3I6cn0pLG59cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZUdweExpbmVTdHlsZUV4dGVuc2lvbj1mdW5jdGlvbihlKXt2YXIgdCxyLG49e307aWYoZSYmZS5jaGlsZE5vZGVzKWZvcih2YXIgYT0wLGk9ZS5jaGlsZE5vZGVzO2E8aS5sZW5ndGg7YSsrKXt2YXIgcz1pW2FdO3N3aXRjaChzLnRhZ05hbWUpe2Nhc2UiY29sb3IiOmVuLmlzVmFsaWRTdHJpbmcocy52YWx1ZSkmJih0PXMudmFsdWUpO2JyZWFrO2Nhc2Uib3BhY2l0eSI6dmFyIG89cGFyc2VGbG9hdChzLnZhbHVlKTtlbi5pc1ZhbGlkTnVtYmVyKG8pJiYocj1vKTticmVhaztjYXNlIndpZHRoIjp2YXIgdT1wYXJzZUZsb2F0KHMudmFsdWUpO2VuLmlzVmFsaWROdW1iZXIodSkmJihuLnN0cm9rZVdpZHRoPU1hdGgucm91bmQodSplbi5tbVBlclBpeGVsR3B4KjEwKS8xMCk7fX1pZigibnVtYmVyIiE9dHlwZW9mIHImJihyPTEpLHQpaWYoMSE9PXIpe3ZhciBsPWVuLmNvbG9yVG9SZ2JhQXJyYXkodCk7bFszXT1yLG4uc3Ryb2tlQ29sb3I9ZW4uY29sb3JUb1JnYmEobCk7fWVsc2Ugbi5zdHJva2VDb2xvcj10O3JldHVybiBufSxyLnByb3RvdHlwZS5fcGFyc2VHcHh4RXh0ZW5zaW9ucz1mdW5jdGlvbihlLHQpe3ZhciByO2lmKGUmJmUuY2hpbGROb2Rlcylmb3IodmFyIG49MCxhPWUuY2hpbGROb2RlcztuPGEubGVuZ3RoO24rKyl7dmFyIGk9YVtuXTtzd2l0Y2goaS50YWdOYW1lKXtjYXNlIkRpc3BsYXlDb2xvciI6ZW4uaXNWYWxpZFN0cmluZyhpLnZhbHVlKSYmKHI9aS52YWx1ZSk7YnJlYWs7ZGVmYXVsdDplbi5pZ25vcmVQcm9wZXJ0eShlLnRhZ05hbWUsZS52YWx1ZSl8fChpLnZhbHVlP3RbaS50YWdOYW1lXT1lbi5zaW1wbGlmeVhtbE5vZGUoaSk6dFtpLnRhZ05hbWVdPWkudmFsdWUpO319cmV0dXJuIHJ9LHJ9KG1uKSxabj1mdW5jdGlvbihlKXtmdW5jdGlvbiByKHQscixuLGEpe3ZhciBpPWUuY2FsbCh0aGlzLHQscil8fHRoaXM7cmV0dXJuIGkuX3N0eWxlcz17fSxpLl9zdHlsZU1hcHM9e30saS5fc2NoZW1hRGF0YT17fSxpLl9jb29yZGluYXRlUng9LygtP1swLTldK1suMC05RV0qKSwoLT9bMC05XStbLjAtOUVdKikoLCgtP1swLTldK1suMC05RV0qKSkqW1xzXHJcblx0XSovZyxpLl9uZXR3b3JrTGlua3NMb2FkZWQ9MCxpLl9jdXJyZW50TmV0d29ya0xpbmtEZXB0aD0wLGkuX3N1cHBvcnRJbWFnZUV4dD0vXC4oanBnfGpwZWd8cG5nfGdpZikkL2ksaS5fa21sQmFsbG9vblN0eWxlUHJvcGVydHlSeD0vXCRcWyhbLWEtekEtWjAtOV9dKykoXC8/KShbLWEtekEtWjAtOV9dKyk/KFwvPykoWy1hLXpBLVowLTlfXSspP1xdL2dpLGkuX2lzU3ViUmVhZGVyPWEsZW4uaXNWYWxpZE51bWJlcihuKSYmKGkuX2N1cnJlbnROZXR3b3JrTGlua0RlcHRoPW4pLGl9cmV0dXJuIHQocixlKSxyLnByb3RvdHlwZS5yZWFkPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbih0KXtzd2l0Y2godC5sYWJlbCl7Y2FzZSAwOnJldHVybiB0aGlzLl9wYXJlbnRLbXo9bnVsbCxbNCx0aGlzLl9wYXJzZUttbERvYyhlKV07Y2FzZSAxOnJldHVybiBbMix0LnNlbnQoKV19fSkpfSkpfSxyLnByb3RvdHlwZS5yZWFkS216QXN5bmM9ZnVuY3Rpb24oZSl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciB0LHIsbixpLHMsbyxsO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6aWYoIWUpcmV0dXJuIFszLDEwXTtpZighKGUgaW5zdGFuY2VvZiBBcnJheUJ1ZmZlcikpcmV0dXJuIFszLDVdO2EubGFiZWw9MTtjYXNlIDE6cmV0dXJuIGEudHJ5cy5wdXNoKFsxLDMsLDRdKSxbNCwobmV3IHUpLmxvYWRBc3luYyhlKV07Y2FzZSAyOnJldHVybiB0PWEuc2VudCgpLHRoaXMuX3BhcmVudEttej10LFszLDRdO2Nhc2UgMzp0aHJvdyBhLnNlbnQoKSxuZXcgRXJyb3IoIlVuYWJsZSB0byBwYXJzZSBLTVogZmlsZS4iKTtjYXNlIDQ6cmV0dXJuIFszLDZdO2Nhc2UgNTplIGluc3RhbmNlb2YgdSYmKHRoaXMuX3BhcmVudEttej1lKSxhLmxhYmVsPTY7Y2FzZSA2OmlmKCF0aGlzLl9wYXJlbnRLbXp8fCF0aGlzLl9wYXJlbnRLbXouZmlsZXMpcmV0dXJuIFszLDEwXTtmb3Iocj10aGlzLl9wYXJlbnRLbXouZmlsZXNbImRvYy5rbWwiXSxuPVtdLGk9MCxzPU9iamVjdC5rZXlzKHRoaXMuX3BhcmVudEttei5maWxlcyk7aTxzLmxlbmd0aDtpKyspbz1zW2ldLCFyJiZ0aGlzLl9wYXJlbnRLbXouZmlsZXNbb10ubmFtZS5pbmNsdWRlcygiLmttbCIpJiYocj10aGlzLl9wYXJlbnRLbXouZmlsZXNbb10pLG4ucHVzaCh0aGlzLl9wcmVsb2FkRW1iZWRkZWRJbWFnZShvKSk7cmV0dXJuIFs0LFByb21pc2UuYWxsKG4pXTtjYXNlIDc6cmV0dXJuIGEuc2VudCgpLHI/WzQsci5hc3luYygidGV4dCIpXTpbMywxMF07Y2FzZSA4OnJldHVybiBsPWEuc2VudCgpLFs0LHRoaXMuX3BhcnNlS21sRG9jKGwpXTtjYXNlIDk6cmV0dXJuIFsyLGEuc2VudCgpXTtjYXNlIDEwOnRocm93IG5ldyBFcnJvcigiVW5hYmxlIHRvIHBhcnNlIEtNWiBmaWxlLiIpfX0pKX0pKX0sci5wcm90b3R5cGUuX3BhcnNlS21sRG9jPWZ1bmN0aW9uKHQpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgcixuLGkscyxvLHUsbCxjO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6cmV0dXJuIGUucHJvdG90eXBlLl9pbml0UmVhZC5jYWxsKHRoaXMsdCkscj1uZXcgdW4sbj1yLnBhcnNlKHQpLGVuLmRvY0hhc0RhdGEobik/WzQsdGhpcy5fcGFyc2VDb250YWluZXIobi5yb290KV06WzMsMl07Y2FzZSAxOmlmKGEuc2VudCgpLHRoaXMuX2hhc1VuZGVmaW5lZFN0eWxlcylmb3IoaT0wLHM9dGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcztpPHMubGVuZ3RoO2krKylvPXNbaV0sKHU9by5wcm9wZXJ0aWVzLnN0eWxlVXJsKSYmKGw9dGhpcy5fZ2V0U3R5bGVCeVVybCh1KSxkZWxldGUgby5wcm9wZXJ0aWVzLnN0eWxlVXJsLGwmJihjPSJib29sZWFuIiE9dHlwZW9mIG8ucHJvcGVydGllcy52aXNpYmxlfHxvLnByb3BlcnRpZXMudmlzaWJsZSx0aGlzLl9hcHBseVN0eWxlKG8sbCxjKSkpO3RoaXMuX2lzU3ViUmVhZGVyfHwodGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcyYmKHRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXM9dGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5yZXZlcnNlKCkpLHRoaXMuX3BhcnNlZERhdGEuX2dyb3VuZE92ZXJsYXlPcHRpb25zJiYodGhpcy5fcGFyc2VkRGF0YS5fZ3JvdW5kT3ZlcmxheU9wdGlvbnM9dGhpcy5fcGFyc2VkRGF0YS5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMucmV2ZXJzZSgpKSx0aGlzLl9oYXNEcmF3T3JkZXImJnRoaXMuX3BhcnNlZERhdGEuX2dyb3VuZE92ZXJsYXlPcHRpb25zLnNvcnQodGhpcy5fb3ZlcmxheURyYXdPcmRlclNvcnRlcikpLGEubGFiZWw9MjtjYXNlIDI6cmV0dXJuIHRoaXMuX2NvbXBsZXRlUmVhZCgpLFsyLHRoaXMuX3BhcnNlZERhdGFdfX0pKX0pKX0sci5wcm90b3R5cGUuX3BhcnNlQ29udGFpbmVyPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgdCxyLG4saSxzLG8sdSxsLGM7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDp0PTAscj1lLmNoaWxkTm9kZXMsYS5sYWJlbD0xO2Nhc2UgMTppZighKHQ8ci5sZW5ndGgpKXJldHVybiBbMywxOF07c3dpdGNoKG49clt0XSxuLnRhZ05hbWUpe2Nhc2UiRG9jdW1lbnQiOmNhc2UiRm9sZGVyIjpyZXR1cm4gWzMsMl07Y2FzZSJQbGFjZW1hcmsiOnJldHVybiBbMyw0XTtjYXNlIlN0eWxlIjpyZXR1cm4gWzMsNl07Y2FzZSJTdHlsZU1hcCI6cmV0dXJuIFszLDldO2Nhc2UiU2NoZW1hIjpyZXR1cm4gWzMsMTBdO2Nhc2UiR3JvdW5kT3ZlcmxheSI6cmV0dXJuIFszLDExXTtjYXNlIk5ldHdvcmtMaW5rIjpyZXR1cm4gWzMsMTJdO2Nhc2UiUmVnaW9uIjpyZXR1cm4gWzMsMTRdO2Nhc2UiU2NyZWVuT3ZlcmxheSI6cmV0dXJuIFszLDE1XX1yZXR1cm4gWzMsMTZdO2Nhc2UgMjpyZXR1cm4gWzQsdGhpcy5fcGFyc2VDb250YWluZXIobildO2Nhc2UgMzpyZXR1cm4gYS5zZW50KCksWzMsMTddO2Nhc2UgNDpyZXR1cm4gWzQsdGhpcy5fcGFyc2VQbGFjZW1hcmsobildO2Nhc2UgNTpyZXR1cm4gKGk9YS5zZW50KCkpJiZpLmxlbmd0aD4wJiYoMT09PWkubGVuZ3RoP3RoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXMucHVzaChpWzBdKToodGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5sZW5ndGgraS5sZW5ndGg+dGhpcy5fb3B0aW9ucy5tYXhGZWF0dXJlcyYmKGkubGVuZ3RoPXRoaXMuX29wdGlvbnMubWF4RmVhdHVyZXMtdGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5sZW5ndGgpLHRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXM9dGhpcy5fcGFyc2VkRGF0YS5mZWF0dXJlcy5jb25jYXQoaSkpLHRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXMubGVuZ3RoLHRoaXMuX29wdGlvbnMubWF4RmVhdHVyZXMpLFszLDE3XTtjYXNlIDY6cmV0dXJuIG4uYXR0cmlidXRlcyYmdGhpcy5fb3B0aW9ucy5wYXJzZVN0eWxlcyYmKHM9bi5hdHRyaWJ1dGVzLmlkKT8obz10aGlzLl9zdHlsZXMsdT1zLFs0LHRoaXMuX3BhcnNlU3R5bGUobildKTpbMyw4XTtjYXNlIDc6b1t1XT1hLnNlbnQoKSxhLmxhYmVsPTg7Y2FzZSA4OnJldHVybiBbMywxN107Y2FzZSA5OnJldHVybiB0aGlzLl9vcHRpb25zLnBhcnNlU3R5bGVzJiZ0aGlzLl9wYXJzZVN0eWxlTWFwKG4pLFszLDE3XTtjYXNlIDEwOnJldHVybiB0aGlzLl9wYXJzZVNjaGVtYShuKSxbMywxN107Y2FzZSAxMTpyZXR1cm4gKGw9dGhpcy5fcGFyc2VHcm91bmRPdmVybGF5KG4pKSYmdGhpcy5fcGFyc2VkRGF0YS5fZ3JvdW5kT3ZlcmxheU9wdGlvbnMucHVzaChsKSxbMywxN107Y2FzZSAxMjpyZXR1cm4gWzQsdGhpcy5fcGFyc2VOZXR3b3JrTGluayhuKV07Y2FzZSAxMzpyZXR1cm4gYS5zZW50KCksWzMsMTddO2Nhc2UgMTQ6cmV0dXJuIHRoaXMuX3BhcnNlZERhdGEuYmJveHx8KGM9dGhpcy5fcGFyc2VSZWdpb24obikpJiYodGhpcy5fcGFyc2VkRGF0YS5iYm94PWMpLFszLDE3XTtjYXNlIDE1OnJldHVybiBbMywxN107Y2FzZSAxNjpyZXR1cm4gdGhpcy5fcGFyc2VGZWF0dXJlTWV0YWRhdGEobix0aGlzLl9wYXJzZWREYXRhLnByb3BlcnRpZXMpLFszLDE3XTtjYXNlIDE3OnJldHVybiB0KyssWzMsMV07Y2FzZSAxODpyZXR1cm4gWzJdfX0pKX0pKX0sci5wcm90b3R5cGUuX2dldFN0eWxlU2NoZW1hTmFtZT1mdW5jdGlvbihlKXt2YXIgdD1lLmxhc3RJbmRleE9mKCIjIik7cmV0dXJuIC0xIT09dD9lLnN1YnN0cih0KzEpOmV9LHIucHJvdG90eXBlLl9nZXRTdHlsZUJ5VXJsPWZ1bmN0aW9uKGUpe2lmKGUpe3ZhciB0PXRoaXMuX2dldFN0eWxlU2NoZW1hTmFtZShlKSxyPXRoaXMuX3N0eWxlc1t0XTtpZighcil7dmFyIG49dGhpcy5fc3R5bGVNYXBzW3RdO24mJihyPXRoaXMuX3N0eWxlc1tuXSk7fWlmKHIpcmV0dXJuIHJ9cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9nZXRTY2hlbWFCeVVybD1mdW5jdGlvbihlKXtpZihlKXt2YXIgdD10aGlzLl9nZXRTdHlsZVNjaGVtYU5hbWUoZSkscj10aGlzLl9zY2hlbWFEYXRhW3RdO2lmKHIpcmV0dXJuIHJ9cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZUZlYXR1cmVNZXRhZGF0YT1mdW5jdGlvbihlLHQpe3N3aXRjaChlLnRhZ05hbWUpe2Nhc2UibmFtZSI6ZS52YWx1ZSYmKHRbZS50YWdOYW1lXT1lLnZhbHVlLHQudGl0bGU9ZS52YWx1ZSk7YnJlYWs7Y2FzZSJkZXNjcmlwdGlvbiI6ZS52YWx1ZSYmKHRbZS50YWdOYW1lXT1lbi5yZXBsYWNlTmV3bGluZXModGhpcy5fcmVwbGFjZUVtYmVkZGVkSW1hZ2VVcmxzKGUudmFsdWUpKS5yZXBsYWNlKC88YnJcLz8+JC9nLCIiKSk7YnJlYWs7Y2FzZSJhZGRyZXNzIjpjYXNlInBob25lTnVtYmVyIjpjYXNlIlNuaXBwZXQiOmUudmFsdWUmJiJlbXB0eSIhPT1lLnZhbHVlJiYodFtlLnRhZ05hbWVdPWUudmFsdWUpO2JyZWFrO2Nhc2UidmlzaWJpbGl0eSI6Y2FzZSJvcGVuIjp0W2UudGFnTmFtZV09ZW4ucGFyc2VCb29sZWFuKGUudmFsdWUpO2JyZWFrO2Nhc2UiYXV0aG9yIjpjYXNlImxpbmsiOmNhc2UiQWRkcmVzc0RldGFpbHMiOnRbZS50YWdOYW1lXT1lbi5zaW1wbGlmeVhtbE5vZGUoZSk7YnJlYWs7Y2FzZSJFeHRlbmRlZERhdGEiOnRoaXMuX3BhcnNlRXh0ZW5kZWREYXRhKGUsdCk7YnJlYWs7Y2FzZSJUaW1lU3RhbXAiOnZhciByPWVuLnNpbXBsaWZ5WG1sTm9kZShlKTtpZihyJiZyLndoZW4pKGE9RGF0ZS5wYXJzZShyLndoZW4pKSYmKHQuVGltZVN0YW1wPW5ldyBEYXRlKGEpLHQuX3RpbWVzdGFtcD1hLHRoaXMuX2hhc1RpbWVzdGFtcD0hMCk7YnJlYWs7Y2FzZSJUaW1lU3BhbiI6dmFyIG49ZW4uc2ltcGxpZnlYbWxOb2RlKGUpO2lmKG4pe3ZhciBhO2lmKG4uYmVnaW4pKGE9RGF0ZS5wYXJzZShuLmJlZ2luKSkmJihuLmJlZ2luPW5ldyBEYXRlKGEpLHQuX3RpbWVzdGFtcHx8KHQuX3RpbWVzdGFtcD1hLHRoaXMuX2hhc1RpbWVzdGFtcD0hMCkpO2lmKG4uZW5kKShhPURhdGUucGFyc2Uobi5lbmQpKSYmKG4uZW5kPW5ldyBEYXRlKGEpLHQuX3RpbWVzdGFtcHx8KHQuX3RpbWVzdGFtcD1hLHRoaXMuX2hhc1RpbWVzdGFtcD0hMCkpO3QuVGltZVNwYW49bjt9YnJlYWs7Y2FzZSJDYW1lcmEiOmNhc2UiTG9va0F0IjpjYXNlIlN0eWxlU2VsZWN0b3IiOmJyZWFrO2RlZmF1bHQ6ZW4uaWdub3JlUHJvcGVydHkoZS50YWdOYW1lLGUudmFsdWUpfHwoZS52YWx1ZT90W2UudGFnTmFtZV09ZS52YWx1ZTp0W2UudGFnTmFtZV09ZW4uc2ltcGxpZnlYbWxOb2RlKGUpKTt9fSxyLnByb3RvdHlwZS5fcGFyc2VFeHRlbmRlZERhdGE9ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHI9MCxuPWUuY2hpbGROb2RlcztyPG4ubGVuZ3RoO3IrKyl7dmFyIGE9bltyXTtpZigiRGF0YSI9PT1hLnRhZ05hbWUpe3ZhciBpPWEuYXR0cmlidXRlcy5uYW1lO2kmJih0W2ldPWVuLnNpbXBsaWZ5WG1sTm9kZShhKSk7fWVsc2UgaWYoIlNjaGVtYURhdGEiPT09YS50YWdOYW1lKXt2YXIgcz10aGlzLl9nZXRTY2hlbWFCeVVybChhLmF0dHJpYnV0ZXMuc2NoZW1hVXJsKTtzJiZ0aGlzLl9wcm9jZXNzU2NoZW1hKHMsYS5jaGlsZE5vZGVzLHQpO319fSxyLnByb3RvdHlwZS5fcGFyc2VTY2hlbWE9ZnVuY3Rpb24oZSl7aWYoZS5hdHRyaWJ1dGVzKXt2YXIgdD1lLmF0dHJpYnV0ZXMuaWQscj1lLmF0dHJpYnV0ZXMubmFtZTtpZih0JiZyKXtmb3IodmFyIG49e2ZpZWxkczp7fSxuYW1lOnJ9LGE9MCxpPWUuY2hpbGROb2RlczthPGkubGVuZ3RoO2ErKyl7dmFyIHM9aVthXTtyPXMuYXR0cmlidXRlcy5uYW1lO3ZhciBvPXMuYXR0cmlidXRlcy50eXBlO3ImJm8mJihzLmNoaWxkTm9kZXMmJnMuY2hpbGROb2Rlcy5sZW5ndGg+MCYmImRpc3BsYXlOYW1lIj09PXMuY2hpbGROb2Rlc1swXS50YWdOYW1lP24uZmllbGRzW3JdPXtkaXNwbGF5TmFtZTpzLmNoaWxkTm9kZXNbMF0udmFsdWUsdHlwZTpvfTpuLmZpZWxkc1tyXT17dHlwZTpvfSk7fXRoaXMuX3NjaGVtYURhdGFbdF09bjt9fX0sci5wcm90b3R5cGUuX3Byb2Nlc3NTY2hlbWE9ZnVuY3Rpb24oZSx0LHIpe2lmKGUmJnQmJnIpZm9yKHZhciBuPTAsYT10O248YS5sZW5ndGg7bisrKXt2YXIgaT1hW25dLHM9aS5hdHRyaWJ1dGVzLm5hbWU7aWYocyl7dmFyIG89ZS5maWVsZHNbc107aWYobyl7dmFyIHU9aS52YWx1ZTtzd2l0Y2goby50eXBlKXtjYXNlImJvb2wiOnU9ZW4ucGFyc2VCb29sZWFuKHUpO2JyZWFrO2Nhc2UiaW50IjpjYXNlInVpbnQiOmNhc2Uic2hvcnQiOmNhc2UidXNob3J0Ijp1PXBhcnNlSW50KHUpO2JyZWFrO2Nhc2UiZmxvYXQiOmNhc2UiZG91YmxlIjp1PXBhcnNlRmxvYXQodSk7fW8uZGlzcGxheU5hbWU/cltzXT17ZGlzcGxheU5hbWU6by5kaXNwbGF5TmFtZSx2YWx1ZTp1fTpyW3NdPXU7fX19fSxyLnByb3RvdHlwZS5fcGFyc2VTdHlsZT1mdW5jdGlvbihlKXtyZXR1cm4gbih0aGlzLHZvaWQgMCx2b2lkIDAsKGZ1bmN0aW9uKCl7dmFyIHQscixuLGkscyxvLHUsbCxjPXRoaXM7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oaCl7c3dpdGNoKGgubGFiZWwpe2Nhc2UgMDp0PXtpY29uU3R5bGU6e30sbGluZVN0eWxlOnt9LHBvbHlTdHlsZTp7fX0scj0hMCxuPSEwLGk9ZnVuY3Rpb24oaSl7dmFyIG87cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDpzd2l0Y2goaS50YWdOYW1lKXtjYXNlIkljb25TdHlsZSI6cmV0dXJuIFszLDFdO2Nhc2UiTGluZVN0eWxlIjpyZXR1cm4gWzMsM107Y2FzZSJQb2x5U3R5bGUiOnJldHVybiBbMyw0XTtjYXNlIkJhbGxvb25TdHlsZSI6cmV0dXJuIFszLDVdO2Nhc2UiTGFiZWxTdHlsZSI6cmV0dXJuIFszLDZdO2Nhc2UiTGlzdFN0eWxlIjpyZXR1cm4gWzMsN119cmV0dXJuIFszLDddO2Nhc2UgMTpyZXR1cm4gWzQscy5fcGFyc2VJY29uU3R5bGUoaSx0KV07Y2FzZSAyOnJldHVybiBhLnNlbnQoKSxbMyw4XTtjYXNlIDM6cmV0dXJuIHMuX3BhcnNlTGluZVN0eWxlKGksdCksWzMsOF07Y2FzZSA0OnJldHVybiBlLmNoaWxkTm9kZXMmJihpLmNoaWxkTm9kZXMuZm9yRWFjaCgoZnVuY3Rpb24oZSl7c3dpdGNoKGUudGFnTmFtZSl7Y2FzZSJjb2xvciI6aWYoZS52YWx1ZSl7dmFyIGE9Yy5fcGFyc2VLbWxDb2xvcihlLnZhbHVlKTthJiYodC5wb2x5U3R5bGUuZmlsbENvbG9yPWVuLmNvbG9yVG9IZXgoYSksdC5wb2x5U3R5bGUuZmlsbE9wYWNpdHk9YVszXSk7fWJyZWFrO2Nhc2UiZmlsbCI6cj1lbi5wYXJzZUJvb2xlYW4oZS52YWx1ZSk7YnJlYWs7Y2FzZSJvdXRsaW5lIjpuPWVuLnBhcnNlQm9vbGVhbihlLnZhbHVlKTt9fSkpLHJ8fCh0LnBvbHlTdHlsZS5maWxsT3BhY2l0eT0wKSxufHwodC5wb2x5U3R5bGUuc3Ryb2tlT3BhY2l0eT0wKSksWzMsOF07Y2FzZSA1OnJldHVybiBpLmNoaWxkTm9kZXMmJmkuY2hpbGROb2Rlcy5sZW5ndGg+MCYmKG89e30saS5jaGlsZE5vZGVzLmZvckVhY2goKGZ1bmN0aW9uKGUpe3N3aXRjaChlLnRhZ05hbWUpe2Nhc2UidGV4dCI6dmFyIHQ9ZS52YWx1ZTtpZih0KXtmb3IodmFyIHI9Yy5fa21sQmFsbG9vblN0eWxlUHJvcGVydHlSeC5leGVjKGUudmFsdWUpO3I7KXtpZihyLmxlbmd0aD49Nil7dmFyIG49IiI7ImRpc3BsYXlOYW1lIj09PXJbNV0/bj0ieyIrclszXSsiLyIrcls1XSsifSI6clszXSYmIiIhPT1yWzNdJiYiLyIhPT1yWzNdP249ImRpc3BsYXlOYW1lIj09PXJbM10/InsiK3JbMV0rIi8iK3JbM10rIn0iOiJ7IityWzNdKyJ9IjpyWzNdfHwobj0ieyIrclsxXSsifSIpLHQ9dC5yZXBsYWNlKHJbMF0sbik7fXI9Yy5fa21sQmFsbG9vblN0eWxlUHJvcGVydHlSeC5leGVjKGUudmFsdWUpO30iIiE9PSh0PXQucmVwbGFjZSgiJFsiLCJ7IikucmVwbGFjZSgiXSIsIn0iKSkmJihvLmNvbnRlbnQ9dCk7fWJyZWFrO2Nhc2UidGV4dENvbG9yIjp2YXIgYT1jLl9wYXJzZUttbENvbG9yKGUudmFsdWUpO2EmJihvLnRleHRDb2xvcj1lbi5jb2xvclRvUmdiYShhKSk7YnJlYWs7Y2FzZSJiZ0NvbG9yIjp2YXIgaT1jLl9wYXJzZUttbENvbG9yKGUudmFsdWUpO2kmJihvLmZpbGxDb2xvcj1lbi5jb2xvclRvUmdiYShpKSk7fX0pKSxvLmNvbnRlbnQmJih0LnBvcHVwVGVtcGxhdGU9bykpLFszLDhdO2Nhc2UgNjpjYXNlIDc6cmV0dXJuIFszLDhdO2Nhc2UgODpyZXR1cm4gWzJdfX0pKX0scz10aGlzLG89MCx1PWUuY2hpbGROb2RlcyxoLmxhYmVsPTE7Y2FzZSAxOnJldHVybiBvPHUubGVuZ3RoPyhsPXVbb10sWzUsaShsKV0pOlszLDRdO2Nhc2UgMjpoLnNlbnQoKSxoLmxhYmVsPTM7Y2FzZSAzOnJldHVybiBvKyssWzMsMV07Y2FzZSA0OnJldHVybiBuJiZ0LnBvbHlTdHlsZSYmdC5saW5lU3R5bGUmJk9iamVjdC5hc3NpZ24odC5wb2x5U3R5bGUsdC5saW5lU3R5bGUpLFsyLHRdfX0pKX0pKX0sci5wcm90b3R5cGUuX3BhcnNlU3R5bGVNYXA9ZnVuY3Rpb24oZSl7dmFyIHQ9ZS5hdHRyaWJ1dGVzLmlkO2lmKHQpe2Zvcih2YXIgcj12b2lkIDAsbj0wLGE9ZS5jaGlsZE5vZGVzO248YS5sZW5ndGg7bisrKXt2YXIgaT1hW25dLHM9ZW4uc2ltcGxpZnlYbWxOb2RlKGkpO2lmKChyPXMua2V5KSYmIm5vcm1hbCI9PT1yKXtyPXRoaXMuX2dldFN0eWxlU2NoZW1hTmFtZShzLnN0eWxlVXJsKTticmVha319ciYmKHRoaXMuX3N0eWxlTWFwc1t0XT1yKTt9fSxyLnByb3RvdHlwZS5fcGFyc2VJY29uU3R5bGU9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gbih0aGlzLHZvaWQgMCx2b2lkIDAsKGZ1bmN0aW9uKCl7dmFyIHIsbixpLHMsbyx1LGwsYyxoLGQsZixwLG0sZyxfLHksdjtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOmlmKCFlLmNoaWxkTm9kZXMpcmV0dXJuIFszLDNdO2ZvcihyPXt9LG49dm9pZCAwLGk9dm9pZCAwLHM9dm9pZCAwLG89dm9pZCAwLHU9dm9pZCAwLGw9MSxjPXZvaWQgMCxoPXZvaWQgMCxkPTAsZj1lLmNoaWxkTm9kZXM7ZDxmLmxlbmd0aDtkKyspc3dpdGNoKChwPWZbZF0pLnRhZ05hbWUpe2Nhc2UiY29sb3IiOnAudmFsdWUmJihjPXRoaXMuX3BhcnNlS21sQ29sb3IocC52YWx1ZSkpO2JyZWFrO2Nhc2UiSWNvbiI6bT1lbi5nZXRFbGVtZW50QnlUYWdOYW1lKCJocmVmIixwKSxuPW0udmFsdWU7YnJlYWs7Y2FzZSJob3RTcG90IjppPXBhcnNlRmxvYXQocC5hdHRyaWJ1dGVzLngpLHM9cGFyc2VGbG9hdChwLmF0dHJpYnV0ZXMueSksZW4uaXNWYWxpZE51bWJlcihpKSYmZW4uaXNWYWxpZE51bWJlcihzKSYmKG89cC5hdHRyaWJ1dGVzLnh1bml0cyx1PXAuYXR0cmlidXRlcy55dW5pdHMpO2JyZWFrO2Nhc2UiaGVhZGluZyI6Zz1wYXJzZUZsb2F0KHAudmFsdWUpLGVuLmlzVmFsaWROdW1iZXIoZykmJihyLnJvdGF0aW9uPWcpO2JyZWFrO2Nhc2Uic2NhbGUiOmw9cGFyc2VGbG9hdChwLnZhbHVlKTticmVhaztjYXNlImNvbG9yTW9kZSI6aD1wLnZhbHVlO31yZXR1cm4gYyYmYy5sZW5ndGg+PTQmJihyLmNvbG9yPWgmJiJyYW5kb20iPT09aD9lbi5jb2xvclRvUmdiYShbY1swXSxNYXRoLnJvdW5kKGNbMV0qTWF0aC5yYW5kb20oKSksTWF0aC5yb3VuZChjWzJdKk1hdGgucmFuZG9tKCkpLE1hdGgucm91bmQoY1szXSpNYXRoLnJhbmRvbSgpKV0pOmVuLmNvbG9yVG9SZ2JhKGMpKSwoaXNOYU4obCl8fGw8PTApJiYobD0xKSxfPXZvaWQgMCxuP1s0LHRoaXMuX2ltYWdlTWFuYWdlci5hZGRJbWFnZShuLG51bGwsbnVsbCx0aGlzLl9vcHRpb25zLnByb3h5U2VydmljZSldOlszLDJdO2Nhc2UgMTooXz1hLnNlbnQoKSkmJihfLnVybHx8Xy5jb2xvcikmJihfLmlzSWNvbj0hMCxfLnVybD8oci5pbWFnZT1fLmlkLHIuaW1hZ2VVcmw9Xy51cmwpOnIuY29sb3J8fChyLmNvbG9yPV8uY29sb3IpKSxhLmxhYmVsPTI7Y2FzZSAyOl8mJl8udXJsJiYoZW4uaXNWYWxpZE51bWJlcihfLndpZHRoKXx8KF8ud2lkdGg9MzIpLGVuLmlzVmFsaWROdW1iZXIoXy5oZWlnaHQpfHwoXy5oZWlnaHQ9MzIpLGw9TWF0aC5yb3VuZCgzMipsL01hdGgubWF4KF8ud2lkdGgsXy5oZWlnaHQpKjEwMCkvMTAwLGVuLmlzVmFsaWROdW1iZXIoaSkmJmVuLmlzVmFsaWROdW1iZXIocykmJih5PSEwLHY9ITEsImZyYWN0aW9uIj09PW8mJihpKj1fLndpZHRoKSwiZnJhY3Rpb24iPT09dSYmKHMqPV8uaGVpZ2h0KSwiaW5zZXRQaXhlbHMiPT09byYmKGk9LWkseT0hMSksImluc2V0UGl4ZWxzIj09PXUmJihzPS1zLHY9ITApLGVuLmlzVmFsaWROdW1iZXIoaSkmJmVuLmlzVmFsaWROdW1iZXIocykmJihyLm9mZnNldD1bLWkqbCxzKmxdLHIuYW5jaG9yPXk/dj8idG9wLWxlZnQiOiJib3R0b20tbGVmdCI6dj8idG9wLXJpZ2h0IjoiYm90dG9tLXJpZ2h0IikpLGVuLmlzVmFsaWROdW1iZXIoaSl8fGVuLmlzVmFsaWROdW1iZXIocyl8fChyLm9mZnNldD1bMCwwXSxyLmFuY2hvcj0iY2VudGVyIikpLDEhPT1sJiYobD1NYXRoLnJvdW5kKDEwMCpsKS8xMDAsci5zaXplPWwpLE9iamVjdC5hc3NpZ24odC5pY29uU3R5bGUsciksYS5sYWJlbD0zO2Nhc2UgMzpyZXR1cm4gWzJdfX0pKX0pKX0sci5wcm90b3R5cGUuX3BhcnNlTGluZVN0eWxlPWZ1bmN0aW9uKGUsdCl7dmFyIHI9dGhpcztpZihlLmNoaWxkTm9kZXMpe3ZhciBuPXt9O2UuY2hpbGROb2Rlcy5mb3JFYWNoKChmdW5jdGlvbihlKXtzd2l0Y2goZS50YWdOYW1lKXtjYXNlImNvbG9yIjppZihlLnZhbHVlKXt2YXIgdD1yLl9wYXJzZUttbENvbG9yKGUudmFsdWUpO3QmJihuLnN0cm9rZUNvbG9yPWVuLmNvbG9yVG9IZXgodCksbi5zdHJva2VPcGFjaXR5PXRbM10pO31icmVhaztjYXNlIndpZHRoIjp2YXIgYT1wYXJzZUZsb2F0KGUudmFsdWUpO2VuLmlzVmFsaWROdW1iZXIoYSkmJihuLnN0cm9rZVdpZHRoPWEpO319KSksT2JqZWN0LmFzc2lnbih0LmxpbmVTdHlsZSxuKTt9fSxyLnByb3RvdHlwZS5fcGFyc2VLbWxDb2xvcj1mdW5jdGlvbihlKXtpZihlKXtpZig4PT09ZS5sZW5ndGgpe3ZhciB0PXBhcnNlSW50KGUuc3Vic3RyKDAsMiksMTYpLHI9cGFyc2VJbnQoZS5zdWJzdHIoMiwyKSwxNiksbj1wYXJzZUludChlLnN1YnN0cig0LDIpLDE2KTtyZXR1cm4gW3BhcnNlSW50KGUuc3Vic3RyKDYsMiksMTYpLG4scix0PU1hdGgucm91bmQodC8yNTUqMTAwKS8xMDBdfWlmKDY9PT1lLmxlbmd0aCl7cj1wYXJzZUludChlLnN1YnN0cigwLDIpLDE2KSxuPXBhcnNlSW50KGUuc3Vic3RyKDIsMiksMTYpO3JldHVybiBbcGFyc2VJbnQoZS5zdWJzdHIoMywyKSwxNiksbixyXX19cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZVBsYWNlbWFyaz1mdW5jdGlvbihlKXtyZXR1cm4gbih0aGlzLHZvaWQgMCx2b2lkIDAsKGZ1bmN0aW9uKCl7dmFyIHQscixuLGkscyxvLHUsbCxjLGgsZCxmPXRoaXM7cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDppZighZS5jaGlsZE5vZGVzKXJldHVybiBbMywxMV07dD17fSxyPXZvaWQgMCxzPSEwLHU9MCxsPWUuY2hpbGROb2RlcyxhLmxhYmVsPTE7Y2FzZSAxOmlmKCEodTxsLmxlbmd0aCkpcmV0dXJuIFszLDEwXTtzd2l0Y2goYz1sW3VdLGMudGFnTmFtZSl7Y2FzZSJzdHlsZVVybCI6cmV0dXJuIFszLDJdO2Nhc2UiU3R5bGUiOnJldHVybiBbMywzXTtjYXNlInZpc2liaWxpdHkiOnJldHVybiBbMyw2XTtjYXNlIlBvaW50IjpjYXNlIkxpbmVTdHJpbmciOmNhc2UiUG9seWdvbiI6Y2FzZSJNdWx0aUdlb21ldHJ5IjpjYXNlIkxpbmVhclJpbmciOnJldHVybiBbMyw3XX1yZXR1cm4gWzMsOF07Y2FzZSAyOnJldHVybiAoaD10aGlzLl9nZXRTdHlsZUJ5VXJsKGMudmFsdWUpKT9uPWg6KHQuc3R5bGVVcmw9Yy52YWx1ZSx0aGlzLl9oYXNVbmRlZmluZWRTdHlsZXM9ITApLFszLDldO2Nhc2UgMzpyZXR1cm4gdGhpcy5fb3B0aW9ucy5wYXJzZVN0eWxlcz9bNCx0aGlzLl9wYXJzZVN0eWxlKGMpXTpbMyw1XTtjYXNlIDQ6aT1hLnNlbnQoKSxhLmxhYmVsPTU7Y2FzZSA1OnJldHVybiBbMyw5XTtjYXNlIDY6cmV0dXJuIHRoaXMuX29wdGlvbnMuaWdub3JlVmlzaWJpbGl0eXx8KHM9ZW4ucGFyc2VCb29sZWFuKGMudmFsdWUpLHQudmlzaWJpbGl0eT1zKSxbMyw5XTtjYXNlIDc6cmV0dXJuIHI9dGhpcy5fcGFyc2VHZW9tZXRyeShjLHQpLFszLDldO2Nhc2UgODpyZXR1cm4gdGhpcy5fcGFyc2VGZWF0dXJlTWV0YWRhdGEoYyx0KSxbMyw5XTtjYXNlIDk6cmV0dXJuIHUrKyxbMywxXTtjYXNlIDEwOmlmKHIpcmV0dXJuIHM9c3x8dGhpcy5fb3B0aW9ucy5pZ25vcmVWaXNpYmlsaXR5LGUuYXR0cmlidXRlcyYmKG89ZS5hdHRyaWJ1dGVzLmlkKSxBcnJheS5pc0FycmF5KHIpPyhkPVtdLHIuZm9yRWFjaCgoZnVuY3Rpb24oZSl7ZC5wdXNoKGYuX2NyZWF0ZUZlYXR1cmUoZSxhcih0KSxvLG4saSxzKSk7fSkpLFsyLGRdKTpbMixbdGhpcy5fY3JlYXRlRmVhdHVyZShyLHQsbyxuLGkscyldXTthLmxhYmVsPTExO2Nhc2UgMTE6cmV0dXJuIFsyLG51bGxdfX0pKX0pKX0sci5wcm90b3R5cGUuX2NyZWF0ZUZlYXR1cmU9ZnVuY3Rpb24oZSx0LHIsbixhLGkpe2lmKCJQb2x5Z29uIj09PWUudHlwZXx8Ik11bHRpUG9seWdvbiI9PT1lLnR5cGUpe3ZhciBzPWUuaGVpZ2h0O3RoaXMuX29wdGlvbnMuZXh0cnVkZVBvbHlnb25zJiZzJiYodC5oZWlnaHQ9cyksZGVsZXRlIGUuaGVpZ2h0O312YXIgbz17Z2VvbWV0cnk6ZSxwcm9wZXJ0aWVzOnQsdHlwZToiRmVhdHVyZSJ9O3JldHVybiByJiYoby5pZD1yKSx0aGlzLl9hcHBseVN0eWxlKG8sbixpKSx0aGlzLl9hcHBseVN0eWxlKG8sYSxpKSxvfSxyLnByb3RvdHlwZS5fcGFyc2VHZW9tZXRyeT1mdW5jdGlvbihlLHQpe3N3aXRjaChlLnRhZ05hbWUpe2Nhc2UiUG9pbnQiOnJldHVybiB0aGlzLl9wYXJzZVBvaW50KGUpO2Nhc2UiTGluZVN0cmluZyI6Y2FzZSJMaW5lYXJSaW5nIjpyZXR1cm4gdGhpcy5fcGFyc2VMaW5lU3RyaW5nKGUpO2Nhc2UiUG9seWdvbiI6cmV0dXJuIHRoaXMuX3BhcnNlUG9seWdvbihlKTtjYXNlIk11bHRpR2VvbWV0cnkiOmZvcih2YXIgcj12b2lkIDAsbj1bXSxhPXZvaWQgMCxpPSExLHM9dm9pZCAwLG89ITEsdT0wLGw9ZS5jaGlsZE5vZGVzO3U8bC5sZW5ndGg7dSsrKXt2YXIgYz1sW3VdO2lmKHI9dGhpcy5fcGFyc2VHZW9tZXRyeShjLHQpKXtpZihhfHwoYT1yLnR5cGUpLHIudHlwZT09PWF8fGl8fChpPSEwKSwiUG9seWdvbiI9PT1yLnR5cGUmJiFvKXt2YXIgaD1yLmhlaWdodDt2b2lkIDA9PT1zP3M9aDpzIT09aCYmKG89ITEpO31uLnB1c2gocik7fX1pZihuLmxlbmd0aD4wKXtpZihpfHxvKXJldHVybiBuO3N3aXRjaChhKXtjYXNlIlBvaW50IjpyZXR1cm4ge2Nvb3JkaW5hdGVzOm4ubWFwKChmdW5jdGlvbihlKXtyZXR1cm4gZS5jb29yZGluYXRlc30pKSx0eXBlOiJNdWx0aVBvaW50In07Y2FzZSJMaW5lU3RyaW5nIjpyZXR1cm4ge2Nvb3JkaW5hdGVzOm4ubWFwKChmdW5jdGlvbihlKXtyZXR1cm4gZS5jb29yZGluYXRlc30pKSx0eXBlOiJNdWx0aUxpbmVTdHJpbmcifTtjYXNlIlBvbHlnb24iOnJldHVybiB7Y29vcmRpbmF0ZXM6bi5tYXAoKGZ1bmN0aW9uKGUpe3JldHVybiBlLmNvb3JkaW5hdGVzfSkpLGhlaWdodDpzLHR5cGU6Ik11bHRpUG9seWdvbiJ9fX19cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZVBvaW50PWZ1bmN0aW9uKGUpe3ZhciB0PWVuLmdldEVsZW1lbnRCeVRhZ05hbWUoImNvb3JkaW5hdGVzIixlKTtpZih0KXt2YXIgcj10aGlzLl9wYXJzZUNvb3JkaW5hdGVzKHQpO2lmKHImJnIubGVuZ3RoPj0xKXJldHVybiB7Y29vcmRpbmF0ZXM6clswXSx0eXBlOiJQb2ludCJ9fXJldHVybiBudWxsfSxyLnByb3RvdHlwZS5fcGFyc2VMaW5lU3RyaW5nPWZ1bmN0aW9uKGUpe2lmKGUuY2hpbGROb2Rlcyl7dmFyIHQ9ZW4uZ2V0RWxlbWVudEJ5VGFnTmFtZSgiY29vcmRpbmF0ZXMiLGUpO2lmKHQpe3ZhciByPXRoaXMuX3BhcnNlQ29vcmRpbmF0ZXModCk7aWYociYmci5sZW5ndGg+PTIpcmV0dXJuICJMaW5lYXJSaW5nIj09PWUudGFnTmFtZSYmZW4uY2xvc2VSaW5nKHIpLHtjb29yZGluYXRlczpyLHR5cGU6IkxpbmVTdHJpbmcifX19cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZVBvbHlnb249ZnVuY3Rpb24oZSl7Zm9yKHZhciB0PVtdLHI9W10sbj1bXSxhPSExLGk9MCxzPTAsbz1lLmNoaWxkTm9kZXM7czxvLmxlbmd0aDtzKyspe3ZhciB1PW9bc107c3dpdGNoKHUudGFnTmFtZSl7Y2FzZSJvdXRlckJvdW5kYXJ5SXMiOih0PXRoaXMuX3BhcnNlTGluZWFyUmluZyh1LCEwKSkmJnQubGVuZ3RoPjAmJnRbMF0ubGVuZ3RoPjImJihpPXRbMF1bMl0pO2JyZWFrO2Nhc2UiaW5uZXJCb3VuZGFyeUlzIjoocj10aGlzLl9wYXJzZUxpbmVhclJpbmcodSwhMCkpJiZuLnB1c2gocik7YnJlYWs7Y2FzZSJleHRydWRlIjphPWVuLnBhcnNlQm9vbGVhbih1LnZhbHVlKTt9fXJldHVybiB0PyhuLnNwbGljZSgwLDAsdCkse2Nvb3JkaW5hdGVzOm4saGVpZ2h0OmE/aTowLHR5cGU6IlBvbHlnb24ifSk6bnVsbH0sci5wcm90b3R5cGUuX3BhcnNlQ29vcmRpbmF0ZXM9ZnVuY3Rpb24oZSl7aWYoZSYmZS52YWx1ZSl7Zm9yKHZhciB0PVtdLHI9dGhpcy5fY29vcmRpbmF0ZVJ4LmV4ZWMoZS52YWx1ZSk7cjspci5sZW5ndGg+PTU/dC5wdXNoKGVuLmNyZWF0ZVBvc2l0aW9uKHBhcnNlRmxvYXQoclsxXSkscGFyc2VGbG9hdChyWzJdKSxwYXJzZUZsb2F0KHJbNF0pLCEwKSk6dC5wdXNoKGVuLmNyZWF0ZVBvc2l0aW9uKHBhcnNlRmxvYXQoclsxXSkscGFyc2VGbG9hdChyWzJdKSxudWxsLCEwKSkscj10aGlzLl9jb29yZGluYXRlUnguZXhlYyhlLnZhbHVlKTtyZXR1cm4gdH1yZXR1cm4gbnVsbH0sci5wcm90b3R5cGUuX3BhcnNlTGluZWFyUmluZz1mdW5jdGlvbihlLHQpe2lmKGUuY2hpbGROb2RlcyYmMT09PWUuY2hpbGROb2Rlcy5sZW5ndGgpe3ZhciByPWUuY2hpbGROb2Rlc1swXTtpZihyKXt2YXIgbj10aGlzLl9wYXJzZUNvb3JkaW5hdGVzKGVuLmdldEVsZW1lbnRCeVRhZ05hbWUoImNvb3JkaW5hdGVzIixyKSk7cmV0dXJuIHQmJm4mJm4ubGVuZ3RoPj0yJiZlbi5jbG9zZVJpbmcobiksbn19cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZUdyb3VuZE92ZXJsYXk9ZnVuY3Rpb24oZSl7aWYoZS5jaGlsZE5vZGVzKXtmb3IodmFyIHQ9e3Byb3BlcnRpZXM6e319LHI9dm9pZCAwLG49MCxhPWUuY2hpbGROb2RlcztuPGEubGVuZ3RoO24rKyl7dmFyIGk9YVtuXTtzd2l0Y2goaS50YWdOYW1lKXtjYXNlIkljb24iOnZhciBzPWVuLmdldEVsZW1lbnRCeVRhZ05hbWUoImhyZWYiLGkpO2lmKHMmJnMudmFsdWUpe3ZhciBvPXMudmFsdWUudG9Mb3dlckNhc2UoKS5pbmNsdWRlcygicmVxdWVzdD1nZXRtYXAiKSx1PWVuLmdldEVsZW1lbnRCeVRhZ05hbWUoInZpZXdSZWZyZXNoTW9kZSIsaSk7aWYodC5pc1dNUz11JiYib25TdG9wIj09PXUudmFsdWV8fG8sdC5pc1dNUyl0LnVybD1zLnZhbHVlLnJlcGxhY2UoLygmYW1wOykvZywiJiIpO2Vsc2Uge3QudXJsPXRoaXMuX2dldEdyb3VuZE92ZXJsYXlVcmwocy52YWx1ZSk7dmFyIGw9dC51cmwudG9Mb3dlckNhc2UoKTtpZihsLmVuZHNXaXRoKCIudGlmIil8fGwuZW5kc1dpdGgoIi50aWZmIil8fGwuZW5kc1dpdGgoIi5zdmciKSlyZXR1cm4gbnVsbH19YnJlYWs7Y2FzZSJMYXRMb25Cb3giOmlmKChyPXRoaXMuX3BhcnNlTGF0TG9uQm94KGkpKSYmci5sZW5ndGg+PTApe3ZhciBjPWVuLmdldEVsZW1lbnRCeVRhZ05hbWUoInJvdGF0aW9uIixpKTtpZihjKXt2YXIgaD1wYXJzZUZsb2F0KGMudmFsdWUpO2lmKGVuLmlzVmFsaWROdW1iZXIoaCkmJjAhPT1oKXtoPTM2MC1oO3ZhciBkPUxyLmdldENlbnRlcihyKSxmPUxyLmdldE5vcnRoV2VzdChyKSxwPUxyLmdldE5vcnRoRWFzdChyKSxtPUxyLmdldFNvdXRoRWFzdChyKSxnPUxyLmdldFNvdXRoV2VzdChyKTt0LmNvb3JkaW5hdGVzPSRyKFtmLHAsbSxnXSxkLGgpO319dC5jb29yZGluYXRlc3x8KHQuYm91bmRzPXIpO31icmVhaztjYXNlIkxhdExvblF1YWQiOih5PXRoaXMuX3BhcnNlTGF0TG9uUXVhZChpKSkmJnkubGVuZ3RoPj00JiYodC5jb29yZGluYXRlcz15LnJldmVyc2UoKSk7YnJlYWs7Y2FzZSJkcmF3T3JkZXIiOmkudmFsdWUmJiIiIT09aS52YWx1ZSYmKHQucHJvcGVydGllcy5fZHJhd29yZGVyPXBhcnNlSW50KGkudmFsdWUpLHRoaXMuX2hhc0RyYXdPcmRlcj0hMCk7YnJlYWs7Y2FzZSJjb2xvciI6dmFyIF89dGhpcy5fcGFyc2VLbWxDb2xvcihpLnZhbHVlKTtfJiYodC5vcGFjaXR5PV9bM10pO2JyZWFrO2RlZmF1bHQ6dGhpcy5fcGFyc2VGZWF0dXJlTWV0YWRhdGEoaSx0LnByb3BlcnRpZXMpO319aWYodGhpcy5fb3B0aW9ucy5pZ25vcmVWaXNpYmlsaXR5fHwiYm9vbGVhbiIhPXR5cGVvZiB0LnByb3BlcnRpZXMudmlzaWJpbGl5fHwodC52aXNpYmxlPXQucHJvcGVydGllcy52aXNpYmlsaXR5KSx0LmlzV01TfHx0LmNvb3JkaW5hdGVzfHwoci5sZW5ndGg+PTY/dC5jb29yZGluYXRlcz1bW3JbMF0scls0XV0sW3JbM10scls0XV0sW3JbM10sclsxXV0sW3JbMF0sclsxXV1dOnQuY29vcmRpbmF0ZXM9W1tyWzBdLHJbM11dLFtyWzJdLHJbM11dLFtyWzJdLHJbMV1dLFtyWzBdLHJbMV1dXSksdC5pc1dNUyYmIXQuYm91bmRzKXt2YXIgeT10LmNvb3JkaW5hdGVzO3QuYm91bmRzPVtNYXRoLm1pbih5WzBdWzBdLHlbMl1bMF0pLE1hdGgubWluKHlbMF1bMV0seVsyXVsxXSksTWF0aC5tYXgoeVswXVswXSx5WzJdWzBdKSxNYXRoLm1heCh5WzBdWzFdLHlbMl1bMV0pXTt9aWYoKHQuY29vcmRpbmF0ZXN8fHQuYm91bmRzKSYmdC51cmwpcmV0dXJuIHR9cmV0dXJuIG51bGx9LHIucHJvdG90eXBlLl9wYXJzZVJlZ2lvbj1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fcGFyc2VMYXRMb25Cb3goZW4uZ2V0RWxlbWVudEJ5VGFnTmFtZSgiTGF0TG9uQm94IixlKSl9LHIucHJvdG90eXBlLl9wYXJzZUxhdExvbkJveD1mdW5jdGlvbihlKXtpZihlKXt2YXIgdD1lbi5zaW1wbGlmeVhtbE5vZGUoZSkscj1wYXJzZUZsb2F0KHQubm9ydGgpLG49cGFyc2VGbG9hdCh0LnNvdXRoKSxhPXBhcnNlRmxvYXQodC5lYXN0KSxpPXBhcnNlRmxvYXQodC53ZXN0KTtpZihlbi5pc1ZhbGlkTnVtYmVyKHIpJiZlbi5pc1ZhbGlkTnVtYmVyKG4pJiZlbi5pc1ZhbGlkTnVtYmVyKGEpJiZlbi5pc1ZhbGlkTnVtYmVyKGkpKXJldHVybiBbaSxYcihuKSxhLFhyKHIpXX1yZXR1cm4gbnVsbH0sci5wcm90b3R5cGUuX3BhcnNlTGF0TG9uUXVhZD1mdW5jdGlvbihlKXtpZihlKXt2YXIgdD1lbi5nZXRFbGVtZW50QnlUYWdOYW1lKCJjb29yZGluYXRlcyIsZSk7aWYodClyZXR1cm4gdGhpcy5fcGFyc2VDb29yZGluYXRlcyh0KX1yZXR1cm4gbnVsbH0sci5wcm90b3R5cGUuX3BhcnNlTmV0d29ya0xpbms9ZnVuY3Rpb24oZSl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciB0LG4saSxzLG8sdSxsLGMsaCxkLGYscDtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOmZvcih0PSEwLGk9MCxzPWUuY2hpbGROb2RlcztpPHMubGVuZ3RoO2krKylzd2l0Y2goKG89c1tpXSkudGFnTmFtZSl7Y2FzZSJ2aXNpYmlsaXR5Ijp0PWVuLnBhcnNlQm9vbGVhbihvLnZhbHVlKTticmVhaztjYXNlIkxpbmsiOmNhc2UiVXJsIjoodT1lbi5nZXRFbGVtZW50QnlUYWdOYW1lKCJocmVmIixvKSkmJihuPXUudmFsdWUpO31yZXR1cm4gKHR8fHRoaXMuX29wdGlvbnMuaWdub3JlVmlzaWJpbGl0eSkmJm4/KGw9dm9pZCAwLGM9YXIodGhpcy5fb3B0aW9ucyksdGhpcy5fb3B0aW9ucy5tYXhGZWF0dXJlcyE9PTEvMCYmKGMubWF4RmVhdHVyZXM9dGhpcy5fb3B0aW9ucy5tYXhGZWF0dXJlcy10aGlzLl9wYXJzZWREYXRhLmZlYXR1cmVzLmxlbmd0aCksdGhpcy5fcGFyZW50S216JiYoaD10aGlzLl9wYXJlbnRLbXouZmlsZXNbbl0pP1s0LGguYXN5bmMoInRleHQiKV06WzMsM10pOlszLDhdO2Nhc2UgMTpyZXR1cm4gZD1hLnNlbnQoKSxsPW5ldyByKGMsdGhpcy5fYmFzZVVybCx0aGlzLl9jdXJyZW50TmV0d29ya0xpbmtEZXB0aCwhMCksWzQsdGhpcy5fcHJvY2Vzc05ldHdvcmtMaW5rKGwsZCldO2Nhc2UgMjpyZXR1cm4gYS5zZW50KCksWzJdO2Nhc2UgMzppZih0aGlzLl9jdXJyZW50TmV0d29ya0xpbmtEZXB0aD50aGlzLl9vcHRpb25zLm1heE5ldHdvcmtMaW5rRGVwdGh8fHRoaXMuX25ldHdvcmtMaW5rc0xvYWRlZD50aGlzLl9vcHRpb25zLm1heE5ldHdvcmtMaW5rcylyZXR1cm4gWzJdO3RoaXMuX25ldHdvcmtMaW5rc0xvYWRlZCsrLHRoaXMuX251bU5ldHdvcmtMaW5rcysrLGY9ZW4ucGFyc2VVUkwobix0aGlzLl9iYXNlVXJsKSxhLmxhYmVsPTQ7Y2FzZSA0OnJldHVybiBhLnRyeXMucHVzaChbNCw3LCw4XSksWzQsZW4uYWpheEdldEFzeW5jKGYsdGhpcy5fb3B0aW9ucy5wcm94eVNlcnZpY2UsbnVsbCwhMCwiS01MIildO2Nhc2UgNTpyZXR1cm4gcD1hLnNlbnQoKSxsPW5ldyByKGMsZix0aGlzLl9jdXJyZW50TmV0d29ya0xpbmtEZXB0aCsxLCEwKSxbNCx0aGlzLl9wcm9jZXNzTmV0d29ya0xpbmsobCxwKV07Y2FzZSA2OnJldHVybiBhLnNlbnQoKSx0aGlzLl9jdXJyZW50TmV0d29ya0xpbmtEZXB0aC0tLFszLDhdO2Nhc2UgNzpyZXR1cm4gYS5zZW50KCksWzMsOF07Y2FzZSA4OnJldHVybiBbMl19fSkpfSkpfSxyLnByb3RvdHlwZS5fcHJvY2Vzc05ldHdvcmtMaW5rPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciByLG47cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDpyZXR1cm4gdCBpbnN0YW5jZW9mIEFycmF5QnVmZmVyP1s0LGUucmVhZEttekFzeW5jKHQpXTpbMywyXTtjYXNlIDE6cmV0dXJuIHI9YS5zZW50KCksWzMsNF07Y2FzZSAyOnJldHVybiBbNCxlLnJlYWQodCldO2Nhc2UgMzpyPWEuc2VudCgpLGEubGFiZWw9NDtjYXNlIDQ6cmV0dXJuIGUuX2hhc0RyYXdPcmRlciYmKHRoaXMuX2hhc0RyYXdPcmRlcj1lLl9oYXNEcmF3T3JkZXIpLHIuZmVhdHVyZXMmJnRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXMubGVuZ3RoK3IuZmVhdHVyZXMubGVuZ3RoPj10aGlzLl9vcHRpb25zLm1heEZlYXR1cmVzJiYobj10aGlzLl9vcHRpb25zLm1heEZlYXR1cmVzLXRoaXMuX3BhcnNlZERhdGEuZmVhdHVyZXMubGVuZ3RoLHIuZmVhdHVyZXM9ci5mZWF0dXJlcy5zcGxpY2UoMCxuKSksdG4ubWVyZ2UodGhpcy5fcGFyc2VkRGF0YSxyKSx0aGlzLl9udW1OZXR3b3JrTGlua3MrPXIuc3RhdHMubnVtTmV0d29ya0xpbmtzLHRoaXMuX251bUNoYXJhY3RlcnMrPXIuc3RhdHMubnVtQ2hhcmFjdGVycyxbMl19fSkpfSkpfSxyLnByb3RvdHlwZS5fZ2V0R3JvdW5kT3ZlcmxheVVybD1mdW5jdGlvbihlKXtpZih0aGlzLl9wYXJlbnRLbXomJighZW4ucHJvdG9jb2xSeC50ZXN0KGUpfHxlLnN0YXJ0c1dpdGgoInJvb3Q6Ly8iKSkpe3ZhciB0PWUucmVwbGFjZSgicm9vdDovLyIsIiIpLHI9dGhpcy5faW1hZ2VNYW5hZ2VyLmdldEltYWdlKHQpO2lmKHIpcmV0dXJuIHIudXJsfXZhciBuPWVuLnBhcnNlVVJMKGUsdGhpcy5fYmFzZVVybCkuYWJzb2x1dGVQYXRoO3JldHVybiB0aGlzLl9pbWFnZU1hbmFnZXIuaXNDb3JzRW5hYmxlZERvbWFpbihuKT9uOnRoaXMuX29wdGlvbnMucHJveHlTZXJ2aWNlP3RoaXMuX29wdGlvbnMucHJveHlTZXJ2aWNlK246bnVsbH0sci5wcm90b3R5cGUuX3JlcGxhY2VFbWJlZGRlZEltYWdlVXJscz1mdW5jdGlvbihlKXtpZihlKXt2YXIgdD10aGlzLl9pbWFnZU1hbmFnZXIuZ2V0QWxsSW1hZ2VzKCk7aWYodC5sZW5ndGg+MClmb3IodmFyIHI9MCxuPXQ7cjxuLmxlbmd0aDtyKyspe3ZhciBhPW5bcl07ZS5pbmNsdWRlcyhhLmlkKSYmKGU9ZS5zcGxpdChhLmlkKS5qb2luKGEudXJsKSk7fX1yZXR1cm4gZX0sci5wcm90b3R5cGUuX3ByZWxvYWRFbWJlZGRlZEltYWdlPWZ1bmN0aW9uKGUpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgdCxyLG4saTtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOmlmKCF0aGlzLl9wYXJlbnRLbXp8fCF0aGlzLl9zdXBwb3J0SW1hZ2VFeHQudGVzdChlKSlyZXR1cm4gWzMsNV07aWYodD10aGlzLl9wYXJlbnRLbXouZmlsZXNbZV0scj12b2lkIDAsbj12b2lkIDAsKGk9dC5uYW1lLnRvTG93ZXJDYXNlKCkpLmVuZHNXaXRoKCIucG5nIik/cj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LCI6aS5lbmRzV2l0aCgiLmpwZyIpfHxpLmVuZHNXaXRoKCIuanBlZyIpP3I9ImRhdGE6aW1hZ2UvanBnO2Jhc2U2NCwiOmkuZW5kc1dpdGgoIi50aWYiKXx8aS5lbmRzV2l0aCgiLnRpZiIpP3I9ImRhdGE6aW1hZ2UvdGlmZjtiYXNlNjQsIjppLmVuZHNXaXRoKCIuZ2lmIik/cj0iZGF0YTppbWFnZS9naWY7YmFzZTY0LCI6aS5lbmRzV2l0aCgiLmJtcCIpJiYocj0iZGF0YTppbWFnZS9ibXA7YmFzZTY0LCIpLCFyKXJldHVybiBbMyw1XTthLmxhYmVsPTE7Y2FzZSAxOnJldHVybiBhLnRyeXMucHVzaChbMSw0LCw1XSksbj9bMywzXTpbNCx0LmFzeW5jKCJiYXNlNjQiKV07Y2FzZSAyOm49YS5zZW50KCksYS5sYWJlbD0zO2Nhc2UgMzpyZXR1cm4gdGhpcy5faW1hZ2VNYW5hZ2VyLmFkZEltYWdlKHIrbixlLG51bGwsdGhpcy5fb3B0aW9ucy5wcm94eVNlcnZpY2UpLFszLDVdO2Nhc2UgNDpyZXR1cm4gYS5zZW50KCksWzMsNV07Y2FzZSA1OnJldHVybiBbMl19fSkpfSkpfSxyLnByb3RvdHlwZS5fYXBwbHlTdHlsZT1mdW5jdGlvbihlLHQscil7aWYoZS5wcm9wZXJ0aWVzfHwoZS5wcm9wZXJ0aWVzPXt9KSx0aGlzLl9vcHRpb25zLnBhcnNlU3R5bGVzJiZ0KXtzd2l0Y2goZS5nZW9tZXRyeS50eXBlKXtjYXNlIlBvaW50IjpjYXNlIk11bHRpUG9pbnQiOmUucHJvcGVydGllcz1PYmplY3QuYXNzaWduKGUucHJvcGVydGllc3x8e30sdC5pY29uU3R5bGUpO2JyZWFrO2Nhc2UiTGluZVN0cmluZyI6Y2FzZSJNdWx0aUxpbmVTdHJpbmciOmUucHJvcGVydGllcz1PYmplY3QuYXNzaWduKGUucHJvcGVydGllc3x8e30sdC5saW5lU3R5bGUpO2JyZWFrO2Nhc2UiUG9seWdvbiI6Y2FzZSJNdWx0aVBvbHlnb24iOmUucHJvcGVydGllcz1PYmplY3QuYXNzaWduKGUucHJvcGVydGllc3x8e30sdC5wb2x5U3R5bGUpO310LnBvcHVwVGVtcGxhdGUmJihlLnByb3BlcnRpZXMucG9wdXBUZW1wbGF0ZT10LnBvcHVwVGVtcGxhdGUpLHJ8fChlLnByb3BlcnRpZXMudmlzaWJsZT0hMSk7fX0sci5wcm90b3R5cGUuX292ZXJsYXlEcmF3T3JkZXJTb3J0ZXI9ZnVuY3Rpb24oZSx0KXtyZXR1cm4gKGUucHJvcGVydGllcy5fZHJhd29yZGVyP2UucHJvcGVydGllcy5fZHJhd29yZGVyOjApLSh0LnByb3BlcnRpZXMuX2RyYXdvcmRlcj90LnByb3BlcnRpZXMuX2RyYXdvcmRlcjowKX0scn0obW4pLFZuPWZ1bmN0aW9uKCl7ZnVuY3Rpb24gZShlLHQscil7aWYodGhpcy5FT1M9ITEsdGhpcy5FT0w9ITEsdGhpcy5fcG9zaXRpb249MCx0aGlzLl9sZW5ndGg9MCxlKXtpZih0aGlzLl9kZWxpbWl0ZWREYXRhPWUsdGhpcy5fbGVuZ3RoPWUubGVuZ3RoLHRoaXMuX2RlbGltaXRlcj10fHwiLCIsIlxcdCI9PT10aGlzLl9kZWxpbWl0ZXIpdGhpcy5fZGVsaW1pdGVyPSJcdCI7ZWxzZSBpZigiYXV0byI9PT10aGlzLl9kZWxpbWl0ZXIpe3ZhciBuPXRoaXMuX2RlbGltaXRlZERhdGEubWF0Y2goLywvZ2kpLmxlbmd0aCxhPXRoaXMuX2RlbGltaXRlZERhdGEubWF0Y2goL3wvZ2kpLmxlbmd0aCxpPXRoaXMuX2RlbGltaXRlZERhdGEubWF0Y2goL1x0L2dpKS5sZW5ndGg7dGhpcy5fZGVsaW1pdGVyPWk+YSYmaT5uPyJcdCI6YT5uPyJ8IjoiLCI7fXRoaXMuX3RleHRRdWFsaWZpZXI9cnx8JyInO319cmV0dXJuIGUucHJvdG90eXBlLnJlYWQ9ZnVuY3Rpb24oKXtmb3IodmFyIGU9W10sdD10aGlzLmdldE5leHRSb3coKTtudWxsIT10JiZ0Lmxlbmd0aD4wOyllLnB1c2godCksdD10aGlzLmdldE5leHRSb3coKTtyZXR1cm4gZX0sZS5wcm90b3R5cGUuZ2V0TmV4dFJvdz1mdW5jdGlvbigpe2Zvcih2YXIgZT1bXSx0PXRoaXMuX2dldE5leHRDZWxsKCk7bnVsbCE9dDspZS5wdXNoKHQpLHQ9dGhpcy5fZ2V0TmV4dENlbGwoKTtyZXR1cm4gZX0sZS5wcm90b3R5cGUuX2dldE5leHRDZWxsPWZ1bmN0aW9uKCl7aWYodGhpcy5FT0x8fHRoaXMuRU9TKXJldHVybiB0aGlzLkVPTD0hMSx0aGlzLkVPUz0hMSxudWxsO2Zvcih2YXIgZT0hMSx0PSEwLHI9ITEsbj0iIjs7KXt2YXIgYT10aGlzLl9nZXRDaGFyKCEwKTtpZih0aGlzLkVPUylyZXR1cm4gbi5sZW5ndGg+MD9uOm51bGw7aWYoKHJ8fCFlKSYmYT09PXRoaXMuX2RlbGltaXRlcilyZXR1cm4gbjtpZigodHx8cnx8IWUpJiYoIlxuIj09PWF8fCJcciI9PT1hKSlyZXR1cm4gdGhpcy5FT0w9ITAsIlxyIj09PWEmJiJcbiI9PT10aGlzLl9nZXRDaGFyKCExKSYmKGE9dGhpcy5fZ2V0Q2hhcighMCkpLG47dCYmIiAiPT09YXx8KHQmJmE9PT10aGlzLl90ZXh0UXVhbGlmaWVyPyhlPSEwLHQ9ITEpOnQ/KHQ9ITEsbis9YSk6YT09PXRoaXMuX3RleHRRdWFsaWZpZXImJmU/dGhpcy5fZ2V0Q2hhcighMSk9PT10aGlzLl90ZXh0UXVhbGlmaWVyP24rPXRoaXMuX2dldENoYXIoITApOnI9ITA6bis9YSk7fX0sZS5wcm90b3R5cGUuX2dldENoYXI9ZnVuY3Rpb24oZSl7cmV0dXJuIHRoaXMuX3Bvc2l0aW9uPT09dGhpcy5fbGVuZ3RoPyh0aGlzLkVPUz0hMCwiXDAiKToodGhpcy5fcG9zaXRpb24+PXRoaXMuX2xlbmd0aCYmKHRoaXMuX3Bvc2l0aW9uPTApLGU/dGhpcy5fZGVsaW1pdGVkRGF0YVt0aGlzLl9wb3NpdGlvbisrXTp0aGlzLl9kZWxpbWl0ZWREYXRhW3RoaXMuX3Bvc2l0aW9uXSl9LGV9KCksSG49ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKGUsdCl7dGhpcy5fZGVsaW1pdGVyPSIsIix0aGlzLl9kZWxpbWl0ZXI9ZXx8IiwiLHRoaXMuX3RleHRRdWFsaWZpZXI9dHx8JyInLHRoaXMuX3dyaXRlcj1bXTt9cmV0dXJuIGUucHJvdG90eXBlLmNsZWFyPWZ1bmN0aW9uKCl7dGhpcy5fd3JpdGVyPVtdLHRoaXMuX251bUNvbHM9bnVsbDt9LGUucHJvdG90eXBlLndyaXRlPWZ1bmN0aW9uKGUpe2lmKGUmJmUubGVuZ3RoPjAmJmVbMF0ubGVuZ3RoPjApe3RoaXMuX251bUNvbHN8fCh0aGlzLl9udW1Db2xzPWVbMF0ubGVuZ3RoKTtmb3IodmFyIHQ9MCxyPWU7dDxyLmxlbmd0aDt0Kyspe3ZhciBuPXJbdF07dGhpcy5fd3JpdGVSb3cobik7fX19LGUucHJvdG90eXBlLndyaXRlUm93PWZ1bmN0aW9uKGUpe2UmJmUubGVuZ3RoPjAmJih0aGlzLl9udW1Db2xzfHwodGhpcy5fbnVtQ29scz1lLmxlbmd0aCksdGhpcy5fd3JpdGVSb3coZSkpO30sZS5wcm90b3R5cGUudG9TdHJpbmc9ZnVuY3Rpb24oKXtyZXR1cm4gdGhpcy5fd3JpdGVyLmpvaW4oIlxuIil9LGUucHJvdG90eXBlLl93cml0ZVJvdz1mdW5jdGlvbihlKXtmb3IodmFyIHQ9W10scj1NYXRoLm1pbihlLmxlbmd0aCx0aGlzLl9udW1Db2xzKSxuPTA7bjxyO24rKyl0LnB1c2godGhpcy5fZ2V0U3RyaW5nVmFsdWUoZVtuXSkpO3ZhciBhPWUubGVuZ3RoLXI7aWYoYT4wKWZvcih2YXIgaT0wO2k8YTtpKyspdC5wdXNoKG51bGwpO3RoaXMuX3dyaXRlci5wdXNoKHQuam9pbih0aGlzLl9kZWxpbWl0ZXIpKTt9LGUucHJvdG90eXBlLl9nZXRTdHJpbmdWYWx1ZT1mdW5jdGlvbihlKXtpZigib2JqZWN0Ij09dHlwZW9mIGUmJnZvaWQgMCE9PWUudmFsdWUmJm51bGwhPT1lLnZhbHVlJiYoZT1lLnZhbHVlKSxlIGluc3RhbmNlb2YgRGF0ZSllPWUudG9JU09TdHJpbmcoKTtlbHNlIGlmKCJib29sZWFuIj09dHlwZW9mIGV8fCJudW1iZXIiPT10eXBlb2YgZSlyZXR1cm4gZS50b1N0cmluZygpO3JldHVybiBlbi5pc1ZhbGlkU3RyaW5nKGUpP2UuaW5jbHVkZXModGhpcy5fZGVsaW1pdGVyKT8oZS5pbmNsdWRlcyh0aGlzLl90ZXh0UXVhbGlmaWVyKSYmKGU9ZS5yZXBsYWNlKHRoaXMuX3RleHRRdWFsaWZpZXIsIlxcIit0aGlzLl90ZXh0UXVhbGlmaWVyKSksIiIrdGhpcy5fdGV4dFF1YWxpZmllcitlK3RoaXMuX3RleHRRdWFsaWZpZXIpOmU6bnVsbH0sZX0oKSxLbj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt9cmV0dXJuIGUucmVhZD1mdW5jdGlvbihlKXtyZXR1cm4gdGhpcy5fcGFyc2VHZW9tZXRyeShlKX0sZS53cml0ZT1mdW5jdGlvbihlLHQscil7dmFyIG49Njtlbi5pc1ZhbGlkTnVtYmVyKHQpJiZuPj0wJiYobj1NYXRoLm1pbihNYXRoLnJvdW5kKG4pLDEyKSkscj1yfHwhMTt2YXIgYT1bXTtyZXR1cm4gdGhpcy5fd3JpdGUoYSxlLE1hdGgucG93KDEwLG4pLHIpLGEubGVuZ3RoPjA/YS5qb2luKCIiKTpudWxsfSxlLl9wYXJzZUNvb3JkaW5hdGVzPWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciByLG49W10sYT0wLGk9ZS5yZXBsYWNlKC8oXlxzfFxzKyQpL2csIiIpLnNwbGl0KC8sXHMqLyk7YTxpLmxlbmd0aDthKyspe3ZhciBzPWlbYV07bnVsbCE9KHI9dGhpcy5fcGFyc2VDb29yZGluYXRlKHMsdCkpJiZuLnB1c2gocik7fXJldHVybiBufSxlLl9wYXJzZUNvb3JkaW5hdGU9ZnVuY3Rpb24oZSx0KXt2YXIgcj1lLnRyaW0oKS5zcGxpdCgvXHMrLyk7aWYoci5sZW5ndGg+MSl7dmFyIG49W3BhcnNlRmxvYXQoclswXSkscGFyc2VGbG9hdChyWzFdKV07cmV0dXJuIHQmJihyLmxlbmd0aD49Mz9uLnB1c2gocGFyc2VGbG9hdChyWzJdKSk6bi5wdXNoKDApKSxufXJldHVybiBudWxsfSxlLl9wYXJzZUdlb21ldHJ5PWZ1bmN0aW9uKGUpe3ZhciB0O2lmKGUpe2lmKChlPWUudG9Mb3dlckNhc2UoKSkuaW5jbHVkZXMoImVtcHR5IikpcmV0dXJuIG51bGw7dmFyIHI9ZS5zdWJzdHJpbmcoMCxlLmluZGV4T2YoIigiLDApKTtzd2l0Y2gocj1yLnJlcGxhY2UoL1xzKi9nLCIiKSl7Y2FzZSJwb2ludCI6dD10aGlzLl9wYXJzZVBvaW50KGUsITEpO2JyZWFrO2Nhc2UicG9pbnR6IjpjYXNlInBvaW50em0iOnQ9dGhpcy5fcGFyc2VQb2ludChlLCEwKTticmVhaztjYXNlImxpbmVzdHJpbmciOnQ9dGhpcy5fcGFyc2VMaW5lc3RyaW5nKGUsITEpO2JyZWFrO2Nhc2UibGluZXN0cmluZ3oiOmNhc2UibGluZXN0cmluZ3ptIjp0PXRoaXMuX3BhcnNlTGluZXN0cmluZyhlLCEwKTticmVhaztjYXNlInBvbHlnb24iOnQ9dGhpcy5fcGFyc2VQb2x5Z29uKGUsITEpO2JyZWFrO2Nhc2UicG9seWdvbnoiOmNhc2UicG9seWdvbnptIjp0PXRoaXMuX3BhcnNlUG9seWdvbihlLCEwKTticmVhaztjYXNlIm11bHRpcG9pbnQiOnQ9dGhpcy5fcGFyc2VNdWx0aVBvaW50KGUsITEpO2JyZWFrO2Nhc2UibXVsdGlwb2ludHoiOmNhc2UibXVsdGlwb2ludHptIjp0PXRoaXMuX3BhcnNlTXVsdGlQb2ludChlLCEwKTticmVhaztjYXNlIm11bHRpbGluZXN0cmluZyI6dD10aGlzLl9wYXJzZU11bHRpTGluZXN0cmluZyhlLCExKTticmVhaztjYXNlIm11bHRpbGluZXN0cmluZyI6Y2FzZSJtdWx0aWxpbmVzdHJpbmd6IjpjYXNlIm11bHRpbGluZXN0cmluZ3ptIjp0PXRoaXMuX3BhcnNlTXVsdGlMaW5lc3RyaW5nKGUsITApO2JyZWFrO2Nhc2UibXVsdGlwb2x5Z29uIjp0PXRoaXMuX3BhcnNlTXVsdGlQb2x5Z29uKGUsITEpO2JyZWFrO2Nhc2UibXVsdGlwb2x5Z29ueiI6Y2FzZSJtdWx0aXBvbHlnb256bSI6dD10aGlzLl9wYXJzZU11bHRpUG9seWdvbihlLCEwKTticmVhaztjYXNlImdlb21ldHJ5Y29sbGVjdGlvbiI6Y2FzZSJnZW9tZXRyeWNvbGxlY3Rpb256IjpjYXNlImdlb21ldHJ5Y29sbGVjdGlvbnptIjpyZXR1cm4gdGhpcy5fcGFyc2VHZW9tZXRyeUNvbGxlY3Rpb24oZSl9fXJldHVybiB0P1t0XTpudWxsfSxlLl9wYXJzZUdlb21ldHJ5Q29sbGVjdGlvbj1mdW5jdGlvbihlKXtmb3IodmFyIHQscj1bXSxuPTAsYT1lLnJlcGxhY2UoLyhnZW9tZXRyeWNvbGxlY3Rpb25ccypcKHwoXClccyopJCkvZywiIikucmVwbGFjZSgvKFwpKSgsXHMqKShbYS16QS1aXSkvZywiJDF8JDMiKS5zcGxpdCgifCIpO248YS5sZW5ndGg7bisrKXt2YXIgaT1hW25dOyh0PXRoaXMuX3BhcnNlR2VvbWV0cnkoaSkpJiZ0Lmxlbmd0aD4wJiYocj1yLmNvbmNhdCh0KSk7fXJldHVybiByfSxlLl9wYXJzZVBvaW50PWZ1bmN0aW9uKGUsdCl7ZT1lLnJlcGxhY2UoLyhwb2ludHxbXChcKV0qKS9nLCIiKTt2YXIgcj10aGlzLl9wYXJzZUNvb3JkaW5hdGUoZSx0KTtyZXR1cm4gcj97dHlwZToiUG9pbnQiLGNvb3JkaW5hdGVzOnJ9Om51bGx9LGUuX3BhcnNlTGluZXN0cmluZz1mdW5jdGlvbihlLHQpe2U9ZS5yZXBsYWNlKC8obGluZXN0cmluZ3xbXChcKV0qfF5ccyp8XHMkKS9nLCIiKTt2YXIgcj10aGlzLl9wYXJzZUNvb3JkaW5hdGVzKGUsdCk7cmV0dXJuIHI/e3R5cGU6IkxpbmVTdHJpbmciLGNvb3JkaW5hdGVzOnJ9Om51bGx9LGUuX3BhcnNlUG9seWdvbj1mdW5jdGlvbihlLHQpe2Zvcih2YXIgcj1bXSxuPTAsYT1lLnJlcGxhY2UoLyhwb2x5Z29ufFwoXCh8XClcKSkvZywiIikuc3BsaXQoL1wpLFxzKlwoLyk7bjxhLmxlbmd0aDtuKyspe3ZhciBpPWFbbl07ci5wdXNoKHRoaXMuX3BhcnNlQ29vcmRpbmF0ZXMoaSx0KSk7fXJldHVybiByLmxlbmd0aD4wP3t0eXBlOiJQb2x5Z29uIixjb29yZGluYXRlczpyfTpudWxsfSxlLl9wYXJzZU11bHRpUG9pbnQ9ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHI9W10sbj0wLGE9ZS5yZXBsYWNlKC8obXVsdGlwb2ludHxbXChcKV0qKS9nLCIiKS5zcGxpdCgvLFxzKi8pO248YS5sZW5ndGg7bisrKXt2YXIgaT1hW25dO3IucHVzaCh0aGlzLl9wYXJzZUNvb3JkaW5hdGUoaSx0KSk7fXJldHVybiByLmxlbmd0aD4wP3t0eXBlOiJNdWx0aVBvaW50Iixjb29yZGluYXRlczpyfTpudWxsfSxlLl9wYXJzZU11bHRpTGluZXN0cmluZz1mdW5jdGlvbihlLHQpe2Zvcih2YXIgcj1bXSxuPTAsYT1lLnJlcGxhY2UoLyhtdWx0aWxpbmVzdHJpbmd8XChcKHxcKVwpKS9nLCIiKS5zcGxpdCgvXCksXHMqXCgvKTtuPGEubGVuZ3RoO24rKyl7dmFyIGk9YVtuXTtyLnB1c2godGhpcy5fcGFyc2VDb29yZGluYXRlcyhpLHQpKTt9cmV0dXJuIHIubGVuZ3RoPjA/e3R5cGU6Ik11bHRpTGluZVN0cmluZyIsY29vcmRpbmF0ZXM6cn06bnVsbH0sZS5fcGFyc2VNdWx0aVBvbHlnb249ZnVuY3Rpb24oZSx0KXtmb3IodmFyIHIsbj1bXSxhPTAsaT1lLnJlcGxhY2UoLyhtdWx0aXBvbHlnb258XChcKFwofFwpXClcKSkvZywiIikuc3BsaXQoL1wpXCksXHMqXChcKC8pO2E8aS5sZW5ndGg7YSsrKXtyPVtdO2Zvcih2YXIgcz0wLG89aVthXS5zcGxpdCgvXCksXHMqXCgvKTtzPG8ubGVuZ3RoO3MrKyl7dmFyIHU9b1tzXTtyLnB1c2godGhpcy5fcGFyc2VDb29yZGluYXRlcyh1LHQpKTt9ci5sZW5ndGg+MCYmbi5wdXNoKHIpO31yZXR1cm4gbi5sZW5ndGg+MD97dHlwZToiTXVsdGlQb2x5Z29uIixjb29yZGluYXRlczpufTpudWxsfSxlLl93cml0ZUNvb3JkaW5hdGU9ZnVuY3Rpb24oZSx0LHIsbil7ZS5wdXNoKChNYXRoLnJvdW5kKHRbMF0qcikvcikudG9TdHJpbmcoKSwiICIsKE1hdGgucm91bmQodFsxXSpyKS9yKS50b1N0cmluZygpKSxuJiYodC5sZW5ndGg+PTM/ZS5wdXNoKCIgIix0WzJdLnRvU3RyaW5nKCkpOmUucHVzaCgiIDAiKSk7fSxlLl93cml0ZUNvb3JkaW5hdGVzPWZ1bmN0aW9uKGUsdCxyLG4pe2UucHVzaCgiKCIpO2Zvcih2YXIgYT10Lmxlbmd0aCxpPTA7aTxhO2krKyl0aGlzLl93cml0ZUNvb3JkaW5hdGUoZSx0W2ldLHIsbiksaTxhLTEmJmUucHVzaCgiLCIpO2UucHVzaCgiKSIpO30sZS5fd3JpdGVSaW5ncz1mdW5jdGlvbihlLHQscixuLGEpe2UucHVzaCgiKCIpO2Zvcih2YXIgaT10Lmxlbmd0aCxzPTA7czxpO3MrKylyJiZlbi5jbG9zZVJpbmcodFtzXSksdGhpcy5fd3JpdGVDb29yZGluYXRlcyhlLHRbc10sbixhKSxzPGktMSYmZS5wdXNoKCIsIik7ZS5wdXNoKCIpIik7fSxlLl93cml0ZVBvaW50PWZ1bmN0aW9uKGUsdCxyLG4pe2UucHVzaCgiUE9JTlQiLG4/IiBaKCI6IigiKSx0aGlzLl93cml0ZUNvb3JkaW5hdGUoZSx0LmNvb3JkaW5hdGVzLHIsbiksZS5wdXNoKCIpIik7fSxlLl93cml0ZUxpbmVzdHJpbmc9ZnVuY3Rpb24oZSx0LHIsbil7ZS5wdXNoKCJMSU5FU1RSSU5HIixuPyIgWiI6IiIpLHRoaXMuX3dyaXRlQ29vcmRpbmF0ZXMoZSx0LmNvb3JkaW5hdGVzLHIsbik7fSxlLl93cml0ZVBvbHlnb249ZnVuY3Rpb24oZSx0LHIsbil7ZS5wdXNoKCJQT0xZR09OIixuPyIgWiI6IiIpLHRoaXMuX3dyaXRlUmluZ3MoZSx0LmNvb3JkaW5hdGVzLCEwLHIsbik7fSxlLl93cml0ZU11bHRpUG9pbnQ9ZnVuY3Rpb24oZSx0LHIsbil7ZS5wdXNoKCJNVUxUSVBPSU5UIixuPyIgWiI6IiIpLHRoaXMuX3dyaXRlQ29vcmRpbmF0ZXMoZSx0LmNvb3JkaW5hdGVzLHIsbik7fSxlLl93cml0ZU11bHRpTGluZVN0cmluZz1mdW5jdGlvbihlLHQscixuKXtlLnB1c2goIk1VTFRJTElORVNUUklORyIsbj8iIFoiOiIiKSx0aGlzLl93cml0ZVJpbmdzKGUsdC5jb29yZGluYXRlcywhMSxyLG4pO30sZS5fd3JpdGVNdWx0aVBvbHlnb249ZnVuY3Rpb24oZSx0LHIsbil7ZS5wdXNoKCJNVUxUSVBPTFlHT04iLG4/IiBaKCI6IigiKTtmb3IodmFyIGE9dC5jb29yZGluYXRlcy5sZW5ndGgsaT0wO2k8YTtpKyspdGhpcy5fd3JpdGVSaW5ncyhlLHQuY29vcmRpbmF0ZXNbaV0sITAscixuKSxpPGEtMSYmZS5wdXNoKCIsIik7ZS5wdXNoKCIpIik7fSxlLl93cml0ZUdlb21ldHJ5Q29sbGVjdGlvbj1mdW5jdGlvbihlLHQscixuKXt2YXIgYT10JiZ0Lmxlbmd0aDtlLnB1c2goIkdFT01FVFJZQ09MTEVDVElPTiIsbj8iIFooIjoiKCIpO2Zvcih2YXIgaT0wO2k8YTtpKyspdGhpcy5fd3JpdGUoZSx0W2ldLHIsbiksaTxhLTEmJmUucHVzaCgiLCIpO2UucHVzaCgiKSIpO30sZS5fd3JpdGU9ZnVuY3Rpb24oZSx0LHIsbil7aWYodClpZihBcnJheS5pc0FycmF5KHQpKXRoaXMuX3dyaXRlR2VvbWV0cnlDb2xsZWN0aW9uKGUsdCxyLG4pO2Vsc2Ugc3dpdGNoKHQudHlwZSl7Y2FzZSJQb2ludCI6cmV0dXJuIHRoaXMuX3dyaXRlUG9pbnQoZSx0LHIsbik7Y2FzZSJMaW5lU3RyaW5nIjpyZXR1cm4gdGhpcy5fd3JpdGVMaW5lc3RyaW5nKGUsdCxyLG4pO2Nhc2UiUG9seWdvbiI6cmV0dXJuIHRoaXMuX3dyaXRlUG9seWdvbihlLHQscixuKTtjYXNlIk11bHRpUG9pbnQiOnJldHVybiB0aGlzLl93cml0ZU11bHRpUG9pbnQoZSx0LHIsbik7Y2FzZSJNdWx0aUxpbmVTdHJpbmciOnJldHVybiB0aGlzLl93cml0ZU11bHRpTGluZVN0cmluZyhlLHQscixuKTtjYXNlIk11bHRpUG9seWdvbiI6cmV0dXJuIHRoaXMuX3dyaXRlTXVsdGlQb2x5Z29uKGUsdCxyLG4pO2Nhc2UiRmVhdHVyZSI6cmV0dXJuIHRoaXMuX3dyaXRlKGUsdC5nZW9tZXRyeSxyLG4pfX0sZX0oKSxxbj1mdW5jdGlvbihlKXtmdW5jdGlvbiByKCl7dmFyIHQ9bnVsbCE9PWUmJmUuYXBwbHkodGhpcyxhcmd1bWVudHMpfHx0aGlzO3JldHVybiB0LnNwYXRpYWxmb3JtYXQ9IndrdCIsdC5sYXRDb2xOYW1lPSJsYXQiLHQubG9uQ29sTmFtZT0ibG9uIix0LmVsdkNvbE5hbWU9ImVsdiIsdC5nZW9Db2xOYW1lPSJnZW8iLHQuZGVsaW1pdGVyPSIsIix0LnRleHRRdWFsaWZpZXI9JyInLHQuaW5jbHVkZVR5cGVzSW5IZWFkZXI9ITEsdH1yZXR1cm4gdChyLGUpLHJ9KGZ1bmN0aW9uKGUpe2Z1bmN0aW9uIHIoKXt2YXIgdD1udWxsIT09ZSYmZS5hcHBseSh0aGlzLGFyZ3VtZW50cyl8fHRoaXM7cmV0dXJuIHQuZm9ybWF0PSJHZW9KU09OIix0fXJldHVybiB0KHIsZSkscn0obm4pKSxYbj1mdW5jdGlvbigpe2Z1bmN0aW9uIGUoKXt9cmV0dXJuIGUucmVhZD1mdW5jdGlvbihlLHQpe2lmKCgibnVtYmVyIiE9dHlwZW9mKHQ9dHx8e21heEZlYXR1cmVzOjEvMH0pLm1heEZlYXR1cmVzfHx0Lm1heEZlYXR1cmVzPD0wKSYmKHQubWF4RmVhdHVyZXM9MS8wKSwhdC5kZWxpbWl0ZXJ8fCIiPT09dC5kZWxpbWl0ZXJ8fCJhdXRvIj09PXQuZGVsaW1pdGVyKXt2YXIgcj1lLmluZGV4T2YoIlxuIiksbj1lLnN1YnN0cmluZygwLHIpO24udG9Mb3dlckNhc2UoKS5zdGFydHNXaXRoKCJiaW5nIHNwYXRpYWwgZGF0YSBzZXJ2aWNlcyIpJiYobj1lLnN1YnN0cmluZyhyLGUuaW5kZXhPZigiXG4iLHIrMSkpKTt2YXIgYT0obi5tYXRjaCgvLC9nKXx8W10pLmxlbmd0aCxpPShuLm1hdGNoKC9bfF0vZyl8fFtdKS5sZW5ndGgscz0obi5tYXRjaCgvXHQvZyl8fFtdKS5sZW5ndGg7YT49aSYmYT49cz90LmRlbGltaXRlcj0iLCI6aT49YSYmaT49cz90LmRlbGltaXRlcj0ifCI6cz49YSYmcz49aSYmKHQuZGVsaW1pdGVyPSJcdCIpO312YXIgbyx1PVtdLGw9bmV3IFZuKGUsdC5kZWxpbWl0ZXIpLGM9bC5nZXROZXh0Um93KCk7aWYobnVsbCE9YyYmYy5sZW5ndGg+MCl7Y1swXS50b0xvd2VyQ2FzZSgpLnN0YXJ0c1dpdGgoImJpbmcgc3BhdGlhbCBkYXRhIHNlcnZpY2VzIikmJihjPWwuZ2V0TmV4dFJvdygpKTt2YXIgaD0hMTtpZih0LmhlYWRlcilvPXQuaGVhZGVyLGg9ITA7ZWxzZSB7bz10aGlzLnBhcnNlSGVhZGVyKGMpLGM9bC5nZXROZXh0Um93KCk7Zm9yKHZhciBkPTAsZj0wLHA9by5uYW1lcy5sZW5ndGg7ZjxwO2YrKylpZigic3RyaW5nIiE9PW8udHlwZXNbZl0mJiJnZW9ncmFwaHkiIT09by50eXBlc1tmXSl7dmFyIG09by5uYW1lc1tmXS50b0xvd2VyQ2FzZSgpO3RoaXMuX2xhdGl0dWRlTmFtZXMuaGFzKG0pfHx0aGlzLl9sb25naXR1ZGVOYW1lcy5oYXMobSl8fHRoaXMuX2VsZXZhdGlvbk5hbWVzLmhhcyhtKXx8ZCsrO31kPjAmJihoPSEwKTt9aWYoIXRoaXMudmFsaWRhdGVIZWFkZXIobyxjKSl0aHJvdyBuZXcgRXJyb3IoIlVuYWJsZSB0byBwYXJzZSBoZWFkZXIiKTt2YXIgZz0hMTtmb3IoIWgmJnQuZHluYW1pY1R5cGluZyYmKGc9ITApO251bGwhPWMmJmMubGVuZ3RoPjA7KXt2YXIgXz10aGlzLnBhcnNlUm93KGMsbyxnKTtpZihudWxsIT1fJiYoIlBvaW50Ij09PV8uZ2VvbWV0cnkudHlwZSYmIkNpcmNsZSI9PT1fLnByb3BlcnRpZXMuc3ViVHlwZSYmZW4uaXNWYWxpZE51bWJlcihfLnByb3BlcnRpZXMucmFkaXVzKSYmKF8ucHJvcGVydGllcy5yYWRpdXM9cGFyc2VGbG9hdChfLnByb3BlcnRpZXMucmFkaXVzKSksdS5wdXNoKF8pLHUubGVuZ3RoPj10Lm1heEZlYXR1cmVzKSlicmVhaztjPWwuZ2V0TmV4dFJvdygpO319cmV0dXJuIHt0eXBlOiJGZWF0dXJlQ29sbGVjdGlvbiIsZmVhdHVyZXM6dX19LGUud3JpdGU9ZnVuY3Rpb24odCxyKXt2YXIgbj10aGlzO2lmKHQmJnQubGVuZ3RoPjApe3I9KG5ldyBxbikubWVyZ2Uocik7dmFyIGE9W10saT1bXSxzPWFyKHRoaXMuX2lnbm9yZVByb3BlcnRpZXMpOyJ3a3QiPT09ci5zcGF0aWFsZm9ybWF0P3MucHVzaChyLmdlb0NvbE5hbWUpOihzLnB1c2goci5sYXRDb2xOYW1lKSxzLnB1c2goci5sb25Db2xOYW1lKSwibGF0bG9uZWx2Ij09PXIuc3BhdGlhbGZvcm1hdCYmcy5wdXNoKHIuZWx2Q29sTmFtZSkpO2Zvcih2YXIgbz12b2lkIDAhPT10WzBdLnByb3BlcnRpZXNbci5lbHZDb2xOYW1lXT9yLmVsdkNvbE5hbWU6bnVsbCx1PSExLGw9ZnVuY3Rpb24odCl7bnVsbCE9dC5pZCYmIiIhPT10LmlkJiYodT0hMCksIndrdCIhPT1yLnNwYXRpYWxmb3JtYXQmJiJQb2ludCIhPT10Lmdlb21ldHJ5LnR5cGV8fE9iamVjdC5rZXlzKHQucHJvcGVydGllcykuZm9yRWFjaCgoZnVuY3Rpb24ocil7aWYoIXIuc3RhcnRzV2l0aCgiXyIpJiYhYS5pbmNsdWRlcyhyKSYmIW4uX2lnbm9yZVByb3BlcnRpZXMuaW5jbHVkZXMocikpe3ZhciBzPXQucHJvcGVydGllc1tyXTtpZihudWxsIT1zJiYiIiE9PXMpe3ZhciB1PXR5cGVvZiBzO3MgaW5zdGFuY2VvZiBEYXRlJiYodT0iZGF0ZSIpLG4uX2FsbG93ZWRUeXBlcy5oYXModSkmJihhLnB1c2gociksaS5wdXNoKHUpKSwhbyYmZS5fZWxldmF0aW9uTmFtZXMuaGFzKHIpJiYobz1yKTt9fX0pKTt9LGM9MCxoPXQ7YzxoLmxlbmd0aDtjKyspe2woYj1oW2NdKTt9dmFyIGQ9bmV3IEhuKHIuZGVsaW1pdGVyLHIudGV4dFF1YWxpZmllciksZj1bXTtpZih1JiZmLnB1c2goci5pbmNsdWRlVHlwZXNJbkhlYWRlcj8iaWQoc3RyaW5nKSI6ImlkIiksci5pbmNsdWRlVHlwZXNJbkhlYWRlcil7Zm9yKHZhciBwPTAsbT1hLmxlbmd0aDtwPG07cCsrKWYucHVzaChhW3BdKyIoIitpW3BdKyIpIik7IndrdCI9PT1yLnNwYXRpYWxmb3JtYXQ/Zi5wdXNoKHIuZ2VvQ29sTmFtZSsiKGdlb2dyYXBoeSkiKTooZi5wdXNoKHIubGF0Q29sTmFtZSsiKG51bWJlcikiKSxmLnB1c2goci5sb25Db2xOYW1lKyIobnVtYmVyKSIpLCJsYXRsb25lbHYiPT09ci5zcGF0aWFsZm9ybWF0JiZmLnB1c2goci5lbHZDb2xOYW1lKyIobnVtYmVyKSIpKTt9ZWxzZSBmPWYuY29uY2F0KGEpLCJ3a3QiPT09ci5zcGF0aWFsZm9ybWF0P2YucHVzaChyLmdlb0NvbE5hbWUpOihmLnB1c2goci5sYXRDb2xOYW1lKSxmLnB1c2goci5sb25Db2xOYW1lKSwibGF0bG9uZWx2Ij09PXIuc3BhdGlhbGZvcm1hdCYmZi5wdXNoKHIuZWx2Q29sTmFtZSkpO2Qud3JpdGVSb3coZik7Zm9yKHZhciBnPXZvaWQgMCxfPXZvaWQgMCx5PTAsdj10O3k8di5sZW5ndGg7eSsrKXt2YXIgYjtpZihnPShiPXZbeV0pLmdlb21ldHJ5LCJ3a3QiPT09ci5zcGF0aWFsZm9ybWF0fHwiUG9pbnQiPT09Zy50eXBlKXtmPXU/W2IuaWRdOltdLF89Yi5wcm9wZXJ0aWVzO2Zvcih2YXIgdz0wLGs9YTt3PGsubGVuZ3RoO3crKyl7dmFyIE49a1t3XTtmLnB1c2goX1tOXSk7fSJ3a3QiPT09ci5zcGF0aWFsZm9ybWF0P2YucHVzaChLbi53cml0ZShnKSk6KGYucHVzaChnLmNvb3JkaW5hdGVzWzFdKSxmLnB1c2goZy5jb29yZGluYXRlc1swXSksImxhdGxvbmVsdiI9PT1yLnNwYXRpYWxmb3JtYXQmJihnLmNvb3JkaW5hdGVzLmxlbmd0aD49Mz9mLnB1c2goZy5jb29yZGluYXRlc1syXSk6dm9pZCAwIT09X1tvXT9mLnB1c2goX1tvXSk6Zi5wdXNoKDApKSksZC53cml0ZVJvdyhmKTt9fXJldHVybiBkLnRvU3RyaW5nKCl9cmV0dXJuIG51bGx9LGUudmFsaWRhdGVIZWFkZXI9ZnVuY3Rpb24oZSx0KXtpZighZXx8IWUubmFtZXN8fDA9PT1lLm5hbWVzLmxlbmd0aClyZXR1cm4gITE7QXJyYXkuaXNBcnJheShlLnR5cGVzKXx8KGUudHlwZXM9W10pO2Zvcih2YXIgcj0hMSxuPSExLGE9ITEsaT0wLHM9ZS5uYW1lcy5sZW5ndGg7aTxzO2krKyl7dmFyIG89ZS5uYW1lc1tpXS50b0xvd2VyQ2FzZSgpO2UudHlwZXMubGVuZ3RoLTE+aT9lLnR5cGVzW2ldPXRoaXMudmFsaWRhdGVUeXBlKGUudHlwZXNbaV0sbyk6ZS50eXBlcy5wdXNoKHRoaXMudmFsaWRhdGVUeXBlKG51bGwsbykpLHRoaXMuX2xhdGl0dWRlTmFtZXMuaGFzKG8pP249ITA6dGhpcy5fbG9uZ2l0dWRlTmFtZXMuaGFzKG8pP2E9ITA6Imdlb2dyYXBoeSI9PT1lLnR5cGVzW2ldJiYocj0hMCk7fWlmKG4mJmF8fHIpcmV0dXJuICEwO2lmKHQmJnQubGVuZ3RoPjApZm9yKHM9TWF0aC5taW4oZS5uYW1lcy5sZW5ndGgsdC5sZW5ndGgpLGk9MDtpPHM7aSsrKWlmKHRoaXMuX3drdFJ4LnRlc3QodFtpXSkpcmV0dXJuIGUudHlwZXNbaV09Imdlb2dyYXBoeSIsITA7cmV0dXJuICExfSxlLnZhbGlkYXRlVHlwZT1mdW5jdGlvbihlLHQpe3ZhciByO3N3aXRjaCgoZT1lfHwiIikudG9Mb3dlckNhc2UoKSl7Y2FzZSJlZG0uaW50NjQiOmNhc2UiaW50IjpjYXNlImxvbmciOmNhc2UiZWRtLmRvdWJsZSI6Y2FzZSJmbG9hdCI6Y2FzZSJkb3VibGUiOmNhc2UibnVtYmVyIjpyPSJudW1iZXIiO2JyZWFrO2Nhc2UiZWRtLmJvb2xlYW4iOmNhc2UiYm9vbCI6Y2FzZSJib29sZWFuIjpyPSJib29sZWFuIjticmVhaztjYXNlImVkbS5kYXRldGltZSI6Y2FzZSJkYXRlIjpjYXNlImRhdGV0aW1lIjpyPSJkYXRlIjticmVhaztjYXNlImVkbS5nZW9ncmFwaHkiOmNhc2UiZ2VvZ3JhcGh5IjpyPSJnZW9ncmFwaHkiO2JyZWFrO2Nhc2UiZWRtLnN0cmluZyI6Y2FzZSJ2YXJjaGFyIjpjYXNlInRleHQiOmNhc2Uic3RyaW5nIjpkZWZhdWx0OnI9InN0cmluZyI7fWlmKCJnZW9ncmFwaHkiIT09cil7dmFyIG49dC50b0xvd2VyQ2FzZSgpOyh0aGlzLl9sYXRpdHVkZU5hbWVzLmhhcyhuKXx8dGhpcy5fbG9uZ2l0dWRlTmFtZXMuaGFzKG4pfHx0aGlzLl9lbGV2YXRpb25OYW1lcy5oYXMobikpJiYocj0ibnVtYmVyIik7fXJldHVybiByfSxlLnBhcnNlSGVhZGVyPWZ1bmN0aW9uKGUpe2Zvcih2YXIgdCxyLG49W10sYT1bXSxpPTAscz1lLmxlbmd0aDtpPHM7aSsrKXtpZih0PWVbaV0scj0ic3RyaW5nIixpPHMtMSYmZVtpKzFdLnRvTG93ZXJDYXNlKCkuc3RhcnRzV2l0aCgicHJpbWFyeWtleSkiKSl0PXQuc3Vic3RyaW5nKDAsdC5pbmRleE9mKCIoIikpLChyPWVbaV0uc3Vic3RyaW5nKGVbaV0uaW5kZXhPZigiKCIpKzEpKS5pbmNsdWRlcygiLCIpJiYocj1yLnJlcGxhY2UoIiwiLCIiKSksaSsrO2Vsc2UgaWYodGhpcy5faGVhZGVyUmVnZXgudGVzdCh0KSl7dmFyIG89dC5tYXRjaCh0aGlzLl9oZWFkZXJSZWdleCk7byYmby5sZW5ndGg+PTMmJih0PW9bMV0sKHI9b1syXSkuaW5jbHVkZXMoIiwiKSYmKHI9ci5zdWJzdHJpbmcoMCxyLmluZGV4T2YoIiwiKSkpKTt9KHQ9dC50cmltKCkpLmluY2x1ZGVzKCIgIikmJih0PXQucmVwbGFjZSgvXHMvZywiXyIpKSxuLmluY2x1ZGVzKHQpPyh0PSJDb2x1bW5fIitpLG4ucHVzaCh0KSk6bi5wdXNoKHQpLGEucHVzaCh0aGlzLnZhbGlkYXRlVHlwZShyLHQpKTt9cmV0dXJuIHtuYW1lczpuLHR5cGVzOmF9fSxlLnBhcnNlUm93PWZ1bmN0aW9uKHQscixuKXtmb3IodmFyIGEsaT1udWxsLHM9e30sbz1OYU4sdT1OYU4sbD1OYU4sYz1NYXRoLm1pbih0Lmxlbmd0aCxyLm5hbWVzLmxlbmd0aCksaD0wO2g8YztoKyspe3N3aXRjaChhPW51bGwsci50eXBlc1toXSl7Y2FzZSJudW1iZXIiOmlmKGE9cGFyc2VGbG9hdCh0W2hdKSxlbi5pc1ZhbGlkTnVtYmVyKGEpKXt2YXIgZD1yLm5hbWVzW2hdLnRvTG93ZXJDYXNlKCk7dGhpcy5fbGF0aXR1ZGVOYW1lcy5oYXMoZCk/bz1hOnRoaXMuX2xvbmdpdHVkZU5hbWVzLmhhcyhkKT91PWE6dGhpcy5fZWxldmF0aW9uTmFtZXMuaGFzKGQpJiYobD1hKTt9ZWxzZSBhPW51bGw7YnJlYWs7Y2FzZSJib29sZWFuIjphPWVuLnBhcnNlQm9vbGVhbih0W2hdKTticmVhaztjYXNlImRhdGUiOmE9SnIodFtoXSk7YnJlYWs7Y2FzZSJnZW9ncmFwaHkiOmk9S24ucmVhZCh0W2hdKSxhPW51bGw7YnJlYWs7Y2FzZSJzdHJpbmciOmRlZmF1bHQ6aWYobilpZihlLl9ib29sUmVnZXgudGVzdCh0W2hdKSlhPSJ0cnVlIj09PXRbaF0udG9Mb3dlckNhc2UoKTtlbHNlIGlmKGUuX251bVJ4LnRlc3QodFtoXSkpe2E9cGFyc2VGbG9hdCh0W2hdKSwoZD1yLm5hbWVzW2hdLnRvTG93ZXJDYXNlKCkpLmluY2x1ZGVzKCJkYXRlIikmJihhPW5ldyBEYXRlKGEpKTt9ZWxzZSB7dmFyIGY9SnIodFtoXSk7YT1udWxsIT09Zj9mOnRbaF07fWVsc2UgYT10W2hdO31udWxsIT1hJiYiIiE9PWEmJihzW3IubmFtZXNbaF1dPWEpO31pZihudWxsIT09aSYmaS5sZW5ndGg+MClyZXR1cm4ge2dlb21ldHJ5OmlbMF0scHJvcGVydGllczpzLHR5cGU6IkZlYXR1cmUifTtpZihlbi5pc1ZhbGlkTnVtYmVyKG8pJiZlbi5pc1ZhbGlkTnVtYmVyKHUpKXt2YXIgcD1bdSxvXTtyZXR1cm4gZW4uaXNWYWxpZE51bWJlcihsKSYmcC5wdXNoKGwpLHtnZW9tZXRyeTp7Y29vcmRpbmF0ZXM6cCx0eXBlOiJQb2ludCJ9LHByb3BlcnRpZXM6cyx0eXBlOiJGZWF0dXJlIn19cmV0dXJuIG51bGx9LGUuY2hlY2tJZHM9ZnVuY3Rpb24oZSl7cmV0dXJuIGUuc29tZSgoZnVuY3Rpb24oZSl7cmV0dXJuIG51bGwhPWUuaWQmJiIiIT09ZS5pZH0pKX0sZS5fbGF0aXR1ZGVOYW1lcz1uZXcgU2V0KFsibGF0aXR1ZGUiLCJsYXQiLCJsYXRkZCIsImxhdF9kZCIsImxhdGl0dWRlODMiLCJsYXRkZWNkZWciLCJ5IiwieWNlbnRlciIsInBvaW50LXkiXSksZS5fbG9uZ2l0dWRlTmFtZXM9bmV3IFNldChbImxvbmdpdHVkZSIsImxvbiIsImxuZyIsImxvbmciLCJsb25nZGQiLCJsb25nX2RkIiwibG9uZ2l0dWRlODMiLCJsb25nZGVjZGVnIiwieCIsInhjZW50ZXIiLCJwb2ludC14Il0pLGUuX2VsZXZhdGlvbk5hbWVzPW5ldyBTZXQoWyJlbGV2YXRpb24iLCJlbHYiLCJhbHRpdHVkZSIsImFsdCIsInoiXSksZS5faGVhZGVyUmVnZXg9L15ccyooW2EtekEtWjAtOV9dKylcKChbYS16QS1aMC05XC4sXSspXClccyokLyxlLl9ib29sUmVnZXg9L15ccyoodHJ1ZXxmYWxzZSlccyokL2ksZS5fbnVtUng9L15ccypbMC05XStccyokLyxlLl93a3RSeD0vXlxzKihwb2ludHxsaW5lc3RyaW5nfHBvbHlnb258bXVsdGlwb2ludHxtdWx0aWxpbmVzdHJpbmd8bXVsdGlwb2x5Z29ufGdlb21ldHJ5Y29sbGVjdGlvbilbel0/W21dP1xzKlwoL2ksZS5fYWxsb3dlZFR5cGVzPW5ldyBTZXQoWyJzdHJpbmciLCJudW1iZXIiLCJkYXRlIiwiYm9vbGVhbiJdKSxlLl9pZ25vcmVQcm9wZXJ0aWVzPVsiaW1hZ2UiLCJpbWFnZVVybCJdLGV9KCksWW49ZnVuY3Rpb24oKXtmdW5jdGlvbiBlKCl7fXJldHVybiBlLnJlYWQ9ZnVuY3Rpb24oZSx0LHIpe3ZhciBuPXRoaXM7cmV0dXJuIG5ldyBQcm9taXNlKChmdW5jdGlvbihhLGkpe2lmKGV8fGEobmV3IHRuKSx0PWZuKHQpLGUgaW5zdGFuY2VvZiBBcnJheUJ1ZmZlciluLl9yZWFkQXJyYXlCdWZmZXIoZSx0LHIpLnRoZW4oYSxpKTtlbHNlIGlmKGUgaW5zdGFuY2VvZiBCbG9iKXt2YXIgcz1uZXcgRmlsZVJlYWRlcjtzLm9ubG9hZD1mdW5jdGlvbihlKXtuLl9yZWFkQXJyYXlCdWZmZXIoZS50YXJnZXQucmVzdWx0LHQscikudGhlbihhLGkpO30scy5yZWFkQXNBcnJheUJ1ZmZlcihlKTt9ZWxzZSBuLl9yZWFkU3RyaW5nKGUsdCxyKS50aGVuKGEsaSk7fSkpfSxlLl9yZWFkU3RyaW5nPWZ1bmN0aW9uKGUsdCxyKXtyZXR1cm4gbih0aGlzLHZvaWQgMCx2b2lkIDAsKGZ1bmN0aW9uKCl7dmFyIG4saSxzLG8sdSxsLGMsaDtyZXR1cm4gYSh0aGlzLChmdW5jdGlvbihhKXtzd2l0Y2goYS5sYWJlbCl7Y2FzZSAwOmlmKGU9ZS50cmltKCksISgobj1lLnN1YnN0cmluZygwLE1hdGgubWluKGUubGVuZ3RoLDUwMCkpLm1hdGNoKC88KFx3KzopPyhcdyspLykpJiZuLmxlbmd0aD49MykpcmV0dXJuIFszLDEyXTtzd2l0Y2goaT1uWzJdLHM9dm9pZCAwLGkpe2Nhc2Uia21sIjpyZXR1cm4gWzMsMV07Y2FzZSJncHgiOnJldHVybiBbMywzXTtjYXNlInJzcyI6Y2FzZSJmZWVkIjpyZXR1cm4gWzMsNV07Y2FzZSJGZWF0dXJlSW5mb1Jlc3BvbnNlIjpyZXR1cm4gWzMsN107Y2FzZSJNdWx0aUdlb21ldHJ5IjpjYXNlIkZlYXR1cmVDb2xsZWN0aW9uIjpjYXNlIlBvaW50IjpjYXNlIkxpbmVTdHJpbmciOmNhc2UiUG9seWdvbiI6Y2FzZSJNdWx0aVBvaW50IjpjYXNlIk11bHRpTGluZVN0cmluZyI6Y2FzZSJNdWx0aUN1cnZlIjpjYXNlIk11bHRpU3VyZmFjZSI6Y2FzZSJNdWx0aVBvbHlnb24iOmNhc2UiRmVhdHVyZSI6Y2FzZSJtc0dNTE91dHB1dCI6cmV0dXJuIFszLDhdfXJldHVybiBbMyw5XTtjYXNlIDE6cmV0dXJuIFs0LG5ldyBabih0LHIpLnJlYWQoZSldO2Nhc2UgMjpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgMzpyZXR1cm4gWzQsbmV3IEduKHQpLnJlYWQoZSldO2Nhc2UgNDpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgNTpyZXR1cm4gWzQsbmV3IFduKHQpLnJlYWQoZSldO2Nhc2UgNjpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgNzpyZXR1cm4gcz1nbi5yZWFkKGUpLFszLDEwXTtjYXNlIDg6cmV0dXJuIHM9bG4ucmVhZChlLHQpLFszLDEwXTtjYXNlIDk6cmV0dXJuIFszLDEwXTtjYXNlIDEwOnJldHVybiBzPyhzLmZlYXR1cmVzJiZzLmZlYXR1cmVzLmxlbmd0aD50Lm1heEZlYXR1cmVzJiYocy5mZWF0dXJlcz1zLmZlYXR1cmVzLnNwbGljZSgwLHQubWF4RmVhdHVyZXMpKSxbNCxtbi5fZ2V0RW5yaWNoZWREYXRhU2V0KGUscy5mZWF0dXJlcyx0KV0pOlszLDEyXTtjYXNlIDExOnJldHVybiBbMixhLnNlbnQoKV07Y2FzZSAxMjppZighZS5zdGFydHNXaXRoKCJ7IikpcmV0dXJuIFszLDE2XTthLmxhYmVsPTEzO2Nhc2UgMTM6cmV0dXJuIGEudHJ5cy5wdXNoKFsxMywxNSwsMTZdKSxbNCx0aGlzLl9wYXJzZUdlb0pzb25TdHJpbmcoZSx0KV07Y2FzZSAxNDpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgMTU6dGhyb3cgYS5zZW50KCk7Y2FzZSAxNjppZighKGUubGVuZ3RoPD0yMDgzKXx8L1tcblxyXS9nLnRlc3QoZSkpcmV0dXJuIFszLDI0XTtvPWVuLnBhcnNlVVJMKGUsciksYS5sYWJlbD0xNztjYXNlIDE3OnJldHVybiBhLnRyeXMucHVzaChbMTcsMjMsLDI0XSksWzQsZW4uYWpheEdldEFzeW5jKG8sdC5wcm94eVNlcnZpY2UsbnVsbCwhMCwiWE1MIildO2Nhc2UgMTg6cmV0dXJuICh1PWEuc2VudCgpKWluc3RhbmNlb2YgQXJyYXlCdWZmZXI/WzQsdGhpcy5fcmVhZEFycmF5QnVmZmVyKHUsdCxvKV06WzMsMjBdO2Nhc2UgMTk6cmV0dXJuIFsyLGEuc2VudCgpXTtjYXNlIDIwOnJldHVybiBbNCx0aGlzLl9yZWFkU3RyaW5nKHUsdCxvKV07Y2FzZSAyMTpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgMjI6cmV0dXJuIFszLDI0XTtjYXNlIDIzOnRocm93IGw9YS5zZW50KCksbmV3IEVycm9yKCJVbmFibGUgdG8gcmVhZCBkYXRhIGZyb20gVVJMLiAiK2wpO2Nhc2UgMjQ6KGM9T2JqZWN0LmFzc2lnbih7fSx0KSkubWF4RmVhdHVyZXM9MSxhLmxhYmVsPTI1O2Nhc2UgMjU6cmV0dXJuIGEudHJ5cy5wdXNoKFsyNSwyOCwsMjldKSwoaD1Ybi5yZWFkKGUsYykpPyhoPVhuLnJlYWQoZSx0KSkmJmguZmVhdHVyZXMmJmguZmVhdHVyZXMubGVuZ3RoPjA/WzQsbW4uX2dldEVucmljaGVkRGF0YVNldChlLGguZmVhdHVyZXMsdCldOlszLDI3XTpbMywyN107Y2FzZSAyNjpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgMjc6cmV0dXJuIFszLDI5XTtjYXNlIDI4OnJldHVybiBhLnNlbnQoKSxbMywyOV07Y2FzZSAyOTp0aHJvdyBuZXcgRXJyb3IoIlVuYWJsZSB0byByZWFkIGRhdGEuIil9fSkpfSkpfSxlLl9yZWFkQXJyYXlCdWZmZXI9ZnVuY3Rpb24oZSx0LHIpe3JldHVybiBuKHRoaXMsdm9pZCAwLHZvaWQgMCwoZnVuY3Rpb24oKXt2YXIgbixpLHMsbyxsLGMsaCxkLGYscCxtO3JldHVybiBhKHRoaXMsKGZ1bmN0aW9uKGEpe3N3aXRjaChhLmxhYmVsKXtjYXNlIDA6cmV0dXJuIGVuLmlzQmluYXJ5RGF0YShlKT9bNCwobmV3IHUpLmxvYWRBc3luYyhlKV06WzMsMTJdO2Nhc2UgMTpyZXR1cm4gKG49YS5zZW50KCkpJiZuLmZpbGVzP24uZmlsZXNbImRvYy5rbWwiXT9bNCxuZXcgWm4odCxyKS5yZWFkS216QXN5bmMobildOlszLDNdOlszLDExXTtjYXNlIDI6cmV0dXJuIFsyLGEuc2VudCgpXTtjYXNlIDM6aT12b2lkIDAscz12b2lkIDAsbz12b2lkIDAsbD0wLGM9T2JqZWN0LmtleXMobi5maWxlcyksYS5sYWJlbD00O2Nhc2UgNDpyZXR1cm4gbDxjLmxlbmd0aD8oaD1jW2xdLChkPW4uZmlsZXNbaF0ubmFtZS50b0xvd2VyQ2FzZSgpKS5pbmNsdWRlcygiLmttbCIpP1s0LG5ldyBabih0LHIpLnJlYWRLbXpBc3luYyhuKV06WzMsNl0pOlszLDhdO2Nhc2UgNTpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgNjppZighaSYmZC5pbmNsdWRlcygiLnhtbCIpKXJldHVybiBpPWgsWzMsOF07c3x8IWQuaW5jbHVkZXMoIi5nZW9qc29uIikmJiFkLmluY2x1ZGVzKCIuanNvbiIpPyFvJiYoZC5pbmNsdWRlcygiLmNzdiIpfHxkLmluY2x1ZGVzKCIudHN2Iil8fGQuaW5jbHVkZXMoIi50eHQiKSkmJihvPWgpOnM9aCxhLmxhYmVsPTc7Y2FzZSA3OnJldHVybiBsKyssWzMsNF07Y2FzZSA4OnJldHVybiAoZj1pKXx8KHM/Zj1zOm8mJihmPW8pKSxmP1s0LG4uZmlsZXNbZl0uYXN5bmMoInRleHQiKV06WzMsMTFdO2Nhc2UgOTpyZXR1cm4gcD1hLnNlbnQoKSxbNCx0aGlzLl9yZWFkU3RyaW5nKHAsdCxyKV07Y2FzZSAxMDpyZXR1cm4gWzIsYS5zZW50KCldO2Nhc2UgMTE6cmV0dXJuIFszLDE1XTtjYXNlIDEyOnJldHVybiAobT1lbi5hcnJheUJ1ZmZlclRvU3RyaW5nKGUpKT9bNCx0aGlzLl9yZWFkU3RyaW5nKG0sdCldOlszLDE0XTtjYXNlIDEzOnJldHVybiBbMixhLnNlbnQoKV07Y2FzZSAxNDp0aHJvdyBuZXcgRXJyb3IoIlVuYWJsZSB0byBwYXJzZSBkYXRhIGZyb20gQXJyYXlCdWZmZXIuIik7Y2FzZSAxNTpyZXR1cm4gWzJdfX0pKX0pKX0sZS5fcGFyc2VHZW9Kc29uU3RyaW5nPWZ1bmN0aW9uKGUsdCl7cmV0dXJuIG4odGhpcyx2b2lkIDAsdm9pZCAwLChmdW5jdGlvbigpe3ZhciByLG47cmV0dXJuIGEodGhpcywoZnVuY3Rpb24oYSl7c3dpdGNoKGEubGFiZWwpe2Nhc2UgMDppZighKHI9SlNPTi5wYXJzZShlKSkudHlwZSlyZXR1cm4gWzMsMl07c3dpdGNoKG49W10sci50eXBlKXtjYXNlIkZlYXR1cmVDb2xsZWN0aW9uIjpyLmZlYXR1cmVzJiZBcnJheS5pc0FycmF5KHIuZmVhdHVyZXMpJiYobj1yLmZlYXR1cmVzKTticmVhaztjYXNlIkZlYXR1cmUiOnIuZ2VvbWV0cnkmJkFycmF5LmlzQXJyYXkoci5nZW9tZXRyeS5jb29yZGluYXRlcykmJm4ucHVzaChyKTticmVhaztjYXNlIlBvaW50IjpjYXNlIkxpbmVTdHJpbmciOmNhc2UiUG9seWdvbiI6Y2FzZSJNdWx0aVBvaW50IjpjYXNlIk11bHRpTGluZVN0cmluZyI6Y2FzZSJNdWx0aVBvbHlnb24iOkFycmF5LmlzQXJyYXkoci5jb29yZGluYXRlcykmJm4ucHVzaCh7ZmVhdHVyZXM6cix0eXBlOiJGZWF0dXJlIn0pO31yZXR1cm4gbi5sZW5ndGg+MD8obi5sZW5ndGg+dC5tYXhGZWF0dXJlcyYmKG49bi5zcGxpY2UoMCx0Lm1heEZlYXR1cmVzKSksWzQsbW4uX2dldEVucmljaGVkRGF0YVNldChlLG4sdCldKTpbMywyXTtjYXNlIDE6cmV0dXJuIFsyLGEuc2VudCgpXTtjYXNlIDI6cmV0dXJuIFsyLG51bGxdfX0pKX0pKX0sZX0oKTtvbm1lc3NhZ2U9ZnVuY3Rpb24oZSl7dHJ5e1luLnJlYWQoZS5kYXRhLmRhdGEsZS5kYXRhLm9wdGlvbnMsZS5kYXRhLmJhc2VVcmwpLnRoZW4oKGZ1bmN0aW9uKGUpe3Bvc3RNZXNzYWdlKGUpO30pLChmdW5jdGlvbihlKXtwb3N0TWVzc2FnZSh7ZXJyb3I6ZX0pO30pKTt9Y2F0Y2goZSl7cG9zdE1lc3NhZ2Uoe2Vycm9yOmV9KTt9fTsKCg==',
  null,
  !1
)
var cl = (function () {
    function t(t, e, i) {
      if (((this.EOS = !1), (this.EOL = !1), (this._position = 0), (this._length = 0), t)) {
        if (
          ((this._delimitedData = t),
          (this._length = t.length),
          (this._delimiter = e || ','),
          '\\t' === this._delimiter)
        )
          this._delimiter = '\t'
        else if ('auto' === this._delimiter) {
          var l = this._delimitedData.match(/,/gi).length,
            s = this._delimitedData.match(/|/gi).length,
            n = this._delimitedData.match(/\t/gi).length
          this._delimiter = n > s && n > l ? '\t' : s > l ? '|' : ','
        }
        this._textQualifier = i || '"'
      }
    }
    return (
      (t.prototype.read = function () {
        for (var t = [], e = this.getNextRow(); null != e && e.length > 0; )
          t.push(e), (e = this.getNextRow())
        return t
      }),
      (t.prototype.getNextRow = function () {
        for (var t = [], e = this._getNextCell(); null != e; ) t.push(e), (e = this._getNextCell())
        return t
      }),
      (t.prototype._getNextCell = function () {
        if (this.EOL || this.EOS) return (this.EOL = !1), (this.EOS = !1), null
        for (var t = !1, e = !0, i = !1, l = ''; ; ) {
          var s = this._getChar(!0)
          if (this.EOS) return l.length > 0 ? l : null
          if ((i || !t) && s === this._delimiter) return l
          if ((e || i || !t) && ('\n' === s || '\r' === s))
            return (
              (this.EOL = !0),
              '\r' === s && '\n' === this._getChar(!1) && (s = this._getChar(!0)),
              l
            )
          ;(e && ' ' === s) ||
            (e && s === this._textQualifier
              ? ((t = !0), (e = !1))
              : e
              ? ((e = !1), (l += s))
              : s === this._textQualifier && t
              ? this._getChar(!1) === this._textQualifier
                ? (l += this._getChar(!0))
                : (i = !0)
              : (l += s))
        }
      }),
      (t.prototype._getChar = function (t) {
        return this._position === this._length
          ? ((this.EOS = !0), '\0')
          : (this._position >= this._length && (this._position = 0),
            t ? this._delimitedData[this._position++] : this._delimitedData[this._position])
      }),
      t
    )
  })(),
  dl = (function () {
    function t(t, e) {
      ;(this._delimiter = ','),
        (this._delimiter = t || ','),
        (this._textQualifier = e || '"'),
        (this._writer = [])
    }
    return (
      (t.prototype.clear = function () {
        ;(this._writer = []), (this._numCols = null)
      }),
      (t.prototype.write = function (t) {
        if (t && t.length > 0 && t[0].length > 0) {
          this._numCols || (this._numCols = t[0].length)
          for (var e = 0, i = t; e < i.length; e++) {
            var l = i[e]
            this._writeRow(l)
          }
        }
      }),
      (t.prototype.writeRow = function (t) {
        t && t.length > 0 && (this._numCols || (this._numCols = t.length), this._writeRow(t))
      }),
      (t.prototype.toString = function () {
        return this._writer.join('\n')
      }),
      (t.prototype._writeRow = function (t) {
        for (var e = [], i = Math.min(t.length, this._numCols), l = 0; l < i; l++)
          e.push(this._getStringValue(t[l]))
        var s = t.length - i
        if (s > 0) for (var n = 0; n < s; n++) e.push(null)
        this._writer.push(e.join(this._delimiter))
      }),
      (t.prototype._getStringValue = function (t) {
        if (
          ('object' == typeof t && void 0 !== t.value && null !== t.value && (t = t.value),
          t instanceof Date)
        )
          t = t.toISOString()
        else if ('boolean' == typeof t || 'number' == typeof t) return t.toString()
        return el.isValidString(t)
          ? t.includes(this._delimiter)
            ? (t.includes(this._textQualifier) &&
                (t = t.replace(this._textQualifier, '\\' + this._textQualifier)),
              '' + this._textQualifier + t + this._textQualifier)
            : t
          : null
      }),
      t
    )
  })(),
  rl = (function () {
    function t() {}
    return (
      (t.read = function (t) {
        return this._parseGeometry(t)
      }),
      (t.write = function (t, e, i) {
        var l = 6
        el.isValidNumber(e) && l >= 0 && (l = Math.min(Math.round(l), 12)), (i = i || !1)
        var s = []
        return this._write(s, t, Math.pow(10, l), i), s.length > 0 ? s.join('') : null
      }),
      (t._parseCoordinates = function (t, e) {
        for (
          var i, l = [], s = 0, n = t.replace(/(^\s|\s+$)/g, '').split(/,\s*/);
          s < n.length;
          s++
        ) {
          var a = n[s]
          null != (i = this._parseCoordinate(a, e)) && l.push(i)
        }
        return l
      }),
      (t._parseCoordinate = function (t, e) {
        var i = t.trim().split(/\s+/)
        if (i.length > 1) {
          var l = [parseFloat(i[0]), parseFloat(i[1])]
          return e && (i.length >= 3 ? l.push(parseFloat(i[2])) : l.push(0)), l
        }
        return null
      }),
      (t._parseGeometry = function (t) {
        var e
        if (t) {
          if ((t = t.toLowerCase()).includes('empty')) return null
          var i = t.substring(0, t.indexOf('(', 0))
          switch ((i = i.replace(/\s*/g, ''))) {
            case 'point':
              e = this._parsePoint(t, !1)
              break
            case 'pointz':
            case 'pointzm':
              e = this._parsePoint(t, !0)
              break
            case 'linestring':
              e = this._parseLinestring(t, !1)
              break
            case 'linestringz':
            case 'linestringzm':
              e = this._parseLinestring(t, !0)
              break
            case 'polygon':
              e = this._parsePolygon(t, !1)
              break
            case 'polygonz':
            case 'polygonzm':
              e = this._parsePolygon(t, !0)
              break
            case 'multipoint':
              e = this._parseMultiPoint(t, !1)
              break
            case 'multipointz':
            case 'multipointzm':
              e = this._parseMultiPoint(t, !0)
              break
            case 'multilinestring':
              e = this._parseMultiLinestring(t, !1)
              break
            case 'multilinestring':
            case 'multilinestringz':
            case 'multilinestringzm':
              e = this._parseMultiLinestring(t, !0)
              break
            case 'multipolygon':
              e = this._parseMultiPolygon(t, !1)
              break
            case 'multipolygonz':
            case 'multipolygonzm':
              e = this._parseMultiPolygon(t, !0)
              break
            case 'geometrycollection':
            case 'geometrycollectionz':
            case 'geometrycollectionzm':
              return this._parseGeometryCollection(t)
          }
        }
        return e ? [e] : null
      }),
      (t._parseGeometryCollection = function (t) {
        for (
          var e,
            i = [],
            l = 0,
            s = t
              .replace(/(geometrycollection\s*\(|(\)\s*)$)/g, '')
              .replace(/(\))(,\s*)([a-zA-Z])/g, '$1|$3')
              .split('|');
          l < s.length;
          l++
        ) {
          var n = s[l]
          ;(e = this._parseGeometry(n)) && e.length > 0 && (i = i.concat(e))
        }
        return i
      }),
      (t._parsePoint = function (t, e) {
        t = t.replace(/(point|[\(\)]*)/g, '')
        var i = this._parseCoordinate(t, e)
        return i ? { type: 'Point', coordinates: i } : null
      }),
      (t._parseLinestring = function (t, e) {
        t = t.replace(/(linestring|[\(\)]*|^\s*|\s$)/g, '')
        var i = this._parseCoordinates(t, e)
        return i ? { type: 'LineString', coordinates: i } : null
      }),
      (t._parsePolygon = function (t, e) {
        for (
          var i = [], l = 0, s = t.replace(/(polygon|\(\(|\)\))/g, '').split(/\),\s*\(/);
          l < s.length;
          l++
        ) {
          var n = s[l]
          i.push(this._parseCoordinates(n, e))
        }
        return i.length > 0 ? { type: 'Polygon', coordinates: i } : null
      }),
      (t._parseMultiPoint = function (t, e) {
        for (
          var i = [], l = 0, s = t.replace(/(multipoint|[\(\)]*)/g, '').split(/,\s*/);
          l < s.length;
          l++
        ) {
          var n = s[l]
          i.push(this._parseCoordinate(n, e))
        }
        return i.length > 0 ? { type: 'MultiPoint', coordinates: i } : null
      }),
      (t._parseMultiLinestring = function (t, e) {
        for (
          var i = [], l = 0, s = t.replace(/(multilinestring|\(\(|\)\))/g, '').split(/\),\s*\(/);
          l < s.length;
          l++
        ) {
          var n = s[l]
          i.push(this._parseCoordinates(n, e))
        }
        return i.length > 0 ? { type: 'MultiLineString', coordinates: i } : null
      }),
      (t._parseMultiPolygon = function (t, e) {
        for (
          var i,
            l = [],
            s = 0,
            n = t.replace(/(multipolygon|\(\(\(|\)\)\))/g, '').split(/\)\),\s*\(\(/);
          s < n.length;
          s++
        ) {
          i = []
          for (var a = 0, c = n[s].split(/\),\s*\(/); a < c.length; a++) {
            var d = c[a]
            i.push(this._parseCoordinates(d, e))
          }
          i.length > 0 && l.push(i)
        }
        return l.length > 0 ? { type: 'MultiPolygon', coordinates: l } : null
      }),
      (t._writeCoordinate = function (t, e, i, l) {
        t.push((Math.round(e[0] * i) / i).toString(), ' ', (Math.round(e[1] * i) / i).toString()),
          l && (e.length >= 3 ? t.push(' ', e[2].toString()) : t.push(' 0'))
      }),
      (t._writeCoordinates = function (t, e, i, l) {
        t.push('(')
        for (var s = e.length, n = 0; n < s; n++)
          this._writeCoordinate(t, e[n], i, l), n < s - 1 && t.push(',')
        t.push(')')
      }),
      (t._writeRings = function (t, e, i, l, s) {
        t.push('(')
        for (var n = e.length, a = 0; a < n; a++)
          i && el.closeRing(e[a]), this._writeCoordinates(t, e[a], l, s), a < n - 1 && t.push(',')
        t.push(')')
      }),
      (t._writePoint = function (t, e, i, l) {
        t.push('POINT', l ? ' Z(' : '('), this._writeCoordinate(t, e.coordinates, i, l), t.push(')')
      }),
      (t._writeLinestring = function (t, e, i, l) {
        t.push('LINESTRING', l ? ' Z' : ''), this._writeCoordinates(t, e.coordinates, i, l)
      }),
      (t._writePolygon = function (t, e, i, l) {
        t.push('POLYGON', l ? ' Z' : ''), this._writeRings(t, e.coordinates, !0, i, l)
      }),
      (t._writeMultiPoint = function (t, e, i, l) {
        t.push('MULTIPOINT', l ? ' Z' : ''), this._writeCoordinates(t, e.coordinates, i, l)
      }),
      (t._writeMultiLineString = function (t, e, i, l) {
        t.push('MULTILINESTRING', l ? ' Z' : ''), this._writeRings(t, e.coordinates, !1, i, l)
      }),
      (t._writeMultiPolygon = function (t, e, i, l) {
        t.push('MULTIPOLYGON', l ? ' Z(' : '(')
        for (var s = e.coordinates.length, n = 0; n < s; n++)
          this._writeRings(t, e.coordinates[n], !0, i, l), n < s - 1 && t.push(',')
        t.push(')')
      }),
      (t._writeGeometryCollection = function (t, e, i, l) {
        var s = e && e.length
        t.push('GEOMETRYCOLLECTION', l ? ' Z(' : '(')
        for (var n = 0; n < s; n++) this._write(t, e[n], i, l), n < s - 1 && t.push(',')
        t.push(')')
      }),
      (t._write = function (t, e, i, l) {
        if (e)
          if (Array.isArray(e)) this._writeGeometryCollection(t, e, i, l)
          else
            switch (e.type) {
              case 'Point':
                return this._writePoint(t, e, i, l)
              case 'LineString':
                return this._writeLinestring(t, e, i, l)
              case 'Polygon':
                return this._writePolygon(t, e, i, l)
              case 'MultiPoint':
                return this._writeMultiPoint(t, e, i, l)
              case 'MultiLineString':
                return this._writeMultiLineString(t, e, i, l)
              case 'MultiPolygon':
                return this._writeMultiPolygon(t, e, i, l)
              case 'Feature':
                return this._write(t, e.geometry, i, l)
            }
      }),
      t
    )
  })(),
  ol = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (e.format = 'GeoJSON'), e
    }
    return s(e, t), e
  })(qi),
  ml = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (
        (e.spatialformat = 'wkt'),
        (e.latColName = 'lat'),
        (e.lonColName = 'lon'),
        (e.elvColName = 'elv'),
        (e.geoColName = 'geo'),
        (e.delimiter = ','),
        (e.textQualifier = '"'),
        (e.includeTypesInHeader = !1),
        e
      )
    }
    return s(e, t), e
  })(ol),
  ul = (function () {
    function t() {}
    return (
      (t.read = function (t, e) {
        if (
          (('number' != typeof (e = e || { maxFeatures: 1 / 0 }).maxFeatures ||
            e.maxFeatures <= 0) &&
            (e.maxFeatures = 1 / 0),
          !e.delimiter || '' === e.delimiter || 'auto' === e.delimiter)
        ) {
          var i = t.indexOf('\n'),
            l = t.substring(0, i)
          l.toLowerCase().startsWith('bing spatial data services') &&
            (l = t.substring(i, t.indexOf('\n', i + 1)))
          var s = (l.match(/,/g) || []).length,
            n = (l.match(/[|]/g) || []).length,
            a = (l.match(/\t/g) || []).length
          s >= n && s >= a
            ? (e.delimiter = ',')
            : n >= s && n >= a
            ? (e.delimiter = '|')
            : a >= s && a >= n && (e.delimiter = '\t')
        }
        var c,
          d = [],
          r = new cl(t, e.delimiter),
          o = r.getNextRow()
        if (null != o && o.length > 0) {
          o[0].toLowerCase().startsWith('bing spatial data services') && (o = r.getNextRow())
          var m = !1
          if (e.header) (c = e.header), (m = !0)
          else {
            ;(c = this.parseHeader(o)), (o = r.getNextRow())
            for (var u = 0, b = 0, h = c.names.length; b < h; b++)
              if ('string' !== c.types[b] && 'geography' !== c.types[b]) {
                var Z = c.names[b].toLowerCase()
                this._latitudeNames.has(Z) ||
                  this._longitudeNames.has(Z) ||
                  this._elevationNames.has(Z) ||
                  u++
              }
            u > 0 && (m = !0)
          }
          if (!this.validateHeader(c, o)) throw new Error('Unable to parse header')
          var p = !1
          for (!m && e.dynamicTyping && (p = !0); null != o && o.length > 0; ) {
            var y = this.parseRow(o, c, p)
            if (
              null != y &&
              ('Point' === y.geometry.type &&
                'Circle' === y.properties.subType &&
                el.isValidNumber(y.properties.radius) &&
                (y.properties.radius = parseFloat(y.properties.radius)),
              d.push(y),
              d.length >= e.maxFeatures)
            )
              break
            o = r.getNextRow()
          }
        }
        return { type: 'FeatureCollection', features: d }
      }),
      (t.write = function (e, i) {
        var l = this
        if (e && e.length > 0) {
          i = new ml().merge(i)
          var s = [],
            n = [],
            a = ci(this._ignoreProperties)
          'wkt' === i.spatialformat
            ? a.push(i.geoColName)
            : (a.push(i.latColName),
              a.push(i.lonColName),
              'latlonelv' === i.spatialformat && a.push(i.elvColName))
          for (
            var c = void 0 !== e[0].properties[i.elvColName] ? i.elvColName : null,
              d = !1,
              r = function (e) {
                null != e.id && '' !== e.id && (d = !0),
                  ('wkt' !== i.spatialformat && 'Point' !== e.geometry.type) ||
                    Object.keys(e.properties).forEach(function (i) {
                      if (
                        !i.startsWith('_') &&
                        !s.includes(i) &&
                        !l._ignoreProperties.includes(i)
                      ) {
                        var a = e.properties[i]
                        if (null != a && '' !== a) {
                          var d = typeof a
                          a instanceof Date && (d = 'date'),
                            l._allowedTypes.has(d) && (s.push(i), n.push(d)),
                            !c && t._elevationNames.has(i) && (c = i)
                        }
                      }
                    })
              },
              o = 0,
              m = e;
            o < m.length;
            o++
          ) {
            r((W = m[o]))
          }
          var u = new dl(i.delimiter, i.textQualifier),
            b = []
          if ((d && b.push(i.includeTypesInHeader ? 'id(string)' : 'id'), i.includeTypesInHeader)) {
            for (var h = 0, Z = s.length; h < Z; h++) b.push(s[h] + '(' + n[h] + ')')
            'wkt' === i.spatialformat
              ? b.push(i.geoColName + '(geography)')
              : (b.push(i.latColName + '(number)'),
                b.push(i.lonColName + '(number)'),
                'latlonelv' === i.spatialformat && b.push(i.elvColName + '(number)'))
          } else
            (b = b.concat(s)),
              'wkt' === i.spatialformat
                ? b.push(i.geoColName)
                : (b.push(i.latColName),
                  b.push(i.lonColName),
                  'latlonelv' === i.spatialformat && b.push(i.elvColName))
          u.writeRow(b)
          for (var p = void 0, y = void 0, X = 0, G = e; X < G.length; X++) {
            var W
            if (((p = (W = G[X]).geometry), 'wkt' === i.spatialformat || 'Point' === p.type)) {
              ;(b = d ? [W.id] : []), (y = W.properties)
              for (var V = 0, Y = s; V < Y.length; V++) {
                var L = Y[V]
                b.push(y[L])
              }
              'wkt' === i.spatialformat
                ? b.push(rl.write(p))
                : (b.push(p.coordinates[1]),
                  b.push(p.coordinates[0]),
                  'latlonelv' === i.spatialformat &&
                    (p.coordinates.length >= 3
                      ? b.push(p.coordinates[2])
                      : void 0 !== y[c]
                      ? b.push(y[c])
                      : b.push(0))),
                u.writeRow(b)
            }
          }
          return u.toString()
        }
        return null
      }),
      (t.validateHeader = function (t, e) {
        if (!t || !t.names || 0 === t.names.length) return !1
        Array.isArray(t.types) || (t.types = [])
        for (var i = !1, l = !1, s = !1, n = 0, a = t.names.length; n < a; n++) {
          var c = t.names[n].toLowerCase()
          t.types.length - 1 > n
            ? (t.types[n] = this.validateType(t.types[n], c))
            : t.types.push(this.validateType(null, c)),
            this._latitudeNames.has(c)
              ? (l = !0)
              : this._longitudeNames.has(c)
              ? (s = !0)
              : 'geography' === t.types[n] && (i = !0)
        }
        if ((l && s) || i) return !0
        if (e && e.length > 0)
          for (a = Math.min(t.names.length, e.length), n = 0; n < a; n++)
            if (this._wktRx.test(e[n])) return (t.types[n] = 'geography'), !0
        return !1
      }),
      (t.validateType = function (t, e) {
        var i
        switch ((t = t || '').toLowerCase()) {
          case 'edm.int64':
          case 'int':
          case 'long':
          case 'edm.double':
          case 'float':
          case 'double':
          case 'number':
            i = 'number'
            break
          case 'edm.boolean':
          case 'bool':
          case 'boolean':
            i = 'boolean'
            break
          case 'edm.datetime':
          case 'date':
          case 'datetime':
            i = 'date'
            break
          case 'edm.geography':
          case 'geography':
            i = 'geography'
            break
          case 'edm.string':
          case 'varchar':
          case 'text':
          case 'string':
          default:
            i = 'string'
        }
        if ('geography' !== i) {
          var l = e.toLowerCase()
          ;(this._latitudeNames.has(l) ||
            this._longitudeNames.has(l) ||
            this._elevationNames.has(l)) &&
            (i = 'number')
        }
        return i
      }),
      (t.parseHeader = function (t) {
        for (var e, i, l = [], s = [], n = 0, a = t.length; n < a; n++) {
          if (
            ((e = t[n]),
            (i = 'string'),
            n < a - 1 && t[n + 1].toLowerCase().startsWith('primarykey)'))
          )
            (e = e.substring(0, e.indexOf('('))),
              (i = t[n].substring(t[n].indexOf('(') + 1)).includes(',') && (i = i.replace(',', '')),
              n++
          else if (this._headerRegex.test(e)) {
            var c = e.match(this._headerRegex)
            c &&
              c.length >= 3 &&
              ((e = c[1]), (i = c[2]).includes(',') && (i = i.substring(0, i.indexOf(','))))
          }
          ;(e = e.trim()).includes(' ') && (e = e.replace(/\s/g, '_')),
            l.includes(e) ? ((e = 'Column_' + n), l.push(e)) : l.push(e),
            s.push(this.validateType(i, e))
        }
        return { names: l, types: s }
      }),
      (t.parseRow = function (e, i, l) {
        for (
          var s,
            n = null,
            a = {},
            c = NaN,
            d = NaN,
            r = NaN,
            o = Math.min(e.length, i.names.length),
            m = 0;
          m < o;
          m++
        ) {
          switch (((s = null), i.types[m])) {
            case 'number':
              if (((s = parseFloat(e[m])), el.isValidNumber(s))) {
                var u = i.names[m].toLowerCase()
                this._latitudeNames.has(u)
                  ? (c = s)
                  : this._longitudeNames.has(u)
                  ? (d = s)
                  : this._elevationNames.has(u) && (r = s)
              } else s = null
              break
            case 'boolean':
              s = el.parseBoolean(e[m])
              break
            case 'date':
              s = Qi(e[m])
              break
            case 'geography':
              ;(n = rl.read(e[m])), (s = null)
              break
            case 'string':
            default:
              if (l)
                if (t._boolRegex.test(e[m])) s = 'true' === e[m].toLowerCase()
                else if (t._numRx.test(e[m])) {
                  ;(s = parseFloat(e[m])),
                    (u = i.names[m].toLowerCase()).includes('date') && (s = new Date(s))
                } else {
                  var b = Qi(e[m])
                  s = null !== b ? b : e[m]
                }
              else s = e[m]
          }
          null != s && '' !== s && (a[i.names[m]] = s)
        }
        if (null !== n && n.length > 0) return { geometry: n[0], properties: a, type: 'Feature' }
        if (el.isValidNumber(c) && el.isValidNumber(d)) {
          var h = [d, c]
          return (
            el.isValidNumber(r) && h.push(r),
            { geometry: { coordinates: h, type: 'Point' }, properties: a, type: 'Feature' }
          )
        }
        return null
      }),
      (t.checkIds = function (t) {
        return t.some(function (t) {
          return null != t.id && '' !== t.id
        })
      }),
      (t._latitudeNames = new Set([
        'latitude',
        'lat',
        'latdd',
        'lat_dd',
        'latitude83',
        'latdecdeg',
        'y',
        'ycenter',
        'point-y'
      ])),
      (t._longitudeNames = new Set([
        'longitude',
        'lon',
        'lng',
        'long',
        'longdd',
        'long_dd',
        'longitude83',
        'longdecdeg',
        'x',
        'xcenter',
        'point-x'
      ])),
      (t._elevationNames = new Set(['elevation', 'elv', 'altitude', 'alt', 'z'])),
      (t._headerRegex = /^\s*([a-zA-Z0-9_]+)\(([a-zA-Z0-9\.,]+)\)\s*$/),
      (t._boolRegex = /^\s*(true|false)\s*$/i),
      (t._numRx = /^\s*[0-9]+\s*$/),
      (t._wktRx =
        /^\s*(point|linestring|polygon|multipoint|multilinestring|multipolygon|geometrycollection)[z]?[m]?\s*\(/i),
      (t._allowedTypes = new Set(['string', 'number', 'date', 'boolean'])),
      (t._ignoreProperties = ['image', 'imageUrl']),
      t
    )
  })(),
  bl = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (
        (e.prettyPrint = !0),
        (e.roundPositions = !1),
        (e.newLineChars = '\r\n'),
        (e.indentChars = '\t'),
        (e.writeIds = !1),
        e
      )
    }
    return s(e, t), e
  })(ol),
  hl = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (
        (e.includeNamespace = !0),
        (e.customNamespace = void 0),
        (e.srsName = 'urn:ogc:def:crs:EPSG::4326'),
        (e.includeSrsName = !1),
        e
      )
    }
    return s(e, t), e
  })(bl),
  Zl = (function () {
    function t(t, e, i) {
      ;(this._indentChars = '\t'),
        (this._indentLevel = 0),
        (this._newLineChars = '\r\n'),
        (this._prettyPrint = !1),
        this.clear(),
        'boolean' == typeof t && (this._prettyPrint = t),
        el.isValidString(e) && (this._newLineChars = e),
        el.isValidString(i) && (this._indentChars = i),
        (this._endsWithNewLineIndentRx = new RegExp(
          '(' + this._newLineChars + '|' + this._indentChars + ')$'
        ))
    }
    return (
      (t.prototype.clear = function () {
        ;(this._indentLevel = 0), (this._xmlDocStringBuilder = []), (this._tagNameStack = [])
      }),
      (t.prototype.writeStartDocument = function (t, e, i) {
        return (
          ('boolean' != typeof t || t) &&
            (this._xmlDocStringBuilder.push(
              '<?xml version="1.0" standalone="' +
                (i ? 'yes' : 'no') +
                '" encoding="' +
                (e || 'UTF-8') +
                '"?>'
            ),
            this._prettyPrint && this._xmlDocStringBuilder.push(this._newLineChars)),
          this
        )
      }),
      (t.prototype.writeEndDocument = function (t) {
        for (var e = this._tagNameStack.length; e > 0; e--) this.writeEndElement()
        return (
          'boolean' == typeof t &&
            !t &&
            this._xmlDocStringBuilder.length > 0 &&
            this._xmlDocStringBuilder[this._xmlDocStringBuilder.length - 1] ===
              this._newLineChars &&
            this._xmlDocStringBuilder.length--,
          this
        )
      }),
      (t.prototype.writeStartElement = function (t, e, i, l) {
        var s = this
        return (
          l || (this._indentLevel++, this._writeNewLineAndIndent()),
          this._xmlDocStringBuilder.push('<' + t),
          e &&
            (this._xmlDocStringBuilder.push(' '),
            Object.keys(e).forEach(function (t) {
              e[t] && s._xmlDocStringBuilder.push(t + '="' + e[t].toString() + '"', ' ')
            }),
            ' ' === this._xmlDocStringBuilder[this._xmlDocStringBuilder.length - 1] &&
              this._xmlDocStringBuilder.pop()),
          i
            ? (this._xmlDocStringBuilder.push('/>'), l || this._indentLevel--)
            : (this._xmlDocStringBuilder.push('>'), this._tagNameStack.push(t)),
          this
        )
      }),
      (t.prototype.writeEndElement = function (t) {
        var e = this._tagNameStack.pop()
        return (
          e &&
            (t || this._writeNewLineAndIndent(),
            this._xmlDocStringBuilder.push('</' + e + '>'),
            this._indentLevel--),
          this
        )
      }),
      (t.prototype.writeElement = function (t, e, i) {
        return this.writeStartElement(t, i).writeValue(e).writeEndElement(!0)
      }),
      (t.prototype.writeValue = function (e) {
        var i = this
        return (
          'string' == typeof e
            ? e.includes('<![CDATA[')
              ? this._xmlDocStringBuilder.push(e)
              : el.containsHtmlRx.test(e)
              ? this._xmlDocStringBuilder.push('<![CDATA[' + e + ']]>')
              : this._xmlDocStringBuilder.push(this._escapeSpecialChars(e))
            : e instanceof Date
            ? this._xmlDocStringBuilder.push(e.toISOString())
            : 'boolean' == typeof e || 'number' == typeof e
            ? this._xmlDocStringBuilder.push(e.toString())
            : Array.isArray(e)
            ? this._xmlDocStringBuilder.push(e.join(','))
            : e instanceof t
            ? this._xmlDocStringBuilder.push(e.toString())
            : e instanceof Object &&
              Object.keys(e).forEach(function (t) {
                i.writeElement(t, e[t])
              }),
          this
        )
      }),
      (t.prototype.writeString = function (t, e) {
        return e ? this.writeValue(t) : this._xmlDocStringBuilder.push(t), this
      }),
      (t.prototype.writeCDataContent = function (t) {
        return (
          t.includes('<![CDATA[')
            ? this._xmlDocStringBuilder.push(t)
            : this._xmlDocStringBuilder.push('<![CDATA[' + t + ']]>'),
          this
        )
      }),
      (t.prototype.writeComment = function (t) {
        return this._xmlDocStringBuilder.push('\x3c!--' + t + '--\x3e'), this
      }),
      (t.prototype.toString = function () {
        return this.writeEndDocument(), this._xmlDocStringBuilder.join('')
      }),
      (t.prototype._writeNewLineAndIndent = function () {
        if (this._prettyPrint && !this._endsWithNewLineIndent()) {
          this._xmlDocStringBuilder.push(this._newLineChars)
          for (var t = 0; t < this._indentLevel; t++)
            this._xmlDocStringBuilder.push(this._indentChars)
        }
      }),
      (t.prototype._endsWithNewLineIndent = function () {
        if (this._xmlDocStringBuilder.length > 0) {
          var t = this._xmlDocStringBuilder[this._xmlDocStringBuilder.length - 1]
          return this._endsWithNewLineIndentRx.test(t)
        }
        return !1
      }),
      (t.prototype._escapeSpecialChars = function (t) {
        return el.containsSpecialCharRx.test(t) && (t = el.escapeHtml(el.unescapeHTML(t))), t
      }),
      t
    )
  })(),
  pl = (function () {
    function t() {}
    return (
      (t.write = function (t, e, i) {
        var l,
          s = null,
          n = 'gml:',
          a = !0,
          c = (e = new hl().merge(e)).srsName
        if (
          (e.includeSrsName || (c = void 0),
          (i = 'boolean' == typeof i && i),
          e.includeNamespace && ((s = { xmlns: 'http://www.opengis.net/gml' }), (n = '')),
          'boolean' == typeof e.prettyPrint && (a = e.prettyPrint),
          e.customNamespace)
        ) {
          null === s && (s = {})
          var d = e.customNamespace
          d.prefix &&
            d.namespaceUrl &&
            d.tagNames &&
            d.tagNames.length > 0 &&
            (d.prefix.includes(':') && (d.prefix = d.prefix.replace(':', '')),
            (s['xmlns:' + d.prefix] = d.namespaceUrl),
            (d.prefix += ':'),
            (l = d))
        }
        var r = new Zl(a, e.newLineChars, e.indentChars)
        if (
          (r.writeStartDocument(i),
          'FeatureCollection' === t.type || (t.features && Array.isArray(t.features)))
        ) {
          n = 'gml:'
          var o = t
          r.writeStartElement(
            'gml:FeatureCollection',
            { 'xmlns:gml': 'http://www.opengis.net/gml' },
            null,
            !0
          ),
            o.properties && this._writeMetadata(o.properties, r, n, l),
            o.bbox &&
              o.bbox.length >= 4 &&
              (r.writeStartElement('gml:boundedBy'),
              this._writeBBox(o.bbox, r, c, e.roundPositions, !0),
              r.writeEndElement())
          for (var m = 0, u = o.features; m < u.length; m++) {
            var b = u[m]
            r.writeStartElement('gml:featureMember'),
              this._writeFeature(
                b,
                r,
                n,
                l,
                e.writeIds && b.id ? { 'gml:id': b.id } : {},
                !1,
                !1,
                c
              ),
              r.writeEndElement()
          }
          r.writeEndElement()
        } else
          'Feature' === t.type
            ? this._writeFeature(t, r, n, l, s, !0, !1, c)
            : this._writeGeometry(t, r, n, s, !0, !1, null, c)
        return r.writeEndDocument(i), r.toString()
      }),
      (t._writeGeometry = function (t, e, i, l, s, n, a, c) {
        ;(l = l || {}).srsName || (l.srsName = c),
          this._writeGeometryByParts(t.type, t.coordinates, e, i, l, s, n, a)
      }),
      (t._writeBBox = function (t, e, i, l, s) {
        var n = {},
          a = 'gml:'
        s || ((a = ''), (n.xmlns = 'http://www.opengis.net/gml')),
          i && (n.srsName = i),
          e.writeStartElement(a + 'Envelope', n),
          l && (t = el.roundBBox(t, 6)),
          e.writeElement(a + 'lowerCorner', t[1].toString() + ' ' + t[0].toString())
        var c = t[3],
          d = t[2]
        t.length >= 6 && ((c = t[4]), (d = t[3])),
          e.writeElement(a + 'upperCorner', c.toString() + ' ' + d.toString()),
          e.writeEndElement()
      }),
      (t._writeFeature = function (t, e, i, l, s, n, a, c) {
        l
          ? (e.writeStartElement(l.prefix + l.featureTagName, s),
            this._writeMetadata(t.properties, e, i, l),
            e.writeStartElement(l.prefix + l.geometryTagName),
            this._writeGeometry(t.geometry, e, i, null, n, a, t.properties, c),
            e.writeEndElement().writeEndElement())
          : this._writeGeometry(t.geometry, e, i, s, n, a, t.properties, c)
      }),
      (t._writeMetadata = function (t, e, i, l) {
        t &&
          Object.keys(t).forEach(function (s) {
            var n = t[s]
            if (el.isValidString(n))
              switch (s) {
                case 'name':
                case 'description':
                case 'identifier':
                  e.writeElement(i + s, n)
                  break
                case 'title':
                  ;(t.name && '' !== t.name) || e.writeElement(i + 'name', n)
                  break
                case 'desc':
                  ;(t.description && '' !== t.description) || e.writeElement(i + 'description', n)
                  break
                default:
                  l && l.tagNames && l.tagNames.includes(s) && e.writeElement(l.prefix + s, n)
              }
          })
      }),
      (t._writeGeometryByParts = function (t, e, l, s, n, a, c, d) {
        switch (t) {
          case 'Point':
            if (d && 'Circle' === d.subType && el.isValidNumber(d.radius) && d.radius > 0) {
              var r = i.math.getRegularPolygonPath(e, d.radius, 72, 'meters')
              this._writeGeometryByParts('Polygon', [r], l, s, n, a, c)
            } else this._writePoint(e, l, s, n, a, c)
            break
          case 'LineString':
            this._writeLineString(e, l, s, n, a, c)
            break
          case 'Polygon':
            this._writePolygon(e, l, s, n, a, c)
            break
          case 'MultiPoint':
          case 'MultiLineString':
          case 'MultiPolygon':
            this._writeMultiGeometryByParts(t, e, l, s, n, a, c)
        }
      }),
      (t._writePoint = function (t, e, i, l, s, n) {
        e.writeStartElement(i + 'Point', l, !1, s).writeStartElement(i + 'pos'),
          this._writeCoordinateValue(t, e, n),
          e.writeEndElement(!0).writeEndElement()
      }),
      (t._writeLineString = function (t, e, i, l, s, n) {
        e.writeStartElement(i + 'LineString', l, !1, s),
          this._writeCoordinates(t, !1, e, i, n),
          e.writeEndElement()
      }),
      (t._writePolygon = function (t, e, i, l, s, n) {
        if (
          (e.writeStartElement(i + 'Polygon', l, !1, s),
          el.closeRing(t[0]),
          e.writeStartElement(i + 'exterior').writeStartElement(i + 'LinearRing'),
          this._writeCoordinates(t[0], !0, e, i, n),
          e.writeEndElement().writeEndElement(),
          t.length > 1)
        )
          for (var a = 1, c = t.length; a < c; a++)
            el.closeRing(t[a]),
              e.writeStartElement(i + 'interior').writeStartElement(i + 'LinearRing'),
              this._writeCoordinates(t[a], !0, e, i, n),
              e.writeEndElement().writeEndElement()
        e.writeEndElement()
      }),
      (t._writeMultiGeometryByParts = function (t, e, i, l, s, n, a) {
        var c, d
        switch (t) {
          case 'MultiPoint':
            i.writeStartElement(l + 'MultiPoint', s, !1, n), (c = l + 'pointMember'), (d = 'Point')
            break
          case 'MultiLineString':
            i.writeStartElement(l + 'MultiLineString', s, !1, n),
              (c = l + 'lineStringMember'),
              (d = 'LineString')
            break
          case 'MultiPolygon':
            i.writeStartElement(l + 'MultiPolygon', s, !1, n),
              (c = l + 'polygonMember'),
              (d = 'Polygon')
        }
        if (d) {
          for (var r = 0, o = e; r < o.length; r++) {
            var m = o[r]
            i.writeStartElement(c),
              this._writeGeometryByParts(d, m, i, l, null, !1, a),
              i.writeEndElement()
          }
          i.writeEndElement()
        }
      }),
      (t._writeCoordinateValue = function (t, e, i) {
        i && (t = el.roundPosition(t, 6)),
          e.writeString(t[1].toString()).writeString(' ').writeString(t[0].toString())
      }),
      (t._writeCoordinates = function (t, e, l, s, n) {
        if (null != t) {
          l.writeStartElement(s + 'posList'),
            e && t.length >= 3 && !i.data.Position.areEqual(t[0], t[t.length - 1]) && t.push(t[0])
          for (var a = 0, c = t.length; a < c; a++)
            this._writeCoordinateValue(t[a], l, n), a < c - 1 && l.writeString(' ')
          l.writeEndElement(!0)
        }
      }),
      t
    )
  })(),
  yl = (function () {
    function t() {}
    return (
      (t.readContent = function (t) {
        var e = t.value
        if (t.attributes && t.attributes.type)
          switch (t.attributes.type) {
            case 'html':
            case 'xhtml':
              return t.value
          }
        return e
      }),
      (t.writeAuthor = function (t, e, i) {
        if (t) {
          var l = ''
          if ((i && (l = 'atom:'), Array.isArray(t)))
            for (var s = 0, n = t; s < n.length; s++) {
              var a = n[s]
              this.writeAuthor(a, e, i)
            }
          else
            el.isValidString(t)
              ? e
                  .writeStartElement(l + 'author')
                  .writeElement(l + 'name', t)
                  .writeEndElement()
              : (e.writeStartElement(l + 'author'),
                t.name && e.writeElement(l + 'name', t.name),
                t.uri && e.writeElement(l + 'uri', t.uri),
                t.email && e.writeElement(l + 'email', t.email),
                e.writeEndElement())
        }
      }),
      (t.writeCategory = function (t, e, i) {
        if (t) {
          var l = ''
          if ((i && (l = 'atom:'), Array.isArray(t)))
            for (var s = 0, n = t; s < n.length; s++) {
              var a = n[s]
              this.writeCategory(a, e, i)
            }
          else
            el.isValidString(t)
              ? e.writeStartElement(l + 'category', { term: t }, !0)
              : el.isValidString(t.term) && e.writeStartElement(l + 'category', t, !0)
        }
      }),
      (t.writeContributor = function (t, e, i) {
        if (t) {
          var l = ''
          if ((i && (l = 'atom:'), Array.isArray(t)))
            for (var s = 0, n = t; s < n.length; s++) {
              var a = n[s]
              this.writeContributor(a, e, i)
            }
          else
            el.isValidString(t)
              ? e
                  .writeStartElement(l + 'contributor')
                  .writeElement(l + 'name', t)
                  .writeEndElement()
              : (e.writeStartElement(l + 'contributor'),
                t.name && e.writeElement(l + 'name', t.name),
                t.uri && e.writeElement(l + 'uri', t.uri),
                t.email && e.writeElement(l + 'email', t.email),
                e.writeEndElement())
        }
      }),
      (t.writeLink = function (t, e, i) {
        if (t) {
          var l = ''
          if ((i && (l = 'atom:'), Array.isArray(t)))
            for (var s = 0, n = t; s < n.length; s++) {
              var a = n[s]
              this.writeLink(a, e, i)
            }
          else
            el.isValidString(t)
              ? e.writeStartElement(l + 'link', { href: t }, !0)
              : el.isValidString(t.href) && e.writeStartElement(l + 'link', t, !0)
        }
      }),
      t
    )
  })(),
  Xl = (function () {
    function t() {}
    return (
      (t.write = function (t, e) {
        e = new hl().merge(e)
        var i = new Zl(e.prettyPrint, e.newLineChars, e.indentChars)
        return this._writeGeoRssDoc(t, i, e), i.toString()
      }),
      (t._writeGeoRssDoc = function (t, e, i) {
        if (
          (e
            .writeStartDocument(!0)
            .writeStartElement(
              'feed',
              {
                xmlns: 'http://www.w3.org/2000/xmlns/',
                'xmlns:georss': 'http://www.georss.org/georss',
                'xmlns:gml': 'http://www.opengis.net/gml'
              },
              !1,
              !0
            ),
          t)
        ) {
          t.properties && Object.keys(t.properties).length > 0 && this._writeMetadata(t, e, !1)
          var l = Ai.getBounds(t)
          l && this._writeBounds(l, e, i), this._writeShapes(t.features, e, i, t.icons || {})
        }
        e.writeEndElement().writeEndDocument()
      }),
      (t._writeShapes = function (t, e, i, l) {
        for (var s = 0, n = t; s < n.length; s++) {
          var a = n[s]
          this._writeShape(a, e, i, l)
        }
      }),
      (t._writeShape = function (t, e, i, l) {
        e.writeStartElement('entry'), this._writeMetadata(t, e, i.writeIds)
        var s = t.properties || {}
        if ('Point' === t.geometry.type || 'MultiPoint' === t.geometry.type) {
          var n = null
          if (el.isValidString(s.image)) {
            var a = l[s.image]
            el.isUrl(a) ? (n = a) : el.isUrl(s.image) && (n = s.image)
          }
          n ||
            (el.isUrl(s.imageUrl) && el.isUrl(s.imageUrl)
              ? (n = s.imageUrl)
              : el.isUrl(s.icon) && (n = s.icon)),
            n && e.writeElement('icon', n)
        }
        var c = !1
        switch (t.geometry.type) {
          case 'Point':
            var d = t.geometry.coordinates
            t.properties &&
            'Circle' === t.properties.subType &&
            el.isValidNumber(t.properties.radius) &&
            t.properties.radius > 0
              ? (e.writeStartElement('georss:circle'),
                this._writeCoordinateValue(d, e, i),
                e.writeString(' ').writeString(t.properties.radius.toString()),
                e.writeEndElement(!0))
              : (e.writeStartElement('georss:point'),
                this._writeCoordinateValue(d, e, i),
                e.writeEndElement(!0)),
              el.isValidNumber(s.elev) ||
                (d.length >= 3
                  ? e.writeElement('georss:elev', s[2])
                  : el.isValidNumber(s.ele)
                  ? e.writeElement('georss:elev', s.ele)
                  : el.isValidNumber(s.elevation) && e.writeElement('georss:elev', s.elevation))
            break
          case 'LineString':
            var r = t.geometry.coordinates
            r.length > 0 &&
              (2 === r[0].length
                ? (e.writeStartElement('georss:line'),
                  this._writeCoordinates(r, e, i),
                  e.writeEndElement(!0))
                : (c = !0))
            break
          case 'Polygon':
            var o = t.geometry.coordinates
            if (o.length > 0) {
              var m = t.geometry.coordinates[0]
              m.length > 0 &&
                (1 === o.length && 2 === m[0].length
                  ? (el.closeRing(m),
                    e.writeStartElement('georss:polygon'),
                    this._writeCoordinates(m, e, i),
                    e.writeEndElement(!0))
                  : (c = !0))
            }
            break
          case 'MultiPoint':
          case 'MultiLineString':
          case 'MultiPolygon':
          default:
            c = !0
        }
        c &&
          (e.writeStartElement('georss:where'),
          pl._writeGeometry(t.geometry, e, 'gml:', null, null, null, null, 'EPSG:4326'),
          e.writeEndElement()),
          e.writeEndElement(!1)
      }),
      (t._writeCoordinateValue = function (t, e, i) {
        t &&
          t.length >= 2 &&
          (i.roundPositions && (t = el.roundPosition(t, 6)),
          e.writeString(t[1].toString()).writeString(' ').writeString(t[0].toString()))
      }),
      (t._writeCoordinates = function (t, e, i) {
        if (null != t)
          for (var l = 0, s = t.length; l < s; l++)
            this._writeCoordinateValue(t[l], e, i), l < s - 1 && e.writeString(' ')
      }),
      (t._writeMetadata = function (t, e, i) {
        var l = this,
          s = t.properties
        if (s) {
          if (i) {
            var n = t.id
            n || (s.id ? (n = s.id) : s.id && (n = s.guid)), n && e.writeElement('id', n)
          }
          Object.keys(s).forEach(function (t) {
            if ('id' !== t && 'guid' !== t) {
              var i = s[t]
              i && l._writeMetdataValue(t, i, s, e)
            }
          })
        }
      }),
      (t._writeMetdataValue = function (t, e, i, l) {
        var s = this
        switch (t) {
          case 'title':
            e && l.writeElement(t, e)
            break
          case 'name':
            e && !i.title && l.writeElement('title', e)
            break
          case 'description':
            e && !i.content && l.writeElement('content', e)
            break
          case 'desc':
            !e || i.content || i.description || l.writeElement('content', e)
            break
          case 'copyright':
            e && !i.rights && l.writeElement('rights', e)
            break
          case 'lastBuildDate':
            !e || i.timestamp || i.updated || l.writeElement('updated', e)
            break
          case 'timestamp':
            e && !i.updated && l.writeElement('updated', e)
            break
          case 'pubDate':
            e && !i.published && l.writeElement('published', e)
            break
          case 'content':
          case 'id':
          case 'logo':
          case 'published':
          case 'subtitle':
          case 'summary':
          case 'updated':
            e && l.writeElement(t, e)
            break
          case 'featuretypetag':
          case 'relationshiptag':
          case 'featurename':
          case 'elev':
          case 'floor':
            l.writeElement('georss:' + t, e)
            break
          case 'radius':
            'Circle' !== i.subType && l.writeElement('georss:' + t, e)
            break
          case 'author':
            yl.writeAuthor(e, l, !1)
            break
          case 'link':
            yl.writeLink(e, l, !1)
            break
          case 'category':
            yl.writeCategory(e, l, !1)
            break
          case 'contributor':
          case 'managingEditor':
            yl.writeContributor(e, l, !1)
            break
          case 'source':
            l.writeStartElement(t),
              el.isValidString(e.url)
                ? yl.writeLink(e.url, l, !1)
                : Object.keys(e).forEach(function (t) {
                    s._writeMetdataValue(t, e[t], i, l)
                  }),
              l.writeEndElement()
        }
      }),
      (t._writeBounds = function (t, e, l) {
        t &&
          (l.roundPositions && (t = el.roundBBox(t, 6)),
          e
            .writeStartElement('georss:box')
            .writeString(i.data.BoundingBox.getSouth(t).toString())
            .writeString(' ')
            .writeString(i.data.BoundingBox.getWest(t).toString())
            .writeString(' ')
            .writeString(i.data.BoundingBox.getNorth(t).toString())
            .writeString(' ')
            .writeString(i.data.BoundingBox.getEast(t).toString())
            .writeEndElement(!0))
      }),
      t
    )
  })(),
  Gl = (function () {
    function t() {}
    return (
      (t.write = function (t, e) {
        e = new bl().merge(e)
        var i = new Zl(e.prettyPrint, e.newLineChars, e.indentChars)
        return this._writeGpxDoc(t, i, e), i.toString()
      }),
      (t._writeGpxDoc = function (t, e, i) {
        e
          .writeStartDocument(!0)
          .writeStartElement(
            'gpx',
            {
              version: '1.1',
              xmlns: 'http://www.topografix.com/GPX/1/1',
              'xmlns:gpx_style': 'http://www.topografix.com/GPX/gpx_style/0/2',
              'xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
              'xsi:schemaLocation':
                'http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd http://www.topografix.com/GPX/gpx_style/0/2 http://www.topografix.com/GPX/gpx_style/0/2/gpx_style.xsd'
            },
            !1,
            !0
          ),
          t && (this._writeXmlDocMetadata(t, e, i), this._writeShapes(t.features, e, i)),
          e.writeEndElement().writeEndDocument()
      }),
      (t._writeXmlDocMetadata = function (t, e, i) {
        if (
          t &&
          ((t.features && t.features.length > 0) ||
            (t.properties && Object.keys(t.properties).length > 0))
        ) {
          if ((e.writeStartElement('metadata'), !t.properties.bounds))
            if (t.bbox) t.properties.bounds = t.bbox
            else {
              var l = Ai.getBounds(t)
              l && this._writeBounds(l, e, i), (t.properties.bounds = l)
            }
          this._writeMetadata(t, e, i), e.writeEndElement()
        }
      }),
      (t._writeShapes = function (t, e, i) {
        if (Array.isArray(t))
          for (var l = 0, s = t; l < s.length; l++) {
            var n = s[l]
            this._writeShape(n, e, i)
          }
      }),
      (t._writeShape = function (t, e, i) {
        if (t.geometry)
          switch (t.geometry.type) {
            case 'Point':
              this._writeWaypoint(t, e, i)
              break
            case 'LineString':
              this._writeRoute(t, e, i)
              break
            case 'MultiPoint':
              this._writeMultiPoint(t, e, i)
              break
            case 'MultiLineString':
              this._writeTrack(t, e, i)
          }
      }),
      (t._writeWaypoint = function (t, e, i) {
        var l = t.geometry.coordinates
        l.length >= 2 &&
          (i.roundPositions && (l = el.roundPosition(l, 6)),
          e.writeStartElement('wpt', { lat: l[1], lon: l[0] }),
          t.properties &&
            'number' != typeof t.properties.ele &&
            l.length >= 3 &&
            e.writeElement('ele', l[2]),
          this._writeMetadata(t, e, i),
          e.writeEndElement())
      }),
      (t._writeMultiPoint = function (t, e, i) {
        for (var l = t.geometry.coordinates, s = 0, n = l.length; s < n; s++)
          i.roundPositions && (l[s] = el.roundPosition(l[s], 6)),
            e.writeStartElement('wpt', { lat: l[s][1], lon: l[s][0] }),
            t.properties &&
              'number' != typeof t.properties.ele &&
              l[s].length >= 3 &&
              e.writeElement('ele', l[s][2]),
            this._writeMetadata(t, e, i),
            e.writeEndElement()
      }),
      (t._writeRoute = function (t, e, i) {
        e.writeStartElement('rte'), this._writeMetadata(t, e, i)
        var l = t.geometry.coordinates,
          s = !1
        t.properties &&
          t.properties.waypoints &&
          t.properties.waypoints.length === l.length &&
          (s = !0)
        for (var n = 0, a = l.length; n < a; n++)
          i.roundPositions && (l[n] = el.roundPosition(l[n], 6)),
            e.writeStartElement('rtept', { lat: l[n][1], lon: l[n][0] }),
            s
              ? ('number' != typeof t.properties.ele &&
                  l[n].length >= 3 &&
                  e.writeElement('ele', l[2]),
                this._writeMetadata(t.properties.waypoints[n], e, i))
              : l[n].length >= 3 && e.writeElement('ele', l[n][2]),
            e.writeEndElement()
        e.writeEndElement()
      }),
      (t._writeTrack = function (t, e, i) {
        e.writeStartElement('trk'), this._writeMetadata(t, e, i)
        for (var l = t.geometry.coordinates, s = !1, n = 0, a = 0, c = l; a < c.length; a++) {
          n += c[a].length
        }
        t.properties && t.properties.waypoints && n === l.length && (s = !0)
        for (var d = 0, r = l.length; d < r; d++) {
          e.writeStartElement('trkseg')
          for (var o = 0, m = l[d].length; o < m; o++) {
            var u = l[d][o]
            i.roundPositions && (u = el.roundPosition(u, 6)),
              e.writeStartElement('trkpt', { lat: u[1], lon: u[0] }),
              s
                ? ('number' != typeof t.properties.ele &&
                    u.length >= 3 &&
                    e.writeElement('ele', u[2]),
                  this._writeMetadata(t.properties.waypoints[d], e, i))
                : u.length >= 3 && e.writeElement('ele', u[2]),
              e.writeEndElement()
          }
          e.writeEndElement()
        }
        e.writeEndElement()
      }),
      (t._writeMetadata = function (t, e, i) {
        var l = this
        if (t) {
          var s = !1,
            n = t
          if (
            ('Feature' === n.type &&
              'Point' === n.geometry.type &&
              n.geometry.coordinates.length >= 3 &&
              (!t.properties || 'number' != typeof t.properties.ele) &&
              (e.writeElement('ele', n.geometry.coordinates[2]), (s = !0)),
            t.properties)
          ) {
            var a,
              c = t.properties
            Object.keys(c).forEach(function (t) {
              switch (t.toLowerCase()) {
                case 'name':
                case 'desc':
                  el.isValidString(c[t]) && e.writeElement(t, c[t])
                  break
                case 'description':
                  el.isValidString(c.desc) || e.writeElement('desc', c[t])
                  break
                case 'title':
                  el.isValidString(c.name) || e.writeElement('name', c[t])
                  break
                case 'cmt':
                case 'src':
                case 'sym':
                case 'type':
                case 'keywords':
                case 'fix':
                  el.isValidString(c[t]) && e.writeElement(t, c[t])
                  break
                case 'bounds':
                  Array.isArray(c[t]) && l._writeBounds(c[t], e, i)
                  break
                case 'magvar':
                case 'geoidheight':
                case 'hdop':
                case 'vdop':
                case 'pdop':
                case 'ageofdgpsdata':
                case 'sat':
                case 'dgpsid':
                case 'ele':
                  el.isValidNumber(c[t]) && e.writeElement(t, c[t])
                  break
                case 'height':
                  !s && void 0 === c.ele && el.isValidNumber(c[t]) && e.writeElement('ele', c[t])
                  break
                case 'time':
                  ;(a = c[t]), c[t].when && (a = c[t].when)
                  break
                case 'timestamp':
                case 'updated':
                case 'lastbuilddate':
                case 'pubdate':
                case 'published':
                  a || ((a = c[t]), c[t].when && (a = c[t].when))
                  break
                case 'author':
                  if ((e.writeStartElement('author'), el.isValidString(c[t])))
                    e.writeElement('name', c[t])
                  else {
                    if ((c[t].name && e.writeElement('name', c[t].name), c[t].email))
                      if ('string' == typeof c[t].email && c[t].email.includes('@')) {
                        var n = c[t].email.split('@')
                        n.length >= 2 &&
                          e.writeStartElement('email', { domain: n[1], id: n[0] }, !0)
                      } else
                        c[t].email.id &&
                          c[t].email.domain &&
                          e.writeStartElement(
                            'email',
                            { domain: c[t].email.domain, id: c[t].email.id },
                            !0
                          )
                    c[t].link && l._writeLink(c[t].link, e)
                  }
                  e.writeEndElement()
                  break
                case 'copyright':
                  c.copyright &&
                    (el.isValidString(c.copyright)
                      ? e
                          .writeStartElement('copyright')
                          .writeElement('license', c.copyright)
                          .writeEndElement()
                      : (c.copyright.author || c.copyright.year || c.copyright.license) &&
                        (c.author
                          ? e.writeStartElement('copyright', { author: c.author })
                          : e.writeStartElement('copyright'),
                        c.year && e.writeElement('year', c.year),
                        c.license && e.writeElement('license', c.license),
                        e.writeEndElement()))
                  break
                case 'link':
                  l._writeLink(c[t], e)
              }
            })
            var d = null
            if (el.isValidString(a)) {
              var r = Date.parse(a)
              r && (d = new Date(r))
            } else el.isValidNumber('number' === a) && (d = new Date(d))
            d && d instanceof Date && e.writeElement('time', d),
              'Feature' !== n.type ||
                ('LineString' !== n.geometry.type && 'MultiLineString' !== n.geometry.type) ||
                this._writeLineStyleExtension(c, e)
          }
        }
      }),
      (t._writeLink = function (t, e) {
        t &&
          (el.isValidString(t)
            ? e.writeStartElement('link', { href: t }, !0)
            : el.isValidString(t.href) &&
              (e.writeStartElement('link', { href: t.href }),
              el.isValidString(t.text)
                ? e.writeElement('text', t.text)
                : el.isValidString(t.title) && e.writeElement('text', t.title),
              el.isValidString(t.type) && e.writeElement('type', t.type),
              e.writeEndElement()))
      }),
      (t._writeBounds = function (t, e, l) {
        t &&
          (l.roundPositions && (t = el.roundBBox(t, 6)),
          e.writeStartElement(
            'bounds',
            {
              maxlat: i.data.BoundingBox.getNorth(t),
              maxlon: i.data.BoundingBox.getEast(t),
              minlat: i.data.BoundingBox.getSouth(t),
              minlon: i.data.BoundingBox.getWest(t)
            },
            !0
          ))
      }),
      (t._writeLineStyleExtension = function (t, e) {
        ;(el.isValidString(t.strokeColor) || el.isValidNumber(t.strokeWidth)) &&
          (e.writeStartElement('extensions'),
          e.writeStartElement('gpx_style:line'),
          '' !== t.strokeColor && this._writeColor(t.strokeColor, e),
          t.strokeWidth > 0 && e.writeElement('gpx_style:width', t.strokeWidth / el.mmPerPixelGpx),
          e.writeEndElement().writeEndElement())
      }),
      (t._writeColor = function (t, e) {
        if (el.isValidString(t)) {
          e.writeElement('gpx_style:color', el.colorToHex(t))
          var i = el.colorToRgbaArray(t)
          1 !== i[3] && e.writeElement('gpx_style:opacity', i[3])
        }
      }),
      t
    )
  })(),
  Wl = (function () {
    function t() {
      ;(this._images = []), (this._idLookup = {}), (this._failedUrls = new Set())
    }
    return (
      (t.prototype.addImage = function (e, i, l, s) {
        return a(this, void 0, void 0, function () {
          var n, a, d
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return e && (e = e.replace('root://', '').replace(/&amp;/g, '&'))
                  ? this._failedUrls.has(e)
                    ? [2, null]
                    : ((n = void 0),
                      l
                        ? [3, 6]
                        : (i && (n = this.getImage(i)),
                          n
                            ? [2, n]
                            : (n = this.getImage(e))
                            ? [2, n]
                            : e.startsWith('data:')
                            ? [4, t._tryLoadImage(e)]
                            : [3, 2]))
                  : [3, 7]
              case 1:
                return (n = c.sent()), [3, 6]
              case 2:
                return (
                  (a = el.parseURL(e)),
                  '' === (d = a.protocol + a.hostName)
                    ? [3, 6]
                    : t._noCorsDomains.has(d)
                    ? [3, 4]
                    : [4, t._tryLoadImage(e)]
                )
              case 3:
                ;(n = c.sent()) && n.noCors && (t._noCorsDomains.add(d), (n = null)), (c.label = 4)
              case 4:
                return !n && a.protocol && '' !== a.protocol && s
                  ? [4, t._tryLoadImage(e, s)]
                  : [3, 6]
              case 5:
                ;(n = c.sent()), (c.label = 6)
              case 6:
                if (
                  (n ||
                    ((n = t._tryGetFallbackColor(e)),
                    i &&
                      (n || (n = t._tryGetFallbackColor(i)),
                      (this._idLookup[i] = this._images.length),
                      n && (n.id = i))),
                  n)
                )
                  return (
                    n.url && (i ? (n.id = i) : (i = n.url)),
                    (this._idLookup[i] = this._images.length),
                    i !== n.id && (this._idLookup[n.id] = this._idLookup[i]),
                    this._images.push(n),
                    [2, n]
                  )
                this._failedUrls.add(e), (c.label = 7)
              case 7:
                return [2, null]
            }
          })
        })
      }),
      (t.prototype.getImage = function (t) {
        t = t.replace('root://', '')
        var e = this._idLookup[t]
        return e >= 0 ? this._images[e] : null
      }),
      (t.prototype.getIcons = function () {
        var t = {}
        return (
          this._images.forEach(function (e) {
            e.isIcon && e.url && (t[e.id] = e.url)
          }),
          t
        )
      }),
      (t.prototype.getAllImages = function () {
        return this._images
      }),
      (t.prototype.isCorsEnabledDomain = function (t) {
        return a(this, void 0, void 0, function () {
          var e, i
          return c(this, function (l) {
            switch (l.label) {
              case 0:
                if (!el.isValidString(t)) return [3, 8]
                l.label = 1
              case 1:
                if (
                  (l.trys.push([1, 7, , 8]),
                  (e = el.parseURL(t)),
                  '' === (i = e.protocol + e.hostName) || this._failedUrls.has(i))
                )
                  return [3, 6]
                l.label = 2
              case 2:
                return l.trys.push([2, 4, , 5]), [4, el.ajaxGetAsync(t, null, null, !0, 'image')]
              case 3:
                return l.sent() ? [2, !0] : [3, 5]
              case 4:
                return l.sent(), [3, 5]
              case 5:
                this._failedUrls.add(i), (l.label = 6)
              case 6:
                return [3, 8]
              case 7:
                return l.sent(), [3, 8]
              case 8:
                return [2, !1]
            }
          })
        })
      }),
      (t._tryLoadImage = function (t, e) {
        return a(this, void 0, void 0, function () {
          var i, l, s, n, a, d
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return (
                  c.trys.push([0, 8, , 9]),
                  (i = { id: t, url: e ? e + encodeURIComponent(t) : t }),
                  [4, el.ajaxGetAsync(t, e, null, !0, 'image')]
                )
              case 1:
                if (!((l = c.sent()) instanceof ArrayBuffer && createImageBitmap)) return [3, 6]
                c.label = 2
              case 2:
                return (
                  c.trys.push([2, 4, , 5]),
                  (s = el.arrayBufferToString(l, 10).toLowerCase()).startsWith('png')
                    ? (i.type = 'PNG')
                    : s.startsWith('jpg') || s.startsWith('jpeg')
                    ? (i.type = 'JPG')
                    : s.startsWith('bmp')
                    ? (i.type = 'BMP')
                    : s.startsWith('gif') && (i.type = 'GIF'),
                  [4, createImageBitmap(new Blob([l]))]
                )
              case 3:
                return (n = c.sent()), (i.height = n.height), (i.width = n.width), [3, 5]
              case 4:
                return c.sent(), [3, 5]
              case 5:
                return [3, 7]
              case 6:
                return [2, null]
              case 7:
                return [2, i]
              case 8:
                return (
                  (a = c.sent()),
                  (d = void 0),
                  'string' == typeof a ? (d = a) : a instanceof Error && (d = a.message),
                  d && d.includes('CORs') ? [2, { noCors: !0 }] : [2, null]
                )
              case 9:
                return [2]
            }
          })
        })
      }),
      (t._tryGetFallbackColor = function (t) {
        if (t) {
          var e = el.parseURL(t)
          if (e.fileName) {
            var i = e.fileName.toLowerCase()
            i.indexOf('.') > 0 && (i = i.substr(0, i.lastIndexOf('.')))
            var l = el.cssColorNames[i]
            if (!l) {
              var s = i.indexOf('-'),
                n = 1
              if ((-1 === s && ((s = i.indexOf(', ')), (n = 2)), s > -1 && s < i.length - n)) {
                var a = i.substr(0, s),
                  c = i.substr(s + n)
                ;(l = el.cssColorNames[a]) || (l = el.cssColorNames[c])
              }
            }
            if (l) return { color: l }
          }
        }
        return null
      }),
      (t._noCorsDomains = new Set()),
      t
    )
  })(),
  Vl = (function () {
    function t(t, e) {
      ;(this._styleIdIndex = 0),
        (this._embeddedImageIdx = 0),
        (this._embeddedImageMap = {}),
        (this._schemaInfo = {}),
        (this._schemaName = 'CustomSchemaType'),
        (this._displayNames = {}),
        (this._popupTemplatePlaceholder = /\{([-a-zA-Z0-9_]+)((\/?)([-a-zA-Z0-9_]+))*\}/gi),
        (this._options = new bl().merge(t)),
        (this._imageManager = new Wl()),
        e && (this._parentKmz = e)
    }
    return (
      (t.prototype.write = function (t) {
        return a(this, void 0, void 0, function () {
          var e
          return c(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (this._styleIdIndex = 0),
                  (this._styles = {}),
                  (this._styleHashIds = {}),
                  t
                    ? ((e = new Zl(
                        this._options.prettyPrint,
                        this._options.newLineChars,
                        this._options.indentChars
                      )),
                      [4, this._writeKmlDoc(t, e)])
                    : [3, 2]
                )
              case 1:
                return i.sent(), [2, e.toString()]
              case 2:
                return [2, null]
            }
          })
        })
      }),
      (t.prototype._writeKmlDoc = function (t, e) {
        return a(this, void 0, void 0, function () {
          var i, l
          return c(this, function (s) {
            switch (s.label) {
              case 0:
                if (
                  (e
                    .writeStartDocument(!0)
                    .writeStartElement(
                      'kml',
                      {
                        xmlns: 'http://www.opengis.net/kml/2.2',
                        'xmlns:atom': 'http://www.w3.org/2000/xmlns/',
                        'xmlns:gx': 'http://www.google.com/kml/ext/2.2"'
                      },
                      !1,
                      !0
                    ),
                  e.writeStartElement('Document'),
                  !t)
                )
                  return [3, 2]
                if (
                  (t.properties &&
                    Object.keys(t.properties).length > 0 &&
                    this._writeMetadata(t, e),
                  (i = Ai.getBounds(t)) && this._writeBounds(i, e),
                  (this._icons = t.icons || {}),
                  t._groundOverlayOptions && t._groundOverlayOptions.length > 0)
                )
                  for (l = t._groundOverlayOptions.length - 1; l >= 0; l--)
                    this._writeGroundOverlay(t._groundOverlayOptions[l], e)
                return t.features && t.features.length > 0
                  ? ((t.features = t.features.reverse()), [4, this._processStyles(t.features, e)])
                  : [3, 2]
              case 1:
                s.sent(), this._writeShapes(t.features, e), (s.label = 2)
              case 2:
                return e.writeEndElement().writeEndElement().writeEndDocument(), [2]
            }
          })
        })
      }),
      (t.prototype._processStyles = function (t, e) {
        return a(this, void 0, void 0, function () {
          var i, l, s
          return c(this, function (n) {
            switch (n.label) {
              case 0:
                if ((this._combineStylesSchema(t), !this._styles)) return [3, 4]
                ;(i = 0), (l = Object.keys(this._styles)), (n.label = 1)
              case 1:
                return i < l.length
                  ? ((s = l[i]), [4, this._writeStyle(this._styles[s], e, s)])
                  : [3, 4]
              case 2:
                n.sent(), (n.label = 3)
              case 3:
                return i++, [3, 1]
              case 4:
                return this._processSchemaInfo(e), [2]
            }
          })
        })
      }),
      (t.prototype._writeShapes = function (t, e) {
        for (var i = 0, l = t; i < l.length; i++) {
          var s = l[i]
          this._writePlacemark(s, e)
        }
      }),
      (t.prototype._writeMetadata = function (t, e) {
        var i = t.properties
        if (i) {
          ;(('boolean' == typeof i.visibility && !i.visibility) ||
            ('boolean' == typeof i.visible && !i.visible)) &&
            e.writeElement('visibility', '0')
          var l,
            s = {},
            n = !1
          Object.keys(i).forEach(function (a) {
            var c = i[a]
            switch (a.toLowerCase()) {
              case 'name':
                c && e.writeElement('name', c)
                break
              case 'title':
                i.name || e.writeElement('name', c)
                break
              case 'description':
                i.description && e.writeElement(a, c)
                break
              case 'desc':
                i.description || e.writeElement('description', c)
                break
              case 'atom:name':
              case 'address':
              case 'phonenumber':
              case 'snippet':
                e.writeElement(a, c)
                break
              case 'open':
                ;(0 !== c && !1 !== c) || e.writeElement(a, '0')
                break
              case 'author':
                yl.writeAuthor(c, e, !0)
                break
              case 'link':
                yl.writeLink(c, e, !0)
                break
              case 'timestamp':
                c && '' !== c && ((l = c), c.when && (l = c.when))
                break
              case 'time':
              case 'updated':
              case 'lastbuilddate':
              case 'pubdate':
              case 'published':
                !l && c && '' !== c && ((l = c), c.when && (l = c.when))
                break
              case 'timespan':
                c &&
                  (c.begin instanceof Date || c.end instanceof Date) &&
                  (e.writeStartElement('TimeStamp'),
                  c.begin && e.writeElement('begin', c.begin),
                  c.end && e.writeElement('end', c.end),
                  e.writeEndElement())
                break
              case 'addressdetails':
              case 'id':
              case 'guid':
                break
              case 'height':
                'Polygon' !== t.type && 'MultiPolygon' !== t.type && ((s[a] = c), (n = !0))
                break
              case 'extendeddata':
              default:
                el.ignoreProperty(a, c) || ((s[a] = c), (n = !0))
            }
          })
          var a = null
          if (el.isValidString(l)) {
            var c = Date.parse(l)
            c && (a = new Date(c))
          } else el.isValidNumber(l) && (a = new Date(l))
          a &&
            a instanceof Date &&
            e.writeStartElement('TimeStamp').writeElement('when', a).writeEndElement(),
            n && this._writeExtendedData(s, e)
        }
      }),
      (t.prototype._writeExtendedData = function (t, e) {
        var i = this
        if (t) {
          e.writeStartElement('ExtendedData')
          var l = !1
          Object.keys(t).forEach(function (s) {
            if (i._schemaInfo[s]) {
              var n = t[s],
                a = void 0
              n instanceof Object && !(n instanceof Date)
                ? void 0 !== n.value && (a = n.value)
                : (a = n),
                void 0 !== a &&
                  (i._useSchema
                    ? (l ||
                        (e.writeStartElement('SchemaData', {
                          schemaUrl: '#' + i._schemaName + 'Id'
                        }),
                        (l = !0)),
                      e.writeElement('SimpleData', a, { name: s }))
                    : (e.writeStartElement('Data', { name: s }),
                      n.displayName && e.writeElement('displayName', n.displayName),
                      e.writeElement('value', a).writeEndElement()))
            }
          }),
            l && e.writeEndElement(),
            e.writeEndElement()
        }
      }),
      (t.prototype._writePlacemark = function (t, e) {
        if (null != t && t.geometry) {
          var i = void 0
          this._options.writeIds &&
            (t.id
              ? (i = { id: t.id })
              : t.properties && null != t.properties.id && (i = { id: t.properties.id })),
            e.writeStartElement('Placemark', i),
            t.properties &&
              (this._writeMetadata(t, e),
              t.properties._KmlStyleId &&
                (e.writeElement('styleUrl', '#' + t.properties._KmlStyleId),
                delete t.properties._KmlStyleId)),
            ('Polygon' !== t.geometry.type && 'MultiPolygon' !== t.geometry.type) ||
              !t.properties.height ||
              0 === t.properties.height ||
              (this._height = t.properties.height),
            this._writeGeometry(t.geometry, e),
            (this._height = null),
            e.writeEndElement()
        }
      }),
      (t.prototype._writeGeometry = function (t, e) {
        if (t)
          switch (t.type) {
            case 'Point':
              this._writePoint(t, e)
              break
            case 'LineString':
              this._writeLineString(t, e)
              break
            case 'Polygon':
              this._writePolygon(t, e)
              break
            case 'MultiPoint':
            case 'MultiLineString':
            case 'MultiPolygon':
              this._writeMultiGeometry(t, e)
          }
      }),
      (t.prototype._writePoint = function (t, e) {
        e.writeStartElement('Point').writeStartElement('coordinates'),
          this._writeCoordinateValue(t.coordinates, e),
          e.writeEndElement(!0).writeEndElement()
      }),
      (t.prototype._writeLineString = function (t, e) {
        e.writeStartElement('LineString'),
          this._writeCoordinates(t.coordinates, !1, e),
          e.writeEndElement()
      }),
      (t.prototype._writePolygon = function (t, e) {
        var i = t.coordinates
        if (i.length > 0) {
          if (
            (e.writeStartElement('Polygon'),
            el.closeRing(i[0]),
            e.writeStartElement('outerBoundaryIs').writeStartElement('LinearRing'),
            this._writeCoordinates(i[0], !0, e),
            e.writeEndElement().writeEndElement(),
            i.length > 1 && i[0].length > 0)
          ) {
            var l = !1
            3 === i[0][0].length && (l = !0)
            for (var s = 1, n = i.length; s < n; s++)
              el.closeRing(i[s]),
                e.writeStartElement('innerBoundaryIs').writeStartElement('LinearRing'),
                l && e.writeElement('extrude', 1),
                this._writeCoordinates(i[s], !0, e),
                e.writeEndElement().writeEndElement()
          }
          e.writeEndElement()
        }
      }),
      (t.prototype._writeMultiGeometry = function (t, e) {
        if (t.coordinates.length > 0) {
          e.writeStartElement('MultiGeometry')
          for (var i = 0, l = t.coordinates; i < l.length; i++) {
            var s = l[i]
            switch (t.type) {
              case 'MultiPoint':
                e.writeStartElement('Point').writeStartElement('coordinates'),
                  this._writeCoordinateValue(s, e),
                  e.writeEndElement(!0).writeEndElement()
                break
              case 'MultiLineString':
                e.writeStartElement('LineString'),
                  this._writeCoordinates(s, !1, e),
                  e.writeEndElement()
                break
              case 'MultiPolygon':
                var n = s
                if (n.length > 0) {
                  if (
                    (e.writeStartElement('Polygon'),
                    e.writeStartElement('outerBoundaryIs').writeStartElement('LinearRing'),
                    this._writeCoordinates(n[0], !0, e),
                    e.writeEndElement().writeEndElement(),
                    n.length > 1)
                  )
                    for (var a = 1, c = n.length; a < c; a++)
                      e.writeStartElement('innerBoundaryIs').writeStartElement('LinearRing'),
                        this._writeCoordinates(n[a], !0, e),
                        e.writeEndElement().writeEndElement()
                  e.writeEndElement()
                }
            }
          }
          e.writeEndElement()
        }
      }),
      (t.prototype._writeCoordinateValue = function (t, e) {
        if (this._options.roundPositions) {
          var i = el.roundPosition(t, 6)
          e.writeString(i[0].toString()).writeString(',').writeString(i[1].toString())
        } else e.writeString(t[0].toString()).writeString(',').writeString(t[1].toString())
        t.length >= 3
          ? e.writeString(',').writeString(t[2].toString())
          : this._height && e.writeString(',').writeString(this._height.toString())
      }),
      (t.prototype._writeCoordinates = function (t, e, l) {
        if (null != t) {
          l.writeStartElement('coordinates'),
            e && t.length >= 3 && !i.data.Position.areEqual(t[0], t[t.length - 1]) && t.push(t[0])
          for (var s = 0, n = t.length; s < n; s++)
            this._writeCoordinateValue(t[s], l), s < n - 1 && l.writeString(' ')
          l.writeEndElement(!0)
        }
      }),
      (t.prototype._writeGroundOverlay = function (t, e) {
        if (el.isUrl(t.url) && (t.bounds || (t.coordinates && t.coordinates.length >= 4))) {
          var l = void 0
          if (
            (this._options.writeIds && t.id && null != t.id && (l = { id: t.id }),
            e.writeStartElement('GroundOverlay', l),
            t.properties && this._writeMetadata(t.properties, e),
            this._writeIcon(t.url, e, t.isWMS),
            t.coordinates && t.coordinates.length >= 4)
          ) {
            e.writeStartElement('gx:LatLonQuad').writeStartElement('coordinates')
            for (var s = t.coordinates.reverse(), n = 0; n < 4; n++)
              this._options.roundPositions && (s[n] = el.roundPosition(s[n], 6)),
                e.writeValue(s[n][0]).writeValue(',').writeValue(s[n][1]),
                n < 3 && e.writeValue(' ')
            e.writeEndElement().writeEndElement()
          } else if (t.bounds) {
            var a = t.bounds
            this._options.roundPositions && (a = el.roundBBox(a, 6)),
              e
                .writeStartElement('LatLonBox')
                .writeElement('north', i.data.BoundingBox.getNorth(a))
                .writeElement('south', i.data.BoundingBox.getSouth(a))
                .writeElement('east', i.data.BoundingBox.getEast(a))
                .writeElement('west', i.data.BoundingBox.getWest(a))
                .writeEndElement()
          }
          el.isValidNumber(t.opacity) &&
            1 !== t.opacity &&
            this._writeKmlColor('color', '#ffffff', e, t.opacity),
            e.writeEndElement()
        }
      }),
      (t.prototype._writeIcon = function (t, e, i) {
        if (t && el.isUrl(t)) {
          if (this._parentKmz && t.startsWith('data:image')) {
            var l = this._embeddedImageMap[t]
            if (!l) {
              var s = void 0
              switch (t.substring(11, t.indexOf(';')).toLowerCase()) {
                case 'jpg':
                case 'jpeg':
                  s = '.jpg'
                  break
                case 'png':
                  s = '.png'
                  break
                case 'gif':
                  s = '.gif'
                  break
                case 'bmp':
                  s = '.bmp'
              }
              ;(l = 'embeddedImage' + this._embeddedImageIdx + s),
                this._embeddedImageIdx++,
                (this._embeddedImageMap[t] = l),
                this._parentKmz.file(l, t.substring(t.indexOf(',')), { base64: !0 }),
                (t = l)
            }
          }
          e.writeStartElement('Icon').writeElement('href', t, null),
            i && e.writeElement('viewRefreshMode', 'onStop').writeElement('viewRefreshTime', 1),
            e.writeEndElement()
        }
      }),
      (t.prototype._writeKmlColor = function (t, e, i, l) {
        if (el.isValidString(e)) {
          var s = el.colorToRgbaArray(e)
          if (s && s.length) {
            if (0 === s[3]) return null
            var n = '',
              a = void 0,
              c = s[3]
            el.isValidNumber(l) && (c *= l),
              (a = Math.round(255 * c).toString(16)).length < 2 && (n += '0'),
              (n += a),
              (a = Math.round(s[2]).toString(16)).length < 2 && (n += '0'),
              (n += a),
              (a = Math.round(s[1]).toString(16)).length < 2 && (n += '0'),
              (n += a),
              (a = Math.round(s[0]).toString(16)).length < 2 && (n += '0'),
              (n += a),
              i.writeElement(t, n)
          }
        }
      }),
      (t.prototype._writeStyle = function (t, e, i) {
        return a(this, void 0, void 0, function () {
          var l, s, n, a, d, r, o, m, u
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return t
                  ? (void 0 !== i
                      ? e.writeStartElement('Style', { id: i })
                      : e.writeStartElement('Style'),
                    (l = t.image && this._icons[t.image] ? this._icons[t.image] : t.imageUrl)
                      ? (e.writeStartElement('IconStyle'),
                        this._writeIcon(l, e),
                        [4, this._imageManager.addImage(l)])
                      : [3, 2])
                  : [3, 3]
              case 1:
                if (
                  ((s = c.sent()),
                  (n = s && s.width ? s.width : 32),
                  (a = s && s.height ? s.height : 32),
                  (d = Math.max(n, a) / 32),
                  (r = 1),
                  el.isValidNumber(t.size) &&
                    1 !== t.size &&
                    ((r = Math.round(d * t.size * 100) / 100), e.writeElement('scale', r)),
                  (o = 0),
                  (m = 0),
                  t.anchor)
                ) {
                  switch (t.anchor) {
                    case 'center':
                      ;(o = 0.5), (m = 0.5)
                      break
                    case 'left':
                      m = 0.5
                      break
                    case 'right':
                      ;(o = 1), (m = 0.5)
                      break
                    case 'top':
                    case 'bottom':
                      o = 0.5
                      break
                    case 'top-right':
                      ;(o = 1), (m = 1)
                      break
                    case 'bottom-right':
                      o = 1
                      break
                    case 'top-left':
                      m = 1
                  }
                  ;(o *= n), (m *= a)
                }
                return (
                  t.offset &&
                    Array.isArray(t.offset) &&
                    t.offset.length >= 2 &&
                    ((o -= Math.round((t.offset[0] * d) / r)),
                    (m = Math.round((t.offset[1] * d) / r))),
                  (0 === o && 0 === m) ||
                    e.writeStartElement(
                      'hotSpot',
                      { x: o, xunits: 'pixels', y: m, yunits: 'pixels' },
                      !0
                    ),
                  t.rotation && e.writeElement('heading', t.rotation),
                  e.writeEndElement(),
                  [3, 3]
                )
              case 2:
                t.color &&
                  (e.writeStartElement('IconStyle'),
                  t.color && this._writeKmlColor('color', t.color, e),
                  t.size && 1 !== t.size && e.writeElement('scale', t.size),
                  e.writeEndElement()),
                  (c.label = 3)
              case 3:
                return (
                  (!t.strokeColor && isNaN(t.strokeWidth)) ||
                    (e.writeStartElement('LineStyle'),
                    t.strokeColor &&
                      this._writeKmlColor('color', t.strokeColor, e, t.strokeOpacity),
                    isNaN(t.strokeWidth) || e.writeElement('width', t.strokeWidth),
                    e.writeEndElement()),
                  t.fillColor &&
                    (e.writeStartElement('PolyStyle'),
                    this._writeKmlColor('color', t.fillColor, e, t.fillOpacity),
                    0 === t.fillOpacity && e.writeElement('fill', 0),
                    (u = 1),
                    0 === t.strokeOpacity && (u = 0),
                    e.writeElement('outline', u).writeEndElement()),
                  t.balloonStyle &&
                    (e.writeStartElement('BalloonStyle'),
                    e.writeElement('text', t.balloonStyle.text),
                    t.balloonStyle.textColor &&
                      this._writeKmlColor('textColor', t.balloonStyle.textColor, e),
                    t.balloonStyle.bgColor &&
                      this._writeKmlColor('bgColor', t.balloonStyle.bgColor, e),
                    e.writeEndElement()),
                  e.writeEndElement(),
                  [2]
                )
            }
          })
        })
      }),
      (t.prototype._combineStylesSchema = function (t) {
        if (Array.isArray(t))
          for (var e = 0, i = t; e < i.length; e++) {
            var l = i[e]
            this._extractSchemaInfo(l)
            var s = this._extractStyle(l),
              n = this._createStyleHash(s)
            if (n) {
              var a = this._styleHashIds[n]
              a ||
                ((a = 'style' + this._styleIdIndex),
                (this._styleHashIds[n] = a),
                (this._styles[a] = s),
                this._styleIdIndex++),
                l.properties || (l.properties = {}),
                (l.properties._KmlStyleId = a)
            }
          }
      }),
      (t.prototype._createStyleHash = function (t) {
        if (t) {
          var e = []
          if (
            (e.push('style'),
            t.imageUrl && e.push(t.imageUrl),
            t.anchor && e.push(t.anchor),
            Array.isArray(t.offset) && t.offset.length >= 2 && e.push(t.offset[0].toString()),
            el.isValidNumber(t.rotation) && e.push(t.rotation.toString()),
            el.isValidNumber(t.size) && e.push(t.size.toString()),
            t.color && e.push(t.color),
            t.strokeColor && e.push(t.strokeColor),
            el.isValidNumber(t.strokeOpacity) && e.push(t.strokeOpacity.toString()),
            el.isValidNumber(t.strokeWidth) && e.push(t.strokeWidth.toString()),
            t.fillColor && e.push(t.fillColor),
            el.isValidNumber(t.fillOpacity) && e.push(t.fillOpacity.toString()),
            'boolean' != typeof t.visible || t.visible || e.push(t.visible.toString()),
            t.balloonStyle && e.push(JSON.stringify(t.balloonStyle)),
            e.length > 1)
          )
            return e.join('_')
        }
        return null
      }),
      (t.prototype._extractSchemaInfo = function (t) {
        var e,
          i,
          l,
          s,
          n,
          a = this,
          c = t.properties
        c &&
          Object.keys(c).forEach(function (t) {
            switch (((n = c[t]), t)) {
              case 'name':
              case 'title':
              case 'description':
              case 'desc':
              case 'atom:name':
              case 'address':
              case 'phoneNumber':
              case 'Snippet':
              case 'open':
              case 'author':
              case 'link':
              case 'TimeStamp':
              case 'TimeSpan':
              case 'id':
              case 'visibility':
              case 'AddressDetails':
                s = !1
                break
              default:
                s = !el.ignoreProperty(t, n)
            }
            if (s) {
              switch (
                ((n = c[t]),
                (e = typeof n),
                n instanceof Object &&
                  void 0 !== n.value &&
                  ((e = typeof n.value), n.displayName && (a._displayNames[t] = n.displayName)),
                e)
              ) {
                case 'number':
                  ;(l = Number.isInteger(n)), (e = l ? 'int' : 'float'), (a._useSchema = !0)
                  break
                case 'boolean':
                  ;(e = 'bool'), (a._useSchema = !0)
              }
              if ((i = a._schemaInfo[t])) {
                if (i !== e && 'string' !== i)
                  switch (e) {
                    case 'number':
                      'int' === i && (Number.isInteger(n) || (a._schemaInfo[t] = 'float'))
                      break
                    case 'string':
                    case 'bool':
                      a._schemaInfo[t] = 'string'
                      break
                    default:
                      a._schemaInfo[t] = e
                  }
              } else a._schemaInfo[t] = e
            }
          })
        return null
      }),
      (t.prototype._processSchemaInfo = function (t) {
        var e = this
        this._useSchema &&
          (t.writeStartElement('Schema', { id: this._schemaName + 'Id', name: this._schemaName }),
          Object.keys(this._schemaInfo).forEach(function (i) {
            e._schemaInfo[i] &&
              (e._displayNames[i]
                ? t
                    .writeStartElement('SimpleField', { name: i, type: e._schemaInfo[i] })
                    .writeElement('displayName', e._displayNames[i])
                    .writeEndElement()
                : t.writeStartElement('SimpleField', { name: i, type: e._schemaInfo[i] }, !0))
          }),
          t.writeEndElement())
      }),
      (t.prototype._writeBounds = function (t, e) {
        Array.isArray(t) &&
          t.length >= 4 &&
          (e.writeStartElement('Region'),
          this._options.roundPositions && (t = el.roundBBox(t, 6)),
          e
            .writeStartElement('LatLonAltBox')
            .writeElement('north', i.data.BoundingBox.getNorth(t).toString())
            .writeElement('south', i.data.BoundingBox.getSouth(t).toString())
            .writeElement('east', i.data.BoundingBox.getEast(t).toString())
            .writeElement('west', i.data.BoundingBox.getWest(t).toString())
            .writeEndElement()
            .writeEndElement())
      }),
      (t.prototype._extractStyle = function (t) {
        if (t.geometry && t.properties) {
          var e = t.properties,
            i = { visible: !0 }
          if (e.popupTemplate && e.popupTemplate.content) {
            var l = this._generateBalloonContent(e.popupTemplate, t)
            if (el.isValidString(l)) {
              i.balloonStyle = { text: l }
              var s = e.popupTemplate.fillColor
              el.isValidString(s) && (i.balloonStyle.bgColor = s)
              var n = e.popupTemplate.textColor
              el.isValidString(n) && (i.balloonStyle.textColor = n)
            }
          }
          if (
            ('boolean' != typeof e.visible || e.visible || (i.visible = !1),
            'Point' === t.geometry.type || 'MultiPoint' === t.geometry.type)
          ) {
            var a = null
            if (el.isValidString(e.image)) {
              var c = this._icons[e.image]
              el.isUrl(c) ? (a = c) : el.isUrl(e.image) && (a = e.image)
            }
            return (
              a ||
                (el.isUrl(e.imageUrl) && el.isUrl(e.imageUrl)
                  ? (a = e.imageUrl)
                  : el.isUrl(e.icon) && (a = e.icon)),
              a && (i.imageUrl = a),
              a &&
                (el.isValidString(e.anchor) && (i.anchor = e.anchor),
                Array.isArray(e.offset) && e.offset.length >= 2 && (i.offset = e.offset)),
              el.isValidNumber(e.rotation) && 0 !== e.rotation && (i.rotation = e.rotation),
              el.isValidNumber(e.size) && e.size > 0 && 1 !== i.size && (i.size = e.size),
              !a && el.isValidString(e.color) && (i.color = e.color),
              i
            )
          }
          return (
            el.isValidString(e.strokeColor) && (i.strokeColor = e.strokeColor),
            el.isValidNumber(e.strokeOpacity) &&
              1 !== e.strokeOpacity &&
              (i.strokeOpacity = e.strokeOpacity),
            el.isValidNumber(e.strokeWidth) &&
              e.strokeWidth >= 0 &&
              (i.strokeWidth = e.strokeWidth),
            ('Polygon' !== t.geometry.type && 'MultiPolygon' !== t.geometry.type) ||
              (el.isValidString(e.fillColor) && (i.fillColor = e.fillColor),
              el.isValidNumber(e.fillOpacity) &&
                1 !== e.fillOpacity &&
                (i.fillOpacity = e.fillOpacity)),
            i
          )
        }
        return null
      }),
      (t.prototype._generateBalloonContent = function (t, e) {
        var i = this
        if (t) {
          if (Array.isArray(t.content)) {
            var l = []
            return t.content.length > 0 && t.content[0].propertyPath
              ? this._processPopupPropertyInfo(t.content, e)
              : (t.content.forEach(function (t) {
                  Array.isArray(t)
                    ? l.push(i._processPopupPropertyInfo(t, e))
                    : l.push(i._processPopupString(t, e))
                }),
                l.join('<br/>'))
          }
          return this._processPopupString(t.content, e)
        }
        return null
      }),
      (t.prototype._processPopupPropertyInfo = function (t, e) {
        var i = this
        if (t && t.length > 0) {
          var l = []
          l.push('<table>')
          return (
            this._useSchema && this._schemaName + '/',
            t.forEach(function (t) {
              var s = i._getPlaceholder(t.propertyPath)
              if (t.hideLabel) l.push('<tr><td colspan="2">', s, '</td></tr>')
              else {
                var n = t.label,
                  a = t.propertyPath.split('/')[0]
                a &&
                  e.properties[a] &&
                  e.properties[a].displayName &&
                  (n = i._useSchema
                    ? '$[' + i._schemaName + '/' + a + '/displayName]'
                    : '$[' + a + '/displayName]'),
                  l.push('<tr><th>', n, '</th><td>', s, '</td></tr>')
              }
            }),
            l.push('</table>'),
            l.join('')
          )
        }
      }),
      (t.prototype._processPopupString = function (t, e) {
        for (var i = t, l = this._popupTemplatePlaceholder.exec(t); l; ) {
          if (l.length >= 1) {
            var s = l[0].replace('{', '').replace('}', '')
            i = i.replace(l[0], this._getPlaceholder(s))
          }
          l = this._popupTemplatePlaceholder.exec(t)
        }
        return (i = (i = i.replace(/\{/g, '$[').replace(/\}/g, ']')).trim())
      }),
      (t.prototype._getPlaceholder = function (t) {
        var e = t.split('/'),
          i = ''
        return (
          1 === e.length
            ? (i = this._useSchema ? '$[' + this._schemaName + '/' + e[0] + ']' : '$[' + e[0] + ']')
            : 2 === e.length &&
              'displayName' === e[1] &&
              (i = this._useSchema
                ? '$[' + this._schemaName + '/' + e[0] + '/displayName]'
                : '$[' + e[0] + '/displayName]'),
          i
        )
      }),
      t
    )
  })(),
  Yl = (function () {
    function t() {}
    return (
      (t.write = function (t, e) {
        return a(this, void 0, void 0, function () {
          var i
          return c(this, function (l) {
            switch (l.label) {
              case 0:
                if (!t) return [3, 6]
                switch (((i = void 0), e && e.format && (i = e.format), i)) {
                  case 'GeoRSS':
                    return [3, 1]
                  case 'GPX':
                    return [3, 2]
                  case 'GML':
                    return [3, 3]
                  case 'KML':
                    return [3, 4]
                }
                return [3, 4]
              case 1:
                return [2, Xl.write(t, e)]
              case 2:
                return [2, Gl.write(t, e)]
              case 3:
                return [
                  2,
                  pl.write(
                    { bbox: t.bbox, features: t.features || [], type: 'FeatureCollection' },
                    e
                  )
                ]
              case 4:
                return [4, new Vl(e).write(t)]
              case 5:
                return [2, l.sent()]
              case 6:
                return [2, null]
            }
          })
        })
      }),
      (t.writeCompressed = function (t, e, i) {
        return a(this, void 0, void 0, function () {
          var l, s, n, a, d, r, o
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                if (!t) return [3, 9]
                switch (
                  ((l = void 0),
                  (s = 'doc.xml'),
                  (n = 'application/zip'),
                  (a = 'KML'),
                  i && (a = i.format),
                  (d = new ll()),
                  a)
                ) {
                  case 'GeoRSS':
                    return [3, 1]
                  case 'GPX':
                    return [3, 2]
                  case 'KML':
                    return [3, 3]
                  case 'GML':
                    return [3, 5]
                }
                return [3, 6]
              case 1:
                return (l = Xl.write(t, i)), [3, 7]
              case 2:
                return (l = Gl.write(t, i)), [3, 7]
              case 3:
                return [4, new Vl(i, d).write(t)]
              case 4:
                return (
                  (l = c.sent()), (s = 'doc.kml'), (n = 'application/vnd.google-earth.kmz'), [3, 7]
                )
              case 5:
                return (l = pl.write(t, i)), (s = 'doc.gml'), [3, 7]
              case 6:
                return [3, 7]
              case 7:
                if (!l) return [3, 9]
                switch ((d.file(s, l), (r = 'blob'), e)) {
                  case 'Base64':
                    r = 'base64'
                    break
                  case 'ArrayBuffer':
                    r = 'uint8array'
                }
                return [4, d.generateAsync({ type: r })]
              case 8:
                return (o = c.sent()), 'base64' === r && (o = 'data:' + n + ';base64,' + o), [2, o]
              case 9:
                return [2, null]
            }
          })
        })
      }),
      t
    )
  })()
function Ll(t, e) {
  return new Promise(function (l, s) {
    var n = window.performance.now(),
      a = el.parseURL(window.location.href),
      c = new al()
    ;(c.onmessage = function (t) {
      if (t.data)
        if (t.data.error) s(t.data.error)
        else {
          var e = t.data
          if (e._groundOverlayOptions && e._groundOverlayOptions.length > 0) {
            var a = []
            e._groundOverlayOptions.forEach(function (t) {
              t.isWMS ? a.push(new vl(t)) : a.push(new i.layer.ImageLayer(t))
            }),
              (e.groundOverlays = a)
          }
          delete e._groundOverlayOptions,
            (e.stats.processingTime = window.performance.now() - n),
            l(e)
        }
      else s('Unable to read data.')
    }),
      c.postMessage({ baseUrl: a, data: t, options: e || {} })
  })
}
function Sl(t, e) {
  return a(this, void 0, void 0, function () {
    var i, l, s
    return c(this, function (n) {
      switch (n.label) {
        case 0:
          if (((i = new Ai()), !Array.isArray(t))) return [3, 5]
          ;(l = 0), (s = t), (n.label = 1)
        case 1:
          return l < s.length ? [4, Il(s[l], i, e)] : [3, 4]
        case 2:
          n.sent(), (n.label = 3)
        case 3:
          return l++, [3, 1]
        case 4:
          return [3, 7]
        case 5:
          return [4, Il(t, i, e)]
        case 6:
          n.sent(), (n.label = 7)
        case 7:
          return (i.bbox = null), Ai.getBounds(i), [2, i]
      }
    })
  })
}
function Il(t, e, l) {
  return a(this, void 0, void 0, function () {
    var s, n, a, d, r, o, m
    return c(this, function (c) {
      switch (c.label) {
        case 0:
          return t instanceof i.layer.ImageLayer
            ? ((s = t.getOptions()),
              (d = {
                coordinates: s.coordinates,
                id: t.getId(),
                isWMS: !1,
                opacity: s.opacity,
                properties: t.metadata || {},
                url: s.url,
                visible: !0
              }),
              e._groundOverlayOptions.push(d),
              l && (e.groundOverlays || (e.groundOverlays = []), e.groundOverlays.push(t)),
              [3, 8])
            : [3, 1]
        case 1:
          if (!(t instanceof vl)) return [3, 7]
          c.label = 2
        case 2:
          return c.trys.push([2, 5, , 6]), [4, t._client.getCapabilities()]
        case 3:
          return (
            (n = c.sent()),
            (a = t.getOptions()),
            (d = {
              bounds: n.bounds,
              id: t.getId(),
              isWMS: !0,
              properties: t.metadata || {},
              visible: !0
            }),
            (r = d),
            [4, t._client._getTileUrl(n, 'EPSG:4326', a.activeLayers, a.styles, !1)]
          )
        case 4:
          return (
            (r.url = c.sent()),
            (d.opacity = a.opacity),
            e._groundOverlayOptions.push(d),
            l && (e.groundOverlays || (e.groundOverlays = []), e.groundOverlays.push(t)),
            [3, 6]
          )
        case 5:
          return (o = c.sent()), console.log(o), [3, 6]
        case 6:
          return [3, 8]
        case 7:
          t instanceof i.source.DataSource
            ? (e.features = e.features.concat(t.toJson().features))
            : ((m = t).features &&
                m.features.length > 0 &&
                (e.features = e.features.concat(m.features)),
              m._groundOverlayOptions &&
                m._groundOverlayOptions.length > 0 &&
                (e._groundOverlayOptions = e._groundOverlayOptions.concat(m._groundOverlayOptions)),
              m.groundOverlays &&
                m.groundOverlays.length > 0 &&
                (e.groundOverlays = e.groundOverlays.concat(m.groundOverlays)),
              m.icons && Object.assign(e.icons, m.icons),
              m.type && 'FeatureCollection' !== t.type && e.features.push(t)),
            (c.label = 8)
        case 8:
          return [2]
      }
    })
  })
}
function Rl(t, e) {
  if (!t.startsWith('_')) return e
}
var fl = (function () {
    function t() {}
    return (
      (t.prototype.merge = function () {
        for (var e, i = [], l = 0; l < arguments.length; l++) i[l] = arguments[l]
        for (var s = 0, n = i; s < n.length; s++) {
          var a = n[s]
          if (a)
            for (var c in a)
              a.hasOwnProperty(c) &&
                this.hasOwnProperty(c) &&
                (void 0 !== a[c] && null != a[c]
                  ? this[c] instanceof t
                    ? this[c].merge(a[c])
                    : (this[c] = a[c])
                  : (e || (e = new (Object.getPrototypeOf(this).constructor)()), (this[c] = e[c])))
        }
        return this
      }),
      t
    )
  })(),
  xl = (function (t) {
    function e(e) {
      var i = t.call(this) || this
      return (i.id = e || Ji()), i
    }
    return (
      s(e, t),
      (e.prototype.getId = function () {
        return this.id
      }),
      (e.prototype._setMap = function (t) {
        if (null == t || void 0 === t) {
          var e = this.map
          delete this.map,
            this._invokeEvent('sourceremoved', this),
            e && e.events.invoke('sourceremoved', this)
        } else
          (this.map = t),
            this._invokeEvent('sourceadded', this),
            this.map.events.invoke('sourceadded', this)
      }),
      e
    )
  })(Ti),
  gl = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (
        (e.service = void 0),
        (e.url = void 0),
        (e.activeLayers = void 0),
        (e.styles = void 0),
        (e.version = void 0),
        (e.bringIntoView = !1),
        (e.debug = !1),
        (e.dimensions = void 0),
        (e.proxyService = void 0),
        e
      )
    }
    return s(e, t), e
  })(
    (function (t) {
      function e() {
        var e = (null !== t && t.apply(this, arguments)) || this
        return (
          (e.contrast = 0),
          (e.fadeDuration = 300),
          (e.hueRotation = 0),
          (e.maxBrightness = 1),
          (e.minBrightness = 0),
          (e.opacity = 1),
          (e.saturation = 0),
          e
        )
      }
      return s(e, t), e
    })(
      (function (t) {
        function e() {
          var e = (null !== t && t.apply(this, arguments)) || this
          return (e.filter = void 0), (e.minZoom = 0), (e.maxZoom = 24), (e.visible = !0), e
        }
        return (
          s(e, t),
          (e._cloneCustomizer = function (t) {
            if (t instanceof xl) return t
          }),
          e
        )
      })(fl)
    )
  ),
  Kl = (function () {
    function t() {}
    return (
      (t.createUrlRequest = function (t, e, i) {
        var l = Object.keys(e)
        return (
          (l = l.filter(function (t) {
            return void 0 !== e[t]
          })),
          i
            ? t +
              '?' +
              l
                .map(function (t) {
                  return t.toUpperCase() + '=' + encodeURIComponent(e[t])
                })
                .join('&')
            : t +
              '?' +
              l
                .map(function (t) {
                  return t + '=' + encodeURIComponent(e[t])
                })
                .join('&')
        )
      }),
      (t.getBaseUrl = function (t) {
        return el.isValidString(t)
          ? (t.includes('?') && (t = t.substr(0, t.indexOf('?'))),
            t.endsWith('/') && (t = t.slice(0, -1)),
            (t = t.replace(/\/WMTSCapabilities.xml$/i, '').replace(/\/1.0.0$/i, '')))
          : null
      }),
      (t.getBBoxString = function (e, i) {
        var l = t.isSridSupported(e, 'wgs84'),
          s = t.isSridSupported(e, 'extended'),
          n = t.isSridSupported(e, 'mercator')
        if (i && Array.isArray(i)) 6 === i.length && (i = [i[0], i[1], i[3], i[4]])
        else if (l || s) i = t.worldBounds
        else if (n) {
          var a = this.toWebMercator([-180, -85.05112878]),
            c = this.toWebMercator([180, 85.05112878])
          i = zi.fromEdges(a[0], a[1], c[0], c[1])
        }
        if (!i || !Array.isArray(i) || 4 !== i.length)
          throw new Error('Invalid bounding box specified.')
        switch ((e = e.toLowerCase())) {
          case 'crs:84':
          case 'crs84':
            return i.join(',')
          default:
            return i[1] + ',' + i[0] + ',' + i[3] + ',' + i[2]
        }
      }),
      (t.getZoomRange = function (t, e) {
        var i, l
        'number' != typeof e || e > this._mapZoomScale512[0]
          ? (i = 0)
          : e < this._mapZoomScale512[this._mapZoomScale512.length - 1] &&
            (i = this._mapZoomScale512.length - 1),
          'number' != typeof t || t > this._mapZoomScale512[0]
            ? (l = 24)
            : t < this._mapZoomScale512[this._mapZoomScale512.length - 1] &&
              (l = this._mapZoomScale512.length - 1)
        var s = void 0 === i,
          n = void 0 === l
        if (s || n)
          for (
            var a = void 0, c = void 0, d = 0, r = this._mapZoomScale512.length - 1;
            d < r &&
            ((a = this._mapZoomScale512[d]),
            (c = this._mapZoomScale512[d + 1]),
            s && e <= a && e >= c && (i = d + 1),
            n && t <= a && t >= c && (l = d),
            (s = void 0 === i),
            (n = void 0 === l) || s);
            d++
          );
        return s && (i = 0), n && (l = 24), i > l && (i = l), [i, l]
      }),
      (t.isEndpointReversed = function (t) {
        if (t)
          for (var e = 0, i = this.knowReversedAxisEndpoints; e < i.length; e++) {
            var l = i[e]
            if (t.includes(l)) return !0
          }
        return !1
      }),
      (t.isSridAxisLonLat = function (t) {
        return (
          !!t &&
          (((t = t.toLowerCase()) && t.includes('crs:84')) ||
            t.includes('crs84') ||
            this._containsSrid(t, this.axisOrderIsLonLat))
        )
      }),
      (t.isSridSupported = function (t, e) {
        if (t) {
          var i = this.wgs84Srs
          switch (e) {
            case 'extended':
              i = this.extendedSrsSupport
              break
            case 'mercator':
              i = this.mercatorSrids
          }
          return this._containsSrid(t, i)
        }
        return !1
      }),
      (t.parseWGS84BoundingBox = function (t) {
        var e = el.getElementByTagName('LowerCorner', t),
          i = el.getElementByTagName('UpperCorner', t)
        if (e && e.value && i && i.value) {
          var l = e.value.split(' '),
            s = i.value.split(' ')
          return l.length >= 2 && s.length >= 2
            ? [parseFloat(l[0]), parseFloat(l[1]), parseFloat(s[0]), parseFloat(s[1])]
            : null
        }
      }),
      (t.toWebMercator = function (t) {
        if (t && t.length >= 2) {
          var e = (t[0] * this.epsg3857MaxExtent) / 180,
            i = Math.log(Math.tan(((90 + t[1]) * Math.PI) / 360)) / (Math.PI / 180),
            l = [e, (i = (i * this.epsg3857MaxExtent) / 180)]
          return t.length > 2 && l.push(t[2]), l
        }
        return null
      }),
      (t.toWgs84 = function (t) {
        if (t && t.length >= 2) {
          var e = [
            (180 * t[0]) / this.epsg3857MaxExtent,
            (360 * Math.atan(Math.exp((t[1] * Math.PI) / this.epsg3857MaxExtent))) / Math.PI - 90
          ]
          return t.length > 2 && e.push(t[2]), e
        }
        return null
      }),
      (t._containsSrid = function (t, e) {
        if (t) {
          var i = t.match(/[0-9]{4,}/gi)
          if (i && 1 === i.length && e.includes(i[0])) return !0
          if (((t = t.toLowerCase().replace('crs:', '').replace('crs', '')), e.includes(t)))
            return !0
        }
        return !1
      }),
      (t.axisOrderIsLonLat = ['84', '4258']),
      (t.epsg3857MaxExtent = 20037508.34),
      (t.extendedSrsSupport = [
        '4269',
        '4283',
        '4258',
        '4308',
        '4230',
        '4272',
        '4271',
        '4267',
        '4608',
        '4674'
      ]),
      (t.knowReversedAxisEndpoints = ['https://hazards.fema.gov/gis']),
      (t._mapZoomScale512 = [
        591657550.5, 295828775.3, 147914387.6, 73957193.81, 36978596.91, 18489298.45, 9244649.227,
        4622324.613, 2311162.307, 1155581.153, 577790.5767, 288895.2883, 144447.6442, 72223.82208,
        36111.91104, 18055.95552, 9027.97776, 4513.98888, 2256.99444, 1128.49722, 564.24861,
        282.124305, 141.0621525, 70.53107625, 35.26553813
      ]),
      (t.mercatorSrids = ['3857', '102100', '3785', '900913', '102113', '41001', '54004']),
      (t.wgs84Srs = ['84', '4326']),
      (t.EPSG3857 = 'EPSG:3857'),
      (t.EPSG4326 = 'EPSG:4326'),
      (t.worldBounds = [-180, -90, 180, 90]),
      t
    )
  })(),
  Jl = (function () {
    function t(t) {
      ;(this._layerIndex = {}),
        (this._options = {}),
        (this._tileSize = 1024),
        (this._preferredImageFormats = [
          'image/png',
          'image/png32',
          'PNG',
          'PNG8',
          'PNG24',
          'PNG32',
          'image/jpgpng',
          'image/jpeg',
          'JPEG',
          'image/gif',
          'GIF',
          'image/bmp',
          'BMP'
        ]),
        this.setOptions(t)
    }
    return (
      (t.prototype.setMap = function (t) {
        this._map = t
      }),
      (t.prototype.setOptions = function (t) {
        var e = new gl().merge(this._options, t)
        e.url !== this._options.url &&
          ((e.url = Kl.getBaseUrl(e.url)),
          (this._capabilities = null),
          (this._tileSize = 1024),
          !e && e.debug && console.log('Invalid URL specified for OGC service.')),
          el.isValidString(e.version) && e.version !== this._options.version
            ? ((this._capabilities = null), (this._tileSize = 1024))
            : (e.version = this._options.version),
          (this._options = e)
      }),
      (t.prototype._getDefaultStyle = function (t) {
        return (
          t.styles.forEach(function (t) {
            if (t.isDefault) return t
          }),
          { id: 'default' }
        )
      }),
      (t.prototype._getSublayer = function (t) {
        var e = null
        return (
          t &&
            ('string' == typeof t
              ? (e = this._capabilities.sublayers.find(function (e) {
                  return e.id === t
                }))
              : t.id && (e = t),
            null === e &&
              this._options.debug &&
              console.log(
                'Unable to find specified sublayer in capabilities. Defaulting to first layer in capabilities.'
              )),
          null === e && (e = this._capabilities.sublayers[0]),
          e
        )
      }),
      (t._parseStyle = function (t, e) {
        var i = {}
        t.childNodes.forEach(function (t) {
          switch (t.tagName) {
            case 'Identifier':
            case 'Name':
              t.value && '' !== t.value && (i.id = t.value)
              break
            case 'Title':
              t.value && '' !== t.value && (i.title = t.value)
              break
            case 'LegendURL':
              var e = el.getElementByTagName('OnlineResource', t)
              e || (e = t),
                e &&
                  (e.attributes.href || e.attributes['xlink:href']) &&
                  (i.legendUrl = e.attributes.href || e.attributes['xlink:href'])
          }
        }),
          i.id &&
            (t.attributes &&
              t.attributes.isDefault &&
              'true' === t.attributes.isDefault &&
              (e._defaultStyleId = i.id),
            e.styles.push(i))
      }),
      (t.prototype._getLayerDetails = function (t) {
        if (t && t.length > 0) {
          for (var e = [], i = 0, l = t; i < l.length; i++) {
            var s = l[i]
            if ('string' == typeof s) {
              var n = this._layerIndex[s]
              n && e.push(n)
            } else s.id && this._layerIndex[s.id] && e.push(s)
          }
          return e
        }
        return this._capabilities.sublayers
      }),
      t
    )
  })(),
  Nl = (function (t) {
    function e(e) {
      var i = t.call(this, e) || this
      return (
        (i._supportedInfoFormats = [
          'application/geojson',
          'application/json',
          'application/vnd.esri.wms_raw_xml',
          'text/xml',
          'application/vnd.ogc.wms_xml',
          'application/vnd.esri.wms_featureinfo_xml',
          'XML'
        ]),
        i
      )
    }
    return (
      s(e, t),
      (e.prototype.getCapabilities = function () {
        var t = this
        return new Promise(function (l, s) {
          var n
          t._capabilities
            ? l(t._capabilities)
            : ((n =
                '1.0.0' === t._options.version
                  ? { request: 'capabilities', WMTVER: t._options.version }
                  : { request: 'GetCapabilities', service: 'WMS', version: t._options.version }),
              el
                .ajaxGetAsync(
                  Kl.createUrlRequest(t._options.url, n, !0),
                  t._options.proxyService,
                  t._map,
                  !1,
                  'WebMapService'
                )
                .then(
                  function (n) {
                    var a = e._parseCapabilities(n)
                    if (a) {
                      if (
                        (a.version
                          ? (t._options.version = a.version)
                          : (a.version = t._options.version),
                        a._getMapTileUrl || (a._getMapTileUrl = t._options.url),
                        (t._capabilities = a),
                        a._maxHeight < t._tileSize || a._maxWidth < t._tileSize)
                      )
                        for (var c = Math.min(a._maxHeight, a._maxWidth); t._tileSize > c; )
                          t._tileSize *= 0.5
                      if (a.sublayers && a.sublayers.length > 0) {
                        var d = !1
                        a.bounds
                          ? a.sublayers.forEach(function (e) {
                              ;(e._tileSize = t._tileSize),
                                (t._layerIndex[e.id] = e),
                                e._queryable && (d = !0)
                            })
                          : ((a.bounds = a.sublayers[0].bounds),
                            a.sublayers.forEach(function (e) {
                              ;(e._tileSize = t._tileSize),
                                (t._layerIndex[e.id] = e),
                                (a.bounds = i.data.BoundingBox.merge(a.bounds, e.bounds)),
                                e._queryable && (d = !0)
                            })),
                          (a._canGetFeatureInfo =
                            d &&
                            null !==
                              el.matchFirstPreference(
                                a._featureInfoFormats,
                                t._supportedInfoFormats
                              ))
                      }
                      l(a)
                    } else s('Error parsing capabilities.')
                  },
                  function () {
                    void 0 === t._options.version
                      ? ((t._options.version = '1.0.0'),
                        t.getCapabilities().then(
                          function (t) {
                            l(t)
                          },
                          function () {
                            s('Error parsing capabilities.')
                          }
                        ))
                      : s('Error parsing capabilities.')
                  }
                ))
        })
      }),
      (e.prototype.getTileLayerOptions = function (t, e, l) {
        return a(this, void 0, void 0, function () {
          var s, n, a, d, r, o
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return [4, this.getCapabilities()]
              case 1:
                return (
                  (s = c.sent()),
                  (n = this._getLayerDetails(t)),
                  (a = 0),
                  (d = 24),
                  (r = Kl.worldBounds),
                  n &&
                    n.length > 0 &&
                    ((a = n[0].minZoom),
                    (d = n[0].maxZoom),
                    (r = n[0].bounds),
                    n.forEach(function (t) {
                      t.minZoom < a && (a = t.minZoom),
                        t.maxZoom > d && (d = t.maxZoom),
                        (r = i.data.BoundingBox.merge(r, t.bounds))
                    }),
                    r[0] > r[2] && ((r[0] = -180), (r[2] = 180))),
                  [4, this._getTileUrl(s, Kl.EPSG3857, n, e, !0, l)]
                )
              case 2:
                return (o = c.sent())
                  ? (this._options.proxyService && (o = this._options.proxyService + o),
                    [
                      2,
                      {
                        _subLayers: n,
                        bounds: r,
                        maxSourceZoom: d,
                        minSourceZoom: a,
                        tileSize: this._tileSize,
                        tileUrl: o
                      }
                    ])
                  : [2, null]
            }
          })
        })
      }),
      (e.prototype.getFeatureInfo = function (t) {
        return a(this, void 0, void 0, function () {
          var e, l, s, n, a, d, r
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return [4, this.getCapabilities()]
              case 1:
                return c.sent()._canGetFeatureInfo && null !== t.zoom
                  ? i.data.BoundingBox.containsPosition(t.tileLayerOptions.bounds, t.position)
                    ? ((e = el.matchFirstPreference(
                        this._capabilities._featureInfoFormats,
                        this._supportedInfoFormats
                      )),
                      (l = this._getFeatureInfoUrl(t, e))
                        ? [
                            4,
                            el.ajaxGetAsync(
                              l,
                              this._options.proxyService,
                              this._map,
                              !1,
                              'WebMapService'
                            )
                          ]
                        : [3, 4])
                    : [3, 4]
                  : [2, null]
              case 2:
                return [4, Ll(c.sent())]
              case 3:
                if (
                  (s = c.sent()) &&
                  s.features &&
                  s.features.length > 0 &&
                  (s.features[0].geometry || Object.keys(s.features[0].properties).length > 0)
                ) {
                  if (t.position)
                    for (
                      n = { coordinates: t.position, type: 'Point' }, a = 0, d = s.features;
                      a < d.length;
                      a++
                    )
                      (r = d[a]).geometry || (r.geometry = n)
                  return [2, { features: s.features, type: 'FeatureCollection' }]
                }
                c.label = 4
              case 4:
                return [2, { features: [], type: 'FeatureCollection' }]
            }
          })
        })
      }),
      (e.prototype.getFeatureInfoHtml = function (t) {
        return a(this, void 0, void 0, function () {
          var e, l
          return c(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.getCapabilities()]
              case 1:
                return s.sent()._canGetHtmlFeatureInfo && null !== t.zoom
                  ? i.data.BoundingBox.containsPosition(t.tileLayerOptions.bounds, t.position) &&
                    (e = this._getFeatureInfoUrl(t, 'text/html'))
                    ? [
                        4,
                        el.ajaxGetAsync(
                          e,
                          this._options.proxyService,
                          this._map,
                          !1,
                          'WebMapService'
                        )
                      ]
                    : [3, 3]
                  : [2, null]
              case 2:
                if ('' !== (l = s.sent())) return [2, l]
                s.label = 3
              case 3:
                return [2, null]
            }
          })
        })
      }),
      (e.prototype._getTileUrl = function (t, e, i, l, s, n) {
        return a(this, void 0, void 0, function () {
          var t,
            a,
            d,
            r,
            o,
            m = this
          return c(this, function (c) {
            return (
              (t = el.matchFirstPreference(
                this._capabilities._imageFormats,
                this._preferredImageFormats
              )) || (t = this._preferredImageFormats[0]),
              (!i || (Array.isArray(i) && 0 === i.length)) && (i = this._capabilities.sublayers),
              l || (l = []),
              (a = []),
              (d = {}),
              (r = []),
              i.forEach(function (t) {
                var e = m._getSublayer(t)
                e &&
                  (a.push(e.id),
                  e.dimensions &&
                    e.dimensions.forEach(function (t) {
                      d[t.id] = t.default
                    }),
                  r.push(e))
              }),
              a.length > this._capabilities.layerLimit &&
                (this._options.debug &&
                  console.log(
                    'Too many layers specified in OGC service. Clipped the request to ' +
                      this._capabilities.layerLimit +
                      ' layers.'
                  ),
                (r.length = this._capabilities.layerLimit),
                (a.length = this._capabilities.layerLimit)),
              0 === a.length
                ? (this._options.debug && console.log('No layers available for OGC service.'),
                  [2, null])
                : ((o = {
                    format: t,
                    height: this._tileSize,
                    layers: a.join(','),
                    request: 'GetMap',
                    styles: this._getStylesString(r, l),
                    tiled: !0,
                    transparent: 'true',
                    width: this._tileSize
                  }),
                  '1.0.0' === this._options.version
                    ? ((o.WMTVER = this._options.version), (o.request = 'map'))
                    : ((o.version = this._options.version), (o.service = 'WMS')),
                  '1.3.0' === this._options.version ? (o.crs = e) : (o.srs = e),
                  Object.keys(d).length > 0 && n && (o = Object.assign(o, d, n)),
                  [
                    2,
                    Kl.createUrlRequest(this._capabilities._getMapTileUrl, o, !0) +
                      (s ? '&BBOX={bbox-epsg-3857}' : '')
                  ])
            )
          })
        })
      }),
      (e.prototype._getFeatureInfoUrl = function (t, e) {
        var l = this
        if (!this._capabilities._canGetFeatureInfo)
          return (
            this._options.debug &&
              console.log('Error: Service does not support getting feature info.'),
            null
          )
        var s = el.matchFirstPreference(
            this._capabilities._imageFormats,
            this._preferredImageFormats
          ),
          n = [],
          a = 24,
          c = 0
        if (
          (t.sublayers
            ? t.sublayers.forEach(function (t) {
                var e = l._getSublayer(t)
                e && (n.push(e.id), (c = e.maxZoom), (a = e.minZoom))
              })
            : this._capabilities.sublayers &&
              this._capabilities.sublayers.forEach(function (t) {
                n.push(t.id), t.minZoom < a && (a = t.minZoom), t.maxZoom > c && (c = t.maxZoom)
              }),
          n.length > this._capabilities.layerLimit &&
            (this._options.debug &&
              console.log(
                'Too many layers specified in OGC service. Clipped the request to ' +
                  this._capabilities.layerLimit +
                  ' layers.'
              ),
            (n.length = this._capabilities.layerLimit)),
          0 === n.length)
        )
          return this._options.debug && console.log('No layers available for OGC service.'), null
        var d = {
          format: s,
          height: this._tileSize,
          info_format: e,
          layers: n.join(','),
          query_layers: n.join(','),
          request: 'GetFeatureInfo',
          transparent: !0,
          width: this._tileSize
        }
        '1.0.0' === this._options.version
          ? ((d.WMTVER = this._options.version), (d.request = 'feature_info'))
          : ((d.version = this._options.version), (d.service = 'WMS'))
        var r = Math.round(t.zoom)
        r < 5 && (r = a > 0 ? a : c > 5 ? 5 : c)
        var o = this._tileSize / 512
        o < 1 ? (r -= 1 / o / 2) : o > 1 && (r += o / 2)
        var m = i.math.mercatorPositionsToPixels([t.position], r)[0],
          u = this._tileSize * Math.pow(2, r),
          b = Math.floor(Math.min(Math.max(m[0] + 0.5, 0), u - 1) / this._tileSize),
          h = Math.floor(Math.min(Math.max(m[1] + 0.5, 0), u - 1) / this._tileSize),
          Z = [b * this._tileSize, h * this._tileSize],
          p = i.math.mercatorPixelsToPositions(
            [
              [Z[0], Z[1] + this._tileSize],
              [Z[0] + this._tileSize, Z[1]]
            ],
            r
          )
        return (
          (d.bbox = Kl.getBBoxString(Kl.EPSG4326, new i.data.BoundingBox(p[0], p[1]))),
          '1.3.0' === this._options.version
            ? ((d.i = m[0] - Z[0]), (d.j = m[1] - Z[1]), (d.crs = Kl.EPSG4326))
            : ((d.x = m[0] - Z[0]), (d.y = m[1] - Z[1]), (d.srs = Kl.EPSG4326)),
          Kl.createUrlRequest(this._options.url, d, !0)
        )
      }),
      (e.prototype._getStylesString = function (t, e) {
        var i = this,
          l = []
        if (e) {
          for (var s = Math.min(t.length, e.length), n = 0; n < s; n++)
            'string' == typeof e[n] ? l.push(e[n]) : t[n].id ? l.push(t[n].id) : l.push('')
          for (n = s; n < t.length; n++) l.push(this._getDefaultStyle(t[n]).id)
        } else
          t.length > 1 &&
            t.forEach(function (t) {
              l.push(i._getDefaultStyle(t).id)
            })
        return l.join(',')
      }),
      (e._parseCapabilities = function (t) {
        var e = new il().parse(t)
        if (el.docHasData(e)) {
          var i = {
            _canGetFeatureInfo: !1,
            _imageFormats: [],
            _maxHeight: 1024,
            _maxWidth: 1024,
            bounds: Kl.worldBounds,
            layerLimit: 1 / 0,
            sublayers: [],
            version: null
          }
          e.root.attributes && e.root.attributes.version && (i.version = e.root.attributes.version)
          for (var l = 0, s = e.root.childNodes; l < s.length; l++) {
            var n = s[l]
            switch (n.tagName) {
              case 'Service':
                for (var a = 0, c = n.childNodes; a < c.length; a++) {
                  switch ((o = c[a]).tagName) {
                    case 'Name':
                      o.value && (i.title = o.value)
                      break
                    case 'Abstract':
                      o.value && (i.description = o.value)
                      break
                    case 'MaxWidth':
                      i._maxWidth = parseInt(o.value)
                      break
                    case 'MaxHeight':
                      i._maxHeight = parseInt(o.value)
                      break
                    case 'LayerLimit':
                      i.layerLimit = parseInt(o.value)
                  }
                }
                break
              case 'Capability':
                for (var d = 0, r = n.childNodes; d < r.length; d++) {
                  var o
                  switch ((o = r[d]).tagName) {
                    case 'Request':
                      this._parseRequest(o, i)
                      break
                    case 'Layer':
                      this._parseLayerGroup(o, i)
                  }
                }
            }
          }
          return (
            (i._canGetHtmlFeatureInfo =
              i._getFeatureInfoUrl &&
              i._featureInfoFormats &&
              i._featureInfoFormats.includes('text/html')),
            i
          )
        }
        return null
      }),
      (e._parseRequest = function (t, e) {
        for (var i = 0, l = t.childNodes; i < l.length; i++) {
          var s = l[i]
          try {
            var n = el.getElementByTagName('DCPType', s).childNodes[0].childNodes[0].childNodes[0]
            if (n.attributes) {
              var a = Kl.getBaseUrl(n.attributes.href || n.attributes['xlink:href'])
              if (a)
                switch (s.tagName) {
                  case 'GetMap':
                  case 'Map':
                    ;(e._imageFormats = this._parseFormats(s)), (e._getMapTileUrl = a)
                    break
                  case 'GetFeatureInfo':
                  case 'FeatureInfo':
                    ;(e._featureInfoFormats = this._parseFormats(s)), (e._getFeatureInfoUrl = a)
                }
            }
          } catch (t) {}
        }
      }),
      (e._parseFormats = function (t) {
        var e = []
        return (
          t.childNodes.forEach(function (t) {
            'Format' === t.tagName &&
              (t.value && '' !== t.value
                ? e.push(t.value)
                : t.childNodes &&
                  t.childNodes.forEach(function (t) {
                    e.push(t.tagName)
                  }))
          }),
          e
        )
      }),
      (e._parseLayerGroup = function (t, e) {
        for (var i = !1, l = 0, s = t.childNodes; l < s.length; l++) {
          var n = s[l]
          switch (n.tagName) {
            case 'Layer':
              this._parseLayer(n, e), (i = !0)
          }
        }
        i || this._parseLayer(t, e)
      }),
      (e._parseLayer = function (t, e) {
        for (
          var i,
            l,
            s = {
              _queryable: !!t.attributes && el.parseBoolean(t.attributes.queryable),
              _tileSize: 1024,
              bounds: Kl.worldBounds,
              dimensions: [],
              maxZoom: 24,
              minZoom: 0,
              styles: []
            },
            n = 0,
            a = t.childNodes;
          n < a.length;
          n++
        ) {
          var c = a[n]
          switch (c.tagName) {
            case 'Name':
              c.value && '' !== c.value && (s.id = c.value)
              break
            case 'Title':
            case 'Abstract':
              c.value && '' !== c.value && (s[c.tagName.toLowerCase()] = c.value)
              break
            case 'Layer':
              this._parseLayer(c, e)
              break
            case 'Style':
              this._parseStyle(c, s)
              break
            case 'EX_GeographicBoundingBox':
              var d = this.parseEX_GeographicBoundingBox(c)
              d && (s.bounds = d)
              break
            case 'MinScaleDenominator':
              i = parseFloat(c.value)
              break
            case 'MaxScaleDenominator':
              l = parseFloat(c.value)
              break
            case 'ScaleHint':
              if (c.attributes) {
                var r = parseFloat(c.attributes.min)
                el.isValidNumber(r) && (i = r)
                var o = parseFloat(c.attributes.max)
                el.isValidNumber(o) && (l = o)
              }
              break
            case 'Dimension':
              if (c.attributes) {
                var m = { default: c.attributes.default, id: c.attributes.name }
                ;(m.value = c.value), m.id && m.default && s.dimensions.push(m)
              }
          }
        }
        if (s.id) {
          !s._defaultStyleId &&
            s.styles &&
            s.styles.length > 0 &&
            (s._defaultStyleId = s.styles[0].id)
          var u = Kl.getZoomRange(i, l)
          ;(s.minZoom = u[0]), (s.maxZoom = u[1]), e.sublayers.push(s)
        }
      }),
      (e.parseEX_GeographicBoundingBox = function (t) {
        for (var e, l, s, n, a = 0, c = t.childNodes; a < c.length; a++) {
          var d = c[a],
            r = parseFloat(d.value)
          switch (d.tagName) {
            case 'westBoundLongitude':
              n = r
              break
            case 'eastBoundLongitude':
              s = r
              break
            case 'southBoundLatitude':
              l = r
              break
            case 'northBoundLatitude':
              e = r
          }
        }
        return el.isValidNumber(e) &&
          el.isValidNumber(l) &&
          el.isValidNumber(s) &&
          el.isValidNumber(n)
          ? i.data.BoundingBox.fromEdges(n, l, s, e)
          : null
      }),
      e
    )
  })(Jl),
  zl = (function (t) {
    function e(e) {
      var i = t.call(this, e) || this
      return (i._supportsKVP = !1), i
    }
    return (
      s(e, t),
      (e.prototype.getCapabilities = function () {
        var t = this
        return new Promise(function (i, l) {
          if (t._capabilities) i(t._capabilities)
          else {
            el.ajaxGetAsync(
              Kl.createUrlRequest(
                t._options.url,
                { request: 'GetCapabilities', service: 'WMTS', version: '1.0.0' },
                !0
              ),
              t._options.proxyService,
              t._map,
              !1,
              'WebMapService'
            ).then(
              function (s) {
                var n = e._parseCapabilities(s)
                n
                  ? ((t._capabilities = n), (t._supportsKVP = !0), i(n))
                  : l(new Error('Error parsing capabilities.'))
              },
              function () {
                var s = t._options.url + '/1.0.0/WMTSCapabilities.xml'
                el.ajaxGetAsync(s, t._options.proxyService, t._map, !1, 'WebMapService').then(
                  function (s) {
                    var n = e._parseCapabilities(s)
                    n ? ((t._capabilities = n), i(n)) : l('Error parsing capabilities.')
                  },
                  function () {
                    ;(s = t._options.url + '/WMTSCapabilities.xml'),
                      el.ajaxGetAsync(s, t._options.proxyService, t._map, !1, 'WebMapService').then(
                        function (s) {
                          var n = e._parseCapabilities(s)
                          n ? ((t._capabilities = n), i(n)) : l('Error parsing capabilities.')
                        },
                        function (t) {
                          l('GetCapabilities request failed: ' + t)
                        }
                      )
                  }
                )
              }
            )
          }
        })
      }),
      (e.prototype.getTileLayerOptions = function (t, e, i) {
        return a(this, void 0, void 0, function () {
          var l, s, n
          return c(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.getCapabilities()]
              case 1:
                return (
                  (l = a.sent())._supportsKVP && (this._supportsKVP = l._supportsKVP),
                  (s = this._getSublayer(t && t.length > 0 ? t[0] : null)),
                  [4, this._getTileUrl(l, null, t, e, !1, i)]
                )
              case 2:
                return (
                  (n = a.sent()),
                  s && n
                    ? ((n = n
                        .replace(/{TileMatrix}/gi, '{z}')
                        .replace(/{TileRow}/gi, '{y}')
                        .replace(/{TileCol}/gi, '{x}')),
                      this._options.proxyService && (n = this._options.proxyService + n),
                      [
                        2,
                        {
                          _subLayers: [s],
                          bounds: s.bounds,
                          maxSourceZoom: s.maxZoom,
                          minSourceZoom: s.minZoom,
                          tileSize: s._tileSize,
                          tileUrl: n
                        }
                      ])
                    : (this._options.debug &&
                        console.log(
                          'No sublayers with supported TileMatrixSet listed in capabilities.'
                        ),
                      [2, null])
                )
            }
          })
        })
      }),
      (e.prototype._getTileUrl = function (t, e, i, l, s, n) {
        return a(this, void 0, void 0, function () {
          var e, s, a, d, r
          return c(this, function (c) {
            return t.sublayers &&
              t.sublayers.length > 0 &&
              ((e = this._getSublayer(i && i.length > 0 ? i[0] : null)),
              (s = this._getStyleName(e, l && l.length > 0 ? l[0] : null)),
              e._tileMatrixSetName)
              ? ((a = null),
                e._tileUrlTemplate
                  ? (a = e._tileUrlTemplate)
                  : this._supportsKVP
                  ? ((d = e._imageFormats
                      ? el.matchFirstPreference(e._imageFormats, this._preferredImageFormats)
                      : null),
                    (r = {
                      format: d,
                      layer: e.id,
                      request: 'GetTile',
                      service: 'WMTS',
                      style: s,
                      TileMatrixSet: e._tileMatrixSetName,
                      version: '1.0.0'
                    }),
                    (a = Kl.createUrlRequest(t._getMapTileUrl, r, !0)),
                    (a += '&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}'),
                    e.dimensions &&
                      n &&
                      Object.keys(n).forEach(function (t) {
                        a += '&' + t + '=' + n[t]
                      }))
                  : (a =
                      t._getMapTileUrl +
                      '/tile/1.0.0/{Layer}/{Style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}'),
                (a = a
                  .replace(/\{style\}/gi, s)
                  .replace(/\{TileMatrixSet\}/gi, e._tileMatrixSetName)),
                e._idPrepend && (a = a.replace('{TileMatrix}', e._idPrepend + '{TileMatrix}')),
                e.dimensions &&
                  (n &&
                    Object.keys(n).forEach(function (t) {
                      a = a.replace(new RegExp('{' + t + '}', 'gi'), n[t])
                    }),
                  e.dimensions.forEach(function (t) {
                    ;(n && n[t.id]) ||
                      (a = a.replace(new RegExp('{' + t.id + '}', 'gi'), t.default))
                  })),
                [2, a])
              : [2, null]
          })
        })
      }),
      (e.prototype._getStyleName = function (t, e) {
        if (e && t.styles && t.styles.length > 0) {
          var i = void 0
          i = 'string' == typeof e ? e : e.id
          for (var l = 0, s = t.styles.length; l < s; l++) if (i === t.styles[l].id) return i
        }
        return t._defaultStyleId || ''
      }),
      (e._getTileMatrixSet = function (t, e) {
        if (t._tileMatrixSets && t._tileMatrixSets.length > 0) {
          var i = t._tileMatrixSets.find(function (t) {
              return 'GoogleMapsCompatible' === t
            }),
            l = e.GoogleMapsCompatible
          if (i && l) return l
          for (var s = 0, n = t._tileMatrixSets; s < n.length; s++) {
            if ((l = e[n[s]])) return l
          }
        }
        return null
      }),
      (e._parseCapabilities = function (t) {
        var l = this,
          s = new il().parse(t)
        if (el.docHasData(s)) {
          for (
            var n = {
                _canGetFeatureInfo: !1,
                _tileMatrixSets: {},
                bounds: Kl.worldBounds,
                layerLimit: 1,
                sublayers: [],
                version: null
              },
              a = 0,
              c = s.root.childNodes;
            a < c.length;
            a++
          ) {
            var d = c[a]
            switch (d.tagName) {
              case 'ServiceIdentification':
                d.childNodes.forEach(function (t) {
                  switch (t.tagName) {
                    case 'Title':
                      n.title = t.value
                      break
                    case 'Abstract':
                      n.description = t.value
                  }
                })
                break
              case 'OperationsMetadata':
                e._parseOperations(d, n)
                break
              case 'Contents':
                d.childNodes.forEach(function (t) {
                  switch (t.tagName) {
                    case 'TileMatrixSet':
                      e._parseTileMatrixSet(t, n)
                      break
                    case 'Layer':
                      e._parseSublayer(t, n)
                  }
                })
            }
          }
          var r,
            o = []
          if (n.sublayers)
            n.sublayers.forEach(function (t) {
              var e = l._getTileMatrixSet(t, n._tileMatrixSets)
              e &&
                ((r = r ? i.data.BoundingBox.merge(r, t.bounds) : t.bounds),
                (t = Object.assign(t, {
                  _idPrepend: e.idPrepend,
                  _tileMatrixSetName: e.identifier,
                  _tileSize: e.tileSize,
                  maxZoom: e.maxZoom,
                  minZoom: e.minZoom
                })),
                o.push(t))
            }),
              r && (n.bounds = r)
          return (n.sublayers = o), n
        }
        return null
      }),
      (e._parseOperations = function (t, e) {
        for (var i = !1, l = 0, s = t.childNodes; l < s.length; l++) {
          var n = s[l]
          if ('Operation' === n.tagName && n.attributes) {
            var a = n.attributes.name
            try {
              for (var c = 0, d = n.childNodes[0].childNodes[0].childNodes.length; c < d; c++) {
                var r = n.childNodes[0].childNodes[0].childNodes[c]
                if (a && r.attributes && 'Get' === r.tagName) {
                  var o = Kl.getBaseUrl(r.attributes.href || r.attributes['xlink:href'])
                  o &&
                    ('GetFeatureInfo' === a
                      ? (e._getFeatureInfoUrl = o)
                      : 'GetTile' !== a ||
                        i ||
                        ((e._getMapTileUrl = o),
                        'KVP' === r.childNodes[0].childNodes[0].childNodes[0].value && (i = !0)))
                }
              }
            } catch (t) {}
          }
          i && (e._supportsKVP = !0),
            (e._canGetFeatureInfo = el.isValidString(e._getFeatureInfoUrl))
        }
      }),
      (e._parseSublayer = function (t, e) {
        for (
          var i = {
              _imageFormats: [],
              _infoFormats: [],
              _tileMatrixSets: [],
              _tileSize: 256,
              bounds: Kl.worldBounds,
              dimensions: [],
              maxZoom: 24,
              minZoom: 0,
              styles: []
            },
            l = function (t) {
              switch (t.tagName) {
                case 'Identifier':
                  i.id = t.value
                  break
                case 'Title':
                  i.title = t.value
                  break
                case 'Abstract':
                  i.description = t.value
                  break
                case 'WGS84BoundingBox':
                  var e = Kl.parseWGS84BoundingBox(t)
                  e && (i.bounds = e)
                  break
                case 'Style':
                  s._parseStyle(t, i)
                  break
                case 'TileMatrixSetLink':
                  var l = el.getElementByTagName('TileMatrixSet', t)
                  l && '' !== l.value && i._tileMatrixSets.push(l.value)
                  break
                case 'ResourceURL':
                  t.attributes &&
                    t.attributes.resourceType &&
                    t.attributes.template &&
                    ('tile' === t.attributes.resourceType
                      ? i._tileUrlTemplate
                        ? t.attributes.format.toLowerCase().includes('png') &&
                          (i._tileUrlTemplate = t.attributes.template)
                        : (i._tileUrlTemplate = t.attributes.template)
                      : 'FeatureInfo' === t.attributes.resourceType &&
                        ('application/json' === t.attributes.format
                          ? (i._getFeatureJsonUrl = t.attributes.template)
                          : 'text/html' === t.attributes.format &&
                            (i._getFeatureHtmlUrl = t.attributes.template)))
                  break
                case 'Format':
                  '' !== t.value && i._imageFormats.push(t.value)
                  break
                case 'InfoFormat':
                  '' !== t.value && i._infoFormats.push(t.value)
                  break
                case 'Dimension':
                  var n = {}
                  t.childNodes.forEach(function (t) {
                    switch (t.tagName) {
                      case 'Identifier':
                        n.id = t.value
                        break
                      case 'Default':
                      case 'Value':
                        n[t.tagName.toLowerCase()] = t.value
                    }
                  }),
                    n.id && n.default && i.dimensions.push(n)
              }
            },
            s = this,
            n = 0,
            a = t.childNodes;
          n < a.length;
          n++
        ) {
          l(a[n])
        }
        i._defaultStyleId, i._tileMatrixSets.length > 0 && e.sublayers.push(i)
      }),
      (e._parseTileMatrixSet = function (t, i) {
        for (
          var l, s, n = NaN, a = NaN, c = 256, d = !1, r = !0, o = null, m = 0, u = t.childNodes;
          m < u.length;
          m++
        ) {
          var b = u[m]
          switch (b.tagName) {
            case 'Identifier':
              l = b.value
              break
            case 'SupportedCRS':
              Kl.isSridSupported(b.value, 'mercator') && (d = !0)
              break
            case 'TileMatrix':
              if ((s = e._parseTileMatrix(b))) {
                if (null === o) o = s.idPrepend
                else if (o !== s.idPrepend) {
                  l = null
                  break
                }
                isNaN(c) && (c = s.width),
                  c !== s.width && (r = !1),
                  isNaN(n) && (n = s.zoom),
                  (n = Math.min(n, s.zoom)),
                  isNaN(a) && (a = s.zoom),
                  (a = Math.max(a, s.zoom))
              }
          }
        }
        l &&
          r &&
          d &&
          el.isValidNumber(n) &&
          el.isValidNumber(a) &&
          (i._tileMatrixSets[l] = {
            identifier: l,
            idPrepend: o,
            maxZoom: Math.min(a, 24),
            minZoom: Math.max(n, 0),
            tileSize: c
          })
      }),
      (e._parseTileMatrix = function (t) {
        for (var e, i = {}, l = 0, s = t.childNodes.length; l < s; l++) {
          var n = t.childNodes[l]
          switch (n.tagName) {
            case 'Identifier':
              var a = n.value.match(this._tileMatrixIdRx)
              a && a.length >= 3
                ? ((i.idPrepend = a[1]), (i.zoom = parseInt(a[2])))
                : (1 === n.value.length || (n.value.length > 1 && n.value.startsWith('1'))) &&
                  (i.zoom = parseInt(n.value))
              break
            case 'TileWidth':
              i.width = parseInt(n.value)
              break
            case 'TileHeight':
              i.height = parseInt(n.value)
              break
            case 'MatrixWidth':
              i.matrixWidth = parseInt(n.value)
              break
            case 'MatrixHeight':
              i.matrixHeight = parseInt(n.value)
              break
            case 'ScaleDenominator':
              e = parseFloat(n.value)
          }
        }
        if (
          !Number.isNaN(i.zoom) &&
          i.width === i.height &&
          !Number.isNaN(e) &&
          i.zoom === Kl.getZoomRange(e)[1]
        ) {
          var c = Math.pow(2, i.zoom)
          if (i.matrixHeight === i.matrixWidth && i.matrixWidth === c) return i
        }
        return null
      }),
      (e._tileMatrixIdRx = /^([0-9a-z:]+:)([0-9]+)$/i),
      e
    )
  })(Jl),
  vl = (function (t) {
    function e(e) {
      var i = t.call(this) || this
      return (i._isInitialized = !1), (i._options = {}), i.setOptions(e), i
    }
    return (
      s(e, t),
      (e.prototype.getCapabilities = function () {
        return a(this, void 0, void 0, function () {
          return c(this, function (t) {
            switch (t.label) {
              case 0:
                return this._client ? [4, this._client.getCapabilities()] : [3, 2]
              case 1:
                return [2, t.sent()]
              case 2:
                return (
                  this._options.debug && console.log("Service hasn't loaded any capabilities."),
                  [2, null]
                )
            }
          })
        })
      }),
      (e.prototype.getOptions = function () {
        return Object.assign({}, this._options, t.prototype.getOptions.call(this))
      }),
      (e.prototype.getFeatureInfo = function (e) {
        return a(this, void 0, void 0, function () {
          return c(this, function (i) {
            switch (i.label) {
              case 0:
                return this._client && this._client instanceof Nl
                  ? [
                      4,
                      this._client.getFeatureInfo({
                        position: e,
                        sublayers: this._options.activeLayers,
                        tileLayerOptions: t.prototype.getOptions.call(this),
                        zoom: this.map ? this.map.getCamera().zoom : null
                      })
                    ]
                  : [3, 2]
              case 1:
                return [2, i.sent()]
              case 2:
                return (
                  this._options.debug && console.log('Service does not support getting features.'),
                  [2, null]
                )
            }
          })
        })
      }),
      (e.prototype.getFeatureInfoHtml = function (e) {
        return a(this, void 0, void 0, function () {
          return c(this, function (i) {
            switch (i.label) {
              case 0:
                return this._client && this._client instanceof Nl
                  ? [
                      4,
                      this._client.getFeatureInfoHtml({
                        position: e,
                        sublayers: this._options.activeLayers,
                        tileLayerOptions: t.prototype.getOptions.call(this),
                        zoom: this.getMap() ? this.getMap().getCamera().zoom : null
                      })
                    ]
                  : [3, 2]
              case 1:
                return [2, i.sent()]
              case 2:
                return (
                  this._options.debug && console.log('Service does not support getting features.'),
                  [2, null]
                )
            }
          })
        })
      }),
      (e.prototype.setOptions = function (e) {
        t.prototype.setOptions.call(this, e)
        var i = new gl().merge(this._options, ci(e)),
          l = !this._isInitialized,
          s = !1
        if (
          (i.debug !== this._options.debug && (s = !0),
          i.proxyService !== this._options.proxyService && ((s = !0), (l = !0)),
          !el.isValidString(i.service) ||
          i.service === this._options.service ||
          ('wmts' !== i.service.toLowerCase() && 'wms' !== i.service.toLowerCase())
            ? (i.service = this._options.service)
            : ((i.service = i.service.toUpperCase()), (s = !0), (l = !0)),
          el.isValidString(i.url) || (i.url = this._options.url),
          i.url !== this._options.url)
        ) {
          ;(s = !0), (l = !0)
          var n = void 0,
            a = el.parseQueryStringParams(i.url, !0, !0)
          if (
            (!e.activeLayers &&
              a.layers &&
              (i.activeLayers = decodeURIComponent(a.layers).split(',')),
            !e.styles && a.styles && (i.styles = decodeURIComponent(a.styles).split(',')),
            !el.isValidString(e.service) ||
              ('wms' !== e.service.toLowerCase() && 'wmts' !== e.service.toLowerCase()))
          ) {
            var c = (el.isValidString(a.service) ? a.service : '').toLowerCase()
            if (
              ('wms' === c ? (n = 'WMS') : 'wmts' === c && (n = 'WMTS'), !this._options.service)
            ) {
              var d = e.url.toLowerCase(),
                r = (el.isValidString(a.request) ? a.request : '').toLowerCase()
              ;(el.isValidString(a.wmtver) || d.includes('wmsserver') || 'capabilities' === r) &&
                (n = 'WMS'),
                n || (!d.includes('wmtscapabilities') && !d.includes('wmts')) || (n = 'WMTS')
            }
            ;(i.service = n),
              i.service !== this._options.service &&
                ((this._client = null), i.debug && console.log('Service detected as ' + n))
          }
        }
        i.version && i.version !== this._options.version
          ? ((s = !0), (l = !0))
          : (i.version = this._options.version),
          this._client &&
            s &&
            this._options.url &&
            (this._client.setOptions(i), (this._isInitialized = !0)),
          (Ki(i.activeLayers, this._options.activeLayers) && Ki(i.styles, this._options.styles)) ||
            (l = !0),
          (this._options = i),
          this.map &&
            this._options.url &&
            (this._updateLayer(l, this._options.bringIntoView), (this._options.bringIntoView = !1))
      }),
      (e.prototype.onAdd = function (e) {
        t.prototype.onAdd.call(this, e),
          this._client && this._client.setMap(e),
          this._options.url &&
            (this._updateLayer(!0, this._options.bringIntoView), (this._options.bringIntoView = !1))
      }),
      (e.prototype._updateLayer = function (e, i) {
        var l = this
        e && this._options.url
          ? (this._client ||
              (this._options.service && 'WMS' === this._options.service
                ? (this._client = new Nl(this._options))
                : ((this._client = new zl(this._options)),
                  !this._options.service &&
                    this._options.debug &&
                    console.log('Unsure of service type, attempting to access it as a WMTS.')),
              this.map && this._client.setMap(this.map)),
            this._client.getTileLayerOptions(this._options.activeLayers, this._options.styles).then(
              function (s) {
                s
                  ? ((l._options.activeLayers = s._subLayers),
                    delete s._subLayers,
                    l.map && i && s.bounds && l.map.setCamera({ bounds: s.bounds }),
                    t.prototype.setOptions.call(l, s),
                    l.onActiveLayersChanged &&
                      l._client.getCapabilities().then(function () {
                        l.onActiveLayersChanged(l)
                      }))
                  : l._options.service && 'WMTS' !== l._options.service
                  ? (l._options.debug && console.log('Service not reachable.'),
                    t.prototype.setOptions.call(l, {
                      tileUrl:
                        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
                    }))
                  : (l._options.debug &&
                      console.log(
                        'Service not reachable, or not WMTS, attempting to connect as WMS.'
                      ),
                    (l._options.service = 'WMS'),
                    (l._client = null),
                    l._updateLayer(e, i))
              },
              function (e) {
                l._options.debug && console.log(e),
                  'WMS' === l._options.service &&
                    t.prototype.setOptions.call(l, {
                      tileUrl:
                        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
                    })
              }
            ))
          : i &&
            this.map &&
            this.map.setCamera({ bounds: t.prototype.getOptions.call(this).bounds })
      }),
      e
    )
  })(i.layer.TileLayer),
  Hl = Object.freeze({ __proto__: null, SimpleDataLayer: tl, OgcMapLayer: vl }),
  wl = (function (t) {
    function e() {
      var e = (null !== t && t.apply(this, arguments)) || this
      return (e.isAxisOrderLonLat = void 0), (e.propertyTypes = void 0), e
    }
    return s(e, t), e
  })(
    (function (t) {
      function e() {
        var e = (null !== t && t.apply(this, arguments)) || this
        return (e.parseStyles = !0), e
      }
      return s(e, t), e
    })(
      (function (t) {
        function e() {
          var e = (null !== t && t.apply(this, arguments)) || this
          return (e.maxFeatures = 1 / 0), (e.proxyService = void 0), e
        }
        return (
          s(e, t),
          (e.prototype.merge = function () {
            for (var e = [], i = 0; i < arguments.length; i++) e[i] = arguments[i]
            var l = t.prototype.merge.apply(this, e)
            return l.maxFeatures < 0 && (l.maxFeatures = 1 / 0), l
          }),
          e
        )
      })(qi)
    )
  ),
  Tl = (function () {
    function t() {}
    return (
      (t.read = function (t, e) {
        if (!t) return null
        e = new wl().merge(e)
        var i = new il().parse(t)
        if (el.docHasData(i)) {
          if ('MultiGeometry' === i.root.tagName || 'FeatureCollection' === i.root.tagName)
            return this._parseFeatureCollection(i.root, e)
          var l = this._parseGeometry(i.root, e)
          if (l)
            return n(n({}, l.bbox && { bbox: l.bbox }), {
              features: [l],
              type: 'FeatureCollection'
            })
        }
        return null
      }),
      (t.readGeometry = function (t, e) {
        return (e = new wl().merge(e)), this._parseGeometry(t, e)
      }),
      (t._parseGeometry = function (t, e) {
        if (t)
          if ('string' == typeof t) {
            var i = new il().parse(t)
            switch (i.root.tagName) {
              case 'Point':
              case 'LineString':
              case 'Polygon':
              case 'MultiPoint':
              case 'MultiLineString':
              case 'MultiCurve':
              case 'MultiSurface':
              case 'MultiPolygon':
              case 'Feature':
                return (e = this._analyzeNode(i.root, e)), this._parseGeometry(i.root, e)
            }
          } else
            switch (((e = this._analyzeNode(t, e)), t.tagName)) {
              case 'Point':
                return this._parsePoint(t, e)
              case 'LineString':
                return this._parseLineString(t, e)
              case 'Polygon':
                return this._parsePolygon(t, e)
              case 'Feature':
                return this._parseFeature(t, e)
              case 'MultiPoint':
              case 'MultiLineString':
              case 'MultiCurve':
              case 'MultiSurface':
              case 'MultiPolygon':
                return this._parseMultiGeometry(t, e)
              case 'where':
              case 'geometry':
                if (t.childNodes.length >= 1) return this._parseGeometry(t.childNodes[0], e)
                break
              default:
                if (el.doesElementContainTagName('geometry', t)) return this._parseFeature(t, e)
                if (
                  t.childNodes &&
                  1 === t.childNodes.length &&
                  el.doesElementContainTagName('geometry', t.childNodes[0])
                )
                  return this._parseFeature(t.childNodes[0], e)
            }
        return null
      }),
      (t._parseFeatureCollection = function (t, e) {
        var i = this
        if (t)
          switch (t.tagName) {
            case 'MultiGeometry':
            case 'FeatureCollection':
              if (t.childNodes) {
                var l = [],
                  s = null
                e = this._analyzeNode(t, e)
                for (
                  var n = function (t) {
                      switch (t.tagName) {
                        case 'boundedBy':
                          s = a._parseEnvelope(t, e)
                          break
                        case 'geometryMember':
                        case 'featureMember':
                        case 'geometryMembers':
                        case 'featureMembers':
                        case 'member':
                          var n = null,
                            c = {},
                            d = null
                          t.childNodes.forEach(function (t) {
                            if ('boundedBy' === t.tagName) d = i._parseEnvelope(t, e)
                            else {
                              var l = i._tryParseFeature(t, c, e)
                              l && (n = l)
                            }
                          }),
                            n &&
                              (d && (n.bbox = d),
                              Object.assign(n.properties, c),
                              c.id ? (n.id = c.id) : c.fid && (n.id = c.fid),
                              l.push(n))
                      }
                      if (l.length >= e.maxFeatures) return 'break'
                    },
                    a = this,
                    c = 0,
                    d = t.childNodes;
                  c < d.length;
                  c++
                ) {
                  if ('break' === n(d[c])) break
                }
                if (l.length > 0) {
                  s || (s = zi.fromData(l)),
                    l.length > e.maxFeatures && (l = l.splice(0, e.maxFeatures))
                  var r = { bbox: s, features: l, type: 'FeatureCollection' },
                    o = {}
                  return (
                    el.addAttributesToObject(t, o),
                    Object.keys(o).length > 0 && (r.properties = o),
                    r
                  )
                }
              }
          }
        return null
      }),
      (t._tryParseFeature = function (t, e, i) {
        var l,
          s = this
        switch (((i = this._analyzeNode(t, i)), t.tagName)) {
          case 'Point':
          case 'LineString':
          case 'Polygon':
          case 'MultiPoint':
          case 'MultiLineString':
          case 'MultiCurve':
          case 'MultiSurface':
          case 'MultiPolygon':
          case 'Feature':
            return this._parseGeometry(t, i)
          case 'geometry':
            return (
              t.childNodes.forEach(function (t) {
                var n = s._tryParseFeature(t, e, i)
                n && (l = n)
              }),
              l
            )
          case 'boundedBy':
            break
          default:
            if (
              (t.attributes &&
                Object.keys(t.attributes).forEach(function (i) {
                  'gml:id' === i
                    ? (e.id = t.attributes[i])
                    : i.startsWith('xmlns') ||
                      i.includes(':') ||
                      i.startsWith('_') ||
                      (e[i] = t.attributes[i])
                }),
              t.childNodes && 0 !== t.childNodes.length)
            )
              return (
                t.childNodes.forEach(function (t) {
                  var n = s._tryParseFeature(t, e, i)
                  n && (l = n)
                }),
                l
              )
            this._parseMetadata(t, e, i)
        }
        return null
      }),
      (t._parseFeature = function (t, e) {
        var i,
          l = {},
          s = null
        e = this._analyzeNode(t, e)
        for (var n = 0, a = t.childNodes; n < a.length; n++) {
          var c = a[n]
          switch (c.tagName) {
            case 'boundedBy':
              s = this._parseEnvelope(c, e)
              break
            case 'geometry':
              i = this._parseGeometry(c, e)
              break
            default:
              this._parseMetadata(c, l, e)
          }
        }
        return i
          ? (t.attributes && t.attributes.id && (i.id = t.attributes.id),
            (i.bbox = s),
            (i.properties = Object.assign(i.properties, l)),
            i)
          : null
      }),
      (t._parseMetadata = function (t, e, i) {
        ;(!i.parseStyles && el.ignoreProperty(t.tagName, t.value)) ||
          (e[t.tagName] =
            i.propertyTypes && i.propertyTypes[t.tagName]
              ? el.tryCastObject(t.value, i.propertyTypes[t.tagName])
              : t.value)
      }),
      (t._parseEnvelope = function (t, e) {
        var i,
          l = this,
          s = el.getElementByTagName('Envelope', t)
        if (s) {
          var n, a
          if (
            ((e = this._analyzeNode(s, e)),
            s.childNodes.forEach(function (t) {
              switch (t.tagName) {
                case 'lowerCorner':
                  ;(i = l._parseCoordinates(t, e)) && i.length > 0 && (n = i[0])
                  break
                case 'upperCorner':
                  ;(i = l._parseCoordinates(t, e)) && i.length > 0 && (a = i[0])
              }
            }),
            n && a)
          )
            return n.length >= 3 && a.length >= 3
              ? [n[0], n[1], n[2], a[0], a[1], a[2]]
              : [n[0], n[1], a[0], a[1]]
        } else {
          var c = el.getElementByTagName('Box', t)
          if (c && c.childNodes) {
            e = this._analyzeNode(c, e)
            var d = el.getElementByTagName('coordinates', c)
            if (d && d.value && (i = this._parseCoordinates(d, e)) && i.length >= 2)
              return [i[0][0], i[0][1], i[1][0], i[1][1]]
          }
        }
        return null
      }),
      (t._parsePoint = function (t, e) {
        if (t.childNodes) {
          for (var i = void 0, l = {}, s = 0, n = t.childNodes; s < n.length; s++) {
            var a = n[s]
            switch (a.tagName) {
              case 'pos':
              case 'coordinates':
                var c = this._parseCoordinates(a, e)
                c && c.length > 0 && (i = c[0])
                break
              default:
                this._parseMetadata(a, l, e)
            }
          }
          if (i)
            return { geometry: { coordinates: i, type: 'Point' }, properties: l, type: 'Feature' }
        }
        return null
      }),
      (t._parseLineString = function (t, e) {
        if (t.childNodes) {
          for (var i = void 0, l = {}, s = 0, n = t.childNodes; s < n.length; s++) {
            var a = n[s]
            switch (a.tagName) {
              case 'pos':
              case 'posList':
              case 'coordinates':
                i = this._parseCoordinates(a, e)
                break
              default:
                this._parseMetadata(a, l, e)
            }
          }
          if (i && i.length >= 2)
            return {
              geometry: { coordinates: i, type: 'LineString' },
              properties: l,
              type: 'Feature'
            }
        }
        return null
      }),
      (t._parsePolygon = function (t, e) {
        var i = this
        if (t.childNodes) {
          for (var l, s = [], n = {}, a = 0, c = t.childNodes; a < c.length; a++) {
            var d = c[a]
            switch (d.tagName) {
              case 'outerBoundaryIs':
              case 'innerBoundaryIs':
              case 'exterior':
              case 'interior':
                d.childNodes &&
                  d.childNodes.forEach(function (t) {
                    'LinearRing' === t.tagName &&
                      t.childNodes &&
                      t.childNodes.length > 0 &&
                      (l = i._parseCoordinates(t.childNodes[0], e)).length >= 3 &&
                      (el.closeRing(l), s.push(l))
                  })
                break
              default:
                this._parseMetadata(d, n, e)
            }
          }
          if (s.length >= 1)
            return { geometry: { coordinates: s, type: 'Polygon' }, properties: n, type: 'Feature' }
        }
        return null
      }),
      (t._parseMultiGeometry = function (t, e) {
        for (var i, l, s = [], n = {}, a = 0, c = t.childNodes; a < c.length; a++) {
          var d = c[a]
          switch (d.tagName) {
            case 'pointMember':
            case 'pointMembers':
            case 'lineStringMember':
            case 'lineStringMembers':
            case 'polygonMember':
            case 'polygonMembers':
            case 'curveMember':
            case 'curveMembers':
            case 'surfaceMember':
            case 'surfaceMembers':
              for (var r = 0, o = d.childNodes; r < o.length; r++) {
                var m = o[r]
                ;(i = this._parseGeometry(m, e)) && s.push(i.geometry)
              }
              break
            default:
              this._parseMetadata(d, n, e)
          }
        }
        var u = []
        switch (t.tagName) {
          case 'MultiPoint':
            for (var b = 0, h = s; b < h.length; b++) {
              'Point' === (G = h[b]).type
                ? u.push(G.coordinates)
                : 'MultiPoint' === G.type && (u = u.concat(G.coordinates))
            }
            u.length > 0 && (l = { coordinates: u, type: 'MultiPoint' })
            break
          case 'MultiLineString':
          case 'MultiCurve':
            for (var Z = 0, p = s; Z < p.length; Z++) {
              'LineString' === (G = p[Z]).type
                ? u.push(G.coordinates)
                : 'MultiLineString' === G.type && (u = u.concat(G.coordinates))
            }
            u.length > 0 && (l = { coordinates: u, type: 'MultiLineString' })
            break
          case 'MultiSurface':
          case 'MultiPolygon':
            for (var y = 0, X = s; y < X.length; y++) {
              var G
              'Polygon' === (G = X[y]).type
                ? u.push(G.coordinates)
                : 'MultiPolygon' === G.type && (u = u.concat(G.coordinates))
            }
            u.length > 0 && (l = { coordinates: u, type: 'MultiPolygon' })
        }
        return l ? { geometry: l, properties: n, type: 'Feature' } : null
      }),
      (t._analyzeNode = function (t, e) {
        if (((e = e || {}), t && t.attributes)) {
          var i = t.attributes.dimension || t.attributes.srsDimension
          i && (e.dimension = i)
          var l = t.attributes.srsName
          if (
            ('boolean' != typeof e.isMercator &&
              Kl.isSridSupported(l, 'mercator') &&
              (e.isMercator = !0),
            'boolean' != typeof e.isAxisOrderLonLat)
          )
            if (Kl.isSridAxisLonLat(l)) e.isAxisOrderLonLat = !0
            else if (t.attributes.schemaLocation) {
              var s = t.attributes.schemaLocation.toLowerCase()
              ;((s.includes('service=wfs') && s.includes('version=1.0.0')) ||
                s.includes('/wfs/1.0.0/') ||
                Kl.isEndpointReversed(s)) &&
                (e.isAxisOrderLonLat = !0)
            }
        }
        return e
      }),
      (t._parseCoordinates = function (t, e) {
        e = e || {}
        var i = []
        if (t && this._coordinateTags.has(t.tagName)) {
          var l = void 0,
            s = void 0,
            n = void 0,
            a = t.value,
            c = !1,
            d = this._coordinate2Rx
          if (
            ('3' === e.dimension && (d = this._coordinate3Rx),
            t.attributes &&
              ((('3' !== e.dimension && '3' === t.attributes.dimension) ||
                '3' === t.attributes.srsDimension) &&
                (d = this._coordinate3Rx),
              'coordinates' === t.tagName))
          ) {
            var r = '.',
              o = ',',
              m = ' '
            t.attributes.decimal &&
              '.' !== (r = t.attributes.decimal) &&
              (a = a.replace(new RegExp(r, 'g'), 'X')),
              t.attributes.cs &&
                ',' !== (o = t.attributes.cs) &&
                (a = a.replace(new RegExp(o, 'g'), ',')),
              t.attributes.ts &&
                ' ' !== (m = t.attributes.ts) &&
                (a = a.replace(new RegExp(m, 'g'), ' ')),
              '.' !== r && (a = a.replace(/X/g, '.'))
          }
          for (l = d.exec(a); l; ) {
            if (
              l.length >= 3 &&
              ((s = parseFloat(l[1])),
              (n = parseFloat(l[2])),
              el.isValidNumber(s) && el.isValidNumber(n))
            ) {
              var u = null
              if (
                (l.length >= 4 && ((u = parseFloat(l[3])), el.isValidNumber(u) || (u = null)),
                e.isMercator)
              ) {
                var b = [s, n]
                e.isAxisOrderLonLat && (b = [n, s]), null !== u && b.push(u), i.push(Kl.toWgs84(b))
              } else {
                if (
                  'boolean' != typeof e.isAxisOrderLonLat &&
                  ((e.isAxisOrderLonLat = (s >= 90 || s <= -90) && n <= 90 && n >= -90),
                  e.isAxisOrderLonLat && i.length > 0)
                ) {
                  c = !0
                  break
                }
                e.isAxisOrderLonLat
                  ? i.push(el.createPosition(s, n, u, !0))
                  : i.push(el.createPosition(n, s, u, !0))
              }
            }
            l = d.exec(a)
          }
          if (c) return this._parseCoordinates(t, e)
        }
        return i
      }),
      (t._coordinate2Rx = /(-?[0-9]+[.0-9E]*)[,\s]+(-?[0-9]+[.0-9E]*)[\s\r\n\t]*/g),
      (t._coordinate3Rx =
        /(-?[0-9]+[.0-9E]*)[,\s]+(-?[0-9]+[.0-9E]*)[,\s]+(-?[0-9]+[.0-9E]*)[\s\r\n\t]*/g),
      (t._coordinateTags = new Set([
        'pos',
        'coordinates',
        'posList',
        'lowerCorner',
        'upperCorner'
      ])),
      t
    )
  })(),
  Fl = Object.freeze({
    __proto__: null,
    CsvReader: cl,
    CsvWriter: dl,
    GmlReader: Tl,
    GmlWriter: pl,
    SimpleXmlReader: il,
    SimpleXmlWriter: Zl
  }),
  Ml = (function () {
    function t(t) {
      if (
        ((this._options = { url: void 0 }),
        (this._featureDetails = {}),
        (this._allPropertyTypes = {}),
        (this._supportedOperations = new Set([
          'GetCapabilities',
          'GetFeature',
          'DescribeFeatureType'
        ])),
        t)
      ) {
        var e = Kl.getBaseUrl(t.url)
        e && (this._options.url = e),
          el.isValidString(t.proxyService) && (this._options.proxyService = t.proxyService),
          (this._options.transformRequest = t.transformRequest)
      }
      if (!this._options.url) throw new Error('Invalid URL specified for WFS Source.')
    }
    return (
      (t.prototype.getCapabilities = function () {
        return a(this, void 0, void 0, function () {
          var t, e, i
          return c(this, function (l) {
            switch (l.label) {
              case 0:
                return this._capabilities
                  ? [2, this._capabilities]
                  : ((t = { request: 'GetCapabilities', service: 'WFS' }),
                    [
                      4,
                      el.ajaxGetAsync(
                        Kl.createUrlRequest(this._options.url, t, !0),
                        this._options.proxyService,
                        this._options.transformRequest,
                        !1,
                        'WFS'
                      )
                    ])
              case 1:
                if (((e = l.sent()), this._checkForExceptions(e), (i = this._parseCapabilities(e))))
                  return (this._capabilities = i), [2, i]
                throw new Error('Error parsing capabilities.')
            }
          })
        })
      }),
      (t.prototype.describeFeatureTypes = function (t) {
        return a(this, void 0, void 0, function () {
          var e,
            i,
            l,
            s,
            n,
            a,
            d = this
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return [4, this.getCapabilities()]
              case 1:
                return (
                  (e = c.sent()),
                  t && t.length > 0
                    ? ('string' == typeof t && (t = [t]),
                      (i = []),
                      (l = []),
                      t.forEach(function (t) {
                        var e = t.includes(':') ? t.substr(t.indexOf(':') + 1) : t,
                          s = d._featureDetails[e]
                            ? d._featureDetails[e]
                            : d._featureDetails[e + 'Type']
                        s ? i.push(s) : l.push(t)
                      }),
                      l.length > 0
                        ? ((s = {
                            request: 'DescribeFeatureType',
                            service: 'WFS',
                            version: e.version
                          }),
                          (n = l.join(',')),
                          ['1.0.0', '1.1.0'].includes(e.version)
                            ? (s.typeName = n)
                            : (s.typeNames = n),
                          [
                            4,
                            el.ajaxGetAsync(
                              Kl.createUrlRequest(this._options.url, s, !0),
                              this._options.proxyService,
                              this._options.transformRequest,
                              !1,
                              'WFS'
                            )
                          ])
                        : [3, 3])
                    : [3, 4]
                )
              case 2:
                ;(a = c.sent()),
                  this._checkForExceptions(a),
                  a &&
                    this._parseFeatureTypeDescription(a).forEach(function (t) {
                      ;(d._featureDetails[t.name] = t), i.push(t)
                    }),
                  (c.label = 3)
              case 3:
                if (i.length > 0) return [2, i]
                c.label = 4
              case 4:
                return [2, null]
            }
          })
        })
      }),
      (t.prototype.getFeatures = function (t) {
        return a(this, void 0, void 0, function () {
          var e, i, l, s
          return c(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this._queryFeatures(t)]
              case 1:
                return (
                  (e = n.sent()),
                  ('1.0.0' === this._capabilities.version ||
                    Kl.isEndpointReversed(this._options.url)) &&
                    (i = !0),
                  [4, Ll(e, { isAxisOrderLonLat: i, propertyTypes: this._allPropertyTypes })]
                )
              case 2:
                return (l = n.sent()) && l.features && l.features.length > 0
                  ? ((s = l.bbox) || (s = zi.fromData(l.features)),
                    [2, { bbox: s, features: l.features, type: 'FeatureCollection' }])
                  : [2, null]
            }
          })
        })
      }),
      (t.prototype.getFeatureInfo = function (t) {
        return a(this, void 0, void 0, function () {
          var e, i, l
          return c(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this._queryFeatures(t)]
              case 1:
                return (e = s.sent()) && ((i = new il()), (l = i.parse(e)).root)
                  ? [2, el.simplifyXmlNode(l.root)]
                  : [2, null]
            }
          })
        })
      }),
      (t.prototype.getFeatureCount = function (t) {
        return a(this, void 0, void 0, function () {
          var e, i, l
          return c(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this._queryFeatures(t, !0)]
              case 1:
                return (e = s.sent()) &&
                  (i = new il().parse(e)) &&
                  i.root &&
                  i.root.attributes &&
                  i.root.attributes.numberOfFeatures &&
                  ((l = parseInt(i.root.attributes.numberOfFeatures)), el.isValidNumber(l))
                  ? [2, l]
                  : [2, 0]
            }
          })
        })
      }),
      (t.prototype._queryFeatures = function (t, e) {
        return a(this, void 0, void 0, function () {
          var i, l, s, n, a, d, r, o, m, u
          return c(this, function (c) {
            switch (c.label) {
              case 0:
                return [4, this.getCapabilities()]
              case 1:
                if (((i = c.sent()), !t.typeNames))
                  throw new Error('Feature types must be specified.')
                if (
                  ((l = Array.isArray(t.typeNames) ? t.typeNames : [t.typeNames]),
                  (s = {
                    featureID: t.featureId,
                    propertyName: t.propertyNames,
                    request: 'GetFeature',
                    service: 'WFS',
                    sortBy: t.sortBy,
                    srsName: this._getBestSrsName(l),
                    version: i.version
                  }),
                  t.customDimensions && (s = Object.assign(s, t.customDimensions)),
                  !s.srsName)
                ) {
                  if (null === t.fallbackSrs)
                    throw new Error(
                      'No supported spatial reference identifier found in capabilities.'
                    )
                  t.fallbackSrs
                    ? (s.srsName = t.fallbackSrs)
                    : (s.srsName = 'urn:ogc:def:crs:EPSG::4326')
                }
                return (
                  e && (s.resultType = 'hits'), (n = l.join(',')), [4, this.describeFeatureTypes(l)]
                )
              case 2:
                if (
                  (c.sent(),
                  ['1.0.0', '1.1.0'].includes(i.version)
                    ? ((s.maxFeatures = t.count), (s.typeName = n))
                    : ((s.count = t.count), (s.typeNames = n)),
                  t.startIndex && (s.startIndex = t.startIndex),
                  t.bbox &&
                    t.bbox.length >= 4 &&
                    ((a = t.bbox[0]),
                    (d = t.bbox[1]),
                    (r = void 0),
                    (o = void 0),
                    4 === t.bbox.length
                      ? ((r = t.bbox[2]), (o = t.bbox[3]))
                      : 6 === t.bbox.length && ((r = t.bbox[3]), (o = t.bbox[4])),
                    (s.bbox =
                      d.toString() +
                      ',' +
                      a.toString() +
                      ',' +
                      o.toString() +
                      ',' +
                      r.toString() +
                      ',' +
                      s.srsName),
                    t.filter))
                )
                  throw new Error('bbox and filter request options cannot be used together.')
                t.filter
                  ? (s.filter = t.filter.toXml(i.version))
                  : t.cql_filter && (s.cql_filter = t.cql_filter),
                  (m = Kl.createUrlRequest(this._options.url, s, !0)),
                  (c.label = 3)
              case 3:
                return (
                  c.trys.push([3, 5, , 6]),
                  [
                    4,
                    el.ajaxGetAsync(
                      m,
                      this._options.proxyService,
                      this._options.transformRequest,
                      !1,
                      'WFS'
                    )
                  ]
                )
              case 4:
                return (u = c.sent()), this._checkForExceptions(u), [2, u]
              case 5:
                throw c.sent()
              case 6:
                return [2]
            }
          })
        })
      }),
      (t.prototype._parseCapabilities = function (t) {
        var e = this,
          i = new il().parse(t)
        if (el.docHasData(i)) {
          for (
            var l = { featureTypes: [], namespaces: {}, operations: [], version: '2.0.0' },
              s = function (t) {
                if (((l.namespaces = i.namespaces), t.childNodes && t.childNodes.length > 0))
                  switch (t.tagName) {
                    case 'Service':
                    case 'ServiceIdentification':
                      t.childNodes.forEach(function (e) {
                        var i = e.value && '' !== e.value ? e.value : null
                        if (i)
                          switch (e.tagName) {
                            case 'Title':
                              l.title = i
                              break
                            case 'Abstract':
                              l.abstract = i
                              break
                            case 'ServiceTypeVersion':
                              l.version = i
                          }
                        'Service' === t.tagName && (l.version = '1.0.0')
                      })
                      break
                    case 'ServiceProvider':
                      var s = el.getElementByTagName('ProviderName', t)
                      s && s.value && '' !== s.value && (l.providerName = s.value)
                      break
                    case 'OperationsMetadata':
                      t.childNodes.forEach(function (t) {
                        if ('Operation' === t.tagName && t.attributes) {
                          var i = t.attributes.name
                          i && e._supportedOperations.has(i) && l.operations.push(i)
                        }
                      })
                      break
                    case 'Capability':
                      var n = el.getElementByTagName('Request', t.childNodes[0])
                      n &&
                        n.childNodes &&
                        n.childNodes.forEach(function (t) {
                          t.tagName &&
                            e._supportedOperations.has(t.tagName) &&
                            l.operations.push(t.tagName)
                        })
                      break
                    case 'FeatureTypeList':
                      t.childNodes.forEach(function (t) {
                        if ('FeatureType' === t.tagName) {
                          var i = e._parseFeatureType(t, l.version)
                          i && l.featureTypes.push(i)
                        }
                      })
                  }
              },
              n = 0,
              a = i.root.childNodes;
            n < a.length;
            n++
          ) {
            s(a[n])
          }
          return l
        }
        return null
      }),
      (t.prototype._parseFeatureType = function (t, e) {
        var l = { otherSrs: [] },
          s = null,
          n = []
        return (
          t.childNodes.forEach(function (t) {
            var e = t.value
            if (e && '' !== e)
              switch (t.tagName) {
                case 'Name':
                  e.includes(':') && (e = e.substr(e.lastIndexOf(':') + 1)), (l.name = e)
                  break
                case 'Title':
                  l.title = e
                  break
                case 'Abstract':
                  l.abstract = e
                  break
                case 'SRS':
                case 'DefaultCRS':
                  Kl.isSridSupported(e, 'wgs84')
                    ? (l.defaultSrs = e)
                    : (s =
                        Kl.isSridSupported(e, 'mercator') || Kl.isSridSupported(e, 'extended')
                          ? e
                          : 'urn:ogc:def:crs:EPSG::4326')
                  break
                case 'OtherCRS':
                  Kl.isSridSupported(e, 'wgs84')
                    ? l.otherSrs.push(e)
                    : (Kl.isSridSupported(e, 'mercator') || Kl.isSridSupported(e, 'extended')) &&
                      n.push(e)
                  break
                case 'LatLongBoundingBox':
                  l.bounds = i.data.BoundingBox.fromEdges(
                    parseFloat(t.attributes.minx),
                    parseFloat(t.attributes.miny),
                    parseFloat(t.attributes.maxx),
                    parseFloat(t.attributes.maxy)
                  )
                  break
                case 'WGS84BoundingBox':
                  var a = Kl.parseWGS84BoundingBox(t)
                  a && (l.bounds = a)
              }
          }),
          0 === l.otherSrs.length && (s ? (l.defaultSrs = s) : n.length > 0 && (l.otherSrs = n)),
          l.defaultSrs || l.otherSrs.length > 0 || ('1.0.0' !== e && '1.1.0' !== e) ? l : null
        )
      }),
      (t.prototype._parseFeatureTypeDescription = function (t) {
        var e = this,
          i = [],
          l = {},
          s = new il().parse(t)
        if (el.docHasData(s))
          for (
            var n = function (t) {
                if (t.childNodes && t.childNodes.length > 0)
                  switch (t.tagName) {
                    case 'element':
                      if (t.attributes) {
                        var n = t.attributes.name,
                          c = t.attributes.type
                        if (c && c.includes(':')) {
                          var d = c.split(':')
                          d.length > 1 && (l[d[1]] = { name: n, nsPrefix: d[0] })
                        } else l[c] = { name: n, nsPrefix: void 0 }
                      }
                      break
                    case 'complexType':
                      var r = t.attributes ? t.attributes.name : null
                      if (r) {
                        var o = r,
                          m = el.getElementByTagName('complexContent', t)
                        if (m) {
                          var u = el.getElementByTagName('extension', m)
                          if (u) {
                            var b = el.getElementByTagName('sequence', u)
                            if (b && b.childNodes) {
                              var h,
                                Z,
                                p = {}
                              b.childNodes.forEach(function (t) {
                                ;(Z = t.attributes),
                                  'element' === t.tagName &&
                                    Z &&
                                    Z.type &&
                                    Z.name &&
                                    (Z.type.startsWith('gml:') && (h = Z.name),
                                    (p[Z.name] = el.sanitizeTypeName(Z.type)),
                                    (e._allPropertyTypes[Z.name] = p[Z.name]))
                              })
                              var y = void 0,
                                X = void 0,
                                G = l[r]
                              G && ((o = G.name), (X = G.nsPrefix) && (y = s.namespaces[X])),
                                i.push({
                                  capability: a._capabilities.featureTypes.find(function (t) {
                                    return t.name === r
                                  }),
                                  geomPropertyName: h,
                                  name: o,
                                  namespace: y,
                                  namespacePrefix: X,
                                  propertyTypes: p
                                })
                            }
                          }
                        }
                      }
                  }
              },
              a = this,
              c = 0,
              d = s.root.childNodes;
            c < d.length;
            c++
          ) {
            n(d[c])
          }
        return i
      }),
      (t.prototype._checkForExceptions = function (t) {
        if (t) {
          if (t.includes('ExceptionReport ')) {
            var e = new il().parse(t),
              i = void 0
            switch (e.root) {
              case 'ServiceExceptionReport':
                i = el.getElementByTagName('ServiceException', e.root)
                break
              case 'ExceptionReport':
                i = el.getElementByTagName('ExceptionText', e.root)
            }
            if (i && i.value && '' !== i.value) throw i.value
            throw new Error('WFS server error. Incomplete WFS request.')
          }
          if (t.includes('<div ')) throw new Error('WFS server error. Incomplete WFS request.')
        }
      }),
      (t.prototype._getBestSrsName = function (t) {
        var e,
          i = !0,
          l = !0,
          s = !0
        return (
          this._capabilities.featureTypes.forEach(function (n) {
            if (t.includes(n.name)) {
              var a = !1
              i &&
                (n.defaultSrs &&
                  Kl.isSridSupported(n.defaultSrs, 'wgs84') &&
                  ((a = !0), (e = n.defaultSrs)),
                a ||
                  (n.otherSrs
                    ? n.otherSrs.forEach(function (t) {
                        Kl.isSridSupported(t, 'wgs84') && ((a = !0), (e = n.defaultSrs))
                      })
                    : ((a = !0), (e = 'urn:ogc:def:crs:EPSG::4326'))),
                a || (i = a)),
                l &&
                  (n.defaultSrs &&
                    Kl.isSridSupported(n.defaultSrs, 'mercator') &&
                    ((a = !0), (e = n.defaultSrs)),
                  a ||
                    (n.otherSrs &&
                      n.otherSrs.forEach(function (t) {
                        Kl.isSridSupported(t, 'mercator') && ((a = !0), (e = n.defaultSrs))
                      })),
                  a || (l = a)),
                s &&
                  (n.defaultSrs &&
                    Kl.isSridSupported(n.defaultSrs, 'extended') &&
                    ((a = !0), (e = n.defaultSrs)),
                  a ||
                    (n.otherSrs &&
                      n.otherSrs.forEach(function (t) {
                        Kl.isSridSupported(t, 'extended') && ((a = !0), (e = n.defaultSrs))
                      })),
                  a || (s = a))
            }
          }),
          e
        )
      }),
      t
    )
  })(),
  kl = (function () {
    function t(t) {
      this._name = t
    }
    return (
      (t.prototype.toXml = function (t) {
        return '<PropertyName>' + this._name + '</PropertyName>'
      }),
      t
    )
  })(),
  Ul = (function () {
    function t() {}
    return (
      (t.prototype.toXml = function (t) {
        return (
          '<Filter xmlns="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml">' +
          this._buildContent(t) +
          '</Filter>'
        )
      }),
      (t._serializeValue = function (e, i, l) {
        if (e instanceof kl) return e.toXml()
        if (e instanceof t) return e._buildContent(i)
        if (e instanceof Date) return '<Literal>' + e.toISOString() + '</Literal>'
        if (!Array.isArray(e))
          return 'object' == typeof e
            ? pl.write(e, { includeNamespace: !1, prettyPrint: !1, srsName: l })
            : '<Literal>' + e.toString() + '</Literal>'
        if (e.length >= 4) {
          var s = e[0],
            n = e[1],
            a = void 0,
            c = void 0
          return (
            4 === e.length ? ((a = e[2]), (c = e[3])) : 6 === e.length && ((a = e[3]), (c = e[4])),
            '<gml:Box' +
              (l ? ' srsName="' + l + '"' : '') +
              '><gml:coordinates>' +
              s.toString() +
              ',' +
              n.toString() +
              ' ' +
              a.toString() +
              ',' +
              c.toString() +
              '</gml:coordinates></gml:Box>'
          )
        }
      }),
      t
    )
  })(),
  Pl = (function (t) {
    function e(e) {
      var i = t.call(this) || this
      return (i._xmlFilter = e.replace(/\n\r/gi, '')), i
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function () {
        return this._xmlFilter
      }),
      (e.prototype.toXml = function (e) {
        return this._xmlFilter && this._xmlFilter.includes('')
          ? this._xmlFilter
          : t.prototype.toXml.call(this, e)
      }),
      e
    )
  })(Ul),
  Cl = (function (t) {
    function e(e, i, l, s) {
      var n = t.call(this) || this
      return (
        (n._options = { srsName: 'urn:ogc:def:crs:EPSG::4326' }),
        (n._isSpatial = !1),
        'Any' === (s = s || {}).matchAction && (s.matchAction = void 0),
        s.matchCase && (s.matchCase = void 0),
        Object.assign(n._options, s || {}),
        (n._comparisonType = e),
        (n._value1 = i),
        (n._value2 = l),
        n
      )
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function (t) {
        var e = this
        if (null !== this._value1 && void 0 !== this._value2) {
          var i = ['<' + this._comparisonType]
          return (
            this._options &&
              Object.keys(this._options).forEach(function (t) {
                i.push(' ', t, '="', e._options[t], '"')
              }),
            i.push('>'),
            null !== this._value1 &&
              i.push(Ul._serializeValue(this._value1, t, this._options.srsName)),
            null !== this._value2 &&
              i.push(Ul._serializeValue(this._value2, t, this._options.srsName)),
            i.push('</' + this._comparisonType + '>'),
            i.join('')
          )
        }
        return ''
      }),
      e
    )
  })(Ul),
  jl = (function (t) {
    function e(e, i, l, s) {
      var n = t.call(this) || this
      return (
        (n._options = { matchAction: 'Any', matchCase: !0 }),
        Object.assign(n._options, s || {}),
        (n._upperBoundary = l),
        (n._value = e),
        (n._lowerBoundary = i),
        n
      )
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function (t) {
        if (this._value && this._lowerBoundary && this._upperBoundary) {
          var e = ['<PropertyIsBetween']
          return (
            this._options &&
              (this._options.matchCase || e.push(' matchCase="false"'),
              'Any' !== this._options.matchAction &&
                e.push(' matchAction="', this._options.matchAction, '"')),
            e.push(
              '>',
              Ul._serializeValue(this._value, t),
              '<LowerBoundary><Literal>' +
                this._lowerBoundary.toString() +
                '</Literal></LowerBoundary>',
              '<UpperBoundary><Literal>' +
                this._upperBoundary.toString() +
                '</Literal></UpperBoundary>',
              '</PropertyIsBetween>'
            ),
            e.join('')
          )
        }
        return ''
      }),
      e
    )
  })(Ul),
  Ol = (function (t) {
    function e(e, i, l) {
      return t.call(this, 'PropertyIsEqualTo', e, i, l) || this
    }
    return s(e, t), e
  })(Cl),
  Bl = (function (t) {
    function e(e, i, l) {
      return t.call(this, 'PropertyIsGreaterThan', e, i, l) || this
    }
    return s(e, t), e
  })(Cl),
  El = (function (t) {
    function e(e, i, l) {
      return t.call(this, 'PropertyIsGreaterThanOrEqualTo', e, i, l) || this
    }
    return s(e, t), e
  })(Cl),
  Dl = (function (t) {
    function e(e, i, l) {
      return t.call(this, 'PropertyIsLessThan', e, i, l) || this
    }
    return s(e, t), e
  })(Cl),
  Ql = (function (t) {
    function e(e, i, l) {
      return t.call(this, 'PropertyIsLessThanOrEqualTo', e, i, l) || this
    }
    return s(e, t), e
  })(Cl),
  _l = (function (t) {
    function e(e, i, l) {
      var s =
        t.call(this, 'PropertyIsLike', e, i, {
          escapeChar: '\\',
          singleChar: '.',
          wildCard: '*'
        }) || this
      return Object.assign(s._options, l || {}), s
    }
    return s(e, t), e
  })(Cl),
  Al = (function (t) {
    function e(e, i) {
      return t.call(this, 'PropertyIsNil', e, null, i) || this
    }
    return s(e, t), e
  })(Cl),
  ql = (function (t) {
    function e(e, i, l) {
      return t.call(this, 'PropertyIsNotEqualTo', e, i, l) || this
    }
    return s(e, t), e
  })(Cl),
  $l = (function (t) {
    function e(e, i) {
      return t.call(this, 'PropertyIsNull', e, null, i) || this
    }
    return s(e, t), e
  })(Cl),
  ts = (function (t) {
    function e(e, i) {
      var l = t.call(this) || this
      return (l._operator = e), (l._filters = i), l
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function (t) {
        if (this._filters && this._filters.length >= 2) {
          var e = ['<', this._operator, '>']
          return (
            this._filters.forEach(function (i) {
              e.push(i._buildContent(t))
            }),
            e.push('</', this._operator, '>'),
            e.join('')
          )
        }
      }),
      e
    )
  })(Ul),
  es = (function (t) {
    function e() {
      for (var e = [], i = 0; i < arguments.length; i++) e[i] = arguments[i]
      return t.call(this, 'And', e) || this
    }
    return s(e, t), e
  })(ts),
  is = (function (t) {
    function e(e) {
      var i = t.call(this) || this
      return (i._filter = e), i
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function (t) {
        return this._filter ? '<Not>' + this._filter._buildContent(t) + '</Not>' : ''
      }),
      e
    )
  })(Ul),
  ls = (function (t) {
    function e() {
      for (var e = [], i = 0; i < arguments.length; i++) e[i] = arguments[i]
      return t.call(this, 'Or', e) || this
    }
    return s(e, t), e
  })(ts),
  ss = (function (t) {
    function e(e, i, l) {
      var s = t.call(this) || this
      return (s._operator = e), (s._value1 = i), (s._value2 = l), s
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function (t) {
        return [
          '<' + this._operator + '>',
          Ul._serializeValue(this._value1, t),
          Ul._serializeValue(this._value2, t),
          '</' + this._operator + '>'
        ].join('')
      }),
      e
    )
  })(Ul),
  ns = (function (t) {
    function e(e, i) {
      return t.call(this, 'Add', e, i) || this
    }
    return s(e, t), e
  })(ss),
  as = (function (t) {
    function e(e, i) {
      return t.call(this, 'Div', e, i) || this
    }
    return s(e, t), e
  })(ss),
  cs = (function (t) {
    function e(e, i) {
      return t.call(this, 'Mul', e, i) || this
    }
    return s(e, t), e
  })(ss),
  ds = (function (t) {
    function e(e, i) {
      return t.call(this, 'Sub', e, i) || this
    }
    return s(e, t), e
  })(ss),
  rs = (function (t) {
    function e(e) {
      var i = t.call(this) || this
      return (i._id = e), i
    }
    return (
      s(e, t),
      (e.prototype._buildContent = function (t) {
        return t && '1.1.0' === t
          ? '<GmlObjectId xmlns:gml="http://www.opengis.net/gml" gml:id="' + this._id + '"/>'
          : '<fes:ResourceId rid="' + this._id + '"/>'
      }),
      e
    )
  })(Ul),
  os = Object.freeze({
    __proto__: null,
    CustomFilter: Pl,
    Filter: Ul,
    PropertyName: kl,
    BinaryComparisonOpType: Cl,
    IsBetween: jl,
    IsEqual: Ol,
    IsGreaterThan: Bl,
    IsGreaterThanOrEqual: El,
    IsLessThan: Dl,
    IsLessThanOrEqual: Ql,
    IsLike: _l,
    IsNil: Al,
    IsNotEqual: ql,
    IsNull: $l,
    And: es,
    LogicOperatorFilter: ts,
    Not: is,
    Or: ls,
    Add: ns,
    Div: as,
    MathOperator: ss,
    Mul: cs,
    Sub: ds,
    Id: rs
  }),
  ms = d.merge('atlas.io.ogc.filter', os),
  us = Object.freeze({ __proto__: null, filter: ms, WKT: rl, WfsClient: Ml }),
  bs = d.merge('atlas.io.core', Fl),
  hs = d.merge('atlas.io.ogc', us),
  Zs = Object.freeze({
    __proto__: null,
    core: bs,
    ogc: hs,
    read: Ll,
    write: function (t, e) {
      return a(this, void 0, void 0, function () {
        var i
        return c(this, function (l) {
          switch (l.label) {
            case 0:
              return (e = e || {}), [4, Sl(t, !1)]
            case 1:
              switch (((i = l.sent()), e.format ? e.format.toLowerCase() : 'geojson')) {
                case 'geojson':
                  return [
                    2,
                    JSON.stringify(
                      { bbox: i.bbox, features: i.features, type: 'FeatureCollection' },
                      Rl,
                      e.prettyPrint ? e.indentChars || '\t' : null
                    )
                  ]
                case 'csv':
                  return [2, ul.write(i.features, e)]
                default:
                  return [2, Yl.write(i, e)]
              }
          }
        })
      })
    },
    writeCompressed: function (t, e, i) {
      return a(this, void 0, void 0, function () {
        var l, s, n, a, d, r
        return c(this, function (c) {
          switch (c.label) {
            case 0:
              return (i = i || {}), [4, Sl(t, !1)]
            case 1:
              switch (((l = c.sent()), i.format ? i.format.toLowerCase() : 'geojson')) {
                case 'geojson':
                  return [3, 2]
                case 'csv':
                  return [3, 3]
              }
              return [3, 4]
            case 2:
              return (
                (s = JSON.stringify(
                  { bbox: l.bbox, features: l.features, type: 'FeatureCollection' },
                  Rl,
                  i.prettyPrint ? i.indentChars || '\t' : null
                )),
                (n = 'doc.json'),
                [3, 6]
              )
            case 3:
              if (((s = ul.write(l.features, i)), (n = 'doc.'), i.delimiter))
                switch (i.delimiter) {
                  case ',':
                    n += 'csv'
                    break
                  case '\t':
                    n += 'tsv'
                    break
                  default:
                    n += 'txt'
                }
              else n += 'csv'
              return [3, 6]
            case 4:
              return [4, Yl.writeCompressed(l, e, i)]
            case 5:
              return [2, c.sent()]
            case 6:
              if (!s) return [3, 8]
              switch (((a = new ll()).file(n, s), (d = 'blob'), e)) {
                case 'Base64':
                  d = 'base64'
                  break
                case 'ArrayBuffer':
                  d = 'uint8array'
              }
              return [4, a.generateAsync({ type: d })]
            case 7:
              return (
                (r = c.sent()), 'base64' === d && (r = 'data:application/zip;base64,' + r), [2, r]
              )
            case 8:
              return [2, null]
          }
        })
      })
    }
  }),
  ps = d.merge('atlas.layer', Hl),
  ys = d.merge('atlas.io', Zs)
;(exports.SpatialDataSet = Ai), (exports.io = ys), (exports.layer = ps)
